(function () {
    'use strict';

    /*!
     * lightgallery | 2.8.3 | March 1st 2025
     * http://www.lightgalleryjs.com/
     * Copyright (c) 2020 Sachin Neravath;
     * @license GPLv3
     */

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign$4 = function () {
      __assign$4 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
      return __assign$4.apply(this, arguments);
    };
    function __spreadArrays() {
      for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
      for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
      return r;
    }

    /**
     * List of lightGallery events
     * All events should be documented here
     * Below interfaces are used to build the website documentations
     * */
    var lGEvents$2 = {
      afterAppendSlide: 'lgAfterAppendSlide',
      init: 'lgInit',
      hasVideo: 'lgHasVideo',
      containerResize: 'lgContainerResize',
      updateSlides: 'lgUpdateSlides',
      afterAppendSubHtml: 'lgAfterAppendSubHtml',
      beforeOpen: 'lgBeforeOpen',
      afterOpen: 'lgAfterOpen',
      slideItemLoad: 'lgSlideItemLoad',
      beforeSlide: 'lgBeforeSlide',
      afterSlide: 'lgAfterSlide',
      posterClick: 'lgPosterClick',
      dragStart: 'lgDragStart',
      dragMove: 'lgDragMove',
      dragEnd: 'lgDragEnd',
      beforeNextSlide: 'lgBeforeNextSlide',
      beforePrevSlide: 'lgBeforePrevSlide',
      beforeClose: 'lgBeforeClose',
      afterClose: 'lgAfterClose',
      rotateLeft: 'lgRotateLeft',
      rotateRight: 'lgRotateRight',
      flipHorizontal: 'lgFlipHorizontal',
      flipVertical: 'lgFlipVertical',
      autoplay: 'lgAutoplay',
      autoplayStart: 'lgAutoplayStart',
      autoplayStop: 'lgAutoplayStop'
    };
    var lightGalleryCoreSettings = {
      mode: 'lg-slide',
      easing: 'ease',
      speed: 400,
      licenseKey: '0000-0000-000-0000',
      height: '100%',
      width: '100%',
      addClass: '',
      startClass: 'lg-start-zoom',
      backdropDuration: 300,
      container: '',
      startAnimationDuration: 400,
      zoomFromOrigin: true,
      hideBarsDelay: 0,
      showBarsAfter: 10000,
      slideDelay: 0,
      supportLegacyBrowser: true,
      allowMediaOverlap: false,
      videoMaxSize: '1280-720',
      loadYouTubePoster: true,
      defaultCaptionHeight: 0,
      ariaLabelledby: '',
      ariaDescribedby: '',
      resetScrollPosition: true,
      hideScrollbar: false,
      closable: true,
      swipeToClose: true,
      closeOnTap: true,
      showCloseIcon: true,
      showMaximizeIcon: false,
      loop: true,
      escKey: true,
      keyPress: true,
      trapFocus: true,
      controls: true,
      slideEndAnimation: true,
      hideControlOnEnd: false,
      mousewheel: false,
      getCaptionFromTitleOrAlt: true,
      appendSubHtmlTo: '.lg-sub-html',
      subHtmlSelectorRelative: false,
      preload: 2,
      numberOfSlideItemsInDom: 10,
      selector: '',
      selectWithin: '',
      nextHtml: '',
      prevHtml: '',
      index: 0,
      iframeWidth: '100%',
      iframeHeight: '100%',
      iframeMaxWidth: '100%',
      iframeMaxHeight: '100%',
      download: true,
      counter: true,
      appendCounterTo: '.lg-toolbar',
      swipeThreshold: 50,
      enableSwipe: true,
      enableDrag: true,
      dynamic: false,
      dynamicEl: [],
      extraProps: [],
      exThumbImage: '',
      isMobile: undefined,
      mobileSettings: {
        controls: false,
        showCloseIcon: false,
        download: false
      },
      plugins: [],
      strings: {
        closeGallery: 'Close gallery',
        toggleMaximize: 'Toggle maximize',
        previousSlide: 'Previous slide',
        nextSlide: 'Next slide',
        download: 'Download',
        playVideo: 'Play video',
        mediaLoadingFailed: 'Oops... Failed to load content...'
      }
    };
    function initLgPolyfills() {
      (function () {
        if (typeof window.CustomEvent === 'function') return false;
        function CustomEvent(event, params) {
          params = params || {
            bubbles: false,
            cancelable: false,
            detail: null
          };
          var evt = document.createEvent('CustomEvent');
          evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
          return evt;
        }
        window.CustomEvent = CustomEvent;
      })();
      (function () {
        if (!Element.prototype.matches) {
          Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        }
      })();
    }
    var lgQuery = /** @class */function () {
      function lgQuery(selector) {
        this.cssVenderPrefixes = ['TransitionDuration', 'TransitionTimingFunction', 'Transform', 'Transition'];
        this.selector = this._getSelector(selector);
        this.firstElement = this._getFirstEl();
        return this;
      }
      lgQuery.generateUUID = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : r & 0x3 | 0x8;
          return v.toString(16);
        });
      };
      lgQuery.prototype._getSelector = function (selector, context) {
        if (context === void 0) {
          context = document;
        }
        if (typeof selector !== 'string') {
          return selector;
        }
        context = context || document;
        var fl = selector.substring(0, 1);
        if (fl === '#') {
          return context.querySelector(selector);
        } else {
          return context.querySelectorAll(selector);
        }
      };
      lgQuery.prototype._each = function (func) {
        if (!this.selector) {
          return this;
        }
        if (this.selector.length !== undefined) {
          [].forEach.call(this.selector, func);
        } else {
          func(this.selector, 0);
        }
        return this;
      };
      lgQuery.prototype._setCssVendorPrefix = function (el, cssProperty, value) {
        // prettier-ignore
        var property = cssProperty.replace(/-([a-z])/gi, function (s, group1) {
          return group1.toUpperCase();
        });
        if (this.cssVenderPrefixes.indexOf(property) !== -1) {
          el.style[property.charAt(0).toLowerCase() + property.slice(1)] = value;
          el.style['webkit' + property] = value;
          el.style['moz' + property] = value;
          el.style['ms' + property] = value;
          el.style['o' + property] = value;
        } else {
          el.style[property] = value;
        }
      };
      lgQuery.prototype._getFirstEl = function () {
        if (this.selector && this.selector.length !== undefined) {
          return this.selector[0];
        } else {
          return this.selector;
        }
      };
      lgQuery.prototype.isEventMatched = function (event, eventName) {
        var eventNamespace = eventName.split('.');
        return event.split('.').filter(function (e) {
          return e;
        }).every(function (e) {
          return eventNamespace.indexOf(e) !== -1;
        });
      };
      lgQuery.prototype.attr = function (attr, value) {
        if (value === undefined) {
          if (!this.firstElement) {
            return '';
          }
          return this.firstElement.getAttribute(attr);
        }
        this._each(function (el) {
          el.setAttribute(attr, value);
        });
        return this;
      };
      lgQuery.prototype.find = function (selector) {
        return $LG(this._getSelector(selector, this.selector));
      };
      lgQuery.prototype.first = function () {
        if (this.selector && this.selector.length !== undefined) {
          return $LG(this.selector[0]);
        } else {
          return $LG(this.selector);
        }
      };
      lgQuery.prototype.eq = function (index) {
        return $LG(this.selector[index]);
      };
      lgQuery.prototype.parent = function () {
        return $LG(this.selector.parentElement);
      };
      lgQuery.prototype.get = function () {
        return this._getFirstEl();
      };
      lgQuery.prototype.removeAttr = function (attributes) {
        var attrs = attributes.split(' ');
        this._each(function (el) {
          attrs.forEach(function (attr) {
            return el.removeAttribute(attr);
          });
        });
        return this;
      };
      lgQuery.prototype.wrap = function (className) {
        if (!this.firstElement) {
          return this;
        }
        var wrapper = document.createElement('div');
        wrapper.className = className;
        this.firstElement.parentNode.insertBefore(wrapper, this.firstElement);
        this.firstElement.parentNode.removeChild(this.firstElement);
        wrapper.appendChild(this.firstElement);
        return this;
      };
      lgQuery.prototype.addClass = function (classNames) {
        if (classNames === void 0) {
          classNames = '';
        }
        this._each(function (el) {
          // IE doesn't support multiple arguments
          classNames.split(' ').forEach(function (className) {
            if (className) {
              el.classList.add(className);
            }
          });
        });
        return this;
      };
      lgQuery.prototype.removeClass = function (classNames) {
        this._each(function (el) {
          // IE doesn't support multiple arguments
          classNames.split(' ').forEach(function (className) {
            if (className) {
              el.classList.remove(className);
            }
          });
        });
        return this;
      };
      lgQuery.prototype.hasClass = function (className) {
        if (!this.firstElement) {
          return false;
        }
        return this.firstElement.classList.contains(className);
      };
      lgQuery.prototype.hasAttribute = function (attribute) {
        if (!this.firstElement) {
          return false;
        }
        return this.firstElement.hasAttribute(attribute);
      };
      lgQuery.prototype.toggleClass = function (className) {
        if (!this.firstElement) {
          return this;
        }
        if (this.hasClass(className)) {
          this.removeClass(className);
        } else {
          this.addClass(className);
        }
        return this;
      };
      lgQuery.prototype.css = function (property, value) {
        var _this = this;
        this._each(function (el) {
          _this._setCssVendorPrefix(el, property, value);
        });
        return this;
      };
      // Need to pass separate namespaces for separate elements
      lgQuery.prototype.on = function (events, listener) {
        var _this = this;
        if (!this.selector) {
          return this;
        }
        events.split(' ').forEach(function (event) {
          if (!Array.isArray(lgQuery.eventListeners[event])) {
            lgQuery.eventListeners[event] = [];
          }
          lgQuery.eventListeners[event].push(listener);
          _this.selector.addEventListener(event.split('.')[0], listener);
        });
        return this;
      };
      // @todo - test this
      lgQuery.prototype.once = function (event, listener) {
        var _this = this;
        this.on(event, function () {
          _this.off(event);
          listener(event);
        });
        return this;
      };
      lgQuery.prototype.off = function (event) {
        var _this = this;
        if (!this.selector) {
          return this;
        }
        Object.keys(lgQuery.eventListeners).forEach(function (eventName) {
          if (_this.isEventMatched(event, eventName)) {
            lgQuery.eventListeners[eventName].forEach(function (listener) {
              _this.selector.removeEventListener(eventName.split('.')[0], listener);
            });
            lgQuery.eventListeners[eventName] = [];
          }
        });
        return this;
      };
      lgQuery.prototype.trigger = function (event, detail) {
        if (!this.firstElement) {
          return this;
        }
        var customEvent = new CustomEvent(event.split('.')[0], {
          detail: detail || null
        });
        this.firstElement.dispatchEvent(customEvent);
        return this;
      };
      // Does not support IE
      lgQuery.prototype.load = function (url) {
        var _this = this;
        fetch(url).then(function (res) {
          return res.text();
        }).then(function (html) {
          _this.selector.innerHTML = html;
        });
        return this;
      };
      lgQuery.prototype.html = function (html) {
        if (html === undefined) {
          if (!this.firstElement) {
            return '';
          }
          return this.firstElement.innerHTML;
        }
        this._each(function (el) {
          el.innerHTML = html;
        });
        return this;
      };
      lgQuery.prototype.append = function (html) {
        this._each(function (el) {
          if (typeof html === 'string') {
            el.insertAdjacentHTML('beforeend', html);
          } else {
            el.appendChild(html);
          }
        });
        return this;
      };
      lgQuery.prototype.prepend = function (html) {
        this._each(function (el) {
          if (typeof html === 'string') {
            el.insertAdjacentHTML('afterbegin', html);
          } else if (html instanceof HTMLElement) {
            el.insertBefore(html.cloneNode(true), el.firstChild);
          }
        });
        return this;
      };
      lgQuery.prototype.remove = function () {
        this._each(function (el) {
          el.parentNode.removeChild(el);
        });
        return this;
      };
      lgQuery.prototype.empty = function () {
        this._each(function (el) {
          el.innerHTML = '';
        });
        return this;
      };
      lgQuery.prototype.scrollTop = function (scrollTop) {
        if (scrollTop !== undefined) {
          document.body.scrollTop = scrollTop;
          document.documentElement.scrollTop = scrollTop;
          return this;
        } else {
          return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        }
      };
      lgQuery.prototype.scrollLeft = function (scrollLeft) {
        if (scrollLeft !== undefined) {
          document.body.scrollLeft = scrollLeft;
          document.documentElement.scrollLeft = scrollLeft;
          return this;
        } else {
          return window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
        }
      };
      lgQuery.prototype.offset = function () {
        if (!this.firstElement) {
          return {
            left: 0,
            top: 0
          };
        }
        var rect = this.firstElement.getBoundingClientRect();
        var bodyMarginLeft = $LG('body').style().marginLeft;
        // Minus body margin - https://stackoverflow.com/questions/30711548/is-getboundingclientrect-left-returning-a-wrong-value
        return {
          left: rect.left - parseFloat(bodyMarginLeft) + this.scrollLeft(),
          top: rect.top + this.scrollTop()
        };
      };
      lgQuery.prototype.style = function () {
        if (!this.firstElement) {
          return {};
        }
        return this.firstElement.currentStyle || window.getComputedStyle(this.firstElement);
      };
      // Width without padding and border even if box-sizing is used.
      lgQuery.prototype.width = function () {
        var style = this.style();
        return this.firstElement.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      };
      // Height without padding and border even if box-sizing is used.
      lgQuery.prototype.height = function () {
        var style = this.style();
        return this.firstElement.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
      };
      lgQuery.eventListeners = {};
      return lgQuery;
    }();
    function $LG(selector) {
      initLgPolyfills();
      return new lgQuery(selector);
    }
    var defaultDynamicOptions = ['src', 'sources', 'subHtml', 'subHtmlUrl', 'html', 'video', 'poster', 'slideName', 'responsive', 'srcset', 'sizes', 'iframe', 'downloadUrl', 'download', 'width', 'facebookShareUrl', 'tweetText', 'iframeTitle', 'twitterShareUrl', 'pinterestShareUrl', 'pinterestText', 'fbHtml', 'disqusIdentifier', 'disqusUrl'];
    // Convert html data-attribute to camalcase
    function convertToData(attr) {
      // FInd a way for lgsize
      if (attr === 'href') {
        return 'src';
      }
      attr = attr.replace('data-', '');
      attr = attr.charAt(0).toLowerCase() + attr.slice(1);
      attr = attr.replace(/-([a-z])/g, function (g) {
        return g[1].toUpperCase();
      });
      return attr;
    }
    var utils$1 = {
      /**
       * Fetches HTML content from a given URL and inserts it into a specified element.
       *
       * @param url - The URL to fetch the HTML content from.
       * @param element - The DOM element (jQuery object) to insert the HTML content into.
       * @param insertMethod - The method to insert the HTML ('append' or 'replace').
       */
      fetchCaptionFromUrl: function (url, element, insertMethod) {
        // Fetch content from the URL
        fetch(url).then(function (response) {
          return response.text();
        }).then(function (htmlContent) {
          if (insertMethod === 'append') {
            var contentDiv = "<div class=\"lg-sub-html\">" + htmlContent + "</div>";
            element.append(contentDiv);
          } else {
            element.html(htmlContent);
          }
        });
      },
      /**
       * get possible width and height from the lgSize attribute. Used for ZoomFromOrigin option
       */
      getSize: function (el, container, spacing, defaultLgSize) {
        if (spacing === void 0) {
          spacing = 0;
        }
        var LGel = $LG(el);
        var lgSize = LGel.attr('data-lg-size') || defaultLgSize;
        if (!lgSize) {
          return;
        }
        var isResponsiveSizes = lgSize.split(',');
        // if at-least two viewport sizes are available
        if (isResponsiveSizes[1]) {
          var wWidth = window.innerWidth;
          for (var i = 0; i < isResponsiveSizes.length; i++) {
            var size_1 = isResponsiveSizes[i];
            var responsiveWidth = parseInt(size_1.split('-')[2], 10);
            if (responsiveWidth > wWidth) {
              lgSize = size_1;
              break;
            }
            // take last item as last option
            if (i === isResponsiveSizes.length - 1) {
              lgSize = size_1;
            }
          }
        }
        var size = lgSize.split('-');
        var width = parseInt(size[0], 10);
        var height = parseInt(size[1], 10);
        var cWidth = container.width();
        var cHeight = container.height() - spacing;
        var maxWidth = Math.min(cWidth, width);
        var maxHeight = Math.min(cHeight, height);
        var ratio = Math.min(maxWidth / width, maxHeight / height);
        return {
          width: width * ratio,
          height: height * ratio
        };
      },
      /**
       * @desc Get transform value based on the imageSize. Used for ZoomFromOrigin option
       * @param {jQuery Element}
       * @returns {String} Transform CSS string
       */
      getTransform: function (el, container, top, bottom, imageSize) {
        if (!imageSize) {
          return;
        }
        var LGel = $LG(el).find('img').first();
        if (!LGel.get()) {
          return;
        }
        var containerRect = container.get().getBoundingClientRect();
        var wWidth = containerRect.width;
        // using innerWidth to include mobile safari bottom bar
        var wHeight = container.height() - (top + bottom);
        var elWidth = LGel.width();
        var elHeight = LGel.height();
        var elStyle = LGel.style();
        var x = (wWidth - elWidth) / 2 - LGel.offset().left + (parseFloat(elStyle.paddingLeft) || 0) + (parseFloat(elStyle.borderLeft) || 0) + $LG(window).scrollLeft() + containerRect.left;
        var y = (wHeight - elHeight) / 2 - LGel.offset().top + (parseFloat(elStyle.paddingTop) || 0) + (parseFloat(elStyle.borderTop) || 0) + $LG(window).scrollTop() + top;
        var scX = elWidth / imageSize.width;
        var scY = elHeight / imageSize.height;
        var transform = 'translate3d(' + (x *= -1) + 'px, ' + (y *= -1) + 'px, 0) scale3d(' + scX + ', ' + scY + ', 1)';
        return transform;
      },
      getIframeMarkup: function (iframeWidth, iframeHeight, iframeMaxWidth, iframeMaxHeight, src, iframeTitle) {
        var title = iframeTitle ? 'title="' + iframeTitle + '"' : '';
        return "<div class=\"lg-media-cont lg-has-iframe\" style=\"width:" + iframeWidth + "; max-width:" + iframeMaxWidth + "; height: " + iframeHeight + "; max-height:" + iframeMaxHeight + "\">\n                    <iframe class=\"lg-object\" frameborder=\"0\" " + title + " src=\"" + src + "\"  allowfullscreen=\"true\"></iframe>\n                </div>";
      },
      getImgMarkup: function (index, src, altAttr, srcset, sizes, sources) {
        var srcsetAttr = srcset ? "srcset=\"" + srcset + "\"" : '';
        var sizesAttr = sizes ? "sizes=\"" + sizes + "\"" : '';
        var imgMarkup = "<img " + altAttr + " " + srcsetAttr + "  " + sizesAttr + " class=\"lg-object lg-image\" data-index=\"" + index + "\" src=\"" + src + "\" />";
        var sourceTag = '';
        if (sources) {
          var sourceObj = typeof sources === 'string' ? JSON.parse(sources) : sources;
          sourceTag = sourceObj.map(function (source) {
            var attrs = '';
            Object.keys(source).forEach(function (key) {
              // Do not remove the first space as it is required to separate the attributes
              attrs += " " + key + "=\"" + source[key] + "\"";
            });
            return "<source " + attrs + "></source>";
          });
        }
        return "" + sourceTag + imgMarkup;
      },
      // Get src from responsive src
      getResponsiveSrc: function (srcItms) {
        var rsWidth = [];
        var rsSrc = [];
        var src = '';
        for (var i = 0; i < srcItms.length; i++) {
          var _src = srcItms[i].split(' ');
          // Manage empty space
          if (_src[0] === '') {
            _src.splice(0, 1);
          }
          rsSrc.push(_src[0]);
          rsWidth.push(_src[1]);
        }
        var wWidth = window.innerWidth;
        for (var j = 0; j < rsWidth.length; j++) {
          if (parseInt(rsWidth[j], 10) > wWidth) {
            src = rsSrc[j];
            break;
          }
        }
        return src;
      },
      isImageLoaded: function (img) {
        if (!img) return false;
        // During the onload event, IE correctly identifies any images that
        // weren’t downloaded as not complete. Others should too. Gecko-based
        // browsers act like NS4 in that they report this incorrectly.
        if (!img.complete) {
          return false;
        }
        // However, they do have two very useful properties: naturalWidth and
        // naturalHeight. These give the true size of the image. If it failed
        // to load, either of these should be zero.
        if (img.naturalWidth === 0) {
          return false;
        }
        // No other way of checking: assume it’s ok.
        return true;
      },
      getVideoPosterMarkup: function (_poster, dummyImg, videoContStyle, playVideoString, _isVideo) {
        var videoClass = '';
        if (_isVideo && _isVideo.youtube) {
          videoClass = 'lg-has-youtube';
        } else if (_isVideo && _isVideo.vimeo) {
          videoClass = 'lg-has-vimeo';
        } else {
          videoClass = 'lg-has-html5';
        }
        var _dummy = dummyImg;
        if (typeof dummyImg !== 'string') {
          _dummy = dummyImg.outerHTML;
        }
        return "<div class=\"lg-video-cont " + videoClass + "\" style=\"" + videoContStyle + "\">\n                <div class=\"lg-video-play-button\">\n                <svg\n                    viewBox=\"0 0 20 20\"\n                    preserveAspectRatio=\"xMidYMid\"\n                    focusable=\"false\"\n                    aria-labelledby=\"" + playVideoString + "\"\n                    role=\"img\"\n                    class=\"lg-video-play-icon\"\n                >\n                    <title>" + playVideoString + "</title>\n                    <polygon class=\"lg-video-play-icon-inner\" points=\"1,0 20,10 1,20\"></polygon>\n                </svg>\n                <svg class=\"lg-video-play-icon-bg\" viewBox=\"0 0 50 50\" focusable=\"false\">\n                    <circle cx=\"50%\" cy=\"50%\" r=\"20\"></circle></svg>\n                <svg class=\"lg-video-play-icon-circle\" viewBox=\"0 0 50 50\" focusable=\"false\">\n                    <circle cx=\"50%\" cy=\"50%\" r=\"20\"></circle>\n                </svg>\n            </div>\n            " + _dummy + "\n            <img class=\"lg-object lg-video-poster\" src=\"" + _poster + "\" />\n        </div>";
      },
      getFocusableElements: function (container) {
        var elements = container.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
        var visibleElements = [].filter.call(elements, function (element) {
          var style = window.getComputedStyle(element);
          return style.display !== 'none' && style.visibility !== 'hidden';
        });
        return visibleElements;
      },
      /**
       * @desc Create dynamic elements array from gallery items when dynamic option is false
       * It helps to avoid frequent DOM interaction
       * and avoid multiple checks for dynamic elments
       *
       * @returns {Array} dynamicEl
       */
      getDynamicOptions: function (items, extraProps, getCaptionFromTitleOrAlt, exThumbImage) {
        var dynamicElements = [];
        var availableDynamicOptions = __spreadArrays(defaultDynamicOptions, extraProps);
        [].forEach.call(items, function (item) {
          var dynamicEl = {};
          for (var i = 0; i < item.attributes.length; i++) {
            var attr = item.attributes[i];
            if (attr.specified) {
              var dynamicAttr = convertToData(attr.name);
              var label = '';
              if (availableDynamicOptions.indexOf(dynamicAttr) > -1) {
                label = dynamicAttr;
              }
              if (label) {
                dynamicEl[label] = attr.value;
              }
            }
          }
          var currentItem = $LG(item);
          var alt = currentItem.find('img').first().attr('alt');
          var title = currentItem.attr('title');
          var thumb = exThumbImage ? currentItem.attr(exThumbImage) : currentItem.find('img').first().attr('src');
          dynamicEl.thumb = thumb;
          if (getCaptionFromTitleOrAlt && !dynamicEl.subHtml) {
            dynamicEl.subHtml = title || alt || '';
          }
          dynamicEl.alt = alt || title || '';
          dynamicElements.push(dynamicEl);
        });
        return dynamicElements;
      },
      isMobile: function () {
        return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      },
      /**
       * @desc Check the given src is video
       * @param {String} src
       * @return {Object} video type
       * Ex:{ youtube  :  ["//www.youtube.com/watch?v=c0asJgSyxcY", "c0asJgSyxcY"] }
       *
       * @todo - this information can be moved to dynamicEl to avoid frequent calls
       */
      isVideo: function (src, isHTML5VIdeo, index) {
        if (!src) {
          if (isHTML5VIdeo) {
            return {
              html5: true
            };
          } else {
            console.error('lightGallery :- data-src is not provided on slide item ' + (index + 1) + '. Please make sure the selector property is properly configured. More info - https://www.lightgalleryjs.com/demos/html-markup/');
            return;
          }
        }
        var youtube = src.match(/\/\/(?:www\.)?youtu(?:\.be|be\.com|be-nocookie\.com)\/(?:watch\?v=|embed\/)?([a-z0-9\-\_\%]+)([\&|?][\S]*)*/i);
        var vimeo = src.match(/\/\/(?:www\.)?(?:player\.)?vimeo.com\/(?:video\/)?([0-9a-z\-_]+)(.*)?/i);
        var wistia = src.match(/https?:\/\/(.+)?(wistia\.com|wi\.st)\/(medias|embed)\/([0-9a-z\-_]+)(.*)/);
        if (youtube) {
          return {
            youtube: youtube
          };
        } else if (vimeo) {
          return {
            vimeo: vimeo
          };
        } else if (wistia) {
          return {
            wistia: wistia
          };
        }
      }
    };

    // @ref - https://stackoverflow.com/questions/3971841/how-to-resize-images-proportionally-keeping-the-aspect-ratio
    // @ref - https://2ality.com/2017/04/setting-up-multi-platform-packages.html
    // Unique id for each gallery
    var lgId = 0;
    var LightGallery = /** @class */function () {
      function LightGallery(element, options) {
        this.lgOpened = false;
        this.index = 0;
        // lightGallery modules
        this.plugins = [];
        // false when lightGallery load first slide content;
        this.lGalleryOn = false;
        // True when a slide animation is in progress
        this.lgBusy = false;
        this.currentItemsInDom = [];
        // Scroll top value before lightGallery is opened
        this.prevScrollTop = 0;
        this.bodyPaddingRight = 0;
        this.isDummyImageRemoved = false;
        this.dragOrSwipeEnabled = false;
        this.mediaContainerPosition = {
          top: 0,
          bottom: 0
        };
        if (!element) {
          return this;
        }
        lgId++;
        this.lgId = lgId;
        this.el = element;
        this.LGel = $LG(element);
        this.generateSettings(options);
        this.buildModules();
        // When using dynamic mode, ensure dynamicEl is an array
        if (this.settings.dynamic && this.settings.dynamicEl !== undefined && !Array.isArray(this.settings.dynamicEl)) {
          throw 'When using dynamic mode, you must also define dynamicEl as an Array.';
        }
        this.galleryItems = this.getItems();
        this.normalizeSettings();
        // Gallery items
        this.init();
        this.validateLicense();
        return this;
      }
      LightGallery.prototype.generateSettings = function (options) {
        // lightGallery settings
        this.settings = __assign$4(__assign$4({}, lightGalleryCoreSettings), options);
        if (this.settings.isMobile && typeof this.settings.isMobile === 'function' ? this.settings.isMobile() : utils$1.isMobile()) {
          var mobileSettings = __assign$4(__assign$4({}, this.settings.mobileSettings), this.settings.mobileSettings);
          this.settings = __assign$4(__assign$4({}, this.settings), mobileSettings);
        }
      };
      LightGallery.prototype.normalizeSettings = function () {
        if (this.settings.slideEndAnimation) {
          this.settings.hideControlOnEnd = false;
        }
        if (!this.settings.closable) {
          this.settings.swipeToClose = false;
        }
        // And reset it on close to get the correct value next time
        this.zoomFromOrigin = this.settings.zoomFromOrigin;
        // At the moment, Zoom from image doesn't support dynamic options
        // @todo add zoomFromOrigin support for dynamic images
        if (this.settings.dynamic) {
          this.zoomFromOrigin = false;
        }
        if (this.settings.container) {
          var container = this.settings.container;
          if (typeof container === 'function') {
            this.settings.container = container();
          } else if (typeof container === 'string') {
            var el = document.querySelector(container);
            this.settings.container = el !== null && el !== void 0 ? el : document.body;
          }
        } else {
          this.settings.container = document.body;
        }
        // settings.preload should not be grater than $item.length
        this.settings.preload = Math.min(this.settings.preload, this.galleryItems.length);
      };
      LightGallery.prototype.init = function () {
        var _this = this;
        this.addSlideVideoInfo(this.galleryItems);
        this.buildStructure();
        this.LGel.trigger(lGEvents$2.init, {
          instance: this
        });
        if (this.settings.keyPress) {
          this.keyPress();
        }
        setTimeout(function () {
          _this.enableDrag();
          _this.enableSwipe();
          _this.triggerPosterClick();
        }, 50);
        this.arrow();
        if (this.settings.mousewheel) {
          this.mousewheel();
        }
        if (!this.settings.dynamic) {
          this.openGalleryOnItemClick();
        }
      };
      LightGallery.prototype.openGalleryOnItemClick = function () {
        var _this = this;
        var _loop_1 = function (index) {
          var element = this_1.items[index];
          var $element = $LG(element);
          // Using different namespace for click because click event should not unbind if selector is same object('this')
          // @todo manage all event listners - should have namespace that represent element
          var uuid = lgQuery.generateUUID();
          $element.attr('data-lg-id', uuid).on("click.lgcustom-item-" + uuid, function (e) {
            e.preventDefault();
            var currentItemIndex = _this.settings.index || index;
            _this.openGallery(currentItemIndex, element);
          });
        };
        var this_1 = this;
        // Using for loop instead of using bubbling as the items can be any html element.
        for (var index = 0; index < this.items.length; index++) {
          _loop_1(index);
        }
      };
      /**
       * Module constructor
       * Modules are build incrementally.
       * Gallery should be opened only once all the modules are initialized.
       * use moduleBuildTimeout to make sure this
       */
      LightGallery.prototype.buildModules = function () {
        var _this = this;
        this.settings.plugins.forEach(function (plugin) {
          _this.plugins.push(new plugin(_this, $LG));
        });
      };
      LightGallery.prototype.validateLicense = function () {
        if (!this.settings.licenseKey) {
          console.error('Please provide a valid license key');
        } else if (this.settings.licenseKey === '0000-0000-000-0000') {
          console.warn("lightGallery: " + this.settings.licenseKey + " license key is not valid for production use");
        }
      };
      LightGallery.prototype.getSlideItem = function (index) {
        return $LG(this.getSlideItemId(index));
      };
      LightGallery.prototype.getSlideItemId = function (index) {
        return "#lg-item-" + this.lgId + "-" + index;
      };
      LightGallery.prototype.getIdName = function (id) {
        return id + "-" + this.lgId;
      };
      LightGallery.prototype.getElementById = function (id) {
        return $LG("#" + this.getIdName(id));
      };
      LightGallery.prototype.manageSingleSlideClassName = function () {
        if (this.galleryItems.length < 2) {
          this.outer.addClass('lg-single-item');
        } else {
          this.outer.removeClass('lg-single-item');
        }
      };
      LightGallery.prototype.buildStructure = function () {
        var _this = this;
        var container = this.$container && this.$container.get();
        if (container) {
          return;
        }
        var controls = '';
        var subHtmlCont = '';
        // Create controls
        if (this.settings.controls) {
          controls = "<button type=\"button\" id=\"" + this.getIdName('lg-prev') + "\" aria-label=\"" + this.settings.strings['previousSlide'] + "\" class=\"lg-prev lg-icon\"> " + this.settings.prevHtml + " </button>\n                <button type=\"button\" id=\"" + this.getIdName('lg-next') + "\" aria-label=\"" + this.settings.strings['nextSlide'] + "\" class=\"lg-next lg-icon\"> " + this.settings.nextHtml + " </button>";
        }
        if (this.settings.appendSubHtmlTo !== '.lg-item') {
          subHtmlCont = '<div class="lg-sub-html" role="status" aria-live="polite"></div>';
        }
        var addClasses = '';
        if (this.settings.allowMediaOverlap) {
          // Do not remove space before last single quote
          addClasses += 'lg-media-overlap ';
        }
        var ariaLabelledby = this.settings.ariaLabelledby ? 'aria-labelledby="' + this.settings.ariaLabelledby + '"' : '';
        var ariaDescribedby = this.settings.ariaDescribedby ? 'aria-describedby="' + this.settings.ariaDescribedby + '"' : '';
        var containerClassName = "lg-container " + this.settings.addClass + " " + (document.body !== this.settings.container ? 'lg-inline' : '');
        var closeIcon = this.settings.closable && this.settings.showCloseIcon ? "<button type=\"button\" aria-label=\"" + this.settings.strings['closeGallery'] + "\" id=\"" + this.getIdName('lg-close') + "\" class=\"lg-close lg-icon\"></button>" : '';
        var maximizeIcon = this.settings.showMaximizeIcon ? "<button type=\"button\" aria-label=\"" + this.settings.strings['toggleMaximize'] + "\" id=\"" + this.getIdName('lg-maximize') + "\" class=\"lg-maximize lg-icon\"></button>" : '';
        var template = "\n        <div class=\"" + containerClassName + "\" id=\"" + this.getIdName('lg-container') + "\" tabindex=\"-1\" aria-modal=\"true\" " + ariaLabelledby + " " + ariaDescribedby + " role=\"dialog\"\n        >\n            <div id=\"" + this.getIdName('lg-backdrop') + "\" class=\"lg-backdrop\"></div>\n\n            <div id=\"" + this.getIdName('lg-outer') + "\" class=\"lg-outer lg-use-css3 lg-css3 lg-hide-items " + addClasses + " \">\n\n              <div id=\"" + this.getIdName('lg-content') + "\" class=\"lg-content\">\n                <div id=\"" + this.getIdName('lg-inner') + "\" class=\"lg-inner\">\n                </div>\n                " + controls + "\n              </div>\n                <div id=\"" + this.getIdName('lg-toolbar') + "\" class=\"lg-toolbar lg-group\">\n                    " + maximizeIcon + "\n                    " + closeIcon + "\n                    </div>\n                    " + (this.settings.appendSubHtmlTo === '.lg-outer' ? subHtmlCont : '') + "\n                <div id=\"" + this.getIdName('lg-components') + "\" class=\"lg-components\">\n                    " + (this.settings.appendSubHtmlTo === '.lg-sub-html' ? subHtmlCont : '') + "\n                </div>\n            </div>\n        </div>\n        ";
        $LG(this.settings.container).append(template);
        if (document.body !== this.settings.container) {
          $LG(this.settings.container).css('position', 'relative');
        }
        this.outer = this.getElementById('lg-outer');
        this.$lgComponents = this.getElementById('lg-components');
        this.$backdrop = this.getElementById('lg-backdrop');
        this.$container = this.getElementById('lg-container');
        this.$inner = this.getElementById('lg-inner');
        this.$content = this.getElementById('lg-content');
        this.$toolbar = this.getElementById('lg-toolbar');
        this.$backdrop.css('transition-duration', this.settings.backdropDuration + 'ms');
        var outerClassNames = this.settings.mode + " ";
        this.manageSingleSlideClassName();
        if (this.settings.enableDrag) {
          outerClassNames += 'lg-grab ';
        }
        this.outer.addClass(outerClassNames);
        this.$inner.css('transition-timing-function', this.settings.easing);
        this.$inner.css('transition-duration', this.settings.speed + 'ms');
        if (this.settings.download) {
          this.$toolbar.append("<a id=\"" + this.getIdName('lg-download') + "\" target=\"_blank\" rel=\"noopener\" aria-label=\"" + this.settings.strings['download'] + "\" download class=\"lg-download lg-icon\"></a>");
        }
        this.counter();
        $LG(window).on("resize.lg.global" + this.lgId + " orientationchange.lg.global" + this.lgId, function () {
          _this.refreshOnResize();
        });
        this.hideBars();
        this.manageCloseGallery();
        this.toggleMaximize();
        this.initModules();
      };
      LightGallery.prototype.refreshOnResize = function () {
        if (this.lgOpened) {
          var currentGalleryItem = this.galleryItems[this.index];
          var __slideVideoInfo = currentGalleryItem.__slideVideoInfo;
          this.mediaContainerPosition = this.getMediaContainerPosition();
          var _a = this.mediaContainerPosition,
            top_1 = _a.top,
            bottom = _a.bottom;
          this.currentImageSize = utils$1.getSize(this.items[this.index], this.outer, top_1 + bottom, __slideVideoInfo && this.settings.videoMaxSize);
          if (__slideVideoInfo) {
            this.resizeVideoSlide(this.index, this.currentImageSize);
          }
          if (this.zoomFromOrigin && !this.isDummyImageRemoved) {
            var imgStyle = this.getDummyImgStyles(this.currentImageSize);
            this.outer.find('.lg-current .lg-dummy-img').first().attr('style', imgStyle);
          }
          this.LGel.trigger(lGEvents$2.containerResize);
        }
      };
      LightGallery.prototype.resizeVideoSlide = function (index, imageSize) {
        var lgVideoStyle = this.getVideoContStyle(imageSize);
        var currentSlide = this.getSlideItem(index);
        currentSlide.find('.lg-video-cont').attr('style', lgVideoStyle);
      };
      /**
       * Update slides dynamically.
       * Add, edit or delete slides dynamically when lightGallery is opened.
       * Modify the current gallery items and pass it via updateSlides method
       * @note
       * - Do not mutate existing lightGallery items directly.
       * - Always pass new list of gallery items
       * - You need to take care of thumbnails outside the gallery if any
       * - user this method only if you want to update slides when the gallery is opened. Otherwise, use `refresh()` method.
       * @param items Gallery items
       * @param index After the update operation, which slide gallery should navigate to
       * @category lGPublicMethods
       * @example
       * const plugin = lightGallery();
       *
       * // Adding slides dynamically
       * let galleryItems = [
       * // Access existing lightGallery items
       * // galleryItems are automatically generated internally from the gallery HTML markup
       * // or directly from galleryItems when dynamic gallery is used
       *   ...plugin.galleryItems,
       *     ...[
       *       {
       *         src: 'img/img-1.png',
       *           thumb: 'img/thumb1.png',
       *         },
       *     ],
       *   ];
       *   plugin.updateSlides(
       *     galleryItems,
       *     plugin.index,
       *   );
       *
       *
       * // Remove slides dynamically
       * galleryItems = JSON.parse(
       *   JSON.stringify(updateSlideInstance.galleryItems),
       * );
       * galleryItems.shift();
       * updateSlideInstance.updateSlides(galleryItems, 1);
       * @see <a href="/demos/update-slides/">Demo</a>
       */
      LightGallery.prototype.updateSlides = function (items, index) {
        if (this.index > items.length - 1) {
          this.index = items.length - 1;
        }
        if (items.length === 1) {
          this.index = 0;
        }
        if (!items.length) {
          this.closeGallery();
          return;
        }
        var currentSrc = this.galleryItems[index].src;
        this.galleryItems = items;
        this.updateControls();
        this.$inner.empty();
        this.currentItemsInDom = [];
        var _index = 0;
        // Find the current index based on source value of the slide
        this.galleryItems.some(function (galleryItem, itemIndex) {
          if (galleryItem.src === currentSrc) {
            _index = itemIndex;
            return true;
          }
          return false;
        });
        this.currentItemsInDom = this.organizeSlideItems(_index, -1);
        this.loadContent(_index, true);
        this.getSlideItem(_index).addClass('lg-current');
        this.index = _index;
        this.updateCurrentCounter(_index);
        this.LGel.trigger(lGEvents$2.updateSlides);
      };
      // Get gallery items based on multiple conditions
      LightGallery.prototype.getItems = function () {
        // Gallery items
        this.items = [];
        if (!this.settings.dynamic) {
          if (this.settings.selector === 'this') {
            this.items.push(this.el);
          } else if (this.settings.selector) {
            if (typeof this.settings.selector === 'string') {
              if (this.settings.selectWithin) {
                var selectWithin = $LG(this.settings.selectWithin);
                this.items = selectWithin.find(this.settings.selector).get();
              } else {
                this.items = this.el.querySelectorAll(this.settings.selector);
              }
            } else {
              this.items = this.settings.selector;
            }
          } else {
            this.items = this.el.children;
          }
          return utils$1.getDynamicOptions(this.items, this.settings.extraProps, this.settings.getCaptionFromTitleOrAlt, this.settings.exThumbImage);
        } else {
          return this.settings.dynamicEl || [];
        }
      };
      LightGallery.prototype.shouldHideScrollbar = function () {
        return this.settings.hideScrollbar && document.body === this.settings.container;
      };
      LightGallery.prototype.hideScrollbar = function () {
        if (!this.shouldHideScrollbar()) {
          return;
        }
        this.bodyPaddingRight = parseFloat($LG('body').style().paddingRight);
        var bodyRect = document.documentElement.getBoundingClientRect();
        var scrollbarWidth = window.innerWidth - bodyRect.width;
        $LG(document.body).css('padding-right', scrollbarWidth + this.bodyPaddingRight + 'px');
        $LG(document.body).addClass('lg-overlay-open');
      };
      LightGallery.prototype.resetScrollBar = function () {
        if (!this.shouldHideScrollbar()) {
          return;
        }
        $LG(document.body).css('padding-right', this.bodyPaddingRight + 'px');
        $LG(document.body).removeClass('lg-overlay-open');
      };
      /**
       * Open lightGallery.
       * Open gallery with specific slide by passing index of the slide as parameter.
       * @category lGPublicMethods
       * @param {Number} index  - index of the slide
       * @param {HTMLElement} element - Which image lightGallery should zoom from
       *
       * @example
       * const $dynamicGallery = document.getElementById('dynamic-gallery-demo');
       * const dynamicGallery = lightGallery($dynamicGallery, {
       *     dynamic: true,
       *     dynamicEl: [
       *         {
       *              src: 'img/1.jpg',
       *              thumb: 'img/thumb-1.jpg',
       *              subHtml: '<h4>Image 1 title</h4><p>Image 1 descriptions.</p>',
       *         },
       *         ...
       *     ],
       * });
       * $dynamicGallery.addEventListener('click', function () {
       *     // Starts with third item.(Optional).
       *     // This is useful if you want use dynamic mode with
       *     // custom thumbnails (thumbnails outside gallery),
       *     dynamicGallery.openGallery(2);
       * });
       *
       */
      LightGallery.prototype.openGallery = function (index, element) {
        var _this = this;
        if (index === void 0) {
          index = this.settings.index;
        }
        // prevent accidental double execution
        if (this.lgOpened) return;
        this.lgOpened = true;
        this.outer.removeClass('lg-hide-items');
        this.hideScrollbar();
        // Add display block, but still has opacity 0
        this.$container.addClass('lg-show');
        var itemsToBeInsertedToDom = this.getItemsToBeInsertedToDom(index, index);
        this.currentItemsInDom = itemsToBeInsertedToDom;
        var items = '';
        itemsToBeInsertedToDom.forEach(function (item) {
          items = items + ("<div id=\"" + item + "\" class=\"lg-item\"></div>");
        });
        this.$inner.append(items);
        this.addHtml(index);
        var transform = '';
        this.mediaContainerPosition = this.getMediaContainerPosition();
        var _a = this.mediaContainerPosition,
          top = _a.top,
          bottom = _a.bottom;
        if (!this.settings.allowMediaOverlap) {
          this.setMediaContainerPosition(top, bottom);
        }
        var __slideVideoInfo = this.galleryItems[index].__slideVideoInfo;
        if (this.zoomFromOrigin && element) {
          this.currentImageSize = utils$1.getSize(element, this.outer, top + bottom, __slideVideoInfo && this.settings.videoMaxSize);
          transform = utils$1.getTransform(element, this.outer, top, bottom, this.currentImageSize);
        }
        if (!this.zoomFromOrigin || !transform) {
          this.outer.addClass(this.settings.startClass);
          this.getSlideItem(index).removeClass('lg-complete');
        }
        var timeout = this.settings.zoomFromOrigin ? 100 : this.settings.backdropDuration;
        setTimeout(function () {
          _this.outer.addClass('lg-components-open');
        }, timeout);
        this.index = index;
        this.LGel.trigger(lGEvents$2.beforeOpen);
        // add class lg-current to remove initial transition
        this.getSlideItem(index).addClass('lg-current');
        this.lGalleryOn = false;
        // Store the current scroll top value to scroll back after closing the gallery..
        this.prevScrollTop = $LG(window).scrollTop();
        setTimeout(function () {
          // Need to check both zoomFromOrigin and transform values as we need to set set the
          // default opening animation if user missed to add the lg-size attribute
          if (_this.zoomFromOrigin && transform) {
            var currentSlide_1 = _this.getSlideItem(index);
            currentSlide_1.css('transform', transform);
            setTimeout(function () {
              currentSlide_1.addClass('lg-start-progress lg-start-end-progress').css('transition-duration', _this.settings.startAnimationDuration + 'ms');
              _this.outer.addClass('lg-zoom-from-image');
            });
            setTimeout(function () {
              currentSlide_1.css('transform', 'translate3d(0, 0, 0)');
            }, 100);
          }
          setTimeout(function () {
            _this.$backdrop.addClass('in');
            _this.$container.addClass('lg-show-in');
          }, 10);
          setTimeout(function () {
            if (_this.settings.trapFocus && document.body === _this.settings.container) {
              _this.trapFocus();
            }
          }, _this.settings.backdropDuration + 50);
          // lg-visible class resets gallery opacity to 1
          if (!_this.zoomFromOrigin || !transform) {
            setTimeout(function () {
              _this.outer.addClass('lg-visible');
            }, _this.settings.backdropDuration);
          }
          // initiate slide function
          _this.slide(index, false, false, false);
          _this.LGel.trigger(lGEvents$2.afterOpen);
        });
        if (document.body === this.settings.container) {
          $LG('html').addClass('lg-on');
        }
      };
      /**
       * Note - Changing the position of the media on every slide transition creates a flickering effect.
       * Therefore, The height of the caption is calculated dynamically, only once based on the first slide caption.
       * if you have dynamic captions for each media,
       * you can provide an appropriate height for the captions via allowMediaOverlap option
       */
      LightGallery.prototype.getMediaContainerPosition = function () {
        if (this.settings.allowMediaOverlap) {
          return {
            top: 0,
            bottom: 0
          };
        }
        var top = this.$toolbar.get().clientHeight || 0;
        var subHtml = this.outer.find('.lg-components .lg-sub-html').get();
        var captionHeight = this.settings.defaultCaptionHeight || subHtml && subHtml.clientHeight || 0;
        var thumbContainer = this.outer.find('.lg-thumb-outer').get();
        var thumbHeight = thumbContainer ? thumbContainer.clientHeight : 0;
        var bottom = thumbHeight + captionHeight;
        return {
          top: top,
          bottom: bottom
        };
      };
      LightGallery.prototype.setMediaContainerPosition = function (top, bottom) {
        if (top === void 0) {
          top = 0;
        }
        if (bottom === void 0) {
          bottom = 0;
        }
        this.$content.css('top', top + 'px').css('bottom', bottom + 'px');
      };
      LightGallery.prototype.hideBars = function () {
        var _this = this;
        // Hide controllers if mouse doesn't move for some period
        setTimeout(function () {
          _this.outer.removeClass('lg-hide-items');
          if (_this.settings.hideBarsDelay > 0) {
            _this.outer.on('mousemove.lg click.lg touchstart.lg', function () {
              _this.outer.removeClass('lg-hide-items');
              clearTimeout(_this.hideBarTimeout);
              // Timeout will be cleared on each slide movement also
              _this.hideBarTimeout = setTimeout(function () {
                _this.outer.addClass('lg-hide-items');
              }, _this.settings.hideBarsDelay);
            });
            _this.outer.trigger('mousemove.lg');
          }
        }, this.settings.showBarsAfter);
      };
      LightGallery.prototype.initPictureFill = function ($img) {
        if (this.settings.supportLegacyBrowser) {
          try {
            picturefill({
              elements: [$img.get()]
            });
          } catch (e) {
            console.warn('lightGallery :- If you want srcset or picture tag to be supported for older browser please include picturefil javascript library in your document.');
          }
        }
      };
      /**
       *  @desc Create image counter
       *  Ex: 1/10
       */
      LightGallery.prototype.counter = function () {
        if (this.settings.counter) {
          var counterHtml = "<div class=\"lg-counter\" role=\"status\" aria-live=\"polite\">\n                <span id=\"" + this.getIdName('lg-counter-current') + "\" class=\"lg-counter-current\">" + (this.index + 1) + " </span> /\n                <span id=\"" + this.getIdName('lg-counter-all') + "\" class=\"lg-counter-all\">" + this.galleryItems.length + " </span></div>";
          this.outer.find(this.settings.appendCounterTo).append(counterHtml);
        }
      };
      /**
       *  @desc add sub-html into the slide
       *  @param {Number} index - index of the slide
       */
      LightGallery.prototype.addHtml = function (index) {
        var subHtml;
        var subHtmlUrl;
        if (this.galleryItems[index].subHtmlUrl) {
          subHtmlUrl = this.galleryItems[index].subHtmlUrl;
        } else {
          subHtml = this.galleryItems[index].subHtml;
        }
        if (!subHtmlUrl) {
          if (subHtml) {
            // get first letter of sub-html
            // if first letter starts with . or # get the html form the jQuery object
            var fL = subHtml.substring(0, 1);
            if (fL === '.' || fL === '#') {
              if (this.settings.subHtmlSelectorRelative && !this.settings.dynamic) {
                subHtml = $LG(this.items).eq(index).find(subHtml).first().html();
              } else {
                subHtml = $LG(subHtml).first().html();
              }
            }
          } else {
            subHtml = '';
          }
        }
        if (this.settings.appendSubHtmlTo !== '.lg-item') {
          if (subHtmlUrl) {
            utils$1.fetchCaptionFromUrl(subHtmlUrl, this.outer.find('.lg-sub-html'), 'replace');
          } else {
            this.outer.find('.lg-sub-html').html(subHtml);
          }
        } else {
          var currentSlide = $LG(this.getSlideItemId(index));
          if (subHtmlUrl) {
            utils$1.fetchCaptionFromUrl(subHtmlUrl, currentSlide, 'append');
          } else {
            currentSlide.append("<div class=\"lg-sub-html\">" + subHtml + "</div>");
          }
        }
        // Add lg-empty-html class if title doesn't exist
        if (typeof subHtml !== 'undefined' && subHtml !== null) {
          if (subHtml === '') {
            this.outer.find(this.settings.appendSubHtmlTo).addClass('lg-empty-html');
          } else {
            this.outer.find(this.settings.appendSubHtmlTo).removeClass('lg-empty-html');
          }
        }
        this.LGel.trigger(lGEvents$2.afterAppendSubHtml, {
          index: index
        });
      };
      /**
       *  @desc Preload slides
       *  @param {Number} index - index of the slide
       * @todo preload not working for the first slide, Also, should work for the first and last slide as well
       */
      LightGallery.prototype.preload = function (index) {
        for (var i = 1; i <= this.settings.preload; i++) {
          if (i >= this.galleryItems.length - index) {
            break;
          }
          this.loadContent(index + i, false);
        }
        for (var j = 1; j <= this.settings.preload; j++) {
          if (index - j < 0) {
            break;
          }
          this.loadContent(index - j, false);
        }
      };
      LightGallery.prototype.getDummyImgStyles = function (imageSize) {
        if (!imageSize) return '';
        return "width:" + imageSize.width + "px;\n                margin-left: -" + imageSize.width / 2 + "px;\n                margin-top: -" + imageSize.height / 2 + "px;\n                height:" + imageSize.height + "px";
      };
      LightGallery.prototype.getVideoContStyle = function (imageSize) {
        if (!imageSize) return '';
        return "width:" + imageSize.width + "px;\n                height:" + imageSize.height + "px";
      };
      LightGallery.prototype.getDummyImageContent = function ($currentSlide, index, alt) {
        var $currentItem;
        if (!this.settings.dynamic) {
          $currentItem = $LG(this.items).eq(index);
        }
        if ($currentItem) {
          var _dummyImgSrc = void 0;
          if (!this.settings.exThumbImage) {
            _dummyImgSrc = $currentItem.find('img').first().attr('src');
          } else {
            _dummyImgSrc = $currentItem.attr(this.settings.exThumbImage);
          }
          if (!_dummyImgSrc) return '';
          var imgStyle = this.getDummyImgStyles(this.currentImageSize);
          var dummyImgContentImg = document.createElement('img');
          dummyImgContentImg.alt = alt || '';
          dummyImgContentImg.src = _dummyImgSrc;
          dummyImgContentImg.className = "lg-dummy-img";
          dummyImgContentImg.style.cssText = imgStyle;
          $currentSlide.addClass('lg-first-slide');
          this.outer.addClass('lg-first-slide-loading');
          return dummyImgContentImg;
        }
        return '';
      };
      LightGallery.prototype.setImgMarkup = function (src, $currentSlide, index) {
        var currentGalleryItem = this.galleryItems[index];
        var alt = currentGalleryItem.alt,
          srcset = currentGalleryItem.srcset,
          sizes = currentGalleryItem.sizes,
          sources = currentGalleryItem.sources;
        // Use the thumbnail as dummy image which will be resized to actual image size and
        // displayed on top of actual image
        var imgContent = '';
        var altAttr = alt ? 'alt="' + alt + '"' : '';
        if (this.isFirstSlideWithZoomAnimation()) {
          imgContent = this.getDummyImageContent($currentSlide, index, altAttr);
        } else {
          imgContent = utils$1.getImgMarkup(index, src, altAttr, srcset, sizes, sources);
        }
        var picture = document.createElement('picture');
        picture.className = 'lg-img-wrap';
        $LG(picture).append(imgContent);
        $currentSlide.prepend(picture);
      };
      LightGallery.prototype.onSlideObjectLoad = function ($slide, isHTML5VideoWithoutPoster, onLoad, onError) {
        var mediaObject = $slide.find('.lg-object').first();
        if (utils$1.isImageLoaded(mediaObject.get()) || isHTML5VideoWithoutPoster) {
          onLoad();
        } else {
          mediaObject.on('load.lg error.lg', function () {
            onLoad && onLoad();
          });
          mediaObject.on('error.lg', function () {
            onError && onError();
          });
        }
      };
      /**
       *
       * @param $el Current slide item
       * @param index
       * @param delay Delay is 0 except first time
       * @param speed Speed is same as delay, except it is 0 if gallery is opened via hash plugin
       * @param isFirstSlide
       */
      LightGallery.prototype.onLgObjectLoad = function (currentSlide, index, delay, speed, isFirstSlide, isHTML5VideoWithoutPoster) {
        var _this = this;
        this.onSlideObjectLoad(currentSlide, isHTML5VideoWithoutPoster, function () {
          _this.triggerSlideItemLoad(currentSlide, index, delay, speed, isFirstSlide);
        }, function () {
          currentSlide.addClass('lg-complete lg-complete_');
          currentSlide.html('<span class="lg-error-msg">' + _this.settings.strings['mediaLoadingFailed'] + '</span>');
        });
      };
      LightGallery.prototype.triggerSlideItemLoad = function ($currentSlide, index, delay, speed, isFirstSlide) {
        var _this = this;
        var currentGalleryItem = this.galleryItems[index];
        // Adding delay for video slides without poster for better performance and user experience
        // Videos should start playing once once the gallery is completely loaded
        var _speed = isFirstSlide && this.getSlideType(currentGalleryItem) === 'video' && !currentGalleryItem.poster ? speed : 0;
        setTimeout(function () {
          $currentSlide.addClass('lg-complete lg-complete_');
          _this.LGel.trigger(lGEvents$2.slideItemLoad, {
            index: index,
            delay: delay || 0,
            isFirstSlide: isFirstSlide
          });
        }, _speed);
      };
      LightGallery.prototype.isFirstSlideWithZoomAnimation = function () {
        return !!(!this.lGalleryOn && this.zoomFromOrigin && this.currentImageSize);
      };
      // Add video slideInfo
      LightGallery.prototype.addSlideVideoInfo = function (items) {
        var _this = this;
        items.forEach(function (element, index) {
          element.__slideVideoInfo = utils$1.isVideo(element.src, !!element.video, index);
          if (element.__slideVideoInfo && _this.settings.loadYouTubePoster && !element.poster && element.__slideVideoInfo.youtube) {
            element.poster = "//img.youtube.com/vi/" + element.__slideVideoInfo.youtube[1] + "/maxresdefault.jpg";
          }
        });
      };
      /**
       *  Load slide content into slide.
       *  This is used to load content into slides that is not visible too
       *  @param {Number} index - index of the slide.
       *  @param {Boolean} rec - if true call loadcontent() function again.
       */
      LightGallery.prototype.loadContent = function (index, rec) {
        var _this = this;
        var currentGalleryItem = this.galleryItems[index];
        var $currentSlide = $LG(this.getSlideItemId(index));
        var poster = currentGalleryItem.poster,
          srcset = currentGalleryItem.srcset,
          sizes = currentGalleryItem.sizes,
          sources = currentGalleryItem.sources;
        var src = currentGalleryItem.src;
        var video = currentGalleryItem.video;
        var _html5Video = video && typeof video === 'string' ? JSON.parse(video) : video;
        if (currentGalleryItem.responsive) {
          var srcDyItms = currentGalleryItem.responsive.split(',');
          src = utils$1.getResponsiveSrc(srcDyItms) || src;
        }
        var videoInfo = currentGalleryItem.__slideVideoInfo;
        var lgVideoStyle = '';
        var iframe = !!currentGalleryItem.iframe;
        var isFirstSlide = !this.lGalleryOn;
        // delay for adding complete class. it is 0 except first time.
        var delay = 0;
        if (isFirstSlide) {
          if (this.zoomFromOrigin && this.currentImageSize) {
            delay = this.settings.startAnimationDuration + 10;
          } else {
            delay = this.settings.backdropDuration + 10;
          }
        }
        if (!$currentSlide.hasClass('lg-loaded')) {
          if (videoInfo) {
            var _a = this.mediaContainerPosition,
              top_2 = _a.top,
              bottom = _a.bottom;
            var videoSize = utils$1.getSize(this.items[index], this.outer, top_2 + bottom, videoInfo && this.settings.videoMaxSize);
            lgVideoStyle = this.getVideoContStyle(videoSize);
          }
          if (iframe) {
            var markup = utils$1.getIframeMarkup(this.settings.iframeWidth, this.settings.iframeHeight, this.settings.iframeMaxWidth, this.settings.iframeMaxHeight, src, currentGalleryItem.iframeTitle);
            $currentSlide.prepend(markup);
          } else if (poster) {
            var dummyImg = '';
            var hasStartAnimation = isFirstSlide && this.zoomFromOrigin && this.currentImageSize;
            if (hasStartAnimation) {
              dummyImg = this.getDummyImageContent($currentSlide, index, '');
            }
            var markup = utils$1.getVideoPosterMarkup(poster, dummyImg || '', lgVideoStyle, this.settings.strings['playVideo'], videoInfo);
            $currentSlide.prepend(markup);
          } else if (videoInfo) {
            var markup = "<div class=\"lg-video-cont \" style=\"" + lgVideoStyle + "\"></div>";
            $currentSlide.prepend(markup);
          } else {
            this.setImgMarkup(src, $currentSlide, index);
            if (srcset || sources) {
              var $img = $currentSlide.find('.lg-object');
              this.initPictureFill($img);
            }
          }
          if (poster || videoInfo) {
            this.LGel.trigger(lGEvents$2.hasVideo, {
              index: index,
              src: src,
              html5Video: _html5Video,
              hasPoster: !!poster
            });
          }
          this.LGel.trigger(lGEvents$2.afterAppendSlide, {
            index: index
          });
          if (this.lGalleryOn && this.settings.appendSubHtmlTo === '.lg-item') {
            this.addHtml(index);
          }
        }
        // For first time add some delay for displaying the start animation.
        var _speed = 0;
        // Do not change the delay value because it is required for zoom plugin.
        // If gallery opened from direct url (hash) speed value should be 0
        if (delay && !$LG(document.body).hasClass('lg-from-hash')) {
          _speed = delay;
        }
        // Only for first slide and zoomFromOrigin is enabled
        if (this.isFirstSlideWithZoomAnimation()) {
          setTimeout(function () {
            $currentSlide.removeClass('lg-start-end-progress lg-start-progress').removeAttr('style');
          }, this.settings.startAnimationDuration + 100);
          if (!$currentSlide.hasClass('lg-loaded')) {
            setTimeout(function () {
              if (_this.getSlideType(currentGalleryItem) === 'image') {
                var alt = currentGalleryItem.alt;
                var altAttr = alt ? 'alt="' + alt + '"' : '';
                $currentSlide.find('.lg-img-wrap').append(utils$1.getImgMarkup(index, src, altAttr, srcset, sizes, currentGalleryItem.sources));
                if (srcset || sources) {
                  var $img = $currentSlide.find('.lg-object');
                  _this.initPictureFill($img);
                }
              }
              if (_this.getSlideType(currentGalleryItem) === 'image' || _this.getSlideType(currentGalleryItem) === 'video' && poster) {
                _this.onLgObjectLoad($currentSlide, index, delay, _speed, true, false);
                // load remaining slides once the slide is completely loaded
                _this.onSlideObjectLoad($currentSlide, !!(videoInfo && videoInfo.html5 && !poster), function () {
                  _this.loadContentOnFirstSlideLoad(index, $currentSlide, _speed);
                }, function () {
                  _this.loadContentOnFirstSlideLoad(index, $currentSlide, _speed);
                });
              }
            }, this.settings.startAnimationDuration + 100);
          }
        }
        // SLide content has been added to dom
        $currentSlide.addClass('lg-loaded');
        if (!this.isFirstSlideWithZoomAnimation() || this.getSlideType(currentGalleryItem) === 'video' && !poster) {
          this.onLgObjectLoad($currentSlide, index, delay, _speed, isFirstSlide, !!(videoInfo && videoInfo.html5 && !poster));
        }
        // When gallery is opened once content is loaded (second time) need to add lg-complete class for css styling
        if ((!this.zoomFromOrigin || !this.currentImageSize) && $currentSlide.hasClass('lg-complete_') && !this.lGalleryOn) {
          setTimeout(function () {
            $currentSlide.addClass('lg-complete');
          }, this.settings.backdropDuration);
        }
        // Content loaded
        // Need to set lGalleryOn before calling preload function
        this.lGalleryOn = true;
        if (rec === true) {
          if (!$currentSlide.hasClass('lg-complete_')) {
            $currentSlide.find('.lg-object').first().on('load.lg error.lg', function () {
              _this.preload(index);
            });
          } else {
            this.preload(index);
          }
        }
      };
      /**
       * @desc Remove dummy image content and load next slides
       * Called only for the first time if zoomFromOrigin animation is enabled
       * @param index
       * @param $currentSlide
       * @param speed
       */
      LightGallery.prototype.loadContentOnFirstSlideLoad = function (index, $currentSlide, speed) {
        var _this = this;
        setTimeout(function () {
          $currentSlide.find('.lg-dummy-img').remove();
          $currentSlide.removeClass('lg-first-slide');
          _this.outer.removeClass('lg-first-slide-loading');
          _this.isDummyImageRemoved = true;
          _this.preload(index);
        }, speed + 300);
      };
      LightGallery.prototype.getItemsToBeInsertedToDom = function (index, prevIndex, numberOfItems) {
        var _this = this;
        if (numberOfItems === void 0) {
          numberOfItems = 0;
        }
        var itemsToBeInsertedToDom = [];
        // Minimum 2 items should be there
        var possibleNumberOfItems = Math.max(numberOfItems, 3);
        possibleNumberOfItems = Math.min(possibleNumberOfItems, this.galleryItems.length);
        var prevIndexItem = "lg-item-" + this.lgId + "-" + prevIndex;
        if (this.galleryItems.length <= 3) {
          this.galleryItems.forEach(function (_element, index) {
            itemsToBeInsertedToDom.push("lg-item-" + _this.lgId + "-" + index);
          });
          return itemsToBeInsertedToDom;
        }
        if (index < (this.galleryItems.length - 1) / 2) {
          for (var idx = index; idx > index - possibleNumberOfItems / 2 && idx >= 0; idx--) {
            itemsToBeInsertedToDom.push("lg-item-" + this.lgId + "-" + idx);
          }
          var numberOfExistingItems = itemsToBeInsertedToDom.length;
          for (var idx = 0; idx < possibleNumberOfItems - numberOfExistingItems; idx++) {
            itemsToBeInsertedToDom.push("lg-item-" + this.lgId + "-" + (index + idx + 1));
          }
        } else {
          for (var idx = index; idx <= this.galleryItems.length - 1 && idx < index + possibleNumberOfItems / 2; idx++) {
            itemsToBeInsertedToDom.push("lg-item-" + this.lgId + "-" + idx);
          }
          var numberOfExistingItems = itemsToBeInsertedToDom.length;
          for (var idx = 0; idx < possibleNumberOfItems - numberOfExistingItems; idx++) {
            itemsToBeInsertedToDom.push("lg-item-" + this.lgId + "-" + (index - idx - 1));
          }
        }
        if (this.settings.loop) {
          if (index === this.galleryItems.length - 1) {
            itemsToBeInsertedToDom.push("lg-item-" + this.lgId + "-" + 0);
          } else if (index === 0) {
            itemsToBeInsertedToDom.push("lg-item-" + this.lgId + "-" + (this.galleryItems.length - 1));
          }
        }
        if (itemsToBeInsertedToDom.indexOf(prevIndexItem) === -1) {
          itemsToBeInsertedToDom.push("lg-item-" + this.lgId + "-" + prevIndex);
        }
        return itemsToBeInsertedToDom;
      };
      LightGallery.prototype.organizeSlideItems = function (index, prevIndex) {
        var _this = this;
        var itemsToBeInsertedToDom = this.getItemsToBeInsertedToDom(index, prevIndex, this.settings.numberOfSlideItemsInDom);
        itemsToBeInsertedToDom.forEach(function (item) {
          if (_this.currentItemsInDom.indexOf(item) === -1) {
            _this.$inner.append("<div id=\"" + item + "\" class=\"lg-item\"></div>");
          }
        });
        this.currentItemsInDom.forEach(function (item) {
          if (itemsToBeInsertedToDom.indexOf(item) === -1) {
            $LG("#" + item).remove();
          }
        });
        return itemsToBeInsertedToDom;
      };
      /**
       * Get previous index of the slide
       */
      LightGallery.prototype.getPreviousSlideIndex = function () {
        var prevIndex = 0;
        try {
          var currentItemId = this.outer.find('.lg-current').first().attr('id');
          prevIndex = parseInt(currentItemId.split('-')[3]) || 0;
        } catch (error) {
          prevIndex = 0;
        }
        return prevIndex;
      };
      LightGallery.prototype.setDownloadValue = function (index) {
        if (this.settings.download) {
          var currentGalleryItem = this.galleryItems[index];
          var hideDownloadBtn = currentGalleryItem.downloadUrl === false || currentGalleryItem.downloadUrl === 'false';
          if (hideDownloadBtn) {
            this.outer.addClass('lg-hide-download');
          } else {
            var $download = this.getElementById('lg-download');
            this.outer.removeClass('lg-hide-download');
            $download.attr('href', currentGalleryItem.downloadUrl || currentGalleryItem.src);
            if (currentGalleryItem.download) {
              $download.attr('download', currentGalleryItem.download);
            }
          }
        }
      };
      LightGallery.prototype.makeSlideAnimation = function (direction, currentSlideItem, previousSlideItem) {
        var _this = this;
        if (this.lGalleryOn) {
          previousSlideItem.addClass('lg-slide-progress');
        }
        setTimeout(function () {
          // remove all transitions
          _this.outer.addClass('lg-no-trans');
          _this.outer.find('.lg-item').removeClass('lg-prev-slide lg-next-slide');
          if (direction === 'prev') {
            //prevslide
            currentSlideItem.addClass('lg-prev-slide');
            previousSlideItem.addClass('lg-next-slide');
          } else {
            // next slide
            currentSlideItem.addClass('lg-next-slide');
            previousSlideItem.addClass('lg-prev-slide');
          }
          // give 50 ms for browser to add/remove class
          setTimeout(function () {
            _this.outer.find('.lg-item').removeClass('lg-current');
            currentSlideItem.addClass('lg-current');
            // reset all transitions
            _this.outer.removeClass('lg-no-trans');
          }, 50);
        }, this.lGalleryOn ? this.settings.slideDelay : 0);
      };
      /**
       * Goto a specific slide.
       * @param {Number} index - index of the slide
       * @param {Boolean} fromTouch - true if slide function called via touch event or mouse drag
       * @param {Boolean} fromThumb - true if slide function called via thumbnail click
       * @param {String} direction - Direction of the slide(next/prev)
       * @category lGPublicMethods
       * @example
       *  const plugin = lightGallery();
       *  // to go to 3rd slide
       *  plugin.slide(2);
       *
       */
      LightGallery.prototype.slide = function (index, fromTouch, fromThumb, direction) {
        var _this = this;
        var prevIndex = this.getPreviousSlideIndex();
        this.currentItemsInDom = this.organizeSlideItems(index, prevIndex);
        // Prevent multiple call, Required for hsh plugin
        if (this.lGalleryOn && prevIndex === index) {
          return;
        }
        var numberOfGalleryItems = this.galleryItems.length;
        if (!this.lgBusy) {
          if (this.settings.counter) {
            this.updateCurrentCounter(index);
          }
          var currentSlideItem = this.getSlideItem(index);
          var previousSlideItem_1 = this.getSlideItem(prevIndex);
          var currentGalleryItem = this.galleryItems[index];
          var videoInfo = currentGalleryItem.__slideVideoInfo;
          this.outer.attr('data-lg-slide-type', this.getSlideType(currentGalleryItem));
          this.setDownloadValue(index);
          if (videoInfo) {
            var _a = this.mediaContainerPosition,
              top_3 = _a.top,
              bottom = _a.bottom;
            var videoSize = utils$1.getSize(this.items[index], this.outer, top_3 + bottom, videoInfo && this.settings.videoMaxSize);
            this.resizeVideoSlide(index, videoSize);
          }
          this.LGel.trigger(lGEvents$2.beforeSlide, {
            prevIndex: prevIndex,
            index: index,
            fromTouch: !!fromTouch,
            fromThumb: !!fromThumb
          });
          this.lgBusy = true;
          clearTimeout(this.hideBarTimeout);
          this.arrowDisable(index);
          if (!direction) {
            if (index < prevIndex) {
              direction = 'prev';
            } else if (index > prevIndex) {
              direction = 'next';
            }
          }
          if (!fromTouch) {
            this.makeSlideAnimation(direction, currentSlideItem, previousSlideItem_1);
          } else {
            this.outer.find('.lg-item').removeClass('lg-prev-slide lg-current lg-next-slide');
            var touchPrev = void 0;
            var touchNext = void 0;
            if (numberOfGalleryItems > 2) {
              touchPrev = index - 1;
              touchNext = index + 1;
              if (index === 0 && prevIndex === numberOfGalleryItems - 1) {
                // next slide
                touchNext = 0;
                touchPrev = numberOfGalleryItems - 1;
              } else if (index === numberOfGalleryItems - 1 && prevIndex === 0) {
                // prev slide
                touchNext = 0;
                touchPrev = numberOfGalleryItems - 1;
              }
            } else {
              touchPrev = 0;
              touchNext = 1;
            }
            if (direction === 'prev') {
              this.getSlideItem(touchNext).addClass('lg-next-slide');
            } else {
              this.getSlideItem(touchPrev).addClass('lg-prev-slide');
            }
            currentSlideItem.addClass('lg-current');
          }
          // Do not put load content in set timeout as it needs to load immediately when the gallery is opened
          if (!this.lGalleryOn) {
            this.loadContent(index, true);
          } else {
            setTimeout(function () {
              _this.loadContent(index, true);
              // Add title if this.settings.appendSubHtmlTo === lg-sub-html
              if (_this.settings.appendSubHtmlTo !== '.lg-item') {
                _this.addHtml(index);
              }
            }, this.settings.speed + 50 + (fromTouch ? 0 : this.settings.slideDelay));
          }
          setTimeout(function () {
            _this.lgBusy = false;
            previousSlideItem_1.removeClass('lg-slide-progress');
            _this.LGel.trigger(lGEvents$2.afterSlide, {
              prevIndex: prevIndex,
              index: index,
              fromTouch: fromTouch,
              fromThumb: fromThumb
            });
          }, (this.lGalleryOn ? this.settings.speed + 100 : 100) + (fromTouch ? 0 : this.settings.slideDelay));
        }
        this.index = index;
      };
      LightGallery.prototype.updateCurrentCounter = function (index) {
        this.getElementById('lg-counter-current').html(index + 1 + '');
      };
      LightGallery.prototype.updateCounterTotal = function () {
        this.getElementById('lg-counter-all').html(this.galleryItems.length + '');
      };
      LightGallery.prototype.getSlideType = function (item) {
        if (item.__slideVideoInfo) {
          return 'video';
        } else if (item.iframe) {
          return 'iframe';
        } else {
          return 'image';
        }
      };
      LightGallery.prototype.touchMove = function (startCoords, endCoords, e) {
        var distanceX = endCoords.pageX - startCoords.pageX;
        var distanceY = endCoords.pageY - startCoords.pageY;
        var allowSwipe = false;
        if (this.swipeDirection) {
          allowSwipe = true;
        } else {
          if (Math.abs(distanceX) > 15) {
            this.swipeDirection = 'horizontal';
            allowSwipe = true;
          } else if (Math.abs(distanceY) > 15) {
            this.swipeDirection = 'vertical';
            allowSwipe = true;
          }
        }
        if (!allowSwipe) {
          return;
        }
        var $currentSlide = this.getSlideItem(this.index);
        if (this.swipeDirection === 'horizontal') {
          e === null || e === void 0 ? void 0 : e.preventDefault();
          // reset opacity and transition duration
          this.outer.addClass('lg-dragging');
          // move current slide
          this.setTranslate($currentSlide, distanceX, 0);
          // move next and prev slide with current slide
          var width = $currentSlide.get().offsetWidth;
          var slideWidthAmount = width * 15 / 100;
          var gutter = slideWidthAmount - Math.abs(distanceX * 10 / 100);
          this.setTranslate(this.outer.find('.lg-prev-slide').first(), -width + distanceX - gutter, 0);
          this.setTranslate(this.outer.find('.lg-next-slide').first(), width + distanceX + gutter, 0);
        } else if (this.swipeDirection === 'vertical') {
          if (this.settings.swipeToClose) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            this.$container.addClass('lg-dragging-vertical');
            var opacity = 1 - Math.abs(distanceY) / window.innerHeight;
            this.$backdrop.css('opacity', opacity);
            var scale = 1 - Math.abs(distanceY) / (window.innerWidth * 2);
            this.setTranslate($currentSlide, 0, distanceY, scale, scale);
            if (Math.abs(distanceY) > 100) {
              this.outer.addClass('lg-hide-items').removeClass('lg-components-open');
            }
          }
        }
      };
      LightGallery.prototype.touchEnd = function (endCoords, startCoords, event) {
        var _this = this;
        var distance;
        // keep slide animation for any mode while dragg/swipe
        if (this.settings.mode !== 'lg-slide') {
          this.outer.addClass('lg-slide');
        }
        // set transition duration
        setTimeout(function () {
          _this.$container.removeClass('lg-dragging-vertical');
          _this.outer.removeClass('lg-dragging lg-hide-items').addClass('lg-components-open');
          var triggerClick = true;
          if (_this.swipeDirection === 'horizontal') {
            distance = endCoords.pageX - startCoords.pageX;
            var distanceAbs = Math.abs(endCoords.pageX - startCoords.pageX);
            if (distance < 0 && distanceAbs > _this.settings.swipeThreshold) {
              _this.goToNextSlide(true);
              triggerClick = false;
            } else if (distance > 0 && distanceAbs > _this.settings.swipeThreshold) {
              _this.goToPrevSlide(true);
              triggerClick = false;
            }
          } else if (_this.swipeDirection === 'vertical') {
            distance = Math.abs(endCoords.pageY - startCoords.pageY);
            if (_this.settings.closable && _this.settings.swipeToClose && distance > 100) {
              _this.closeGallery();
              return;
            } else {
              _this.$backdrop.css('opacity', 1);
            }
          }
          _this.outer.find('.lg-item').removeAttr('style');
          if (triggerClick && Math.abs(endCoords.pageX - startCoords.pageX) < 5) {
            // Trigger click if distance is less than 5 pix
            var target = $LG(event.target);
            if (_this.isPosterElement(target)) {
              _this.LGel.trigger(lGEvents$2.posterClick);
            }
          }
          _this.swipeDirection = undefined;
        });
        // remove slide class once drag/swipe is completed if mode is not slide
        setTimeout(function () {
          if (!_this.outer.hasClass('lg-dragging') && _this.settings.mode !== 'lg-slide') {
            _this.outer.removeClass('lg-slide');
          }
        }, this.settings.speed + 100);
      };
      LightGallery.prototype.enableSwipe = function () {
        var _this = this;
        var startCoords = {};
        var endCoords = {};
        var isMoved = false;
        var isSwiping = false;
        if (this.settings.enableSwipe) {
          this.$inner.on('touchstart.lg', function (e) {
            _this.dragOrSwipeEnabled = true;
            var $item = _this.getSlideItem(_this.index);
            if (($LG(e.target).hasClass('lg-item') || $item.get().contains(e.target)) && !_this.outer.hasClass('lg-zoomed') && !_this.lgBusy && e.touches.length === 1) {
              isSwiping = true;
              _this.touchAction = 'swipe';
              _this.manageSwipeClass();
              startCoords = {
                pageX: e.touches[0].pageX,
                pageY: e.touches[0].pageY
              };
            }
          });
          this.$inner.on('touchmove.lg', function (e) {
            if (isSwiping && _this.touchAction === 'swipe' && e.touches.length === 1) {
              endCoords = {
                pageX: e.touches[0].pageX,
                pageY: e.touches[0].pageY
              };
              _this.touchMove(startCoords, endCoords, e);
              isMoved = true;
            }
          });
          this.$inner.on('touchend.lg', function (event) {
            if (_this.touchAction === 'swipe') {
              if (isMoved) {
                isMoved = false;
                _this.touchEnd(endCoords, startCoords, event);
              } else if (isSwiping) {
                var target = $LG(event.target);
                if (_this.isPosterElement(target)) {
                  _this.LGel.trigger(lGEvents$2.posterClick);
                }
              }
              _this.touchAction = undefined;
              isSwiping = false;
            }
          });
        }
      };
      LightGallery.prototype.enableDrag = function () {
        var _this = this;
        var startCoords = {};
        var endCoords = {};
        var isDraging = false;
        var isMoved = false;
        if (this.settings.enableDrag) {
          this.outer.on('mousedown.lg', function (e) {
            _this.dragOrSwipeEnabled = true;
            var $item = _this.getSlideItem(_this.index);
            if ($LG(e.target).hasClass('lg-item') || $item.get().contains(e.target)) {
              if (!_this.outer.hasClass('lg-zoomed') && !_this.lgBusy) {
                e.preventDefault();
                if (!_this.lgBusy) {
                  _this.manageSwipeClass();
                  startCoords = {
                    pageX: e.pageX,
                    pageY: e.pageY
                  };
                  isDraging = true;
                  // ** Fix for webkit cursor issue https://code.google.com/p/chromium/issues/detail?id=26723
                  _this.outer.get().scrollLeft += 1;
                  _this.outer.get().scrollLeft -= 1;
                  // *
                  _this.outer.removeClass('lg-grab').addClass('lg-grabbing');
                  _this.LGel.trigger(lGEvents$2.dragStart);
                }
              }
            }
          });
          $LG(window).on("mousemove.lg.global" + this.lgId, function (e) {
            if (isDraging && _this.lgOpened) {
              isMoved = true;
              endCoords = {
                pageX: e.pageX,
                pageY: e.pageY
              };
              _this.touchMove(startCoords, endCoords);
              _this.LGel.trigger(lGEvents$2.dragMove);
            }
          });
          $LG(window).on("mouseup.lg.global" + this.lgId, function (event) {
            if (!_this.lgOpened) {
              return;
            }
            var target = $LG(event.target);
            if (isMoved) {
              isMoved = false;
              _this.touchEnd(endCoords, startCoords, event);
              _this.LGel.trigger(lGEvents$2.dragEnd);
            } else if (_this.isPosterElement(target)) {
              _this.LGel.trigger(lGEvents$2.posterClick);
            }
            // Prevent execution on click
            if (isDraging) {
              isDraging = false;
              _this.outer.removeClass('lg-grabbing').addClass('lg-grab');
            }
          });
        }
      };
      LightGallery.prototype.triggerPosterClick = function () {
        var _this = this;
        this.$inner.on('click.lg', function (event) {
          if (!_this.dragOrSwipeEnabled && _this.isPosterElement($LG(event.target))) {
            _this.LGel.trigger(lGEvents$2.posterClick);
          }
        });
      };
      LightGallery.prototype.manageSwipeClass = function () {
        var _touchNext = this.index + 1;
        var _touchPrev = this.index - 1;
        if (this.settings.loop && this.galleryItems.length > 2) {
          if (this.index === 0) {
            _touchPrev = this.galleryItems.length - 1;
          } else if (this.index === this.galleryItems.length - 1) {
            _touchNext = 0;
          }
        }
        this.outer.find('.lg-item').removeClass('lg-next-slide lg-prev-slide');
        if (_touchPrev > -1) {
          this.getSlideItem(_touchPrev).addClass('lg-prev-slide');
        }
        this.getSlideItem(_touchNext).addClass('lg-next-slide');
      };
      /**
       * Go to next slide
       * @param {Boolean} fromTouch - true if slide function called via touch event
       * @category lGPublicMethods
       * @example
       *  const plugin = lightGallery();
       *  plugin.goToNextSlide();
       * @see <a href="/demos/methods/">Demo</a>
       */
      LightGallery.prototype.goToNextSlide = function (fromTouch) {
        var _this = this;
        var _loop = this.settings.loop;
        if (fromTouch && this.galleryItems.length < 3) {
          _loop = false;
        }
        if (!this.lgBusy) {
          if (this.index + 1 < this.galleryItems.length) {
            this.index++;
            this.LGel.trigger(lGEvents$2.beforeNextSlide, {
              index: this.index
            });
            this.slide(this.index, !!fromTouch, false, 'next');
          } else {
            if (_loop) {
              this.index = 0;
              this.LGel.trigger(lGEvents$2.beforeNextSlide, {
                index: this.index
              });
              this.slide(this.index, !!fromTouch, false, 'next');
            } else if (this.settings.slideEndAnimation && !fromTouch) {
              this.outer.addClass('lg-right-end');
              setTimeout(function () {
                _this.outer.removeClass('lg-right-end');
              }, 400);
            }
          }
        }
      };
      /**
       * Go to previous slides
       * @param {Boolean} fromTouch - true if slide function called via touch event
       * @category lGPublicMethods
       * @example
       *  const plugin = lightGallery({});
       *  plugin.goToPrevSlide();
       * @see <a href="/demos/methods/">Demo</a>
       *
       */
      LightGallery.prototype.goToPrevSlide = function (fromTouch) {
        var _this = this;
        var _loop = this.settings.loop;
        if (fromTouch && this.galleryItems.length < 3) {
          _loop = false;
        }
        if (!this.lgBusy) {
          if (this.index > 0) {
            this.index--;
            this.LGel.trigger(lGEvents$2.beforePrevSlide, {
              index: this.index,
              fromTouch: fromTouch
            });
            this.slide(this.index, !!fromTouch, false, 'prev');
          } else {
            if (_loop) {
              this.index = this.galleryItems.length - 1;
              this.LGel.trigger(lGEvents$2.beforePrevSlide, {
                index: this.index,
                fromTouch: fromTouch
              });
              this.slide(this.index, !!fromTouch, false, 'prev');
            } else if (this.settings.slideEndAnimation && !fromTouch) {
              this.outer.addClass('lg-left-end');
              setTimeout(function () {
                _this.outer.removeClass('lg-left-end');
              }, 400);
            }
          }
        }
      };
      LightGallery.prototype.keyPress = function () {
        var _this = this;
        $LG(window).on("keydown.lg.global" + this.lgId, function (e) {
          if (_this.lgOpened && _this.settings.escKey === true && e.keyCode === 27) {
            e.preventDefault();
            if (_this.settings.allowMediaOverlap && _this.outer.hasClass('lg-can-toggle') && _this.outer.hasClass('lg-components-open')) {
              _this.outer.removeClass('lg-components-open');
            } else {
              _this.closeGallery();
            }
          }
          if (_this.lgOpened && _this.galleryItems.length > 1) {
            if (e.keyCode === 37) {
              e.preventDefault();
              _this.goToPrevSlide();
            }
            if (e.keyCode === 39) {
              e.preventDefault();
              _this.goToNextSlide();
            }
          }
        });
      };
      LightGallery.prototype.arrow = function () {
        var _this = this;
        this.getElementById('lg-prev').on('click.lg', function () {
          _this.goToPrevSlide();
        });
        this.getElementById('lg-next').on('click.lg', function () {
          _this.goToNextSlide();
        });
      };
      LightGallery.prototype.arrowDisable = function (index) {
        // Disable arrows if settings.hideControlOnEnd is true
        if (!this.settings.loop && this.settings.hideControlOnEnd) {
          var $prev = this.getElementById('lg-prev');
          var $next = this.getElementById('lg-next');
          if (index + 1 === this.galleryItems.length) {
            $next.attr('disabled', 'disabled').addClass('disabled');
          } else {
            $next.removeAttr('disabled').removeClass('disabled');
          }
          if (index === 0) {
            $prev.attr('disabled', 'disabled').addClass('disabled');
          } else {
            $prev.removeAttr('disabled').removeClass('disabled');
          }
        }
      };
      LightGallery.prototype.setTranslate = function ($el, xValue, yValue, scaleX, scaleY) {
        if (scaleX === void 0) {
          scaleX = 1;
        }
        if (scaleY === void 0) {
          scaleY = 1;
        }
        $el.css('transform', 'translate3d(' + xValue + 'px, ' + yValue + 'px, 0px) scale3d(' + scaleX + ', ' + scaleY + ', 1)');
      };
      LightGallery.prototype.mousewheel = function () {
        var _this = this;
        var lastCall = 0;
        this.outer.on('wheel.lg', function (e) {
          if (!e.deltaY || _this.galleryItems.length < 2) {
            return;
          }
          e.preventDefault();
          var now = new Date().getTime();
          if (now - lastCall < 1000) {
            return;
          }
          lastCall = now;
          if (e.deltaY > 0) {
            _this.goToNextSlide();
          } else if (e.deltaY < 0) {
            _this.goToPrevSlide();
          }
        });
      };
      LightGallery.prototype.isSlideElement = function (target) {
        return target.hasClass('lg-outer') || target.hasClass('lg-item') || target.hasClass('lg-img-wrap') || target.hasClass('lg-img-rotate');
      };
      LightGallery.prototype.isPosterElement = function (target) {
        var playButton = this.getSlideItem(this.index).find('.lg-video-play-button').get();
        return target.hasClass('lg-video-poster') || target.hasClass('lg-video-play-button') || playButton && playButton.contains(target.get());
      };
      /**
       * Maximize minimize inline gallery.
       * @category lGPublicMethods
       */
      LightGallery.prototype.toggleMaximize = function () {
        var _this = this;
        this.getElementById('lg-maximize').on('click.lg', function () {
          _this.$container.toggleClass('lg-inline');
          _this.refreshOnResize();
        });
      };
      LightGallery.prototype.invalidateItems = function () {
        for (var index = 0; index < this.items.length; index++) {
          var element = this.items[index];
          var $element = $LG(element);
          $element.off("click.lgcustom-item-" + $element.attr('data-lg-id'));
        }
      };
      LightGallery.prototype.trapFocus = function () {
        var _this = this;
        this.$container.get().focus({
          preventScroll: true
        });
        $LG(window).on("keydown.lg.global" + this.lgId, function (e) {
          if (!_this.lgOpened) {
            return;
          }
          var isTabPressed = e.key === 'Tab' || e.keyCode === 9;
          if (!isTabPressed) {
            return;
          }
          var focusableEls = utils$1.getFocusableElements(_this.$container.get());
          var firstFocusableEl = focusableEls[0];
          var lastFocusableEl = focusableEls[focusableEls.length - 1];
          if (e.shiftKey) {
            if (document.activeElement === firstFocusableEl) {
              lastFocusableEl.focus();
              e.preventDefault();
            }
          } else {
            if (document.activeElement === lastFocusableEl) {
              firstFocusableEl.focus();
              e.preventDefault();
            }
          }
        });
      };
      LightGallery.prototype.manageCloseGallery = function () {
        var _this = this;
        if (!this.settings.closable) return;
        var mousedown = false;
        this.getElementById('lg-close').on('click.lg', function () {
          _this.closeGallery();
        });
        if (this.settings.closeOnTap) {
          // If you drag the slide and release outside gallery gets close on chrome
          // for preventing this check mousedown and mouseup happened on .lg-item or lg-outer
          this.outer.on('mousedown.lg', function (e) {
            var target = $LG(e.target);
            if (_this.isSlideElement(target)) {
              mousedown = true;
            } else {
              mousedown = false;
            }
          });
          this.outer.on('mousemove.lg', function () {
            mousedown = false;
          });
          this.outer.on('mouseup.lg', function (e) {
            var target = $LG(e.target);
            if (_this.isSlideElement(target) && mousedown) {
              if (!_this.outer.hasClass('lg-dragging')) {
                _this.closeGallery();
              }
            }
          });
        }
      };
      /**
       * Close lightGallery if it is opened.
       *
       * @description If closable is false in the settings, you need to pass true via closeGallery method to force close gallery
       * @return returns the estimated time to close gallery completely including the close animation duration
       * @category lGPublicMethods
       * @example
       *  const plugin = lightGallery();
       *  plugin.closeGallery();
       *
       */
      LightGallery.prototype.closeGallery = function (force) {
        var _this = this;
        if (!this.lgOpened || !this.settings.closable && !force) {
          return 0;
        }
        this.LGel.trigger(lGEvents$2.beforeClose);
        if (this.settings.resetScrollPosition && !this.settings.hideScrollbar) {
          $LG(window).scrollTop(this.prevScrollTop);
        }
        var currentItem = this.items[this.index];
        var transform;
        if (this.zoomFromOrigin && currentItem) {
          var _a = this.mediaContainerPosition,
            top_4 = _a.top,
            bottom = _a.bottom;
          var _b = this.galleryItems[this.index],
            __slideVideoInfo = _b.__slideVideoInfo,
            poster = _b.poster;
          var imageSize = utils$1.getSize(currentItem, this.outer, top_4 + bottom, __slideVideoInfo && poster && this.settings.videoMaxSize);
          transform = utils$1.getTransform(currentItem, this.outer, top_4, bottom, imageSize);
        }
        if (this.zoomFromOrigin && transform) {
          this.outer.addClass('lg-closing lg-zoom-from-image');
          this.getSlideItem(this.index).addClass('lg-start-end-progress').css('transition-duration', this.settings.startAnimationDuration + 'ms').css('transform', transform);
        } else {
          this.outer.addClass('lg-hide-items');
          // lg-zoom-from-image is used for setting the opacity to 1 if zoomFromOrigin is true
          // If the closing item doesn't have the lg-size attribute, remove this class to avoid the closing css conflicts
          this.outer.removeClass('lg-zoom-from-image');
        }
        // Unbind all events added by lightGallery
        // @todo
        //this.$el.off('.lg.tm');
        this.destroyModules();
        this.lGalleryOn = false;
        this.isDummyImageRemoved = false;
        this.zoomFromOrigin = this.settings.zoomFromOrigin;
        clearTimeout(this.hideBarTimeout);
        this.hideBarTimeout = false;
        $LG('html').removeClass('lg-on');
        this.outer.removeClass('lg-visible lg-components-open');
        // Resetting opacity to 0 isd required as  vertical swipe to close function adds inline opacity.
        this.$backdrop.removeClass('in').css('opacity', 0);
        var removeTimeout = this.zoomFromOrigin && transform ? Math.max(this.settings.startAnimationDuration, this.settings.backdropDuration) : this.settings.backdropDuration;
        this.$container.removeClass('lg-show-in');
        // Once the closign animation is completed and gallery is invisible
        setTimeout(function () {
          if (_this.zoomFromOrigin && transform) {
            _this.outer.removeClass('lg-zoom-from-image');
          }
          _this.$container.removeClass('lg-show');
          // Reset scrollbar
          _this.resetScrollBar();
          // Need to remove inline opacity as it is used in the stylesheet as well
          _this.$backdrop.removeAttr('style').css('transition-duration', _this.settings.backdropDuration + 'ms');
          _this.outer.removeClass("lg-closing " + _this.settings.startClass);
          _this.getSlideItem(_this.index).removeClass('lg-start-end-progress');
          _this.$inner.empty();
          if (_this.lgOpened) {
            _this.LGel.trigger(lGEvents$2.afterClose, {
              instance: _this
            });
          }
          if (_this.$container.get()) {
            _this.$container.get().blur();
          }
          _this.lgOpened = false;
        }, removeTimeout + 100);
        return removeTimeout + 100;
      };
      LightGallery.prototype.initModules = function () {
        this.plugins.forEach(function (module) {
          try {
            module.init();
          } catch (err) {
            console.warn("lightGallery:- make sure lightGallery module is properly initiated");
          }
        });
      };
      LightGallery.prototype.destroyModules = function (destroy) {
        this.plugins.forEach(function (module) {
          try {
            if (destroy) {
              module.destroy();
            } else {
              module.closeGallery && module.closeGallery();
            }
          } catch (err) {
            console.warn("lightGallery:- make sure lightGallery module is properly destroyed");
          }
        });
      };
      /**
       * Refresh lightGallery with new set of children.
       *
       * @description This is useful to update the gallery when the child elements are changed without calling destroy method.
       *
       * If you are using dynamic mode, you can pass the modified array of dynamicEl as the first parameter to refresh the dynamic gallery
       * @see <a href="/demos/dynamic-mode/">Demo</a>
       * @category lGPublicMethods
       * @example
       *  const plugin = lightGallery();
       *  // Delete or add children, then call
       *  plugin.refresh();
       *
       */
      LightGallery.prototype.refresh = function (galleryItems) {
        if (!this.settings.dynamic) {
          this.invalidateItems();
        }
        if (galleryItems) {
          this.galleryItems = galleryItems;
        } else {
          this.galleryItems = this.getItems();
        }
        this.updateControls();
        this.openGalleryOnItemClick();
        this.LGel.trigger(lGEvents$2.updateSlides);
      };
      LightGallery.prototype.updateControls = function () {
        this.addSlideVideoInfo(this.galleryItems);
        this.updateCounterTotal();
        this.manageSingleSlideClassName();
      };
      LightGallery.prototype.destroyGallery = function () {
        this.destroyModules(true);
        if (!this.settings.dynamic) {
          this.invalidateItems();
        }
        $LG(window).off(".lg.global" + this.lgId);
        this.LGel.off('.lg');
        this.$container.remove();
      };
      /**
       * Destroy lightGallery.
       * Destroy lightGallery and its plugin instances completely
       *
       * @description This method also calls CloseGallery function internally. Returns the time takes to completely close and destroy the instance.
       * In case if you want to re-initialize lightGallery right after destroying it, initialize it only once the destroy process is completed.
       * You can use refresh method most of the times.
       * @category lGPublicMethods
       * @example
       *  const plugin = lightGallery();
       *  plugin.destroy();
       *
       */
      LightGallery.prototype.destroy = function () {
        var closeTimeout = this.closeGallery(true);
        if (closeTimeout) {
          setTimeout(this.destroyGallery.bind(this), closeTimeout);
        } else {
          this.destroyGallery();
        }
        return closeTimeout;
      };
      return LightGallery;
    }();
    function lightGallery(el, options) {
      return new LightGallery(el, options);
    }

    /*!
     * lightgallery | 2.8.3 | March 1st 2025
     * http://www.lightgalleryjs.com/
     * Copyright (c) 2020 Sachin Neravath;
     * @license GPLv3
     */

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign$3 = function () {
      __assign$3 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
      return __assign$3.apply(this, arguments);
    };
    var zoomSettings = {
      scale: 1,
      zoom: true,
      infiniteZoom: true,
      actualSize: true,
      showZoomInOutIcons: false,
      actualSizeIcons: {
        zoomIn: 'lg-zoom-in',
        zoomOut: 'lg-zoom-out'
      },
      enableZoomAfter: 300,
      zoomPluginStrings: {
        zoomIn: 'Zoom in',
        zoomOut: 'Zoom out',
        viewActualSize: 'View actual size'
      }
    };

    /**
     * List of lightGallery events
     * All events should be documented here
     * Below interfaces are used to build the website documentations
     * */
    var lGEvents$1 = {
      afterAppendSlide: 'lgAfterAppendSlide',
      init: 'lgInit',
      hasVideo: 'lgHasVideo',
      containerResize: 'lgContainerResize',
      updateSlides: 'lgUpdateSlides',
      afterAppendSubHtml: 'lgAfterAppendSubHtml',
      beforeOpen: 'lgBeforeOpen',
      afterOpen: 'lgAfterOpen',
      slideItemLoad: 'lgSlideItemLoad',
      beforeSlide: 'lgBeforeSlide',
      afterSlide: 'lgAfterSlide',
      posterClick: 'lgPosterClick',
      dragStart: 'lgDragStart',
      dragMove: 'lgDragMove',
      dragEnd: 'lgDragEnd',
      beforeNextSlide: 'lgBeforeNextSlide',
      beforePrevSlide: 'lgBeforePrevSlide',
      beforeClose: 'lgBeforeClose',
      afterClose: 'lgAfterClose',
      rotateLeft: 'lgRotateLeft',
      rotateRight: 'lgRotateRight',
      flipHorizontal: 'lgFlipHorizontal',
      flipVertical: 'lgFlipVertical',
      autoplay: 'lgAutoplay',
      autoplayStart: 'lgAutoplayStart',
      autoplayStop: 'lgAutoplayStop'
    };
    var ZOOM_TRANSITION_DURATION = 500;
    var Zoom = /** @class */function () {
      function Zoom(instance, $LG) {
        // get lightGallery core plugin instance
        this.core = instance;
        this.$LG = $LG;
        this.settings = __assign$3(__assign$3({}, zoomSettings), this.core.settings);
        return this;
      }
      // Append Zoom controls. Actual size, Zoom-in, Zoom-out
      Zoom.prototype.buildTemplates = function () {
        var zoomIcons = this.settings.showZoomInOutIcons ? "<button id=\"" + this.core.getIdName('lg-zoom-in') + "\" type=\"button\" aria-label=\"" + this.settings.zoomPluginStrings['zoomIn'] + "\" class=\"lg-zoom-in lg-icon\"></button><button id=\"" + this.core.getIdName('lg-zoom-out') + "\" type=\"button\" aria-label=\"" + this.settings.zoomPluginStrings['zoomOut'] + "\" class=\"lg-zoom-out lg-icon\"></button>" : '';
        if (this.settings.actualSize) {
          zoomIcons += "<button id=\"" + this.core.getIdName('lg-actual-size') + "\" type=\"button\" aria-label=\"" + this.settings.zoomPluginStrings['viewActualSize'] + "\" class=\"" + this.settings.actualSizeIcons.zoomIn + " lg-icon\"></button>";
        }
        this.core.outer.addClass('lg-use-transition-for-zoom');
        this.core.$toolbar.first().append(zoomIcons);
      };
      /**
       * @desc Enable zoom option only once the image is completely loaded
       * If zoomFromOrigin is true, Zoom is enabled once the dummy image has been inserted
       *
       * Zoom styles are defined under lg-zoomable CSS class.
       */
      Zoom.prototype.enableZoom = function (event) {
        var _this = this;
        // delay will be 0 except first time
        var _speed = this.settings.enableZoomAfter + event.detail.delay;
        // set _speed value 0 if gallery opened from direct url and if it is first slide
        if (this.$LG('body').first().hasClass('lg-from-hash') && event.detail.delay) {
          // will execute only once
          _speed = 0;
        } else {
          // Remove lg-from-hash to enable starting animation.
          this.$LG('body').first().removeClass('lg-from-hash');
        }
        this.zoomableTimeout = setTimeout(function () {
          if (!_this.isImageSlide(_this.core.index)) {
            return;
          }
          _this.core.getSlideItem(event.detail.index).addClass('lg-zoomable');
          if (event.detail.index === _this.core.index) {
            _this.setZoomEssentials();
          }
        }, _speed + 30);
      };
      Zoom.prototype.enableZoomOnSlideItemLoad = function () {
        // Add zoomable class
        this.core.LGel.on(lGEvents$1.slideItemLoad + ".zoom", this.enableZoom.bind(this));
      };
      Zoom.prototype.getDragCords = function (e) {
        return {
          x: e.pageX,
          y: e.pageY
        };
      };
      Zoom.prototype.getSwipeCords = function (e) {
        var x = e.touches[0].pageX;
        var y = e.touches[0].pageY;
        return {
          x: x,
          y: y
        };
      };
      Zoom.prototype.getDragAllowedAxises = function (scale, scaleDiff) {
        if (!this.containerRect) {
          return {
            allowX: false,
            allowY: false
          };
        }
        var $image = this.core.getSlideItem(this.core.index).find('.lg-image').first().get();
        var height = 0;
        var width = 0;
        var rect = $image.getBoundingClientRect();
        if (scale) {
          height = $image.offsetHeight * scale;
          width = $image.offsetWidth * scale;
        } else if (scaleDiff) {
          height = rect.height + scaleDiff * rect.height;
          width = rect.width + scaleDiff * rect.width;
        } else {
          height = rect.height;
          width = rect.width;
        }
        var allowY = height > this.containerRect.height;
        var allowX = width > this.containerRect.width;
        return {
          allowX: allowX,
          allowY: allowY
        };
      };
      Zoom.prototype.setZoomEssentials = function () {
        this.containerRect = this.core.$content.get().getBoundingClientRect();
      };
      /**
       * @desc Image zoom
       * Translate the wrap and scale the image to get better user experience
       *
       * @param {String} scale - Zoom decrement/increment value
       */
      Zoom.prototype.zoomImage = function (scale, scaleDiff, reposition, resetToMax) {
        if (Math.abs(scaleDiff) <= 0) return;
        var offsetX = this.containerRect.width / 2 + this.containerRect.left;
        var offsetY = this.containerRect.height / 2 + this.containerRect.top + this.scrollTop;
        var originalX;
        var originalY;
        if (scale === 1) {
          this.positionChanged = false;
        }
        var dragAllowedAxises = this.getDragAllowedAxises(0, scaleDiff);
        var allowY = dragAllowedAxises.allowY,
          allowX = dragAllowedAxises.allowX;
        if (this.positionChanged) {
          originalX = this.left / (this.scale - scaleDiff);
          originalY = this.top / (this.scale - scaleDiff);
          this.pageX = offsetX - originalX;
          this.pageY = offsetY - originalY;
          this.positionChanged = false;
        }
        var possibleSwipeCords = this.getPossibleSwipeDragCords(scaleDiff);
        var x;
        var y;
        var _x = offsetX - this.pageX;
        var _y = offsetY - this.pageY;
        if (scale - scaleDiff > 1) {
          var scaleVal = (scale - scaleDiff) / Math.abs(scaleDiff);
          _x = (scaleDiff < 0 ? -_x : _x) + this.left * (scaleVal + (scaleDiff < 0 ? -1 : 1));
          _y = (scaleDiff < 0 ? -_y : _y) + this.top * (scaleVal + (scaleDiff < 0 ? -1 : 1));
          x = _x / scaleVal;
          y = _y / scaleVal;
        } else {
          var scaleVal = (scale - scaleDiff) * scaleDiff;
          x = _x * scaleVal;
          y = _y * scaleVal;
        }
        if (reposition) {
          if (allowX) {
            if (this.isBeyondPossibleLeft(x, possibleSwipeCords.minX)) {
              x = possibleSwipeCords.minX;
            } else if (this.isBeyondPossibleRight(x, possibleSwipeCords.maxX)) {
              x = possibleSwipeCords.maxX;
            }
          } else {
            if (scale > 1) {
              if (x < possibleSwipeCords.minX) {
                x = possibleSwipeCords.minX;
              } else if (x > possibleSwipeCords.maxX) {
                x = possibleSwipeCords.maxX;
              }
            }
          }
          // @todo fix this
          if (allowY) {
            if (this.isBeyondPossibleTop(y, possibleSwipeCords.minY)) {
              y = possibleSwipeCords.minY;
            } else if (this.isBeyondPossibleBottom(y, possibleSwipeCords.maxY)) {
              y = possibleSwipeCords.maxY;
            }
          } else {
            // If the translate value based on index of beyond the viewport, utilize the available space to prevent image being cut out
            if (scale > 1) {
              //If image goes beyond viewport top, use the minim possible translate value
              if (y < possibleSwipeCords.minY) {
                y = possibleSwipeCords.minY;
              } else if (y > possibleSwipeCords.maxY) {
                y = possibleSwipeCords.maxY;
              }
            }
          }
        }
        this.setZoomStyles({
          x: x,
          y: y,
          scale: scale
        });
        this.left = x;
        this.top = y;
        if (resetToMax) {
          this.setZoomImageSize();
        }
      };
      Zoom.prototype.resetImageTranslate = function (index) {
        if (!this.isImageSlide(index)) {
          return;
        }
        var $image = this.core.getSlideItem(index).find('.lg-image').first();
        this.imageReset = false;
        $image.removeClass('reset-transition reset-transition-y reset-transition-x');
        this.core.outer.removeClass('lg-actual-size');
        $image.css('width', 'auto').css('height', 'auto');
        setTimeout(function () {
          $image.removeClass('no-transition');
        }, 10);
      };
      Zoom.prototype.setZoomImageSize = function () {
        var _this = this;
        var $image = this.core.getSlideItem(this.core.index).find('.lg-image').first();
        setTimeout(function () {
          var actualSizeScale = _this.getCurrentImageActualSizeScale();
          if (_this.scale >= actualSizeScale) {
            $image.addClass('no-transition');
            _this.imageReset = true;
          }
        }, ZOOM_TRANSITION_DURATION);
        setTimeout(function () {
          var actualSizeScale = _this.getCurrentImageActualSizeScale();
          if (_this.scale >= actualSizeScale) {
            var dragAllowedAxises = _this.getDragAllowedAxises(_this.scale);
            $image.css('width', $image.get().naturalWidth + 'px').css('height', $image.get().naturalHeight + 'px');
            _this.core.outer.addClass('lg-actual-size');
            if (dragAllowedAxises.allowX && dragAllowedAxises.allowY) {
              $image.addClass('reset-transition');
            } else if (dragAllowedAxises.allowX && !dragAllowedAxises.allowY) {
              $image.addClass('reset-transition-x');
            } else if (!dragAllowedAxises.allowX && dragAllowedAxises.allowY) {
              $image.addClass('reset-transition-y');
            }
          }
        }, ZOOM_TRANSITION_DURATION + 50);
      };
      /**
       * @desc apply scale3d to image and translate to image wrap
       * @param {style} X,Y and scale
       */
      Zoom.prototype.setZoomStyles = function (style) {
        var $imageWrap = this.core.getSlideItem(this.core.index).find('.lg-img-wrap').first();
        var $image = this.core.getSlideItem(this.core.index).find('.lg-image').first();
        var $dummyImage = this.core.outer.find('.lg-current .lg-dummy-img').first();
        this.scale = style.scale;
        $image.css('transform', 'scale3d(' + style.scale + ', ' + style.scale + ', 1)');
        $dummyImage.css('transform', 'scale3d(' + style.scale + ', ' + style.scale + ', 1)');
        var transform = 'translate3d(' + style.x + 'px, ' + style.y + 'px, 0)';
        $imageWrap.css('transform', transform);
      };
      /**
       * @param index - Index of the current slide
       * @param event - event will be available only if the function is called on clicking/taping the imags
       */
      Zoom.prototype.setActualSize = function (index, event) {
        var _this = this;
        if (this.zoomInProgress) {
          return;
        }
        this.zoomInProgress = true;
        var currentItem = this.core.galleryItems[this.core.index];
        this.resetImageTranslate(index);
        setTimeout(function () {
          // Allow zoom only on image
          if (!currentItem.src || _this.core.outer.hasClass('lg-first-slide-loading')) {
            return;
          }
          var scale = _this.getCurrentImageActualSizeScale();
          var prevScale = _this.scale;
          if (_this.core.outer.hasClass('lg-zoomed')) {
            _this.scale = 1;
          } else {
            _this.scale = _this.getScale(scale);
          }
          _this.setPageCords(event);
          _this.beginZoom(_this.scale);
          _this.zoomImage(_this.scale, _this.scale - prevScale, true, true);
        }, 50);
        setTimeout(function () {
          _this.core.outer.removeClass('lg-grabbing').addClass('lg-grab');
        }, 60);
        setTimeout(function () {
          _this.zoomInProgress = false;
        }, ZOOM_TRANSITION_DURATION + 110);
      };
      Zoom.prototype.getNaturalWidth = function (index) {
        var $image = this.core.getSlideItem(index).find('.lg-image').first();
        var naturalWidth = this.core.galleryItems[index].width;
        return naturalWidth ? parseFloat(naturalWidth) : $image.get().naturalWidth;
      };
      Zoom.prototype.getActualSizeScale = function (naturalWidth, width) {
        var _scale;
        var scale;
        if (naturalWidth >= width) {
          _scale = naturalWidth / width;
          scale = _scale || 2;
        } else {
          scale = 1;
        }
        return scale;
      };
      Zoom.prototype.getCurrentImageActualSizeScale = function () {
        var $image = this.core.getSlideItem(this.core.index).find('.lg-image').first();
        var width = $image.get().offsetWidth;
        var naturalWidth = this.getNaturalWidth(this.core.index) || width;
        return this.getActualSizeScale(naturalWidth, width);
      };
      Zoom.prototype.getPageCords = function (event) {
        var cords = {};
        if (event) {
          cords.x = event.pageX || event.touches[0].pageX;
          cords.y = event.pageY || event.touches[0].pageY;
        } else {
          var containerRect = this.core.$content.get().getBoundingClientRect();
          cords.x = containerRect.width / 2 + containerRect.left;
          cords.y = containerRect.height / 2 + this.scrollTop + containerRect.top;
        }
        return cords;
      };
      Zoom.prototype.setPageCords = function (event) {
        var pageCords = this.getPageCords(event);
        this.pageX = pageCords.x;
        this.pageY = pageCords.y;
      };
      Zoom.prototype.manageActualPixelClassNames = function () {
        var $actualSize = this.core.getElementById('lg-actual-size');
        $actualSize.removeClass(this.settings.actualSizeIcons.zoomIn).addClass(this.settings.actualSizeIcons.zoomOut);
      };
      // If true, zoomed - in else zoomed out
      Zoom.prototype.beginZoom = function (scale) {
        this.core.outer.removeClass('lg-zoom-drag-transition lg-zoom-dragging');
        if (scale > 1) {
          this.core.outer.addClass('lg-zoomed');
          this.manageActualPixelClassNames();
        } else {
          this.resetZoom();
        }
        return scale > 1;
      };
      Zoom.prototype.getScale = function (scale) {
        var actualSizeScale = this.getCurrentImageActualSizeScale();
        if (scale < 1) {
          scale = 1;
        } else if (scale > actualSizeScale) {
          scale = actualSizeScale;
        }
        return scale;
      };
      Zoom.prototype.init = function () {
        var _this = this;
        if (!this.settings.zoom) {
          return;
        }
        this.buildTemplates();
        this.enableZoomOnSlideItemLoad();
        var tapped = null;
        this.core.outer.on('dblclick.lg', function (event) {
          if (!_this.$LG(event.target).hasClass('lg-image')) {
            return;
          }
          _this.setActualSize(_this.core.index, event);
        });
        this.core.outer.on('touchstart.lg', function (event) {
          var $target = _this.$LG(event.target);
          if (event.touches.length === 1 && $target.hasClass('lg-image')) {
            if (!tapped) {
              tapped = setTimeout(function () {
                tapped = null;
              }, 300);
            } else {
              clearTimeout(tapped);
              tapped = null;
              event.preventDefault();
              _this.setActualSize(_this.core.index, event);
            }
          }
        });
        this.core.LGel.on(lGEvents$1.containerResize + ".zoom " + lGEvents$1.rotateRight + ".zoom " + lGEvents$1.rotateLeft + ".zoom " + lGEvents$1.flipHorizontal + ".zoom " + lGEvents$1.flipVertical + ".zoom", function () {
          if (!_this.core.lgOpened || !_this.isImageSlide(_this.core.index) || _this.core.touchAction) {
            return;
          }
          var _LGel = _this.core.getSlideItem(_this.core.index).find('.lg-img-wrap').first();
          _this.top = 0;
          _this.left = 0;
          _this.setZoomEssentials();
          _this.setZoomSwipeStyles(_LGel, {
            x: 0,
            y: 0
          });
          _this.positionChanged = true;
        });
        // Update zoom on resize and orientationchange
        this.$LG(window).on("scroll.lg.zoom.global" + this.core.lgId, function () {
          if (!_this.core.lgOpened) return;
          _this.scrollTop = _this.$LG(window).scrollTop();
        });
        this.core.getElementById('lg-zoom-out').on('click.lg', function () {
          // Allow zoom only on image
          if (!_this.isImageSlide(_this.core.index)) {
            return;
          }
          var timeout = 0;
          if (_this.imageReset) {
            _this.resetImageTranslate(_this.core.index);
            timeout = 50;
          }
          setTimeout(function () {
            var scale = _this.scale - _this.settings.scale;
            if (scale < 1) {
              scale = 1;
            }
            _this.beginZoom(scale);
            _this.zoomImage(scale, -_this.settings.scale, true, !_this.settings.infiniteZoom);
          }, timeout);
        });
        this.core.getElementById('lg-zoom-in').on('click.lg', function () {
          _this.zoomIn();
        });
        this.core.getElementById('lg-actual-size').on('click.lg', function () {
          _this.setActualSize(_this.core.index);
        });
        this.core.LGel.on(lGEvents$1.beforeOpen + ".zoom", function () {
          _this.core.outer.find('.lg-item').removeClass('lg-zoomable');
        });
        this.core.LGel.on(lGEvents$1.afterOpen + ".zoom", function () {
          _this.scrollTop = _this.$LG(window).scrollTop();
          // Set the initial value center
          _this.pageX = _this.core.outer.width() / 2;
          _this.pageY = _this.core.outer.height() / 2 + _this.scrollTop;
          _this.scale = 1;
        });
        // Reset zoom on slide change
        this.core.LGel.on(lGEvents$1.afterSlide + ".zoom", function (event) {
          var prevIndex = event.detail.prevIndex;
          _this.scale = 1;
          _this.positionChanged = false;
          _this.zoomInProgress = false;
          _this.resetZoom(prevIndex);
          _this.resetImageTranslate(prevIndex);
          if (_this.isImageSlide(_this.core.index)) {
            _this.setZoomEssentials();
          }
        });
        // Drag option after zoom
        this.zoomDrag();
        this.pinchZoom();
        this.zoomSwipe();
        // Store the zoomable timeout value just to clear it while closing
        this.zoomableTimeout = false;
        this.positionChanged = false;
        this.zoomInProgress = false;
      };
      Zoom.prototype.zoomIn = function () {
        // Allow zoom only on image
        if (!this.isImageSlide(this.core.index)) {
          return;
        }
        var scale = this.scale + this.settings.scale;
        if (!this.settings.infiniteZoom) {
          scale = this.getScale(scale);
        }
        this.beginZoom(scale);
        this.zoomImage(scale, Math.min(this.settings.scale, scale - this.scale), true, !this.settings.infiniteZoom);
      };
      // Reset zoom effect
      Zoom.prototype.resetZoom = function (index) {
        this.core.outer.removeClass('lg-zoomed lg-zoom-drag-transition');
        var $actualSize = this.core.getElementById('lg-actual-size');
        var $item = this.core.getSlideItem(index !== undefined ? index : this.core.index);
        $actualSize.removeClass(this.settings.actualSizeIcons.zoomOut).addClass(this.settings.actualSizeIcons.zoomIn);
        $item.find('.lg-img-wrap').first().removeAttr('style');
        $item.find('.lg-image').first().removeAttr('style');
        this.scale = 1;
        this.left = 0;
        this.top = 0;
        // Reset pagx pagy values to center
        this.setPageCords();
      };
      Zoom.prototype.getTouchDistance = function (e) {
        return Math.sqrt((e.touches[0].pageX - e.touches[1].pageX) * (e.touches[0].pageX - e.touches[1].pageX) + (e.touches[0].pageY - e.touches[1].pageY) * (e.touches[0].pageY - e.touches[1].pageY));
      };
      Zoom.prototype.pinchZoom = function () {
        var _this = this;
        var startDist = 0;
        var pinchStarted = false;
        var initScale = 1;
        var prevScale = 0;
        var $item = this.core.getSlideItem(this.core.index);
        this.core.outer.on('touchstart.lg', function (e) {
          $item = _this.core.getSlideItem(_this.core.index);
          if (!_this.isImageSlide(_this.core.index)) {
            return;
          }
          if (e.touches.length === 2) {
            e.preventDefault();
            if (_this.core.outer.hasClass('lg-first-slide-loading')) {
              return;
            }
            initScale = _this.scale || 1;
            _this.core.outer.removeClass('lg-zoom-drag-transition lg-zoom-dragging');
            _this.setPageCords(e);
            _this.resetImageTranslate(_this.core.index);
            _this.core.touchAction = 'pinch';
            startDist = _this.getTouchDistance(e);
          }
        });
        this.core.$inner.on('touchmove.lg', function (e) {
          if (e.touches.length === 2 && _this.core.touchAction === 'pinch' && (_this.$LG(e.target).hasClass('lg-item') || $item.get().contains(e.target))) {
            e.preventDefault();
            var endDist = _this.getTouchDistance(e);
            var distance = startDist - endDist;
            if (!pinchStarted && Math.abs(distance) > 5) {
              pinchStarted = true;
            }
            if (pinchStarted) {
              prevScale = _this.scale;
              var _scale = Math.max(1, initScale + -distance * 0.02);
              _this.scale = Math.round((_scale + Number.EPSILON) * 100) / 100;
              var diff = _this.scale - prevScale;
              _this.zoomImage(_this.scale, Math.round((diff + Number.EPSILON) * 100) / 100, false, false);
            }
          }
        });
        this.core.$inner.on('touchend.lg', function (e) {
          if (_this.core.touchAction === 'pinch' && (_this.$LG(e.target).hasClass('lg-item') || $item.get().contains(e.target))) {
            pinchStarted = false;
            startDist = 0;
            if (_this.scale <= 1) {
              _this.resetZoom();
            } else {
              var actualSizeScale = _this.getCurrentImageActualSizeScale();
              if (_this.scale >= actualSizeScale) {
                var scaleDiff = actualSizeScale - _this.scale;
                if (scaleDiff === 0) {
                  scaleDiff = 0.01;
                }
                _this.zoomImage(actualSizeScale, scaleDiff, false, true);
              }
              _this.manageActualPixelClassNames();
              _this.core.outer.addClass('lg-zoomed');
            }
            _this.core.touchAction = undefined;
          }
        });
      };
      Zoom.prototype.touchendZoom = function (startCoords, endCoords, allowX, allowY, touchDuration) {
        var distanceXnew = endCoords.x - startCoords.x;
        var distanceYnew = endCoords.y - startCoords.y;
        var speedX = Math.abs(distanceXnew) / touchDuration + 1;
        var speedY = Math.abs(distanceYnew) / touchDuration + 1;
        if (speedX > 2) {
          speedX += 1;
        }
        if (speedY > 2) {
          speedY += 1;
        }
        distanceXnew = distanceXnew * speedX;
        distanceYnew = distanceYnew * speedY;
        var _LGel = this.core.getSlideItem(this.core.index).find('.lg-img-wrap').first();
        var distance = {};
        distance.x = this.left + distanceXnew;
        distance.y = this.top + distanceYnew;
        var possibleSwipeCords = this.getPossibleSwipeDragCords();
        if (Math.abs(distanceXnew) > 15 || Math.abs(distanceYnew) > 15) {
          if (allowY) {
            if (this.isBeyondPossibleTop(distance.y, possibleSwipeCords.minY)) {
              distance.y = possibleSwipeCords.minY;
            } else if (this.isBeyondPossibleBottom(distance.y, possibleSwipeCords.maxY)) {
              distance.y = possibleSwipeCords.maxY;
            }
          }
          if (allowX) {
            if (this.isBeyondPossibleLeft(distance.x, possibleSwipeCords.minX)) {
              distance.x = possibleSwipeCords.minX;
            } else if (this.isBeyondPossibleRight(distance.x, possibleSwipeCords.maxX)) {
              distance.x = possibleSwipeCords.maxX;
            }
          }
          if (allowY) {
            this.top = distance.y;
          } else {
            distance.y = this.top;
          }
          if (allowX) {
            this.left = distance.x;
          } else {
            distance.x = this.left;
          }
          this.setZoomSwipeStyles(_LGel, distance);
          this.positionChanged = true;
        }
      };
      Zoom.prototype.getZoomSwipeCords = function (startCoords, endCoords, allowX, allowY, possibleSwipeCords) {
        var distance = {};
        if (allowY) {
          distance.y = this.top + (endCoords.y - startCoords.y);
          if (this.isBeyondPossibleTop(distance.y, possibleSwipeCords.minY)) {
            var diffMinY = possibleSwipeCords.minY - distance.y;
            distance.y = possibleSwipeCords.minY - diffMinY / 6;
          } else if (this.isBeyondPossibleBottom(distance.y, possibleSwipeCords.maxY)) {
            var diffMaxY = distance.y - possibleSwipeCords.maxY;
            distance.y = possibleSwipeCords.maxY + diffMaxY / 6;
          }
        } else {
          distance.y = this.top;
        }
        if (allowX) {
          distance.x = this.left + (endCoords.x - startCoords.x);
          if (this.isBeyondPossibleLeft(distance.x, possibleSwipeCords.minX)) {
            var diffMinX = possibleSwipeCords.minX - distance.x;
            distance.x = possibleSwipeCords.minX - diffMinX / 6;
          } else if (this.isBeyondPossibleRight(distance.x, possibleSwipeCords.maxX)) {
            var difMaxX = distance.x - possibleSwipeCords.maxX;
            distance.x = possibleSwipeCords.maxX + difMaxX / 6;
          }
        } else {
          distance.x = this.left;
        }
        return distance;
      };
      Zoom.prototype.isBeyondPossibleLeft = function (x, minX) {
        return x >= minX;
      };
      Zoom.prototype.isBeyondPossibleRight = function (x, maxX) {
        return x <= maxX;
      };
      Zoom.prototype.isBeyondPossibleTop = function (y, minY) {
        return y >= minY;
      };
      Zoom.prototype.isBeyondPossibleBottom = function (y, maxY) {
        return y <= maxY;
      };
      Zoom.prototype.isImageSlide = function (index) {
        var currentItem = this.core.galleryItems[index];
        return this.core.getSlideType(currentItem) === 'image';
      };
      Zoom.prototype.getPossibleSwipeDragCords = function (scale) {
        var $image = this.core.getSlideItem(this.core.index).find('.lg-image').first();
        var bottom = this.core.mediaContainerPosition.bottom;
        var imgRect = $image.get().getBoundingClientRect();
        var imageHeight = imgRect.height;
        var imageWidth = imgRect.width;
        if (scale) {
          imageHeight = imageHeight + scale * imageHeight;
          imageWidth = imageWidth + scale * imageWidth;
        }
        var minY = (imageHeight - this.containerRect.height) / 2;
        var maxY = (this.containerRect.height - imageHeight) / 2 + bottom;
        var minX = (imageWidth - this.containerRect.width) / 2;
        var maxX = (this.containerRect.width - imageWidth) / 2;
        var possibleSwipeCords = {
          minY: minY,
          maxY: maxY,
          minX: minX,
          maxX: maxX
        };
        return possibleSwipeCords;
      };
      Zoom.prototype.setZoomSwipeStyles = function (LGel, distance) {
        LGel.css('transform', 'translate3d(' + distance.x + 'px, ' + distance.y + 'px, 0)');
      };
      Zoom.prototype.zoomSwipe = function () {
        var _this = this;
        var startCoords = {};
        var endCoords = {};
        var isMoved = false;
        // Allow x direction drag
        var allowX = false;
        // Allow Y direction drag
        var allowY = false;
        var startTime = new Date();
        var endTime = new Date();
        var possibleSwipeCords;
        var _LGel;
        var $item = this.core.getSlideItem(this.core.index);
        this.core.$inner.on('touchstart.lg', function (e) {
          // Allow zoom only on image
          if (!_this.isImageSlide(_this.core.index)) {
            return;
          }
          $item = _this.core.getSlideItem(_this.core.index);
          if ((_this.$LG(e.target).hasClass('lg-item') || $item.get().contains(e.target)) && e.touches.length === 1 && _this.core.outer.hasClass('lg-zoomed')) {
            e.preventDefault();
            startTime = new Date();
            _this.core.touchAction = 'zoomSwipe';
            _LGel = _this.core.getSlideItem(_this.core.index).find('.lg-img-wrap').first();
            var dragAllowedAxises = _this.getDragAllowedAxises(0);
            allowY = dragAllowedAxises.allowY;
            allowX = dragAllowedAxises.allowX;
            if (allowX || allowY) {
              startCoords = _this.getSwipeCords(e);
            }
            possibleSwipeCords = _this.getPossibleSwipeDragCords();
            // reset opacity and transition duration
            _this.core.outer.addClass('lg-zoom-dragging lg-zoom-drag-transition');
          }
        });
        this.core.$inner.on('touchmove.lg', function (e) {
          if (e.touches.length === 1 && _this.core.touchAction === 'zoomSwipe' && (_this.$LG(e.target).hasClass('lg-item') || $item.get().contains(e.target))) {
            e.preventDefault();
            _this.core.touchAction = 'zoomSwipe';
            endCoords = _this.getSwipeCords(e);
            var distance = _this.getZoomSwipeCords(startCoords, endCoords, allowX, allowY, possibleSwipeCords);
            if (Math.abs(endCoords.x - startCoords.x) > 15 || Math.abs(endCoords.y - startCoords.y) > 15) {
              isMoved = true;
              _this.setZoomSwipeStyles(_LGel, distance);
            }
          }
        });
        this.core.$inner.on('touchend.lg', function (e) {
          if (_this.core.touchAction === 'zoomSwipe' && (_this.$LG(e.target).hasClass('lg-item') || $item.get().contains(e.target))) {
            e.preventDefault();
            _this.core.touchAction = undefined;
            _this.core.outer.removeClass('lg-zoom-dragging');
            if (!isMoved) {
              return;
            }
            isMoved = false;
            endTime = new Date();
            var touchDuration = endTime.valueOf() - startTime.valueOf();
            _this.touchendZoom(startCoords, endCoords, allowX, allowY, touchDuration);
          }
        });
      };
      Zoom.prototype.zoomDrag = function () {
        var _this = this;
        var startCoords = {};
        var endCoords = {};
        var isDragging = false;
        var isMoved = false;
        // Allow x direction drag
        var allowX = false;
        // Allow Y direction drag
        var allowY = false;
        var startTime;
        var endTime;
        var possibleSwipeCords;
        var _LGel;
        this.core.outer.on('mousedown.lg.zoom', function (e) {
          // Allow zoom only on image
          if (!_this.isImageSlide(_this.core.index)) {
            return;
          }
          var $item = _this.core.getSlideItem(_this.core.index);
          if (_this.$LG(e.target).hasClass('lg-item') || $item.get().contains(e.target)) {
            startTime = new Date();
            _LGel = _this.core.getSlideItem(_this.core.index).find('.lg-img-wrap').first();
            var dragAllowedAxises = _this.getDragAllowedAxises(0);
            allowY = dragAllowedAxises.allowY;
            allowX = dragAllowedAxises.allowX;
            if (_this.core.outer.hasClass('lg-zoomed')) {
              if (_this.$LG(e.target).hasClass('lg-object') && (allowX || allowY)) {
                e.preventDefault();
                startCoords = _this.getDragCords(e);
                possibleSwipeCords = _this.getPossibleSwipeDragCords();
                isDragging = true;
                _this.core.outer.removeClass('lg-grab').addClass('lg-grabbing lg-zoom-drag-transition lg-zoom-dragging');
                // reset opacity and transition duration
              }
            }
          }
        });
        this.$LG(window).on("mousemove.lg.zoom.global" + this.core.lgId, function (e) {
          if (isDragging) {
            isMoved = true;
            endCoords = _this.getDragCords(e);
            var distance = _this.getZoomSwipeCords(startCoords, endCoords, allowX, allowY, possibleSwipeCords);
            _this.setZoomSwipeStyles(_LGel, distance);
          }
        });
        this.$LG(window).on("mouseup.lg.zoom.global" + this.core.lgId, function (e) {
          if (isDragging) {
            endTime = new Date();
            isDragging = false;
            _this.core.outer.removeClass('lg-zoom-dragging');
            // Fix for chrome mouse move on click
            if (isMoved && (startCoords.x !== endCoords.x || startCoords.y !== endCoords.y)) {
              endCoords = _this.getDragCords(e);
              var touchDuration = endTime.valueOf() - startTime.valueOf();
              _this.touchendZoom(startCoords, endCoords, allowX, allowY, touchDuration);
            }
            isMoved = false;
          }
          _this.core.outer.removeClass('lg-grabbing').addClass('lg-grab');
        });
      };
      Zoom.prototype.closeGallery = function () {
        this.resetZoom();
        this.zoomInProgress = false;
      };
      Zoom.prototype.destroy = function () {
        // Unbind all events added by lightGallery zoom plugin
        this.$LG(window).off(".lg.zoom.global" + this.core.lgId);
        this.core.LGel.off('.lg.zoom');
        this.core.LGel.off('.zoom');
        clearTimeout(this.zoomableTimeout);
        this.zoomableTimeout = false;
      };
      return Zoom;
    }();

    /*!
     * lightgallery | 2.8.3 | March 1st 2025
     * http://www.lightgalleryjs.com/
     * Copyright (c) 2020 Sachin Neravath;
     * @license GPLv3
     */

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign$2 = function () {
      __assign$2 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
      return __assign$2.apply(this, arguments);
    };
    var fullscreenSettings = {
      fullScreen: true,
      fullscreenPluginStrings: {
        toggleFullscreen: 'Toggle Fullscreen'
      }
    };
    var FullScreen = /** @class */function () {
      function FullScreen(instance, $LG) {
        // get lightGallery core plugin instance
        this.core = instance;
        this.$LG = $LG;
        // extend module default settings with lightGallery core settings
        this.settings = __assign$2(__assign$2({}, fullscreenSettings), this.core.settings);
        return this;
      }
      FullScreen.prototype.init = function () {
        var fullScreen = '';
        if (this.settings.fullScreen) {
          // check for fullscreen browser support
          if (!document.fullscreenEnabled && !document.webkitFullscreenEnabled && !document.mozFullScreenEnabled && !document.msFullscreenEnabled) {
            return;
          } else {
            fullScreen = "<button type=\"button\" aria-label=\"" + this.settings.fullscreenPluginStrings['toggleFullscreen'] + "\" class=\"lg-fullscreen lg-icon\"></button>";
            this.core.$toolbar.append(fullScreen);
            this.fullScreen();
          }
        }
      };
      FullScreen.prototype.isFullScreen = function () {
        return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
      };
      FullScreen.prototype.requestFullscreen = function () {
        var el = document.documentElement;
        if (el.requestFullscreen) {
          el.requestFullscreen();
        } else if (el.msRequestFullscreen) {
          el.msRequestFullscreen();
        } else if (el.mozRequestFullScreen) {
          el.mozRequestFullScreen();
        } else if (el.webkitRequestFullscreen) {
          el.webkitRequestFullscreen();
        }
      };
      FullScreen.prototype.exitFullscreen = function () {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        }
      };
      // https://developer.mozilla.org/en-US/docs/Web/Guide/API/DOM/Using_full_screen_mode
      FullScreen.prototype.fullScreen = function () {
        var _this = this;
        this.$LG(document).on("fullscreenchange.lg.global" + this.core.lgId + " \n            webkitfullscreenchange.lg.global" + this.core.lgId + " \n            mozfullscreenchange.lg.global" + this.core.lgId + " \n            MSFullscreenChange.lg.global" + this.core.lgId, function () {
          if (!_this.core.lgOpened) return;
          _this.core.outer.toggleClass('lg-fullscreen-on');
        });
        this.core.outer.find('.lg-fullscreen').first().on('click.lg', function () {
          if (_this.isFullScreen()) {
            _this.exitFullscreen();
          } else {
            _this.requestFullscreen();
          }
        });
      };
      FullScreen.prototype.closeGallery = function () {
        // exit from fullscreen if activated
        if (this.isFullScreen()) {
          this.exitFullscreen();
        }
      };
      FullScreen.prototype.destroy = function () {
        this.$LG(document).off("fullscreenchange.lg.global" + this.core.lgId + " \n            webkitfullscreenchange.lg.global" + this.core.lgId + " \n            mozfullscreenchange.lg.global" + this.core.lgId + " \n            MSFullscreenChange.lg.global" + this.core.lgId);
      };
      return FullScreen;
    }();

    /*!
     * lightgallery | 2.8.3 | March 1st 2025
     * http://www.lightgalleryjs.com/
     * Copyright (c) 2020 Sachin Neravath;
     * @license GPLv3
     */

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign$1 = function () {
      __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
      return __assign$1.apply(this, arguments);
    };
    var videoSettings = {
      autoplayFirstVideo: true,
      youTubePlayerParams: false,
      vimeoPlayerParams: false,
      wistiaPlayerParams: false,
      gotoNextSlideOnVideoEnd: true,
      autoplayVideoOnSlide: false,
      videojs: false,
      videojsTheme: '',
      videojsOptions: {}
    };

    /**
     * List of lightGallery events
     * All events should be documented here
     * Below interfaces are used to build the website documentations
     * */
    var lGEvents = {
      afterAppendSlide: 'lgAfterAppendSlide',
      init: 'lgInit',
      hasVideo: 'lgHasVideo',
      containerResize: 'lgContainerResize',
      updateSlides: 'lgUpdateSlides',
      afterAppendSubHtml: 'lgAfterAppendSubHtml',
      beforeOpen: 'lgBeforeOpen',
      afterOpen: 'lgAfterOpen',
      slideItemLoad: 'lgSlideItemLoad',
      beforeSlide: 'lgBeforeSlide',
      afterSlide: 'lgAfterSlide',
      posterClick: 'lgPosterClick',
      dragStart: 'lgDragStart',
      dragMove: 'lgDragMove',
      dragEnd: 'lgDragEnd',
      beforeNextSlide: 'lgBeforeNextSlide',
      beforePrevSlide: 'lgBeforePrevSlide',
      beforeClose: 'lgBeforeClose',
      afterClose: 'lgAfterClose',
      rotateLeft: 'lgRotateLeft',
      rotateRight: 'lgRotateRight',
      flipHorizontal: 'lgFlipHorizontal',
      flipVertical: 'lgFlipVertical',
      autoplay: 'lgAutoplay',
      autoplayStart: 'lgAutoplayStart',
      autoplayStop: 'lgAutoplayStop'
    };
    var param = function (obj) {
      return Object.keys(obj).map(function (k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]);
      }).join('&');
    };
    var paramsToObject = function (url) {
      var paramas = url.slice(1).split('&').map(function (p) {
        return p.split('=');
      }).reduce(function (obj, pair) {
        var _a = pair.map(decodeURIComponent),
          key = _a[0],
          value = _a[1];
        obj[key] = value;
        return obj;
      }, {});
      return paramas;
    };
    var getYouTubeParams = function (videoInfo, youTubePlayerParamsSettings) {
      if (!videoInfo.youtube) return '';
      var slideUrlParams = videoInfo.youtube[2] ? paramsToObject(videoInfo.youtube[2]) : '';
      // For youtube first params gets priority if duplicates found
      var defaultYouTubePlayerParams = {
        wmode: 'opaque',
        autoplay: 0,
        mute: 1,
        enablejsapi: 1
      };
      var playerParamsSettings = youTubePlayerParamsSettings || {};
      var youTubePlayerParams = __assign$1(__assign$1(__assign$1({}, defaultYouTubePlayerParams), playerParamsSettings), slideUrlParams);
      var youTubeParams = "?" + param(youTubePlayerParams);
      return youTubeParams;
    };
    var isYouTubeNoCookie = function (url) {
      return url.includes('youtube-nocookie.com');
    };
    var getVimeoURLParams = function (defaultParams, videoInfo) {
      if (!videoInfo || !videoInfo.vimeo) return '';
      var urlParams = videoInfo.vimeo[2] || '';
      var defaultVimeoPlayerParams = Object.assign({}, {
        autoplay: 0,
        muted: 1
      }, defaultParams);
      var defaultPlayerParams = defaultVimeoPlayerParams && Object.keys(defaultVimeoPlayerParams).length !== 0 ? param(defaultVimeoPlayerParams) : '';
      // Support private video
      var urlWithHash = videoInfo.vimeo[0].split('/').pop() || '';
      var urlWithHashWithParams = urlWithHash.split('?')[0] || '';
      var hash = urlWithHashWithParams.split('#')[0];
      var isPrivate = videoInfo.vimeo[1] !== hash;
      if (isPrivate) {
        urlParams = urlParams.replace("/" + hash, '');
      }
      urlParams = urlParams[0] == '?' ? '&' + urlParams.slice(1) : urlParams || '';
      var privateUrlParams = isPrivate ? "h=" + hash : '';
      defaultPlayerParams = privateUrlParams ? "&" + defaultPlayerParams : defaultPlayerParams;
      var vimeoPlayerParams = "?" + privateUrlParams + defaultPlayerParams + urlParams;
      return vimeoPlayerParams;
    };

    /**
     * Video module for lightGallery
     * Supports HTML5, YouTube, Vimeo, wistia videos
     *
     *
     * @ref Wistia
     * https://wistia.com/support/integrations/wordpress(How to get url)
     * https://wistia.com/support/developers/embed-options#using-embed-options
     * https://wistia.com/support/developers/player-api
     * https://wistia.com/support/developers/construct-an-embed-code
     * http://jsfiddle.net/xvnm7xLm/
     * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video
     * https://wistia.com/support/embed-and-share/sharing-videos
     * https://private-sharing.wistia.com/medias/mwhrulrucj
     *
     * @ref Youtube
     * https://developers.google.com/youtube/player_parameters#enablejsapi
     * https://developers.google.com/youtube/iframe_api_reference
     * https://developer.chrome.com/blog/autoplay/#iframe-delegation
     *
     * @ref Vimeo
     * https://stackoverflow.com/questions/10488943/easy-way-to-get-vimeo-id-from-a-vimeo-url
     * https://vimeo.zendesk.com/hc/en-us/articles/360000121668-Starting-playback-at-a-specific-timecode
     * https://vimeo.zendesk.com/hc/en-us/articles/360001494447-Using-Player-Parameters
     */
    var Video = /** @class */function () {
      function Video(instance) {
        // get lightGallery core plugin instance
        this.core = instance;
        this.settings = __assign$1(__assign$1({}, videoSettings), this.core.settings);
        return this;
      }
      Video.prototype.init = function () {
        var _this = this;
        /**
         * Event triggered when video url found without poster
         * Append video HTML
         * Play if autoplayFirstVideo is true
         */
        this.core.LGel.on(lGEvents.hasVideo + ".video", this.onHasVideo.bind(this));
        this.core.LGel.on(lGEvents.posterClick + ".video", function () {
          var $el = _this.core.getSlideItem(_this.core.index);
          _this.loadVideoOnPosterClick($el);
        });
        this.core.LGel.on(lGEvents.slideItemLoad + ".video", this.onSlideItemLoad.bind(this));
        // @desc fired immediately before each slide transition.
        this.core.LGel.on(lGEvents.beforeSlide + ".video", this.onBeforeSlide.bind(this));
        // @desc fired immediately after each slide transition.
        this.core.LGel.on(lGEvents.afterSlide + ".video", this.onAfterSlide.bind(this));
      };
      /**
       * @desc Event triggered when a slide is completely loaded
       *
       * @param {Event} event - lightGalley custom event
       */
      Video.prototype.onSlideItemLoad = function (event) {
        var _this = this;
        var _a = event.detail,
          isFirstSlide = _a.isFirstSlide,
          index = _a.index;
        // Should check the active slide as well as user may have moved to different slide before the first slide is loaded
        if (this.settings.autoplayFirstVideo && isFirstSlide && index === this.core.index) {
          // Delay is just for the transition effect on video load
          setTimeout(function () {
            _this.loadAndPlayVideo(index);
          }, 200);
        }
        // Should not call on first slide. should check only if the slide is active
        if (!isFirstSlide && this.settings.autoplayVideoOnSlide && index === this.core.index) {
          this.loadAndPlayVideo(index);
        }
      };
      /**
       * @desc Event triggered when video url or poster found
       * Append video HTML is poster is not given
       * Play if autoplayFirstVideo is true
       *
       * @param {Event} event - Javascript Event object.
       */
      Video.prototype.onHasVideo = function (event) {
        var _a = event.detail,
          index = _a.index,
          src = _a.src,
          html5Video = _a.html5Video,
          hasPoster = _a.hasPoster;
        if (!hasPoster) {
          // All functions are called separately if poster exist in loadVideoOnPosterClick function
          this.appendVideos(this.core.getSlideItem(index), {
            src: src,
            addClass: 'lg-object',
            index: index,
            html5Video: html5Video
          });
          // Automatically navigate to next slide once video reaches the end.
          this.gotoNextSlideOnVideoEnd(src, index);
        }
      };
      /**
       * @desc fired immediately before each slide transition.
       * Pause the previous video
       * Hide the download button if the slide contains YouTube, Vimeo, or Wistia videos.
       *
       * @param {Event} event - Javascript Event object.
       * @param {number} prevIndex - Previous index of the slide.
       * @param {number} index - Current index of the slide
       */
      Video.prototype.onBeforeSlide = function (event) {
        if (this.core.lGalleryOn) {
          var prevIndex = event.detail.prevIndex;
          this.pauseVideo(prevIndex);
        }
      };
      /**
       * @desc fired immediately after each slide transition.
       * Play video if autoplayVideoOnSlide option is enabled.
       *
       * @param {Event} event - Javascript Event object.
       * @param {number} prevIndex - Previous index of the slide.
       * @param {number} index - Current index of the slide
       * @todo should check on onSlideLoad as well if video is not loaded on after slide
       */
      Video.prototype.onAfterSlide = function (event) {
        var _this = this;
        var _a = event.detail,
          index = _a.index,
          prevIndex = _a.prevIndex;
        // Do not call on first slide
        var $slide = this.core.getSlideItem(index);
        if (this.settings.autoplayVideoOnSlide && index !== prevIndex) {
          if ($slide.hasClass('lg-complete')) {
            setTimeout(function () {
              _this.loadAndPlayVideo(index);
            }, 100);
          }
        }
      };
      Video.prototype.loadAndPlayVideo = function (index) {
        var $slide = this.core.getSlideItem(index);
        var currentGalleryItem = this.core.galleryItems[index];
        if (currentGalleryItem.poster) {
          this.loadVideoOnPosterClick($slide, true);
        } else {
          this.playVideo(index);
        }
      };
      /**
       * Play HTML5, Youtube, Vimeo or Wistia videos in a particular slide.
       * @param {number} index - Index of the slide
       */
      Video.prototype.playVideo = function (index) {
        this.controlVideo(index, 'play');
      };
      /**
       * Pause HTML5, Youtube, Vimeo or Wistia videos in a particular slide.
       * @param {number} index - Index of the slide
       */
      Video.prototype.pauseVideo = function (index) {
        this.controlVideo(index, 'pause');
      };
      Video.prototype.getVideoHtml = function (src, addClass, index, html5Video) {
        var video = '';
        var videoInfo = this.core.galleryItems[index].__slideVideoInfo || {};
        var currentGalleryItem = this.core.galleryItems[index];
        var videoTitle = currentGalleryItem.title || currentGalleryItem.alt;
        videoTitle = videoTitle ? 'title="' + videoTitle + '"' : '';
        var commonIframeProps = "allowtransparency=\"true\"\n            frameborder=\"0\"\n            scrolling=\"no\"\n            allowfullscreen\n            mozallowfullscreen\n            webkitallowfullscreen\n            oallowfullscreen\n            msallowfullscreen";
        if (videoInfo.youtube) {
          var videoId = 'lg-youtube' + index;
          var youTubeParams = getYouTubeParams(videoInfo, this.settings.youTubePlayerParams);
          var isYouTubeNoCookieURL = isYouTubeNoCookie(src);
          var youtubeURL = isYouTubeNoCookieURL ? '//www.youtube-nocookie.com/' : '//www.youtube.com/';
          video = "<iframe allow=\"autoplay\" id=" + videoId + " class=\"lg-video-object lg-youtube " + addClass + "\" " + videoTitle + " src=\"" + youtubeURL + "embed/" + (videoInfo.youtube[1] + youTubeParams) + "\" " + commonIframeProps + "></iframe>";
        } else if (videoInfo.vimeo) {
          var videoId = 'lg-vimeo' + index;
          var playerParams = getVimeoURLParams(this.settings.vimeoPlayerParams, videoInfo);
          video = "<iframe allow=\"autoplay\" id=" + videoId + " class=\"lg-video-object lg-vimeo " + addClass + "\" " + videoTitle + " src=\"//player.vimeo.com/video/" + (videoInfo.vimeo[1] + playerParams) + "\" " + commonIframeProps + "></iframe>";
        } else if (videoInfo.wistia) {
          var wistiaId = 'lg-wistia' + index;
          var playerParams = param(this.settings.wistiaPlayerParams);
          playerParams = playerParams ? '?' + playerParams : '';
          video = "<iframe allow=\"autoplay\" id=\"" + wistiaId + "\" src=\"//fast.wistia.net/embed/iframe/" + (videoInfo.wistia[4] + playerParams) + "\" " + videoTitle + " class=\"wistia_embed lg-video-object lg-wistia " + addClass + "\" name=\"wistia_embed\" " + commonIframeProps + "></iframe>";
        } else if (videoInfo.html5) {
          var html5VideoMarkup = '';
          for (var i = 0; i < html5Video.source.length; i++) {
            var type = html5Video.source[i].type;
            var typeAttr = type ? "type=\"" + type + "\"" : '';
            html5VideoMarkup += "<source src=\"" + html5Video.source[i].src + "\" " + typeAttr + ">";
          }
          if (html5Video.tracks) {
            var _loop_1 = function (i) {
              var trackAttributes = '';
              var track = html5Video.tracks[i];
              Object.keys(track || {}).forEach(function (key) {
                trackAttributes += key + "=\"" + track[key] + "\" ";
              });
              html5VideoMarkup += "<track " + trackAttributes + ">";
            };
            for (var i = 0; i < html5Video.tracks.length; i++) {
              _loop_1(i);
            }
          }
          var html5VideoAttrs_1 = '';
          var videoAttributes_1 = html5Video.attributes || {};
          Object.keys(videoAttributes_1 || {}).forEach(function (key) {
            html5VideoAttrs_1 += key + "=\"" + videoAttributes_1[key] + "\" ";
          });
          video = "<video class=\"lg-video-object lg-html5 " + (this.settings.videojs && this.settings.videojsTheme ? this.settings.videojsTheme + ' ' : '') + " " + (this.settings.videojs ? ' video-js' : '') + "\" " + html5VideoAttrs_1 + ">\n                " + html5VideoMarkup + "\n                Your browser does not support HTML5 video.\n            </video>";
        }
        return video;
      };
      /**
       * @desc - Append videos to the slide
       *
       * @param {HTMLElement} el - slide element
       * @param {Object} videoParams - Video parameters, Contains src, class, index, htmlVideo
       */
      Video.prototype.appendVideos = function (el, videoParams) {
        var _a;
        var videoHtml = this.getVideoHtml(videoParams.src, videoParams.addClass, videoParams.index, videoParams.html5Video);
        el.find('.lg-video-cont').append(videoHtml);
        var $videoElement = el.find('.lg-video-object').first();
        if (videoParams.html5Video) {
          $videoElement.on('mousedown.lg.video', function (e) {
            e.stopPropagation();
          });
        }
        if (this.settings.videojs && ((_a = this.core.galleryItems[videoParams.index].__slideVideoInfo) === null || _a === void 0 ? void 0 : _a.html5)) {
          try {
            return videojs($videoElement.get(), this.settings.videojsOptions);
          } catch (e) {
            console.error('lightGallery:- Make sure you have included videojs');
          }
        }
      };
      Video.prototype.gotoNextSlideOnVideoEnd = function (src, index) {
        var _this = this;
        var $videoElement = this.core.getSlideItem(index).find('.lg-video-object').first();
        var videoInfo = this.core.galleryItems[index].__slideVideoInfo || {};
        if (this.settings.gotoNextSlideOnVideoEnd) {
          if (videoInfo.html5) {
            $videoElement.on('ended', function () {
              _this.core.goToNextSlide();
            });
          } else if (videoInfo.vimeo) {
            try {
              // https://github.com/vimeo/player.js/#ended
              new Vimeo.Player($videoElement.get()).on('ended', function () {
                _this.core.goToNextSlide();
              });
            } catch (e) {
              console.error('lightGallery:- Make sure you have included //github.com/vimeo/player.js');
            }
          } else if (videoInfo.wistia) {
            try {
              window._wq = window._wq || [];
              // @todo Event is gettign triggered multiple times
              window._wq.push({
                id: $videoElement.attr('id'),
                onReady: function (video) {
                  video.bind('end', function () {
                    _this.core.goToNextSlide();
                  });
                }
              });
            } catch (e) {
              console.error('lightGallery:- Make sure you have included //fast.wistia.com/assets/external/E-v1.js');
            }
          }
        }
      };
      Video.prototype.controlVideo = function (index, action) {
        var $videoElement = this.core.getSlideItem(index).find('.lg-video-object').first();
        var videoInfo = this.core.galleryItems[index].__slideVideoInfo || {};
        if (!$videoElement.get()) return;
        if (videoInfo.youtube) {
          try {
            $videoElement.get().contentWindow.postMessage("{\"event\":\"command\",\"func\":\"" + action + "Video\",\"args\":\"\"}", '*');
          } catch (e) {
            console.error("lightGallery:- " + e);
          }
        } else if (videoInfo.vimeo) {
          try {
            new Vimeo.Player($videoElement.get())[action]();
          } catch (e) {
            console.error('lightGallery:- Make sure you have included //github.com/vimeo/player.js');
          }
        } else if (videoInfo.html5) {
          if (this.settings.videojs) {
            try {
              videojs($videoElement.get())[action]();
            } catch (e) {
              console.error('lightGallery:- Make sure you have included videojs');
            }
          } else {
            $videoElement.get()[action]();
          }
        } else if (videoInfo.wistia) {
          try {
            window._wq = window._wq || [];
            // @todo Find a way to destroy wistia player instance
            window._wq.push({
              id: $videoElement.attr('id'),
              onReady: function (video) {
                video[action]();
              }
            });
          } catch (e) {
            console.error('lightGallery:- Make sure you have included //fast.wistia.com/assets/external/E-v1.js');
          }
        }
      };
      Video.prototype.loadVideoOnPosterClick = function ($el, forcePlay) {
        var _this = this;
        // check slide has poster
        if (!$el.hasClass('lg-video-loaded')) {
          // check already video element present
          if (!$el.hasClass('lg-has-video')) {
            $el.addClass('lg-has-video');
            var _html = void 0;
            var _src = this.core.galleryItems[this.core.index].src;
            var video = this.core.galleryItems[this.core.index].video;
            if (video) {
              _html = typeof video === 'string' ? JSON.parse(video) : video;
            }
            var videoJsPlayer_1 = this.appendVideos($el, {
              src: _src,
              addClass: '',
              index: this.core.index,
              html5Video: _html
            });
            this.gotoNextSlideOnVideoEnd(_src, this.core.index);
            var $tempImg = $el.find('.lg-object').first().get();
            // @todo make sure it is working
            $el.find('.lg-video-cont').first().append($tempImg);
            $el.addClass('lg-video-loading');
            videoJsPlayer_1 && videoJsPlayer_1.ready(function () {
              videoJsPlayer_1.on('loadedmetadata', function () {
                _this.onVideoLoadAfterPosterClick($el, _this.core.index);
              });
            });
            $el.find('.lg-video-object').first().on('load.lg error.lg loadedmetadata.lg', function () {
              setTimeout(function () {
                _this.onVideoLoadAfterPosterClick($el, _this.core.index);
              }, 50);
            });
          } else {
            this.playVideo(this.core.index);
          }
        } else if (forcePlay) {
          this.playVideo(this.core.index);
        }
      };
      Video.prototype.onVideoLoadAfterPosterClick = function ($el, index) {
        $el.addClass('lg-video-loaded');
        this.playVideo(index);
      };
      Video.prototype.destroy = function () {
        this.core.LGel.off('.lg.video');
        this.core.LGel.off('.video');
      };
      return Video;
    }();

    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

    var isotope = {exports: {}};

    var outlayer = {exports: {}};

    var evEmitter = {exports: {}};

    /**
     * EvEmitter v1.1.0
     * Lil' event emitter
     * MIT License
     */
    (function (module) {
      /* jshint unused: true, undef: true, strict: true */

      (function (global, factory) {
        // universal module definition
        /* jshint strict: false */ /* globals define, module, window */
        if (module.exports) {
          // CommonJS - Browserify, Webpack
          module.exports = factory();
        } else {
          // Browser globals
          global.EvEmitter = factory();
        }
      })(typeof window != 'undefined' ? window : commonjsGlobal, function () {

        function EvEmitter() {}
        var proto = EvEmitter.prototype;
        proto.on = function (eventName, listener) {
          if (!eventName || !listener) {
            return;
          }
          // set events hash
          var events = this._events = this._events || {};
          // set listeners array
          var listeners = events[eventName] = events[eventName] || [];
          // only add once
          if (listeners.indexOf(listener) == -1) {
            listeners.push(listener);
          }
          return this;
        };
        proto.once = function (eventName, listener) {
          if (!eventName || !listener) {
            return;
          }
          // add event
          this.on(eventName, listener);
          // set once flag
          // set onceEvents hash
          var onceEvents = this._onceEvents = this._onceEvents || {};
          // set onceListeners object
          var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
          // set flag
          onceListeners[listener] = true;
          return this;
        };
        proto.off = function (eventName, listener) {
          var listeners = this._events && this._events[eventName];
          if (!listeners || !listeners.length) {
            return;
          }
          var index = listeners.indexOf(listener);
          if (index != -1) {
            listeners.splice(index, 1);
          }
          return this;
        };
        proto.emitEvent = function (eventName, args) {
          var listeners = this._events && this._events[eventName];
          if (!listeners || !listeners.length) {
            return;
          }
          // copy over to avoid interference if .off() in listener
          listeners = listeners.slice(0);
          args = args || [];
          // once stuff
          var onceListeners = this._onceEvents && this._onceEvents[eventName];
          for (var i = 0; i < listeners.length; i++) {
            var listener = listeners[i];
            var isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
              // remove listener
              // remove before trigger to prevent recursion
              this.off(eventName, listener);
              // unset once flag
              delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
          }
          return this;
        };
        proto.allOff = function () {
          delete this._events;
          delete this._onceEvents;
        };
        return EvEmitter;
      });
    })(evEmitter);

    var getSize = {exports: {}};

    /*!
     * getSize v2.0.3
     * measure size of elements
     * MIT license
     */
    (function (module) {
      /* jshint browser: true, strict: true, undef: true, unused: true */
      /* globals console: false */

      (function (window, factory) {
        /* jshint strict: false */ /* globals define, module */
        if (module.exports) {
          // CommonJS
          module.exports = factory();
        } else {
          // browser global
          window.getSize = factory();
        }
      })(window, function factory() {

        // -------------------------- helpers -------------------------- //

        // get a number from a string, not a percentage
        function getStyleSize(value) {
          var num = parseFloat(value);
          // not a percent like '100%', and a number
          var isValid = value.indexOf('%') == -1 && !isNaN(num);
          return isValid && num;
        }
        function noop() {}
        var logError = typeof console == 'undefined' ? noop : function (message) {
          console.error(message);
        };

        // -------------------------- measurements -------------------------- //

        var measurements = ['paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'borderBottomWidth'];
        var measurementsLength = measurements.length;
        function getZeroSize() {
          var size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
          };
          for (var i = 0; i < measurementsLength; i++) {
            var measurement = measurements[i];
            size[measurement] = 0;
          }
          return size;
        }

        // -------------------------- getStyle -------------------------- //

        /**
         * getStyle, get style of element, check for Firefox bug
         * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
         */
        function getStyle(elem) {
          var style = getComputedStyle(elem);
          if (!style) {
            logError('Style returned ' + style + '. Are you running this code in a hidden iframe on Firefox? ' + 'See https://bit.ly/getsizebug1');
          }
          return style;
        }

        // -------------------------- setup -------------------------- //

        var isSetup = false;
        var isBoxSizeOuter;

        /**
         * setup
         * check isBoxSizerOuter
         * do on first getSize() rather than on page load for Firefox bug
         */
        function setup() {
          // setup once
          if (isSetup) {
            return;
          }
          isSetup = true;

          // -------------------------- box sizing -------------------------- //

          /**
           * Chrome & Safari measure the outer-width on style.width on border-box elems
           * IE11 & Firefox<29 measures the inner-width
           */
          var div = document.createElement('div');
          div.style.width = '200px';
          div.style.padding = '1px 2px 3px 4px';
          div.style.borderStyle = 'solid';
          div.style.borderWidth = '1px 2px 3px 4px';
          div.style.boxSizing = 'border-box';
          var body = document.body || document.documentElement;
          body.appendChild(div);
          var style = getStyle(div);
          // round value for browser zoom. desandro/masonry#928
          isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
          getSize.isBoxSizeOuter = isBoxSizeOuter;
          body.removeChild(div);
        }

        // -------------------------- getSize -------------------------- //

        function getSize(elem) {
          setup();

          // use querySeletor if elem is string
          if (typeof elem == 'string') {
            elem = document.querySelector(elem);
          }

          // do not proceed on non-objects
          if (!elem || typeof elem != 'object' || !elem.nodeType) {
            return;
          }
          var style = getStyle(elem);

          // if hidden, everything is 0
          if (style.display == 'none') {
            return getZeroSize();
          }
          var size = {};
          size.width = elem.offsetWidth;
          size.height = elem.offsetHeight;
          var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

          // get all measurements
          for (var i = 0; i < measurementsLength; i++) {
            var measurement = measurements[i];
            var value = style[measurement];
            var num = parseFloat(value);
            // any 'auto', 'medium' value will be 0
            size[measurement] = !isNaN(num) ? num : 0;
          }
          var paddingWidth = size.paddingLeft + size.paddingRight;
          var paddingHeight = size.paddingTop + size.paddingBottom;
          var marginWidth = size.marginLeft + size.marginRight;
          var marginHeight = size.marginTop + size.marginBottom;
          var borderWidth = size.borderLeftWidth + size.borderRightWidth;
          var borderHeight = size.borderTopWidth + size.borderBottomWidth;
          var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

          // overwrite width and height if we can get it from style
          var styleWidth = getStyleSize(style.width);
          if (styleWidth !== false) {
            size.width = styleWidth + (
            // add padding and border unless it's already including it
            isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
          }
          var styleHeight = getStyleSize(style.height);
          if (styleHeight !== false) {
            size.height = styleHeight + (
            // add padding and border unless it's already including it
            isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
          }
          size.innerWidth = size.width - (paddingWidth + borderWidth);
          size.innerHeight = size.height - (paddingHeight + borderHeight);
          size.outerWidth = size.width + marginWidth;
          size.outerHeight = size.height + marginHeight;
          return size;
        }
        return getSize;
      });
    })(getSize);

    var utils = {exports: {}};

    var matchesSelector = {exports: {}};

    /**
     * matchesSelector v2.0.2
     * matchesSelector( element, '.selector' )
     * MIT license
     */
    (function (module) {
      /*jshint browser: true, strict: true, undef: true, unused: true */

      (function (window, factory) {

        // universal module definition
        if (module.exports) {
          // CommonJS
          module.exports = factory();
        } else {
          // browser global
          window.matchesSelector = factory();
        }
      })(window, function factory() {

        var matchesMethod = function () {
          var ElemProto = window.Element.prototype;
          // check for the standard method name first
          if (ElemProto.matches) {
            return 'matches';
          }
          // check un-prefixed
          if (ElemProto.matchesSelector) {
            return 'matchesSelector';
          }
          // check vendor prefixes
          var prefixes = ['webkit', 'moz', 'ms', 'o'];
          for (var i = 0; i < prefixes.length; i++) {
            var prefix = prefixes[i];
            var method = prefix + 'MatchesSelector';
            if (ElemProto[method]) {
              return method;
            }
          }
        }();
        return function matchesSelector(elem, selector) {
          return elem[matchesMethod](selector);
        };
      });
    })(matchesSelector);

    /**
     * Fizzy UI utils v2.0.7
     * MIT license
     */
    (function (module) {
      /*jshint browser: true, undef: true, unused: true, strict: true */

      (function (window, factory) {
        // universal module definition
        /*jshint strict: false */ /*globals define, module, require */

        if (module.exports) {
          // CommonJS
          module.exports = factory(window, matchesSelector.exports);
        } else {
          // browser global
          window.fizzyUIUtils = factory(window, window.matchesSelector);
        }
      })(window, function factory(window, matchesSelector) {

        var utils = {};

        // ----- extend ----- //

        // extends objects
        utils.extend = function (a, b) {
          for (var prop in b) {
            a[prop] = b[prop];
          }
          return a;
        };

        // ----- modulo ----- //

        utils.modulo = function (num, div) {
          return (num % div + div) % div;
        };

        // ----- makeArray ----- //

        var arraySlice = Array.prototype.slice;

        // turn element or nodeList into an array
        utils.makeArray = function (obj) {
          if (Array.isArray(obj)) {
            // use object if already an array
            return obj;
          }
          // return empty array if undefined or null. #6
          if (obj === null || obj === undefined) {
            return [];
          }
          var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
          if (isArrayLike) {
            // convert nodeList to array
            return arraySlice.call(obj);
          }

          // array of single index
          return [obj];
        };

        // ----- removeFrom ----- //

        utils.removeFrom = function (ary, obj) {
          var index = ary.indexOf(obj);
          if (index != -1) {
            ary.splice(index, 1);
          }
        };

        // ----- getParent ----- //

        utils.getParent = function (elem, selector) {
          while (elem.parentNode && elem != document.body) {
            elem = elem.parentNode;
            if (matchesSelector(elem, selector)) {
              return elem;
            }
          }
        };

        // ----- getQueryElement ----- //

        // use element as selector string
        utils.getQueryElement = function (elem) {
          if (typeof elem == 'string') {
            return document.querySelector(elem);
          }
          return elem;
        };

        // ----- handleEvent ----- //

        // enable .ontype to trigger from .addEventListener( elem, 'type' )
        utils.handleEvent = function (event) {
          var method = 'on' + event.type;
          if (this[method]) {
            this[method](event);
          }
        };

        // ----- filterFindElements ----- //

        utils.filterFindElements = function (elems, selector) {
          // make array of elems
          elems = utils.makeArray(elems);
          var ffElems = [];
          elems.forEach(function (elem) {
            // check that elem is an actual element
            if (!(elem instanceof HTMLElement)) {
              return;
            }
            // add elem if no selector
            if (!selector) {
              ffElems.push(elem);
              return;
            }
            // filter & find items if we have a selector
            // filter
            if (matchesSelector(elem, selector)) {
              ffElems.push(elem);
            }
            // find children
            var childElems = elem.querySelectorAll(selector);
            // concat childElems to filterFound array
            for (var i = 0; i < childElems.length; i++) {
              ffElems.push(childElems[i]);
            }
          });
          return ffElems;
        };

        // ----- debounceMethod ----- //

        utils.debounceMethod = function (_class, methodName, threshold) {
          threshold = threshold || 100;
          // original method
          var method = _class.prototype[methodName];
          var timeoutName = methodName + 'Timeout';
          _class.prototype[methodName] = function () {
            var timeout = this[timeoutName];
            clearTimeout(timeout);
            var args = arguments;
            var _this = this;
            this[timeoutName] = setTimeout(function () {
              method.apply(_this, args);
              delete _this[timeoutName];
            }, threshold);
          };
        };

        // ----- docReady ----- //

        utils.docReady = function (callback) {
          var readyState = document.readyState;
          if (readyState == 'complete' || readyState == 'interactive') {
            // do async to allow for other scripts to run. metafizzy/flickity#441
            setTimeout(callback);
          } else {
            document.addEventListener('DOMContentLoaded', callback);
          }
        };

        // ----- htmlInit ----- //

        // http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
        utils.toDashed = function (str) {
          return str.replace(/(.)([A-Z])/g, function (match, $1, $2) {
            return $1 + '-' + $2;
          }).toLowerCase();
        };
        var console = window.console;
        /**
         * allow user to initialize classes via [data-namespace] or .js-namespace class
         * htmlInit( Widget, 'widgetName' )
         * options are parsed from data-namespace-options
         */
        utils.htmlInit = function (WidgetClass, namespace) {
          utils.docReady(function () {
            var dashedNamespace = utils.toDashed(namespace);
            var dataAttr = 'data-' + dashedNamespace;
            var dataAttrElems = document.querySelectorAll('[' + dataAttr + ']');
            var jsDashElems = document.querySelectorAll('.js-' + dashedNamespace);
            var elems = utils.makeArray(dataAttrElems).concat(utils.makeArray(jsDashElems));
            var dataOptionsAttr = dataAttr + '-options';
            var jQuery = window.jQuery;
            elems.forEach(function (elem) {
              var attr = elem.getAttribute(dataAttr) || elem.getAttribute(dataOptionsAttr);
              var options;
              try {
                options = attr && JSON.parse(attr);
              } catch (error) {
                // log error, do not initialize
                if (console) {
                  console.error('Error parsing ' + dataAttr + ' on ' + elem.className + ': ' + error);
                }
                return;
              }
              // initialize
              var instance = new WidgetClass(elem, options);
              // make available via $().data('namespace')
              if (jQuery) {
                jQuery.data(elem, namespace, instance);
              }
            });
          });
        };

        // -----  ----- //

        return utils;
      });
    })(utils);

    var item$1 = {exports: {}};

    /**
     * Outlayer Item
     */
    (function (module) {
      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */ /* globals define, module, require */
        if (module.exports) {
          // CommonJS - Browserify, Webpack
          module.exports = factory(evEmitter.exports, getSize.exports);
        } else {
          // browser global
          window.Outlayer = {};
          window.Outlayer.Item = factory(window.EvEmitter, window.getSize);
        }
      })(window, function factory(EvEmitter, getSize) {

        // ----- helpers ----- //
        function isEmptyObj(obj) {
          for (var prop in obj) {
            return false;
          }
          prop = null;
          return true;
        }

        // -------------------------- CSS3 support -------------------------- //

        var docElemStyle = document.documentElement.style;
        var transitionProperty = typeof docElemStyle.transition == 'string' ? 'transition' : 'WebkitTransition';
        var transformProperty = typeof docElemStyle.transform == 'string' ? 'transform' : 'WebkitTransform';
        var transitionEndEvent = {
          WebkitTransition: 'webkitTransitionEnd',
          transition: 'transitionend'
        }[transitionProperty];

        // cache all vendor properties that could have vendor prefix
        var vendorProperties = {
          transform: transformProperty,
          transition: transitionProperty,
          transitionDuration: transitionProperty + 'Duration',
          transitionProperty: transitionProperty + 'Property',
          transitionDelay: transitionProperty + 'Delay'
        };

        // -------------------------- Item -------------------------- //

        function Item(element, layout) {
          if (!element) {
            return;
          }
          this.element = element;
          // parent layout class, i.e. Masonry, Isotope, or Packery
          this.layout = layout;
          this.position = {
            x: 0,
            y: 0
          };
          this._create();
        }

        // inherit EvEmitter
        var proto = Item.prototype = Object.create(EvEmitter.prototype);
        proto.constructor = Item;
        proto._create = function () {
          // transition objects
          this._transn = {
            ingProperties: {},
            clean: {},
            onEnd: {}
          };
          this.css({
            position: 'absolute'
          });
        };

        // trigger specified handler for event type
        proto.handleEvent = function (event) {
          var method = 'on' + event.type;
          if (this[method]) {
            this[method](event);
          }
        };
        proto.getSize = function () {
          this.size = getSize(this.element);
        };

        /**
         * apply CSS styles to element
         * @param {Object} style
         */
        proto.css = function (style) {
          var elemStyle = this.element.style;
          for (var prop in style) {
            // use vendor property if available
            var supportedProp = vendorProperties[prop] || prop;
            elemStyle[supportedProp] = style[prop];
          }
        };

        // measure position, and sets it
        proto.getPosition = function () {
          var style = getComputedStyle(this.element);
          var isOriginLeft = this.layout._getOption('originLeft');
          var isOriginTop = this.layout._getOption('originTop');
          var xValue = style[isOriginLeft ? 'left' : 'right'];
          var yValue = style[isOriginTop ? 'top' : 'bottom'];
          var x = parseFloat(xValue);
          var y = parseFloat(yValue);
          // convert percent to pixels
          var layoutSize = this.layout.size;
          if (xValue.indexOf('%') != -1) {
            x = x / 100 * layoutSize.width;
          }
          if (yValue.indexOf('%') != -1) {
            y = y / 100 * layoutSize.height;
          }
          // clean up 'auto' or other non-integer values
          x = isNaN(x) ? 0 : x;
          y = isNaN(y) ? 0 : y;
          // remove padding from measurement
          x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
          y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;
          this.position.x = x;
          this.position.y = y;
        };

        // set settled position, apply padding
        proto.layoutPosition = function () {
          var layoutSize = this.layout.size;
          var style = {};
          var isOriginLeft = this.layout._getOption('originLeft');
          var isOriginTop = this.layout._getOption('originTop');

          // x
          var xPadding = isOriginLeft ? 'paddingLeft' : 'paddingRight';
          var xProperty = isOriginLeft ? 'left' : 'right';
          var xResetProperty = isOriginLeft ? 'right' : 'left';
          var x = this.position.x + layoutSize[xPadding];
          // set in percentage or pixels
          style[xProperty] = this.getXValue(x);
          // reset other property
          style[xResetProperty] = '';

          // y
          var yPadding = isOriginTop ? 'paddingTop' : 'paddingBottom';
          var yProperty = isOriginTop ? 'top' : 'bottom';
          var yResetProperty = isOriginTop ? 'bottom' : 'top';
          var y = this.position.y + layoutSize[yPadding];
          // set in percentage or pixels
          style[yProperty] = this.getYValue(y);
          // reset other property
          style[yResetProperty] = '';
          this.css(style);
          this.emitEvent('layout', [this]);
        };
        proto.getXValue = function (x) {
          var isHorizontal = this.layout._getOption('horizontal');
          return this.layout.options.percentPosition && !isHorizontal ? x / this.layout.size.width * 100 + '%' : x + 'px';
        };
        proto.getYValue = function (y) {
          var isHorizontal = this.layout._getOption('horizontal');
          return this.layout.options.percentPosition && isHorizontal ? y / this.layout.size.height * 100 + '%' : y + 'px';
        };
        proto._transitionTo = function (x, y) {
          this.getPosition();
          // get current x & y from top/left
          var curX = this.position.x;
          var curY = this.position.y;
          var didNotMove = x == this.position.x && y == this.position.y;

          // save end position
          this.setPosition(x, y);

          // if did not move and not transitioning, just go to layout
          if (didNotMove && !this.isTransitioning) {
            this.layoutPosition();
            return;
          }
          var transX = x - curX;
          var transY = y - curY;
          var transitionStyle = {};
          transitionStyle.transform = this.getTranslate(transX, transY);
          this.transition({
            to: transitionStyle,
            onTransitionEnd: {
              transform: this.layoutPosition
            },
            isCleaning: true
          });
        };
        proto.getTranslate = function (x, y) {
          // flip cooridinates if origin on right or bottom
          var isOriginLeft = this.layout._getOption('originLeft');
          var isOriginTop = this.layout._getOption('originTop');
          x = isOriginLeft ? x : -x;
          y = isOriginTop ? y : -y;
          return 'translate3d(' + x + 'px, ' + y + 'px, 0)';
        };

        // non transition + transform support
        proto.goTo = function (x, y) {
          this.setPosition(x, y);
          this.layoutPosition();
        };
        proto.moveTo = proto._transitionTo;
        proto.setPosition = function (x, y) {
          this.position.x = parseFloat(x);
          this.position.y = parseFloat(y);
        };

        // ----- transition ----- //

        /**
         * @param {Object} style - CSS
         * @param {Function} onTransitionEnd
         */

        // non transition, just trigger callback
        proto._nonTransition = function (args) {
          this.css(args.to);
          if (args.isCleaning) {
            this._removeStyles(args.to);
          }
          for (var prop in args.onTransitionEnd) {
            args.onTransitionEnd[prop].call(this);
          }
        };

        /**
         * proper transition
         * @param {Object} args - arguments
         *   @param {Object} to - style to transition to
         *   @param {Object} from - style to start transition from
         *   @param {Boolean} isCleaning - removes transition styles after transition
         *   @param {Function} onTransitionEnd - callback
         */
        proto.transition = function (args) {
          // redirect to nonTransition if no transition duration
          if (!parseFloat(this.layout.options.transitionDuration)) {
            this._nonTransition(args);
            return;
          }
          var _transition = this._transn;
          // keep track of onTransitionEnd callback by css property
          for (var prop in args.onTransitionEnd) {
            _transition.onEnd[prop] = args.onTransitionEnd[prop];
          }
          // keep track of properties that are transitioning
          for (prop in args.to) {
            _transition.ingProperties[prop] = true;
            // keep track of properties to clean up when transition is done
            if (args.isCleaning) {
              _transition.clean[prop] = true;
            }
          }

          // set from styles
          if (args.from) {
            this.css(args.from);
            // force redraw. http://blog.alexmaccaw.com/css-transitions
            this.element.offsetHeight;
          }
          // enable transition
          this.enableTransition(args.to);
          // set styles that are transitioning
          this.css(args.to);
          this.isTransitioning = true;
        };

        // dash before all cap letters, including first for
        // WebkitTransform => -webkit-transform
        function toDashedAll(str) {
          return str.replace(/([A-Z])/g, function ($1) {
            return '-' + $1.toLowerCase();
          });
        }
        var transitionProps = 'opacity,' + toDashedAll(transformProperty);
        proto.enableTransition = function /* style */
        () {
          // HACK changing transitionProperty during a transition
          // will cause transition to jump
          if (this.isTransitioning) {
            return;
          }

          // make `transition: foo, bar, baz` from style object
          // HACK un-comment this when enableTransition can work
          // while a transition is happening
          // var transitionValues = [];
          // for ( var prop in style ) {
          //   // dash-ify camelCased properties like WebkitTransition
          //   prop = vendorProperties[ prop ] || prop;
          //   transitionValues.push( toDashedAll( prop ) );
          // }
          // munge number to millisecond, to match stagger
          var duration = this.layout.options.transitionDuration;
          duration = typeof duration == 'number' ? duration + 'ms' : duration;
          // enable transition styles
          this.css({
            transitionProperty: transitionProps,
            transitionDuration: duration,
            transitionDelay: this.staggerDelay || 0
          });
          // listen for transition end event
          this.element.addEventListener(transitionEndEvent, this, false);
        };

        // ----- events ----- //

        proto.onwebkitTransitionEnd = function (event) {
          this.ontransitionend(event);
        };
        proto.onotransitionend = function (event) {
          this.ontransitionend(event);
        };

        // properties that I munge to make my life easier
        var dashedVendorProperties = {
          '-webkit-transform': 'transform'
        };
        proto.ontransitionend = function (event) {
          // disregard bubbled events from children
          if (event.target !== this.element) {
            return;
          }
          var _transition = this._transn;
          // get property name of transitioned property, convert to prefix-free
          var propertyName = dashedVendorProperties[event.propertyName] || event.propertyName;

          // remove property that has completed transitioning
          delete _transition.ingProperties[propertyName];
          // check if any properties are still transitioning
          if (isEmptyObj(_transition.ingProperties)) {
            // all properties have completed transitioning
            this.disableTransition();
          }
          // clean style
          if (propertyName in _transition.clean) {
            // clean up style
            this.element.style[event.propertyName] = '';
            delete _transition.clean[propertyName];
          }
          // trigger onTransitionEnd callback
          if (propertyName in _transition.onEnd) {
            var onTransitionEnd = _transition.onEnd[propertyName];
            onTransitionEnd.call(this);
            delete _transition.onEnd[propertyName];
          }
          this.emitEvent('transitionEnd', [this]);
        };
        proto.disableTransition = function () {
          this.removeTransitionStyles();
          this.element.removeEventListener(transitionEndEvent, this, false);
          this.isTransitioning = false;
        };

        /**
         * removes style property from element
         * @param {Object} style
        **/
        proto._removeStyles = function (style) {
          // clean up transition styles
          var cleanStyle = {};
          for (var prop in style) {
            cleanStyle[prop] = '';
          }
          this.css(cleanStyle);
        };
        var cleanTransitionStyle = {
          transitionProperty: '',
          transitionDuration: '',
          transitionDelay: ''
        };
        proto.removeTransitionStyles = function () {
          // remove transition
          this.css(cleanTransitionStyle);
        };

        // ----- stagger ----- //

        proto.stagger = function (delay) {
          delay = isNaN(delay) ? 0 : delay;
          this.staggerDelay = delay + 'ms';
        };

        // ----- show/hide/remove ----- //

        // remove element from DOM
        proto.removeElem = function () {
          this.element.parentNode.removeChild(this.element);
          // remove display: none
          this.css({
            display: ''
          });
          this.emitEvent('remove', [this]);
        };
        proto.remove = function () {
          // just remove element if no transition support or no transition
          if (!transitionProperty || !parseFloat(this.layout.options.transitionDuration)) {
            this.removeElem();
            return;
          }

          // start transition
          this.once('transitionEnd', function () {
            this.removeElem();
          });
          this.hide();
        };
        proto.reveal = function () {
          delete this.isHidden;
          // remove display: none
          this.css({
            display: ''
          });
          var options = this.layout.options;
          var onTransitionEnd = {};
          var transitionEndProperty = this.getHideRevealTransitionEndProperty('visibleStyle');
          onTransitionEnd[transitionEndProperty] = this.onRevealTransitionEnd;
          this.transition({
            from: options.hiddenStyle,
            to: options.visibleStyle,
            isCleaning: true,
            onTransitionEnd: onTransitionEnd
          });
        };
        proto.onRevealTransitionEnd = function () {
          // check if still visible
          // during transition, item may have been hidden
          if (!this.isHidden) {
            this.emitEvent('reveal');
          }
        };

        /**
         * get style property use for hide/reveal transition end
         * @param {String} styleProperty - hiddenStyle/visibleStyle
         * @returns {String}
         */
        proto.getHideRevealTransitionEndProperty = function (styleProperty) {
          var optionStyle = this.layout.options[styleProperty];
          // use opacity
          if (optionStyle.opacity) {
            return 'opacity';
          }
          // get first property
          for (var prop in optionStyle) {
            return prop;
          }
        };
        proto.hide = function () {
          // set flag
          this.isHidden = true;
          // remove display: none
          this.css({
            display: ''
          });
          var options = this.layout.options;
          var onTransitionEnd = {};
          var transitionEndProperty = this.getHideRevealTransitionEndProperty('hiddenStyle');
          onTransitionEnd[transitionEndProperty] = this.onHideTransitionEnd;
          this.transition({
            from: options.visibleStyle,
            to: options.hiddenStyle,
            // keep hidden stuff hidden
            isCleaning: true,
            onTransitionEnd: onTransitionEnd
          });
        };
        proto.onHideTransitionEnd = function () {
          // check if still hidden
          // during transition, item may have been un-hidden
          if (this.isHidden) {
            this.css({
              display: 'none'
            });
            this.emitEvent('hide');
          }
        };
        proto.destroy = function () {
          this.css({
            position: '',
            left: '',
            right: '',
            top: '',
            bottom: '',
            transition: '',
            transform: ''
          });
        };
        return Item;
      });
    })(item$1);

    /*!
     * Outlayer v2.1.1
     * the brains and guts of a layout library
     * MIT license
     */
    (function (module) {
      (function (window, factory) {

        // universal module definition
        /* jshint strict: false */ /* globals define, module, require */
        if (module.exports) {
          // CommonJS - Browserify, Webpack
          module.exports = factory(window, evEmitter.exports, getSize.exports, utils.exports, item$1.exports);
        } else {
          // browser global
          window.Outlayer = factory(window, window.EvEmitter, window.getSize, window.fizzyUIUtils, window.Outlayer.Item);
        }
      })(window, function factory(window, EvEmitter, getSize, utils, Item) {

        // ----- vars ----- //
        var console = window.console;
        var jQuery = window.jQuery;
        var noop = function () {};

        // -------------------------- Outlayer -------------------------- //

        // globally unique identifiers
        var GUID = 0;
        // internal store of all Outlayer intances
        var instances = {};

        /**
         * @param {Element, String} element
         * @param {Object} options
         * @constructor
         */
        function Outlayer(element, options) {
          var queryElement = utils.getQueryElement(element);
          if (!queryElement) {
            if (console) {
              console.error('Bad element for ' + this.constructor.namespace + ': ' + (queryElement || element));
            }
            return;
          }
          this.element = queryElement;
          // add jQuery
          if (jQuery) {
            this.$element = jQuery(this.element);
          }

          // options
          this.options = utils.extend({}, this.constructor.defaults);
          this.option(options);

          // add id for Outlayer.getFromElement
          var id = ++GUID;
          this.element.outlayerGUID = id; // expando
          instances[id] = this; // associate via id

          // kick it off
          this._create();
          var isInitLayout = this._getOption('initLayout');
          if (isInitLayout) {
            this.layout();
          }
        }

        // settings are for internal use only
        Outlayer.namespace = 'outlayer';
        Outlayer.Item = Item;

        // default options
        Outlayer.defaults = {
          containerStyle: {
            position: 'relative'
          },
          initLayout: true,
          originLeft: true,
          originTop: true,
          resize: true,
          resizeContainer: true,
          // item options
          transitionDuration: '0.4s',
          hiddenStyle: {
            opacity: 0,
            transform: 'scale(0.001)'
          },
          visibleStyle: {
            opacity: 1,
            transform: 'scale(1)'
          }
        };
        var proto = Outlayer.prototype;
        // inherit EvEmitter
        utils.extend(proto, EvEmitter.prototype);

        /**
         * set options
         * @param {Object} opts
         */
        proto.option = function (opts) {
          utils.extend(this.options, opts);
        };

        /**
         * get backwards compatible option value, check old name
         */
        proto._getOption = function (option) {
          var oldOption = this.constructor.compatOptions[option];
          return oldOption && this.options[oldOption] !== undefined ? this.options[oldOption] : this.options[option];
        };
        Outlayer.compatOptions = {
          // currentName: oldName
          initLayout: 'isInitLayout',
          horizontal: 'isHorizontal',
          layoutInstant: 'isLayoutInstant',
          originLeft: 'isOriginLeft',
          originTop: 'isOriginTop',
          resize: 'isResizeBound',
          resizeContainer: 'isResizingContainer'
        };
        proto._create = function () {
          // get items from children
          this.reloadItems();
          // elements that affect layout, but are not laid out
          this.stamps = [];
          this.stamp(this.options.stamp);
          // set container style
          utils.extend(this.element.style, this.options.containerStyle);

          // bind resize method
          var canBindResize = this._getOption('resize');
          if (canBindResize) {
            this.bindResize();
          }
        };

        // goes through all children again and gets bricks in proper order
        proto.reloadItems = function () {
          // collection of item elements
          this.items = this._itemize(this.element.children);
        };

        /**
         * turn elements into Outlayer.Items to be used in layout
         * @param {Array or NodeList or HTMLElement} elems
         * @returns {Array} items - collection of new Outlayer Items
         */
        proto._itemize = function (elems) {
          var itemElems = this._filterFindItemElements(elems);
          var Item = this.constructor.Item;

          // create new Outlayer Items for collection
          var items = [];
          for (var i = 0; i < itemElems.length; i++) {
            var elem = itemElems[i];
            var item = new Item(elem, this);
            items.push(item);
          }
          return items;
        };

        /**
         * get item elements to be used in layout
         * @param {Array or NodeList or HTMLElement} elems
         * @returns {Array} items - item elements
         */
        proto._filterFindItemElements = function (elems) {
          return utils.filterFindElements(elems, this.options.itemSelector);
        };

        /**
         * getter method for getting item elements
         * @returns {Array} elems - collection of item elements
         */
        proto.getItemElements = function () {
          return this.items.map(function (item) {
            return item.element;
          });
        };

        // ----- init & layout ----- //

        /**
         * lays out all items
         */
        proto.layout = function () {
          this._resetLayout();
          this._manageStamps();

          // don't animate first layout
          var layoutInstant = this._getOption('layoutInstant');
          var isInstant = layoutInstant !== undefined ? layoutInstant : !this._isLayoutInited;
          this.layoutItems(this.items, isInstant);

          // flag for initalized
          this._isLayoutInited = true;
        };

        // _init is alias for layout
        proto._init = proto.layout;

        /**
         * logic before any new layout
         */
        proto._resetLayout = function () {
          this.getSize();
        };
        proto.getSize = function () {
          this.size = getSize(this.element);
        };

        /**
         * get measurement from option, for columnWidth, rowHeight, gutter
         * if option is String -> get element from selector string, & get size of element
         * if option is Element -> get size of element
         * else use option as a number
         *
         * @param {String} measurement
         * @param {String} size - width or height
         * @private
         */
        proto._getMeasurement = function (measurement, size) {
          var option = this.options[measurement];
          var elem;
          if (!option) {
            // default to 0
            this[measurement] = 0;
          } else {
            // use option as an element
            if (typeof option == 'string') {
              elem = this.element.querySelector(option);
            } else if (option instanceof HTMLElement) {
              elem = option;
            }
            // use size of element, if element
            this[measurement] = elem ? getSize(elem)[size] : option;
          }
        };

        /**
         * layout a collection of item elements
         * @api public
         */
        proto.layoutItems = function (items, isInstant) {
          items = this._getItemsForLayout(items);
          this._layoutItems(items, isInstant);
          this._postLayout();
        };

        /**
         * get the items to be laid out
         * you may want to skip over some items
         * @param {Array} items
         * @returns {Array} items
         */
        proto._getItemsForLayout = function (items) {
          return items.filter(function (item) {
            return !item.isIgnored;
          });
        };

        /**
         * layout items
         * @param {Array} items
         * @param {Boolean} isInstant
         */
        proto._layoutItems = function (items, isInstant) {
          this._emitCompleteOnItems('layout', items);
          if (!items || !items.length) {
            // no items, emit event with empty array
            return;
          }
          var queue = [];
          items.forEach(function (item) {
            // get x/y object from method
            var position = this._getItemLayoutPosition(item);
            // enqueue
            position.item = item;
            position.isInstant = isInstant || item.isLayoutInstant;
            queue.push(position);
          }, this);
          this._processLayoutQueue(queue);
        };

        /**
         * get item layout position
         * @param {Outlayer.Item} item
         * @returns {Object} x and y position
         */
        proto._getItemLayoutPosition = function /* item */
        () {
          return {
            x: 0,
            y: 0
          };
        };

        /**
         * iterate over array and position each item
         * Reason being - separating this logic prevents 'layout invalidation'
         * thx @paul_irish
         * @param {Array} queue
         */
        proto._processLayoutQueue = function (queue) {
          this.updateStagger();
          queue.forEach(function (obj, i) {
            this._positionItem(obj.item, obj.x, obj.y, obj.isInstant, i);
          }, this);
        };

        // set stagger from option in milliseconds number
        proto.updateStagger = function () {
          var stagger = this.options.stagger;
          if (stagger === null || stagger === undefined) {
            this.stagger = 0;
            return;
          }
          this.stagger = getMilliseconds(stagger);
          return this.stagger;
        };

        /**
         * Sets position of item in DOM
         * @param {Outlayer.Item} item
         * @param {Number} x - horizontal position
         * @param {Number} y - vertical position
         * @param {Boolean} isInstant - disables transitions
         */
        proto._positionItem = function (item, x, y, isInstant, i) {
          if (isInstant) {
            // if not transition, just set CSS
            item.goTo(x, y);
          } else {
            item.stagger(i * this.stagger);
            item.moveTo(x, y);
          }
        };

        /**
         * Any logic you want to do after each layout,
         * i.e. size the container
         */
        proto._postLayout = function () {
          this.resizeContainer();
        };
        proto.resizeContainer = function () {
          var isResizingContainer = this._getOption('resizeContainer');
          if (!isResizingContainer) {
            return;
          }
          var size = this._getContainerSize();
          if (size) {
            this._setContainerMeasure(size.width, true);
            this._setContainerMeasure(size.height, false);
          }
        };

        /**
         * Sets width or height of container if returned
         * @returns {Object} size
         *   @param {Number} width
         *   @param {Number} height
         */
        proto._getContainerSize = noop;

        /**
         * @param {Number} measure - size of width or height
         * @param {Boolean} isWidth
         */
        proto._setContainerMeasure = function (measure, isWidth) {
          if (measure === undefined) {
            return;
          }
          var elemSize = this.size;
          // add padding and border width if border box
          if (elemSize.isBorderBox) {
            measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight + elemSize.borderLeftWidth + elemSize.borderRightWidth : elemSize.paddingBottom + elemSize.paddingTop + elemSize.borderTopWidth + elemSize.borderBottomWidth;
          }
          measure = Math.max(measure, 0);
          this.element.style[isWidth ? 'width' : 'height'] = measure + 'px';
        };

        /**
         * emit eventComplete on a collection of items events
         * @param {String} eventName
         * @param {Array} items - Outlayer.Items
         */
        proto._emitCompleteOnItems = function (eventName, items) {
          var _this = this;
          function onComplete() {
            _this.dispatchEvent(eventName + 'Complete', null, [items]);
          }
          var count = items.length;
          if (!items || !count) {
            onComplete();
            return;
          }
          var doneCount = 0;
          function tick() {
            doneCount++;
            if (doneCount == count) {
              onComplete();
            }
          }

          // bind callback
          items.forEach(function (item) {
            item.once(eventName, tick);
          });
        };

        /**
         * emits events via EvEmitter and jQuery events
         * @param {String} type - name of event
         * @param {Event} event - original event
         * @param {Array} args - extra arguments
         */
        proto.dispatchEvent = function (type, event, args) {
          // add original event to arguments
          var emitArgs = event ? [event].concat(args) : args;
          this.emitEvent(type, emitArgs);
          if (jQuery) {
            // set this.$element
            this.$element = this.$element || jQuery(this.element);
            if (event) {
              // create jQuery event
              var $event = jQuery.Event(event);
              $event.type = type;
              this.$element.trigger($event, args);
            } else {
              // just trigger with type if no event available
              this.$element.trigger(type, args);
            }
          }
        };

        // -------------------------- ignore & stamps -------------------------- //

        /**
         * keep item in collection, but do not lay it out
         * ignored items do not get skipped in layout
         * @param {Element} elem
         */
        proto.ignore = function (elem) {
          var item = this.getItem(elem);
          if (item) {
            item.isIgnored = true;
          }
        };

        /**
         * return item to layout collection
         * @param {Element} elem
         */
        proto.unignore = function (elem) {
          var item = this.getItem(elem);
          if (item) {
            delete item.isIgnored;
          }
        };

        /**
         * adds elements to stamps
         * @param {NodeList, Array, Element, or String} elems
         */
        proto.stamp = function (elems) {
          elems = this._find(elems);
          if (!elems) {
            return;
          }
          this.stamps = this.stamps.concat(elems);
          // ignore
          elems.forEach(this.ignore, this);
        };

        /**
         * removes elements to stamps
         * @param {NodeList, Array, or Element} elems
         */
        proto.unstamp = function (elems) {
          elems = this._find(elems);
          if (!elems) {
            return;
          }
          elems.forEach(function (elem) {
            // filter out removed stamp elements
            utils.removeFrom(this.stamps, elem);
            this.unignore(elem);
          }, this);
        };

        /**
         * finds child elements
         * @param {NodeList, Array, Element, or String} elems
         * @returns {Array} elems
         */
        proto._find = function (elems) {
          if (!elems) {
            return;
          }
          // if string, use argument as selector string
          if (typeof elems == 'string') {
            elems = this.element.querySelectorAll(elems);
          }
          elems = utils.makeArray(elems);
          return elems;
        };
        proto._manageStamps = function () {
          if (!this.stamps || !this.stamps.length) {
            return;
          }
          this._getBoundingRect();
          this.stamps.forEach(this._manageStamp, this);
        };

        // update boundingLeft / Top
        proto._getBoundingRect = function () {
          // get bounding rect for container element
          var boundingRect = this.element.getBoundingClientRect();
          var size = this.size;
          this._boundingRect = {
            left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,
            top: boundingRect.top + size.paddingTop + size.borderTopWidth,
            right: boundingRect.right - (size.paddingRight + size.borderRightWidth),
            bottom: boundingRect.bottom - (size.paddingBottom + size.borderBottomWidth)
          };
        };

        /**
         * @param {Element} stamp
        **/
        proto._manageStamp = noop;

        /**
         * get x/y position of element relative to container element
         * @param {Element} elem
         * @returns {Object} offset - has left, top, right, bottom
         */
        proto._getElementOffset = function (elem) {
          var boundingRect = elem.getBoundingClientRect();
          var thisRect = this._boundingRect;
          var size = getSize(elem);
          var offset = {
            left: boundingRect.left - thisRect.left - size.marginLeft,
            top: boundingRect.top - thisRect.top - size.marginTop,
            right: thisRect.right - boundingRect.right - size.marginRight,
            bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom
          };
          return offset;
        };

        // -------------------------- resize -------------------------- //

        // enable event handlers for listeners
        // i.e. resize -> onresize
        proto.handleEvent = utils.handleEvent;

        /**
         * Bind layout to window resizing
         */
        proto.bindResize = function () {
          window.addEventListener('resize', this);
          this.isResizeBound = true;
        };

        /**
         * Unbind layout to window resizing
         */
        proto.unbindResize = function () {
          window.removeEventListener('resize', this);
          this.isResizeBound = false;
        };
        proto.onresize = function () {
          this.resize();
        };
        utils.debounceMethod(Outlayer, 'onresize', 100);
        proto.resize = function () {
          // don't trigger if size did not change
          // or if resize was unbound. See #9
          if (!this.isResizeBound || !this.needsResizeLayout()) {
            return;
          }
          this.layout();
        };

        /**
         * check if layout is needed post layout
         * @returns Boolean
         */
        proto.needsResizeLayout = function () {
          var size = getSize(this.element);
          // check that this.size and size are there
          // IE8 triggers resize on body size change, so they might not be
          var hasSizes = this.size && size;
          return hasSizes && size.innerWidth !== this.size.innerWidth;
        };

        // -------------------------- methods -------------------------- //

        /**
         * add items to Outlayer instance
         * @param {Array or NodeList or Element} elems
         * @returns {Array} items - Outlayer.Items
        **/
        proto.addItems = function (elems) {
          var items = this._itemize(elems);
          // add items to collection
          if (items.length) {
            this.items = this.items.concat(items);
          }
          return items;
        };

        /**
         * Layout newly-appended item elements
         * @param {Array or NodeList or Element} elems
         */
        proto.appended = function (elems) {
          var items = this.addItems(elems);
          if (!items.length) {
            return;
          }
          // layout and reveal just the new items
          this.layoutItems(items, true);
          this.reveal(items);
        };

        /**
         * Layout prepended elements
         * @param {Array or NodeList or Element} elems
         */
        proto.prepended = function (elems) {
          var items = this._itemize(elems);
          if (!items.length) {
            return;
          }
          // add items to beginning of collection
          var previousItems = this.items.slice(0);
          this.items = items.concat(previousItems);
          // start new layout
          this._resetLayout();
          this._manageStamps();
          // layout new stuff without transition
          this.layoutItems(items, true);
          this.reveal(items);
          // layout previous items
          this.layoutItems(previousItems);
        };

        /**
         * reveal a collection of items
         * @param {Array of Outlayer.Items} items
         */
        proto.reveal = function (items) {
          this._emitCompleteOnItems('reveal', items);
          if (!items || !items.length) {
            return;
          }
          var stagger = this.updateStagger();
          items.forEach(function (item, i) {
            item.stagger(i * stagger);
            item.reveal();
          });
        };

        /**
         * hide a collection of items
         * @param {Array of Outlayer.Items} items
         */
        proto.hide = function (items) {
          this._emitCompleteOnItems('hide', items);
          if (!items || !items.length) {
            return;
          }
          var stagger = this.updateStagger();
          items.forEach(function (item, i) {
            item.stagger(i * stagger);
            item.hide();
          });
        };

        /**
         * reveal item elements
         * @param {Array}, {Element}, {NodeList} items
         */
        proto.revealItemElements = function (elems) {
          var items = this.getItems(elems);
          this.reveal(items);
        };

        /**
         * hide item elements
         * @param {Array}, {Element}, {NodeList} items
         */
        proto.hideItemElements = function (elems) {
          var items = this.getItems(elems);
          this.hide(items);
        };

        /**
         * get Outlayer.Item, given an Element
         * @param {Element} elem
         * @param {Function} callback
         * @returns {Outlayer.Item} item
         */
        proto.getItem = function (elem) {
          // loop through items to get the one that matches
          for (var i = 0; i < this.items.length; i++) {
            var item = this.items[i];
            if (item.element == elem) {
              // return item
              return item;
            }
          }
        };

        /**
         * get collection of Outlayer.Items, given Elements
         * @param {Array} elems
         * @returns {Array} items - Outlayer.Items
         */
        proto.getItems = function (elems) {
          elems = utils.makeArray(elems);
          var items = [];
          elems.forEach(function (elem) {
            var item = this.getItem(elem);
            if (item) {
              items.push(item);
            }
          }, this);
          return items;
        };

        /**
         * remove element(s) from instance and DOM
         * @param {Array or NodeList or Element} elems
         */
        proto.remove = function (elems) {
          var removeItems = this.getItems(elems);
          this._emitCompleteOnItems('remove', removeItems);

          // bail if no items to remove
          if (!removeItems || !removeItems.length) {
            return;
          }
          removeItems.forEach(function (item) {
            item.remove();
            // remove item from collection
            utils.removeFrom(this.items, item);
          }, this);
        };

        // ----- destroy ----- //

        // remove and disable Outlayer instance
        proto.destroy = function () {
          // clean up dynamic styles
          var style = this.element.style;
          style.height = '';
          style.position = '';
          style.width = '';
          // destroy items
          this.items.forEach(function (item) {
            item.destroy();
          });
          this.unbindResize();
          var id = this.element.outlayerGUID;
          delete instances[id]; // remove reference to instance by id
          delete this.element.outlayerGUID;
          // remove data for jQuery
          if (jQuery) {
            jQuery.removeData(this.element, this.constructor.namespace);
          }
        };

        // -------------------------- data -------------------------- //

        /**
         * get Outlayer instance from element
         * @param {Element} elem
         * @returns {Outlayer}
         */
        Outlayer.data = function (elem) {
          elem = utils.getQueryElement(elem);
          var id = elem && elem.outlayerGUID;
          return id && instances[id];
        };

        // -------------------------- create Outlayer class -------------------------- //

        /**
         * create a layout class
         * @param {String} namespace
         */
        Outlayer.create = function (namespace, options) {
          // sub-class Outlayer
          var Layout = subclass(Outlayer);
          // apply new options and compatOptions
          Layout.defaults = utils.extend({}, Outlayer.defaults);
          utils.extend(Layout.defaults, options);
          Layout.compatOptions = utils.extend({}, Outlayer.compatOptions);
          Layout.namespace = namespace;
          Layout.data = Outlayer.data;

          // sub-class Item
          Layout.Item = subclass(Item);

          // -------------------------- declarative -------------------------- //

          utils.htmlInit(Layout, namespace);

          // -------------------------- jQuery bridge -------------------------- //

          // make into jQuery plugin
          if (jQuery && jQuery.bridget) {
            jQuery.bridget(namespace, Layout);
          }
          return Layout;
        };
        function subclass(Parent) {
          function SubClass() {
            Parent.apply(this, arguments);
          }
          SubClass.prototype = Object.create(Parent.prototype);
          SubClass.prototype.constructor = SubClass;
          return SubClass;
        }

        // ----- helpers ----- //

        // how many milliseconds are in each unit
        var msUnits = {
          ms: 1,
          s: 1000
        };

        // munge time-like parameter into millisecond number
        // '0.4s' -> 40
        function getMilliseconds(time) {
          if (typeof time == 'number') {
            return time;
          }
          var matches = time.match(/(^\d*\.?\d*)(\w*)/);
          var num = matches && matches[1];
          var unit = matches && matches[2];
          if (!num.length) {
            return 0;
          }
          num = parseFloat(num);
          var mult = msUnits[unit] || 1;
          return num * mult;
        }

        // ----- fin ----- //

        // back in global
        Outlayer.Item = Item;
        return Outlayer;
      });
    })(outlayer);

    var item = {exports: {}};

    /**
     * Isotope Item
    **/
    (function (module) {
      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */ /*globals define, module, require */
        if (module.exports) {
          // CommonJS
          module.exports = factory(outlayer.exports);
        } else {
          // browser global
          window.Isotope = window.Isotope || {};
          window.Isotope.Item = factory(window.Outlayer);
        }
      })(window, function factory(Outlayer) {

        // -------------------------- Item -------------------------- //

        // sub-class Outlayer Item
        function Item() {
          Outlayer.Item.apply(this, arguments);
        }
        var proto = Item.prototype = Object.create(Outlayer.Item.prototype);
        var _create = proto._create;
        proto._create = function () {
          // assign id, used for original-order sorting
          this.id = this.layout.itemGUID++;
          _create.call(this);
          this.sortData = {};
        };
        proto.updateSortData = function () {
          if (this.isIgnored) {
            return;
          }
          // default sorters
          this.sortData.id = this.id;
          // for backward compatibility
          this.sortData['original-order'] = this.id;
          this.sortData.random = Math.random();
          // go thru getSortData obj and apply the sorters
          var getSortData = this.layout.options.getSortData;
          var sorters = this.layout._sorters;
          for (var key in getSortData) {
            var sorter = sorters[key];
            this.sortData[key] = sorter(this.element, this);
          }
        };
        var _destroy = proto.destroy;
        proto.destroy = function () {
          // call super
          _destroy.apply(this, arguments);
          // reset display, #741
          this.css({
            display: ''
          });
        };
        return Item;
      });
    })(item);

    var layoutMode = {exports: {}};

    /**
     * Isotope LayoutMode
     */
    (function (module) {
      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */ /*globals define, module, require */
        if (module.exports) {
          // CommonJS
          module.exports = factory(getSize.exports, outlayer.exports);
        } else {
          // browser global
          window.Isotope = window.Isotope || {};
          window.Isotope.LayoutMode = factory(window.getSize, window.Outlayer);
        }
      })(window, function factory(getSize, Outlayer) {

        // layout mode class
        function LayoutMode(isotope) {
          this.isotope = isotope;
          // link properties
          if (isotope) {
            this.options = isotope.options[this.namespace];
            this.element = isotope.element;
            this.items = isotope.filteredItems;
            this.size = isotope.size;
          }
        }
        var proto = LayoutMode.prototype;

        /**
         * some methods should just defer to default Outlayer method
         * and reference the Isotope instance as `this`
        **/
        var facadeMethods = ['_resetLayout', '_getItemLayoutPosition', '_manageStamp', '_getContainerSize', '_getElementOffset', 'needsResizeLayout', '_getOption'];
        facadeMethods.forEach(function (methodName) {
          proto[methodName] = function () {
            return Outlayer.prototype[methodName].apply(this.isotope, arguments);
          };
        });

        // -----  ----- //

        // for horizontal layout modes, check vertical size
        proto.needsVerticalResizeLayout = function () {
          // don't trigger if size did not change
          var size = getSize(this.isotope.element);
          // check that this.size and size are there
          // IE8 triggers resize on body size change, so they might not be
          var hasSizes = this.isotope.size && size;
          return hasSizes && size.innerHeight != this.isotope.size.innerHeight;
        };

        // ----- measurements ----- //

        proto._getMeasurement = function () {
          this.isotope._getMeasurement.apply(this, arguments);
        };
        proto.getColumnWidth = function () {
          this.getSegmentSize('column', 'Width');
        };
        proto.getRowHeight = function () {
          this.getSegmentSize('row', 'Height');
        };

        /**
         * get columnWidth or rowHeight
         * segment: 'column' or 'row'
         * size 'Width' or 'Height'
        **/
        proto.getSegmentSize = function (segment, size) {
          var segmentName = segment + size;
          var outerSize = 'outer' + size;
          // columnWidth / outerWidth // rowHeight / outerHeight
          this._getMeasurement(segmentName, outerSize);
          // got rowHeight or columnWidth, we can chill
          if (this[segmentName]) {
            return;
          }
          // fall back to item of first element
          var firstItemSize = this.getFirstItemSize();
          this[segmentName] = firstItemSize && firstItemSize[outerSize] ||
          // or size of container
          this.isotope.size['inner' + size];
        };
        proto.getFirstItemSize = function () {
          var firstItem = this.isotope.filteredItems[0];
          return firstItem && firstItem.element && getSize(firstItem.element);
        };

        // ----- methods that should reference isotope ----- //

        proto.layout = function () {
          this.isotope.layout.apply(this.isotope, arguments);
        };
        proto.getSize = function () {
          this.isotope.getSize();
          this.size = this.isotope.size;
        };

        // -------------------------- create -------------------------- //

        LayoutMode.modes = {};
        LayoutMode.create = function (namespace, options) {
          function Mode() {
            LayoutMode.apply(this, arguments);
          }
          Mode.prototype = Object.create(proto);
          Mode.prototype.constructor = Mode;

          // default options
          if (options) {
            Mode.options = options;
          }
          Mode.prototype.namespace = namespace;
          // register in Isotope
          LayoutMode.modes[namespace] = Mode;
          return Mode;
        };
        return LayoutMode;
      });
    })(layoutMode);

    var masonry$1 = {exports: {}};

    var masonry = {exports: {}};

    /*!
     * Masonry v4.2.2
     * Cascading grid layout library
     * https://masonry.desandro.com
     * MIT License
     * by David DeSandro
     */
    (function (module) {
      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */ /*globals define, module, require */
        if (module.exports) {
          // CommonJS
          module.exports = factory(outlayer.exports, getSize.exports);
        } else {
          // browser global
          window.Masonry = factory(window.Outlayer, window.getSize);
        }
      })(window, function factory(Outlayer, getSize) {

        // -------------------------- masonryDefinition -------------------------- //

        // create an Outlayer layout class
        var Masonry = Outlayer.create('masonry');
        // isFitWidth -> fitWidth
        Masonry.compatOptions.fitWidth = 'isFitWidth';
        var proto = Masonry.prototype;
        proto._resetLayout = function () {
          this.getSize();
          this._getMeasurement('columnWidth', 'outerWidth');
          this._getMeasurement('gutter', 'outerWidth');
          this.measureColumns();

          // reset column Y
          this.colYs = [];
          for (var i = 0; i < this.cols; i++) {
            this.colYs.push(0);
          }
          this.maxY = 0;
          this.horizontalColIndex = 0;
        };
        proto.measureColumns = function () {
          this.getContainerWidth();
          // if columnWidth is 0, default to outerWidth of first item
          if (!this.columnWidth) {
            var firstItem = this.items[0];
            var firstItemElem = firstItem && firstItem.element;
            // columnWidth fall back to item of first element
            this.columnWidth = firstItemElem && getSize(firstItemElem).outerWidth ||
            // if first elem has no width, default to size of container
            this.containerWidth;
          }
          var columnWidth = this.columnWidth += this.gutter;

          // calculate columns
          var containerWidth = this.containerWidth + this.gutter;
          var cols = containerWidth / columnWidth;
          // fix rounding errors, typically with gutters
          var excess = columnWidth - containerWidth % columnWidth;
          // if overshoot is less than a pixel, round up, otherwise floor it
          var mathMethod = excess && excess < 1 ? 'round' : 'floor';
          cols = Math[mathMethod](cols);
          this.cols = Math.max(cols, 1);
        };
        proto.getContainerWidth = function () {
          // container is parent if fit width
          var isFitWidth = this._getOption('fitWidth');
          var container = isFitWidth ? this.element.parentNode : this.element;
          // check that this.size and size are there
          // IE8 triggers resize on body size change, so they might not be
          var size = getSize(container);
          this.containerWidth = size && size.innerWidth;
        };
        proto._getItemLayoutPosition = function (item) {
          item.getSize();
          // how many columns does this brick span
          var remainder = item.size.outerWidth % this.columnWidth;
          var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
          // round if off by 1 pixel, otherwise use ceil
          var colSpan = Math[mathMethod](item.size.outerWidth / this.columnWidth);
          colSpan = Math.min(colSpan, this.cols);
          // use horizontal or top column position
          var colPosMethod = this.options.horizontalOrder ? '_getHorizontalColPosition' : '_getTopColPosition';
          var colPosition = this[colPosMethod](colSpan, item);
          // position the brick
          var position = {
            x: this.columnWidth * colPosition.col,
            y: colPosition.y
          };
          // apply setHeight to necessary columns
          var setHeight = colPosition.y + item.size.outerHeight;
          var setMax = colSpan + colPosition.col;
          for (var i = colPosition.col; i < setMax; i++) {
            this.colYs[i] = setHeight;
          }
          return position;
        };
        proto._getTopColPosition = function (colSpan) {
          var colGroup = this._getTopColGroup(colSpan);
          // get the minimum Y value from the columns
          var minimumY = Math.min.apply(Math, colGroup);
          return {
            col: colGroup.indexOf(minimumY),
            y: minimumY
          };
        };

        /**
         * @param {Number} colSpan - number of columns the element spans
         * @returns {Array} colGroup
         */
        proto._getTopColGroup = function (colSpan) {
          if (colSpan < 2) {
            // if brick spans only one column, use all the column Ys
            return this.colYs;
          }
          var colGroup = [];
          // how many different places could this brick fit horizontally
          var groupCount = this.cols + 1 - colSpan;
          // for each group potential horizontal position
          for (var i = 0; i < groupCount; i++) {
            colGroup[i] = this._getColGroupY(i, colSpan);
          }
          return colGroup;
        };
        proto._getColGroupY = function (col, colSpan) {
          if (colSpan < 2) {
            return this.colYs[col];
          }
          // make an array of colY values for that one group
          var groupColYs = this.colYs.slice(col, col + colSpan);
          // and get the max value of the array
          return Math.max.apply(Math, groupColYs);
        };

        // get column position based on horizontal index. #873
        proto._getHorizontalColPosition = function (colSpan, item) {
          var col = this.horizontalColIndex % this.cols;
          var isOver = colSpan > 1 && col + colSpan > this.cols;
          // shift to next row if item can't fit on current row
          col = isOver ? 0 : col;
          // don't let zero-size items take up space
          var hasSize = item.size.outerWidth && item.size.outerHeight;
          this.horizontalColIndex = hasSize ? col + colSpan : this.horizontalColIndex;
          return {
            col: col,
            y: this._getColGroupY(col, colSpan)
          };
        };
        proto._manageStamp = function (stamp) {
          var stampSize = getSize(stamp);
          var offset = this._getElementOffset(stamp);
          // get the columns that this stamp affects
          var isOriginLeft = this._getOption('originLeft');
          var firstX = isOriginLeft ? offset.left : offset.right;
          var lastX = firstX + stampSize.outerWidth;
          var firstCol = Math.floor(firstX / this.columnWidth);
          firstCol = Math.max(0, firstCol);
          var lastCol = Math.floor(lastX / this.columnWidth);
          // lastCol should not go over if multiple of columnWidth #425
          lastCol -= lastX % this.columnWidth ? 0 : 1;
          lastCol = Math.min(this.cols - 1, lastCol);
          // set colYs to bottom of the stamp

          var isOriginTop = this._getOption('originTop');
          var stampMaxY = (isOriginTop ? offset.top : offset.bottom) + stampSize.outerHeight;
          for (var i = firstCol; i <= lastCol; i++) {
            this.colYs[i] = Math.max(stampMaxY, this.colYs[i]);
          }
        };
        proto._getContainerSize = function () {
          this.maxY = Math.max.apply(Math, this.colYs);
          var size = {
            height: this.maxY
          };
          if (this._getOption('fitWidth')) {
            size.width = this._getContainerFitWidth();
          }
          return size;
        };
        proto._getContainerFitWidth = function () {
          var unusedCols = 0;
          // count unused columns
          var i = this.cols;
          while (--i) {
            if (this.colYs[i] !== 0) {
              break;
            }
            unusedCols++;
          }
          // fit container to columns that have been used
          return (this.cols - unusedCols) * this.columnWidth - this.gutter;
        };
        proto.needsResizeLayout = function () {
          var previousWidth = this.containerWidth;
          this.getContainerWidth();
          return previousWidth != this.containerWidth;
        };
        return Masonry;
      });
    })(masonry);

    /*!
     * Masonry layout mode
     * sub-classes Masonry
     * https://masonry.desandro.com
     */
    (function (module) {
      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */ /*globals define, module, require */
        if (module.exports) {
          // CommonJS
          module.exports = factory(layoutMode.exports, masonry.exports);
        } else {
          // browser global
          factory(window.Isotope.LayoutMode, window.Masonry);
        }
      })(window, function factory(LayoutMode, Masonry) {

        // -------------------------- masonryDefinition -------------------------- //

        // create an Outlayer layout class
        var MasonryMode = LayoutMode.create('masonry');
        var proto = MasonryMode.prototype;
        var keepModeMethods = {
          _getElementOffset: true,
          layout: true,
          _getMeasurement: true
        };

        // inherit Masonry prototype
        for (var method in Masonry.prototype) {
          // do not inherit mode methods
          if (!keepModeMethods[method]) {
            proto[method] = Masonry.prototype[method];
          }
        }
        var measureColumns = proto.measureColumns;
        proto.measureColumns = function () {
          // set items, used if measuring first item
          this.items = this.isotope.filteredItems;
          measureColumns.call(this);
        };

        // point to mode options for fitWidth
        var _getOption = proto._getOption;
        proto._getOption = function (option) {
          if (option == 'fitWidth') {
            return this.options.isFitWidth !== undefined ? this.options.isFitWidth : this.options.fitWidth;
          }
          return _getOption.apply(this.isotope, arguments);
        };
        return MasonryMode;
      });
    })(masonry$1);

    var fitRows = {exports: {}};

    /**
     * fitRows layout mode
     */
    (function (module, exports) {
      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */ /*globals define, module, require */
        {
          // CommonJS
          module.exports = factory(layoutMode.exports);
        }
      })(window, function factory(LayoutMode) {

        var FitRows = LayoutMode.create('fitRows');
        var proto = FitRows.prototype;
        proto._resetLayout = function () {
          this.x = 0;
          this.y = 0;
          this.maxY = 0;
          this._getMeasurement('gutter', 'outerWidth');
        };
        proto._getItemLayoutPosition = function (item) {
          item.getSize();
          var itemWidth = item.size.outerWidth + this.gutter;
          // if this element cannot fit in the current row
          var containerWidth = this.isotope.size.innerWidth + this.gutter;
          if (this.x !== 0 && itemWidth + this.x > containerWidth) {
            this.x = 0;
            this.y = this.maxY;
          }
          var position = {
            x: this.x,
            y: this.y
          };
          this.maxY = Math.max(this.maxY, this.y + item.size.outerHeight);
          this.x += itemWidth;
          return position;
        };
        proto._getContainerSize = function () {
          return {
            height: this.maxY
          };
        };
        return FitRows;
      });
    })(fitRows);

    var vertical = {exports: {}};

    /**
     * vertical layout mode
     */
    (function (module) {
      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */ /*globals define, module, require */
        if (module.exports) {
          // CommonJS
          module.exports = factory(layoutMode.exports);
        } else {
          // browser global
          factory(window.Isotope.LayoutMode);
        }
      })(window, function factory(LayoutMode) {

        var Vertical = LayoutMode.create('vertical', {
          horizontalAlignment: 0
        });
        var proto = Vertical.prototype;
        proto._resetLayout = function () {
          this.y = 0;
        };
        proto._getItemLayoutPosition = function (item) {
          item.getSize();
          var x = (this.isotope.size.innerWidth - item.size.outerWidth) * this.options.horizontalAlignment;
          var y = this.y;
          this.y += item.size.outerHeight;
          return {
            x: x,
            y: y
          };
        };
        proto._getContainerSize = function () {
          return {
            height: this.y
          };
        };
        return Vertical;
      });
    })(vertical);

    /*!
     * Isotope v3.0.6
     *
     * Licensed GPLv3 for open source use
     * or Isotope Commercial License for commercial use
     *
     * https://isotope.metafizzy.co
     * Copyright 2010-2018 Metafizzy
     */
    (function (module) {
      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */ /*globals define, module, require */
        if (module.exports) {
          // CommonJS
          module.exports = factory(window, outlayer.exports, getSize.exports, matchesSelector.exports, utils.exports, item.exports, layoutMode.exports,
          // include default layout modes
          masonry$1.exports, fitRows.exports, vertical.exports);
        } else {
          // browser global
          window.Isotope = factory(window, window.Outlayer, window.getSize, window.matchesSelector, window.fizzyUIUtils, window.Isotope.Item, window.Isotope.LayoutMode);
        }
      })(window, function factory(window, Outlayer, getSize, matchesSelector, utils, Item, LayoutMode) {

        // -------------------------- vars -------------------------- //
        var jQuery = window.jQuery;

        // -------------------------- helpers -------------------------- //

        var trim = String.prototype.trim ? function (str) {
          return str.trim();
        } : function (str) {
          return str.replace(/^\s+|\s+$/g, '');
        };

        // -------------------------- isotopeDefinition -------------------------- //

        // create an Outlayer layout class
        var Isotope = Outlayer.create('isotope', {
          layoutMode: 'masonry',
          isJQueryFiltering: true,
          sortAscending: true
        });
        Isotope.Item = Item;
        Isotope.LayoutMode = LayoutMode;
        var proto = Isotope.prototype;
        proto._create = function () {
          this.itemGUID = 0;
          // functions that sort items
          this._sorters = {};
          this._getSorters();
          // call super
          Outlayer.prototype._create.call(this);

          // create layout modes
          this.modes = {};
          // start filteredItems with all items
          this.filteredItems = this.items;
          // keep of track of sortBys
          this.sortHistory = ['original-order'];
          // create from registered layout modes
          for (var name in LayoutMode.modes) {
            this._initLayoutMode(name);
          }
        };
        proto.reloadItems = function () {
          // reset item ID counter
          this.itemGUID = 0;
          // call super
          Outlayer.prototype.reloadItems.call(this);
        };
        proto._itemize = function () {
          var items = Outlayer.prototype._itemize.apply(this, arguments);
          // assign ID for original-order
          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            item.id = this.itemGUID++;
          }
          this._updateItemsSortData(items);
          return items;
        };

        // -------------------------- layout -------------------------- //

        proto._initLayoutMode = function (name) {
          var Mode = LayoutMode.modes[name];
          // set mode options
          // HACK extend initial options, back-fill in default options
          var initialOpts = this.options[name] || {};
          this.options[name] = Mode.options ? utils.extend(Mode.options, initialOpts) : initialOpts;
          // init layout mode instance
          this.modes[name] = new Mode(this);
        };
        proto.layout = function () {
          // if first time doing layout, do all magic
          if (!this._isLayoutInited && this._getOption('initLayout')) {
            this.arrange();
            return;
          }
          this._layout();
        };

        // private method to be used in layout() & magic()
        proto._layout = function () {
          // don't animate first layout
          var isInstant = this._getIsInstant();
          // layout flow
          this._resetLayout();
          this._manageStamps();
          this.layoutItems(this.filteredItems, isInstant);

          // flag for initalized
          this._isLayoutInited = true;
        };

        // filter + sort + layout
        proto.arrange = function (opts) {
          // set any options pass
          this.option(opts);
          this._getIsInstant();
          // filter, sort, and layout

          // filter
          var filtered = this._filter(this.items);
          this.filteredItems = filtered.matches;
          this._bindArrangeComplete();
          if (this._isInstant) {
            this._noTransition(this._hideReveal, [filtered]);
          } else {
            this._hideReveal(filtered);
          }
          this._sort();
          this._layout();
        };
        // alias to _init for main plugin method
        proto._init = proto.arrange;
        proto._hideReveal = function (filtered) {
          this.reveal(filtered.needReveal);
          this.hide(filtered.needHide);
        };

        // HACK
        // Don't animate/transition first layout
        // Or don't animate/transition other layouts
        proto._getIsInstant = function () {
          var isLayoutInstant = this._getOption('layoutInstant');
          var isInstant = isLayoutInstant !== undefined ? isLayoutInstant : !this._isLayoutInited;
          this._isInstant = isInstant;
          return isInstant;
        };

        // listen for layoutComplete, hideComplete and revealComplete
        // to trigger arrangeComplete
        proto._bindArrangeComplete = function () {
          // listen for 3 events to trigger arrangeComplete
          var isLayoutComplete, isHideComplete, isRevealComplete;
          var _this = this;
          function arrangeParallelCallback() {
            if (isLayoutComplete && isHideComplete && isRevealComplete) {
              _this.dispatchEvent('arrangeComplete', null, [_this.filteredItems]);
            }
          }
          this.once('layoutComplete', function () {
            isLayoutComplete = true;
            arrangeParallelCallback();
          });
          this.once('hideComplete', function () {
            isHideComplete = true;
            arrangeParallelCallback();
          });
          this.once('revealComplete', function () {
            isRevealComplete = true;
            arrangeParallelCallback();
          });
        };

        // -------------------------- filter -------------------------- //

        proto._filter = function (items) {
          var filter = this.options.filter;
          filter = filter || '*';
          var matches = [];
          var hiddenMatched = [];
          var visibleUnmatched = [];
          var test = this._getFilterTest(filter);

          // test each item
          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item.isIgnored) {
              continue;
            }
            // add item to either matched or unmatched group
            var isMatched = test(item);
            // item.isFilterMatched = isMatched;
            // add to matches if its a match
            if (isMatched) {
              matches.push(item);
            }
            // add to additional group if item needs to be hidden or revealed
            if (isMatched && item.isHidden) {
              hiddenMatched.push(item);
            } else if (!isMatched && !item.isHidden) {
              visibleUnmatched.push(item);
            }
          }

          // return collections of items to be manipulated
          return {
            matches: matches,
            needReveal: hiddenMatched,
            needHide: visibleUnmatched
          };
        };

        // get a jQuery, function, or a matchesSelector test given the filter
        proto._getFilterTest = function (filter) {
          if (jQuery && this.options.isJQueryFiltering) {
            // use jQuery
            return function (item) {
              return jQuery(item.element).is(filter);
            };
          }
          if (typeof filter == 'function') {
            // use filter as function
            return function (item) {
              return filter(item.element);
            };
          }
          // default, use filter as selector string
          return function (item) {
            return matchesSelector(item.element, filter);
          };
        };

        // -------------------------- sorting -------------------------- //

        /**
         * @params {Array} elems
         * @public
         */
        proto.updateSortData = function (elems) {
          // get items
          var items;
          if (elems) {
            elems = utils.makeArray(elems);
            items = this.getItems(elems);
          } else {
            // update all items if no elems provided
            items = this.items;
          }
          this._getSorters();
          this._updateItemsSortData(items);
        };
        proto._getSorters = function () {
          var getSortData = this.options.getSortData;
          for (var key in getSortData) {
            var sorter = getSortData[key];
            this._sorters[key] = mungeSorter(sorter);
          }
        };

        /**
         * @params {Array} items - of Isotope.Items
         * @private
         */
        proto._updateItemsSortData = function (items) {
          // do not update if no items
          var len = items && items.length;
          for (var i = 0; len && i < len; i++) {
            var item = items[i];
            item.updateSortData();
          }
        };

        // ----- munge sorter ----- //

        // encapsulate this, as we just need mungeSorter
        // other functions in here are just for munging
        var mungeSorter = function () {
          // add a magic layer to sorters for convienent shorthands
          // `.foo-bar` will use the text of .foo-bar querySelector
          // `[foo-bar]` will use attribute
          // you can also add parser
          // `.foo-bar parseInt` will parse that as a number
          function mungeSorter(sorter) {
            // if not a string, return function or whatever it is
            if (typeof sorter != 'string') {
              return sorter;
            }
            // parse the sorter string
            var args = trim(sorter).split(' ');
            var query = args[0];
            // check if query looks like [an-attribute]
            var attrMatch = query.match(/^\[(.+)\]$/);
            var attr = attrMatch && attrMatch[1];
            var getValue = getValueGetter(attr, query);
            // use second argument as a parser
            var parser = Isotope.sortDataParsers[args[1]];
            // parse the value, if there was a parser
            sorter = parser ? function (elem) {
              return elem && parser(getValue(elem));
            } :
            // otherwise just return value
            function (elem) {
              return elem && getValue(elem);
            };
            return sorter;
          }

          // get an attribute getter, or get text of the querySelector
          function getValueGetter(attr, query) {
            // if query looks like [foo-bar], get attribute
            if (attr) {
              return function getAttribute(elem) {
                return elem.getAttribute(attr);
              };
            }

            // otherwise, assume its a querySelector, and get its text
            return function getChildText(elem) {
              var child = elem.querySelector(query);
              return child && child.textContent;
            };
          }
          return mungeSorter;
        }();

        // parsers used in getSortData shortcut strings
        Isotope.sortDataParsers = {
          'parseInt': function (val) {
            return parseInt(val, 10);
          },
          'parseFloat': function (val) {
            return parseFloat(val);
          }
        };

        // ----- sort method ----- //

        // sort filteredItem order
        proto._sort = function () {
          if (!this.options.sortBy) {
            return;
          }
          // keep track of sortBy History
          var sortBys = utils.makeArray(this.options.sortBy);
          if (!this._getIsSameSortBy(sortBys)) {
            // concat all sortBy and sortHistory, add to front, oldest goes in last
            this.sortHistory = sortBys.concat(this.sortHistory);
          }
          // sort magic
          var itemSorter = getItemSorter(this.sortHistory, this.options.sortAscending);
          this.filteredItems.sort(itemSorter);
        };

        // check if sortBys is same as start of sortHistory
        proto._getIsSameSortBy = function (sortBys) {
          for (var i = 0; i < sortBys.length; i++) {
            if (sortBys[i] != this.sortHistory[i]) {
              return false;
            }
          }
          return true;
        };

        // returns a function used for sorting
        function getItemSorter(sortBys, sortAsc) {
          return function sorter(itemA, itemB) {
            // cycle through all sortKeys
            for (var i = 0; i < sortBys.length; i++) {
              var sortBy = sortBys[i];
              var a = itemA.sortData[sortBy];
              var b = itemB.sortData[sortBy];
              if (a > b || a < b) {
                // if sortAsc is an object, use the value given the sortBy key
                var isAscending = sortAsc[sortBy] !== undefined ? sortAsc[sortBy] : sortAsc;
                var direction = isAscending ? 1 : -1;
                return (a > b ? 1 : -1) * direction;
              }
            }
            return 0;
          };
        }

        // -------------------------- methods -------------------------- //

        // get layout mode
        proto._mode = function () {
          var layoutMode = this.options.layoutMode;
          var mode = this.modes[layoutMode];
          if (!mode) {
            // TODO console.error
            throw new Error('No layout mode: ' + layoutMode);
          }
          // HACK sync mode's options
          // any options set after init for layout mode need to be synced
          mode.options = this.options[layoutMode];
          return mode;
        };
        proto._resetLayout = function () {
          // trigger original reset layout
          Outlayer.prototype._resetLayout.call(this);
          this._mode()._resetLayout();
        };
        proto._getItemLayoutPosition = function (item) {
          return this._mode()._getItemLayoutPosition(item);
        };
        proto._manageStamp = function (stamp) {
          this._mode()._manageStamp(stamp);
        };
        proto._getContainerSize = function () {
          return this._mode()._getContainerSize();
        };
        proto.needsResizeLayout = function () {
          return this._mode().needsResizeLayout();
        };

        // -------------------------- adding & removing -------------------------- //

        // HEADS UP overwrites default Outlayer appended
        proto.appended = function (elems) {
          var items = this.addItems(elems);
          if (!items.length) {
            return;
          }
          // filter, layout, reveal new items
          var filteredItems = this._filterRevealAdded(items);
          // add to filteredItems
          this.filteredItems = this.filteredItems.concat(filteredItems);
        };

        // HEADS UP overwrites default Outlayer prepended
        proto.prepended = function (elems) {
          var items = this._itemize(elems);
          if (!items.length) {
            return;
          }
          // start new layout
          this._resetLayout();
          this._manageStamps();
          // filter, layout, reveal new items
          var filteredItems = this._filterRevealAdded(items);
          // layout previous items
          this.layoutItems(this.filteredItems);
          // add to items and filteredItems
          this.filteredItems = filteredItems.concat(this.filteredItems);
          this.items = items.concat(this.items);
        };
        proto._filterRevealAdded = function (items) {
          var filtered = this._filter(items);
          this.hide(filtered.needHide);
          // reveal all new items
          this.reveal(filtered.matches);
          // layout new items, no transition
          this.layoutItems(filtered.matches, true);
          return filtered.matches;
        };

        /**
         * Filter, sort, and layout newly-appended item elements
         * @param {Array or NodeList or Element} elems
         */
        proto.insert = function (elems) {
          var items = this.addItems(elems);
          if (!items.length) {
            return;
          }
          // append item elements
          var i, item;
          var len = items.length;
          for (i = 0; i < len; i++) {
            item = items[i];
            this.element.appendChild(item.element);
          }
          // filter new stuff
          var filteredInsertItems = this._filter(items).matches;
          // set flag
          for (i = 0; i < len; i++) {
            items[i].isLayoutInstant = true;
          }
          this.arrange();
          // reset flag
          for (i = 0; i < len; i++) {
            delete items[i].isLayoutInstant;
          }
          this.reveal(filteredInsertItems);
        };
        var _remove = proto.remove;
        proto.remove = function (elems) {
          elems = utils.makeArray(elems);
          var removeItems = this.getItems(elems);
          // do regular thing
          _remove.call(this, elems);
          // bail if no items to remove
          var len = removeItems && removeItems.length;
          // remove elems from filteredItems
          for (var i = 0; len && i < len; i++) {
            var item = removeItems[i];
            // remove item from collection
            utils.removeFrom(this.filteredItems, item);
          }
        };
        proto.shuffle = function () {
          // update random sortData
          for (var i = 0; i < this.items.length; i++) {
            var item = this.items[i];
            item.sortData.random = Math.random();
          }
          this.options.sortBy = 'random';
          this._sort();
          this._layout();
        };

        /**
         * trigger fn without transition
         * kind of hacky to have this in the first place
         * @param {Function} fn
         * @param {Array} args
         * @returns ret
         * @private
         */
        proto._noTransition = function (fn, args) {
          // save transitionDuration before disabling
          var transitionDuration = this.options.transitionDuration;
          // disable transition
          this.options.transitionDuration = 0;
          // do it
          var returnValue = fn.apply(this, args);
          // re-enable transition for reveal
          this.options.transitionDuration = transitionDuration;
          return returnValue;
        };

        // ----- helper methods ----- //

        /**
         * getter method for getting filtered item elements
         * @returns {Array} elems - collection of item elements
         */
        proto.getFilteredItemElements = function () {
          return this.filteredItems.map(function (item) {
            return item.element;
          });
        };

        // -----  ----- //

        return Isotope;
      });
    })(isotope);
    var Isotope = isotope.exports;

    var airDatepicker = {exports: {}};

    (function (module, exports) {
      !function (e, t) {
        module.exports = t() ;
      }(commonjsGlobal, function () {
        return function () {

          var e = {
              d: function (t, i) {
                for (var s in i) e.o(i, s) && !e.o(t, s) && Object.defineProperty(t, s, {
                  enumerable: !0,
                  get: i[s]
                });
              },
              o: function (e, t) {
                return Object.prototype.hasOwnProperty.call(e, t);
              }
            },
            t = {};
          e.d(t, {
            default: function () {
              return R;
            }
          });
          var i = {
              days: "days",
              months: "months",
              years: "years",
              day: "day",
              month: "month",
              year: "year",
              eventChangeViewDate: "changeViewDate",
              eventChangeCurrentView: "changeCurrentView",
              eventChangeFocusDate: "changeFocusDate",
              eventChangeSelectedDate: "changeSelectedDate",
              eventChangeTime: "changeTime",
              eventChangeLastSelectedDate: "changeLastSelectedDate",
              actionSelectDate: "selectDate",
              actionUnselectDate: "unselectDate",
              cssClassWeekend: "-weekend-"
            },
            s = {
              classes: "",
              inline: !1,
              locale: {
                days: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
                daysShort: ["Вос", "Пон", "Вто", "Сре", "Чет", "Пят", "Суб"],
                daysMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
                months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
                monthsShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
                today: "Сегодня",
                clear: "Очистить",
                dateFormat: "dd.MM.yyyy",
                timeFormat: "HH:mm",
                firstDay: 1
              },
              startDate: new Date(),
              firstDay: "",
              weekends: [6, 0],
              dateFormat: "",
              altField: "",
              altFieldDateFormat: "T",
              toggleSelected: !0,
              keyboardNav: !0,
              selectedDates: !1,
              container: "",
              isMobile: !1,
              visible: !1,
              position: "bottom left",
              offset: 12,
              view: i.days,
              minView: i.days,
              showOtherMonths: !0,
              selectOtherMonths: !0,
              moveToOtherMonthsOnSelect: !0,
              showOtherYears: !0,
              selectOtherYears: !0,
              moveToOtherYearsOnSelect: !0,
              minDate: "",
              maxDate: "",
              disableNavWhenOutOfRange: !0,
              multipleDates: !1,
              multipleDatesSeparator: ", ",
              range: !1,
              dynamicRange: !0,
              buttons: !1,
              monthsField: "monthsShort",
              showEvent: "focus",
              autoClose: !1,
              fixedHeight: !1,
              prevHtml: '<svg><path d="M 17,12 l -5,5 l 5,5"></path></svg>',
              nextHtml: '<svg><path d="M 14,12 l 5,5 l -5,5"></path></svg>',
              navTitles: {
                days: "MMMM, <i>yyyy</i>",
                months: "yyyy",
                years: "yyyy1 - yyyy2"
              },
              timepicker: !1,
              onlyTimepicker: !1,
              dateTimeSeparator: " ",
              timeFormat: "",
              minHours: 0,
              maxHours: 24,
              minMinutes: 0,
              maxMinutes: 59,
              hoursStep: 1,
              minutesStep: 1,
              onSelect: !1,
              onChangeViewDate: !1,
              onChangeView: !1,
              onRenderCell: !1,
              onShow: !1,
              onHide: !1,
              onClickDayName: !1
            };
          function a(e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document;
            return "string" == typeof e ? t.querySelector(e) : e;
          }
          function n() {
            let {
                tagName: e = "div",
                className: t = "",
                innerHtml: i = "",
                id: s = "",
                attrs: a = {}
              } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = document.createElement(e);
            return t && n.classList.add(...t.split(" ")), s && (n.id = s), i && (n.innerHTML = i), a && r(n, a), n;
          }
          function r(e, t) {
            for (let [i, s] of Object.entries(t)) void 0 !== s && e.setAttribute(i, s);
            return e;
          }
          function h(e) {
            return new Date(e.getFullYear(), e.getMonth() + 1, 0).getDate();
          }
          function o(e) {
            let t = e.getHours(),
              {
                hours: i,
                dayPeriod: s
              } = l(t);
            return {
              year: e.getFullYear(),
              month: e.getMonth(),
              fullMonth: e.getMonth() + 1 < 10 ? "0" + (e.getMonth() + 1) : e.getMonth() + 1,
              date: e.getDate(),
              fullDate: e.getDate() < 10 ? "0" + e.getDate() : e.getDate(),
              day: e.getDay(),
              hours: t,
              fullHours: d(t),
              hours12: i,
              dayPeriod: s,
              fullHours12: d(i),
              minutes: e.getMinutes(),
              fullMinutes: e.getMinutes() < 10 ? "0" + e.getMinutes() : e.getMinutes()
            };
          }
          function l(e) {
            return {
              dayPeriod: e > 11 ? "pm" : "am",
              hours: e % 12 == 0 ? 12 : e % 12
            };
          }
          function d(e) {
            return e < 10 ? "0" + e : e;
          }
          function c(e) {
            let t = 10 * Math.floor(e.getFullYear() / 10);
            return [t, t + 9];
          }
          function u() {
            let e = [];
            for (var t = arguments.length, i = new Array(t), s = 0; s < t; s++) i[s] = arguments[s];
            return i.forEach(t => {
              if ("object" == typeof t) for (let i in t) t[i] && e.push(i);else t && e.push(t);
            }), e.join(" ");
          }
          function p(e, t) {
            let s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.days;
            if (!e || !t) return !1;
            let a = o(e),
              n = o(t);
            return {
              [i.days]: a.date === n.date && a.month === n.month && a.year === n.year,
              [i.months]: a.month === n.month && a.year === n.year,
              [i.years]: a.year === n.year
            }[s];
          }
          function m(e, t, i) {
            let s = g(e, !1).getTime(),
              a = g(t, !1).getTime();
            return i ? s >= a : s > a;
          }
          function v(e, t) {
            return !m(e, t, !0);
          }
          function g(e) {
            let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
              i = new Date(e.getTime());
            return "boolean" != typeof t || t || function (e) {
              e.setHours(0, 0, 0, 0);
            }(i), i;
          }
          function D(e, t, i) {
            e.length ? e.forEach(e => {
              e.addEventListener(t, i);
            }) : e.addEventListener(t, i);
          }
          function y(e, t) {
            return !(!e || e === document || e instanceof DocumentFragment) && (e.matches(t) ? e : y(e.parentNode, t));
          }
          function f(e, t, i) {
            return e > i ? i : e < t ? t : e;
          }
          function w(e) {
            for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++) i[s - 1] = arguments[s];
            return i.filter(e => e).forEach(t => {
              for (let [i, s] of Object.entries(t)) if (void 0 !== s && "[object Object]" === s.toString()) {
                let t = void 0 !== e[i] ? e[i].toString() : void 0,
                  a = s.toString(),
                  n = Array.isArray(s) ? [] : {};
                e[i] = e[i] ? t !== a ? n : e[i] : n, w(e[i], s);
              } else e[i] = s;
            }), e;
          }
          function b(e) {
            let t = e;
            return e instanceof Date || ("string" == typeof e && /^\d{4}-\d{2}-\d{2}$/.test(e) && (e += "T00:00:00"), t = new Date(e)), isNaN(t.getTime()) && (console.log(`Unable to convert value "${e}" to Date object`), t = !1), t;
          }
          function $(e) {
            let t = "\\s|\\.|-|/|\\\\|,|\\$|\\!|\\?|:|;";
            return new RegExp("(^|>|" + t + ")(" + e + ")($|<|" + t + ")", "g");
          }
          function k(e, t, i) {
            return (t = function (e) {
              var t = function (e, t) {
                if ("object" != typeof e || null === e) return e;
                var i = e[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var s = i.call(e, "string");
                  if ("object" != typeof s) return s;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
              }(e);
              return "symbol" == typeof t ? t : String(t);
            }(t)) in e ? Object.defineProperty(e, t, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = i, e;
          }
          class C {
            constructor() {
              let {
                type: e,
                date: t,
                dp: i,
                opts: s,
                body: a
              } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              k(this, "focus", () => {
                this.$cell.classList.add("-focus-"), this.focused = !0;
              }), k(this, "removeFocus", () => {
                this.$cell.classList.remove("-focus-"), this.focused = !1;
              }), k(this, "select", () => {
                this.$cell.classList.add("-selected-"), this.selected = !0;
              }), k(this, "removeSelect", () => {
                this.$cell.classList.remove("-selected-", "-range-from-", "-range-to-"), this.selected = !1;
              }), k(this, "onChangeSelectedDate", () => {
                this.isDisabled || (this._handleSelectedStatus(), this.opts.range && this._handleRangeStatus());
              }), k(this, "onChangeFocusDate", e => {
                if (!e) return void (this.focused && this.removeFocus());
                let t = p(e, this.date, this.type);
                t ? this.focus() : !t && this.focused && this.removeFocus(), this.opts.range && this._handleRangeStatus();
              }), k(this, "render", () => (this.$cell.innerHTML = this._getHtml(), this._handleClasses(), this.$cell)), this.type = e, this.singleType = this.type.slice(0, -1), this.date = t, this.dp = i, this.opts = s, this.body = a, this.customData = !1, this.init();
            }
            init() {
              var e, t;
              let {
                onRenderCell: i
              } = this.opts;
              i && (this.customData = i({
                date: this.date,
                cellType: this.singleType,
                datepicker: this.dp
              })), this._createElement(), this._bindDatepickerEvents(), null !== (e = this.customData) && void 0 !== e && e.disabled ? this.dp.disableDate(this.date) : !1 === (null === (t = this.customData) || void 0 === t ? void 0 : t.disabled) && this.dp.enableDate(this.date);
            }
            _bindDatepickerEvents() {
              this.dp.on(i.eventChangeSelectedDate, this.onChangeSelectedDate), this.dp.on(i.eventChangeFocusDate, this.onChangeFocusDate);
            }
            unbindDatepickerEvents() {
              this.dp.off(i.eventChangeSelectedDate, this.onChangeSelectedDate), this.dp.off(i.eventChangeFocusDate, this.onChangeFocusDate);
            }
            _createElement() {
              var e;
              let {
                  year: t,
                  month: i,
                  fullMonth: s,
                  date: a,
                  fullDate: r
                } = o(this.date),
                h = (null === (e = this.customData) || void 0 === e ? void 0 : e.attrs) || {};
              this.$cell = n({
                attrs: {
                  "data-year": t,
                  "data-month": i,
                  "data-date": a,
                  "data-iso-date": `${t}-${s}-${r}`,
                  ...h
                }
              }), this.$cell.adpCell = this;
            }
            _getClassName() {
              var e;
              let t = new Date(),
                {
                  selectOtherMonths: s,
                  selectOtherYears: a
                } = this.opts,
                {
                  minDate: n,
                  maxDate: r,
                  isDateDisabled: h
                } = this.dp,
                {
                  day: l
                } = o(this.date),
                d = this._isOutOfMinMaxRange(),
                c = h(this.date),
                m = u("air-datepicker-cell", `-${this.singleType}-`, {
                  "-current-": p(t, this.date, this.type),
                  "-min-date-": n && p(n, this.date, this.type),
                  "-max-date-": r && p(r, this.date, this.type)
                }),
                v = "";
              switch (this.type) {
                case i.days:
                  v = u({
                    "-weekend-": this.dp.isWeekend(l),
                    "-other-month-": this.isOtherMonth,
                    "-disabled-": this.isOtherMonth && !s || d || c
                  });
                  break;
                case i.months:
                  v = u({
                    "-disabled-": d
                  });
                  break;
                case i.years:
                  v = u({
                    "-other-decade-": this.isOtherDecade,
                    "-disabled-": d || this.isOtherDecade && !a
                  });
              }
              return u(m, v, null === (e = this.customData) || void 0 === e ? void 0 : e.classes).split(" ");
            }
            _getHtml() {
              var e;
              let {
                  year: t,
                  month: s,
                  date: a
                } = o(this.date),
                {
                  showOtherMonths: n,
                  showOtherYears: r
                } = this.opts;
              if (null !== (e = this.customData) && void 0 !== e && e.html) return this.customData.html;
              switch (this.type) {
                case i.days:
                  return !n && this.isOtherMonth ? "" : a;
                case i.months:
                  return this.dp.locale[this.opts.monthsField][s];
                case i.years:
                  return !r && this.isOtherDecade ? "" : t;
              }
            }
            _isOutOfMinMaxRange() {
              let {
                  minDate: e,
                  maxDate: t
                } = this.dp,
                {
                  type: s,
                  date: a
                } = this,
                {
                  month: n,
                  year: r,
                  date: h
                } = o(a),
                l = s === i.days,
                d = s === i.years,
                c = !!e && new Date(r, d ? e.getMonth() : n, l ? h : e.getDate()),
                u = !!t && new Date(r, d ? t.getMonth() : n, l ? h : t.getDate());
              return e && t ? v(c, e) || m(u, t) : e ? v(c, e) : t ? m(u, t) : void 0;
            }
            destroy() {
              this.unbindDatepickerEvents();
            }
            _handleRangeStatus() {
              const {
                  selectedDates: e,
                  focusDate: t,
                  rangeDateTo: i,
                  rangeDateFrom: s
                } = this.dp,
                a = e.length;
              if (this.$cell.classList.remove("-range-from-", "-range-to-", "-in-range-"), !a) return;
              let n = s,
                r = i;
              if (1 === a && t) {
                const i = m(t, e[0]);
                n = i ? e[0] : t, r = i ? t : e[0];
              }
              let h = u({
                "-in-range-": n && r && (o = this.date, l = n, d = r, m(o, l) && v(o, d)),
                "-range-from-": n && p(this.date, n, this.type),
                "-range-to-": r && p(this.date, r, this.type)
              });
              var o, l, d;
              h && this.$cell.classList.add(...h.split(" "));
            }
            _handleSelectedStatus() {
              let e = this.dp._checkIfDateIsSelected(this.date, this.type);
              e ? this.select() : !e && this.selected && this.removeSelect();
            }
            _handleInitialFocusStatus() {
              p(this.dp.focusDate, this.date, this.type) && this.focus();
            }
            _handleClasses() {
              this.$cell.setAttribute("class", ""), this._handleInitialFocusStatus(), this.dp.hasSelectedDates && (this._handleSelectedStatus(), this.dp.opts.range && this._handleRangeStatus()), this.$cell.classList.add(...this._getClassName());
            }
            get isDisabled() {
              return this.$cell.matches(".-disabled-");
            }
            get isOtherMonth() {
              return this.dp.isOtherMonth(this.date);
            }
            get isOtherDecade() {
              return this.dp.isOtherDecade(this.date);
            }
          }
          function _(e, t, i) {
            return (t = function (e) {
              var t = function (e, t) {
                if ("object" != typeof e || null === e) return e;
                var i = e[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var s = i.call(e, "string");
                  if ("object" != typeof s) return s;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
              }(e);
              return "symbol" == typeof t ? t : String(t);
            }(t)) in e ? Object.defineProperty(e, t, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = i, e;
          }
          let M = {
            [i.days]: `<div class="air-datepicker-body--day-names"></div><div class="air-datepicker-body--cells -${i.days}-"></div>`,
            [i.months]: `<div class="air-datepicker-body--cells -${i.months}-"></div>`,
            [i.years]: `<div class="air-datepicker-body--cells -${i.years}-"></div>`
          };
          const S = ".air-datepicker-cell";
          class T {
            constructor(e) {
              let {
                dp: t,
                type: s,
                opts: a
              } = e;
              _(this, "handleClick", e => {
                let t = e.target.closest(S).adpCell;
                if (t.isDisabled) return;
                if (!this.dp.isMinViewReached) return void this.dp.down();
                let i = this.dp._checkIfDateIsSelected(t.date, t.type);
                i ? this.dp._handleAlreadySelectedDates(i, t.date) : this.dp.selectDate(t.date);
              }), _(this, "handleDayNameClick", e => {
                let t = e.target.getAttribute("data-day-index");
                this.opts.onClickDayName({
                  dayIndex: Number(t),
                  datepicker: this.dp
                });
              }), _(this, "onChangeCurrentView", e => {
                e !== this.type ? this.hide() : (this.show(), this.render());
              }), _(this, "onMouseOverCell", e => {
                let t = y(e.target, S);
                this.dp.setFocusDate(!!t && t.adpCell.date);
              }), _(this, "onMouseOutCell", () => {
                this.dp.setFocusDate(!1);
              }), _(this, "onClickBody", e => {
                let {
                    onClickDayName: t
                  } = this.opts,
                  i = e.target;
                i.closest(S) && this.handleClick(e), t && i.closest(".air-datepicker-body--day-name") && this.handleDayNameClick(e);
              }), _(this, "onMouseDown", e => {
                this.pressed = !0;
                let t = y(e.target, S),
                  i = t && t.adpCell;
                p(i.date, this.dp.rangeDateFrom) && (this.rangeFromFocused = !0), p(i.date, this.dp.rangeDateTo) && (this.rangeToFocused = !0);
              }), _(this, "onMouseMove", e => {
                if (!this.pressed || !this.dp.isMinViewReached) return;
                e.preventDefault();
                let t = y(e.target, S),
                  i = t && t.adpCell,
                  {
                    selectedDates: s,
                    rangeDateTo: a,
                    rangeDateFrom: n
                  } = this.dp;
                if (!i || i.isDisabled) return;
                let {
                  date: r
                } = i;
                if (2 === s.length) {
                  if (this.rangeFromFocused && !m(r, a)) {
                    let {
                      hours: e,
                      minutes: t
                    } = o(n);
                    r.setHours(e), r.setMinutes(t), this.dp.rangeDateFrom = r, this.dp.replaceDate(n, r);
                  }
                  if (this.rangeToFocused && !v(r, n)) {
                    let {
                      hours: e,
                      minutes: t
                    } = o(a);
                    r.setHours(e), r.setMinutes(t), this.dp.rangeDateTo = r, this.dp.replaceDate(a, r);
                  }
                }
              }), _(this, "onMouseUp", () => {
                this.pressed = !1, this.rangeFromFocused = !1, this.rangeToFocused = !1;
              }), _(this, "onChangeViewDate", (e, t) => {
                if (!this.isVisible) return;
                let s = c(e),
                  a = c(t);
                switch (this.dp.currentView) {
                  case i.days:
                    if (p(e, t, i.months)) return;
                    break;
                  case i.months:
                    if (p(e, t, i.years)) return;
                    break;
                  case i.years:
                    if (s[0] === a[0] && s[1] === a[1]) return;
                }
                this.render();
              }), _(this, "render", () => {
                this.destroyCells(), this._generateCells(), this.cells.forEach(e => {
                  this.$cells.appendChild(e.render());
                });
              }), this.dp = t, this.type = s, this.opts = a, this.cells = [], this.$el = "", this.pressed = !1, this.isVisible = !0, this.init();
            }
            init() {
              this._buildBaseHtml(), this.type === i.days && this.renderDayNames(), this.render(), this._bindEvents(), this._bindDatepickerEvents();
            }
            _bindEvents() {
              let {
                range: e,
                dynamicRange: t
              } = this.opts;
              D(this.$el, "mouseover", this.onMouseOverCell), D(this.$el, "mouseout", this.onMouseOutCell), D(this.$el, "click", this.onClickBody), e && t && (D(this.$el, "mousedown", this.onMouseDown), D(this.$el, "mousemove", this.onMouseMove), D(window.document, "mouseup", this.onMouseUp));
            }
            _bindDatepickerEvents() {
              this.dp.on(i.eventChangeViewDate, this.onChangeViewDate), this.dp.on(i.eventChangeCurrentView, this.onChangeCurrentView);
            }
            _buildBaseHtml() {
              this.$el = n({
                className: `air-datepicker-body -${this.type}-`,
                innerHtml: M[this.type]
              }), this.$names = a(".air-datepicker-body--day-names", this.$el), this.$cells = a(".air-datepicker-body--cells", this.$el);
            }
            _getDayNamesHtml() {
              let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.dp.locale.firstDay,
                t = "",
                s = this.dp.isWeekend,
                {
                  onClickDayName: a
                } = this.opts,
                n = e,
                r = 0;
              for (; r < 7;) {
                let e = n % 7;
                t += `<div class="${u("air-datepicker-body--day-name", {
              [i.cssClassWeekend]: s(e),
              "-clickable-": !!a
            })}" data-day-index='${e}'>${this.dp.locale.daysMin[e]}</div>`, r++, n++;
              }
              return t;
            }
            renderDayNames() {
              this.$names.innerHTML = this._getDayNamesHtml();
            }
            _generateCell(e) {
              let {
                type: t,
                dp: i,
                opts: s
              } = this;
              return new C({
                type: t,
                dp: i,
                opts: s,
                date: e,
                body: this
              });
            }
            _generateCells() {
              T.getDatesFunction(this.type)(this.dp, e => {
                this.cells.push(this._generateCell(e));
              });
            }
            show() {
              this.isVisible = !0, this.$el.classList.remove("-hidden-");
            }
            hide() {
              this.isVisible = !1, this.$el.classList.add("-hidden-");
            }
            destroyCells() {
              this.cells.forEach(e => e.destroy()), this.cells = [], this.$cells.innerHTML = "";
            }
            destroy() {
              this.destroyCells(), this.dp.off(i.eventChangeViewDate, this.onChangeViewDate), this.dp.off(i.eventChangeCurrentView, this.onChangeCurrentView);
            }
            static getDaysDates(e, t) {
              let {
                  viewDate: i,
                  opts: {
                    fixedHeight: s
                  },
                  locale: {
                    firstDay: a
                  }
                } = e,
                n = h(i),
                {
                  year: r,
                  month: l
                } = o(i),
                d = new Date(r, l, 1),
                c = new Date(r, l, n),
                u = d.getDay() - a,
                p = 6 - c.getDay() + a;
              u = u < 0 ? u + 7 : u, p = p > 6 ? p - 7 : p;
              let m = function (e, t) {
                  let {
                    year: i,
                    month: s,
                    date: a
                  } = o(e);
                  return new Date(i, s, a - t);
                }(d, u),
                v = n + u + p,
                g = m.getDate(),
                {
                  year: D,
                  month: y
                } = o(m),
                f = 0;
              s && (v = 42);
              const w = [];
              for (; f < v;) {
                let e = new Date(D, y, g + f);
                t && t(e), w.push(e), f++;
              }
              return w;
            }
            static getMonthsDates(e, t) {
              let {
                  year: i
                } = e.parsedViewDate,
                s = 0,
                a = [];
              for (; s < 12;) {
                const e = new Date(i, s);
                a.push(e), t && t(e), s++;
              }
              return a;
            }
            static getYearsDates(e, t) {
              let i = c(e.viewDate),
                s = i[0] - 1,
                a = i[1] + 1,
                n = s,
                r = [];
              for (; n <= a;) {
                const e = new Date(n, 0);
                r.push(e), t && t(e), n++;
              }
              return r;
            }
            static getDatesFunction() {
              let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : i.days;
              return {
                [i.days]: T.getDaysDates,
                [i.months]: T.getMonthsDates,
                [i.years]: T.getYearsDates
              }[e];
            }
          }
          function F(e, t, i) {
            return (t = function (e) {
              var t = function (e, t) {
                if ("object" != typeof e || null === e) return e;
                var i = e[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var s = i.call(e, "string");
                  if ("object" != typeof s) return s;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
              }(e);
              return "symbol" == typeof t ? t : String(t);
            }(t)) in e ? Object.defineProperty(e, t, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = i, e;
          }
          class V {
            constructor(e) {
              let {
                dp: t,
                opts: i
              } = e;
              F(this, "onClickNav", e => {
                let t = y(e.target, ".air-datepicker-nav--action");
                if (!t) return;
                let i = t.dataset.action;
                this.dp[i]();
              }), F(this, "onChangeViewDate", () => {
                this.render(), this._resetNavStatus(), this.handleNavStatus();
              }), F(this, "onChangeCurrentView", () => {
                this.render(), this._resetNavStatus(), this.handleNavStatus();
              }), F(this, "onClickNavTitle", () => {
                this.dp.isFinalView || this.dp.up();
              }), F(this, "update", () => {
                let {
                  prevHtml: e,
                  nextHtml: t
                } = this.opts;
                this.$prev.innerHTML = e, this.$next.innerHTML = t, this._resetNavStatus(), this.render(), this.handleNavStatus();
              }), F(this, "renderDelay", () => {
                setTimeout(this.render);
              }), F(this, "render", () => {
                this.$title.innerHTML = this._getTitle(), function (e, t) {
                  for (let i in t) t[i] ? e.classList.add(i) : e.classList.remove(i);
                }(this.$title, {
                  "-disabled-": this.dp.isFinalView
                });
              }), this.dp = t, this.opts = i, this.init();
            }
            init() {
              this._createElement(), this._buildBaseHtml(), this._defineDOM(), this.render(), this.handleNavStatus(), this._bindEvents(), this._bindDatepickerEvents();
            }
            _defineDOM() {
              this.$title = a(".air-datepicker-nav--title", this.$el), this.$prev = a('[data-action="prev"]', this.$el), this.$next = a('[data-action="next"]', this.$el);
            }
            _bindEvents() {
              this.$el.addEventListener("click", this.onClickNav), this.$title.addEventListener("click", this.onClickNavTitle);
            }
            _bindDatepickerEvents() {
              this.dp.on(i.eventChangeViewDate, this.onChangeViewDate), this.dp.on(i.eventChangeCurrentView, this.onChangeCurrentView), this.isNavIsFunction && (this.dp.on(i.eventChangeSelectedDate, this.renderDelay), this.dp.opts.timepicker && this.dp.on(i.eventChangeTime, this.render));
            }
            destroy() {
              this.dp.off(i.eventChangeViewDate, this.onChangeViewDate), this.dp.off(i.eventChangeCurrentView, this.onChangeCurrentView), this.isNavIsFunction && (this.dp.off(i.eventChangeSelectedDate, this.renderDelay), this.dp.opts.timepicker && this.dp.off(i.eventChangeTime, this.render));
            }
            _createElement() {
              this.$el = n({
                tagName: "nav",
                className: "air-datepicker-nav"
              });
            }
            _getTitle() {
              let {
                  dp: e,
                  opts: t
                } = this,
                i = t.navTitles[e.currentView];
              return "function" == typeof i ? i(e) : e.formatDate(e.viewDate, i);
            }
            handleNavStatus() {
              let {
                  disableNavWhenOutOfRange: e
                } = this.opts,
                {
                  minDate: t,
                  maxDate: s
                } = this.dp;
              if (!t && !s || !e) return;
              let {
                  year: a,
                  month: n
                } = this.dp.parsedViewDate,
                r = !!t && o(t),
                h = !!s && o(s);
              switch (this.dp.currentView) {
                case i.days:
                  t && r.month >= n && r.year >= a && this._disableNav("prev"), s && h.month <= n && h.year <= a && this._disableNav("next");
                  break;
                case i.months:
                  t && r.year >= a && this._disableNav("prev"), s && h.year <= a && this._disableNav("next");
                  break;
                case i.years:
                  {
                    let e = c(this.dp.viewDate);
                    t && r.year >= e[0] && this._disableNav("prev"), s && h.year <= e[1] && this._disableNav("next");
                    break;
                  }
              }
            }
            _disableNav(e) {
              a('[data-action="' + e + '"]', this.$el).classList.add("-disabled-");
            }
            _resetNavStatus() {
              !function (e) {
                for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++) i[s - 1] = arguments[s];
                e.length ? e.forEach(e => {
                  e.classList.remove(...i);
                }) : e.classList.remove(...i);
              }(this.$el.querySelectorAll(".air-datepicker-nav--action"), "-disabled-");
            }
            _buildBaseHtml() {
              let {
                prevHtml: e,
                nextHtml: t
              } = this.opts;
              this.$el.innerHTML = `<div class="air-datepicker-nav--action" data-action="prev">${e}</div><div class="air-datepicker-nav--title"></div><div class="air-datepicker-nav--action" data-action="next">${t}</div>`;
            }
            get isNavIsFunction() {
              let {
                navTitles: e
              } = this.opts;
              return Object.keys(e).find(t => "function" == typeof e[t]);
            }
          }
          var x = {
            today: {
              content: e => e.locale.today,
              onClick: e => e.setViewDate(new Date())
            },
            clear: {
              content: e => e.locale.clear,
              onClick: e => e.clear()
            }
          };
          class H {
            constructor(e) {
              let {
                dp: t,
                opts: i
              } = e;
              this.dp = t, this.opts = i, this.init();
            }
            init() {
              this.createElement(), this.render();
            }
            createElement() {
              this.$el = n({
                className: "air-datepicker-buttons"
              });
            }
            destroy() {
              this.$el.parentNode.removeChild(this.$el);
            }
            clearHtml() {
              return this.$el.innerHTML = "", this;
            }
            generateButtons() {
              let {
                buttons: e
              } = this.opts;
              Array.isArray(e) || (e = [e]), e.forEach(e => {
                let t = e;
                "string" == typeof e && x[e] && (t = x[e]);
                let i = this.createButton(t);
                t.onClick && this.attachEventToButton(i, t.onClick), this.$el.appendChild(i);
              });
            }
            attachEventToButton(e, t) {
              e.addEventListener("click", () => {
                t(this.dp);
              });
            }
            createButton(e) {
              let {
                content: t,
                className: i,
                tagName: s = "button",
                attrs: a = {}
              } = e;
              return n({
                tagName: s,
                innerHtml: `<span tabindex='-1'>${"function" == typeof t ? t(this.dp) : t}</span>`,
                className: u("air-datepicker-button", i),
                attrs: a
              });
            }
            render() {
              this.generateButtons();
            }
          }
          function E(e, t, i) {
            return (t = function (e) {
              var t = function (e, t) {
                if ("object" != typeof e || null === e) return e;
                var i = e[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var s = i.call(e, "string");
                  if ("object" != typeof s) return s;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
              }(e);
              return "symbol" == typeof t ? t : String(t);
            }(t)) in e ? Object.defineProperty(e, t, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = i, e;
          }
          class L {
            constructor() {
              let {
                opts: e,
                dp: t
              } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              E(this, "toggleTimepickerIsActive", e => {
                this.dp.timepickerIsActive = e;
              }), E(this, "onChangeSelectedDate", e => {
                let {
                  date: t,
                  updateTime: i = !1
                } = e;
                t && (this.setMinMaxTime(t), this.setCurrentTime(!!i && t), this.addTimeToDate(t));
              }), E(this, "onChangeLastSelectedDate", e => {
                e && (this.setTime(e), this.render());
              }), E(this, "onChangeInputRange", e => {
                let t = e.target;
                this[t.getAttribute("name")] = t.value, this.updateText(), this.dp.trigger(i.eventChangeTime, {
                  hours: this.hours,
                  minutes: this.minutes
                });
              }), E(this, "onMouseEnterLeave", e => {
                let t = e.target.getAttribute("name"),
                  i = this.$minutesText;
                "hours" === t && (i = this.$hoursText), i.classList.toggle("-focus-");
              }), E(this, "onFocus", () => {
                this.toggleTimepickerIsActive(!0);
              }), E(this, "onBlur", () => {
                this.toggleTimepickerIsActive(!1);
              }), this.opts = e, this.dp = t;
              let {
                timeFormat: s
              } = this.dp.locale;
              s && (s.match($("h")) || s.match($("hh"))) && (this.ampm = !0), this.init();
            }
            init() {
              this.setTime(this.dp.lastSelectedDate || this.dp.viewDate), this.createElement(), this.buildHtml(), this.defineDOM(), this.render(), this.bindDatepickerEvents(), this.bindDOMEvents();
            }
            bindDatepickerEvents() {
              this.dp.on(i.eventChangeSelectedDate, this.onChangeSelectedDate), this.dp.on(i.eventChangeLastSelectedDate, this.onChangeLastSelectedDate);
            }
            bindDOMEvents() {
              let e = "input";
              navigator.userAgent.match(/trident/gi) && (e = "change"), D(this.$ranges, e, this.onChangeInputRange), D(this.$ranges, "mouseenter", this.onMouseEnterLeave), D(this.$ranges, "mouseleave", this.onMouseEnterLeave), D(this.$ranges, "focus", this.onFocus), D(this.$ranges, "mousedown", this.onFocus), D(this.$ranges, "blur", this.onBlur);
            }
            createElement() {
              this.$el = n({
                className: u("air-datepicker-time", {
                  "-am-pm-": this.dp.ampm
                })
              });
            }
            destroy() {
              this.dp.off(i.eventChangeSelectedDate, this.onChangeSelectedDate), this.dp.off(i.eventChangeLastSelectedDate, this.onChangeLastSelectedDate), this.$el.parentNode.removeChild(this.$el);
            }
            buildHtml() {
              let {
                ampm: e,
                hours: t,
                displayHours: i,
                minutes: s,
                minHours: a,
                minMinutes: n,
                maxHours: r,
                maxMinutes: h,
                dayPeriod: o,
                opts: {
                  hoursStep: l,
                  minutesStep: c
                }
              } = this;
              this.$el.innerHTML = `<div class="air-datepicker-time--current">   <span class="air-datepicker-time--current-hours">${d(i)}</span>   <span class="air-datepicker-time--current-colon">:</span>   <span class="air-datepicker-time--current-minutes">${d(s)}</span>   ` + (e ? `<span class='air-datepicker-time--current-ampm'>${o}</span>` : "") + '</div><div class="air-datepicker-time--sliders">   <div class="air-datepicker-time--row">' + `      <input type="range" name="hours" value="${t}" min="${a}" max="${r}" step="${l}"/>   </div>   <div class="air-datepicker-time--row">` + `      <input type="range" name="minutes" value="${s}" min="${n}" max="${h}" step="${c}"/>   </div></div>`;
            }
            defineDOM() {
              let e = e => a(e, this.$el);
              this.$ranges = this.$el.querySelectorAll('[type="range"]'), this.$hours = e('[name="hours"]'), this.$minutes = e('[name="minutes"]'), this.$hoursText = e(".air-datepicker-time--current-hours"), this.$minutesText = e(".air-datepicker-time--current-minutes"), this.$ampm = e(".air-datepicker-time--current-ampm");
            }
            setTime(e) {
              this.setMinMaxTime(e), this.setCurrentTime(e);
            }
            addTimeToDate(e) {
              e && (e.setHours(this.hours), e.setMinutes(this.minutes));
            }
            setMinMaxTime(e) {
              if (this.setMinMaxTimeFromOptions(), e) {
                let {
                  minDate: t,
                  maxDate: i
                } = this.dp;
                t && p(e, t) && this.setMinTimeFromMinDate(t), i && p(e, i) && this.setMaxTimeFromMaxDate(i);
              }
            }
            setCurrentTime(e) {
              let {
                hours: t,
                minutes: i
              } = e ? o(e) : this;
              this.hours = f(t, this.minHours, this.maxHours), this.minutes = f(i, this.minMinutes, this.maxMinutes);
            }
            setMinMaxTimeFromOptions() {
              let {
                minHours: e,
                minMinutes: t,
                maxHours: i,
                maxMinutes: s
              } = this.opts;
              this.minHours = f(e, 0, 23), this.minMinutes = f(t, 0, 59), this.maxHours = f(i, 0, 23), this.maxMinutes = f(s, 0, 59);
            }
            setMinTimeFromMinDate(e) {
              let {
                lastSelectedDate: t
              } = this.dp;
              this.minHours = e.getHours(), t && t.getHours() > e.getHours() ? this.minMinutes = this.opts.minMinutes : this.minMinutes = e.getMinutes();
            }
            setMaxTimeFromMaxDate(e) {
              let {
                lastSelectedDate: t
              } = this.dp;
              this.maxHours = e.getHours(), t && t.getHours() < e.getHours() ? this.maxMinutes = this.opts.maxMinutes : this.maxMinutes = e.getMinutes();
            }
            updateSliders() {
              r(this.$hours, {
                min: this.minHours,
                max: this.maxHours
              }).value = this.hours, r(this.$minutes, {
                min: this.minMinutes,
                max: this.maxMinutes
              }).value = this.minutes;
            }
            updateText() {
              this.$hoursText.innerHTML = d(this.displayHours), this.$minutesText.innerHTML = d(this.minutes), this.ampm && (this.$ampm.innerHTML = this.dayPeriod);
            }
            set hours(e) {
              this._hours = e;
              let {
                hours: t,
                dayPeriod: i
              } = l(e);
              this.displayHours = this.ampm ? t : e, this.dayPeriod = i;
            }
            get hours() {
              return this._hours;
            }
            render() {
              this.updateSliders(), this.updateText();
            }
          }
          function A(e, t, i) {
            return (t = function (e) {
              var t = function (e, t) {
                if ("object" != typeof e || null === e) return e;
                var i = e[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var s = i.call(e, "string");
                  if ("object" != typeof s) return s;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
              }(e);
              return "symbol" == typeof t ? t : String(t);
            }(t)) in e ? Object.defineProperty(e, t, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = i, e;
          }
          class O {
            constructor(e) {
              let {
                dp: t,
                opts: i
              } = e;
              A(this, "pressedKeys", new Set()), A(this, "hotKeys", new Map([[[["Control", "ArrowRight"], ["Control", "ArrowUp"]], e => e.month++], [[["Control", "ArrowLeft"], ["Control", "ArrowDown"]], e => e.month--], [[["Shift", "ArrowRight"], ["Shift", "ArrowUp"]], e => e.year++], [[["Shift", "ArrowLeft"], ["Shift", "ArrowDown"]], e => e.year--], [[["Alt", "ArrowRight"], ["Alt", "ArrowUp"]], e => e.year += 10], [[["Alt", "ArrowLeft"], ["Alt", "ArrowDown"]], e => e.year -= 10], [["Control", "Shift", "ArrowUp"], (e, t) => t.up()]])), A(this, "handleHotKey", e => {
                let t = this.hotKeys.get(e),
                  i = o(this.getInitialFocusDate());
                t(i, this.dp);
                let {
                    year: s,
                    month: a,
                    date: n
                  } = i,
                  r = h(new Date(s, a));
                r < n && (n = r);
                let l = this.dp.getClampedDate(new Date(s, a, n));
                this.dp.setFocusDate(l, {
                  viewDateTransition: !0
                });
              }), A(this, "isHotKeyPressed", () => {
                let e = !1,
                  t = this.pressedKeys.size,
                  i = e => this.pressedKeys.has(e);
                for (let [s] of this.hotKeys) {
                  if (e) break;
                  if (Array.isArray(s[0])) s.forEach(a => {
                    e || t !== a.length || (e = a.every(i) && s);
                  });else {
                    if (t !== s.length) continue;
                    e = s.every(i) && s;
                  }
                }
                return e;
              }), A(this, "isArrow", e => e >= 37 && e <= 40), A(this, "onKeyDown", e => {
                if (!this.dp.visible && !this.dp.treatAsInline) return;
                let {
                    key: t,
                    which: i
                  } = e,
                  {
                    dp: s,
                    dp: {
                      focusDate: a
                    },
                    opts: n
                  } = this;
                this.registerKey(t);
                let r = this.isHotKeyPressed();
                if (r) return e.preventDefault(), void this.handleHotKey(r);
                if (this.isArrow(i)) return e.preventDefault(), void this.focusNextCell(t);
                if ("Enter" === t) {
                  if (s.currentView !== n.minView) return void s.down();
                  if (a) {
                    let e = s._checkIfDateIsSelected(a);
                    return void (e ? s._handleAlreadySelectedDates(e, a) : s.selectDate(a));
                  }
                }
                "Escape" === t && this.dp.hide();
              }), A(this, "onKeyUp", e => {
                this.removeKey(e.key);
              }), this.dp = t, this.opts = i, this.init();
            }
            init() {
              this.bindKeyboardEvents();
            }
            bindKeyboardEvents() {
              let {
                $el: e
              } = this.dp;
              e.addEventListener("keydown", this.onKeyDown), e.addEventListener("keyup", this.onKeyUp);
            }
            destroy() {
              let {
                $el: e
              } = this.dp;
              e.removeEventListener("keydown", this.onKeyDown), e.removeEventListener("keyup", this.onKeyUp), this.hotKeys = null, this.pressedKeys = null;
            }
            getInitialFocusDate() {
              let {
                  focusDate: e,
                  currentView: t,
                  selectedDates: s,
                  parsedViewDate: {
                    year: a,
                    month: n
                  }
                } = this.dp,
                r = e || s[s.length - 1];
              if (!r) switch (t) {
                case i.days:
                  r = new Date(a, n, new Date().getDate());
                  break;
                case i.months:
                  r = new Date(a, n, 1);
                  break;
                case i.years:
                  r = new Date(a, 0, 1);
              }
              return r;
            }
            focusNextCell(e) {
              let t = this.getInitialFocusDate(),
                {
                  currentView: s
                } = this.dp,
                {
                  days: a,
                  months: n,
                  years: r
                } = i,
                h = o(t),
                l = h.year,
                d = h.month,
                c = h.date;
              switch (e) {
                case "ArrowLeft":
                  s === a && (c -= 1), s === n && (d -= 1), s === r && (l -= 1);
                  break;
                case "ArrowUp":
                  s === a && (c -= 7), s === n && (d -= 3), s === r && (l -= 4);
                  break;
                case "ArrowRight":
                  s === a && (c += 1), s === n && (d += 1), s === r && (l += 1);
                  break;
                case "ArrowDown":
                  s === a && (c += 7), s === n && (d += 3), s === r && (l += 4);
              }
              let u = this.dp.getClampedDate(new Date(l, d, c));
              this.dp.setFocusDate(u, {
                viewDateTransition: !0
              });
            }
            registerKey(e) {
              this.pressedKeys.add(e);
            }
            removeKey(e) {
              this.pressedKeys.delete(e);
            }
          }
          let N = {
            on(e, t) {
              this.__events || (this.__events = {}), this.__events[e] ? this.__events[e].push(t) : this.__events[e] = [t];
            },
            off(e, t) {
              this.__events && this.__events[e] && (this.__events[e] = this.__events[e].filter(e => e !== t));
            },
            removeAllEvents() {
              this.__events = {};
            },
            trigger(e) {
              for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++) i[s - 1] = arguments[s];
              this.__events && this.__events[e] && this.__events[e].forEach(e => {
                e(...i);
              });
            }
          };
          function I(e, t, i) {
            return (t = function (e) {
              var t = function (e, t) {
                if ("object" != typeof e || null === e) return e;
                var i = e[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var s = i.call(e, "string");
                  if ("object" != typeof s) return s;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
              }(e);
              return "symbol" == typeof t ? t : String(t);
            }(t)) in e ? Object.defineProperty(e, t, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = i, e;
          }
          let P = "",
            j = "",
            B = !1;
          class R {
            static buildGlobalContainer(e) {
              B = !0, P = n({
                className: e,
                id: e
              }), a("body").appendChild(P);
            }
            constructor(e, t) {
              var r = this;
              if (I(this, "viewIndexes", [i.days, i.months, i.years]), I(this, "next", () => {
                let {
                  year: e,
                  month: t
                } = this.parsedViewDate;
                switch (this.currentView) {
                  case i.days:
                    this.setViewDate(new Date(e, t + 1, 1));
                    break;
                  case i.months:
                    this.setViewDate(new Date(e + 1, t, 1));
                    break;
                  case i.years:
                    this.setViewDate(new Date(e + 10, 0, 1));
                }
              }), I(this, "prev", () => {
                let {
                  year: e,
                  month: t
                } = this.parsedViewDate;
                switch (this.currentView) {
                  case i.days:
                    this.setViewDate(new Date(e, t - 1, 1));
                    break;
                  case i.months:
                    this.setViewDate(new Date(e - 1, t, 1));
                    break;
                  case i.years:
                    this.setViewDate(new Date(e - 10, 0, 1));
                }
              }), I(this, "_finishHide", () => {
                this.hideAnimation = !1, this._destroyComponents(), this.$container.removeChild(this.$datepicker);
              }), I(this, "setPosition", function (e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                if ("function" == typeof (e = e || r.opts.position)) return void (r.customHide = e({
                  $datepicker: r.$datepicker,
                  $target: r.$el,
                  $pointer: r.$pointer,
                  isViewChange: t,
                  done: r._finishHide
                }));
                let i,
                  s,
                  {
                    isMobile: a
                  } = r.opts,
                  n = r.$el.getBoundingClientRect(),
                  h = r.$el.getBoundingClientRect(),
                  o = r.$datepicker.offsetParent,
                  l = r.$el.offsetParent,
                  d = r.$datepicker.getBoundingClientRect(),
                  c = e.split(" "),
                  u = window.scrollY,
                  p = window.scrollX,
                  m = r.opts.offset,
                  v = c[0],
                  g = c[1];
                if (a) r.$datepicker.style.cssText = "left: 50%; top: 50%";else {
                  if (o === l && o !== document.body && (h = {
                    top: r.$el.offsetTop,
                    left: r.$el.offsetLeft,
                    width: n.width,
                    height: r.$el.offsetHeight
                  }, u = 0, p = 0), o !== l && o !== document.body) {
                    let e = o.getBoundingClientRect();
                    h = {
                      top: n.top - e.top,
                      left: n.left - e.left,
                      width: n.width,
                      height: n.height
                    }, u = 0, p = 0;
                  }
                  switch (v) {
                    case "top":
                      i = h.top - d.height - m;
                      break;
                    case "right":
                      s = h.left + h.width + m;
                      break;
                    case "bottom":
                      i = h.top + h.height + m;
                      break;
                    case "left":
                      s = h.left - d.width - m;
                  }
                  switch (g) {
                    case "top":
                      i = h.top;
                      break;
                    case "right":
                      s = h.left + h.width - d.width;
                      break;
                    case "bottom":
                      i = h.top + h.height - d.height;
                      break;
                    case "left":
                      s = h.left;
                      break;
                    case "center":
                      /left|right/.test(v) ? i = h.top + h.height / 2 - d.height / 2 : s = h.left + h.width / 2 - d.width / 2;
                  }
                  r.$datepicker.style.cssText = `left: ${s + p}px; top: ${i + u}px`;
                }
              }), I(this, "_setInputValue", () => {
                let {
                    opts: e,
                    $altField: t,
                    locale: {
                      dateFormat: i
                    }
                  } = this,
                  {
                    altFieldDateFormat: s,
                    altField: a
                  } = e;
                a && t && (t.value = this._getInputValue(s)), this.$el.value = this._getInputValue(i), this.$el.dispatchEvent(new Event("change"));
              }), I(this, "_getInputValue", e => {
                let {
                    selectedDates: t,
                    opts: i
                  } = this,
                  {
                    multipleDates: s,
                    multipleDatesSeparator: a
                  } = i;
                if (!t.length) return "";
                let n = "function" == typeof e,
                  r = n ? e(s ? t : t[0]) : t.map(t => this.formatDate(t, e));
                return r = n ? r : r.join(a), r;
              }), I(this, "_checkIfDateIsSelected", function (e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i.days,
                  s = !1;
                return r.selectedDates.some(i => {
                  let a = p(e, i, t);
                  return s = a && i, a;
                }), s;
              }), I(this, "_scheduleCallAfterTransition", e => {
                this._cancelScheduledCall(), e && e(!1), this._onTransitionEnd = () => {
                  e && e(!0);
                }, this.$datepicker.addEventListener("transitionend", this._onTransitionEnd, {
                  once: !0
                });
              }), I(this, "_cancelScheduledCall", () => {
                this.$datepicker.removeEventListener("transitionend", this._onTransitionEnd);
              }), I(this, "setViewDate", e => {
                if (!((e = b(e)) instanceof Date)) return;
                if (p(e, this.viewDate)) return;
                let t = this.viewDate;
                this.viewDate = e;
                let {
                  onChangeViewDate: s
                } = this.opts;
                if (s) {
                  let {
                    month: e,
                    year: t
                  } = this.parsedViewDate;
                  s({
                    month: e,
                    year: t,
                    decade: this.curDecade
                  });
                }
                this.trigger(i.eventChangeViewDate, e, t);
              }), I(this, "setFocusDate", function (e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                (!e || (e = b(e)) instanceof Date) && (r.focusDate = e, r.trigger(i.eventChangeFocusDate, e, t));
              }), I(this, "setCurrentView", function (e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (r.viewIndexes.includes(e)) {
                  if (r.currentView = e, r.elIsInput && r.visible && r.setPosition(void 0, !0), r.trigger(i.eventChangeCurrentView, e), !r.views[e]) {
                    let t = r.views[e] = new T({
                      dp: r,
                      opts: r.opts,
                      type: e
                    });
                    r.shouldUpdateDOM && r.$content.appendChild(t.$el);
                  }
                  r.opts.onChangeView && !t.silent && r.opts.onChangeView(e);
                }
              }), I(this, "_updateLastSelectedDate", e => {
                this.lastSelectedDate = e, this.trigger(i.eventChangeLastSelectedDate, e);
              }), I(this, "destroy", () => {
                if (this.isDestroyed) return;
                let {
                    showEvent: e,
                    isMobile: t
                  } = this.opts,
                  i = this.$datepicker.parentNode;
                i && i.removeChild(this.$datepicker), this.$el.removeEventListener(e, this._onFocus), this.$el.removeEventListener("blur", this._onBlur), window.removeEventListener("resize", this._onResize), t && this._removeMobileAttributes(), this.keyboardNav && this.keyboardNav.destroy(), this.views = null, this.nav = null, this.$datepicker = null, this.opts = {}, this.$customContainer = null, this.viewDate = null, this.focusDate = null, this.selectedDates = [], this.rangeDateFrom = null, this.rangeDateTo = null, this.isDestroyed = !0;
              }), I(this, "update", function () {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                  t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                  s = w({}, r.opts),
                  {
                    silent: a
                  } = t;
                w(r.opts, e);
                let {
                    timepicker: n,
                    buttons: h,
                    range: o,
                    selectedDates: l,
                    isMobile: d
                  } = r.opts,
                  c = r.visible || r.treatAsInline;
                r._createMinMaxDates(), r._limitViewDateByMaxMinDates(), r._handleLocale(), l && (r.selectedDates = [], r.selectDate(l, {
                  silent: a
                })), e.view && r.setCurrentView(e.view, {
                  silent: a
                }), r._setInputValue(), s.range && !o ? (r.rangeDateTo = !1, r.rangeDateFrom = !1) : !s.range && o && r.selectedDates.length && (r.rangeDateFrom = r.selectedDates[0], r.rangeDateTo = r.selectedDates[1]), s.timepicker && !n ? (c && r.timepicker.destroy(), r.timepicker = !1, r.$timepicker.parentNode.removeChild(r.$timepicker)) : !s.timepicker && n && r._addTimepicker(), !s.buttons && h ? r._addButtons() : s.buttons && !h ? (r.buttons.destroy(), r.$buttons.parentNode.removeChild(r.$buttons)) : c && s.buttons && h && r.buttons.clearHtml().render(), !s.isMobile && d ? (r.treatAsInline || j || r._createMobileOverlay(), r._addMobileAttributes(), r.visible && r._showMobileOverlay()) : s.isMobile && !d && (r._removeMobileAttributes(), r.visible && (j.classList.remove("-active-"), "function" != typeof r.opts.position && r.setPosition())), c && (r.nav.update(), r.views[r.currentView].render(), r.currentView === i.days && r.views[r.currentView].renderDayNames());
              }), I(this, "disableDate", (e, t) => {
                (Array.isArray(e) ? e : [e]).forEach(e => {
                  let i = b(e);
                  if (!i) return;
                  let s = t ? "delete" : "add";
                  this.disabledDates[s](this.formatDate(i, "yyyy-MM-dd"));
                  let a = this.getCell(i, this.currentViewSingular);
                  a && a.adpCell.render();
                }, []);
              }), I(this, "enableDate", e => {
                this.disableDate(e, !0);
              }), I(this, "isDateDisabled", e => {
                let t = b(e);
                return this.disabledDates.has(this.formatDate(t, "yyyy-MM-dd"));
              }), I(this, "isOtherMonth", e => {
                let {
                  month: t
                } = o(e);
                return t !== this.parsedViewDate.month;
              }), I(this, "isOtherYear", e => {
                let {
                  year: t
                } = o(e);
                return t !== this.parsedViewDate.year;
              }), I(this, "isOtherDecade", e => {
                let {
                    year: t
                  } = o(e),
                  [i, s] = c(this.viewDate);
                return t < i || t > s;
              }), I(this, "_onChangeSelectedDate", e => {
                let {
                  silent: t
                } = e;
                setTimeout(() => {
                  this._setInputValue(), this.opts.onSelect && !t && this._triggerOnSelect();
                });
              }), I(this, "_onChangeFocusedDate", function (e) {
                let {
                  viewDateTransition: t
                } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (!e) return;
                let i = !1;
                t && (i = r.isOtherMonth(e) || r.isOtherYear(e) || r.isOtherDecade(e)), i && r.setViewDate(e), r.opts.onFocus && r.opts.onFocus({
                  datepicker: r,
                  date: e
                });
              }), I(this, "_onChangeTime", e => {
                let {
                    hours: t,
                    minutes: i
                  } = e,
                  s = new Date(),
                  {
                    lastSelectedDate: a,
                    opts: {
                      onSelect: n
                    }
                  } = this,
                  r = a;
                a || (r = s);
                let h = this.getCell(r, this.currentViewSingular),
                  o = h && h.adpCell;
                o && o.isDisabled || (r.setHours(t), r.setMinutes(i), a ? (this._setInputValue(), n && this._triggerOnSelect()) : this.selectDate(r));
              }), I(this, "_onFocus", e => {
                this.visible || this.show();
              }), I(this, "_onBlur", e => {
                this.inFocus || !this.visible || this.opts.isMobile || this.hide();
              }), I(this, "_onMouseDown", e => {
                this.inFocus = !0;
              }), I(this, "_onMouseUp", e => {
                this.inFocus = !1, this.$el.focus();
              }), I(this, "_onResize", () => {
                this.visible && "function" != typeof this.opts.position && this.setPosition();
              }), I(this, "_onClickOverlay", () => {
                this.visible && this.hide();
              }), I(this, "getViewDates", function () {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : i.days;
                return T.getDatesFunction(e)(r);
              }), I(this, "isWeekend", e => this.opts.weekends.includes(e)), I(this, "getClampedDate", e => {
                let {
                    minDate: t,
                    maxDate: i
                  } = this,
                  s = e;
                return i && m(e, i) ? s = i : t && v(e, t) && (s = t), s;
              }), this.$el = a(e), !this.$el) return;
              this.$datepicker = n({
                className: "air-datepicker"
              }), this.opts = w({}, s, t), this.$customContainer = !!this.opts.container && a(this.opts.container), this.$altField = a(this.opts.altField || !1);
              let {
                view: h,
                startDate: l
              } = this.opts;
              l || (this.opts.startDate = new Date()), "INPUT" === this.$el.nodeName && (this.elIsInput = !0), this.inited = !1, this.visible = !1, this.viewDate = b(this.opts.startDate), this.focusDate = !1, this.initialReadonly = this.$el.getAttribute("readonly"), this.customHide = !1, this.currentView = h, this.selectedDates = [], this.disabledDates = new Set(), this.isDestroyed = !1, this.views = {}, this.keys = [], this.rangeDateFrom = "", this.rangeDateTo = "", this.timepickerIsActive = !1, this.treatAsInline = this.opts.inline || !this.elIsInput, this.init();
            }
            init() {
              let {
                  opts: e,
                  treatAsInline: t,
                  opts: {
                    inline: i,
                    isMobile: s,
                    selectedDates: n,
                    keyboardNav: r,
                    onlyTimepicker: h
                  }
                } = this,
                o = a("body");
              (!B || B && P && !o.contains(P)) && !i && this.elIsInput && !this.$customContainer && R.buildGlobalContainer(R.defaultGlobalContainerId), !s || j || t || this._createMobileOverlay(), this._handleLocale(), this._bindSubEvents(), this._createMinMaxDates(), this._limitViewDateByMaxMinDates(), this.elIsInput && (i || this._bindEvents(), r && !h && (this.keyboardNav = new O({
                dp: this,
                opts: e
              }))), n && this.selectDate(n, {
                silent: !0
              }), this.opts.visible && !t && this.show(), s && !t && this.$el.setAttribute("readonly", !0), t && this._createComponents();
            }
            _createMobileOverlay() {
              j = n({
                className: "air-datepicker-overlay"
              }), P.appendChild(j);
            }
            _createComponents() {
              let {
                opts: e,
                treatAsInline: t,
                opts: {
                  inline: i,
                  buttons: s,
                  timepicker: a,
                  position: n,
                  classes: r,
                  onlyTimepicker: h,
                  isMobile: o
                }
              } = this;
              this._buildBaseHtml(), this.elIsInput && (i || this._setPositionClasses(n)), !i && this.elIsInput || this.$datepicker.classList.add("-inline-"), r && this.$datepicker.classList.add(...r.split(" ")), h && this.$datepicker.classList.add("-only-timepicker-"), o && !t && this._addMobileAttributes(), this.views[this.currentView] = new T({
                dp: this,
                type: this.currentView,
                opts: e
              }), this.nav = new V({
                dp: this,
                opts: e
              }), a && this._addTimepicker(), s && this._addButtons(), this.$content.appendChild(this.views[this.currentView].$el), this.$nav.appendChild(this.nav.$el);
            }
            _destroyComponents() {
              for (let e in this.views) this.views[e].destroy();
              this.views = {}, this.nav.destroy(), this.timepicker && this.timepicker.destroy();
            }
            _addMobileAttributes() {
              j.addEventListener("click", this._onClickOverlay), this.$datepicker.classList.add("-is-mobile-"), this.$el.setAttribute("readonly", !0);
            }
            _removeMobileAttributes() {
              j.removeEventListener("click", this._onClickOverlay), this.$datepicker.classList.remove("-is-mobile-"), this.initialReadonly || "" === this.initialReadonly || this.$el.removeAttribute("readonly");
            }
            _createMinMaxDates() {
              let {
                minDate: e,
                maxDate: t
              } = this.opts;
              this.minDate = !!e && b(e), this.maxDate = !!t && b(t);
            }
            _addTimepicker() {
              this.$timepicker = n({
                className: "air-datepicker--time"
              }), this.$datepicker.appendChild(this.$timepicker), this.timepicker = new L({
                dp: this,
                opts: this.opts
              }), this.$timepicker.appendChild(this.timepicker.$el);
            }
            _addButtons() {
              this.$buttons = n({
                className: "air-datepicker--buttons"
              }), this.$datepicker.appendChild(this.$buttons), this.buttons = new H({
                dp: this,
                opts: this.opts
              }), this.$buttons.appendChild(this.buttons.$el);
            }
            _bindSubEvents() {
              this.on(i.eventChangeSelectedDate, this._onChangeSelectedDate), this.on(i.eventChangeFocusDate, this._onChangeFocusedDate), this.on(i.eventChangeTime, this._onChangeTime);
            }
            _buildBaseHtml() {
              let {
                inline: e
              } = this.opts;
              var t, i;
              this.elIsInput ? e ? (t = this.$datepicker, (i = this.$el).parentNode.insertBefore(t, i.nextSibling)) : this.$container.appendChild(this.$datepicker) : this.$el.appendChild(this.$datepicker), this.$datepicker.innerHTML = '<i class="air-datepicker--pointer"></i><div class="air-datepicker--navigation"></div><div class="air-datepicker--content"></div>', this.$content = a(".air-datepicker--content", this.$datepicker), this.$pointer = a(".air-datepicker--pointer", this.$datepicker), this.$nav = a(".air-datepicker--navigation", this.$datepicker);
            }
            _handleLocale() {
              let {
                locale: e,
                dateFormat: t,
                firstDay: i,
                timepicker: s,
                onlyTimepicker: a,
                timeFormat: n,
                dateTimeSeparator: r
              } = this.opts;
              var h;
              this.locale = (h = e, JSON.parse(JSON.stringify(h))), t && (this.locale.dateFormat = t), void 0 !== n && "" !== n && (this.locale.timeFormat = n);
              let {
                timeFormat: o
              } = this.locale;
              if ("" !== i && (this.locale.firstDay = i), s && "function" != typeof t) {
                let e = o ? r : "";
                this.locale.dateFormat = [this.locale.dateFormat, o || ""].join(e);
              }
              a && "function" != typeof t && (this.locale.dateFormat = this.locale.timeFormat);
            }
            _setPositionClasses(e) {
              if ("function" == typeof e) return void this.$datepicker.classList.add("-custom-position-");
              let t = (e = e.split(" "))[0],
                i = `air-datepicker -${t}-${e[1]}- -from-${t}-`;
              this.$datepicker.classList.add(...i.split(" "));
            }
            _bindEvents() {
              this.$el.addEventListener(this.opts.showEvent, this._onFocus), this.$el.addEventListener("blur", this._onBlur), this.$datepicker.addEventListener("mousedown", this._onMouseDown), this.$datepicker.addEventListener("mouseup", this._onMouseUp), window.addEventListener("resize", this._onResize);
            }
            _limitViewDateByMaxMinDates() {
              let {
                viewDate: e,
                minDate: t,
                maxDate: i
              } = this;
              i && m(e, i) && this.setViewDate(i), t && v(e, t) && this.setViewDate(t);
            }
            formatDate() {
              let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.viewDate,
                t = arguments.length > 1 ? arguments[1] : void 0;
              if (e = b(e), !(e instanceof Date)) return;
              let i = t,
                s = this.locale,
                a = o(e),
                n = a.dayPeriod,
                r = c(e),
                h = R.replacer,
                l = {
                  T: e.getTime(),
                  m: a.minutes,
                  mm: a.fullMinutes,
                  h: a.hours12,
                  hh: a.fullHours12,
                  H: a.hours,
                  HH: a.fullHours,
                  aa: n,
                  AA: n.toUpperCase(),
                  E: s.daysShort[a.day],
                  EEEE: s.days[a.day],
                  d: a.date,
                  dd: a.fullDate,
                  M: a.month + 1,
                  MM: a.fullMonth,
                  MMM: s.monthsShort[a.month],
                  MMMM: s.months[a.month],
                  yy: a.year.toString().slice(-2),
                  yyyy: a.year,
                  yyyy1: r[0],
                  yyyy2: r[1]
                };
              for (let [e, t] of Object.entries(l)) i = h(i, $(e), t);
              return i;
            }
            down(e) {
              this._handleUpDownActions(e, "down");
            }
            up(e) {
              this._handleUpDownActions(e, "up");
            }
            selectDate(e) {
              let t,
                s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                {
                  currentView: a,
                  parsedViewDate: n,
                  selectedDates: r
                } = this,
                {
                  updateTime: h,
                  silent: o
                } = s,
                {
                  moveToOtherMonthsOnSelect: l,
                  moveToOtherYearsOnSelect: d,
                  multipleDates: c,
                  range: u,
                  autoClose: p,
                  onBeforeSelect: v
                } = this.opts,
                g = r.length;
              if (Array.isArray(e)) return e.forEach(e => {
                this.selectDate(e, s);
              }), new Promise(e => {
                setTimeout(e);
              });
              if ((e = b(e)) instanceof Date) {
                if (v && !o && !v({
                  date: e,
                  datepicker: this
                })) return Promise.resolve();
                if (a === i.days && e.getMonth() !== n.month && l && (t = new Date(e.getFullYear(), e.getMonth(), 1)), a === i.years && e.getFullYear() !== n.year && d && (t = new Date(e.getFullYear(), 0, 1)), t && this.setViewDate(t), c && !u) {
                  if (g === c) return;
                  this._checkIfDateIsSelected(e) || r.push(e);
                } else if (u) switch (g) {
                  case 1:
                    r.push(e), this.rangeDateTo || (this.rangeDateTo = e), m(this.rangeDateFrom, this.rangeDateTo) && (this.rangeDateTo = this.rangeDateFrom, this.rangeDateFrom = e), this.selectedDates = [this.rangeDateFrom, this.rangeDateTo];
                    break;
                  case 2:
                    this.selectedDates = [e], this.rangeDateFrom = e, this.rangeDateTo = "";
                    break;
                  default:
                    this.selectedDates = [e], this.rangeDateFrom = e;
                } else this.selectedDates = [e];
                return this.trigger(i.eventChangeSelectedDate, {
                  action: i.actionSelectDate,
                  silent: null == s ? void 0 : s.silent,
                  date: e,
                  updateTime: h
                }), this._updateLastSelectedDate(e), p && !this.timepickerIsActive && this.visible && (c || u ? u && 1 === g && this.hide() : this.hide()), new Promise(e => {
                  setTimeout(e);
                });
              }
            }
            unselectDate(e) {
              let t = this.selectedDates,
                s = this;
              if ((e = b(e)) instanceof Date) return t.some((a, n) => {
                if (p(a, e)) return t.splice(n, 1), s.selectedDates.length ? (s.rangeDateTo = "", s.rangeDateFrom = t[0], s._updateLastSelectedDate(s.selectedDates[s.selectedDates.length - 1])) : (s.rangeDateFrom = "", s.rangeDateTo = "", s._updateLastSelectedDate(!1)), this.trigger(i.eventChangeSelectedDate, {
                  action: i.actionUnselectDate,
                  date: e
                }), !0;
              });
            }
            replaceDate(e, t) {
              let s = this.selectedDates.find(t => p(t, e, this.currentView)),
                a = this.selectedDates.indexOf(s);
              a < 0 || p(this.selectedDates[a], t, this.currentView) || (this.selectedDates[a] = t, this.trigger(i.eventChangeSelectedDate, {
                action: i.actionSelectDate,
                date: t,
                updateTime: !0
              }), this._updateLastSelectedDate(t));
            }
            clear() {
              let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              return this.selectedDates = [], this.rangeDateFrom = !1, this.rangeDateTo = !1, this.lastSelectedDate = !1, this.trigger(i.eventChangeSelectedDate, {
                action: i.actionUnselectDate,
                silent: e.silent
              }), new Promise(e => {
                setTimeout(e);
              });
            }
            show() {
              let {
                onShow: e,
                isMobile: t
              } = this.opts;
              this._cancelScheduledCall(), this.visible || this.hideAnimation || this._createComponents(), this.setPosition(this.opts.position), this.$datepicker.classList.add("-active-"), this.visible = !0, e && this._scheduleCallAfterTransition(e), t && this._showMobileOverlay();
            }
            hide() {
              let {
                  onHide: e,
                  isMobile: t
                } = this.opts,
                i = this._hasTransition();
              this.visible = !1, this.hideAnimation = !0, this.$datepicker.classList.remove("-active-"), this.customHide && this.customHide(), this.elIsInput && this.$el.blur(), this._scheduleCallAfterTransition(t => {
                !this.customHide && (t && i || !t && !i) && this._finishHide(), e && e(t);
              }), t && j.classList.remove("-active-");
            }
            _triggerOnSelect() {
              let e = [],
                t = [],
                {
                  selectedDates: i,
                  locale: s,
                  opts: {
                    onSelect: a,
                    multipleDates: n,
                    range: r
                  }
                } = this,
                h = n || r,
                o = "function" == typeof s.dateFormat;
              i.length && (e = i.map(g), t = o ? n ? s.dateFormat(e) : e.map(e => s.dateFormat(e)) : e.map(e => this.formatDate(e, s.dateFormat))), a({
                date: h ? e : e[0],
                formattedDate: h ? t : t[0],
                datepicker: this
              });
            }
            _handleAlreadySelectedDates(e, t) {
              let {
                  selectedDates: i,
                  rangeDateFrom: s,
                  rangeDateTo: a
                } = this,
                {
                  range: n,
                  toggleSelected: r
                } = this.opts,
                h = i.length,
                o = "function" == typeof r ? r({
                  datepicker: this,
                  date: t
                }) : r,
                l = Boolean(n && 1 === h && e),
                d = l ? g(t) : t;
              n && !o && (2 !== h && this.selectDate(d), 2 === h && p(s, a)) || (o ? this.unselectDate(d) : this._updateLastSelectedDate(l ? d : e));
            }
            _handleUpDownActions(e, t) {
              if (!((e = b(e || this.focusDate || this.viewDate)) instanceof Date)) return;
              let i = "up" === t ? this.viewIndex + 1 : this.viewIndex - 1;
              i > 2 && (i = 2), i < 0 && (i = 0), this.setViewDate(new Date(e.getFullYear(), e.getMonth(), 1)), this.setCurrentView(this.viewIndexes[i]);
            }
            getCell(e) {
              let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i.day;
              if (!((e = b(e)) instanceof Date)) return;
              let {
                  year: s,
                  month: a,
                  date: n
                } = o(e),
                r = `[data-year="${s}"]`,
                h = `[data-month="${a}"]`,
                l = {
                  [i.day]: `${r}${h}[data-date="${n}"]`,
                  [i.month]: `${r}${h}`,
                  [i.year]: `${r}`
                };
              return this.views[this.currentView] ? this.views[this.currentView].$el.querySelector(l[t]) : void 0;
            }
            _showMobileOverlay() {
              j.classList.add("-active-");
            }
            _hasTransition() {
              return window.getComputedStyle(this.$datepicker).getPropertyValue("transition-duration").split(", ").reduce((e, t) => parseFloat(t) + e, 0) > 0;
            }
            get shouldUpdateDOM() {
              return this.visible || this.treatAsInline;
            }
            get parsedViewDate() {
              return o(this.viewDate);
            }
            get currentViewSingular() {
              return this.currentView.slice(0, -1);
            }
            get curDecade() {
              return c(this.viewDate);
            }
            get viewIndex() {
              return this.viewIndexes.indexOf(this.currentView);
            }
            get isFinalView() {
              return this.currentView === i.years;
            }
            get hasSelectedDates() {
              return this.selectedDates.length > 0;
            }
            get isMinViewReached() {
              return this.currentView === this.opts.minView || this.currentView === i.days;
            }
            get $container() {
              return this.$customContainer || P;
            }
            static replacer(e, t, i) {
              return e.replace(t, function (e, t, s, a) {
                return t + i + a;
              });
            }
          }
          var K;
          return I(R, "defaults", s), I(R, "version", "3.6.0"), I(R, "defaultGlobalContainerId", "air-datepicker-global-container"), K = R.prototype, Object.assign(K, N), t.default;
        }();
      });
    })(airDatepicker);
    var AirDatepicker = airDatepicker.exports;

    var en = {};

    Object.defineProperty(en, "__esModule", {
      value: true
    });
    var default_1 = en.default = void 0;
    var _default = {
      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      today: 'Today',
      clear: 'Clear',
      dateFormat: 'MM/dd/yyyy',
      timeFormat: 'hh:mm aa',
      firstDay: 0
    };
    default_1 = en.default = _default;

    function t$1(t) {
      return "object" == typeof t && null != t && 1 === t.nodeType;
    }
    function e(t, e) {
      return (!e || "hidden" !== t) && "visible" !== t && "clip" !== t;
    }
    function n(t, n) {
      if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        var r = getComputedStyle(t, null);
        return e(r.overflowY, n) || e(r.overflowX, n) || function (t) {
          var e = function (t) {
            if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
            try {
              return t.ownerDocument.defaultView.frameElement;
            } catch (t) {
              return null;
            }
          }(t);
          return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        }(t);
      }
      return !1;
    }
    function r(t, e, n, r, i, o, l, d) {
      return o < t && l > e || o > t && l < e ? 0 : o <= t && d <= n || l >= e && d >= n ? o - t - r : l > e && d < n || o < t && d > n ? l - e + i : 0;
    }
    var i$1 = function (e, i) {
      var o = window,
        l = i.scrollMode,
        d = i.block,
        f = i.inline,
        h = i.boundary,
        u = i.skipOverflowHiddenElements,
        s = "function" == typeof h ? h : function (t) {
          return t !== h;
        };
      if (!t$1(e)) throw new TypeError("Invalid target");
      for (var a, c, g = document.scrollingElement || document.documentElement, p = [], m = e; t$1(m) && s(m);) {
        if ((m = null == (c = (a = m).parentElement) ? a.getRootNode().host || null : c) === g) {
          p.push(m);
          break;
        }
        null != m && m === document.body && n(m) && !n(document.documentElement) || null != m && n(m, u) && p.push(m);
      }
      for (var w = o.visualViewport ? o.visualViewport.width : innerWidth, v = o.visualViewport ? o.visualViewport.height : innerHeight, W = window.scrollX || pageXOffset, H = window.scrollY || pageYOffset, b = e.getBoundingClientRect(), y = b.height, E = b.width, M = b.top, V = b.right, x = b.bottom, I = b.left, C = "start" === d || "nearest" === d ? M : "end" === d ? x : M + y / 2, R = "center" === f ? I + E / 2 : "end" === f ? V : I, T = [], k = 0; k < p.length; k++) {
        var B = p[k],
          D = B.getBoundingClientRect(),
          O = D.height,
          X = D.width,
          Y = D.top,
          L = D.right,
          S = D.bottom,
          j = D.left;
        if ("if-needed" === l && M >= 0 && I >= 0 && x <= v && V <= w && M >= Y && x <= S && I >= j && V <= L) return T;
        var N = getComputedStyle(B),
          q = parseInt(N.borderLeftWidth, 10),
          z = parseInt(N.borderTopWidth, 10),
          A = parseInt(N.borderRightWidth, 10),
          F = parseInt(N.borderBottomWidth, 10),
          G = 0,
          J = 0,
          K = "offsetWidth" in B ? B.offsetWidth - B.clientWidth - q - A : 0,
          P = "offsetHeight" in B ? B.offsetHeight - B.clientHeight - z - F : 0,
          Q = "offsetWidth" in B ? 0 === B.offsetWidth ? 0 : X / B.offsetWidth : 0,
          U = "offsetHeight" in B ? 0 === B.offsetHeight ? 0 : O / B.offsetHeight : 0;
        if (g === B) G = "start" === d ? C : "end" === d ? C - v : "nearest" === d ? r(H, H + v, v, z, F, H + C, H + C + y, y) : C - v / 2, J = "start" === f ? R : "center" === f ? R - w / 2 : "end" === f ? R - w : r(W, W + w, w, q, A, W + R, W + R + E, E), G = Math.max(0, G + H), J = Math.max(0, J + W);else {
          G = "start" === d ? C - Y - z : "end" === d ? C - S + F + P : "nearest" === d ? r(Y, S, O, z, F + P, C, C + y, y) : C - (Y + O / 2) + P / 2, J = "start" === f ? R - j - q : "center" === f ? R - (j + X / 2) + K / 2 : "end" === f ? R - L + A + K : r(j, L, X, q, A + K, R, R + E, E);
          var Z = B.scrollLeft,
            $ = B.scrollTop;
          C += $ - (G = Math.max(0, Math.min($ + G / U, B.scrollHeight - O / U + P))), R += Z - (J = Math.max(0, Math.min(Z + J / Q, B.scrollWidth - X / Q + K)));
        }
        T.push({
          el: B,
          top: G,
          left: J
        });
      }
      return T;
    };

    function isOptionsObject(options) {
      return options === Object(options) && Object.keys(options).length !== 0;
    }
    function defaultBehavior(actions, behavior) {
      if (behavior === void 0) {
        behavior = 'auto';
      }
      var canSmoothScroll = 'scrollBehavior' in document.body.style;
      actions.forEach(function (_ref) {
        var el = _ref.el,
          top = _ref.top,
          left = _ref.left;
        if (el.scroll && canSmoothScroll) {
          el.scroll({
            top: top,
            left: left,
            behavior: behavior
          });
        } else {
          el.scrollTop = top;
          el.scrollLeft = left;
        }
      });
    }
    function getOptions(options) {
      if (options === false) {
        return {
          block: 'end',
          inline: 'nearest'
        };
      }
      if (isOptionsObject(options)) {
        return options;
      }
      return {
        block: 'start',
        inline: 'nearest'
      };
    }
    function scrollIntoView$1(target, options) {
      var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);
      if (isOptionsObject(options) && typeof options.behavior === 'function') {
        return options.behavior(isTargetAttached ? i$1(target, options) : []);
      }
      if (!isTargetAttached) {
        return;
      }
      var computeOptions = getOptions(options);
      return defaultBehavior(i$1(target, computeOptions), computeOptions.behavior);
    }

    var memoizedNow;
    var now$1 = function now() {
      if (!memoizedNow) {
        memoizedNow = 'performance' in window ? performance.now.bind(performance) : Date.now;
      }
      return memoizedNow();
    };
    function step(context) {
      var time = now$1();
      var elapsed = Math.min((time - context.startTime) / context.duration, 1);
      var value = context.ease(elapsed);
      var currentX = context.startX + (context.x - context.startX) * value;
      var currentY = context.startY + (context.y - context.startY) * value;
      context.method(currentX, currentY);
      if (currentX !== context.x || currentY !== context.y) {
        requestAnimationFrame(function () {
          return step(context);
        });
      } else {
        context.cb();
      }
    }
    function smoothScroll(el, x, y, duration, ease, cb) {
      if (duration === void 0) {
        duration = 600;
      }
      if (ease === void 0) {
        ease = function ease(t) {
          return 1 + --t * t * t * t * t;
        };
      }
      var scrollable;
      var startX;
      var startY;
      var method;
      scrollable = el;
      startX = el.scrollLeft;
      startY = el.scrollTop;
      method = function method(x, y) {
        el.scrollLeft = Math.ceil(x);
        el.scrollTop = Math.ceil(y);
      };
      step({
        scrollable: scrollable,
        method: method,
        startTime: now$1(),
        startX: startX,
        startY: startY,
        x: x,
        y: y,
        duration: duration,
        ease: ease,
        cb: cb
      });
    }
    var shouldSmoothScroll = function shouldSmoothScroll(options) {
      return options && !options.behavior || options.behavior === 'smooth';
    };
    function scroll(target, options) {
      var overrides = options || {};
      if (shouldSmoothScroll(overrides)) {
        return scrollIntoView$1(target, {
          block: overrides.block,
          inline: overrides.inline,
          scrollMode: overrides.scrollMode,
          boundary: overrides.boundary,
          behavior: function behavior(actions) {
            return Promise.all(actions.reduce(function (results, _ref) {
              var el = _ref.el,
                left = _ref.left,
                top = _ref.top;
              var startLeft = el.scrollLeft;
              var startTop = el.scrollTop;
              if (startLeft === left && startTop === top) {
                return results;
              }
              return [].concat(results, [new Promise(function (resolve) {
                return smoothScroll(el, left, top, overrides.duration, overrides.ease, function () {
                  return resolve({
                    el: el,
                    left: [startLeft, left],
                    top: [startTop, top]
                  });
                });
              })]);
            }, []));
          }
        });
      }
      return Promise.resolve(scrollIntoView$1(target, options));
    }
    var smoothScrollIntoView = scroll;
    var scrollIntoView = smoothScrollIntoView;

    var top = 'top';
    var bottom = 'bottom';
    var right = 'right';
    var left = 'left';
    var auto = 'auto';
    var basePlacements = [top, bottom, right, left];
    var start = 'start';
    var end = 'end';
    var clippingParents = 'clippingParents';
    var viewport = 'viewport';
    var popper = 'popper';
    var reference = 'reference';
    var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
      return acc.concat([placement + "-" + start, placement + "-" + end]);
    }, []);
    var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
      return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
    }, []); // modifiers that need to read the DOM

    var beforeRead = 'beforeRead';
    var read = 'read';
    var afterRead = 'afterRead'; // pure-logic modifiers

    var beforeMain = 'beforeMain';
    var main = 'main';
    var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

    var beforeWrite = 'beforeWrite';
    var write = 'write';
    var afterWrite = 'afterWrite';
    var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

    function getNodeName(element) {
      return element ? (element.nodeName || '').toLowerCase() : null;
    }

    function getWindow$1(node) {
      if (node == null) {
        return window;
      }
      if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
      }
      return node;
    }

    function isElement$1(node) {
      var OwnElement = getWindow$1(node).Element;
      return node instanceof OwnElement || node instanceof Element;
    }
    function isHTMLElement(node) {
      var OwnElement = getWindow$1(node).HTMLElement;
      return node instanceof OwnElement || node instanceof HTMLElement;
    }
    function isShadowRoot(node) {
      // IE 11 has no ShadowRoot
      if (typeof ShadowRoot === 'undefined') {
        return false;
      }
      var OwnElement = getWindow$1(node).ShadowRoot;
      return node instanceof OwnElement || node instanceof ShadowRoot;
    }

    // and applies them to the HTMLElements such as popper and arrow

    function applyStyles(_ref) {
      var state = _ref.state;
      Object.keys(state.elements).forEach(function (name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements

        if (!isHTMLElement(element) || !getNodeName(element)) {
          return;
        } // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]

        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function (name) {
          var value = attributes[name];
          if (value === false) {
            element.removeAttribute(name);
          } else {
            element.setAttribute(name, value === true ? '' : value);
          }
        });
      });
    }
    function effect$2(_ref2) {
      var state = _ref2.state;
      var initialStyles = {
        popper: {
          position: state.options.strategy,
          left: '0',
          top: '0',
          margin: '0'
        },
        arrow: {
          position: 'absolute'
        },
        reference: {}
      };
      Object.assign(state.elements.popper.style, initialStyles.popper);
      state.styles = initialStyles;
      if (state.elements.arrow) {
        Object.assign(state.elements.arrow.style, initialStyles.arrow);
      }
      return function () {
        Object.keys(state.elements).forEach(function (name) {
          var element = state.elements[name];
          var attributes = state.attributes[name] || {};
          var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

          var style = styleProperties.reduce(function (style, property) {
            style[property] = '';
            return style;
          }, {}); // arrow is optional + virtual elements

          if (!isHTMLElement(element) || !getNodeName(element)) {
            return;
          }
          Object.assign(element.style, style);
          Object.keys(attributes).forEach(function (attribute) {
            element.removeAttribute(attribute);
          });
        });
      };
    } // eslint-disable-next-line import/no-unused-modules

    var applyStyles$1 = {
      name: 'applyStyles',
      enabled: true,
      phase: 'write',
      fn: applyStyles,
      effect: effect$2,
      requires: ['computeStyles']
    };

    function getBasePlacement$1(placement) {
      return placement.split('-')[0];
    }

    var max = Math.max;
    var min = Math.min;
    var round = Math.round;

    function getUAString() {
      var uaData = navigator.userAgentData;
      if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
        return uaData.brands.map(function (item) {
          return item.brand + "/" + item.version;
        }).join(' ');
      }
      return navigator.userAgent;
    }

    function isLayoutViewport() {
      return !/^((?!chrome|android).)*safari/i.test(getUAString());
    }

    function getBoundingClientRect(element, includeScale, isFixedStrategy) {
      if (includeScale === void 0) {
        includeScale = false;
      }
      if (isFixedStrategy === void 0) {
        isFixedStrategy = false;
      }
      var clientRect = element.getBoundingClientRect();
      var scaleX = 1;
      var scaleY = 1;
      if (includeScale && isHTMLElement(element)) {
        scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
      }
      var _ref = isElement$1(element) ? getWindow$1(element) : window,
        visualViewport = _ref.visualViewport;
      var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
      var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
      var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
      var width = clientRect.width / scaleX;
      var height = clientRect.height / scaleY;
      return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
      };
    }

    // means it doesn't take into account transforms.

    function getLayoutRect(element) {
      var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
      // Fixes https://github.com/popperjs/popper-core/issues/1223

      var width = element.offsetWidth;
      var height = element.offsetHeight;
      if (Math.abs(clientRect.width - width) <= 1) {
        width = clientRect.width;
      }
      if (Math.abs(clientRect.height - height) <= 1) {
        height = clientRect.height;
      }
      return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
      };
    }

    function contains(parent, child) {
      var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

      if (parent.contains(child)) {
        return true;
      } // then fallback to custom implementation with Shadow DOM support
      else if (rootNode && isShadowRoot(rootNode)) {
        var next = child;
        do {
          if (next && parent.isSameNode(next)) {
            return true;
          } // $FlowFixMe[prop-missing]: need a better way to handle this...

          next = next.parentNode || next.host;
        } while (next);
      } // Give up, the result is false

      return false;
    }

    function getComputedStyle$2(element) {
      return getWindow$1(element).getComputedStyle(element);
    }

    function isTableElement(element) {
      return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
    }

    function getDocumentElement(element) {
      // $FlowFixMe[incompatible-return]: assume body is always available
      return ((isElement$1(element) ? element.ownerDocument :
      // $FlowFixMe[prop-missing]
      element.document) || window.document).documentElement;
    }

    function getParentNode(element) {
      if (getNodeName(element) === 'html') {
        return element;
      }
      return (
        // this is a quicker (but less type safe) way to save quite some bytes from the bundle
        // $FlowFixMe[incompatible-return]
        // $FlowFixMe[prop-missing]
        element.assignedSlot ||
        // step into the shadow DOM of the parent of a slotted node
        element.parentNode || (
        // DOM Element detected
        isShadowRoot(element) ? element.host : null) ||
        // ShadowRoot detected
        // $FlowFixMe[incompatible-call]: HTMLElement is a Node
        getDocumentElement(element) // fallback
      );
    }

    function getTrueOffsetParent(element) {
      if (!isHTMLElement(element) ||
      // https://github.com/popperjs/popper-core/issues/837
      getComputedStyle$2(element).position === 'fixed') {
        return null;
      }
      return element.offsetParent;
    } // `.offsetParent` reports `null` for fixed elements, while absolute elements
    // return the containing block

    function getContainingBlock(element) {
      var isFirefox = /firefox/i.test(getUAString());
      var isIE = /Trident/i.test(getUAString());
      if (isIE && isHTMLElement(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = getComputedStyle$2(element);
        if (elementCss.position === 'fixed') {
          return null;
        }
      }
      var currentNode = getParentNode(element);
      if (isShadowRoot(currentNode)) {
        currentNode = currentNode.host;
      }
      while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
        var css = getComputedStyle$2(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
          return currentNode;
        } else {
          currentNode = currentNode.parentNode;
        }
      }
      return null;
    } // Gets the closest ancestor positioned element. Handles some edge cases,
    // such as table ancestors and cross browser bugs.

    function getOffsetParent(element) {
      var window = getWindow$1(element);
      var offsetParent = getTrueOffsetParent(element);
      while (offsetParent && isTableElement(offsetParent) && getComputedStyle$2(offsetParent).position === 'static') {
        offsetParent = getTrueOffsetParent(offsetParent);
      }
      if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$2(offsetParent).position === 'static')) {
        return window;
      }
      return offsetParent || getContainingBlock(element) || window;
    }

    function getMainAxisFromPlacement(placement) {
      return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
    }

    function within(min$1, value, max$1) {
      return max(min$1, min(value, max$1));
    }
    function withinMaxClamp(min, value, max) {
      var v = within(min, value, max);
      return v > max ? max : v;
    }

    function getFreshSideObject() {
      return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      };
    }

    function mergePaddingObject(paddingObject) {
      return Object.assign({}, getFreshSideObject(), paddingObject);
    }

    function expandToHashMap(value, keys) {
      return keys.reduce(function (hashMap, key) {
        hashMap[key] = value;
        return hashMap;
      }, {});
    }

    var toPaddingObject = function toPaddingObject(padding, state) {
      padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
      })) : padding;
      return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
    };
    function arrow(_ref) {
      var _state$modifiersData$;
      var state = _ref.state,
        name = _ref.name,
        options = _ref.options;
      var arrowElement = state.elements.arrow;
      var popperOffsets = state.modifiersData.popperOffsets;
      var basePlacement = getBasePlacement$1(state.placement);
      var axis = getMainAxisFromPlacement(basePlacement);
      var isVertical = [left, right].indexOf(basePlacement) >= 0;
      var len = isVertical ? 'height' : 'width';
      if (!arrowElement || !popperOffsets) {
        return;
      }
      var paddingObject = toPaddingObject(options.padding, state);
      var arrowRect = getLayoutRect(arrowElement);
      var minProp = axis === 'y' ? top : left;
      var maxProp = axis === 'y' ? bottom : right;
      var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
      var startDiff = popperOffsets[axis] - state.rects.reference[axis];
      var arrowOffsetParent = getOffsetParent(arrowElement);
      var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
      var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
      // outside of the popper bounds

      var min = paddingObject[minProp];
      var max = clientSize - arrowRect[len] - paddingObject[maxProp];
      var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
      var offset = within(min, center, max); // Prevents breaking syntax highlighting...

      var axisProp = axis;
      state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
    }
    function effect$1(_ref2) {
      var state = _ref2.state,
        options = _ref2.options;
      var _options$element = options.element,
        arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
      if (arrowElement == null) {
        return;
      } // CSS selector

      if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) {
          return;
        }
      }
      if (!contains(state.elements.popper, arrowElement)) {
        return;
      }
      state.elements.arrow = arrowElement;
    } // eslint-disable-next-line import/no-unused-modules

    var arrow$1 = {
      name: 'arrow',
      enabled: true,
      phase: 'main',
      fn: arrow,
      effect: effect$1,
      requires: ['popperOffsets'],
      requiresIfExists: ['preventOverflow']
    };

    function getVariation(placement) {
      return placement.split('-')[1];
    }

    var unsetSides = {
      top: 'auto',
      right: 'auto',
      bottom: 'auto',
      left: 'auto'
    }; // Round the offsets to the nearest suitable subpixel based on the DPR.
    // Zooming can change the DPR, but it seems to report a value that will
    // cleanly divide the values into the appropriate subpixels.

    function roundOffsetsByDPR(_ref, win) {
      var x = _ref.x,
        y = _ref.y;
      var dpr = win.devicePixelRatio || 1;
      return {
        x: round(x * dpr) / dpr || 0,
        y: round(y * dpr) / dpr || 0
      };
    }
    function mapToStyles(_ref2) {
      var _Object$assign2;
      var popper = _ref2.popper,
        popperRect = _ref2.popperRect,
        placement = _ref2.placement,
        variation = _ref2.variation,
        offsets = _ref2.offsets,
        position = _ref2.position,
        gpuAcceleration = _ref2.gpuAcceleration,
        adaptive = _ref2.adaptive,
        roundOffsets = _ref2.roundOffsets,
        isFixed = _ref2.isFixed;
      var _offsets$x = offsets.x,
        x = _offsets$x === void 0 ? 0 : _offsets$x,
        _offsets$y = offsets.y,
        y = _offsets$y === void 0 ? 0 : _offsets$y;
      var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
      }) : {
        x: x,
        y: y
      };
      x = _ref3.x;
      y = _ref3.y;
      var hasX = offsets.hasOwnProperty('x');
      var hasY = offsets.hasOwnProperty('y');
      var sideX = left;
      var sideY = top;
      var win = window;
      if (adaptive) {
        var offsetParent = getOffsetParent(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === getWindow$1(popper)) {
          offsetParent = getDocumentElement(popper);
          if (getComputedStyle$2(offsetParent).position !== 'static' && position === 'absolute') {
            heightProp = 'scrollHeight';
            widthProp = 'scrollWidth';
          }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it

        offsetParent = offsetParent;
        if (placement === top || (placement === left || placement === right) && variation === end) {
          sideY = bottom;
          var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height :
          // $FlowFixMe[prop-missing]
          offsetParent[heightProp];
          y -= offsetY - popperRect.height;
          y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === left || (placement === top || placement === bottom) && variation === end) {
          sideX = right;
          var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width :
          // $FlowFixMe[prop-missing]
          offsetParent[widthProp];
          x -= offsetX - popperRect.width;
          x *= gpuAcceleration ? 1 : -1;
        }
      }
      var commonStyles = Object.assign({
        position: position
      }, adaptive && unsetSides);
      var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
        x: x,
        y: y
      }, getWindow$1(popper)) : {
        x: x,
        y: y
      };
      x = _ref4.x;
      y = _ref4.y;
      if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
      }
      return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
    }
    function computeStyles(_ref5) {
      var state = _ref5.state,
        options = _ref5.options;
      var _options$gpuAccelerat = options.gpuAcceleration,
        gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
        _options$adaptive = options.adaptive,
        adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
        _options$roundOffsets = options.roundOffsets,
        roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
      var commonStyles = {
        placement: getBasePlacement$1(state.placement),
        variation: getVariation(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
      };
      if (state.modifiersData.popperOffsets != null) {
        state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
          offsets: state.modifiersData.popperOffsets,
          position: state.options.strategy,
          adaptive: adaptive,
          roundOffsets: roundOffsets
        })));
      }
      if (state.modifiersData.arrow != null) {
        state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
          offsets: state.modifiersData.arrow,
          position: 'absolute',
          adaptive: false,
          roundOffsets: roundOffsets
        })));
      }
      state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
      });
    } // eslint-disable-next-line import/no-unused-modules

    var computeStyles$1 = {
      name: 'computeStyles',
      enabled: true,
      phase: 'beforeWrite',
      fn: computeStyles,
      data: {}
    };

    var passive = {
      passive: true
    };
    function effect(_ref) {
      var state = _ref.state,
        instance = _ref.instance,
        options = _ref.options;
      var _options$scroll = options.scroll,
        scroll = _options$scroll === void 0 ? true : _options$scroll,
        _options$resize = options.resize,
        resize = _options$resize === void 0 ? true : _options$resize;
      var window = getWindow$1(state.elements.popper);
      var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
      if (scroll) {
        scrollParents.forEach(function (scrollParent) {
          scrollParent.addEventListener('scroll', instance.update, passive);
        });
      }
      if (resize) {
        window.addEventListener('resize', instance.update, passive);
      }
      return function () {
        if (scroll) {
          scrollParents.forEach(function (scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, passive);
          });
        }
        if (resize) {
          window.removeEventListener('resize', instance.update, passive);
        }
      };
    } // eslint-disable-next-line import/no-unused-modules

    var eventListeners = {
      name: 'eventListeners',
      enabled: true,
      phase: 'write',
      fn: function fn() {},
      effect: effect,
      data: {}
    };

    var hash$1 = {
      left: 'right',
      right: 'left',
      bottom: 'top',
      top: 'bottom'
    };
    function getOppositePlacement(placement) {
      return placement.replace(/left|right|bottom|top/g, function (matched) {
        return hash$1[matched];
      });
    }

    var hash = {
      start: 'end',
      end: 'start'
    };
    function getOppositeVariationPlacement(placement) {
      return placement.replace(/start|end/g, function (matched) {
        return hash[matched];
      });
    }

    function getWindowScroll(node) {
      var win = getWindow$1(node);
      var scrollLeft = win.pageXOffset;
      var scrollTop = win.pageYOffset;
      return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      };
    }

    function getWindowScrollBarX(element) {
      // If <html> has a CSS width greater than the viewport, then this will be
      // incorrect for RTL.
      // Popper 1 is broken in this case and never had a bug report so let's assume
      // it's not an issue. I don't think anyone ever specifies width on <html>
      // anyway.
      // Browsers where the left scrollbar doesn't cause an issue report `0` for
      // this (e.g. Edge 2019, IE11, Safari)
      return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
    }

    function getViewportRect(element, strategy) {
      var win = getWindow$1(element);
      var html = getDocumentElement(element);
      var visualViewport = win.visualViewport;
      var width = html.clientWidth;
      var height = html.clientHeight;
      var x = 0;
      var y = 0;
      if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = isLayoutViewport();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
          x = visualViewport.offsetLeft;
          y = visualViewport.offsetTop;
        }
      }
      return {
        width: width,
        height: height,
        x: x + getWindowScrollBarX(element),
        y: y
      };
    }

    // of the `<html>` and `<body>` rect bounds if horizontally scrollable

    function getDocumentRect(element) {
      var _element$ownerDocumen;
      var html = getDocumentElement(element);
      var winScroll = getWindowScroll(element);
      var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
      var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
      var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
      var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
      var y = -winScroll.scrollTop;
      if (getComputedStyle$2(body || html).direction === 'rtl') {
        x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
      }
      return {
        width: width,
        height: height,
        x: x,
        y: y
      };
    }

    function isScrollParent(element) {
      // Firefox wants us to check `-x` and `-y` variations as well
      var _getComputedStyle = getComputedStyle$2(element),
        overflow = _getComputedStyle.overflow,
        overflowX = _getComputedStyle.overflowX,
        overflowY = _getComputedStyle.overflowY;
      return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
    }

    function getScrollParent$1(node) {
      if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
        // $FlowFixMe[incompatible-return]: assume body is always available
        return node.ownerDocument.body;
      }
      if (isHTMLElement(node) && isScrollParent(node)) {
        return node;
      }
      return getScrollParent$1(getParentNode(node));
    }

    /*
    given a DOM element, return the list of all scroll parents, up the list of ancesors
    until we get to the top window object. This list is what we attach scroll listeners
    to, because if any of these parent elements scroll, we'll need to re-calculate the
    reference element's position.
    */

    function listScrollParents(element, list) {
      var _element$ownerDocumen;
      if (list === void 0) {
        list = [];
      }
      var scrollParent = getScrollParent$1(element);
      var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
      var win = getWindow$1(scrollParent);
      var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
      var updatedList = list.concat(target);
      return isBody ? updatedList :
      // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
      updatedList.concat(listScrollParents(getParentNode(target)));
    }

    function rectToClientRect(rect) {
      return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
      });
    }

    function getInnerBoundingClientRect(element, strategy) {
      var rect = getBoundingClientRect(element, false, strategy === 'fixed');
      rect.top = rect.top + element.clientTop;
      rect.left = rect.left + element.clientLeft;
      rect.bottom = rect.top + element.clientHeight;
      rect.right = rect.left + element.clientWidth;
      rect.width = element.clientWidth;
      rect.height = element.clientHeight;
      rect.x = rect.left;
      rect.y = rect.top;
      return rect;
    }
    function getClientRectFromMixedType(element, clippingParent, strategy) {
      return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement$1(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
    } // A "clipping parent" is an overflowable container with the characteristic of
    // clipping (or hiding) overflowing elements with a position different from
    // `initial`

    function getClippingParents(element) {
      var clippingParents = listScrollParents(getParentNode(element));
      var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$2(element).position) >= 0;
      var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
      if (!isElement$1(clipperElement)) {
        return [];
      } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414

      return clippingParents.filter(function (clippingParent) {
        return isElement$1(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
      });
    } // Gets the maximum area that the element is visible in due to any number of
    // clipping parents

    function getClippingRect(element, boundary, rootBoundary, strategy) {
      var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
      var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
      var firstClippingParent = clippingParents[0];
      var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
        var rect = getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = max(rect.top, accRect.top);
        accRect.right = min(rect.right, accRect.right);
        accRect.bottom = min(rect.bottom, accRect.bottom);
        accRect.left = max(rect.left, accRect.left);
        return accRect;
      }, getClientRectFromMixedType(element, firstClippingParent, strategy));
      clippingRect.width = clippingRect.right - clippingRect.left;
      clippingRect.height = clippingRect.bottom - clippingRect.top;
      clippingRect.x = clippingRect.left;
      clippingRect.y = clippingRect.top;
      return clippingRect;
    }

    function computeOffsets(_ref) {
      var reference = _ref.reference,
        element = _ref.element,
        placement = _ref.placement;
      var basePlacement = placement ? getBasePlacement$1(placement) : null;
      var variation = placement ? getVariation(placement) : null;
      var commonX = reference.x + reference.width / 2 - element.width / 2;
      var commonY = reference.y + reference.height / 2 - element.height / 2;
      var offsets;
      switch (basePlacement) {
        case top:
          offsets = {
            x: commonX,
            y: reference.y - element.height
          };
          break;
        case bottom:
          offsets = {
            x: commonX,
            y: reference.y + reference.height
          };
          break;
        case right:
          offsets = {
            x: reference.x + reference.width,
            y: commonY
          };
          break;
        case left:
          offsets = {
            x: reference.x - element.width,
            y: commonY
          };
          break;
        default:
          offsets = {
            x: reference.x,
            y: reference.y
          };
      }
      var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
      if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch (variation) {
          case start:
            offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
            break;
          case end:
            offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
            break;
        }
      }
      return offsets;
    }

    function detectOverflow(state, options) {
      if (options === void 0) {
        options = {};
      }
      var _options = options,
        _options$placement = _options.placement,
        placement = _options$placement === void 0 ? state.placement : _options$placement,
        _options$strategy = _options.strategy,
        strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
        _options$boundary = _options.boundary,
        boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
        _options$rootBoundary = _options.rootBoundary,
        rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
        _options$elementConte = _options.elementContext,
        elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
        _options$altBoundary = _options.altBoundary,
        altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
        _options$padding = _options.padding,
        padding = _options$padding === void 0 ? 0 : _options$padding;
      var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
      var altContext = elementContext === popper ? reference : popper;
      var popperRect = state.rects.popper;
      var element = state.elements[altBoundary ? altContext : elementContext];
      var clippingClientRect = getClippingRect(isElement$1(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
      var referenceClientRect = getBoundingClientRect(state.elements.reference);
      var popperOffsets = computeOffsets({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
      });
      var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
      var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
      // 0 or negative = within the clipping rect

      var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
      };
      var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

      if (elementContext === popper && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function (key) {
          var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
          var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
          overflowOffsets[key] += offset[axis] * multiply;
        });
      }
      return overflowOffsets;
    }

    function computeAutoPlacement(state, options) {
      if (options === void 0) {
        options = {};
      }
      var _options = options,
        placement = _options.placement,
        boundary = _options.boundary,
        rootBoundary = _options.rootBoundary,
        padding = _options.padding,
        flipVariations = _options.flipVariations,
        _options$allowedAutoP = _options.allowedAutoPlacements,
        allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
      var variation = getVariation(placement);
      var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
        return getVariation(placement) === variation;
      }) : basePlacements;
      var allowedPlacements = placements$1.filter(function (placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
      });
      if (allowedPlacements.length === 0) {
        allowedPlacements = placements$1;
      } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...

      var overflows = allowedPlacements.reduce(function (acc, placement) {
        acc[placement] = detectOverflow(state, {
          placement: placement,
          boundary: boundary,
          rootBoundary: rootBoundary,
          padding: padding
        })[getBasePlacement$1(placement)];
        return acc;
      }, {});
      return Object.keys(overflows).sort(function (a, b) {
        return overflows[a] - overflows[b];
      });
    }

    function getExpandedFallbackPlacements(placement) {
      if (getBasePlacement$1(placement) === auto) {
        return [];
      }
      var oppositePlacement = getOppositePlacement(placement);
      return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
    }
    function flip(_ref) {
      var state = _ref.state,
        options = _ref.options,
        name = _ref.name;
      if (state.modifiersData[name]._skip) {
        return;
      }
      var _options$mainAxis = options.mainAxis,
        checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
        _options$altAxis = options.altAxis,
        checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
        specifiedFallbackPlacements = options.fallbackPlacements,
        padding = options.padding,
        boundary = options.boundary,
        rootBoundary = options.rootBoundary,
        altBoundary = options.altBoundary,
        _options$flipVariatio = options.flipVariations,
        flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
        allowedAutoPlacements = options.allowedAutoPlacements;
      var preferredPlacement = state.options.placement;
      var basePlacement = getBasePlacement$1(preferredPlacement);
      var isBasePlacement = basePlacement === preferredPlacement;
      var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
      var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
        return acc.concat(getBasePlacement$1(placement) === auto ? computeAutoPlacement(state, {
          placement: placement,
          boundary: boundary,
          rootBoundary: rootBoundary,
          padding: padding,
          flipVariations: flipVariations,
          allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
      }, []);
      var referenceRect = state.rects.reference;
      var popperRect = state.rects.popper;
      var checksMap = new Map();
      var makeFallbackChecks = true;
      var firstFittingPlacement = placements[0];
      for (var i = 0; i < placements.length; i++) {
        var placement = placements[i];
        var _basePlacement = getBasePlacement$1(placement);
        var isStartVariation = getVariation(placement) === start;
        var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = detectOverflow(state, {
          placement: placement,
          boundary: boundary,
          rootBoundary: rootBoundary,
          altBoundary: altBoundary,
          padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
        if (referenceRect[len] > popperRect[len]) {
          mainVariationSide = getOppositePlacement(mainVariationSide);
        }
        var altVariationSide = getOppositePlacement(mainVariationSide);
        var checks = [];
        if (checkMainAxis) {
          checks.push(overflow[_basePlacement] <= 0);
        }
        if (checkAltAxis) {
          checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        }
        if (checks.every(function (check) {
          return check;
        })) {
          firstFittingPlacement = placement;
          makeFallbackChecks = false;
          break;
        }
        checksMap.set(placement, checks);
      }
      if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
          var fittingPlacement = placements.find(function (placement) {
            var checks = checksMap.get(placement);
            if (checks) {
              return checks.slice(0, _i).every(function (check) {
                return check;
              });
            }
          });
          if (fittingPlacement) {
            firstFittingPlacement = fittingPlacement;
            return "break";
          }
        };
        for (var _i = numberOfChecks; _i > 0; _i--) {
          var _ret = _loop(_i);
          if (_ret === "break") break;
        }
      }
      if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
      }
    } // eslint-disable-next-line import/no-unused-modules

    var flip$1 = {
      name: 'flip',
      enabled: true,
      phase: 'main',
      fn: flip,
      requiresIfExists: ['offset'],
      data: {
        _skip: false
      }
    };

    function getSideOffsets(overflow, rect, preventedOffsets) {
      if (preventedOffsets === void 0) {
        preventedOffsets = {
          x: 0,
          y: 0
        };
      }
      return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
      };
    }
    function isAnySideFullyClipped(overflow) {
      return [top, right, bottom, left].some(function (side) {
        return overflow[side] >= 0;
      });
    }
    function hide(_ref) {
      var state = _ref.state,
        name = _ref.name;
      var referenceRect = state.rects.reference;
      var popperRect = state.rects.popper;
      var preventedOffsets = state.modifiersData.preventOverflow;
      var referenceOverflow = detectOverflow(state, {
        elementContext: 'reference'
      });
      var popperAltOverflow = detectOverflow(state, {
        altBoundary: true
      });
      var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
      var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
      var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
      var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
      state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
      };
      state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
      });
    } // eslint-disable-next-line import/no-unused-modules

    var hide$1 = {
      name: 'hide',
      enabled: true,
      phase: 'main',
      requiresIfExists: ['preventOverflow'],
      fn: hide
    };

    function distanceAndSkiddingToXY(placement, rects, offset) {
      var basePlacement = getBasePlacement$1(placement);
      var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
      var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
          placement: placement
        })) : offset,
        skidding = _ref[0],
        distance = _ref[1];
      skidding = skidding || 0;
      distance = (distance || 0) * invertDistance;
      return [left, right].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
      } : {
        x: skidding,
        y: distance
      };
    }
    function offset(_ref2) {
      var state = _ref2.state,
        options = _ref2.options,
        name = _ref2.name;
      var _options$offset = options.offset,
        offset = _options$offset === void 0 ? [0, 0] : _options$offset;
      var data = placements.reduce(function (acc, placement) {
        acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
        return acc;
      }, {});
      var _data$state$placement = data[state.placement],
        x = _data$state$placement.x,
        y = _data$state$placement.y;
      if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
      }
      state.modifiersData[name] = data;
    } // eslint-disable-next-line import/no-unused-modules

    var offset$1 = {
      name: 'offset',
      enabled: true,
      phase: 'main',
      requires: ['popperOffsets'],
      fn: offset
    };

    function popperOffsets(_ref) {
      var state = _ref.state,
        name = _ref.name;
      // Offsets are the actual position the popper needs to have to be
      // properly positioned near its reference element
      // This is the most basic placement, and will be adjusted by
      // the modifiers in the next step
      state.modifiersData[name] = computeOffsets({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
      });
    } // eslint-disable-next-line import/no-unused-modules

    var popperOffsets$1 = {
      name: 'popperOffsets',
      enabled: true,
      phase: 'read',
      fn: popperOffsets,
      data: {}
    };

    function getAltAxis(axis) {
      return axis === 'x' ? 'y' : 'x';
    }

    function preventOverflow(_ref) {
      var state = _ref.state,
        options = _ref.options,
        name = _ref.name;
      var _options$mainAxis = options.mainAxis,
        checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
        _options$altAxis = options.altAxis,
        checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
        boundary = options.boundary,
        rootBoundary = options.rootBoundary,
        altBoundary = options.altBoundary,
        padding = options.padding,
        _options$tether = options.tether,
        tether = _options$tether === void 0 ? true : _options$tether,
        _options$tetherOffset = options.tetherOffset,
        tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
      var overflow = detectOverflow(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
      });
      var basePlacement = getBasePlacement$1(state.placement);
      var variation = getVariation(state.placement);
      var isBasePlacement = !variation;
      var mainAxis = getMainAxisFromPlacement(basePlacement);
      var altAxis = getAltAxis(mainAxis);
      var popperOffsets = state.modifiersData.popperOffsets;
      var referenceRect = state.rects.reference;
      var popperRect = state.rects.popper;
      var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
      })) : tetherOffset;
      var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
      } : Object.assign({
        mainAxis: 0,
        altAxis: 0
      }, tetherOffsetValue);
      var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
      var data = {
        x: 0,
        y: 0
      };
      if (!popperOffsets) {
        return;
      }
      if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? top : left;
        var altSide = mainAxis === 'y' ? bottom : right;
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min$1 = offset + overflow[mainSide];
        var max$1 = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === start ? referenceRect[len] : popperRect[len];
        var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds

        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
          width: 0,
          height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)

        var arrowLen = within(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
      }
      if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? top : left;
        var _altSide = mainAxis === 'x' ? bottom : right;
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
      }
      state.modifiersData[name] = data;
    } // eslint-disable-next-line import/no-unused-modules

    var preventOverflow$1 = {
      name: 'preventOverflow',
      enabled: true,
      phase: 'main',
      fn: preventOverflow,
      requiresIfExists: ['offset']
    };

    function getHTMLElementScroll(element) {
      return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
      };
    }

    function getNodeScroll(node) {
      if (node === getWindow$1(node) || !isHTMLElement(node)) {
        return getWindowScroll(node);
      } else {
        return getHTMLElementScroll(node);
      }
    }

    function isElementScaled(element) {
      var rect = element.getBoundingClientRect();
      var scaleX = round(rect.width) / element.offsetWidth || 1;
      var scaleY = round(rect.height) / element.offsetHeight || 1;
      return scaleX !== 1 || scaleY !== 1;
    } // Returns the composite rect of an element relative to its offsetParent.
    // Composite means it takes into account transforms as well as layout.

    function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
      if (isFixed === void 0) {
        isFixed = false;
      }
      var isOffsetParentAnElement = isHTMLElement(offsetParent);
      var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
      var documentElement = getDocumentElement(offsetParent);
      var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
      var scroll = {
        scrollLeft: 0,
        scrollTop: 0
      };
      var offsets = {
        x: 0,
        y: 0
      };
      if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if (getNodeName(offsetParent) !== 'body' ||
        // https://github.com/popperjs/popper-core/issues/1078
        isScrollParent(documentElement)) {
          scroll = getNodeScroll(offsetParent);
        }
        if (isHTMLElement(offsetParent)) {
          offsets = getBoundingClientRect(offsetParent, true);
          offsets.x += offsetParent.clientLeft;
          offsets.y += offsetParent.clientTop;
        } else if (documentElement) {
          offsets.x = getWindowScrollBarX(documentElement);
        }
      }
      return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
      };
    }

    function order(modifiers) {
      var map = new Map();
      var visited = new Set();
      var result = [];
      modifiers.forEach(function (modifier) {
        map.set(modifier.name, modifier);
      }); // On visiting object, check for its dependencies and visit them recursively

      function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function (dep) {
          if (!visited.has(dep)) {
            var depModifier = map.get(dep);
            if (depModifier) {
              sort(depModifier);
            }
          }
        });
        result.push(modifier);
      }
      modifiers.forEach(function (modifier) {
        if (!visited.has(modifier.name)) {
          // check for visited object
          sort(modifier);
        }
      });
      return result;
    }
    function orderModifiers(modifiers) {
      // order based on dependencies
      var orderedModifiers = order(modifiers); // order based on phase

      return modifierPhases.reduce(function (acc, phase) {
        return acc.concat(orderedModifiers.filter(function (modifier) {
          return modifier.phase === phase;
        }));
      }, []);
    }

    function debounce$1(fn) {
      var pending;
      return function () {
        if (!pending) {
          pending = new Promise(function (resolve) {
            Promise.resolve().then(function () {
              pending = undefined;
              resolve(fn());
            });
          });
        }
        return pending;
      };
    }

    function mergeByName(modifiers) {
      var merged = modifiers.reduce(function (merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
          options: Object.assign({}, existing.options, current.options),
          data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
      }, {}); // IE11 does not support Object.values

      return Object.keys(merged).map(function (key) {
        return merged[key];
      });
    }

    var DEFAULT_OPTIONS = {
      placement: 'bottom',
      modifiers: [],
      strategy: 'absolute'
    };
    function areValidElements() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return !args.some(function (element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
      });
    }
    function popperGenerator(generatorOptions) {
      if (generatorOptions === void 0) {
        generatorOptions = {};
      }
      var _generatorOptions = generatorOptions,
        _generatorOptions$def = _generatorOptions.defaultModifiers,
        defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
        _generatorOptions$def2 = _generatorOptions.defaultOptions,
        defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
      return function createPopper(reference, popper, options) {
        if (options === void 0) {
          options = defaultOptions;
        }
        var state = {
          placement: 'bottom',
          orderedModifiers: [],
          options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
          modifiersData: {},
          elements: {
            reference: reference,
            popper: popper
          },
          attributes: {},
          styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
          state: state,
          setOptions: function setOptions(setOptionsAction) {
            var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
            cleanupModifierEffects();
            state.options = Object.assign({}, defaultOptions, state.options, options);
            state.scrollParents = {
              reference: isElement$1(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
              popper: listScrollParents(popper)
            }; // Orders the modifiers based on their dependencies and `phase`
            // properties

            var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

            state.orderedModifiers = orderedModifiers.filter(function (m) {
              return m.enabled;
            });
            runModifierEffects();
            return instance.update();
          },
          // Sync update – it will always be executed, even if not necessary. This
          // is useful for low frequency updates where sync behavior simplifies the
          // logic.
          // For high frequency updates (e.g. `resize` and `scroll` events), always
          // prefer the async Popper#update method
          forceUpdate: function forceUpdate() {
            if (isDestroyed) {
              return;
            }
            var _state$elements = state.elements,
              reference = _state$elements.reference,
              popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
            // anymore

            if (!areValidElements(reference, popper)) {
              return;
            } // Store the reference and popper rects to be read by modifiers

            state.rects = {
              reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
              popper: getLayoutRect(popper)
            }; // Modifiers have the ability to reset the current update cycle. The
            // most common use case for this is the `flip` modifier changing the
            // placement, which then needs to re-run all the modifiers, because the
            // logic was previously ran for the previous placement and is therefore
            // stale/incorrect

            state.reset = false;
            state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
            // is filled with the initial data specified by the modifier. This means
            // it doesn't persist and is fresh on each update.
            // To ensure persistent data, use `${name}#persistent`

            state.orderedModifiers.forEach(function (modifier) {
              return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
            });
            for (var index = 0; index < state.orderedModifiers.length; index++) {
              if (state.reset === true) {
                state.reset = false;
                index = -1;
                continue;
              }
              var _state$orderedModifie = state.orderedModifiers[index],
                fn = _state$orderedModifie.fn,
                _state$orderedModifie2 = _state$orderedModifie.options,
                _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
                name = _state$orderedModifie.name;
              if (typeof fn === 'function') {
                state = fn({
                  state: state,
                  options: _options,
                  name: name,
                  instance: instance
                }) || state;
              }
            }
          },
          // Async and optimistically optimized update – it will not be executed if
          // not necessary (debounced to run at most once-per-tick)
          update: debounce$1(function () {
            return new Promise(function (resolve) {
              instance.forceUpdate();
              resolve(state);
            });
          }),
          destroy: function destroy() {
            cleanupModifierEffects();
            isDestroyed = true;
          }
        };
        if (!areValidElements(reference, popper)) {
          return instance;
        }
        instance.setOptions(options).then(function (state) {
          if (!isDestroyed && options.onFirstUpdate) {
            options.onFirstUpdate(state);
          }
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.

        function runModifierEffects() {
          state.orderedModifiers.forEach(function (_ref) {
            var name = _ref.name,
              _ref$options = _ref.options,
              options = _ref$options === void 0 ? {} : _ref$options,
              effect = _ref.effect;
            if (typeof effect === 'function') {
              var cleanupFn = effect({
                state: state,
                name: name,
                instance: instance,
                options: options
              });
              var noopFn = function noopFn() {};
              effectCleanupFns.push(cleanupFn || noopFn);
            }
          });
        }
        function cleanupModifierEffects() {
          effectCleanupFns.forEach(function (fn) {
            return fn();
          });
          effectCleanupFns = [];
        }
        return instance;
      };
    }

    var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
    var createPopper = /*#__PURE__*/popperGenerator({
      defaultModifiers: defaultModifiers
    }); // eslint-disable-next-line import/no-unused-modules

    /**!
    * tippy.js v6.3.7
    * (c) 2017-2021 atomiks
    * MIT License
    */
    var BOX_CLASS = "tippy-box";
    var CONTENT_CLASS = "tippy-content";
    var BACKDROP_CLASS = "tippy-backdrop";
    var ARROW_CLASS = "tippy-arrow";
    var SVG_ARROW_CLASS = "tippy-svg-arrow";
    var TOUCH_OPTIONS = {
      passive: true,
      capture: true
    };
    var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
      return document.body;
    };
    function getValueAtIndexOrReturn(value, index, defaultValue) {
      if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
      }
      return value;
    }
    function isType(value, type) {
      var str = {}.toString.call(value);
      return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
    }
    function invokeWithArgsOrReturn(value, args) {
      return typeof value === 'function' ? value.apply(void 0, args) : value;
    }
    function debounce(fn, ms) {
      // Avoid wrapping in `setTimeout` if ms is 0 anyway
      if (ms === 0) {
        return fn;
      }
      var timeout;
      return function (arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          fn(arg);
        }, ms);
      };
    }
    function splitBySpaces(value) {
      return value.split(/\s+/).filter(Boolean);
    }
    function normalizeToArray(value) {
      return [].concat(value);
    }
    function pushIfUnique(arr, value) {
      if (arr.indexOf(value) === -1) {
        arr.push(value);
      }
    }
    function unique(arr) {
      return arr.filter(function (item, index) {
        return arr.indexOf(item) === index;
      });
    }
    function getBasePlacement(placement) {
      return placement.split('-')[0];
    }
    function arrayFrom(value) {
      return [].slice.call(value);
    }
    function removeUndefinedProps(obj) {
      return Object.keys(obj).reduce(function (acc, key) {
        if (obj[key] !== undefined) {
          acc[key] = obj[key];
        }
        return acc;
      }, {});
    }
    function div() {
      return document.createElement('div');
    }
    function isElement(value) {
      return ['Element', 'Fragment'].some(function (type) {
        return isType(value, type);
      });
    }
    function isNodeList(value) {
      return isType(value, 'NodeList');
    }
    function isMouseEvent(value) {
      return isType(value, 'MouseEvent');
    }
    function isReferenceElement(value) {
      return !!(value && value._tippy && value._tippy.reference === value);
    }
    function getArrayOfElements(value) {
      if (isElement(value)) {
        return [value];
      }
      if (isNodeList(value)) {
        return arrayFrom(value);
      }
      if (Array.isArray(value)) {
        return value;
      }
      return arrayFrom(document.querySelectorAll(value));
    }
    function setTransitionDuration(els, value) {
      els.forEach(function (el) {
        if (el) {
          el.style.transitionDuration = value + "ms";
        }
      });
    }
    function setVisibilityState(els, state) {
      els.forEach(function (el) {
        if (el) {
          el.setAttribute('data-state', state);
        }
      });
    }
    function getOwnerDocument(elementOrElements) {
      var _element$ownerDocumen;
      var _normalizeToArray = normalizeToArray(elementOrElements),
        element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body

      return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
    }
    function isCursorOutsideInteractiveBorder(popperTreeData, event) {
      var clientX = event.clientX,
        clientY = event.clientY;
      return popperTreeData.every(function (_ref) {
        var popperRect = _ref.popperRect,
          popperState = _ref.popperState,
          props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) {
          return true;
        }
        var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
        var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
      });
    }
    function updateTransitionEndListener(box, action, listener) {
      var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
      // `webkitTransitionEnd`...

      ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
        box[method](event, listener);
      });
    }
    /**
     * Compared to xxx.contains, this function works for dom structures with shadow
     * dom
     */

    function actualContains(parent, child) {
      var target = child;
      while (target) {
        var _target$getRootNode;
        if (parent.contains(target)) {
          return true;
        }
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
      }
      return false;
    }
    var currentInput = {
      isTouch: false
    };
    var lastMouseMoveTime = 0;
    /**
     * When a `touchstart` event is fired, it's assumed the user is using touch
     * input. We'll bind a `mousemove` event listener to listen for mouse input in
     * the future. This way, the `isTouch` property is fully dynamic and will handle
     * hybrid devices that use a mix of touch + mouse input.
     */

    function onDocumentTouchStart$1() {
      if (currentInput.isTouch) {
        return;
      }
      currentInput.isTouch = true;
      if (window.performance) {
        document.addEventListener('mousemove', onDocumentMouseMove);
      }
    }
    /**
     * When two `mousemove` event are fired consecutively within 20ms, it's assumed
     * the user is using mouse input again. `mousemove` can fire on touch devices as
     * well, but very rarely that quickly.
     */

    function onDocumentMouseMove() {
      var now = performance.now();
      if (now - lastMouseMoveTime < 20) {
        currentInput.isTouch = false;
        document.removeEventListener('mousemove', onDocumentMouseMove);
      }
      lastMouseMoveTime = now;
    }
    /**
     * When an element is in focus and has a tippy, leaving the tab/window and
     * returning causes it to show again. For mouse users this is unexpected, but
     * for keyboard use it makes sense.
     * TODO: find a better technique to solve this problem
     */

    function onWindowBlur() {
      var activeElement = document.activeElement;
      if (isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) {
          activeElement.blur();
        }
      }
    }
    function bindGlobalEventListeners() {
      document.addEventListener('touchstart', onDocumentTouchStart$1, TOUCH_OPTIONS);
      window.addEventListener('blur', onWindowBlur);
    }
    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
    var isIE11 = isBrowser ?
    // @ts-ignore
    !!window.msCrypto : false;
    var pluginProps = {
      animateFill: false,
      followCursor: false,
      inlinePositioning: false,
      sticky: false
    };
    var renderProps = {
      allowHTML: false,
      animation: 'fade',
      arrow: true,
      content: '',
      inertia: false,
      maxWidth: 350,
      role: 'tooltip',
      theme: '',
      zIndex: 9999
    };
    var defaultProps = Object.assign({
      appendTo: TIPPY_DEFAULT_APPEND_TO,
      aria: {
        content: 'auto',
        expanded: 'auto'
      },
      delay: 0,
      duration: [300, 250],
      getReferenceClientRect: null,
      hideOnClick: true,
      ignoreAttributes: false,
      interactive: false,
      interactiveBorder: 2,
      interactiveDebounce: 0,
      moveTransition: '',
      offset: [0, 10],
      onAfterUpdate: function onAfterUpdate() {},
      onBeforeUpdate: function onBeforeUpdate() {},
      onCreate: function onCreate() {},
      onDestroy: function onDestroy() {},
      onHidden: function onHidden() {},
      onHide: function onHide() {},
      onMount: function onMount() {},
      onShow: function onShow() {},
      onShown: function onShown() {},
      onTrigger: function onTrigger() {},
      onUntrigger: function onUntrigger() {},
      onClickOutside: function onClickOutside() {},
      placement: 'top',
      plugins: [],
      popperOptions: {},
      render: null,
      showOnCreate: false,
      touch: true,
      trigger: 'mouseenter focus',
      triggerTarget: null
    }, pluginProps, renderProps);
    var defaultKeys = Object.keys(defaultProps);
    var setDefaultProps = function setDefaultProps(partialProps) {
      var keys = Object.keys(partialProps);
      keys.forEach(function (key) {
        defaultProps[key] = partialProps[key];
      });
    };
    function getExtendedPassedProps(passedProps) {
      var plugins = passedProps.plugins || [];
      var pluginProps = plugins.reduce(function (acc, plugin) {
        var name = plugin.name,
          defaultValue = plugin.defaultValue;
        if (name) {
          var _name;
          acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
      }, {});
      return Object.assign({}, passedProps, pluginProps);
    }
    function getDataAttributeProps(reference, plugins) {
      var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
        plugins: plugins
      }))) : defaultKeys;
      var props = propKeys.reduce(function (acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();
        if (!valueAsString) {
          return acc;
        }
        if (key === 'content') {
          acc[key] = valueAsString;
        } else {
          try {
            acc[key] = JSON.parse(valueAsString);
          } catch (e) {
            acc[key] = valueAsString;
          }
        }
        return acc;
      }, {});
      return props;
    }
    function evaluateProps(reference, props) {
      var out = Object.assign({}, props, {
        content: invokeWithArgsOrReturn(props.content, [reference])
      }, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
      out.aria = Object.assign({}, defaultProps.aria, out.aria);
      out.aria = {
        expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
        content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
      };
      return out;
    }
    var innerHTML = function innerHTML() {
      return 'innerHTML';
    };
    function dangerouslySetInnerHTML(element, html) {
      element[innerHTML()] = html;
    }
    function createArrowElement(value) {
      var arrow = div();
      if (value === true) {
        arrow.className = ARROW_CLASS;
      } else {
        arrow.className = SVG_ARROW_CLASS;
        if (isElement(value)) {
          arrow.appendChild(value);
        } else {
          dangerouslySetInnerHTML(arrow, value);
        }
      }
      return arrow;
    }
    function setContent(content, props) {
      if (isElement(props.content)) {
        dangerouslySetInnerHTML(content, '');
        content.appendChild(props.content);
      } else if (typeof props.content !== 'function') {
        if (props.allowHTML) {
          dangerouslySetInnerHTML(content, props.content);
        } else {
          content.textContent = props.content;
        }
      }
    }
    function getChildren(popper) {
      var box = popper.firstElementChild;
      var boxChildren = arrayFrom(box.children);
      return {
        box: box,
        content: boxChildren.find(function (node) {
          return node.classList.contains(CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function (node) {
          return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function (node) {
          return node.classList.contains(BACKDROP_CLASS);
        })
      };
    }
    function render(instance) {
      var popper = div();
      var box = div();
      box.className = BOX_CLASS;
      box.setAttribute('data-state', 'hidden');
      box.setAttribute('tabindex', '-1');
      var content = div();
      content.className = CONTENT_CLASS;
      content.setAttribute('data-state', 'hidden');
      setContent(content, instance.props);
      popper.appendChild(box);
      box.appendChild(content);
      onUpdate(instance.props, instance.props);
      function onUpdate(prevProps, nextProps) {
        var _getChildren = getChildren(popper),
          box = _getChildren.box,
          content = _getChildren.content,
          arrow = _getChildren.arrow;
        if (nextProps.theme) {
          box.setAttribute('data-theme', nextProps.theme);
        } else {
          box.removeAttribute('data-theme');
        }
        if (typeof nextProps.animation === 'string') {
          box.setAttribute('data-animation', nextProps.animation);
        } else {
          box.removeAttribute('data-animation');
        }
        if (nextProps.inertia) {
          box.setAttribute('data-inertia', '');
        } else {
          box.removeAttribute('data-inertia');
        }
        box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) {
          box.setAttribute('role', nextProps.role);
        } else {
          box.removeAttribute('role');
        }
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) {
          setContent(content, instance.props);
        }
        if (nextProps.arrow) {
          if (!arrow) {
            box.appendChild(createArrowElement(nextProps.arrow));
          } else if (prevProps.arrow !== nextProps.arrow) {
            box.removeChild(arrow);
            box.appendChild(createArrowElement(nextProps.arrow));
          }
        } else if (arrow) {
          box.removeChild(arrow);
        }
      }
      return {
        popper: popper,
        onUpdate: onUpdate
      };
    } // Runtime check to identify if the render function is the default one; this
    // way we can apply default CSS transitions logic and it can be tree-shaken away

    render.$$tippy = true;
    var idCounter = 1;
    var mouseMoveListeners = []; // Used by `hideAll()`

    var mountedInstances = [];
    function createTippy(reference, passedProps) {
      var props = evaluateProps(reference, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(passedProps)))); // ===========================================================================
      // 🔒 Private members
      // ===========================================================================

      var showTimeout;
      var hideTimeout;
      var scheduleHideAnimationFrame;
      var isVisibleFromClick = false;
      var didHideDueToDocumentMouseDown = false;
      var didTouchMove = false;
      var ignoreOnFirstUpdate = false;
      var lastTriggerEvent;
      var currentTransitionEndListener;
      var onFirstUpdate;
      var listeners = [];
      var debouncedOnMouseMove = debounce(onMouseMove, props.interactiveDebounce);
      var currentTarget; // ===========================================================================
      // 🔑 Public members
      // ===========================================================================

      var id = idCounter++;
      var popperInstance = null;
      var plugins = unique(props.plugins);
      var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
      };
      var instance = {
        // properties
        id: id,
        reference: reference,
        popper: div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
      }; // TODO: Investigate why this early return causes a TDZ error in the tests —
      // it doesn't seem to happen in the browser

      /* istanbul ignore if */

      if (!props.render) {
        return instance;
      } // ===========================================================================
      // Initial mutations
      // ===========================================================================

      var _props$render = props.render(instance),
        popper = _props$render.popper,
        onUpdate = _props$render.onUpdate;
      popper.setAttribute('data-tippy-root', '');
      popper.id = "tippy-" + instance.id;
      instance.popper = popper;
      reference._tippy = instance;
      popper._tippy = instance;
      var pluginsHooks = plugins.map(function (plugin) {
        return plugin.fn(instance);
      });
      var hasAriaExpanded = reference.hasAttribute('aria-expanded');
      addListeners();
      handleAriaExpandedAttribute();
      handleStyles();
      invokeHook('onCreate', [instance]);
      if (props.showOnCreate) {
        scheduleShow();
      } // Prevent a tippy with a delay from hiding if the cursor left then returned
      // before it started hiding

      popper.addEventListener('mouseenter', function () {
        if (instance.props.interactive && instance.state.isVisible) {
          instance.clearDelayTimeouts();
        }
      });
      popper.addEventListener('mouseleave', function () {
        if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) {
          getDocument().addEventListener('mousemove', debouncedOnMouseMove);
        }
      });
      return instance; // ===========================================================================
      // 🔒 Private methods
      // ===========================================================================

      function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [touch, 0];
      }
      function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === 'hold';
      }
      function getIsDefaultRenderFn() {
        var _instance$props$rende;

        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
      }
      function getCurrentTarget() {
        return currentTarget || reference;
      }
      function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? getOwnerDocument(parent) : document;
      }
      function getDefaultTemplateChildren() {
        return getChildren(popper);
      }
      function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') {
          return 0;
        }
        return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
      }
      function handleStyles(fromHide) {
        if (fromHide === void 0) {
          fromHide = false;
        }
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
        popper.style.zIndex = "" + instance.props.zIndex;
      }
      function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) {
          shouldInvokePropsHook = true;
        }
        pluginsHooks.forEach(function (pluginHooks) {
          if (pluginHooks[hook]) {
            pluginHooks[hook].apply(pluginHooks, args);
          }
        });
        if (shouldInvokePropsHook) {
          var _instance$props;
          (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
      }
      function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) {
          return;
        }
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function (node) {
          var currentValue = node.getAttribute(attr);
          if (instance.state.isVisible) {
            node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
          } else {
            var nextValue = currentValue && currentValue.replace(id, '').trim();
            if (nextValue) {
              node.setAttribute(attr, nextValue);
            } else {
              node.removeAttribute(attr);
            }
          }
        });
      }
      function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) {
          return;
        }
        var nodes = normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function (node) {
          if (instance.props.interactive) {
            node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
          } else {
            node.removeAttribute('aria-expanded');
          }
        });
      }
      function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
        mouseMoveListeners = mouseMoveListeners.filter(function (listener) {
          return listener !== debouncedOnMouseMove;
        });
      }
      function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if (currentInput.isTouch) {
          if (didTouchMove || event.type === 'mousedown') {
            return;
          }
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper

        if (instance.props.interactive && actualContains(popper, actualTarget)) {
          return;
        } // Clicked on the event listeners target

        if (normalizeToArray(instance.props.triggerTarget || reference).some(function (el) {
          return actualContains(el, actualTarget);
        })) {
          if (currentInput.isTouch) {
            return;
          }
          if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) {
            return;
          }
        } else {
          invokeHook('onClickOutside', [instance, event]);
        }
        if (instance.props.hideOnClick === true) {
          instance.clearDelayTimeouts();
          instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
          // currentTarget. This lets a tippy with `focus` trigger know that it
          // should not show

          didHideDueToDocumentMouseDown = true;
          setTimeout(function () {
            didHideDueToDocumentMouseDown = false;
          }); // The listener gets added in `scheduleShow()`, but this may be hiding it
          // before it shows, and hide()'s early bail-out behavior can prevent it
          // from being cleaned up

          if (!instance.state.isMounted) {
            removeDocumentPress();
          }
        }
      }
      function onTouchMove() {
        didTouchMove = true;
      }
      function onTouchStart() {
        didTouchMove = false;
      }
      function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener('mousedown', onDocumentPress, true);
        doc.addEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
        doc.addEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
        doc.addEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
      }
      function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener('mousedown', onDocumentPress, true);
        doc.removeEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
        doc.removeEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
        doc.removeEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
      }
      function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function () {
          if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) {
            callback();
          }
        });
      }
      function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
      }
      function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
          if (event.target === box) {
            updateTransitionEndListener(box, 'remove', listener);
            callback();
          }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise

        if (duration === 0) {
          return callback();
        }
        updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
        updateTransitionEndListener(box, 'add', listener);
        currentTransitionEndListener = listener;
      }
      function on(eventType, handler, options) {
        if (options === void 0) {
          options = false;
        }
        var nodes = normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function (node) {
          node.addEventListener(eventType, handler, options);
          listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
          });
        });
      }
      function addListeners() {
        if (getIsCustomTouchBehavior()) {
          on('touchstart', onTrigger, {
            passive: true
          });
          on('touchend', onMouseLeave, {
            passive: true
          });
        }
        splitBySpaces(instance.props.trigger).forEach(function (eventType) {
          if (eventType === 'manual') {
            return;
          }
          on(eventType, onTrigger);
          switch (eventType) {
            case 'mouseenter':
              on('mouseleave', onMouseLeave);
              break;
            case 'focus':
              on(isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
              break;
            case 'focusin':
              on('focusout', onBlurOrFocusOut);
              break;
          }
        });
      }
      function removeListeners() {
        listeners.forEach(function (_ref) {
          var node = _ref.node,
            eventType = _ref.eventType,
            handler = _ref.handler,
            options = _ref.options;
          node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
      }
      function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) {
          return;
        }
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && isMouseEvent(event)) {
          // If scrolling, `mouseenter` events can be fired if the cursor lands
          // over a new target, but `mousemove` events don't get fired. This
          // causes interactive tooltips to get stuck open until the cursor is
          // moved
          mouseMoveListeners.forEach(function (listener) {
            return listener(event);
          });
        } // Toggle show/hide when clicking click-triggered tooltips

        if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) {
          shouldScheduleClickHide = true;
        } else {
          scheduleShow(event);
        }
        if (event.type === 'click') {
          isVisibleFromClick = !shouldScheduleClickHide;
        }
        if (shouldScheduleClickHide && !wasFocused) {
          scheduleHide(event);
        }
      }
      function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) {
          return;
        }
        var popperTreeData = getNestedPopperTree().concat(popper).map(function (popper) {
          var _instance$popperInsta;
          var instance = popper._tippy;
          var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
          if (state) {
            return {
              popperRect: popper.getBoundingClientRect(),
              popperState: state,
              props: props
            };
          }
          return null;
        }).filter(Boolean);
        if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
          cleanupInteractiveMouseListeners();
          scheduleHide(event);
        }
      }
      function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;
        if (shouldBail) {
          return;
        }
        if (instance.props.interactive) {
          instance.hideWithInteractivity(event);
          return;
        }
        scheduleHide(event);
      }
      function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) {
          return;
        } // If focus was moved to within the popper

        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) {
          return;
        }
        scheduleHide(event);
      }
      function isEventListenerStopped(event) {
        return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
      }
      function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props,
          popperOptions = _instance$props2.popperOptions,
          placement = _instance$props2.placement,
          offset = _instance$props2.offset,
          getReferenceClientRect = _instance$props2.getReferenceClientRect,
          moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
          getBoundingClientRect: getReferenceClientRect,
          contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
          name: '$$tippy',
          enabled: true,
          phase: 'beforeWrite',
          requires: ['computeStyles'],
          fn: function fn(_ref2) {
            var state = _ref2.state;
            if (getIsDefaultRenderFn()) {
              var _getDefaultTemplateCh = getDefaultTemplateChildren(),
                box = _getDefaultTemplateCh.box;
              ['placement', 'reference-hidden', 'escaped'].forEach(function (attr) {
                if (attr === 'placement') {
                  box.setAttribute('data-placement', state.placement);
                } else {
                  if (state.attributes.popper["data-popper-" + attr]) {
                    box.setAttribute("data-" + attr, '');
                  } else {
                    box.removeAttribute("data-" + attr);
                  }
                }
              });
              state.attributes.popper = {};
            }
          }
        };
        var modifiers = [{
          name: 'offset',
          options: {
            offset: offset
          }
        }, {
          name: 'preventOverflow',
          options: {
            padding: {
              top: 2,
              bottom: 2,
              left: 5,
              right: 5
            }
          }
        }, {
          name: 'flip',
          options: {
            padding: 5
          }
        }, {
          name: 'computeStyles',
          options: {
            adaptive: !moveTransition
          }
        }, tippyModifier];
        if (getIsDefaultRenderFn() && arrow) {
          modifiers.push({
            name: 'arrow',
            options: {
              element: arrow,
              padding: 3
            }
          });
        }
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = createPopper(computedReference, popper, Object.assign({}, popperOptions, {
          placement: placement,
          onFirstUpdate: onFirstUpdate,
          modifiers: modifiers
        }));
      }
      function destroyPopperInstance() {
        if (instance.popperInstance) {
          instance.popperInstance.destroy();
          instance.popperInstance = null;
        }
      }
      function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually

        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') {
          parentNode = node.parentNode;
        } else {
          parentNode = invokeWithArgsOrReturn(appendTo, [node]);
        } // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions

        if (!parentNode.contains(popper)) {
          parentNode.appendChild(popper);
        }
        instance.state.isMounted = true;
        createPopperInstance();
      }
      function getNestedPopperTree() {
        return arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
      }
      function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) {
          invokeHook('onTrigger', [instance, event]);
        }
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(),
          touchValue = _getNormalizedTouchSe[0],
          touchDelay = _getNormalizedTouchSe[1];
        if (currentInput.isTouch && touchValue === 'hold' && touchDelay) {
          delay = touchDelay;
        }
        if (delay) {
          showTimeout = setTimeout(function () {
            instance.show();
          }, delay);
        } else {
          instance.show();
        }
      }
      function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook('onUntrigger', [instance, event]);
        if (!instance.state.isVisible) {
          removeDocumentPress();
          return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.

        if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && ['mouseleave', 'mousemove'].indexOf(event.type) >= 0 && isVisibleFromClick) {
          return;
        }
        var delay = getDelay(false);
        if (delay) {
          hideTimeout = setTimeout(function () {
            if (instance.state.isVisible) {
              instance.hide();
            }
          }, delay);
        } else {
          // Fixes a `transitionend` problem when it fires 1 frame too
          // late sometimes, we don't want hide() to be called.
          scheduleHideAnimationFrame = requestAnimationFrame(function () {
            instance.hide();
          });
        }
      } // ===========================================================================
      // 🔑 Public methods
      // ===========================================================================

      function enable() {
        instance.state.isEnabled = true;
      }
      function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
      }
      function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
      }
      function setProps(partialProps) {
        if (instance.state.isDestroyed) {
          return;
        }
        invokeHook('onBeforeUpdate', [instance, partialProps]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = evaluateProps(reference, Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
          ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
          cleanupInteractiveMouseListeners();
          debouncedOnMouseMove = debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed

        if (prevProps.triggerTarget && !nextProps.triggerTarget) {
          normalizeToArray(prevProps.triggerTarget).forEach(function (node) {
            node.removeAttribute('aria-expanded');
          });
        } else if (nextProps.triggerTarget) {
          reference.removeAttribute('aria-expanded');
        }
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) {
          onUpdate(prevProps, nextProps);
        }
        if (instance.popperInstance) {
          createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
          // and the nested ones get re-rendered first.
          // https://github.com/atomiks/tippyjs-react/issues/177
          // TODO: find a cleaner / more efficient solution(!)

          getNestedPopperTree().forEach(function (nestedPopper) {
            // React (and other UI libs likely) requires a rAF wrapper as it flushes
            // its work in one
            requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
          });
        }
        invokeHook('onAfterUpdate', [instance, partialProps]);
      }
      function setContent(content) {
        instance.setProps({
          content: content
        });
      }
      function show() {

        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
        var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) {
          return;
        } // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.

        if (getCurrentTarget().hasAttribute('disabled')) {
          return;
        }
        invokeHook('onShow', [instance], false);
        if (instance.props.onShow(instance) === false) {
          return;
        }
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) {
          popper.style.visibility = 'visible';
        }
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) {
          popper.style.transition = 'none';
        } // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration

        if (getIsDefaultRenderFn()) {
          var _getDefaultTemplateCh2 = getDefaultTemplateChildren(),
            box = _getDefaultTemplateCh2.box,
            content = _getDefaultTemplateCh2.content;
          setTransitionDuration([box, content], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
          var _instance$popperInsta2;
          if (!instance.state.isVisible || ignoreOnFirstUpdate) {
            return;
          }
          ignoreOnFirstUpdate = true; // reflow

          void popper.offsetHeight;
          popper.style.transition = instance.props.moveTransition;
          if (getIsDefaultRenderFn() && instance.props.animation) {
            var _getDefaultTemplateCh3 = getDefaultTemplateChildren(),
              _box = _getDefaultTemplateCh3.box,
              _content = _getDefaultTemplateCh3.content;
            setTransitionDuration([_box, _content], duration);
            setVisibilityState([_box, _content], 'visible');
          }
          handleAriaContentAttribute();
          handleAriaExpandedAttribute();
          pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
          // popper has been positioned for the first time

          (_instance$popperInsta2 = instance.popperInstance) == null ? void 0 : _instance$popperInsta2.forceUpdate();
          invokeHook('onMount', [instance]);
          if (instance.props.animation && getIsDefaultRenderFn()) {
            onTransitionedIn(duration, function () {
              instance.state.isShown = true;
              invokeHook('onShown', [instance]);
            });
          }
        };
        mount();
      }
      function hide() {

        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) {
          return;
        }
        invokeHook('onHide', [instance], false);
        if (instance.props.onHide(instance) === false) {
          return;
        }
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) {
          popper.style.visibility = 'hidden';
        }
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
          var _getDefaultTemplateCh4 = getDefaultTemplateChildren(),
            box = _getDefaultTemplateCh4.box,
            content = _getDefaultTemplateCh4.content;
          if (instance.props.animation) {
            setTransitionDuration([box, content], duration);
            setVisibilityState([box, content], 'hidden');
          }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
          if (getIsDefaultRenderFn()) {
            onTransitionedOut(duration, instance.unmount);
          }
        } else {
          instance.unmount();
        }
      }
      function hideWithInteractivity(event) {
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
        pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
      }
      function unmount() {
        if (instance.state.isVisible) {
          instance.hide();
        }
        if (!instance.state.isMounted) {
          return;
        }
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible

        getNestedPopperTree().forEach(function (nestedPopper) {
          nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) {
          popper.parentNode.removeChild(popper);
        }
        mountedInstances = mountedInstances.filter(function (i) {
          return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook('onHidden', [instance]);
      }
      function destroy() {
        if (instance.state.isDestroyed) {
          return;
        }
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook('onDestroy', [instance]);
      }
    }
    function tippy(targets, optionalProps) {
      if (optionalProps === void 0) {
        optionalProps = {};
      }
      var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
      bindGlobalEventListeners();
      var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
      });
      var elements = getArrayOfElements(targets);
      var instances = elements.reduce(function (acc, reference) {
        var instance = reference && createTippy(reference, passedProps);
        if (instance) {
          acc.push(instance);
        }
        return acc;
      }, []);
      return isElement(targets) ? instances[0] : instances;
    }
    tippy.defaultProps = defaultProps;
    tippy.setDefaultProps = setDefaultProps;
    tippy.currentInput = currentInput;

    // every time the popper is destroyed (i.e. a new target), removing the styles
    // and causing transitions to break for singletons when the console is open, but
    // most notably for non-transform styles being used, `gpuAcceleration: false`.

    Object.assign({}, applyStyles$1, {
      effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
          popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
          },
          arrow: {
            position: 'absolute'
          },
          reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) {
          Object.assign(state.elements.arrow.style, initialStyles.arrow);
        } // intentionally return no cleanup function
        // return () => { ... }
      }
    });
    tippy.setDefaultProps({
      render: render
    });

    var dayjs_min = {exports: {}};

    (function (module, exports) {
      !function (t, e) {
        module.exports = e() ;
      }(commonjsGlobal, function () {

        var t = 1e3,
          e = 6e4,
          n = 36e5,
          r = "millisecond",
          i = "second",
          s = "minute",
          u = "hour",
          a = "day",
          o = "week",
          c = "month",
          f = "quarter",
          h = "year",
          d = "date",
          l = "Invalid Date",
          $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
          y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
          M = {
            name: "en",
            weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
            months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
            ordinal: function (t) {
              var e = ["th", "st", "nd", "rd"],
                n = t % 100;
              return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
            }
          },
          m = function (t, e, n) {
            var r = String(t);
            return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
          },
          v = {
            s: m,
            z: function (t) {
              var e = -t.utcOffset(),
                n = Math.abs(e),
                r = Math.floor(n / 60),
                i = n % 60;
              return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
            },
            m: function t(e, n) {
              if (e.date() < n.date()) return -t(n, e);
              var r = 12 * (n.year() - e.year()) + (n.month() - e.month()),
                i = e.clone().add(r, c),
                s = n - i < 0,
                u = e.clone().add(r + (s ? -1 : 1), c);
              return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
            },
            a: function (t) {
              return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
            },
            p: function (t) {
              return {
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
              }[t] || String(t || "").toLowerCase().replace(/s$/, "");
            },
            u: function (t) {
              return void 0 === t;
            }
          },
          g = "en",
          D = {};
        D[g] = M;
        var p = "$isDayjsObject",
          S = function (t) {
            return t instanceof _ || !(!t || !t[p]);
          },
          w = function t(e, n, r) {
            var i;
            if (!e) return g;
            if ("string" == typeof e) {
              var s = e.toLowerCase();
              D[s] && (i = s), n && (D[s] = n, i = s);
              var u = e.split("-");
              if (!i && u.length > 1) return t(u[0]);
            } else {
              var a = e.name;
              D[a] = e, i = a;
            }
            return !r && i && (g = i), i || !r && g;
          },
          O = function (t, e) {
            if (S(t)) return t.clone();
            var n = "object" == typeof e ? e : {};
            return n.date = t, n.args = arguments, new _(n);
          },
          b = v;
        b.l = w, b.i = S, b.w = function (t, e) {
          return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
          });
        };
        var _ = function () {
            function M(t) {
              this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
            }
            var m = M.prototype;
            return m.parse = function (t) {
              this.$d = function (t) {
                var e = t.date,
                  n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date();
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                  var r = e.match($);
                  if (r) {
                    var i = r[2] - 1 || 0,
                      s = (r[7] || "0").substring(0, 3);
                    return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                  }
                }
                return new Date(e);
              }(t), this.init();
            }, m.init = function () {
              var t = this.$d;
              this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
            }, m.$utils = function () {
              return b;
            }, m.isValid = function () {
              return !(this.$d.toString() === l);
            }, m.isSame = function (t, e) {
              var n = O(t);
              return this.startOf(e) <= n && n <= this.endOf(e);
            }, m.isAfter = function (t, e) {
              return O(t) < this.startOf(e);
            }, m.isBefore = function (t, e) {
              return this.endOf(e) < O(t);
            }, m.$g = function (t, e, n) {
              return b.u(t) ? this[e] : this.set(n, t);
            }, m.unix = function () {
              return Math.floor(this.valueOf() / 1e3);
            }, m.valueOf = function () {
              return this.$d.getTime();
            }, m.startOf = function (t, e) {
              var n = this,
                r = !!b.u(e) || e,
                f = b.p(t),
                l = function (t, e) {
                  var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                  return r ? i : i.endOf(a);
                },
                $ = function (t, e) {
                  return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e)), n);
                },
                y = this.$W,
                M = this.$M,
                m = this.$D,
                v = "set" + (this.$u ? "UTC" : "");
              switch (f) {
                case h:
                  return r ? l(1, 0) : l(31, 11);
                case c:
                  return r ? l(1, M) : l(0, M + 1);
                case o:
                  var g = this.$locale().weekStart || 0,
                    D = (y < g ? y + 7 : y) - g;
                  return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                  return $(v + "Hours", 0);
                case u:
                  return $(v + "Minutes", 1);
                case s:
                  return $(v + "Seconds", 2);
                case i:
                  return $(v + "Milliseconds", 3);
                default:
                  return this.clone();
              }
            }, m.endOf = function (t) {
              return this.startOf(t, !1);
            }, m.$set = function (t, e) {
              var n,
                o = b.p(t),
                f = "set" + (this.$u ? "UTC" : ""),
                l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o],
                $ = o === a ? this.$D + (e - this.$W) : e;
              if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
              } else l && this.$d[l]($);
              return this.init(), this;
            }, m.set = function (t, e) {
              return this.clone().$set(t, e);
            }, m.get = function (t) {
              return this[b.p(t)]();
            }, m.add = function (r, f) {
              var d,
                l = this;
              r = Number(r);
              var $ = b.p(f),
                y = function (t) {
                  var e = O(l);
                  return b.w(e.date(e.date() + Math.round(t * r)), l);
                };
              if ($ === c) return this.set(c, this.$M + r);
              if ($ === h) return this.set(h, this.$y + r);
              if ($ === a) return y(1);
              if ($ === o) return y(7);
              var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1,
                m = this.$d.getTime() + r * M;
              return b.w(m, this);
            }, m.subtract = function (t, e) {
              return this.add(-1 * t, e);
            }, m.format = function (t) {
              var e = this,
                n = this.$locale();
              if (!this.isValid()) return n.invalidDate || l;
              var r = t || "YYYY-MM-DDTHH:mm:ssZ",
                i = b.z(this),
                s = this.$H,
                u = this.$m,
                a = this.$M,
                o = n.weekdays,
                c = n.months,
                f = n.meridiem,
                h = function (t, n, i, s) {
                  return t && (t[n] || t(e, r)) || i[n].slice(0, s);
                },
                d = function (t) {
                  return b.s(s % 12 || 12, t, "0");
                },
                $ = f || function (t, e, n) {
                  var r = t < 12 ? "AM" : "PM";
                  return n ? r.toLowerCase() : r;
                };
              return r.replace(y, function (t, r) {
                return r || function (t) {
                  switch (t) {
                    case "YY":
                      return String(e.$y).slice(-2);
                    case "YYYY":
                      return b.s(e.$y, 4, "0");
                    case "M":
                      return a + 1;
                    case "MM":
                      return b.s(a + 1, 2, "0");
                    case "MMM":
                      return h(n.monthsShort, a, c, 3);
                    case "MMMM":
                      return h(c, a);
                    case "D":
                      return e.$D;
                    case "DD":
                      return b.s(e.$D, 2, "0");
                    case "d":
                      return String(e.$W);
                    case "dd":
                      return h(n.weekdaysMin, e.$W, o, 2);
                    case "ddd":
                      return h(n.weekdaysShort, e.$W, o, 3);
                    case "dddd":
                      return o[e.$W];
                    case "H":
                      return String(s);
                    case "HH":
                      return b.s(s, 2, "0");
                    case "h":
                      return d(1);
                    case "hh":
                      return d(2);
                    case "a":
                      return $(s, u, !0);
                    case "A":
                      return $(s, u, !1);
                    case "m":
                      return String(u);
                    case "mm":
                      return b.s(u, 2, "0");
                    case "s":
                      return String(e.$s);
                    case "ss":
                      return b.s(e.$s, 2, "0");
                    case "SSS":
                      return b.s(e.$ms, 3, "0");
                    case "Z":
                      return i;
                  }
                  return null;
                }(t) || i.replace(":", "");
              });
            }, m.utcOffset = function () {
              return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
            }, m.diff = function (r, d, l) {
              var $,
                y = this,
                M = b.p(d),
                m = O(r),
                v = (m.utcOffset() - this.utcOffset()) * e,
                g = this - m,
                D = function () {
                  return b.m(y, m);
                };
              switch (M) {
                case h:
                  $ = D() / 12;
                  break;
                case c:
                  $ = D();
                  break;
                case f:
                  $ = D() / 3;
                  break;
                case o:
                  $ = (g - v) / 6048e5;
                  break;
                case a:
                  $ = (g - v) / 864e5;
                  break;
                case u:
                  $ = g / n;
                  break;
                case s:
                  $ = g / e;
                  break;
                case i:
                  $ = g / t;
                  break;
                default:
                  $ = g;
              }
              return l ? $ : b.a($);
            }, m.daysInMonth = function () {
              return this.endOf(c).$D;
            }, m.$locale = function () {
              return D[this.$L];
            }, m.locale = function (t, e) {
              if (!t) return this.$L;
              var n = this.clone(),
                r = w(t, e, !0);
              return r && (n.$L = r), n;
            }, m.clone = function () {
              return b.w(this.$d, this);
            }, m.toDate = function () {
              return new Date(this.valueOf());
            }, m.toJSON = function () {
              return this.isValid() ? this.toISOString() : null;
            }, m.toISOString = function () {
              return this.$d.toISOString();
            }, m.toString = function () {
              return this.$d.toUTCString();
            }, M;
          }(),
          k = _.prototype;
        return O.prototype = k, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", c], ["$y", h], ["$D", d]].forEach(function (t) {
          k[t[1]] = function (e) {
            return this.$g(e, t[0], t[1]);
          };
        }), O.extend = function (t, e) {
          return t.$i || (t(e, _, O), t.$i = !0), O;
        }, O.locale = w, O.isDayjs = S, O.unix = function (t) {
          return O(1e3 * t);
        }, O.en = D[g], O.Ls = D, O.p = {}, O;
      });
    })(dayjs_min);
    var dayjs = dayjs_min.exports;

    var customParseFormat$1 = {exports: {}};

    (function (module, exports) {
      !function (e, t) {
        module.exports = t() ;
      }(commonjsGlobal, function () {

        var e = {
            LTS: "h:mm:ss A",
            LT: "h:mm A",
            L: "MM/DD/YYYY",
            LL: "MMMM D, YYYY",
            LLL: "MMMM D, YYYY h:mm A",
            LLLL: "dddd, MMMM D, YYYY h:mm A"
          },
          t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,
          n = /\d/,
          r = /\d\d/,
          i = /\d\d?/,
          o = /\d*[^-_:/,()\s\d]+/,
          s = {},
          a = function (e) {
            return (e = +e) + (e > 68 ? 1900 : 2e3);
          };
        var f = function (e) {
            return function (t) {
              this[e] = +t;
            };
          },
          h = [/[+-]\d\d:?(\d\d)?|Z/, function (e) {
            (this.zone || (this.zone = {})).offset = function (e) {
              if (!e) return 0;
              if ("Z" === e) return 0;
              var t = e.match(/([+-]|\d\d)/g),
                n = 60 * t[1] + (+t[2] || 0);
              return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
          }],
          u = function (e) {
            var t = s[e];
            return t && (t.indexOf ? t : t.s.concat(t.f));
          },
          d = function (e, t) {
            var n,
              r = s.meridiem;
            if (r) {
              for (var i = 1; i <= 24; i += 1) if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
              }
            } else n = e === (t ? "pm" : "PM");
            return n;
          },
          c = {
            A: [o, function (e) {
              this.afternoon = d(e, !1);
            }],
            a: [o, function (e) {
              this.afternoon = d(e, !0);
            }],
            Q: [n, function (e) {
              this.month = 3 * (e - 1) + 1;
            }],
            S: [n, function (e) {
              this.milliseconds = 100 * +e;
            }],
            SS: [r, function (e) {
              this.milliseconds = 10 * +e;
            }],
            SSS: [/\d{3}/, function (e) {
              this.milliseconds = +e;
            }],
            s: [i, f("seconds")],
            ss: [i, f("seconds")],
            m: [i, f("minutes")],
            mm: [i, f("minutes")],
            H: [i, f("hours")],
            h: [i, f("hours")],
            HH: [i, f("hours")],
            hh: [i, f("hours")],
            D: [i, f("day")],
            DD: [r, f("day")],
            Do: [o, function (e) {
              var t = s.ordinal,
                n = e.match(/\d+/);
              if (this.day = n[0], t) for (var r = 1; r <= 31; r += 1) t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }],
            w: [i, f("week")],
            ww: [r, f("week")],
            M: [i, f("month")],
            MM: [r, f("month")],
            MMM: [o, function (e) {
              var t = u("months"),
                n = (u("monthsShort") || t.map(function (e) {
                  return e.slice(0, 3);
                })).indexOf(e) + 1;
              if (n < 1) throw new Error();
              this.month = n % 12 || n;
            }],
            MMMM: [o, function (e) {
              var t = u("months").indexOf(e) + 1;
              if (t < 1) throw new Error();
              this.month = t % 12 || t;
            }],
            Y: [/[+-]?\d+/, f("year")],
            YY: [r, function (e) {
              this.year = a(e);
            }],
            YYYY: [/\d{4}/, f("year")],
            Z: h,
            ZZ: h
          };
        function l(n) {
          var r, i;
          r = n, i = s && s.formats;
          for (var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function (t, n, r) {
              var o = r && r.toUpperCase();
              return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function (e, t, n) {
                return t || n.slice(1);
              });
            })).match(t), a = o.length, f = 0; f < a; f += 1) {
            var h = o[f],
              u = c[h],
              d = u && u[0],
              l = u && u[1];
            o[f] = l ? {
              regex: d,
              parser: l
            } : h.replace(/^\[|\]$/g, "");
          }
          return function (e) {
            for (var t = {}, n = 0, r = 0; n < a; n += 1) {
              var i = o[n];
              if ("string" == typeof i) r += i.length;else {
                var s = i.regex,
                  f = i.parser,
                  h = e.slice(r),
                  u = s.exec(h)[0];
                f.call(t, u), e = e.replace(u, "");
              }
            }
            return function (e) {
              var t = e.afternoon;
              if (void 0 !== t) {
                var n = e.hours;
                t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
              }
            }(t), t;
          };
        }
        return function (e, t, n) {
          n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
          var r = t.prototype,
            i = r.parse;
          r.parse = function (e) {
            var t = e.date,
              r = e.utc,
              o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
              var f = !0 === o[2],
                h = !0 === o[3],
                u = f || h,
                d = o[2];
              h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function (e, t, n, r) {
                try {
                  if (["x", "X"].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                  var i = l(t)(e),
                    o = i.year,
                    s = i.month,
                    a = i.day,
                    f = i.hours,
                    h = i.minutes,
                    u = i.seconds,
                    d = i.milliseconds,
                    c = i.zone,
                    m = i.week,
                    M = new Date(),
                    Y = a || (o || s ? 1 : M.getDate()),
                    p = o || M.getFullYear(),
                    v = 0;
                  o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                  var D,
                    w = f || 0,
                    g = h || 0,
                    y = u || 0,
                    L = d || 0;
                  return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                } catch (e) {
                  return new Date("");
                }
              }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for (var c = a.length, m = 1; m <= c; m += 1) {
              o[1] = a[m - 1];
              var M = n.apply(this, o);
              if (M.isValid()) {
                this.$d = M.$d, this.$L = M.$L, this.init();
                break;
              }
              m === c && (this.$d = new Date(""));
            } else i.call(this, e);
          };
        };
      });
    })(customParseFormat$1);
    var customParseFormat = customParseFormat$1.exports;

    var vanillaMasker = {exports: {}};

    (function (module, exports) {
      (function (root, factory) {
        {
          module.exports = factory();
        }
      })(commonjsGlobal, function () {
        var DIGIT = "9",
          ALPHA = "A",
          ALPHANUM = "S",
          BY_PASS_KEYS = [9, 16, 17, 18, 36, 37, 38, 39, 40, 91, 92, 93],
          isAllowedKeyCode = function (keyCode) {
            for (var i = 0, len = BY_PASS_KEYS.length; i < len; i++) {
              if (keyCode == BY_PASS_KEYS[i]) {
                return false;
              }
            }
            return true;
          },
          mergeMoneyOptions = function (opts) {
            opts = opts || {};
            opts = {
              delimiter: opts.delimiter || ".",
              lastOutput: opts.lastOutput,
              precision: opts.hasOwnProperty("precision") ? opts.precision : 2,
              separator: opts.separator || ",",
              showSignal: opts.showSignal,
              suffixUnit: opts.suffixUnit && " " + opts.suffixUnit.replace(/[\s]/g, '') || "",
              unit: opts.unit && opts.unit.replace(/[\s]/g, '') + " " || "",
              zeroCents: opts.zeroCents
            };
            opts.moneyPrecision = opts.zeroCents ? 0 : opts.precision;
            return opts;
          },
          // Fill wildcards past index in output with placeholder
          addPlaceholdersToOutput = function (output, index, placeholder) {
            for (; index < output.length; index++) {
              if (output[index] === DIGIT || output[index] === ALPHA || output[index] === ALPHANUM) {
                output[index] = placeholder;
              }
            }
            return output;
          };
        var VanillaMasker = function (elements) {
          this.elements = elements;
        };
        VanillaMasker.prototype.unbindElementToMask = function () {
          for (var i = 0, len = this.elements.length; i < len; i++) {
            this.elements[i].lastOutput = "";
            this.elements[i].onkeyup = false;
            this.elements[i].onkeydown = false;
            if (this.elements[i].value.length) {
              this.elements[i].value = this.elements[i].value.replace(/\D/g, '');
            }
          }
        };
        VanillaMasker.prototype.bindElementToMask = function (maskFunction) {
          var that = this,
            onType = function (e) {
              e = e || window.event;
              var source = e.target || e.srcElement;
              if (isAllowedKeyCode(e.keyCode)) {
                setTimeout(function () {
                  that.opts.lastOutput = source.lastOutput;
                  source.value = VMasker[maskFunction](source.value, that.opts);
                  source.lastOutput = source.value;
                  if (source.setSelectionRange && that.opts.suffixUnit) {
                    source.setSelectionRange(source.value.length, source.value.length - that.opts.suffixUnit.length);
                  }
                }, 0);
              }
            };
          for (var i = 0, len = this.elements.length; i < len; i++) {
            this.elements[i].lastOutput = "";
            this.elements[i].onkeyup = onType;
            if (this.elements[i].value.length) {
              this.elements[i].value = VMasker[maskFunction](this.elements[i].value, this.opts);
            }
          }
        };
        VanillaMasker.prototype.maskMoney = function (opts) {
          this.opts = mergeMoneyOptions(opts);
          this.bindElementToMask("toMoney");
        };
        VanillaMasker.prototype.maskNumber = function () {
          this.opts = {};
          this.bindElementToMask("toNumber");
        };
        VanillaMasker.prototype.maskAlphaNum = function () {
          this.opts = {};
          this.bindElementToMask("toAlphaNumeric");
        };
        VanillaMasker.prototype.maskPattern = function (pattern) {
          this.opts = {
            pattern: pattern
          };
          this.bindElementToMask("toPattern");
        };
        VanillaMasker.prototype.unMask = function () {
          this.unbindElementToMask();
        };
        var VMasker = function (el) {
          if (!el) {
            throw new Error("VanillaMasker: There is no element to bind.");
          }
          var elements = "length" in el ? el.length ? el : [] : [el];
          return new VanillaMasker(elements);
        };
        VMasker.toMoney = function (value, opts) {
          opts = mergeMoneyOptions(opts);
          if (opts.zeroCents) {
            opts.lastOutput = opts.lastOutput || "";
            var zeroMatcher = "(" + opts.separator + "[0]{0," + opts.precision + "})",
              zeroRegExp = new RegExp(zeroMatcher, "g"),
              digitsLength = value.toString().replace(/[\D]/g, "").length || 0,
              lastDigitLength = opts.lastOutput.toString().replace(/[\D]/g, "").length || 0;
            value = value.toString().replace(zeroRegExp, "");
            if (digitsLength < lastDigitLength) {
              value = value.slice(0, value.length - 1);
            }
          }
          var number = value.toString().replace(/[\D]/g, ""),
            clearDelimiter = new RegExp("^(0|\\" + opts.delimiter + ")"),
            clearSeparator = new RegExp("(\\" + opts.separator + ")$"),
            money = number.substr(0, number.length - opts.moneyPrecision),
            masked = money.substr(0, money.length % 3),
            cents = new Array(opts.precision + 1).join("0");
          money = money.substr(money.length % 3, money.length);
          for (var i = 0, len = money.length; i < len; i++) {
            if (i % 3 === 0) {
              masked += opts.delimiter;
            }
            masked += money[i];
          }
          masked = masked.replace(clearDelimiter, "");
          masked = masked.length ? masked : "0";
          var signal = "";
          if (opts.showSignal === true) {
            signal = value < 0 || value.startsWith && value.startsWith('-') ? "-" : "";
          }
          if (!opts.zeroCents) {
            var beginCents = number.length - opts.precision,
              centsValue = number.substr(beginCents, opts.precision),
              centsLength = centsValue.length,
              centsSliced = opts.precision > centsLength ? opts.precision : centsLength;
            cents = (cents + centsValue).slice(-centsSliced);
          }
          var output = opts.unit + signal + masked + opts.separator + cents;
          return output.replace(clearSeparator, "") + opts.suffixUnit;
        };
        VMasker.toPattern = function (value, opts) {
          var pattern = typeof opts === 'object' ? opts.pattern : opts,
            patternChars = pattern.replace(/\W/g, ''),
            output = pattern.split(""),
            values = value.toString().replace(/\W/g, ""),
            charsValues = values.replace(/\W/g, ''),
            index = 0,
            i,
            outputLength = output.length,
            placeholder = typeof opts === 'object' ? opts.placeholder : undefined;
          for (i = 0; i < outputLength; i++) {
            // Reached the end of input
            if (index >= values.length) {
              if (patternChars.length == charsValues.length) {
                return output.join("");
              } else if (placeholder !== undefined && patternChars.length > charsValues.length) {
                return addPlaceholdersToOutput(output, i, placeholder).join("");
              } else {
                break;
              }
            }
            // Remaining chars in input
            else {
              if (output[i] === DIGIT && values[index].match(/[0-9]/) || output[i] === ALPHA && values[index].match(/[a-zA-Z]/) || output[i] === ALPHANUM && values[index].match(/[0-9a-zA-Z]/)) {
                output[i] = values[index++];
              } else if (output[i] === DIGIT || output[i] === ALPHA || output[i] === ALPHANUM) {
                if (placeholder !== undefined) {
                  return addPlaceholdersToOutput(output, i, placeholder).join("");
                } else {
                  return output.slice(0, i).join("");
                }
              }
            }
          }
          return output.join("").substr(0, i);
        };
        VMasker.toNumber = function (value) {
          return value.toString().replace(/(?!^-)[^0-9]/g, "");
        };
        VMasker.toAlphaNumeric = function (value) {
          return value.toString().replace(/[^a-z0-9 ]+/i, "");
        };
        return VMasker;
      });
    })(vanillaMasker);
    var VMasker = vanillaMasker.exports;

    var cardTypes$1 = {
      visa: {
        niceType: "Visa",
        type: "visa",
        patterns: [4],
        gaps: [4, 8, 12],
        lengths: [16, 18, 19],
        code: {
          name: "CVV",
          size: 3
        }
      },
      mastercard: {
        niceType: "Mastercard",
        type: "mastercard",
        patterns: [[51, 55], [2221, 2229], [223, 229], [23, 26], [270, 271], 2720],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
          name: "CVC",
          size: 3
        }
      },
      "american-express": {
        niceType: "American Express",
        type: "american-express",
        patterns: [34, 37],
        gaps: [4, 10],
        lengths: [15],
        code: {
          name: "CID",
          size: 4
        }
      },
      "diners-club": {
        niceType: "Diners Club",
        type: "diners-club",
        patterns: [[300, 305], 36, 38, 39],
        gaps: [4, 10],
        lengths: [14, 16, 19],
        code: {
          name: "CVV",
          size: 3
        }
      },
      discover: {
        niceType: "Discover",
        type: "discover",
        patterns: [6011, [644, 649], 65],
        gaps: [4, 8, 12],
        lengths: [16, 19],
        code: {
          name: "CID",
          size: 3
        }
      },
      jcb: {
        niceType: "JCB",
        type: "jcb",
        patterns: [2131, 1800, [3528, 3589]],
        gaps: [4, 8, 12],
        lengths: [16, 17, 18, 19],
        code: {
          name: "CVV",
          size: 3
        }
      },
      unionpay: {
        niceType: "UnionPay",
        type: "unionpay",
        patterns: [620, [624, 626], [62100, 62182], [62184, 62187], [62185, 62197], [62200, 62205], [622010, 622999], 622018, [622019, 622999], [62207, 62209], [622126, 622925], [623, 626], 6270, 6272, 6276, [627700, 627779], [627781, 627799], [6282, 6289], 6291, 6292, 810, [8110, 8131], [8132, 8151], [8152, 8163], [8164, 8171]],
        gaps: [4, 8, 12],
        lengths: [14, 15, 16, 17, 18, 19],
        code: {
          name: "CVN",
          size: 3
        }
      },
      maestro: {
        niceType: "Maestro",
        type: "maestro",
        patterns: [493698, [500000, 504174], [504176, 506698], [506779, 508999], [56, 59], 63, 67, 6],
        gaps: [4, 8, 12],
        lengths: [12, 13, 14, 15, 16, 17, 18, 19],
        code: {
          name: "CVC",
          size: 3
        }
      },
      elo: {
        niceType: "Elo",
        type: "elo",
        patterns: [401178, 401179, 438935, 457631, 457632, 431274, 451416, 457393, 504175, [506699, 506778], [509000, 509999], 627780, 636297, 636368, [650031, 650033], [650035, 650051], [650405, 650439], [650485, 650538], [650541, 650598], [650700, 650718], [650720, 650727], [650901, 650978], [651652, 651679], [655000, 655019], [655021, 655058]],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
          name: "CVE",
          size: 3
        }
      },
      mir: {
        niceType: "Mir",
        type: "mir",
        patterns: [[2200, 2204]],
        gaps: [4, 8, 12],
        lengths: [16, 17, 18, 19],
        code: {
          name: "CVP2",
          size: 3
        }
      },
      hiper: {
        niceType: "Hiper",
        type: "hiper",
        patterns: [637095, 63737423, 63743358, 637568, 637599, 637609, 637612],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
          name: "CVC",
          size: 3
        }
      },
      hipercard: {
        niceType: "Hipercard",
        type: "hipercard",
        patterns: [606282],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
          name: "CVC",
          size: 3
        }
      }
    };
    var cardTypes_1 = cardTypes$1;

    var addMatchingCardsToResults$1 = {};

    var clone$1 = {};

    Object.defineProperty(clone$1, "__esModule", {
      value: true
    });
    clone$1.clone = void 0;
    function clone(originalObject) {
      if (!originalObject) {
        return null;
      }
      return JSON.parse(JSON.stringify(originalObject));
    }
    clone$1.clone = clone;

    var matches$1 = {};

    /*
     * Adapted from https://github.com/polvo-labs/card-type/blob/aaab11f80fa1939bccc8f24905a06ae3cd864356/src/cardType.js#L37-L42
     * */
    Object.defineProperty(matches$1, "__esModule", {
      value: true
    });
    matches$1.matches = void 0;
    function matchesRange(cardNumber, min, max) {
      var maxLengthToCheck = String(min).length;
      var substr = cardNumber.substr(0, maxLengthToCheck);
      var integerRepresentationOfCardNumber = parseInt(substr, 10);
      min = parseInt(String(min).substr(0, substr.length), 10);
      max = parseInt(String(max).substr(0, substr.length), 10);
      return integerRepresentationOfCardNumber >= min && integerRepresentationOfCardNumber <= max;
    }
    function matchesPattern(cardNumber, pattern) {
      pattern = String(pattern);
      return pattern.substring(0, cardNumber.length) === cardNumber.substring(0, pattern.length);
    }
    function matches(cardNumber, pattern) {
      if (Array.isArray(pattern)) {
        return matchesRange(cardNumber, pattern[0], pattern[1]);
      }
      return matchesPattern(cardNumber, pattern);
    }
    matches$1.matches = matches;

    Object.defineProperty(addMatchingCardsToResults$1, "__esModule", {
      value: true
    });
    addMatchingCardsToResults$1.addMatchingCardsToResults = void 0;
    var clone_1$1 = clone$1;
    var matches_1 = matches$1;
    function addMatchingCardsToResults(cardNumber, cardConfiguration, results) {
      var i, patternLength;
      for (i = 0; i < cardConfiguration.patterns.length; i++) {
        var pattern = cardConfiguration.patterns[i];
        if (!matches_1.matches(cardNumber, pattern)) {
          continue;
        }
        var clonedCardConfiguration = clone_1$1.clone(cardConfiguration);
        if (Array.isArray(pattern)) {
          patternLength = String(pattern[0]).length;
        } else {
          patternLength = String(pattern).length;
        }
        if (cardNumber.length >= patternLength) {
          clonedCardConfiguration.matchStrength = patternLength;
        }
        results.push(clonedCardConfiguration);
        break;
      }
    }
    addMatchingCardsToResults$1.addMatchingCardsToResults = addMatchingCardsToResults;

    var isValidInputType$1 = {};

    Object.defineProperty(isValidInputType$1, "__esModule", {
      value: true
    });
    isValidInputType$1.isValidInputType = void 0;
    function isValidInputType(cardNumber) {
      return typeof cardNumber === "string" || cardNumber instanceof String;
    }
    isValidInputType$1.isValidInputType = isValidInputType;

    var findBestMatch$1 = {};

    Object.defineProperty(findBestMatch$1, "__esModule", {
      value: true
    });
    findBestMatch$1.findBestMatch = void 0;
    function hasEnoughResultsToDetermineBestMatch(results) {
      var numberOfResultsWithMaxStrengthProperty = results.filter(function (result) {
        return result.matchStrength;
      }).length;
      /*
       * if all possible results have a maxStrength property that means the card
       * number is sufficiently long enough to determine conclusively what the card
       * type is
       * */
      return numberOfResultsWithMaxStrengthProperty > 0 && numberOfResultsWithMaxStrengthProperty === results.length;
    }
    function findBestMatch(results) {
      if (!hasEnoughResultsToDetermineBestMatch(results)) {
        return null;
      }
      return results.reduce(function (bestMatch, result) {
        if (!bestMatch) {
          return result;
        }
        /*
         * If the current best match pattern is less specific than this result, set
         * the result as the new best match
         * */
        if (Number(bestMatch.matchStrength) < Number(result.matchStrength)) {
          return result;
        }
        return bestMatch;
      });
    }
    findBestMatch$1.findBestMatch = findBestMatch;

    var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
      __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };
    var cardTypes = cardTypes_1;
    var add_matching_cards_to_results_1 = addMatchingCardsToResults$1;
    var is_valid_input_type_1 = isValidInputType$1;
    var find_best_match_1 = findBestMatch$1;
    var clone_1 = clone$1;
    var customCards = {};
    var cardNames = {
      VISA: "visa",
      MASTERCARD: "mastercard",
      AMERICAN_EXPRESS: "american-express",
      DINERS_CLUB: "diners-club",
      DISCOVER: "discover",
      JCB: "jcb",
      UNIONPAY: "unionpay",
      MAESTRO: "maestro",
      ELO: "elo",
      MIR: "mir",
      HIPER: "hiper",
      HIPERCARD: "hipercard"
    };
    var ORIGINAL_TEST_ORDER = [cardNames.VISA, cardNames.MASTERCARD, cardNames.AMERICAN_EXPRESS, cardNames.DINERS_CLUB, cardNames.DISCOVER, cardNames.JCB, cardNames.UNIONPAY, cardNames.MAESTRO, cardNames.ELO, cardNames.MIR, cardNames.HIPER, cardNames.HIPERCARD];
    var testOrder = clone_1.clone(ORIGINAL_TEST_ORDER);
    function findType(cardType) {
      return customCards[cardType] || cardTypes[cardType];
    }
    function getAllCardTypes() {
      return testOrder.map(function (cardType) {
        return clone_1.clone(findType(cardType));
      });
    }
    function getCardPosition(name, ignoreErrorForNotExisting) {
      if (ignoreErrorForNotExisting === void 0) {
        ignoreErrorForNotExisting = false;
      }
      var position = testOrder.indexOf(name);
      if (!ignoreErrorForNotExisting && position === -1) {
        throw new Error('"' + name + '" is not a supported card type.');
      }
      return position;
    }
    function creditCardType(cardNumber) {
      var results = [];
      if (!is_valid_input_type_1.isValidInputType(cardNumber)) {
        return results;
      }
      if (cardNumber.length === 0) {
        return getAllCardTypes();
      }
      testOrder.forEach(function (cardType) {
        var cardConfiguration = findType(cardType);
        add_matching_cards_to_results_1.addMatchingCardsToResults(cardNumber, cardConfiguration, results);
      });
      var bestMatch = find_best_match_1.findBestMatch(results);
      if (bestMatch) {
        return [bestMatch];
      }
      return results;
    }
    creditCardType.getTypeInfo = function (cardType) {
      return clone_1.clone(findType(cardType));
    };
    creditCardType.removeCard = function (name) {
      var position = getCardPosition(name);
      testOrder.splice(position, 1);
    };
    creditCardType.addCard = function (config) {
      var existingCardPosition = getCardPosition(config.type, true);
      customCards[config.type] = config;
      if (existingCardPosition === -1) {
        testOrder.push(config.type);
      }
    };
    creditCardType.updateCard = function (cardType, updates) {
      var originalObject = customCards[cardType] || cardTypes[cardType];
      if (!originalObject) {
        throw new Error("\"" + cardType + "\" is not a recognized type. Use `addCard` instead.'");
      }
      if (updates.type && originalObject.type !== updates.type) {
        throw new Error("Cannot overwrite type parameter.");
      }
      var clonedCard = clone_1.clone(originalObject);
      clonedCard = __assign(__assign({}, clonedCard), updates);
      customCards[clonedCard.type] = clonedCard;
    };
    creditCardType.changeOrder = function (name, position) {
      var currentPosition = getCardPosition(name);
      testOrder.splice(currentPosition, 1);
      testOrder.splice(position, 0, name);
    };
    creditCardType.resetModifications = function () {
      testOrder = clone_1.clone(ORIGINAL_TEST_ORDER);
      customCards = {};
    };
    creditCardType.types = cardNames;
    var dist = creditCardType;

    var duration = {exports: {}};

    (function (module, exports) {
      !function (t, s) {
        module.exports = s() ;
      }(commonjsGlobal, function () {

        var t,
          s,
          n = 1e3,
          i = 6e4,
          e = 36e5,
          r = 864e5,
          o = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
          u = 31536e6,
          d = 2628e6,
          a = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/,
          h = {
            years: u,
            months: d,
            days: r,
            hours: e,
            minutes: i,
            seconds: n,
            milliseconds: 1,
            weeks: 6048e5
          },
          c = function (t) {
            return t instanceof g;
          },
          f = function (t, s, n) {
            return new g(t, n, s.$l);
          },
          m = function (t) {
            return s.p(t) + "s";
          },
          l = function (t) {
            return t < 0;
          },
          $ = function (t) {
            return l(t) ? Math.ceil(t) : Math.floor(t);
          },
          y = function (t) {
            return Math.abs(t);
          },
          v = function (t, s) {
            return t ? l(t) ? {
              negative: !0,
              format: "" + y(t) + s
            } : {
              negative: !1,
              format: "" + t + s
            } : {
              negative: !1,
              format: ""
            };
          },
          g = function () {
            function l(t, s, n) {
              var i = this;
              if (this.$d = {}, this.$l = n, void 0 === t && (this.$ms = 0, this.parseFromMilliseconds()), s) return f(t * h[m(s)], this);
              if ("number" == typeof t) return this.$ms = t, this.parseFromMilliseconds(), this;
              if ("object" == typeof t) return Object.keys(t).forEach(function (s) {
                i.$d[m(s)] = t[s];
              }), this.calMilliseconds(), this;
              if ("string" == typeof t) {
                var e = t.match(a);
                if (e) {
                  var r = e.slice(2).map(function (t) {
                    return null != t ? Number(t) : 0;
                  });
                  return this.$d.years = r[0], this.$d.months = r[1], this.$d.weeks = r[2], this.$d.days = r[3], this.$d.hours = r[4], this.$d.minutes = r[5], this.$d.seconds = r[6], this.calMilliseconds(), this;
                }
              }
              return this;
            }
            var y = l.prototype;
            return y.calMilliseconds = function () {
              var t = this;
              this.$ms = Object.keys(this.$d).reduce(function (s, n) {
                return s + (t.$d[n] || 0) * h[n];
              }, 0);
            }, y.parseFromMilliseconds = function () {
              var t = this.$ms;
              this.$d.years = $(t / u), t %= u, this.$d.months = $(t / d), t %= d, this.$d.days = $(t / r), t %= r, this.$d.hours = $(t / e), t %= e, this.$d.minutes = $(t / i), t %= i, this.$d.seconds = $(t / n), t %= n, this.$d.milliseconds = t;
            }, y.toISOString = function () {
              var t = v(this.$d.years, "Y"),
                s = v(this.$d.months, "M"),
                n = +this.$d.days || 0;
              this.$d.weeks && (n += 7 * this.$d.weeks);
              var i = v(n, "D"),
                e = v(this.$d.hours, "H"),
                r = v(this.$d.minutes, "M"),
                o = this.$d.seconds || 0;
              this.$d.milliseconds && (o += this.$d.milliseconds / 1e3, o = Math.round(1e3 * o) / 1e3);
              var u = v(o, "S"),
                d = t.negative || s.negative || i.negative || e.negative || r.negative || u.negative,
                a = e.format || r.format || u.format ? "T" : "",
                h = (d ? "-" : "") + "P" + t.format + s.format + i.format + a + e.format + r.format + u.format;
              return "P" === h || "-P" === h ? "P0D" : h;
            }, y.toJSON = function () {
              return this.toISOString();
            }, y.format = function (t) {
              var n = t || "YYYY-MM-DDTHH:mm:ss",
                i = {
                  Y: this.$d.years,
                  YY: s.s(this.$d.years, 2, "0"),
                  YYYY: s.s(this.$d.years, 4, "0"),
                  M: this.$d.months,
                  MM: s.s(this.$d.months, 2, "0"),
                  D: this.$d.days,
                  DD: s.s(this.$d.days, 2, "0"),
                  H: this.$d.hours,
                  HH: s.s(this.$d.hours, 2, "0"),
                  m: this.$d.minutes,
                  mm: s.s(this.$d.minutes, 2, "0"),
                  s: this.$d.seconds,
                  ss: s.s(this.$d.seconds, 2, "0"),
                  SSS: s.s(this.$d.milliseconds, 3, "0")
                };
              return n.replace(o, function (t, s) {
                return s || String(i[t]);
              });
            }, y.as = function (t) {
              return this.$ms / h[m(t)];
            }, y.get = function (t) {
              var s = this.$ms,
                n = m(t);
              return "milliseconds" === n ? s %= 1e3 : s = "weeks" === n ? $(s / h[n]) : this.$d[n], s || 0;
            }, y.add = function (t, s, n) {
              var i;
              return i = s ? t * h[m(s)] : c(t) ? t.$ms : f(t, this).$ms, f(this.$ms + i * (n ? -1 : 1), this);
            }, y.subtract = function (t, s) {
              return this.add(t, s, !0);
            }, y.locale = function (t) {
              var s = this.clone();
              return s.$l = t, s;
            }, y.clone = function () {
              return f(this.$ms, this);
            }, y.humanize = function (s) {
              return t().add(this.$ms, "ms").locale(this.$l).fromNow(!s);
            }, y.valueOf = function () {
              return this.asMilliseconds();
            }, y.milliseconds = function () {
              return this.get("milliseconds");
            }, y.asMilliseconds = function () {
              return this.as("milliseconds");
            }, y.seconds = function () {
              return this.get("seconds");
            }, y.asSeconds = function () {
              return this.as("seconds");
            }, y.minutes = function () {
              return this.get("minutes");
            }, y.asMinutes = function () {
              return this.as("minutes");
            }, y.hours = function () {
              return this.get("hours");
            }, y.asHours = function () {
              return this.as("hours");
            }, y.days = function () {
              return this.get("days");
            }, y.asDays = function () {
              return this.as("days");
            }, y.weeks = function () {
              return this.get("weeks");
            }, y.asWeeks = function () {
              return this.as("weeks");
            }, y.months = function () {
              return this.get("months");
            }, y.asMonths = function () {
              return this.as("months");
            }, y.years = function () {
              return this.get("years");
            }, y.asYears = function () {
              return this.as("years");
            }, l;
          }(),
          p = function (t, s, n) {
            return t.add(s.years() * n, "y").add(s.months() * n, "M").add(s.days() * n, "d").add(s.hours() * n, "h").add(s.minutes() * n, "m").add(s.seconds() * n, "s").add(s.milliseconds() * n, "ms");
          };
        return function (n, i, e) {
          t = e, s = e().$utils(), e.duration = function (t, s) {
            var n = e.locale();
            return f(t, {
              $l: n
            }, s);
          }, e.isDuration = c;
          var r = i.prototype.add,
            o = i.prototype.subtract;
          i.prototype.add = function (t, s) {
            return c(t) ? p(this, t, 1) : r.bind(this)(t, s);
          }, i.prototype.subtract = function (t, s) {
            return c(t) ? p(this, t, -1) : o.bind(this)(t, s);
          };
        };
      });
    })(duration);
    var dayJsDuration = duration.exports;

    /**
     * MOB StickyNavbar
     * @author Mert Osman Başol
     * @email mert.basol@magicport.ai
     */
    class MOBStickyNavbar {
      /**
       * Constructor
       * @param navbar
       */
      constructor(navbar) {
        this.navbar = navbar;
        this.hideClass = 'is-hide';
        this.stickyClass = 'is-sticky';
        this.shadowDisableClass = 'no-shadow';
        this.lastScroll = 0;
        this.disableStickyClass = 'disable-sticky';
        this.placeholder = document.querySelector('[data-sticky-navbar-placeholder]');
        this.disableScrollElements = document.querySelector('[data-navbar-sticky-shadow="false"]');
      }

      /**
       * Init
       */
      init() {
        window.addEventListener('load', () => {
          setTimeout(() => {
            if (!this.checkDisabled()) this.scrolling();
          }, 300);
        });
        window.addEventListener('scroll', () => {
          if (!this.checkDisabled()) this.scrolling();
        });
        if (this.disableScrollElements) {
          this.navbar.classList.add(this.shadowDisableClass);
        }
      }

      /**
       * Scrolling
       */
      scrolling() {
        const currentScroll = window.pageYOffset;
        const scrollLimit = this.placeholder ? this.placeholder.offsetTop + this.placeholder.clientHeight : 0;
        if (currentScroll <= scrollLimit) {
          this.navbar.classList.remove(this.stickyClass);
        } else {
          if (currentScroll > this.lastScroll && !this.navbar.classList.contains(this.hideClass)) {
            // down
            this.navbar.classList.remove(this.stickyClass);
            this.navbar.classList.add(this.hideClass);
          } else if (currentScroll < this.lastScroll && this.navbar.classList.contains(this.hideClass)) {
            // up
            this.navbar.classList.remove(this.hideClass);
            this.navbar.classList.add(this.stickyClass);
          }
          this.lastScroll = currentScroll;
        }
      }
      checkDisabled() {
        return this.navbar.classList.contains(this.disableStickyClass);
      }
    }

    var smoothscroll$1 = {exports: {}};

    /* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */
    (function (module, exports) {
      (function () {

        // polyfill
        function polyfill() {
          // aliases
          var w = window;
          var d = document;

          // return if scroll behavior is supported and polyfill is not forced
          if ('scrollBehavior' in d.documentElement.style && w.__forceSmoothScrollPolyfill__ !== true) {
            return;
          }

          // globals
          var Element = w.HTMLElement || w.Element;
          var SCROLL_TIME = 468;

          // object gathering original scroll methods
          var original = {
            scroll: w.scroll || w.scrollTo,
            scrollBy: w.scrollBy,
            elementScroll: Element.prototype.scroll || scrollElement,
            scrollIntoView: Element.prototype.scrollIntoView
          };

          // define timing method
          var now = w.performance && w.performance.now ? w.performance.now.bind(w.performance) : Date.now;

          /**
           * indicates if a the current browser is made by Microsoft
           * @method isMicrosoftBrowser
           * @param {String} userAgent
           * @returns {Boolean}
           */
          function isMicrosoftBrowser(userAgent) {
            var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];
            return new RegExp(userAgentPatterns.join('|')).test(userAgent);
          }

          /*
           * IE has rounding bug rounding down clientHeight and clientWidth and
           * rounding up scrollHeight and scrollWidth causing false positives
           * on hasScrollableSpace
           */
          var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

          /**
           * changes scroll position inside an element
           * @method scrollElement
           * @param {Number} x
           * @param {Number} y
           * @returns {undefined}
           */
          function scrollElement(x, y) {
            this.scrollLeft = x;
            this.scrollTop = y;
          }

          /**
           * returns result of applying ease math function to a number
           * @method ease
           * @param {Number} k
           * @returns {Number}
           */
          function ease(k) {
            return 0.5 * (1 - Math.cos(Math.PI * k));
          }

          /**
           * indicates if a smooth behavior should be applied
           * @method shouldBailOut
           * @param {Number|Object} firstArg
           * @returns {Boolean}
           */
          function shouldBailOut(firstArg) {
            if (firstArg === null || typeof firstArg !== 'object' || firstArg.behavior === undefined || firstArg.behavior === 'auto' || firstArg.behavior === 'instant') {
              // first argument is not an object/null
              // or behavior is auto, instant or undefined
              return true;
            }
            if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
              // first argument is an object and behavior is smooth
              return false;
            }

            // throw error when behavior is not supported
            throw new TypeError('behavior member of ScrollOptions ' + firstArg.behavior + ' is not a valid value for enumeration ScrollBehavior.');
          }

          /**
           * indicates if an element has scrollable space in the provided axis
           * @method hasScrollableSpace
           * @param {Node} el
           * @param {String} axis
           * @returns {Boolean}
           */
          function hasScrollableSpace(el, axis) {
            if (axis === 'Y') {
              return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
            }
            if (axis === 'X') {
              return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
            }
          }

          /**
           * indicates if an element has a scrollable overflow property in the axis
           * @method canOverflow
           * @param {Node} el
           * @param {String} axis
           * @returns {Boolean}
           */
          function canOverflow(el, axis) {
            var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];
            return overflowValue === 'auto' || overflowValue === 'scroll';
          }

          /**
           * indicates if an element can be scrolled in either axis
           * @method isScrollable
           * @param {Node} el
           * @param {String} axis
           * @returns {Boolean}
           */
          function isScrollable(el) {
            var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
            var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');
            return isScrollableY || isScrollableX;
          }

          /**
           * finds scrollable parent of an element
           * @method findScrollableParent
           * @param {Node} el
           * @returns {Node} el
           */
          function findScrollableParent(el) {
            while (el !== d.body && isScrollable(el) === false) {
              el = el.parentNode || el.host;
            }
            return el;
          }

          /**
           * self invoked function that, given a context, steps through scrolling
           * @method step
           * @param {Object} context
           * @returns {undefined}
           */
          function step(context) {
            var time = now();
            var value;
            var currentX;
            var currentY;
            var elapsed = (time - context.startTime) / SCROLL_TIME;

            // avoid elapsed times higher than one
            elapsed = elapsed > 1 ? 1 : elapsed;

            // apply easing to elapsed time
            value = ease(elapsed);
            currentX = context.startX + (context.x - context.startX) * value;
            currentY = context.startY + (context.y - context.startY) * value;
            context.method.call(context.scrollable, currentX, currentY);

            // scroll more if we have not reached our destination
            if (currentX !== context.x || currentY !== context.y) {
              w.requestAnimationFrame(step.bind(w, context));
            }
          }

          /**
           * scrolls window or element with a smooth behavior
           * @method smoothScroll
           * @param {Object|Node} el
           * @param {Number} x
           * @param {Number} y
           * @returns {undefined}
           */
          function smoothScroll(el, x, y) {
            var scrollable;
            var startX;
            var startY;
            var method;
            var startTime = now();

            // define scroll context
            if (el === d.body) {
              scrollable = w;
              startX = w.scrollX || w.pageXOffset;
              startY = w.scrollY || w.pageYOffset;
              method = original.scroll;
            } else {
              scrollable = el;
              startX = el.scrollLeft;
              startY = el.scrollTop;
              method = scrollElement;
            }

            // scroll looping over a frame
            step({
              scrollable: scrollable,
              method: method,
              startTime: startTime,
              startX: startX,
              startY: startY,
              x: x,
              y: y
            });
          }

          // ORIGINAL METHODS OVERRIDES
          // w.scroll and w.scrollTo
          w.scroll = w.scrollTo = function () {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) {
              return;
            }

            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
              original.scroll.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== 'object' ? arguments[0] : w.scrollX || w.pageXOffset,
              // use top prop, second argument if present or fallback to scrollY
              arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : w.scrollY || w.pageYOffset);
              return;
            }

            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(w, d.body, arguments[0].left !== undefined ? ~~arguments[0].left : w.scrollX || w.pageXOffset, arguments[0].top !== undefined ? ~~arguments[0].top : w.scrollY || w.pageYOffset);
          };

          // w.scrollBy
          w.scrollBy = function () {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) {
              return;
            }

            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0])) {
              original.scrollBy.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== 'object' ? arguments[0] : 0, arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : 0);
              return;
            }

            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(w, d.body, ~~arguments[0].left + (w.scrollX || w.pageXOffset), ~~arguments[0].top + (w.scrollY || w.pageYOffset));
          };

          // Element.prototype.scroll and Element.prototype.scrollTo
          Element.prototype.scroll = Element.prototype.scrollTo = function () {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) {
              return;
            }

            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
              // if one number is passed, throw error to match Firefox implementation
              if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
                throw new SyntaxError('Value could not be converted');
              }
              original.elementScroll.call(this,
              // use left prop, first number argument or fallback to scrollLeft
              arguments[0].left !== undefined ? ~~arguments[0].left : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft,
              // use top prop, second argument or fallback to scrollTop
              arguments[0].top !== undefined ? ~~arguments[0].top : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop);
              return;
            }
            var left = arguments[0].left;
            var top = arguments[0].top;

            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(this, this, typeof left === 'undefined' ? this.scrollLeft : ~~left, typeof top === 'undefined' ? this.scrollTop : ~~top);
          };

          // Element.prototype.scrollBy
          Element.prototype.scrollBy = function () {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) {
              return;
            }

            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
              original.elementScroll.call(this, arguments[0].left !== undefined ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, arguments[0].top !== undefined ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop);
              return;
            }
            this.scroll({
              left: ~~arguments[0].left + this.scrollLeft,
              top: ~~arguments[0].top + this.scrollTop,
              behavior: arguments[0].behavior
            });
          };

          // Element.prototype.scrollIntoView
          Element.prototype.scrollIntoView = function () {
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
              original.scrollIntoView.call(this, arguments[0] === undefined ? true : arguments[0]);
              return;
            }

            // LET THE SMOOTHNESS BEGIN!
            var scrollableParent = findScrollableParent(this);
            var parentRects = scrollableParent.getBoundingClientRect();
            var clientRects = this.getBoundingClientRect();
            if (scrollableParent !== d.body) {
              // reveal element inside parent
              smoothScroll.call(this, scrollableParent, scrollableParent.scrollLeft + clientRects.left - parentRects.left, scrollableParent.scrollTop + clientRects.top - parentRects.top);

              // reveal parent in viewport unless is fixed
              if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
                w.scrollBy({
                  left: parentRects.left,
                  top: parentRects.top,
                  behavior: 'smooth'
                });
              }
            } else {
              // reveal element in viewport
              w.scrollBy({
                left: clientRects.left,
                top: clientRects.top,
                behavior: 'smooth'
              });
            }
          };
        }
        {
          // commonjs
          module.exports = {
            polyfill: polyfill
          };
        }
      })();
    })(smoothscroll$1);
    var smoothscroll = smoothscroll$1.exports;

    /**
     * MOB Scroll To
     * @author Mert Osman Başol
     * @email mert.basol@magicport.ai
     */
    smoothscroll.polyfill();
    class MOBScrollTo {
      constructor(scrollElement, options = {}) {
        this.element = scrollElement;
        // eslint-disable-next-line prefer-destructuring
        this.target = scrollElement.getAttribute('href').split('#')[1];
        this.hash = !!options.hash;
        this.activeClass = 'is-active';
        this.offset = scrollElement.dataset?.scrollToOffset;
        this.lastActiveSection = null; // Track last active section to prevent unnecessary updates
        this.scrollWrapper = null; // Will store scroll wrapper reference
        this.wrapperScrollHandler = null; // Will store bound scroll handler
      }

      /**
       * Init
       */
      init() {
        const childs = [...this.element.parentNode.querySelectorAll('[data-scroll-to]')];
        this.element.addEventListener('click', e => {
          const target = document.getElementById(this.target);
          if (target) {
            this.scrollTo(target);
            if (childs.length > 1) {
              childs.map(child => child.classList.toggle(this.activeClass, child === this.element));

              // Scroll to center in wrapper if scrollable
              if (this.wrapperScrollHandler) {
                setTimeout(() => this.scrollActiveToCenter(), 10);
              }
            }
            // eslint-disable-next-line no-restricted-globals
            // history.pushState(null, null, hashval);
            // e.preventDefault();

            if (!this.hash) {
              e.preventDefault();
            } else {
              if (window.location.hash) e.preventDefault();
              const tabButton = document.querySelector(`[data-tab-button][href="#${this.target}"]`);
              if (tabButton) tabButton.click();
            }
          }
        });

        // Anchor Scrolling Hash Check
        if (this.hash && window.location.hash) {
          setTimeout(() => window.scroll(0, 0), 0);
          const id = window.location.hash.split('#')[1];
          const target = document.getElementById(id);
          if (target) setTimeout(() => this.scrollTo(target, 'auto'), 50);
        }

        // Scroll tracking with throttling for better performance
        let scrollTimeout;
        window.addEventListener('scroll', () => {
          if (scrollTimeout) {
            clearTimeout(scrollTimeout);
          }
          scrollTimeout = setTimeout(() => this.scrollTrack(), 10);
        });
      }

      /**
       * getOffset
       * @param element
       * @param horizontal
       */
      getOffset(element, horizontal = false) {
        if (!element) return 0;
        return this.getOffset(element.offsetParent, horizontal) + (horizontal ? element.offsetLeft : element.offsetTop);
      }

      /**
       * Scroll To
       * @param el
       * @param behavior
       */
      // eslint-disable-next-line class-methods-use-this
      scrollTo(el, behavior = 'smooth') {
        const container = el.querySelector('.section__container') || el;
        const navbar = document.querySelector('.navbar');
        const tab = document.querySelector('[data-sticky-nav]');
        const placeholder = document.querySelector('[data-scroll-placeholder]');
        const doc = document.documentElement;
        const windowTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        const offset = this.getOffset(el) - (window.getComputedStyle(container, null).getPropertyValue('padding-top') === '0px' ? 48 : 0) - (
        // eslint-disable-next-line no-nested-ternary
        navbar ? this.getOffset(el) - navbar.clientHeight < windowTop ? navbar.clientHeight : 0 : 0) - (
        // eslint-disable-next-line no-nested-ternary
        tab ? window.matchMedia('(max-width: 991px)') ? tab.clientHeight : 0 : 0) - (placeholder ? placeholder.clientHeight : 0) - (this.offset ? parseFloat(this.offset) : 0);
        window.scroll({
          behavior,
          top: offset
        });
      }

      /**
       * Calculate dynamic root margin based on fixed/sticky elements
       */
      calculateRootMargin() {
        let topOffset = 0;
        let bottomOffset = 0;

        // Common selectors for fixed/sticky elements
        const stickySelectors = ['[data-scroll-placeholder]'];
        stickySelectors.forEach(selector => {
          const elements = document.querySelectorAll(selector);
          elements.forEach(element => {
            const style = window.getComputedStyle(element);
            const position = style.position;

            // Check if element is fixed or sticky
            if (position === 'fixed' || position === 'sticky') {
              const rect = element.getBoundingClientRect();

              // Determine if element is at top or bottom
              if (rect.top <= 10) {
                // Element is at/near top
                topOffset += rect.height;
              } else if (rect.bottom >= window.innerHeight - 10) {
                // Element is at/near bottom
                bottomOffset += rect.height;
              }
            }
          });
        });

        // Add small buffer for better UX
        topOffset += 20;
        bottomOffset += 20;
        const rootMargin = `-${topOffset}px 0px -${bottomOffset}px 0px`;
        return rootMargin;
      }

      /**
       * Initialize Intersection Observer for precise section tracking
       */
      initObserver() {
        const childs = [...this.element.parentNode.querySelectorAll('[data-scroll-to]')];
        if (childs.length <= 1) return;

        // Build trackable navigation items (exclude data-scroll-no-track)
        this.trackableItems = [];
        childs.forEach(element => {
          if (element.hasAttribute('data-scroll-no-track')) return;
          const href = element.getAttribute('href');
          if (!href) return;
          const targetId = href.split('#')[1];
          const section = document.getElementById(targetId);
          if (!section) return;
          this.trackableItems.push({
            element,
            targetId,
            section,
            isVisible: false,
            visibilityRatio: 0
          });
        });
        if (this.trackableItems.length === 0) return;

        // Calculate dynamic root margin based on fixed/sticky elements
        const rootMargin = this.calculateRootMargin();

        // Create Intersection Observer with dynamic configuration
        this.observer = new IntersectionObserver(entries => {
          // Update visibility data for each section
          entries.forEach(entry => {
            const item = this.trackableItems.find(item => item.section === entry.target);
            if (item) {
              item.isVisible = entry.isIntersecting;
              item.visibilityRatio = entry.intersectionRatio;
            }
          });
          this.updateActiveSection();
        }, {
          root: null,
          // Use viewport as root
          rootMargin,
          // Dynamic margin based on sticky elements
          threshold: [0, 0.1, 0.25, 0.5, 0.75, 1.0] // Multiple thresholds for precise tracking
        });

        // Start observing all trackable sections
        this.trackableItems.forEach(item => {
          this.observer.observe(item.section);
        });

        // Handle initial state and trigger initial tracking
        this.handleInitialSection();

        // Trigger initial section detection after observer is set up
        setTimeout(() => {
          this.performInitialTracking();
        }, 500);

        // Handle window resize for responsive sticky elements
        this.setupResizeHandler();

        // Setup horizontal scroll wrapper management
        this.setupWrapperScrolling();
      }

      /**
       * Setup window resize handler for responsive sticky elements
       */
      setupResizeHandler() {
        let resizeTimeout;
        window.addEventListener('resize', () => {
          // Debounce resize events
          if (resizeTimeout) {
            clearTimeout(resizeTimeout);
          }
          resizeTimeout = setTimeout(() => {
            // Recalculate and update observer when window resizes
            if (this.observer) {
              this.observer.disconnect();

              // Reinitialize with new root margin
              const rootMargin = this.calculateRootMargin();
              this.observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                  const item = this.trackableItems.find(item => item.section === entry.target);
                  if (item) {
                    item.isVisible = entry.isIntersecting;
                    item.visibilityRatio = entry.intersectionRatio;
                  }
                });
                this.updateActiveSection();
              }, {
                root: null,
                rootMargin,
                threshold: [0, 0.1, 0.25, 0.5, 0.75, 1.0]
              });

              // Re-observe all sections
              this.trackableItems.forEach(item => {
                this.observer.observe(item.section);
              });
            }
          }, 250); // 250ms debounce
        });
      }

      /**
       * Handle initial section activation (for first section when scrolled above it)
       */
      handleInitialSection() {
        if (this.trackableItems.length === 0) return;
        const firstSection = this.trackableItems[0];
        const scrollTop = window.scrollY;

        // If we're above the first section, activate it
        if (scrollTop < firstSection.section.offsetTop - 100) {
          this.setActiveSection(firstSection.targetId, 0);
        }
      }

      /**
       * Perform initial tracking to detect current section on page load
       */
      performInitialTracking() {
        if (!this.trackableItems || this.trackableItems.length === 0) return;

        // Find which section should be active based on current scroll position
        let bestSection = null;
        let bestIndex = -1;
        let maxVisibility = 0;

        // Check each section's current visibility
        this.trackableItems.forEach((item, index) => {
          const rect = item.section.getBoundingClientRect();
          const viewportHeight = window.innerHeight;

          // Calculate how much of the section is visible in current viewport
          const visibleTop = Math.max(0, rect.top);
          const visibleBottom = Math.min(viewportHeight, rect.bottom);
          const visibleHeight = Math.max(0, visibleBottom - visibleTop);
          const sectionHeight = rect.height;
          const visibilityRatio = sectionHeight > 0 ? visibleHeight / sectionHeight : 0;
          if (visibilityRatio > maxVisibility && visibleHeight > 50) {
            // At least 50px visible
            maxVisibility = visibilityRatio;
            bestSection = item.targetId;
            bestIndex = index;
          }
        });

        // If no section is sufficiently visible, check if we're above first section
        if (!bestSection) {
          const scrollTop = window.scrollY;
          const firstSection = this.trackableItems[0];
          if (scrollTop < firstSection.section.offsetTop) {
            bestSection = firstSection.targetId;
            bestIndex = 0;
          }
        }

        // Set initial active section
        if (bestSection) {
          this.setActiveSection(bestSection, bestIndex);
        }
      }

      /**
       * Update active section based on visibility ratios
       */
      updateActiveSection() {
        if (!this.trackableItems) return;

        // Find the section with highest visibility ratio
        let bestSection = null;
        let bestIndex = -1;
        let maxVisibility = 0;
        this.trackableItems.forEach((item, index) => {
          if (item.isVisible && item.visibilityRatio > maxVisibility) {
            maxVisibility = item.visibilityRatio;
            bestSection = item.targetId;
            bestIndex = index;
          }
        });

        // Fallback: if no section is visible, check if we're above first section
        if (!bestSection) {
          const scrollTop = window.scrollY;
          const firstSection = this.trackableItems[0];
          if (scrollTop < firstSection.section.offsetTop) {
            bestSection = firstSection.targetId;
            bestIndex = 0;
          }
        }

        // Update active section if changed
        if (bestSection && this.lastActiveSection !== bestSection) {
          this.setActiveSection(bestSection, bestIndex);
        }
      }

      /**
       * Setup horizontal scroll wrapper management
       */
      setupWrapperScrolling() {
        // Find scroll wrapper
        this.scrollWrapper = document.querySelector('[data-scroll-to-wrapper]');
        if (!this.scrollWrapper) return;

        // Initial setup
        this.checkWrapperScrollability();

        // Setup resize observer for wrapper scrollability changes
        this.setupWrapperResizeHandler();
      }

      /**
       * Check if wrapper needs horizontal scrolling and setup/remove handlers accordingly
       */
      checkWrapperScrollability() {
        if (!this.scrollWrapper) return;
        const isScrollable = this.scrollWrapper.scrollWidth > this.scrollWrapper.clientWidth;
        if (isScrollable && !this.wrapperScrollHandler) {
          // Enable scroll-to-center functionality
          this.enableWrapperScrolling();
        } else if (!isScrollable && this.wrapperScrollHandler) {
          // Disable scroll-to-center functionality
          this.disableWrapperScrolling();
        }
      }

      /**
       * Enable horizontal scroll-to-center functionality
       */
      enableWrapperScrolling() {
        if (!this.scrollWrapper || this.wrapperScrollHandler) return;

        // Create bound handler for performance
        this.wrapperScrollHandler = () => this.scrollActiveToCenter();

        // Listen for active section changes to center active element
        // We'll trigger this in setActiveSection method
      }

      /**
       * Disable horizontal scroll-to-center functionality
       */
      disableWrapperScrolling() {
        if (!this.wrapperScrollHandler) return;

        // Remove handler reference
        this.wrapperScrollHandler = null;
      }

      /**
       * Scroll active navigation element to center of wrapper
       */
      scrollActiveToCenter() {
        if (!this.scrollWrapper || !this.wrapperScrollHandler) return;
        const activeElement = this.scrollWrapper.querySelector(`.${this.activeClass}`);
        if (!activeElement) return;
        const wrapperRect = this.scrollWrapper.getBoundingClientRect();
        const activeRect = activeElement.getBoundingClientRect();

        // Calculate center position
        const wrapperCenter = wrapperRect.width / 2;
        const activeCenter = activeRect.left - wrapperRect.left + activeRect.width / 2;
        const scrollOffset = activeCenter - wrapperCenter;

        // Smooth scroll to center
        this.scrollWrapper.scrollBy({
          left: scrollOffset,
          behavior: 'smooth'
        });
      }

      /**
       * Setup resize handler for wrapper scrollability changes
       */
      setupWrapperResizeHandler() {
        if (!this.scrollWrapper) return;
        let resizeTimeout;
        const handleResize = () => {
          if (resizeTimeout) clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            this.checkWrapperScrollability();

            // If scrolling is enabled and there's an active element, center it
            if (this.wrapperScrollHandler) {
              this.scrollActiveToCenter();
            }
          }, 100); // Quick response for better UX
        };

        // Use ResizeObserver for better performance if available
        if (window.ResizeObserver) {
          this.wrapperResizeObserver = new ResizeObserver(handleResize);
          this.wrapperResizeObserver.observe(this.scrollWrapper);
        } else {
          // Fallback to window resize
          window.addEventListener('resize', handleResize);
        }
      }

      /**
       * Set active section and update navigation classes
       */
      setActiveSection(sectionId, index) {
        // Update classes for all trackable items
        this.trackableItems.forEach((item, i) => {
          const shouldBeActive = i === index;
          if (item.element.classList.contains(this.activeClass) !== shouldBeActive) {
            item.element.classList.toggle(this.activeClass, shouldBeActive);
          }
        });

        // Clear active class from non-trackable items (bypass items)
        const allNavItems = [...this.element.parentNode.querySelectorAll('[data-scroll-to]')];
        allNavItems.forEach(child => {
          if (child.hasAttribute('data-scroll-no-track')) {
            child.classList.remove(this.activeClass);
          }
        });
        this.lastActiveSection = sectionId;

        // Scroll active element to center if wrapper is scrollable
        if (this.wrapperScrollHandler) {
          // Small delay to ensure DOM updates are complete
          setTimeout(() => this.scrollActiveToCenter(), 10);
        }
      }

      /**
       * Legacy scrollTrack method - now initializes observer
       */
      scrollTrack() {
        if (!this.observer) {
          this.initObserver();
        }
      }
    }

    /**
     * MOB Dropdown
     */

    class MOBDropdown {
      /**
       * Constructor
       * @param  {Node} dropdownButton - Node Element
       * @param dropdownOptions
       */
      constructor(dropdownButton, dropdownOptions = {}) {
        this.dropdownToggle = dropdownButton;
        this.dropdownContainer = dropdownButton.parentNode;
        this.dropdownClose = document.querySelectorAll('[data-dropdown-close]');
        this.activeClass = dropdownOptions.activeClass || 'is-active';
        this.toggleClass = null;
        this.toggleActiveClass = dropdownOptions.toggleActiveClass || this.activeClass;
        this.isOpened = false;
        this.documentClick = this.documentClick.bind(this);
        this.dropdownToggle.dropdown = this;
        this.dropdownContainer.dropdown = this;
        this.dropdownOverlay = dropdownOptions.overlay || null;
        this.bodyHidden = !!dropdownOptions.bodyHidden;
        this.bodyHiddenClass = dropdownOptions.bodyHiddenClass || 'is-hidden';
        this.bodyActiveClass = dropdownOptions.bodyActiveClass;
        this.dropdownItem = this.dropdownContainer.querySelectorAll('[data-dropdown-item]');
        this.dropdownItemActiveClass = 'is-active';
        this.dropdownToggleLabel = this.dropdownContainer.querySelector('[data-dropdown-label]');
        this.dropdownReset = this.dropdownContainer.querySelector('[data-dropdown-input-reset]');
        this.dropdownInput = this.dropdownContainer.querySelector('[data-dropdown-input]');
        this.headerStickyStop = dropdownOptions.headerStickyStop || false;
        this.animationClass = dropdownOptions.animationClass || null;
        this.animationDuration = dropdownOptions.animationDuration || null;
        this.isMenu = dropdownOptions.menu || null;
        this.dropdownType = this.dropdownToggle.dataset.dropdownType;
      }

      /**
       * Init
       */
      init() {
        if (this.dropdownToggle.hasAttribute('data-accordion-toggle') && this.dropdownToggle.closest('[data-accordion="mobile"]') && this.isMobile()) return;
        if (this.dropdownToggle.hasAttribute('data-accordion-toggle') && this.dropdownToggle.closest('[data-accordion="mobile-sm"]') && this.isMobileSm()) return;
        if (this.dropdownType) {
          this.toggleClass = 'd-none';
        }
        if (this.dropdownToggle.getAttribute('data-target')) {
          this.dropdownContainer = document.querySelector(this.dropdownToggle.getAttribute('data-target'));
        }
        if (this.dropdownOverlay) {
          this.dropdownOverlay = new DOMParser().parseFromString(this.dropdownOverlay, 'text/html').body.firstChild;
        }
        if (this.dropdownClose) {
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < this.dropdownClose.length; i++) {
            const closeButton = this.dropdownClose[i];
            closeButton.addEventListener('click', () => this.close());
          }
        }
        if (this.dropdownItem) {
          Array.from(this.dropdownItem).forEach(item => item.addEventListener('click', e => this.change(e)));
        }

        // Item label change event
        if (this.dropdownToggleLabel) this.setActiveItem(this.dropdownToggleLabel);

        // Reset Event
        if (this.dropdownReset) this.dropdownReset.addEventListener('click', e => this.resetInputs(e));

        // Toggle Event
        this.dropdownToggle.addEventListener('click', e => this.toggle(e));
      }

      /**
       * Toggle
       * @param {*} e
       */
      toggle(e) {
        e.preventDefault();
        if (this.isOpened) {
          this.close();
        } else {
          this.open();
        }
      }

      /**
       * Document Click Func
       * @param {*} e
       */
      documentClick(e) {
        const dropdownClickInside = this.dropdownContainer.contains(e.target);
        if (this.isOpened && !dropdownClickInside) {
          if (this.dropdownToggle.hasAttribute('data-accordion-toggle') && this.dropdownToggle.closest('[data-accordion="mobile"]') && this.isMobile()) return;
          if (this.dropdownToggle.hasAttribute('data-accordion-toggle') && this.dropdownToggle.closest('[data-accordion="mobile-sm"]') && this.isMobileSm()) return;
          this.close();
        }
      }

      /**
       * Open
       */
      open() {
        this.isOpened = true;
        this.dropdownContainer.classList.add(this.activeClass);
        this.dropdownToggle.classList.add(this.toggleActiveClass);
        if (this.toggleClass) {
          this.dropdownContainer.classList.remove(this.toggleClass);
        }
        if (this.animationDuration) {
          setTimeout(() => this.dropdownContainer.classList.add(this.animationClass), this.animationDuration);
        }
        if (!this.isMobile() && this.dropdownOverlay) {
          this.dropdownContainer.parentNode.insertBefore(this.dropdownOverlay, this.dropdownContainer.nextSibling);
        }
        if (this.bodyHidden) {
          if (this.bodyHiddenClass) document.body.classList.add(this.bodyHiddenClass);
        }
        if (this.bodyActiveClass && this.isMobileSm()) {
          if (this.bodyActiveClass) document.body.classList.add(this.bodyActiveClass);
        }
        if (this.headerStickyStop) {
          const header = document.querySelector('.layout__header');
          if (header) header.classList.add('is-fixed');
        }
        if (this.isMenu) document.body.classList.add('menu-opened');
        setTimeout(() => {
          document.addEventListener('click', this.documentClick);
        });
      }

      /**
       * Close
       */
      close() {
        this.isOpened = false;
        this.dropdownContainer.classList.remove(this.activeClass);
        this.dropdownToggle.classList.remove(this.toggleActiveClass);
        if (this.toggleClass) {
          this.dropdownContainer.classList.add(this.toggleClass, this.dropdownStyle);
        }
        if (this.animationDuration) {
          setTimeout(() => this.dropdownContainer.classList.remove(this.animationClass), this.animationDuration);
        }
        if (!this.isMobile() && this.dropdownOverlay) {
          if (this.dropdownContainer.nextSibling === this.dropdownOverlay) {
            this.dropdownContainer.parentNode.removeChild(this.dropdownOverlay);
          }
        }
        if (this.isMenu) document.body.classList.remove('menu-opened');
        setTimeout(() => {
          if (this.bodyHiddenClass && !document.body.classList.contains('menu-opened')) document.body.classList.remove(this.bodyHiddenClass);
        }, 50);
        setTimeout(() => {
          if (this.bodyActiveClass) {
            if (this.bodyActiveClass) document.body.classList.remove(this.bodyActiveClass);
          }
        }, 200);
        if (this.headerStickyStop) {
          const header = document.querySelector('.layout__header');
          if (header) header.classList.remove('is-fixed');
        }
        document.removeEventListener('click', this.documentClick);
      }

      /**
       * Change
       */
      change(e) {
        this.setActiveItem(e.currentTarget);
        this.close();
      }

      /**
       * Set Active Item
       * @param value
       */
      setActiveItem(value) {
        if (this.dropdownToggleLabel) {
          const text = value.textContent;
          const itemValue = value.getAttribute('data-dropdown-item-value');
          const label = this.dropdownToggleLabel.textContent;
          if (text.toLowerCase().trim() !== label.toLowerCase().trim()) {
            this.dropdownToggleLabel.textContent = text.trim();
            if (this.dropdownInput) {
              let inputEvent = new Event('input', {
                bubbles: true,
                cancelable: true
              });
              this.dropdownInput.value = itemValue || parseFloat(text.replace(/[^0-9]/g, ''));
              this.dropdownInput.setAttribute('value', itemValue || text.replace(/[^0-9]/g, ''));
              this.dropdownInput.dispatchEvent(inputEvent);
            }
          }
          Array.from(this.dropdownItem).map(item => item.classList.toggle(this.dropdownItemActiveClass, item.textContent.toLowerCase().trim() === text.toLowerCase().trim()));
        }
      }

      /**
       * Reset Inputs
       */
      resetInputs(e) {
        e.preventDefault();
        const inputs = Array.from(this.dropdownContainer.querySelectorAll('input:not([type=submit]), textarea'));
        // eslint-disable-next-line no-return-assign,array-callback-return
        inputs.map(input => {
          const inputEvent = new Event('input', {
            bubbles: true,
            cancelable: true
          });
          // eslint-disable-next-line no-unused-expressions
          input.getAttribute('type') === 'radio' || input.getAttribute('type') === 'checkbox' ?
          // eslint-disable-next-line no-param-reassign
          input.checked = false :
          // eslint-disable-next-line no-param-reassign
          input.value = '';
          input.dispatchEvent(inputEvent);
        });
      }

      /**
       * isMobile
       */
      // eslint-disable-next-line class-methods-use-this
      isMobile() {
        return window.matchMedia('(max-width: 768px)').matches;
      }

      /**
       * isMobileSm
       */
      // eslint-disable-next-line class-methods-use-this
      isMobileSm() {
        return window.matchMedia('(max-width: 575px)').matches;
      }
    }

    class KeyboardAwareModal {
      constructor(modal) {
        this.modal = modal;
        this.init();
      }
      init() {
        if (!this.modal) return;
        if (window.visualViewport) {
          window.visualViewport.addEventListener('resize', () => this.adjustHeight());
          window.visualViewport.addEventListener('scroll', () => this.adjustHeight());
          this.adjustHeight();
        }
      }

      // eslint-disable-next-line class-methods-use-this
      isMobile() {
        return window.matchMedia('(max-width: 768px)').matches;
      }
      adjustHeight() {
        if (!this.isMobile()) {
          this.modal.style.height = null;
          this.modal.style.top = null;
          return;
        }
        const vv = window.visualViewport;
        this.modal.style.height = `${vv.height}px`;
        this.modal.style.top = `${vv.offsetTop}px`;
      }
    }

    class ScrollLock {
      #lockCount = 0;
      #scrollX = 0;
      #scrollY = 0;
      #reserveScrollbarGap = true;
      lock({
        reserveScrollbarGap = true
      } = {}) {
        // eslint-disable-next-line no-plusplus
        this.#lockCount++;
        if (this.#lockCount > 1) return;
        this.#reserveScrollbarGap = reserveScrollbarGap;
        this.#scrollY = window.scrollY || document.documentElement.scrollTop || 0;
        this.#scrollX = window.scrollX || document.documentElement.scrollLeft || 0;
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        if (reserveScrollbarGap && scrollbarWidth > 0) {
          document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
          document.body.style.paddingRight = 'var(--scrollbar-width)';
        }
        document.body.style.top = `-${this.#scrollY}px`;
        document.body.style.left = `-${this.#scrollX}px`;
        document.documentElement.classList.add('is-locked');
        document.body.classList.add('is-locked');
      }
      unlock() {
        if (this.#lockCount === 0) return;
        // eslint-disable-next-line no-plusplus
        this.#lockCount--;
        if (this.#lockCount > 0) return;
        document.body.classList.remove('is-locked');
        document.documentElement.classList.remove('is-locked');
        document.body.style.top = '';
        document.body.style.left = '';
        if (this.#reserveScrollbarGap) {
          document.body.style.paddingRight = '';
          document.documentElement.style.removeProperty('--scrollbar-width');
        }
        window.scrollTo(this.#scrollX, this.#scrollY);
      }
    }

    /**
     * MOBModal
     *
     * A lightweight, reusable modal component that supports multiple steps,
     * stacking behavior, and programmatic control via its public API.
     *
     * @module MOBModal
     * @author Mert Osman Başol
     * @email mert.basol@magicport.ai
     */
    class MOBModal {
      // Stores the stack of open modal IDs to support nested modals
      static modalStack = [];

      // Registry of all instantiated modal APIs by their container ID
      static instances = {};
      static {
        document.addEventListener('click', e => {
          const stepChanger = e.target.closest('[data-modal-set-step]');
          if (!stepChanger) return;
          e.preventDefault();
          const step = parseInt(stepChanger.dataset.modalSetStep, 10);
          // eslint-disable-next-line no-restricted-globals
          if (isNaN(step)) return;

          // Find the currently active modal instance
          const activeModalEl = document.querySelector('.modal.is-opened');
          if (!activeModalEl) return;
          const modalApi = MOBModal.instances[activeModalEl.id];
          if (modalApi) {
            modalApi.setStep(step);
          }
        });
      }

      /**
       * @param {HTMLElement} modalToggle - The element that triggers this modal
       */
      constructor(modalToggle) {
        this.modalToggle = modalToggle;
        this.modalContainer = null;
        this.modalClose = '[data-modal-close]';
        this.modalFocusElement = '[data-modal-focus]';
        this.modalClass = 'modal';
        this.showClass = 'is-show';
        this.activeClass = 'is-opened';
        this.body = document.body;
        this.bodyHiddenClass = 'is-hidden';
        this.bodyOpenedClass = modalToggle.dataset.modalInline === 'true' ? 'modal-opened' : false;
        this.nativeShare = modalToggle.dataset.nativeShare === 'true';
        this.scrollLock = new ScrollLock();

        // Step management state
        this.initialStep = null;
        this.stepReset = false;
        this.currentStep = null;

        // Embed iframe management state (stored on container to share across triggers)
      }

      /**
       * Initializes event listeners and default state for the modal.
       * Reads initial step and reset behavior from data attributes.
       */
      init() {
        // Avoid duplicate initialization
        // eslint-disable-next-line no-underscore-dangle
        if (this.modalToggle?._modalLoaded) return;

        // Determine target container element
        const target = this.modalToggle.dataset.modalTarget || this.modalToggle.getAttribute('href')?.split('#')[1];
        const container = document.getElementById(target);
        if (!container) return;
        this.modalContainer = container;
        // console.log(this.modalContainer);
        // eslint-disable-next-line no-new
        new KeyboardAwareModal(this.modalContainer);

        // Read configuration: initial step and reset behavior
        this.initialStep = container.dataset.modalInitialStep ? parseInt(container.dataset.modalInitialStep, 10) : 1;
        this.stepReset = container.dataset.modalStepReset === 'true';

        // Apply initial step immediately
        this.currentStep = this.initialStep;
        this.showStep(this.currentStep);

        // Check if modal is initially opened and handle embed iframe
        const isInitiallyOpened = container.classList.contains(this.activeClass) || container.classList.contains(this.showClass);
        if (isInitiallyOpened) {
          // Handle dynamic embed iframe creation for initially opened modals
          this.handleEmbedIframe();

          // Handle iframe loading for mobile paint/compositing bug fix
          this.handleIframeLoading();
        }

        // Register modal API and setup toggle/close buttons
        const api = this.createGlobalInstance();
        // eslint-disable-next-line no-underscore-dangle
        container._modal = api;
        MOBModal.instances[target] = api;
        if (!this.modalToggle.hasAttribute('data-modal-lazy')) {
          this.modalToggle.addEventListener('click', e => this.open(e));

          // Prefetch embed iframe on hover for faster open
          if (this.modalContainer.dataset.modalEmbed) {
            this.modalToggle.addEventListener('mouseenter', () => this.prefetchEmbed(), {
              once: true
            });
          }
        }
        container.querySelectorAll(this.modalClose).forEach(btn => btn.addEventListener('click', e => this.close(e)));

        // Mark as initialized
        // eslint-disable-next-line no-underscore-dangle
        this.modalToggle._modalLoaded = true;
      }

      /**
       * Opens the modal, handles stacking, and focuses the first focusable element.
       * @param {Event} [e] - The triggering event
       */
      open(e) {
        if (e) e.preventDefault();

        // Ensure currentStep is set
        if (this.currentStep === null) {
          this.currentStep = this.initialStep || 1;
        }

        // Push any already-open modal onto the stack
        const openModal = document.querySelector(`.${this.modalClass}.${this.activeClass}`);
        if (openModal && openModal.id !== this.modalContainer.id) {
          MOBModal.modalStack.push(openModal.id);
        }

        // Hide all modals and show this one
        Array.from(document.querySelectorAll(`.${this.modalClass}`)).forEach(modal => {
          if (modal === this.modalContainer) {
            modal.classList.add(this.showClass);
            modal.setAttribute('aria-hidden', 'false');
            modal.setAttribute('aria-modal', 'true');
            setTimeout(() => modal.classList.add(this.activeClass), 50);
          } else {
            modal.classList.remove(this.showClass, this.activeClass);
            modal.setAttribute('aria-hidden', 'true');
            modal.removeAttribute('aria-modal');
          }
        });
        if (this.isMobile()) this.scrollLock?.lock();

        // Lock body scroll
        this.body.classList.add(this.bodyHiddenClass);
        if (this.bodyOpenedClass) this.body.classList.add(this.bodyOpenedClass);

        // Show the configured step
        this.showStep(this.currentStep);

        // Handle dynamic embed iframe creation
        this.handleEmbedIframe();

        // Handle iframe lazy loading for mobile paint/compositing bug fix
        this.handleIframeLoading();

        // Focus the designated element if present
        const focusEl = this.modalContainer.querySelector(this.modalFocusElement);
        if (focusEl) setTimeout(() => focusEl.focus(), 300);

        // Initialize Select2 if available
        // eslint-disable-next-line no-undef
        if (typeof initSelect2 !== 'undefined') setTimeout(() => initSelect2(), 10);
      }

      /**
       * Closes the modal, restores body scroll, and reopens any stacked modal.
       * @param {Event} [e] - The triggering event
       */
      close(e) {
        // Prevent default for anchor closes
        if (e?.currentTarget.tagName === 'A' && e.currentTarget.href === '#') e.preventDefault();

        // Clean up embed iframe if exists
        this.cleanupEmbedIframe();

        // Remove active state
        this.modalContainer.classList.remove(this.activeClass);
        this.modalContainer.setAttribute('aria-hidden', 'true');
        this.modalContainer.removeAttribute('aria-modal');
        setTimeout(() => {
          // After animation, hide completely
          this.modalContainer.classList.remove(this.showClass);

          // Reopen previous modal or unlock body
          const prevId = MOBModal.modalStack.pop();
          if (prevId) {
            MOBModal.instances[prevId]?.show();
          } else {
            this.scrollLock?.unlock();
            this.body.classList.remove(this.bodyHiddenClass);
            if (this.bodyOpenedClass) this.body.classList.remove(this.bodyOpenedClass);
          }

          // Reset step state if configured
          if (this.stepReset) {
            this.currentStep = null;
          }
        }, 400);
      }

      /**
       * Programmatically set the current step to display.
       * @param {number} step - The step number to show
       */
      setStep(step) {
        this.currentStep = step;
        this.showStep(step);
      }

      /**
       * Internal: toggles visibility of step elements
       * @param {number} step
       */
      showStep(step) {
        const allSteps = this.modalContainer.querySelectorAll('[data-modal-step]');
        allSteps.forEach(el => el.classList.add('d-none'));
        const target = this.modalContainer.querySelector(`[data-modal-step="${step}"]`);
        if (target) target.classList.remove('d-none');
      }

      /**
       * Prefetches embed iframe on hover so it's ready when the modal opens
       */
      prefetchEmbed() {
        // eslint-disable-next-line no-underscore-dangle
        if (this.modalContainer._embedInitialized) return;
        const embedUrl = this.modalContainer.dataset.modalEmbed;
        if (!embedUrl) return;
        const modalContent = this.modalContainer.querySelector('.modal__content');
        if (!modalContent) return;

        // Create hidden iframe and start loading
        let iframe = modalContent.querySelector('iframe[data-modal-iframe]');
        if (!iframe) {
          iframe = document.createElement('iframe');
          iframe.setAttribute('data-modal-iframe', '');
          iframe.className = 'modal__embed';
          iframe.allow = 'clipboard-read; clipboard-write';
          iframe.style.display = 'none';
          modalContent.appendChild(iframe);
        }
        if (!iframe.src || iframe.src === 'about:blank') {
          // eslint-disable-next-line no-underscore-dangle
          this.modalContainer._prefetchLoaded = false;
          iframe.addEventListener('load', () => {
            // eslint-disable-next-line no-underscore-dangle
            this.modalContainer._prefetchLoaded = true;
          }, {
            once: true
          });
          iframe.src = embedUrl;
        }
      }

      /**
       * Handles dynamic embed iframe creation based on data-modal-embed attribute
       */
      handleEmbedIframe() {
        const embedUrl = this.modalContainer.dataset.modalEmbed;
        if (!embedUrl) return;

        // Already loaded before — ensure loader is hidden and iframe visible
        // eslint-disable-next-line no-underscore-dangle
        if (this.modalContainer._embedInitialized) {
          const loader = this.modalContainer.querySelector('[data-modal-loader]');
          if (loader) loader.classList.remove('is-active');
          const iframe = this.modalContainer.querySelector('iframe[data-modal-iframe]');
          if (iframe) iframe.style.display = 'block';
          return;
        }
        const modalContent = this.modalContainer.querySelector('.modal__content');
        const loader = this.modalContainer.querySelector('[data-modal-loader]');
        if (!modalContent) return;

        // Check if iframe already exists (may have been created by prefetch)
        let iframe = modalContent.querySelector('iframe[data-modal-iframe]');
        if (!iframe) {
          iframe = document.createElement('iframe');
          iframe.setAttribute('data-modal-iframe', '');
          iframe.className = 'modal__embed';
          iframe.allow = 'clipboard-read; clipboard-write';
          iframe.style.display = 'none';
          modalContent.appendChild(iframe);
        }
        const onLoaded = () => {
          setTimeout(() => {
            iframe.style.display = 'block';
            // eslint-disable-next-line no-underscore-dangle
            this.modalContainer._embedInitialized = true;
            this.forceRepaint();
            this.fixModalDimensions();
            if (loader) {
              loader.classList.remove('is-active');
            }
          }, 10);
        };

        // If prefetch already finished loading, show immediately without loader
        // eslint-disable-next-line no-underscore-dangle
        if (this.modalContainer._prefetchLoaded) {
          onLoaded();
          return;
        }

        // Show loader while loading
        if (loader) {
          loader.classList.add('is-active');
        }
        iframe.addEventListener('load', onLoaded, {
          once: true
        });
        iframe.addEventListener('error', () => {
          if (loader) {
            loader.classList.remove('is-active');
          }
          console.error('Failed to load embed iframe:', embedUrl);
        }, {
          once: true
        });

        // Start loading if not already started by prefetch
        if (!iframe.src || iframe.src === 'about:blank') {
          iframe.src = embedUrl;
        }
      }

      /**
       * Cleans up embed iframe when modal is closed
       */
      cleanupEmbedIframe() {
        const embedUrl = this.modalContainer.dataset.modalEmbed;
        // eslint-disable-next-line no-useless-return
        if (!embedUrl) return;

        // For embed iframes, do nothing - keep them visible and loaded
        // The iframe stays permanently visible once loaded
      }

      /**
       * Handles iframe loading and fixes mobile paint/compositing issues
       */
      handleIframeLoading() {
        const iframes = this.modalContainer.querySelectorAll('iframe[data-modal-iframe]');
        iframes.forEach(iframe => {
          // Only handle iframes that are already loaded or loading
          if (iframe.src && iframe.src !== '' && iframe.src !== 'about:blank') {
            // Additional load event for extra safety
            iframe.addEventListener('load', () => {
              setTimeout(() => {
                this.forceRepaint();
                this.fixModalDimensions();
              }, 100);
            });

            // Fallback: if iframe is already loaded when modal opens
            if (iframe.contentWindow) {
              setTimeout(() => {
                this.forceRepaint();
                this.fixModalDimensions();
              }, 200);
            }
          }
        });
      }

      /**
       * Forces repaint to fix mobile rendering issues
       */
      forceRepaint() {
        if (this.isMobile()) {
          // Method 1: Force reflow by accessing offsetHeight
          // eslint-disable-next-line no-unused-expressions
          this.modalContainer.offsetHeight;

          // Method 2: Temporary style change to trigger repaint
          const originalTransform = this.modalContainer.style.transform;
          this.modalContainer.style.transform = 'translateZ(0)';

          // Force another reflow
          // eslint-disable-next-line no-unused-expressions
          this.modalContainer.offsetHeight;

          // Restore original transform after a brief delay
          setTimeout(() => {
            this.modalContainer.style.transform = originalTransform;
          }, 50);
        }
      }

      /**
       * Fixes modal dimensions after iframe load
       */
      fixModalDimensions() {
        if (this.isMobile()) {
          // Trigger a resize event to ensure proper modal sizing
          window.dispatchEvent(new Event('resize'));

          // Force modal container to recalculate its dimensions
          const modalContent = this.modalContainer.querySelector('.modal__content');
          if (modalContent) {
            const originalHeight = modalContent.style.height;
            modalContent.style.height = 'auto';

            // Force reflow
            // eslint-disable-next-line no-unused-expressions
            modalContent.offsetHeight;
            modalContent.style.height = originalHeight;
          }
        }
      }

      /**
       * Returns the public API for external control of this modal.
       */
      createGlobalInstance() {
        return {
          show: () => this.open(),
          hide: () => this.close(),
          setStep: step => this.setStep(step)
        };
      }

      /**
       * isMobile
       */
      // eslint-disable-next-line class-methods-use-this
      isMobile() {
        return window.matchMedia('(max-width: 992px)').matches;
      }
    }

    /**
     * MOB Tab
     * @author Mert Osman Başol
     * @email mert.basol@magicport.ai
     */
    class MOBTab {
      /**
       * Constructor
       * @param tab
       * @param tabOptions
       */
      constructor(tab, tabOptions = {}) {
        this.tab = tab;
        this.toggle = tabOptions.toggle;
        this.item = tabOptions.item;
        this.buttonWrapper = this.tab.querySelector('[data-tab-buttons]');
        this.wrapper = this.tab.querySelector('[data-tab-content]');
        this.toggles = Array.from(this.tab.querySelectorAll(this.toggle));
        this.items = Array.from(this.tab.querySelectorAll(this.item));
        this.hash = tabOptions.hash;
        this.buttonActiveClass = 'is-active';
        this.buttonScroll = this.tab.querySelector('[data-tab-buttons]')?.getAttribute('data-tab-buttons-scroll') === 'true';
        this.scroll = tab.dataset.tabScroll;
        this.inModal = tab?.closest('.modal');
        this.triggers = document?.querySelectorAll('[data-tab-trigger]');

        // Autoplay
        this.autoplayDuration = parseInt(tab.dataset.tabAutoplay, 10) || 0;
        this.autoplayTimer = null;
      }

      /**
       * Init
       */
      init() {
        if (!this.toggle || !this.item) {
          console.warn('Please tab toggles or tab items check!');
          return;
        }
        if (this.wrapper) {
          this.items = this.items.filter(item => {
            return item.parentNode === this.wrapper;
          });
        }
        if (this.buttonWrapper) {
          this.toggles = this.toggles.filter(item => {
            return item.parentNode === this.buttonWrapper || item.parentNode.parentNode === this.buttonWrapper;
          });
        }

        // Button Event
        if (this.toggles) {
          this.toggles.forEach(button => {
            button.addEventListener('click', e => this.setTab(e));
            if (button.classList.contains(this.buttonActiveClass)) {
              const target = button.dataset?.target || button.getAttribute('href');
              if (!target) return;
              const id = target?.replace('#', '');
              this.items.map(
              // eslint-disable-next-line no-return-assign,no-param-reassign
              item => item.style.display = item.getAttribute('id') === id ? item.classList.contains('flex-column') ? 'flex' : 'block' : 'none');
            }
          });
        }

        // Autoplay
        if (this.autoplayDuration > 0) {
          this.tab.classList.add('is-tab-autoplay');
          this.startAutoplay();
        }

        // Location Hash
        if (this.hash) {
          if (window.location.hash) {
            const {
              hash
            } = window.location;
            const target = hash.replace('#', '');
            const activeItem = document.getElementById(target);
            const activeToggle = document.querySelector(`[data-tab-button][href='${hash}']`);
            if (activeItem) {
              // eslint-disable-next-line no-param-reassign,no-return-assign
              this.items.map(item => item.style.display = item === activeItem ? 'block' : 'none');
              this.toggles.map(toggle => toggle === activeToggle ? toggle.classList.add(this.buttonActiveClass) : toggle.classList.remove(this.buttonActiveClass));

              // Scrolling active item centered for mobile
              if (this.isMobile() || this.buttonScroll) {
                scrollIntoView(activeToggle, {
                  inline: 'center',
                  block: 'nearest'
                });
              }
            }
          }
        }

        // Triggers
        this.initTriggers();
      }
      initTriggers() {
        if (!this.triggers || this.triggers?.length === 0) return;
        const header = document?.querySelector('.layout__header');
        this.triggers.forEach(trigger => {
          trigger.addEventListener('click', e => {
            const target = e.currentTarget.dataset.tabTrigger;
            if (!target) return;
            const targetButton = this.buttonWrapper.querySelector(`[data-target='${target}'], [href='${target}']`);
            if (targetButton) {
              targetButton.click();
              window.scrollTo(0, 0);
              if (header.classList.contains('is-hide')) {
                header.classList.remove('is-hide');
              }
            }
          });
        });
      }

      /**
       * activeteTab
       * @param targetId
       * @param clickedElement
       */
      activateTab(targetId, clickedElement = null, shouldScroll = true) {
        this.items.map(
        // eslint-disable-next-line no-param-reassign
        item => item.style.display = item.getAttribute('id') === targetId ? 'block' : 'none');
        this.toggles.map(toggle => {
          if (toggle === clickedElement) {
            toggle.classList.add(this.buttonActiveClass);
          } else {
            toggle.classList.remove(this.buttonActiveClass);
            toggle.classList.remove('is-autoplay-active');
            toggle.style.removeProperty('--tab-autoplay-duration');
          }
        });
        if ((this.isMobile() && clickedElement || this.buttonScroll) && this.buttonWrapper) {
          const wrapperRect = this.buttonWrapper.getBoundingClientRect();
          const elementRect = clickedElement.getBoundingClientRect();
          const scrollLeft = this.buttonWrapper.scrollLeft + (elementRect.left - wrapperRect.left) - wrapperRect.width / 2 + elementRect.width / 2;
          this.buttonWrapper.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
          });
        }
        if (shouldScroll && this.buttonWrapper && this.scroll !== 'false' && !this.inModal) {
          scrollIntoView(this.buttonWrapper, {
            behavior: 'smooth',
            block: 'start'
          });
        }
        const activeTab = document.getElementById(targetId);
        if (activeTab && activeTab?.querySelector('[data-magicmap]') && typeof window?.MagicMap !== 'undefined') {
          // eslint-disable-next-line no-undef
          const instance = window.MagicMap.getInstanceFromElement(activeTab.querySelector('[data-magicmap]'));
          if (instance) {
            setTimeout(() => {
              // eslint-disable-next-line no-underscore-dangle
              instance?._fitBoundsToMarkers();
            }, 0);
          }
        }
        if (activeTab && activeTab?.querySelector('[data-leaflet-map]')) {
          // Örneğin, harita örneğini globalde window.leafletMap olarak saklıyorsan:
          if (window.leafletMap && typeof window.leafletMap.invalidateSize === 'function') {
            window.leafletMap.invalidateSize();
          }
        }

        // Auto calculate height parent accordion
        const accordionWrapper = activeTab?.closest('[data-accordion-item].is-opened');
        if (accordionWrapper) {
          const content = accordionWrapper?.querySelector('[data-accordion-content]');
          if (content) {
            content.style.maxHeight = `${content.scrollHeight}px`;
          }
        }
      }

      /**
       * updateTabVisibility
       * @param targetId
       */
      // eslint-disable-next-line class-methods-use-this
      updateTabVisibility(targetId) {
        const tab = document.getElementById(targetId);
        if (!tab) return;
        const items = tab?.closest('[data-tab]')?.querySelectorAll('[data-tab-visibility-show]');
        items?.forEach(element => {
          const showIds = element.dataset.tabVisibilityShow?.split(',') || [];
          if (showIds.includes(`#${targetId}`)) {
            element.classList.remove('d-none');
            element.classList.add('d-flex');
          } else {
            element.classList.remove('d-flex');
            element.classList.add('d-none');
          }
        });
      }

      /**
       * setTab
       * @param e
       */
      setTab(e) {
        const target = e.currentTarget.dataset?.target || e.currentTarget.getAttribute('href');
        if (!target) return;
        const id = target.replace('#', '');
        if (document.getElementById(id)) {
          e.preventDefault();

          // eslint-disable-next-line no-restricted-globals
          if (this.hash) history.pushState({}, '', target);
          this.updateTabVisibility(id);
          this.activateTab(id, e.currentTarget);
          this.resetAutoplay();
        } else {
          console.warn(`The target ('${id}') tab element was not found.`);
        }
      }

      /**
       * Start autoplay timer
       */
      startAutoplay() {
        this.stopAutoplay();
        this.setAutoplayProgress();
        this.autoplayTimer = setInterval(() => {
          this.nextTab();
        }, this.autoplayDuration);
      }

      /**
       * Stop autoplay timer
       */
      stopAutoplay() {
        if (this.autoplayTimer) {
          clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }

      /**
       * Reset autoplay (on manual click)
       */
      resetAutoplay() {
        if (this.autoplayDuration > 0) {
          this.startAutoplay();
        }
      }

      /**
       * Set CSS variables for autoplay progress on active toggle
       */
      setAutoplayProgress() {
        this.toggles.forEach(toggle => {
          toggle.style.removeProperty('--tab-autoplay-duration');
          toggle.style.removeProperty('--tab-autoplay-width');
          toggle.classList.remove('is-autoplay-active');
        });
        const activeToggle = this.toggles.find(t => t.classList.contains(this.buttonActiveClass));
        if (activeToggle) {
          // Start at 0%, force reflow, then transition to 100%
          activeToggle.style.setProperty('--tab-autoplay-width', '0%');
          activeToggle.style.setProperty('--tab-autoplay-duration', '0ms');
          activeToggle.classList.add('is-autoplay-active');

          // eslint-disable-next-line no-void
          void activeToggle.offsetWidth;
          activeToggle.style.setProperty('--tab-autoplay-duration', `${this.autoplayDuration}ms`);
          activeToggle.style.setProperty('--tab-autoplay-width', '100%');
        }
      }

      /**
       * Go to next tab
       */
      nextTab() {
        const currentIndex = this.toggles.findIndex(t => t.classList.contains(this.buttonActiveClass));
        const nextIndex = (currentIndex + 1) % this.toggles.length;
        const nextToggle = this.toggles[nextIndex];
        const target = nextToggle.dataset?.target || nextToggle.getAttribute('href');
        if (!target) return;
        const id = target.replace('#', '');
        this.updateTabVisibility(id);
        this.activateTab(id, nextToggle, false);
        this.setAutoplayProgress();
      }

      /**
       * is Mobile
       */
      // eslint-disable-next-line class-methods-use-this
      isMobile() {
        return window.matchMedia('(max-width: 991px)').matches;
      }
    }

    /**
     * MOB Accordion
     * @author Mert Osman Başol
     * @email mert.basol@magicport.ai
     */

    class MOBAccordion {
      constructor(accordion) {
        this.accordion = accordion;
        this.accordionItems = accordion.querySelectorAll('[data-accordion-item]');
        this.accordionToggle = '[data-accordion-toggle]';
        this.accordionClose = '[data-accordion-close]';
        this.accordionContent = '[data-accordion-content]';
        this.activeClass = 'is-active';
        this.openedClass = 'is-opened';
        this.animateClass = 'is-animate';
        this.closeOther = accordion.dataset.accordionCloseOthers === 'true';
        this.isOpened = false;
        this.scrollLock = accordion.dataset.accordionScrollLock === 'true';
        this.triggerUpdateInputs = accordion?.querySelectorAll('select[multiple]');
        // Track bound listeners so they can be removed on destroy().
        this.listeners = [];
        this.initialized = false;
      }

      /**
       * Bind a listener and keep a reference for destroy()
       * @param el
       * @param type
       * @param fn
       */
      bind(el, type, fn) {
        el.addEventListener(type, fn);
        this.listeners.push({
          el,
          type,
          fn
        });
      }

      /**
       * Update aria-expanded on an item's toggle (only if the attribute is present)
       * @param item
       * @param expanded
       */
      // eslint-disable-next-line class-methods-use-this
      setExpanded(item, expanded) {
        const toggle = item.querySelector('[data-accordion-toggle]');
        if (toggle && toggle.hasAttribute('aria-expanded')) {
          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        }
      }

      /**
       * Init
       */
      init() {
        if (this.accordion.dataset.accordion === 'mobile' && !this.isMobile()) return;
        if (this.accordion.dataset.accordion === 'mobile-sm' && !this.isMobileSm()) return;
        if (this.initialized) return;
        this.initialized = true;
        Array.from(this.accordionItems).forEach(item => {
          const toggle = item.querySelector(this.accordionToggle);
          if (toggle) this.bind(toggle, 'click', e => this.toggle(e));
          const closeButtons = item.querySelectorAll(this.accordionClose);
          [...closeButtons].forEach(button => this.bind(button, 'click', e => this.close(e)));
          if (item.classList.contains(this.activeClass)) {
            this.isOpened = true;
            this.setExpanded(item, true);
            setTimeout(() => {
              const content = item.querySelector(this.accordionContent);
              if (content) content.style.maxHeight = `${content.scrollHeight}px`;
              item.classList.remove(this.activeClass);
              item.classList.add(this.openedClass);
            }, 200);
            setTimeout(() => {
              item.classList.add(this.animateClass);
            }, 500);
          } else {
            this.setExpanded(item, false);
            item.classList.add(this.animateClass);
          }
        });

        // Trigger select2 height bug
        if (typeof jQuery !== 'undefined') {
          [...this.triggerUpdateInputs].forEach(input => $(input).on('change', e => {
            this.open(e);
          }));
        }
      }

      /**
       * Toggle
       * @param e
       */
      toggle(e) {
        // inline link
        // eslint-disable-next-line no-script-url
        if (e.currentTarget.tagName === 'A' && !e.currentTarget?.href?.startsWith('javascript:void')) {
          const parent = e.currentTarget.closest('[data-accordion-item]');
          if (parent.classList.contains(this.openedClass)) {
            return;
          }
        }
        if (e.currentTarget.tagName === 'A') e.preventDefault();
        if (this.closeOther) {
          // eslint-disable-next-line no-return-assign
          Array.from(this.accordionItems).map(item => item.classList.contains(this.openedClass) && e.currentTarget.closest('[data-accordion-item]') !== item ? this.isOpened = false : null);
        } else {
          const parent = e.currentTarget.closest('[data-accordion-item]');
          if (parent) this.isOpened = parent.classList.contains(this.openedClass);
        }
        if (this.isOpened) {
          this.close(e);
        } else {
          this.open(e);
        }
        if (this.scrollLock && window.matchMedia('(max-width: 991px)').matches) {
          // console.log(this.scrollLock);
          this.accordion.classList.toggle('is-hidden', this.isOpened);
        }
      }

      /**
       * Open
       * @param e
       */
      open(e) {
        const parent = e.currentTarget.closest('[data-accordion-item]');
        // console.log('selamlar');
        if (parent) {
          this.isOpened = true;
          if (this.closeOther) {
            // eslint-disable-next-line array-callback-return
            Array.from(this.accordionItems).map(item => {
              item.classList.toggle(this.openedClass, item === parent);
              this.setExpanded(item, item === parent);
              const content = item.querySelector(this.accordionContent);
              if (content) content.style.maxHeight = item === parent ? `${content.scrollHeight}px` : null;
            });
          } else {
            parent.classList.add(this.openedClass);
            this.setExpanded(parent, true);
            const content = parent.querySelector(this.accordionContent);
            if (content) {
              content.style.maxHeight = `${content.scrollHeight}px`;
              if (content?.closest('.modal') && window.matchMedia('(max-width: 991px)').matches) {
                content.closest('.modal').classList.add('modal--free');
              }
            }
          }
        }
      }

      /**
       * Close
       * @param e
       */
      close(e) {
        const parent = e.currentTarget.closest('[data-accordion-item]');
        if (parent) {
          this.isOpened = false;
          if (this.closeOther) {
            // eslint-disable-next-line array-callback-return
            Array.from(this.accordionItems).map(item => {
              item.classList.remove(this.openedClass);
              this.setExpanded(item, false);
              const content = item.querySelector(this.accordionContent);
              if (content) {
                content.style.overflow = null;
                content.style.maxHeight = null;
              }
            });
          } else {
            parent.classList.remove(this.openedClass);
            this.setExpanded(parent, false);
            const content = parent.querySelector(this.accordionContent);
            if (content) {
              content.style.overflow = null;
              content.style.maxHeight = null;
            }
            if (content.closest('.modal') && window.matchMedia('(max-width: 991px)').matches) {
              setTimeout(() => content.closest('.modal').classList.remove('modal--free'), 400);
            }
          }
        }
      }

      /**
       * isMobile
       */
      // eslint-disable-next-line class-methods-use-this
      isMobile() {
        return window.matchMedia('(max-width: 992px)').matches;
      }

      /**
       * isMobileSm
       */
      // eslint-disable-next-line class-methods-use-this
      isMobileSm() {
        return window.matchMedia('(max-width: 575px)').matches;
      }

      /**
       * Whether the accordion should be active at the current viewport.
       * Non size-gated accordions (no `data-accordion` value) are always active.
       */
      shouldBeActive() {
        const mode = this.accordion.dataset.accordion;
        if (mode === 'mobile') return this.isMobile();
        if (mode === 'mobile-sm') return this.isMobileSm();
        return true;
      }

      /**
       * Destroy — remove listeners and reset state so the element behaves
       * like a plain (CSS-driven) menu again on desktop.
       */
      destroy() {
        this.listeners.forEach(({
          el,
          type,
          fn
        }) => el.removeEventListener(type, fn));
        this.listeners = [];
        Array.from(this.accordionItems).forEach(item => {
          item.classList.remove(this.openedClass, this.activeClass, this.animateClass);
          this.setExpanded(item, false);
          const content = item.querySelector(this.accordionContent);
          if (content) {
            content.style.overflow = null;
            content.style.maxHeight = null;
          }
        });
        this.isOpened = false;
        this.initialized = false;
      }

      /**
       * updateHeight
       */
      updateHeight() {}
    }

    class Helpers {
      // Parents Node
      // same like: jQuery parents();
      // eslint-disable-next-line class-methods-use-this
      parents(node) {
        let current = node;
        let list = [];
        while (current.parentNode != null && current.parentNode !== document.documentElement) {
          list.push(current.parentNode);
          current = current.parentNode;
        }
        return list;
      }

      /**
       * is Visible
       * @param el
       * @returns {boolean}
       */
      // eslint-disable-next-line class-methods-use-this
      isVisible(el) {
        return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
      }

      /**
       * is Hidden
       * @param el
       * @returns {boolean}
       */
      // eslint-disable-next-line class-methods-use-this
      isHidden(el) {
        const style = window.getComputedStyle(el);
        return style.display === 'none' || style.visibility === 'hidden';
      }

      /**
       * checkVisible
       * @param elm
       * @returns {boolean}
       */
      // eslint-disable-next-line class-methods-use-this
      checkVisible(elm) {
        const rect = elm.getBoundingClientRect();
        const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
      }

      /**
       * scrollingProgress
       * @returns {number}
       */
      // eslint-disable-next-line class-methods-use-this
      scrollingProgress() {
        const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
        const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        return winScroll / height * 100;
      }

      /**
       * getRandomChartColor
       * @param count
       * @param opposite
       * @returns {*[]}
       */
      // eslint-disable-next-line class-methods-use-this
      getRandomChartColor(count, opposite = false) {
        const flatColors = ['#1abc9c', '#e74c3c', '#f1c40f', '#3498db', '#f39c12', '#2ecc71', '#8e44ad', '#27ae60', '#e67e22', '#a29bfe', '#ff7675', '#d35400', '#2980b9', '#16a085', '#c0392b', '#9b59b6', '#34495e', '#55efc4', '#81ecec', '#74b9ff', '#00b894', '#00cec9', '#0984e3', '#6c5ce7', '#ffeaa7', '#fab1a0', '#fd79a8', '#fdcb6e', '#e17055'];
        const colors = [];
        if (opposite) {
          for (let i = 0; i < count; i++) {
            if (i === 0) {
              colors.push('#FFFFFF'); // Beyaz için ilk değer
            } else if (i === count - 1) {
              colors.push('#808080'); // Gri için son değer
            } else {
              colors.push(flatColors[i]);
            }
          }
        } else {
          for (let i = 0; i < count; i++) {
            colors.push(flatColors[i]);
          }
        }
        return colors;
      }

      /**
       * getColor
       * @param color
       * @returns {*|boolean}
       */
      // eslint-disable-next-line class-methods-use-this
      getColor(color) {
        const colors = {
          primary: '#2bace2',
          border: '#e8e8ee',
          'neutral-100': '#f5f7f9',
          'neutral-200': '#eceff3',
          'neutral-300': '#dadee6',
          'neutral-400': '#c0c7d3',
          'neutral-500': '#959fb2',
          'neutral-600': '#636d7e',
          'neutral-700': '#394456',
          'neutral-800': '#1c2536',
          'neutral-900': '#00041a'
        };
        return colors[color] || false;
      }

      /**
       * formatNumber
       * @param num
       * @returns {string}
       */
      // eslint-disable-next-line class-methods-use-this
      formatNumber(num) {
        return num.toLocaleString();
      }

      /**
       * unFormatNumber
       * @param formattedNum
       * @returns {*}
       */
      // eslint-disable-next-line class-methods-use-this
      unformatNumber(formattedNum) {
        return formattedNum.replace(/,/g, '');
      }

      /**
       * sleep
       * @param ms
       * @returns {Promise<unknown>}
       */
      // eslint-disable-next-line class-methods-use-this
      sleep(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
      }

      /**
       * Check if JS component(s) are loaded
       * @param {Element} element - DOM element to check
       * @param {string|string[]} components - Component name(s) to check
       * @returns {boolean}
       */
      // eslint-disable-next-line class-methods-use-this
      hasJSLoaded(element, components) {
        const loadedAttr = element.getAttribute('data-js-loaded');
        if (!loadedAttr) return false;
        const loadedComponents = loadedAttr.split(',').map(comp => comp.trim());
        if (Array.isArray(components)) {
          return components.every(component => loadedComponents.includes(component));
        }
        return loadedComponents.includes(components);
      }

      /**
       * Set JS component(s) as loaded
       * @param {Element} element - DOM element to mark
       * @param {string|string[]} components - Component name(s) to mark as loaded
       */
      // eslint-disable-next-line class-methods-use-this
      setJSLoaded(element, components) {
        const existingAttr = element.getAttribute('data-js-loaded');
        let loadedComponents = existingAttr ? existingAttr.split(',').map(comp => comp.trim()) : [];
        const componentsToAdd = Array.isArray(components) ? components : [components];
        componentsToAdd.forEach(component => {
          if (!loadedComponents.includes(component)) {
            loadedComponents.push(component);
          }
        });
        element.setAttribute('data-js-loaded', loadedComponents.join(','));
      }

      /**
       * Unset JS component(s) as loaded
       * @param {Element} element - DOM element to unmark
       * @param {string|string[]} components - Component name(s) to mark as not loaded
       */
      // eslint-disable-next-line class-methods-use-this
      removeJSLoaded(element, components) {
        const existingAttr = element.getAttribute('data-js-loaded');
        if (!existingAttr) return;
        const componentsToRemove = Array.isArray(components) ? components : [components];
        const loadedComponents = existingAttr.split(',').map(comp => comp.trim()).filter(comp => comp && !componentsToRemove.includes(comp));
        if (loadedComponents.length) {
          element.setAttribute('data-js-loaded', loadedComponents.join(','));
        } else {
          element.removeAttribute('data-js-loaded');
        }
      }
    }
    const {
      checkVisible,
      isVisible,
      isHidden,
      parents,
      scrollingProgress,
      getRandomChartColor,
      getColor,
      formatNumber,
      unformatNumber,
      sleep,
      hasJSLoaded,
      setJSLoaded,
      removeJSLoaded
    } = Helpers.prototype;

    /**
     * MOB Editable Forms
     * @author Mert Osman Başol
     * @email mert.basol@magicport.ai
     */
    class MOBEditableForm {
      constructor(form) {
        this.form = form;
        this.editableItems = form?.querySelectorAll('[data-form-editable-item]');
        this.buttonsWrapper = form?.querySelector('[data-form-editable-buttons]');
        this.buttonEdit = form?.querySelector('[data-form-editable-button="edit"]');
        // eslint-disable-next-line no-underscore-dangle
        this.buttonEditTippy = this.buttonEdit ? this.buttonEdit?._tippy : null;
        this.buttonReset = form?.querySelector('[data-form-editable-button="reset"]');
        this.inputs = form?.querySelectorAll('input[disabled], textarea[disabled], select[disabled], button[disabled]');
        this.isDisabled = form?.dataset?.formEditable !== 'true';
        this.editableForms = document.querySelectorAll('[data-form-editable]');
        this.activeClass = 'is-active';
        this.inputInitivalValues = {};
        this.inputOriginalValues = {};
        this.isTouched = false;
        this.highlightClass = 'is-highlight';
        this.lazySubmit = form?.dataset?.formEditableLazySubmit === 'true';
        // this.isSubmitted = false;
        // eslint-disable-next-line no-underscore-dangle
      }

      /**
       * Init
       */
      init() {
        // First disabled init check
        if (!this.isDisabled && [...this.inputs].length > 0) {
          // eslint-disable-next-line no-param-reassign,no-return-assign
          [...this.inputs].map(i => {
            // eslint-disable-next-line no-param-reassign
            if (!i.classList.contains('is-disabled')) i.disabled = false;
            return i;
          });
          if (this.buttonsWrapper) this.buttonsWrapper.classList.remove('d-none');
        }

        // Edit button
        if (this.buttonEdit) {
          this.buttonEdit.addEventListener('click', () => this.handleEdit());
        }

        // Reset buttons
        if (this.buttonReset) {
          this.buttonReset.addEventListener('click', () => {
            this.setCurrentInputs();
            this.handleReset();
            this.handleLock();
          });
        }

        // Escape button event
        document.addEventListener('keydown', event => {
          if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
            if (!this.isDisabled && this.form) {
              this.form.dispatchEvent(new Event('submit'));
            }
          }
          if (event.key === 'Escape') {
            const isNotCombinedKey = !(event.ctrlKey || event.altKey || event.shiftKey);
            if (isNotCombinedKey && !this.isDisabled && !document.body.classList.contains('is-hidden')) {
              this.setCurrentInputs();
              this.handleReset();
              this.handleLock();
            }
          }
        });

        // Form Submit
        if (!this.lazySubmit) this.form.addEventListener('submit', () => this.handleSubmit());

        // eslint-disable-next-line no-underscore-dangle
        this.form._editableForm = this.createGlobalInstance();
      }

      /**
       * handleEdit
       */
      handleEdit() {
        if (!this.isDisabled && this.buttonReset) {
          this.buttonReset.dispatchEvent(new Event('click'));
          return;
        }
        this.isDisabled = !this.isDisabled;
        // if (this.buttonEdit) this.buttonEdit.classList.toggle('d-none', !this.isDisabled);
        if (this.buttonsWrapper) this.buttonsWrapper.classList.toggle('d-none', this.isDisabled);
        if (this.form.classList.contains('box')) this.form.classList.add('is-active');
        if (this.buttonEdit) {
          this.buttonEdit.blur();
          const icon = this.buttonEdit?.querySelector('use');
          if (icon) {
            icon.setAttribute('xlink:href', `#icon-${this.isDisabled ? 'pencil' : 'close'}`);
          }
          // eslint-disable-next-line no-underscore-dangle
          if (this.buttonEdit?._tippy)
            // eslint-disable-next-line no-underscore-dangle
            this.buttonEdit._tippy.setContent(!this.isDisabled ? 'Close' : 'Edit');
        }
        this.editableForms.forEach(f => {
          if (f !== this.form) {
            const reset = f.querySelector('[data-form-editable-button="reset"]');
            if (reset) reset.dispatchEvent(new Event('click'));
          }
        });
        if ([...this.editableItems].length > 0) {
          [...this.editableItems].map(i => i.classList.toggle(this.activeClass, !this.isDisabled));
        }
        if (!this.inputs || this.inputs.length === 0) return;
        let isFocused = false;
        [...this.inputs].map(input => {
          // eslint-disable-next-line no-param-reassign

          // eslint-disable-next-line no-param-reassign
          if (!input.classList.contains('is-disabled')) input.disabled = this.isDisabled;

          // Quill Editor
          const quillEditor = document.querySelector(`[data-editor="${input.getAttribute('id')}"]`);
          // eslint-disable-next-line no-undef
          const quill = quillEditor && typeof Quill !== 'undefined' ? Quill.find(quillEditor) : null;
          if (quill) quill.enable(!this.isDisabled);
          if (!isFocused && (isVisible(input) || input?.previousSibling?.previousSibling?.dataset.editor) && input.getAttribute('type') !== 'file' && input.tagName !== 'BUTTON' && input.tagName !== 'A' && !input.classList.contains('file__preview-item-remove') && !input.classList.contains('button') && !input.hasAttribute('data-form-editable-button')) {
            isFocused = true;
            if (input?.previousSibling?.previousSibling?.dataset.editor) {
              if (quill) quill.focus();
            } else {
              input.focus();
            }
          }

          // Select2 initial values
          if (input.tagName === 'SELECT' && typeof jQuery !== 'undefined') {
            // eslint-disable-next-line no-param-reassign,no-underscore-dangle
            input._initialOptions = input?.querySelectorAll('option');
          }
          return input;
        });
        this.inputCheckTouched();
      }

      /**
       * handleReset
       */
      handleReset() {
        if (!this.isSubmitted) {
          this.form.reset();
          // this.resetSelect2InitialValues();
        } else {
          this.resetSelect2InitialValues();
          [...this.inputs].forEach(input => {
            // eslint-disable-next-line no-param-reassign
            input.value = this.inputOriginalValues[input.id];
          });
        }
      }

      /**
       * handleLock
       */
      handleLock() {
        this.isDisabled = true;
        [...this.inputs].map(i => {
          // eslint-disable-next-line no-param-reassign
          i.disabled = true;

          // Select2
          if (typeof jQuery !== 'undefined' && i.tagName === 'SELECT') {
            $(i).trigger('change');
          }

          // Quill editor
          const quillEditor = document.querySelector(`[data-editor="${i.getAttribute('id')}"]`);
          if (quillEditor && typeof Quill !== 'undefined') {
            const preview = document.querySelector(`[data-editor-preview="${i.getAttribute('id')}"]`);

            // eslint-disable-next-line no-undef
            const quill = Quill.find(quillEditor);
            const initialContent = quill.clipboard.convert(i.value);
            if (preview) {
              preview.innerHTML = i.value;
            }
            quill.enable(false);
            quill.setContents(initialContent, 'silent');
          }
          return i;
        });
        if (this.buttonsWrapper) this.buttonsWrapper.classList.add('d-none');
        if (this.form.classList.contains('box')) this.form.classList.remove('is-active');
        if (this.buttonEdit) {
          const icon = this.buttonEdit?.querySelector('use');
          if (icon) icon.setAttribute('xlink:href', '#icon-pencil');
          // eslint-disable-next-line no-underscore-dangle
          if (this.buttonEdit?._tippy)
            // eslint-disable-next-line no-underscore-dangle
            this.buttonEdit._tippy.setContent('Edit');
        }
        if ([...this.editableItems].length > 0) {
          [...this.editableItems].map(i => i.classList.remove(this.activeClass));
        }
      }

      /**
       * isMobile
       * @returns {boolean}
       */
      // eslint-disable-next-line class-methods-use-this
      isMobile() {
        return window.matchMedia('(max-width: 768px)').matches;
      }

      /**
       * setCurrentInputs
       */
      setCurrentInputs() {
        if (!this.isDisabled) {
          this.inputs = this.form?.querySelectorAll('input, textarea, select, button:not([type="submit"]):not([data-form-editable-button="edit"]):not([data-form-editable-button="reset"]):not([data-form-editable-button="new"])');
        }
      }

      /**
       * inputCheckTouched
       */
      inputCheckTouched() {
        this.isTouched = false;
        [...this.inputs].forEach(input => {
          this.inputInitivalValues[input.id] = input.value;
          if (typeof jQuery !== 'undefined' && input.tagName === 'SELECT') {
            $(input).on('change', () => {
              this.isTouched = input.value !== this.inputInitivalValues[input.id];
            });
          } else {
            input.addEventListener('change', () => {
              this.isTouched = input.value !== this.inputInitivalValues[input.id];
            });
          }
        });
      }

      /**
       * SaveOriginalValues
       */
      saveOriginalFormValues() {
        this.setCurrentInputs();
        [...this.inputs].forEach(input => {
          this.inputOriginalValues[input.id] = input.value;
          // console.log(this.inputOriginalValues);
        });
      }

      /**
       * handleSubmit
       */
      handleSubmit() {
        this.saveOriginalFormValues();
        this.isSubmitted = true;
        this.isTouched = false;
        this.inputInitivalValues = {};
        this.handleLock();
        this.form.classList.add(this.highlightClass);
        setTimeout(() => this.form.classList.remove(this.highlightClass), 1200);
      }

      /**
       * setItems
       */
      setItems() {
        this.editableItems = this.form?.querySelectorAll('[data-form-editable-item]');
        if ([...this.editableItems].length > 0) {
          [...this.editableItems].forEach(item => {
            item.classList.toggle(this.activeClass, !this.isDisabled);

            // init modals
            const toggleModal = item.querySelector('[data-toggle="modal"]');
            if (!toggleModal) return;
            const modal = new MOBModal(toggleModal);
            modal.init();
          });
        }
      }

      /**
       * createGlobalInstance
       * @returns {{edit: edit, lock: lock, reset: reset, update(): void}}
       */
      // eslint-disable-next-line class-methods-use-this
      createGlobalInstance() {
        return {
          edit: () => {
            this.handleEdit();
          },
          lock: () => {
            this.handleLock();
          },
          reset: () => {
            this.handleReset();
          },
          update: () => {
            this.setItems();
          },
          submit: () => {
            this.handleSubmit();
          }
        };
      }

      /**
       * resetSelect2InitialValues
       */
      resetSelect2InitialValues() {
        [...this.inputs].forEach(input => {
          if (input.tagName === 'SELECT' && typeof jQuery !== 'undefined' &&
          // eslint-disable-next-line no-underscore-dangle
          input?._initialOptions &&
          // eslint-disable-next-line no-underscore-dangle,no-unsafe-optional-chaining
          [...input?._initialOptions].length > 0) {
            const select = $(input);
            select.val(null).empty().select2('destroy');
            select.removeClass('is-loaded').attr('data-placeholder', input.dataset.placeholder);
            // eslint-disable-next-line no-underscore-dangle
            [...input._initialOptions].forEach(option => {
              select.append(option);
            });
            // select.val(this.inputOriginalValues[input.id]).trigger('change');
            if (typeof initSelect2 !== 'undefined') {
              // eslint-disable-next-line no-undef
              initSelect2();
            }
          }
          return input;
        });
      }
    }

    /**
     * MOB Block Loader
     * @author Mert Osman Başol
     * @email mert.basol@magicport.ai
     */

    class MOBBLockLoader {
      constructor(loader) {
        this.loader = loader;
        this.loaderItem = null;
        this.isAppended = false;
        this.isLoadingClass = 'is-loading';
        this.init();
      }

      /**
       * Init
       */
      init() {
        this.loader.loader = this.createGlobalInstance();
      }

      /**
       * show
       */
      show() {
        if (!this.isAppended) {
          this.loader.classList.add(this.isLoadingClass);
          const div = document.createElement('div');
          div.className = 'loader is-active';
          div.innerHTML = this.getLoaderMarkup();
          this.loader.append(div);
          this.loaderItem = this.loader?.querySelector('.loader');
          this.isAppended = true;
        }
      }
      hide() {
        if (this.loaderItem) {
          this.loaderItem.remove();
          this.loader.classList.add(this.isLoadingClass);
          this.isAppended = false;
        }
      }

      /**
       * getLoaderMarkup
       */
      // eslint-disable-next-line class-methods-use-this
      getLoaderMarkup() {
        return `
      <div class="loader__wrapper">
        <div class="loader__item"></div>
      </div>
    `;
      }

      /**
       * createGlobalInstance
       * @returns {{show: show, close: MOBModal.close}}
       */
      // eslint-disable-next-line class-methods-use-this
      createGlobalInstance() {
        return {
          show: () => {
            this.show();
          },
          hide: () => {
            this.hide();
          }
        };
      }
    }

    /**
     * SSR Window 5.0.1
     * Better handling for window object in SSR environment
     * https://github.com/nolimits4web/ssr-window
     *
     * Copyright 2025, Vladimir Kharlampidi
     *
     * Licensed under MIT
     *
     * Released on: June 27, 2025
     */
    /* eslint-disable no-param-reassign */
    function isObject$1(obj) {
      return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
    }
    function extend$1(target = {}, src = {}) {
      const noExtend = ['__proto__', 'constructor', 'prototype'];
      Object.keys(src).filter(key => noExtend.indexOf(key) < 0).forEach(key => {
        if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject$1(src[key]) && isObject$1(target[key]) && Object.keys(src[key]).length > 0) {
          extend$1(target[key], src[key]);
        }
      });
    }
    const ssrDocument = {
      body: {},
      addEventListener() {},
      removeEventListener() {},
      activeElement: {
        blur() {},
        nodeName: ''
      },
      querySelector() {
        return null;
      },
      querySelectorAll() {
        return [];
      },
      getElementById() {
        return null;
      },
      createEvent() {
        return {
          initEvent() {}
        };
      },
      createElement() {
        return {
          children: [],
          childNodes: [],
          style: {},
          setAttribute() {},
          getElementsByTagName() {
            return [];
          }
        };
      },
      createElementNS() {
        return {};
      },
      importNode() {
        return null;
      },
      location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
      }
    };
    function getDocument() {
      const doc = typeof document !== 'undefined' ? document : {};
      extend$1(doc, ssrDocument);
      return doc;
    }
    const ssrWindow = {
      document: ssrDocument,
      navigator: {
        userAgent: ''
      },
      location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
      },
      history: {
        replaceState() {},
        pushState() {},
        go() {},
        back() {}
      },
      CustomEvent: function CustomEvent() {
        return this;
      },
      addEventListener() {},
      removeEventListener() {},
      getComputedStyle() {
        return {
          getPropertyValue() {
            return '';
          }
        };
      },
      Image() {},
      Date() {},
      screen: {},
      setTimeout() {},
      clearTimeout() {},
      matchMedia() {
        return {};
      },
      requestAnimationFrame(callback) {
        if (typeof setTimeout === 'undefined') {
          callback();
          return null;
        }
        return setTimeout(callback, 0);
      },
      cancelAnimationFrame(id) {
        if (typeof setTimeout === 'undefined') {
          return;
        }
        clearTimeout(id);
      }
    };
    function getWindow() {
      const win = typeof window !== 'undefined' ? window : {};
      extend$1(win, ssrWindow);
      return win;
    }

    function classesToTokens(classes = '') {
      return classes.trim().split(' ').filter(c => !!c.trim());
    }
    function deleteProps(obj) {
      const object = obj;
      Object.keys(object).forEach(key => {
        try {
          object[key] = null;
        } catch (e) {
          // no getter for object
        }
        try {
          delete object[key];
        } catch (e) {
          // something got wrong
        }
      });
    }
    function nextTick(callback, delay = 0) {
      return setTimeout(callback, delay);
    }
    function now() {
      return Date.now();
    }
    function getComputedStyle$1(el) {
      const window = getWindow();
      let style;
      if (window.getComputedStyle) {
        style = window.getComputedStyle(el, null);
      }
      if (!style && el.currentStyle) {
        style = el.currentStyle;
      }
      if (!style) {
        style = el.style;
      }
      return style;
    }
    function getTranslate(el, axis = 'x') {
      const window = getWindow();
      let matrix;
      let curTransform;
      let transformMatrix;
      const curStyle = getComputedStyle$1(el);
      if (window.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) {
          curTransform = curTransform.split(', ').map(a => a.replace(',', '.')).join(', ');
        }
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
      } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
      }
      if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
      }
      if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
      }
      return curTransform || 0;
    }
    function isObject(o) {
      return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
    }
    function isNode(node) {
      // eslint-disable-next-line
      if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
        return node instanceof HTMLElement;
      }
      return node && (node.nodeType === 1 || node.nodeType === 11);
    }
    function extend(...args) {
      const to = Object(args[0]);
      for (let i = 1; i < args.length; i += 1) {
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
          const keysArray = Object.keys(Object(nextSource)).filter(key => key !== '__proto__' && key !== 'constructor' && key !== 'prototype');
          for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
            const nextKey = keysArray[nextIndex];
            const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) {
              if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
                if (nextSource[nextKey].__swiper__) {
                  to[nextKey] = nextSource[nextKey];
                } else {
                  extend(to[nextKey], nextSource[nextKey]);
                }
              } else if (!isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
                to[nextKey] = {};
                if (nextSource[nextKey].__swiper__) {
                  to[nextKey] = nextSource[nextKey];
                } else {
                  extend(to[nextKey], nextSource[nextKey]);
                }
              } else {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
      }
      return to;
    }
    function setCSSProperty(el, varName, varValue) {
      el.style.setProperty(varName, varValue);
    }
    function animateCSSModeScroll({
      swiper,
      targetPosition,
      side
    }) {
      const window = getWindow();
      const startPosition = -swiper.translate;
      let startTime = null;
      let time;
      const duration = swiper.params.speed;
      swiper.wrapperEl.style.scrollSnapType = 'none';
      window.cancelAnimationFrame(swiper.cssModeFrameID);
      const dir = targetPosition > startPosition ? 'next' : 'prev';
      const isOutOfBound = (current, target) => {
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
      };
      const animate = () => {
        time = new Date().getTime();
        if (startTime === null) {
          startTime = time;
        }
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) {
          currentPosition = targetPosition;
        }
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
          swiper.wrapperEl.style.overflow = 'hidden';
          swiper.wrapperEl.style.scrollSnapType = '';
          setTimeout(() => {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.scrollTo({
              [side]: currentPosition
            });
          });
          window.cancelAnimationFrame(swiper.cssModeFrameID);
          return;
        }
        swiper.cssModeFrameID = window.requestAnimationFrame(animate);
      };
      animate();
    }
    function getSlideTransformEl(slideEl) {
      return slideEl.querySelector('.swiper-slide-transform') || slideEl.shadowRoot && slideEl.shadowRoot.querySelector('.swiper-slide-transform') || slideEl;
    }
    function elementChildren(element, selector = '') {
      const window = getWindow();
      const children = [...element.children];
      if (window.HTMLSlotElement && element instanceof HTMLSlotElement) {
        children.push(...element.assignedElements());
      }
      if (!selector) {
        return children;
      }
      return children.filter(el => el.matches(selector));
    }
    function elementIsChildOfSlot(el, slot) {
      // Breadth-first search through all parent's children and assigned elements
      const elementsQueue = [slot];
      while (elementsQueue.length > 0) {
        const elementToCheck = elementsQueue.shift();
        if (el === elementToCheck) {
          return true;
        }
        elementsQueue.push(...elementToCheck.children, ...(elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : []), ...(elementToCheck.assignedElements ? elementToCheck.assignedElements() : []));
      }
    }
    function elementIsChildOf(el, parent) {
      const window = getWindow();
      let isChild = parent.contains(el);
      if (!isChild && window.HTMLSlotElement && parent instanceof HTMLSlotElement) {
        const children = [...parent.assignedElements()];
        isChild = children.includes(el);
        if (!isChild) {
          isChild = elementIsChildOfSlot(el, parent);
        }
      }
      return isChild;
    }
    function showWarning(text) {
      try {
        console.warn(text);
        return;
      } catch (err) {
        // err
      }
    }
    function createElement(tag, classes = []) {
      const el = document.createElement(tag);
      el.classList.add(...(Array.isArray(classes) ? classes : classesToTokens(classes)));
      return el;
    }
    function elementPrevAll(el, selector) {
      const prevEls = [];
      while (el.previousElementSibling) {
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
          if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
      }
      return prevEls;
    }
    function elementNextAll(el, selector) {
      const nextEls = [];
      while (el.nextElementSibling) {
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
          if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
      }
      return nextEls;
    }
    function elementStyle(el, prop) {
      const window = getWindow();
      return window.getComputedStyle(el, null).getPropertyValue(prop);
    }
    function elementIndex(el) {
      let child = el;
      let i;
      if (child) {
        i = 0;
        // eslint-disable-next-line
        while ((child = child.previousSibling) !== null) {
          if (child.nodeType === 1) i += 1;
        }
        return i;
      }
      return undefined;
    }
    function elementParents(el, selector) {
      const parents = []; // eslint-disable-line
      let parent = el.parentElement; // eslint-disable-line
      while (parent) {
        if (selector) {
          if (parent.matches(selector)) parents.push(parent);
        } else {
          parents.push(parent);
        }
        parent = parent.parentElement;
      }
      return parents;
    }
    function elementTransitionEnd(el, callback) {
      function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener('transitionend', fireCallBack);
      }
      if (callback) {
        el.addEventListener('transitionend', fireCallBack);
      }
    }
    function elementOuterSize(el, size, includeMargins) {
      const window = getWindow();
      if (includeMargins) {
        return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
      }
      return el.offsetWidth;
    }
    function makeElementsArray(el) {
      return (Array.isArray(el) ? el : [el]).filter(e => !!e);
    }
    function setInnerHTML(el, html = '') {
      if (typeof trustedTypes !== 'undefined') {
        el.innerHTML = trustedTypes.createPolicy('html', {
          createHTML: s => s
        }).createHTML(html);
      } else {
        el.innerHTML = html;
      }
    }

    let support;
    function calcSupport() {
      const window = getWindow();
      const document = getDocument();
      return {
        smoothScroll: document.documentElement && document.documentElement.style && 'scrollBehavior' in document.documentElement.style,
        touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch)
      };
    }
    function getSupport() {
      if (!support) {
        support = calcSupport();
      }
      return support;
    }
    let deviceCached;
    function calcDevice({
      userAgent
    } = {}) {
      const support = getSupport();
      const window = getWindow();
      const platform = window.navigator.platform;
      const ua = userAgent || window.navigator.userAgent;
      const device = {
        ios: false,
        android: false
      };
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;
      const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
      let ipad = ua.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
      const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
      const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
      const windows = platform === 'Win32';
      let macos = platform === 'MacIntel';

      // iPadOs 13 fix
      const iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];
      if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [0, 1, '13_0_0'];
        macos = false;
      }

      // Android
      if (android && !windows) {
        device.os = 'android';
        device.android = true;
      }
      if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
      }

      // Export object
      return device;
    }
    function getDevice(overrides = {}) {
      if (!deviceCached) {
        deviceCached = calcDevice(overrides);
      }
      return deviceCached;
    }
    let browser;
    function calcBrowser() {
      const window = getWindow();
      const device = getDevice();
      let needPerspectiveFix = false;
      function isSafari() {
        const ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
      }
      if (isSafari()) {
        const ua = String(window.navigator.userAgent);
        if (ua.includes('Version/')) {
          const [major, minor] = ua.split('Version/')[1].split(' ')[0].split('.').map(num => Number(num));
          needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
      }
      const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent);
      const isSafariBrowser = isSafari();
      const need3dFix = isSafariBrowser || isWebView && device.ios;
      return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix,
        need3dFix,
        isWebView
      };
    }
    function getBrowser() {
      if (!browser) {
        browser = calcBrowser();
      }
      return browser;
    }
    function Resize({
      swiper,
      on,
      emit
    }) {
      const window = getWindow();
      let observer = null;
      let animationFrame = null;
      const resizeHandler = () => {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
      };
      const createObserver = () => {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver(entries => {
          animationFrame = window.requestAnimationFrame(() => {
            const {
              width,
              height
            } = swiper;
            let newWidth = width;
            let newHeight = height;
            entries.forEach(({
              contentBoxSize,
              contentRect,
              target
            }) => {
              if (target && target !== swiper.el) return;
              newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
              newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
            });
            if (newWidth !== width || newHeight !== height) {
              resizeHandler();
            }
          });
        });
        observer.observe(swiper.el);
      };
      const removeObserver = () => {
        if (animationFrame) {
          window.cancelAnimationFrame(animationFrame);
        }
        if (observer && observer.unobserve && swiper.el) {
          observer.unobserve(swiper.el);
          observer = null;
        }
      };
      const orientationChangeHandler = () => {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
      };
      on('init', () => {
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
          createObserver();
          return;
        }
        window.addEventListener('resize', resizeHandler);
        window.addEventListener('orientationchange', orientationChangeHandler);
      });
      on('destroy', () => {
        removeObserver();
        window.removeEventListener('resize', resizeHandler);
        window.removeEventListener('orientationchange', orientationChangeHandler);
      });
    }
    function Observer({
      swiper,
      extendParams,
      on,
      emit
    }) {
      const observers = [];
      const window = getWindow();
      const attach = (target, options = {}) => {
        const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        const observer = new ObserverFunc(mutations => {
          // The observerUpdate event should only be triggered
          // once despite the number of mutations.  Additional
          // triggers are redundant and are very costly
          if (swiper.__preventObserver__) return;
          if (mutations.length === 1) {
            emit('observerUpdate', mutations[0]);
            return;
          }
          const observerUpdate = function observerUpdate() {
            emit('observerUpdate', mutations[0]);
          };
          if (window.requestAnimationFrame) {
            window.requestAnimationFrame(observerUpdate);
          } else {
            window.setTimeout(observerUpdate, 0);
          }
        });
        observer.observe(target, {
          attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
          childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options).childList,
          characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
      };
      const init = () => {
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
          const containerParents = elementParents(swiper.hostEl);
          for (let i = 0; i < containerParents.length; i += 1) {
            attach(containerParents[i]);
          }
        }
        // Observe container
        attach(swiper.hostEl, {
          childList: swiper.params.observeSlideChildren
        });

        // Observe wrapper
        attach(swiper.wrapperEl, {
          attributes: false
        });
      };
      const destroy = () => {
        observers.forEach(observer => {
          observer.disconnect();
        });
        observers.splice(0, observers.length);
      };
      extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
      });
      on('init', init);
      on('destroy', destroy);
    }

    /* eslint-disable no-underscore-dangle */

    var eventsEmitter = {
      on(events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach(event => {
          if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
          self.eventsListeners[event][method](handler);
        });
        return self;
      },
      once(events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler(...args) {
          self.off(events, onceHandler);
          if (onceHandler.__emitterProxy) {
            delete onceHandler.__emitterProxy;
          }
          handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
      },
      onAny(handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) {
          self.eventsAnyListeners[method](handler);
        }
        return self;
      },
      offAny(handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) {
          self.eventsAnyListeners.splice(index, 1);
        }
        return self;
      },
      off(events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach(event => {
          if (typeof handler === 'undefined') {
            self.eventsListeners[event] = [];
          } else if (self.eventsListeners[event]) {
            self.eventsListeners[event].forEach((eventHandler, index) => {
              if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
                self.eventsListeners[event].splice(index, 1);
              }
            });
          }
        });
        return self;
      },
      emit(...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
          events = args[0];
          data = args.slice(1, args.length);
          context = self;
        } else {
          events = args[0].events;
          data = args[0].data;
          context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach(event => {
          if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
            self.eventsAnyListeners.forEach(eventHandler => {
              eventHandler.apply(context, [event, ...data]);
            });
          }
          if (self.eventsListeners && self.eventsListeners[event]) {
            self.eventsListeners[event].forEach(eventHandler => {
              eventHandler.apply(context, data);
            });
          }
        });
        return self;
      }
    };
    function updateSize() {
      const swiper = this;
      let width;
      let height;
      const el = swiper.el;
      if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
        width = swiper.params.width;
      } else {
        width = el.clientWidth;
      }
      if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
        height = swiper.params.height;
      } else {
        height = el.clientHeight;
      }
      if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
        return;
      }

      // Subtract paddings
      width = width - parseInt(elementStyle(el, 'padding-left') || 0, 10) - parseInt(elementStyle(el, 'padding-right') || 0, 10);
      height = height - parseInt(elementStyle(el, 'padding-top') || 0, 10) - parseInt(elementStyle(el, 'padding-bottom') || 0, 10);
      if (Number.isNaN(width)) width = 0;
      if (Number.isNaN(height)) height = 0;
      Object.assign(swiper, {
        width,
        height,
        size: swiper.isHorizontal() ? width : height
      });
    }
    function updateSlides() {
      const swiper = this;
      function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
      }
      const params = swiper.params;
      const {
        wrapperEl,
        slidesEl,
        rtlTranslate: rtl,
        wrongRTL
      } = swiper;
      const isVirtual = swiper.virtual && params.virtual.enabled;
      const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
      const slides = elementChildren(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
      const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
      let snapGrid = [];
      const slidesGrid = [];
      const slidesSizesGrid = [];
      let offsetBefore = params.slidesOffsetBefore;
      if (typeof offsetBefore === 'function') {
        offsetBefore = params.slidesOffsetBefore.call(swiper);
      }
      let offsetAfter = params.slidesOffsetAfter;
      if (typeof offsetAfter === 'function') {
        offsetAfter = params.slidesOffsetAfter.call(swiper);
      }
      const previousSnapGridLength = swiper.snapGrid.length;
      const previousSlidesGridLength = swiper.slidesGrid.length;
      const swiperSize = swiper.size - offsetBefore - offsetAfter;
      let spaceBetween = params.spaceBetween;
      let slidePosition = -offsetBefore;
      let prevSlideSize = 0;
      let index = 0;
      if (typeof swiperSize === 'undefined') {
        return;
      }
      if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
        spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
      } else if (typeof spaceBetween === 'string') {
        spaceBetween = parseFloat(spaceBetween);
      }
      swiper.virtualSize = -spaceBetween - offsetBefore - offsetAfter;

      // reset margins
      slides.forEach(slideEl => {
        if (rtl) {
          slideEl.style.marginLeft = '';
        } else {
          slideEl.style.marginRight = '';
        }
        slideEl.style.marginBottom = '';
        slideEl.style.marginTop = '';
      });

      // reset cssMode offsets
      if (params.centeredSlides && params.cssMode) {
        setCSSProperty(wrapperEl, '--swiper-centered-offset-before', '');
        setCSSProperty(wrapperEl, '--swiper-centered-offset-after', '');
      }

      // set cssMode offsets
      if (params.cssMode) {
        setCSSProperty(wrapperEl, '--swiper-slides-offset-before', `${offsetBefore}px`);
        setCSSProperty(wrapperEl, '--swiper-slides-offset-after', `${offsetAfter}px`);
      }
      const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
      if (gridEnabled) {
        swiper.grid.initSlides(slides);
      } else if (swiper.grid) {
        swiper.grid.unsetSlides();
      }

      // Calc slides
      let slideSize;
      const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(key => {
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
      }).length > 0;
      for (let i = 0; i < slidesLength; i += 1) {
        slideSize = 0;
        const slide = slides[i];
        if (slide) {
          if (gridEnabled) {
            swiper.grid.updateSlide(i, slide, slides);
          }
          if (elementStyle(slide, 'display') === 'none') continue; // eslint-disable-line
        }
        if (isVirtual && params.slidesPerView === 'auto') {
          if (params.virtual.slidesPerViewAutoSlideSize) {
            slideSize = params.virtual.slidesPerViewAutoSlideSize;
          }
          if (slideSize && slide) {
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
          }
        } else if (params.slidesPerView === 'auto') {
          if (shouldResetSlideSize) {
            slide.style[swiper.getDirectionLabel('width')] = ``;
          }
          const slideStyles = getComputedStyle(slide);
          const currentTransform = slide.style.transform;
          const currentWebKitTransform = slide.style.webkitTransform;
          if (currentTransform) {
            slide.style.transform = 'none';
          }
          if (currentWebKitTransform) {
            slide.style.webkitTransform = 'none';
          }
          if (params.roundLengths) {
            slideSize = swiper.isHorizontal() ? elementOuterSize(slide, 'width', true) : elementOuterSize(slide, 'height', true);
          } else {
            // eslint-disable-next-line
            const width = getDirectionPropertyValue(slideStyles, 'width');
            const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
            const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
            const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
            const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
            const boxSizing = slideStyles.getPropertyValue('box-sizing');
            if (boxSizing && boxSizing === 'border-box') {
              slideSize = width + marginLeft + marginRight;
            } else {
              const {
                clientWidth,
                offsetWidth
              } = slide;
              slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
            }
          }
          if (currentTransform) {
            slide.style.transform = currentTransform;
          }
          if (currentWebKitTransform) {
            slide.style.webkitTransform = currentWebKitTransform;
          }
          if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
          slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
          if (params.roundLengths) slideSize = Math.floor(slideSize);
          if (slide) {
            slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
          }
        }
        if (slide) {
          slide.swiperSlideSize = slideSize;
        }
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
          slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
          if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
          if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
          if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
          if (params.roundLengths) slidePosition = Math.floor(slidePosition);
          if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
          slidesGrid.push(slidePosition);
        } else {
          if (params.roundLengths) slidePosition = Math.floor(slidePosition);
          if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
          slidesGrid.push(slidePosition);
          slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
      }
      swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
      if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
        wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
      }
      if (params.setWrapperSize) {
        wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
      }
      if (gridEnabled) {
        swiper.grid.updateWrapperSize(slideSize, snapGrid);
      }

      // Remove last grid elements depending on width
      if (!params.centeredSlides) {
        // Check if snapToSlideEdge should be applied
        const isFractionalSlidesPerView = params.slidesPerView !== 'auto' && params.slidesPerView % 1 !== 0;
        const shouldSnapToSlideEdge = params.snapToSlideEdge && !params.loop && (params.slidesPerView === 'auto' || isFractionalSlidesPerView);

        // Calculate the last allowed snap index when snapToSlideEdge is enabled
        // This ensures minimum slides are visible at the end
        let lastAllowedSnapIndex = snapGrid.length;
        if (shouldSnapToSlideEdge) {
          let minVisibleSlides;
          if (params.slidesPerView === 'auto') {
            // For 'auto' mode, calculate how many slides fit based on actual sizes
            minVisibleSlides = 1;
            let accumulatedSize = 0;
            for (let i = slidesSizesGrid.length - 1; i >= 0; i -= 1) {
              accumulatedSize += slidesSizesGrid[i] + (i < slidesSizesGrid.length - 1 ? spaceBetween : 0);
              if (accumulatedSize <= swiperSize) {
                minVisibleSlides = slidesSizesGrid.length - i;
              } else {
                break;
              }
            }
          } else {
            minVisibleSlides = Math.floor(params.slidesPerView);
          }
          lastAllowedSnapIndex = Math.max(slidesLength - minVisibleSlides, 0);
        }
        const newSlidesGrid = [];
        for (let i = 0; i < snapGrid.length; i += 1) {
          let slidesGridItem = snapGrid[i];
          if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
          if (shouldSnapToSlideEdge) {
            // When snapToSlideEdge is enabled, only keep snaps up to lastAllowedSnapIndex
            if (i <= lastAllowedSnapIndex) {
              newSlidesGrid.push(slidesGridItem);
            }
          } else if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
            // When snapToSlideEdge is disabled, keep snaps that fit within scrollable area
            newSlidesGrid.push(slidesGridItem);
          }
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
          // Only add edge-aligned snap if snapToSlideEdge is not enabled
          if (!shouldSnapToSlideEdge) {
            snapGrid.push(swiper.virtualSize - swiperSize);
          }
        }
      }
      if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
          const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
          const groupSize = size * params.slidesPerGroup;
          for (let i = 0; i < groups; i += 1) {
            snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
          }
        }
        for (let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1) {
          if (params.slidesPerGroup === 1) {
            snapGrid.push(snapGrid[snapGrid.length - 1] + size);
          }
          slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
          swiper.virtualSize += size;
        }
      }
      if (snapGrid.length === 0) snapGrid = [0];
      if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
        slides.filter((_, slideIndex) => {
          if (!params.cssMode || params.loop) return true;
          if (slideIndex === slides.length - 1) {
            return false;
          }
          return true;
        }).forEach(slideEl => {
          slideEl.style[key] = `${spaceBetween}px`;
        });
      }
      if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach(slideSizeValue => {
          allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map(snap => {
          if (snap <= 0) return -offsetBefore;
          if (snap > maxSnap) return maxSnap + offsetAfter;
          return snap;
        });
      }
      if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach(slideSizeValue => {
          allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        if (allSlidesSize < swiperSize) {
          const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
          snapGrid.forEach((snap, snapIndex) => {
            snapGrid[snapIndex] = snap - allSlidesOffset;
          });
          slidesGrid.forEach((snap, snapIndex) => {
            slidesGrid[snapIndex] = snap + allSlidesOffset;
          });
        }
      }
      Object.assign(swiper, {
        slides,
        snapGrid,
        slidesGrid,
        slidesSizesGrid
      });
      if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        setCSSProperty(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        setCSSProperty(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map(v => v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map(v => v + addToSlidesGrid);
      }
      if (slidesLength !== previousSlidesLength) {
        swiper.emit('slidesLengthChange');
      }
      if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
      }
      if (slidesGrid.length !== previousSlidesGridLength) {
        swiper.emit('slidesGridLengthChange');
      }
      if (params.watchSlidesProgress) {
        swiper.updateSlidesOffset();
      }
      swiper.emit('slidesUpdated');
      if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
          if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) {
          swiper.el.classList.remove(backFaceHiddenClass);
        }
      }
    }
    function updateAutoHeight(speed) {
      const swiper = this;
      const activeSlides = [];
      const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      let newHeight = 0;
      let i;
      if (typeof speed === 'number') {
        swiper.setTransition(speed);
      } else if (speed === true) {
        swiper.setTransition(swiper.params.speed);
      }
      const getSlideByIndex = index => {
        if (isVirtual) {
          return swiper.slides[swiper.getSlideIndexByData(index)];
        }
        return swiper.slides[index];
      };
      // Find slides currently in view
      if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) {
          (swiper.visibleSlides || []).forEach(slide => {
            activeSlides.push(slide);
          });
        } else {
          for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
          }
        }
      } else {
        activeSlides.push(getSlideByIndex(swiper.activeIndex));
      }

      // Find new height from highest slide in view
      for (i = 0; i < activeSlides.length; i += 1) {
        if (typeof activeSlides[i] !== 'undefined') {
          const height = activeSlides[i].offsetHeight;
          newHeight = height > newHeight ? height : newHeight;
        }
      }

      // Update Height
      if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
    }
    function updateSlidesOffset() {
      const swiper = this;
      const slides = swiper.slides;
      // eslint-disable-next-line
      const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
      for (let i = 0; i < slides.length; i += 1) {
        slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
      }
    }
    const toggleSlideClasses$1 = (slideEl, condition, className) => {
      if (condition && !slideEl.classList.contains(className)) {
        slideEl.classList.add(className);
      } else if (!condition && slideEl.classList.contains(className)) {
        slideEl.classList.remove(className);
      }
    };
    function updateSlidesProgress(translate = this && this.translate || 0) {
      const swiper = this;
      const params = swiper.params;
      const {
        slides,
        rtlTranslate: rtl,
        snapGrid
      } = swiper;
      if (slides.length === 0) return;
      if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
      let offsetCenter = -translate;
      if (rtl) offsetCenter = translate;
      swiper.visibleSlidesIndexes = [];
      swiper.visibleSlides = [];
      let spaceBetween = params.spaceBetween;
      if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
        spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
      } else if (typeof spaceBetween === 'string') {
        spaceBetween = parseFloat(spaceBetween);
      }
      for (let i = 0; i < slides.length; i += 1) {
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) {
          slideOffset -= slides[0].swiperSlideOffset;
        }
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
          swiper.visibleSlides.push(slide);
          swiper.visibleSlidesIndexes.push(i);
        }
        toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
        toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
      }
    }
    function updateProgress(translate) {
      const swiper = this;
      if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
      }
      const params = swiper.params;
      const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
      let {
        progress,
        isBeginning,
        isEnd,
        progressLoop
      } = swiper;
      const wasBeginning = isBeginning;
      const wasEnd = isEnd;
      if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
      } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
      }
      if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) {
          progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        } else {
          progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        }
        if (progressLoop > 1) progressLoop -= 1;
      }
      Object.assign(swiper, {
        progress,
        progressLoop,
        isBeginning,
        isEnd
      });
      if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
      if (isBeginning && !wasBeginning) {
        swiper.emit('reachBeginning toEdge');
      }
      if (isEnd && !wasEnd) {
        swiper.emit('reachEnd toEdge');
      }
      if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
        swiper.emit('fromEdge');
      }
      swiper.emit('progress', progress);
    }
    const toggleSlideClasses = (slideEl, condition, className) => {
      if (condition && !slideEl.classList.contains(className)) {
        slideEl.classList.add(className);
      } else if (!condition && slideEl.classList.contains(className)) {
        slideEl.classList.remove(className);
      }
    };
    function updateSlidesClasses() {
      const swiper = this;
      const {
        slides,
        params,
        slidesEl,
        activeIndex
      } = swiper;
      const isVirtual = swiper.virtual && params.virtual.enabled;
      const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
      const getFilteredSlide = selector => {
        return elementChildren(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
      };
      let activeSlide;
      let prevSlide;
      let nextSlide;
      if (isVirtual) {
        if (params.loop) {
          let slideIndex = activeIndex - swiper.virtual.slidesBefore;
          if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
          if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
          activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else {
          activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
        }
      } else {
        if (gridEnabled) {
          activeSlide = slides.find(slideEl => slideEl.column === activeIndex);
          nextSlide = slides.find(slideEl => slideEl.column === activeIndex + 1);
          prevSlide = slides.find(slideEl => slideEl.column === activeIndex - 1);
        } else {
          activeSlide = slides[activeIndex];
        }
      }
      if (activeSlide) {
        if (!gridEnabled) {
          // Next Slide
          nextSlide = elementNextAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
          if (params.loop && !nextSlide) {
            nextSlide = slides[0];
          }

          // Prev Slide
          prevSlide = elementPrevAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
          if (params.loop && !prevSlide === 0) {
            prevSlide = slides[slides.length - 1];
          }
        }
      }
      slides.forEach(slideEl => {
        toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
        toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
        toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
      });
      swiper.emitSlidesClasses();
    }
    const processLazyPreloader = (swiper, imageEl) => {
      if (!swiper || swiper.destroyed || !swiper.params) return;
      const slideSelector = () => swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
      const slideEl = imageEl.closest(slideSelector());
      if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
          if (slideEl.shadowRoot) {
            lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
          } else {
            // init later
            requestAnimationFrame(() => {
              if (slideEl.shadowRoot) {
                lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                if (lazyEl && !lazyEl.lazyPreloaderManaged) lazyEl.remove();
              }
            });
          }
        }
        // Skip removal if managed by React/Vue component
        if (lazyEl && !lazyEl.lazyPreloaderManaged) lazyEl.remove();
      }
    };
    const unlazy = (swiper, index) => {
      if (!swiper.slides[index]) return;
      const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
      if (imageEl) imageEl.removeAttribute('loading');
    };
    const preload = swiper => {
      if (!swiper || swiper.destroyed || !swiper.params) return;
      let amount = swiper.params.lazyPreloadPrevNext;
      const len = swiper.slides.length;
      if (!len || !amount || amount < 0) return;
      amount = Math.min(amount, len);
      const slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
      const activeIndex = swiper.activeIndex;
      if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [activeColumn - amount];
        preloadColumns.push(...Array.from({
          length: amount
        }).map((_, i) => {
          return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i) => {
          if (preloadColumns.includes(slideEl.column)) unlazy(swiper, i);
        });
        return;
      }
      const slideIndexLastInView = activeIndex + slidesPerView - 1;
      if (swiper.params.rewind || swiper.params.loop) {
        for (let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1) {
          const realIndex = (i % len + len) % len;
          if (realIndex < activeIndex || realIndex > slideIndexLastInView) unlazy(swiper, realIndex);
        }
      } else {
        for (let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1) {
          if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) {
            unlazy(swiper, i);
          }
        }
      }
    };
    function getActiveIndexByTranslate(swiper) {
      const {
        slidesGrid,
        params
      } = swiper;
      const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
      let activeIndex;
      for (let i = 0; i < slidesGrid.length; i += 1) {
        if (typeof slidesGrid[i + 1] !== 'undefined') {
          if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
            activeIndex = i;
          } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
            activeIndex = i + 1;
          }
        } else if (translate >= slidesGrid[i]) {
          activeIndex = i;
        }
      }
      // Normalize slideIndex
      if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
      }
      return activeIndex;
    }
    function updateActiveIndex(newActiveIndex) {
      const swiper = this;
      const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
      const {
        snapGrid,
        params,
        activeIndex: previousIndex,
        realIndex: previousRealIndex,
        snapIndex: previousSnapIndex
      } = swiper;
      let activeIndex = newActiveIndex;
      let snapIndex;
      const getVirtualRealIndex = aIndex => {
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) {
          realIndex = swiper.virtual.slides.length + realIndex;
        }
        if (realIndex >= swiper.virtual.slides.length) {
          realIndex -= swiper.virtual.slides.length;
        }
        return realIndex;
      };
      if (typeof activeIndex === 'undefined') {
        activeIndex = getActiveIndexByTranslate(swiper);
      }
      if (snapGrid.indexOf(translate) >= 0) {
        snapIndex = snapGrid.indexOf(translate);
      } else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
      }
      if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
      if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
          swiper.snapIndex = snapIndex;
          swiper.emit('snapIndexChange');
        }
        return;
      }
      if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
      }
      const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;

      // Get real index
      let realIndex;
      if (swiper.virtual && params.virtual.enabled) {
        if (params.loop) {
          realIndex = getVirtualRealIndex(activeIndex);
        } else {
          realIndex = activeIndex;
        }
      } else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.find(slideEl => slideEl.column === activeIndex);
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
        if (Number.isNaN(activeSlideIndex)) {
          activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        }
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
      } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
        if (slideIndex) {
          realIndex = parseInt(slideIndex, 10);
        } else {
          realIndex = activeIndex;
        }
      } else {
        realIndex = activeIndex;
      }
      Object.assign(swiper, {
        previousSnapIndex,
        snapIndex,
        previousRealIndex,
        realIndex,
        previousIndex,
        activeIndex
      });
      if (swiper.initialized) {
        preload(swiper);
      }
      swiper.emit('activeIndexChange');
      swiper.emit('snapIndexChange');
      if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) {
          swiper.emit('realIndexChange');
        }
        swiper.emit('slideChange');
      }
    }
    function updateClickedSlide(el, path) {
      const swiper = this;
      const params = swiper.params;
      let slide = el.closest(`.${params.slideClass}, swiper-slide`);
      if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) {
        [...path.slice(path.indexOf(el) + 1, path.length)].forEach(pathEl => {
          if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) {
            slide = pathEl;
          }
        });
      }
      let slideFound = false;
      let slideIndex;
      if (slide) {
        for (let i = 0; i < swiper.slides.length; i += 1) {
          if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
          }
        }
      }
      if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) {
          swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
        } else {
          swiper.clickedIndex = slideIndex;
        }
      } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
      }
      if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
        swiper.slideToClickedSlide();
      }
    }
    var update = {
      updateSize,
      updateSlides,
      updateAutoHeight,
      updateSlidesOffset,
      updateSlidesProgress,
      updateProgress,
      updateSlidesClasses,
      updateActiveIndex,
      updateClickedSlide
    };
    function getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
      const swiper = this;
      const {
        params,
        rtlTranslate: rtl,
        translate,
        wrapperEl
      } = swiper;
      if (params.virtualTranslate) {
        return rtl ? -translate : translate;
      }
      if (params.cssMode) {
        return translate;
      }
      let currentTranslate = getTranslate(wrapperEl, axis);
      currentTranslate += swiper.cssOverflowAdjustment();
      if (rtl) currentTranslate = -currentTranslate;
      return currentTranslate || 0;
    }
    function setTranslate(translate, byController) {
      const swiper = this;
      const {
        rtlTranslate: rtl,
        params,
        wrapperEl,
        progress
      } = swiper;
      let x = 0;
      let y = 0;
      const z = 0;
      if (swiper.isHorizontal()) {
        x = rtl ? -translate : translate;
      } else {
        y = translate;
      }
      if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
      }
      swiper.previousTranslate = swiper.translate;
      swiper.translate = swiper.isHorizontal() ? x : y;
      if (params.cssMode) {
        wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
      } else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) {
          x -= swiper.cssOverflowAdjustment();
        } else {
          y -= swiper.cssOverflowAdjustment();
        }
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
      }

      // Check if we need to update progress
      let newProgress;
      const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
      if (translatesDiff === 0) {
        newProgress = 0;
      } else {
        newProgress = (translate - swiper.minTranslate()) / translatesDiff;
      }
      if (newProgress !== progress) {
        swiper.updateProgress(translate);
      }
      swiper.emit('setTranslate', swiper.translate, byController);
    }
    function minTranslate() {
      return -this.snapGrid[0];
    }
    function maxTranslate() {
      return -this.snapGrid[this.snapGrid.length - 1];
    }
    function translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
      const swiper = this;
      const {
        params,
        wrapperEl
      } = swiper;
      if (swiper.animating && params.preventInteractionOnTransition) {
        return false;
      }
      const minTranslate = swiper.minTranslate();
      const maxTranslate = swiper.maxTranslate();
      let newTranslate;
      if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate;

      // Update progress
      swiper.updateProgress(newTranslate);
      if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) {
          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        } else {
          if (!swiper.support.smoothScroll) {
            animateCSSModeScroll({
              swiper,
              targetPosition: -newTranslate,
              side: isH ? 'left' : 'top'
            });
            return true;
          }
          wrapperEl.scrollTo({
            [isH ? 'left' : 'top']: -newTranslate,
            behavior: 'smooth'
          });
        }
        return true;
      }
      if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
          swiper.emit('beforeTransitionStart', speed, internal);
          swiper.emit('transitionEnd');
        }
      } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
          swiper.emit('beforeTransitionStart', speed, internal);
          swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
          swiper.animating = true;
          if (!swiper.onTranslateToWrapperTransitionEnd) {
            swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
              if (!swiper || swiper.destroyed) return;
              if (e.target !== this) return;
              swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
              swiper.onTranslateToWrapperTransitionEnd = null;
              delete swiper.onTranslateToWrapperTransitionEnd;
              swiper.animating = false;
              if (runCallbacks) {
                swiper.emit('transitionEnd');
              }
            };
          }
          swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        }
      }
      return true;
    }
    var translate = {
      getTranslate: getSwiperTranslate,
      setTranslate,
      minTranslate,
      maxTranslate,
      translateTo
    };
    function setTransition(duration, byController) {
      const swiper = this;
      if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
      }
      swiper.emit('setTransition', duration, byController);
    }
    function transitionEmit({
      swiper,
      runCallbacks,
      direction,
      step
    }) {
      const {
        activeIndex,
        previousIndex
      } = swiper;
      let dir = direction;
      if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
      }
      swiper.emit(`transition${step}`);
      if (runCallbacks && dir === 'reset') {
        swiper.emit(`slideResetTransition${step}`);
      } else if (runCallbacks && activeIndex !== previousIndex) {
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') {
          swiper.emit(`slideNextTransition${step}`);
        } else {
          swiper.emit(`slidePrevTransition${step}`);
        }
      }
    }
    function transitionStart(runCallbacks = true, direction) {
      const swiper = this;
      const {
        params
      } = swiper;
      if (params.cssMode) return;
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
      transitionEmit({
        swiper,
        runCallbacks,
        direction,
        step: 'Start'
      });
    }
    function transitionEnd(runCallbacks = true, direction) {
      const swiper = this;
      const {
        params
      } = swiper;
      swiper.animating = false;
      if (params.cssMode) return;
      swiper.setTransition(0);
      transitionEmit({
        swiper,
        runCallbacks,
        direction,
        step: 'End'
      });
    }
    var transition = {
      setTransition,
      transitionStart,
      transitionEnd
    };
    function slideTo(index = 0, speed, runCallbacks = true, internal, initial) {
      if (typeof index === 'string') {
        index = parseInt(index, 10);
      }
      const swiper = this;
      let slideIndex = index;
      if (slideIndex < 0) slideIndex = 0;
      const {
        params,
        snapGrid,
        slidesGrid,
        previousIndex,
        activeIndex,
        rtlTranslate: rtl,
        wrapperEl,
        enabled
      } = swiper;
      if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) {
        return false;
      }
      if (typeof speed === 'undefined') {
        speed = swiper.params.speed;
      }
      const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
      let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
      if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
      const translate = -snapGrid[snapIndex];
      // Normalize slideIndex
      if (params.normalizeSlideIndex) {
        for (let i = 0; i < slidesGrid.length; i += 1) {
          const normalizedTranslate = -Math.floor(translate * 100);
          const normalizedGrid = Math.floor(slidesGrid[i] * 100);
          const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
          if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
              slideIndex = i;
            } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
              slideIndex = i + 1;
            }
          } else if (normalizedTranslate >= normalizedGrid) {
            slideIndex = i;
          }
        }
      }
      // Directions locks
      if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) {
          return false;
        }
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
          if ((activeIndex || 0) !== slideIndex) {
            return false;
          }
        }
      }
      if (slideIndex !== (previousIndex || 0) && runCallbacks) {
        swiper.emit('beforeSlideChangeStart');
      }

      // Update progress
      swiper.updateProgress(translate);
      let direction;
      if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset';

      // initial virtual
      const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      const isInitialVirtual = isVirtual && initial;
      // Update Index
      if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) {
          swiper.updateAutoHeight();
        }
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') {
          swiper.setTranslate(translate);
        }
        if (direction !== 'reset') {
          swiper.transitionStart(runCallbacks, direction);
          swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
      }
      if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
          if (isVirtual) {
            swiper.wrapperEl.style.scrollSnapType = 'none';
            swiper._immediateVirtual = true;
          }
          if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
            swiper._cssModeVirtualInitialSet = true;
            requestAnimationFrame(() => {
              wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            });
          } else {
            wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
          }
          if (isVirtual) {
            requestAnimationFrame(() => {
              swiper.wrapperEl.style.scrollSnapType = '';
              swiper._immediateVirtual = false;
            });
          }
        } else {
          if (!swiper.support.smoothScroll) {
            animateCSSModeScroll({
              swiper,
              targetPosition: t,
              side: isH ? 'left' : 'top'
            });
            return true;
          }
          wrapperEl.scrollTo({
            [isH ? 'left' : 'top']: t,
            behavior: 'smooth'
          });
        }
        return true;
      }
      const browser = getBrowser();
      const isSafari = browser.isSafari;
      if (isVirtual && !initial && isSafari && swiper.isElement) {
        swiper.virtual.update(false, false, slideIndex);
      }
      swiper.setTransition(speed);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      if (speed === 0) {
        swiper.transitionEnd(runCallbacks, direction);
      } else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) {
          swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
          };
        }
        swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
      }
      return true;
    }
    function slideToLoop(index = 0, speed, runCallbacks = true, internal) {
      if (typeof index === 'string') {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
      }
      const swiper = this;
      if (swiper.destroyed) return;
      if (typeof speed === 'undefined') {
        speed = swiper.params.speed;
      }
      const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
      let newIndex = index;
      if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) {
          // eslint-disable-next-line
          newIndex = newIndex + swiper.virtual.slidesBefore;
        } else {
          let targetSlideIndex;
          if (gridEnabled) {
            const slideIndex = newIndex * swiper.params.grid.rows;
            targetSlideIndex = swiper.slides.find(slideEl => slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
          } else {
            targetSlideIndex = swiper.getSlideIndexByData(newIndex);
          }
          const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
          const {
            centeredSlides,
            slidesOffsetBefore,
            slidesOffsetAfter
          } = swiper.params;
          const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
          let slidesPerView = swiper.params.slidesPerView;
          if (slidesPerView === 'auto') {
            slidesPerView = swiper.slidesPerViewDynamic();
          } else {
            slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
            if (bothDirections && slidesPerView % 2 === 0) {
              slidesPerView = slidesPerView + 1;
            }
          }
          let needLoopFix = cols - targetSlideIndex < slidesPerView;
          if (bothDirections) {
            needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
          }
          if (internal && bothDirections && swiper.params.slidesPerView !== 'auto' && !gridEnabled) {
            needLoopFix = false;
          }
          if (needLoopFix) {
            const direction = bothDirections ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
            swiper.loopFix({
              direction,
              slideTo: true,
              activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
              slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
            });
          }
          if (gridEnabled) {
            const slideIndex = newIndex * swiper.params.grid.rows;
            newIndex = swiper.slides.find(slideEl => slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
          } else {
            newIndex = swiper.getSlideIndexByData(newIndex);
          }
        }
      }
      requestAnimationFrame(() => {
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
      });
      return swiper;
    }

    /* eslint no-unused-vars: "off" */
    function slideNext(speed, runCallbacks = true, internal) {
      const swiper = this;
      const {
        enabled,
        params,
        animating
      } = swiper;
      if (!enabled || swiper.destroyed) return swiper;
      if (typeof speed === 'undefined') {
        speed = swiper.params.speed;
      }
      let perGroup = params.slidesPerGroup;
      if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
        perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
      }
      const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
      const isVirtual = swiper.virtual && params.virtual.enabled;
      if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
          direction: 'next'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
          requestAnimationFrame(() => {
            swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
          });
          return true;
        }
      }
      if (params.rewind && swiper.isEnd) {
        return swiper.slideTo(0, speed, runCallbacks, internal);
      }
      return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
    }

    /* eslint no-unused-vars: "off" */
    function slidePrev(speed, runCallbacks = true, internal) {
      const swiper = this;
      const {
        params,
        snapGrid,
        slidesGrid,
        rtlTranslate,
        enabled,
        animating
      } = swiper;
      if (!enabled || swiper.destroyed) return swiper;
      if (typeof speed === 'undefined') {
        speed = swiper.params.speed;
      }
      const isVirtual = swiper.virtual && params.virtual.enabled;
      if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
          direction: 'prev'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
      }
      const translate = rtlTranslate ? swiper.translate : -swiper.translate;
      function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
      }
      const normalizedTranslate = normalize(translate);
      const normalizedSnapGrid = snapGrid.map(val => normalize(val));
      const isFreeMode = params.freeMode && params.freeMode.enabled;
      let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
      if (typeof prevSnap === 'undefined' && (params.cssMode || isFreeMode)) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex) => {
          if (normalizedTranslate >= snap) {
            // prevSnap = snap;
            prevSnapIndex = snapIndex;
          }
        });
        if (typeof prevSnapIndex !== 'undefined') {
          prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
        }
      }
      let prevIndex = 0;
      if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
          prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
          prevIndex = Math.max(prevIndex, 0);
        }
      }
      if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
      } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(() => {
          swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
      }
      return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
    }

    /* eslint no-unused-vars: "off" */
    function slideReset(speed, runCallbacks = true, internal) {
      const swiper = this;
      if (swiper.destroyed) return;
      if (typeof speed === 'undefined') {
        speed = swiper.params.speed;
      }
      return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
    }

    /* eslint no-unused-vars: "off" */
    function slideToClosest(speed, runCallbacks = true, internal, threshold = 0.5) {
      const swiper = this;
      if (swiper.destroyed) return;
      if (typeof speed === 'undefined') {
        speed = swiper.params.speed;
      }
      let index = swiper.activeIndex;
      const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
      const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
      const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
      if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
          index += swiper.params.slidesPerGroup;
        }
      } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) {
          index -= swiper.params.slidesPerGroup;
        }
      }
      index = Math.max(index, 0);
      index = Math.min(index, swiper.slidesGrid.length - 1);
      return swiper.slideTo(index, speed, runCallbacks, internal);
    }
    function slideToClickedSlide() {
      const swiper = this;
      if (swiper.destroyed) return;
      const {
        params,
        slidesEl
      } = swiper;
      const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
      let slideToIndex = swiper.getSlideIndexWhenGrid(swiper.clickedIndex);
      let realIndex;
      const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
      const isGrid = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
      if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        if (params.centeredSlides) {
          swiper.slideToLoop(realIndex);
        } else if (slideToIndex > (isGrid ? (swiper.slides.length - slidesPerView) / 2 - (swiper.params.grid.rows - 1) : swiper.slides.length - slidesPerView)) {
          swiper.loopFix();
          slideToIndex = swiper.getSlideIndex(elementChildren(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
          nextTick(() => {
            swiper.slideTo(slideToIndex);
          });
        } else {
          swiper.slideTo(slideToIndex);
        }
      } else {
        swiper.slideTo(slideToIndex);
      }
    }
    var slide = {
      slideTo,
      slideToLoop,
      slideNext,
      slidePrev,
      slideReset,
      slideToClosest,
      slideToClickedSlide
    };
    function loopCreate(slideRealIndex, initial) {
      const swiper = this;
      const {
        params,
        slidesEl
      } = swiper;
      if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
      const initSlides = () => {
        const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index) => {
          el.setAttribute('data-swiper-slide-index', index);
        });
      };
      const clearBlankSlides = () => {
        const slides = elementChildren(slidesEl, `.${params.slideBlankClass}`);
        slides.forEach(el => {
          el.remove();
        });
        if (slides.length > 0) {
          swiper.recalcSlides();
          swiper.updateSlides();
        }
      };
      const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
      if (params.loopAddBlankSlides && (params.slidesPerGroup > 1 || gridEnabled)) {
        clearBlankSlides();
      }
      const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
      const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
      const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
      const addBlankSlides = amountOfSlides => {
        for (let i = 0; i < amountOfSlides; i += 1) {
          const slideEl = swiper.isElement ? createElement('swiper-slide', [params.slideBlankClass]) : createElement('div', [params.slideClass, params.slideBlankClass]);
          swiper.slidesEl.append(slideEl);
        }
      };
      if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
          const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
          addBlankSlides(slidesToAdd);
          swiper.recalcSlides();
          swiper.updateSlides();
        } else {
          showWarning('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        }
        initSlides();
      } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
          const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
          addBlankSlides(slidesToAdd);
          swiper.recalcSlides();
          swiper.updateSlides();
        } else {
          showWarning('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        }
        initSlides();
      } else {
        initSlides();
      }
      const bothDirections = params.centeredSlides || !!params.slidesOffsetBefore || !!params.slidesOffsetAfter;
      swiper.loopFix({
        slideRealIndex,
        direction: bothDirections ? undefined : 'next',
        initial
      });
    }
    function loopFix({
      slideRealIndex,
      slideTo = true,
      direction,
      setTranslate,
      activeSlideIndex,
      initial,
      byController,
      byMousewheel
    } = {}) {
      const swiper = this;
      if (!swiper.params.loop) return;
      swiper.emit('beforeLoopFix');
      const {
        slides,
        allowSlidePrev,
        allowSlideNext,
        slidesEl,
        params
      } = swiper;
      const {
        centeredSlides,
        slidesOffsetBefore,
        slidesOffsetAfter,
        initialSlide
      } = params;
      const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
      swiper.allowSlidePrev = true;
      swiper.allowSlideNext = true;
      if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
          if (!bothDirections && swiper.snapIndex === 0) {
            swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
          } else if (bothDirections && swiper.snapIndex < params.slidesPerView) {
            swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
          } else if (swiper.snapIndex === swiper.snapGrid.length - 1) {
            swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
          }
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit('loopFix');
        return;
      }
      let slidesPerView = params.slidesPerView;
      if (slidesPerView === 'auto') {
        slidesPerView = swiper.slidesPerViewDynamic();
      } else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (bothDirections && slidesPerView % 2 === 0) {
          slidesPerView = slidesPerView + 1;
        }
      }
      const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
      let loopedSlides = bothDirections ? Math.max(slidesPerGroup, Math.ceil(slidesPerView / 2)) : slidesPerGroup;
      if (loopedSlides % slidesPerGroup !== 0) {
        loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
      }
      loopedSlides += params.loopAdditionalSlides;
      swiper.loopedSlides = loopedSlides;
      const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
      if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
        showWarning('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
      } else if (gridEnabled && params.grid.fill === 'row') {
        showWarning('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
      }
      const prependSlidesIndexes = [];
      const appendSlidesIndexes = [];
      const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
      const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !bothDirections;
      let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
      if (typeof activeSlideIndex === 'undefined') {
        activeSlideIndex = swiper.getSlideIndex(slides.find(el => el.classList.contains(params.slideActiveClass)));
      } else {
        activeIndex = activeSlideIndex;
      }
      const isNext = direction === 'next' || !direction;
      const isPrev = direction === 'prev' || !direction;
      let slidesPrepended = 0;
      let slidesAppended = 0;
      const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
      const activeColIndexWithShift = activeColIndex + (bothDirections && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
      // prepend last slides before start
      if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for (let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1) {
          const index = i - Math.floor(i / cols) * cols;
          if (gridEnabled) {
            const colIndexToPrepend = cols - index - 1;
            for (let i = slides.length - 1; i >= 0; i -= 1) {
              if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
            }
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
          } else {
            prependSlidesIndexes.push(cols - index - 1);
          }
        }
      } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        if (isInitialOverflow) {
          slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
        }
        for (let i = 0; i < slidesAppended; i += 1) {
          const index = i - Math.floor(i / cols) * cols;
          if (gridEnabled) {
            slides.forEach((slide, slideIndex) => {
              if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
          } else {
            appendSlidesIndexes.push(index);
          }
        }
      }
      swiper.__preventObserver__ = true;
      requestAnimationFrame(() => {
        swiper.__preventObserver__ = false;
      });
      if (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
        if (appendSlidesIndexes.includes(activeSlideIndex)) {
          appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
        }
        if (prependSlidesIndexes.includes(activeSlideIndex)) {
          prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
        }
      }
      if (isPrev) {
        prependSlidesIndexes.forEach(index => {
          slides[index].swiperLoopMoveDOM = true;
          slidesEl.prepend(slides[index]);
          slides[index].swiperLoopMoveDOM = false;
        });
      }
      if (isNext) {
        appendSlidesIndexes.forEach(index => {
          slides[index].swiperLoopMoveDOM = true;
          slidesEl.append(slides[index]);
          slides[index].swiperLoopMoveDOM = false;
        });
      }
      swiper.recalcSlides();
      if (params.slidesPerView === 'auto') {
        swiper.updateSlides();
      } else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) {
        swiper.slides.forEach((slide, slideIndex) => {
          swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
        });
      }
      if (params.watchSlidesProgress) {
        swiper.updateSlidesOffset();
      }
      if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
          if (typeof slideRealIndex === 'undefined') {
            const currentSlideTranslate = swiper.slidesGrid[activeIndex];
            const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
            const diff = newSlideTranslate - currentSlideTranslate;
            if (byMousewheel) {
              swiper.setTranslate(swiper.translate - diff);
            } else {
              swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
              if (setTranslate) {
                swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
              }
            }
          } else {
            if (setTranslate) {
              const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
              swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
              swiper.touchEventsData.currentTranslate = swiper.translate;
            }
          }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
          if (typeof slideRealIndex === 'undefined') {
            const currentSlideTranslate = swiper.slidesGrid[activeIndex];
            const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
            const diff = newSlideTranslate - currentSlideTranslate;
            if (byMousewheel) {
              swiper.setTranslate(swiper.translate - diff);
            } else {
              swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
              if (setTranslate) {
                swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
              }
            }
          } else {
            const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
            swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
          }
        }
      }
      swiper.allowSlidePrev = allowSlidePrev;
      swiper.allowSlideNext = allowSlideNext;
      if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
          slideRealIndex,
          direction,
          setTranslate,
          activeSlideIndex,
          byController: true
        };
        if (Array.isArray(swiper.controller.control)) {
          swiper.controller.control.forEach(c => {
            if (!c.destroyed && c.params.loop) c.loopFix({
              ...loopParams,
              slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
          });
        } else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) {
          swiper.controller.control.loopFix({
            ...loopParams,
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
          });
        }
      }
      swiper.emit('loopFix');
    }
    function loopDestroy() {
      const swiper = this;
      const {
        params,
        slidesEl
      } = swiper;
      if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
      swiper.recalcSlides();
      const newSlidesOrder = [];
      swiper.slides.forEach(slideEl => {
        const index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
      });
      swiper.slides.forEach(slideEl => {
        slideEl.removeAttribute('data-swiper-slide-index');
      });
      newSlidesOrder.forEach(slideEl => {
        slidesEl.append(slideEl);
      });
      swiper.recalcSlides();
      swiper.slideTo(swiper.realIndex, 0);
    }
    var loop = {
      loopCreate,
      loopFix,
      loopDestroy
    };
    function setGrabCursor(moving) {
      const swiper = this;
      if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
      const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
      if (swiper.isElement) {
        swiper.__preventObserver__ = true;
      }
      el.style.cursor = 'move';
      el.style.cursor = moving ? 'grabbing' : 'grab';
      if (swiper.isElement) {
        requestAnimationFrame(() => {
          swiper.__preventObserver__ = false;
        });
      }
    }
    function unsetGrabCursor() {
      const swiper = this;
      if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
        return;
      }
      if (swiper.isElement) {
        swiper.__preventObserver__ = true;
      }
      swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
      if (swiper.isElement) {
        requestAnimationFrame(() => {
          swiper.__preventObserver__ = false;
        });
      }
    }
    var grabCursor = {
      setGrabCursor,
      unsetGrabCursor
    };

    // Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
    function closestElement(selector, base = this) {
      function __closestFrom(el) {
        if (!el || el === getDocument() || el === getWindow()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) {
          return null;
        }
        return found || __closestFrom(el.getRootNode().host);
      }
      return __closestFrom(base);
    }
    function preventEdgeSwipe(swiper, event, startX) {
      const window = getWindow();
      const {
        params
      } = swiper;
      const edgeSwipeDetection = params.edgeSwipeDetection;
      const edgeSwipeThreshold = params.edgeSwipeThreshold;
      if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') {
          event.preventDefault();
          return true;
        }
        return false;
      }
      return true;
    }
    function onTouchStart(event) {
      const swiper = this;
      if (swiper.destroyed) return;
      const document = getDocument();
      let e = event;
      if (e.originalEvent) e = e.originalEvent;
      const data = swiper.touchEventsData;
      if (e.type === 'pointerdown') {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) {
          return;
        }
        data.pointerId = e.pointerId;
      } else if (e.type === 'touchstart' && e.targetTouches.length === 1) {
        data.touchId = e.targetTouches[0].identifier;
      }
      if (e.type === 'touchstart') {
        // don't proceed touch event
        preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
      }
      const {
        params,
        touches,
        enabled
      } = swiper;
      if (!enabled) return;
      if (!params.simulateTouch && e.pointerType === 'mouse') return;
      if (swiper.animating && params.preventInteractionOnTransition) {
        return;
      }
      if (!swiper.animating && params.cssMode && params.loop) {
        swiper.loopFix();
      }
      let targetEl = e.target;
      if (params.touchEventsTarget === 'wrapper') {
        if (!elementIsChildOf(targetEl, swiper.wrapperEl)) return;
      }
      if ('which' in e && e.which === 3) return;
      if ('button' in e && e.button > 0) return;
      if (data.isTouched && data.isMoved) return;

      // change target el for shadow root component
      const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
      // eslint-disable-next-line
      const eventPath = e.composedPath ? e.composedPath() : e.path;
      if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
        targetEl = eventPath[0];
      }
      const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
      const isTargetShadow = !!(e.target && e.target.shadowRoot);

      // use closestElement for shadow root element to get the actual closest for nested shadow root element
      if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
      }
      if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
      }
      touches.currentX = e.pageX;
      touches.currentY = e.pageY;
      const startX = touches.currentX;
      const startY = touches.currentY;

      // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

      if (!preventEdgeSwipe(swiper, e, startX)) {
        return;
      }
      Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
      });
      touches.startX = startX;
      touches.startY = startY;
      data.touchStartTime = now();
      swiper.allowClick = true;
      swiper.updateSize();
      swiper.swipeDirection = undefined;
      if (params.threshold > 0) data.allowThresholdMove = false;
      let preventDefault = true;
      if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === 'SELECT') {
          data.isTouched = false;
        }
      }
      if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== targetEl && (e.pointerType === 'mouse' || e.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements))) {
        document.activeElement.blur();
      }
      const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
      if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) {
        e.preventDefault();
      }
      if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
        swiper.freeMode.onTouchStart();
      }
      swiper.emit('touchStart', e);
    }
    function onTouchMove(event) {
      const document = getDocument();
      const swiper = this;
      if (swiper.destroyed) return;
      const data = swiper.touchEventsData;
      const {
        params,
        touches,
        rtlTranslate: rtl,
        enabled
      } = swiper;
      if (!enabled) return;
      if (!params.simulateTouch && event.pointerType === 'mouse') return;
      let e = event;
      if (e.originalEvent) e = e.originalEvent;
      if (e.type === 'pointermove') {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const id = e.pointerId;
        if (id !== data.pointerId) return;
      }
      let targetTouch;
      if (e.type === 'touchmove') {
        targetTouch = [...e.changedTouches].find(t => t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
      } else {
        targetTouch = e;
      }
      if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) {
          swiper.emit('touchMoveOpposite', e);
        }
        return;
      }
      const pageX = targetTouch.pageX;
      const pageY = targetTouch.pageY;
      if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
      }
      if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) {
          swiper.allowClick = false;
        }
        if (data.isTouched) {
          Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY
          });
          data.touchStartTime = now();
        }
        return;
      }
      if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) {
          // Vertical
          if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
            data.isTouched = false;
            data.isMoved = false;
            return;
          }
        } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) {
          return;
        } else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) {
          return;
        }
      }
      if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== e.target && e.pointerType !== 'mouse') {
        document.activeElement.blur();
      }
      if (document.activeElement) {
        if (e.target === document.activeElement && e.target.matches(data.focusableElements)) {
          data.isMoved = true;
          swiper.allowClick = false;
          return;
        }
      }
      if (data.allowTouchCallbacks) {
        swiper.emit('touchMove', e);
      }
      touches.previousX = touches.currentX;
      touches.previousY = touches.currentY;
      touches.currentX = pageX;
      touches.currentY = pageY;
      const diffX = touches.currentX - touches.startX;
      const diffY = touches.currentY - touches.startY;
      if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
      if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
          data.isScrolling = false;
        } else {
          // eslint-disable-next-line
          if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
          }
        }
      }
      if (data.isScrolling) {
        swiper.emit('touchMoveOpposite', e);
      }
      if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
          data.startMoving = true;
        }
      }
      if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
      }
      if (!data.startMoving) {
        return;
      }
      swiper.allowClick = false;
      if (!params.cssMode && e.cancelable) {
        e.preventDefault();
      }
      if (params.touchMoveStopPropagation && !params.nested) {
        e.stopPropagation();
      }
      let diff = swiper.isHorizontal() ? diffX : diffY;
      let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
      if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
      }
      touches.diff = diff;
      diff *= params.touchRatio;
      if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
      }
      const prevTouchesDirection = swiper.touchesDirection;
      swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
      swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
      const isLoop = swiper.params.loop && !params.cssMode;
      const allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
      if (!data.isMoved) {
        if (isLoop && allowLoopFix) {
          swiper.loopFix({
            direction: swiper.swipeDirection
          });
        }
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
          const evt = new window.CustomEvent('transitionend', {
            bubbles: true,
            cancelable: true,
            detail: {
              bySwiperTouchMove: true
            }
          });
          swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
          swiper.setGrabCursor(true);
        }
        swiper.emit('sliderFirstMove', e);
      }
      let loopFixed;
      new Date().getTime();
      if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
          startX: pageX,
          startY: pageY,
          currentX: pageX,
          currentY: pageY,
          startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
      }
      swiper.emit('sliderMove', e);
      data.isMoved = true;
      data.currentTranslate = diff + data.startTranslate;
      let disableParentSwiper = true;
      let resistanceRatio = params.resistanceRatio;
      if (params.touchReleaseOnEdges) {
        resistanceRatio = 0;
      }
      if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) {
          swiper.loopFix({
            direction: 'prev',
            setTranslate: true,
            activeSlideIndex: 0
          });
        }
        if (data.currentTranslate > swiper.minTranslate()) {
          disableParentSwiper = false;
          if (params.resistance) {
            data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
          }
        }
      } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) {
          swiper.loopFix({
            direction: 'next',
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
          });
        }
        if (data.currentTranslate < swiper.maxTranslate()) {
          disableParentSwiper = false;
          if (params.resistance) {
            data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
          }
        }
      }
      if (disableParentSwiper) {
        e.preventedByNestedSwiper = true;
      }

      // Directions locks
      if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
        data.currentTranslate = data.startTranslate;
      }
      if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
        data.currentTranslate = data.startTranslate;
      }
      if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
        data.currentTranslate = data.startTranslate;
      }

      // Threshold
      if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
          if (!data.allowThresholdMove) {
            data.allowThresholdMove = true;
            touches.startX = touches.currentX;
            touches.startY = touches.currentY;
            data.currentTranslate = data.startTranslate;
            touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
            return;
          }
        } else {
          data.currentTranslate = data.startTranslate;
          return;
        }
      }
      if (!params.followFinger || params.cssMode) return;

      // Update active index in free mode
      if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      if (params.freeMode && params.freeMode.enabled && swiper.freeMode) {
        swiper.freeMode.onTouchMove();
      }
      // Update progress
      swiper.updateProgress(data.currentTranslate);
      // Update translate
      swiper.setTranslate(data.currentTranslate);
    }
    function onTouchEnd(event) {
      const swiper = this;
      if (swiper.destroyed) return;
      const data = swiper.touchEventsData;
      let e = event;
      if (e.originalEvent) e = e.originalEvent;
      let targetTouch;
      const isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
      if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
      } else {
        targetTouch = [...e.changedTouches].find(t => t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
      }
      if (['pointercancel', 'pointerout', 'pointerleave', 'contextmenu'].includes(e.type)) {
        const proceed = ['pointercancel', 'contextmenu'].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) {
          return;
        }
      }
      data.pointerId = null;
      data.touchId = null;
      const {
        params,
        touches,
        rtlTranslate: rtl,
        slidesGrid,
        enabled
      } = swiper;
      if (!enabled) return;
      if (!params.simulateTouch && e.pointerType === 'mouse') return;
      if (data.allowTouchCallbacks) {
        swiper.emit('touchEnd', e);
      }
      data.allowTouchCallbacks = false;
      if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) {
          swiper.setGrabCursor(false);
        }
        data.isMoved = false;
        data.startMoving = false;
        return;
      }

      // Return Grab Cursor
      if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(false);
      }

      // Time diff
      const touchEndTime = now();
      const timeDiff = touchEndTime - data.touchStartTime;

      // Tap, doubleTap, Click
      if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
          swiper.emit('doubleTap doubleClick', e);
        }
      }
      data.lastClickTime = now();
      nextTick(() => {
        if (!swiper.destroyed) swiper.allowClick = true;
      });
      if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
      }
      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;
      let currentPos;
      if (params.followFinger) {
        currentPos = rtl ? swiper.translate : -swiper.translate;
      } else {
        currentPos = -data.currentTranslate;
      }
      if (params.cssMode) {
        return;
      }
      if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
          currentPos
        });
        return;
      }

      // Find current slide
      const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
      let stopIndex = 0;
      let groupSize = swiper.slidesSizesGrid[0];
      for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
          if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
            stopIndex = i;
            groupSize = slidesGrid[i + increment] - slidesGrid[i];
          }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
          stopIndex = i;
          groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
      }
      let rewindFirstIndex = null;
      let rewindLastIndex = null;
      if (params.rewind) {
        if (swiper.isBeginning) {
          rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        } else if (swiper.isEnd) {
          rewindFirstIndex = 0;
        }
      }
      // Find current slide size
      const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
      const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
      if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
          swiper.slideTo(swiper.activeIndex);
          return;
        }
        if (swiper.swipeDirection === 'next') {
          if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
          if (ratio > 1 - params.longSwipesRatio) {
            swiper.slideTo(stopIndex + increment);
          } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
            swiper.slideTo(rewindLastIndex);
          } else {
            swiper.slideTo(stopIndex);
          }
        }
      } else {
        // Short swipes
        if (!params.shortSwipes) {
          swiper.slideTo(swiper.activeIndex);
          return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
          if (swiper.swipeDirection === 'next') {
            swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
          }
          if (swiper.swipeDirection === 'prev') {
            swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
          }
        } else if (e.target === swiper.navigation.nextEl) {
          swiper.slideTo(stopIndex + increment);
        } else {
          swiper.slideTo(stopIndex);
        }
      }
    }
    function onResize() {
      const swiper = this;
      const {
        params,
        el
      } = swiper;
      if (el && el.offsetWidth === 0) return;

      // Breakpoints
      if (params.breakpoints) {
        swiper.setBreakpoint();
      }

      // Save locks
      const {
        allowSlideNext,
        allowSlidePrev,
        snapGrid
      } = swiper;
      const isVirtual = swiper.virtual && swiper.params.virtual.enabled;

      // Disable locks on resize
      swiper.allowSlideNext = true;
      swiper.allowSlidePrev = true;
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateSlidesClasses();
      const isVirtualLoop = isVirtual && params.loop;
      if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
        const slides = isVirtual ? swiper.virtual.slides : swiper.slides;
        swiper.slideTo(slides.length - 1, 0, false, true);
      } else {
        if (swiper.params.loop && !isVirtual) {
          swiper.slideToLoop(swiper.realIndex, 0, false, true);
        } else {
          swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
      }
      if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(() => {
          if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
            swiper.autoplay.resume();
          }
        }, 500);
      }
      // Return locks after resize
      swiper.allowSlidePrev = allowSlidePrev;
      swiper.allowSlideNext = allowSlideNext;
      if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
    }
    function onClick(e) {
      const swiper = this;
      if (swiper.destroyed) return;
      if (!swiper.enabled) return;
      if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      }
    }
    function onScroll() {
      const swiper = this;
      if (swiper.destroyed) return;
      const {
        wrapperEl,
        rtlTranslate,
        enabled
      } = swiper;
      if (!enabled) return;
      swiper.previousTranslate = swiper.translate;
      if (swiper.isHorizontal()) {
        swiper.translate = -wrapperEl.scrollLeft;
      } else {
        swiper.translate = -wrapperEl.scrollTop;
      }
      // eslint-disable-next-line
      if (swiper.translate === 0) swiper.translate = 0;
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
      let newProgress;
      const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
      if (translatesDiff === 0) {
        newProgress = 0;
      } else {
        newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
      }
      if (newProgress !== swiper.progress) {
        swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
      }
      swiper.emit('setTranslate', swiper.translate, false);
    }
    function onLoad(e) {
      const swiper = this;
      if (swiper.destroyed) return;
      processLazyPreloader(swiper, e.target);
      if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) {
        return;
      }
      swiper.update();
    }
    function onDocumentTouchStart() {
      const swiper = this;
      if (swiper.destroyed) return;
      if (swiper.documentTouchHandlerProceeded) return;
      swiper.documentTouchHandlerProceeded = true;
      if (swiper.params.touchReleaseOnEdges) {
        swiper.el.style.touchAction = 'auto';
      }
    }
    const events = (swiper, method) => {
      const document = getDocument();
      const {
        params,
        el,
        wrapperEl,
        device
      } = swiper;
      const capture = !!params.nested;
      const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
      const swiperMethod = method;
      if (!el || typeof el === 'string') return;

      // Touch Events
      document[domMethod]('touchstart', swiper.onDocumentTouchStart, {
        passive: false,
        capture
      });
      el[domMethod]('touchstart', swiper.onTouchStart, {
        passive: false
      });
      el[domMethod]('pointerdown', swiper.onTouchStart, {
        passive: false
      });
      document[domMethod]('touchmove', swiper.onTouchMove, {
        passive: false,
        capture
      });
      document[domMethod]('pointermove', swiper.onTouchMove, {
        passive: false,
        capture
      });
      document[domMethod]('touchend', swiper.onTouchEnd, {
        passive: true
      });
      document[domMethod]('pointerup', swiper.onTouchEnd, {
        passive: true
      });
      document[domMethod]('pointercancel', swiper.onTouchEnd, {
        passive: true
      });
      document[domMethod]('touchcancel', swiper.onTouchEnd, {
        passive: true
      });
      document[domMethod]('pointerout', swiper.onTouchEnd, {
        passive: true
      });
      document[domMethod]('pointerleave', swiper.onTouchEnd, {
        passive: true
      });
      document[domMethod]('contextmenu', swiper.onTouchEnd, {
        passive: true
      });

      // Prevent Links Clicks
      if (params.preventClicks || params.preventClicksPropagation) {
        el[domMethod]('click', swiper.onClick, true);
      }
      if (params.cssMode) {
        wrapperEl[domMethod]('scroll', swiper.onScroll);
      }

      // Resize handler
      if (params.updateOnWindowResize) {
        swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
      } else {
        swiper[swiperMethod]('observerUpdate', onResize, true);
      }

      // Images loader
      el[domMethod]('load', swiper.onLoad, {
        capture: true
      });
    };
    function attachEvents() {
      const swiper = this;
      const {
        params
      } = swiper;
      swiper.onTouchStart = onTouchStart.bind(swiper);
      swiper.onTouchMove = onTouchMove.bind(swiper);
      swiper.onTouchEnd = onTouchEnd.bind(swiper);
      swiper.onDocumentTouchStart = onDocumentTouchStart.bind(swiper);
      if (params.cssMode) {
        swiper.onScroll = onScroll.bind(swiper);
      }
      swiper.onClick = onClick.bind(swiper);
      swiper.onLoad = onLoad.bind(swiper);
      events(swiper, 'on');
    }
    function detachEvents() {
      const swiper = this;
      events(swiper, 'off');
    }
    var events$1 = {
      attachEvents,
      detachEvents
    };
    const isGridEnabled = (swiper, params) => {
      return swiper.grid && params.grid && params.grid.rows > 1;
    };
    function setBreakpoint() {
      const swiper = this;
      const {
        realIndex,
        initialized,
        params,
        el
      } = swiper;
      const breakpoints = params.breakpoints;
      if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
      const document = getDocument();

      // Get breakpoint for window/container width and update parameters
      const breakpointsBase = params.breakpointsBase === 'window' || !params.breakpointsBase ? params.breakpointsBase : 'container';
      const breakpointContainer = ['window', 'container'].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document.querySelector(params.breakpointsBase);
      const breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
      if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
      const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
      const breakpointParams = breakpointOnlyParams || swiper.originalParams;
      const wasMultiRow = isGridEnabled(swiper, params);
      const isMultiRow = isGridEnabled(swiper, breakpointParams);
      const wasGrabCursor = swiper.params.grabCursor;
      const isGrabCursor = breakpointParams.grabCursor;
      const wasEnabled = params.enabled;
      if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
      } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') {
          el.classList.add(`${params.containerModifierClass}grid-column`);
        }
        swiper.emitContainerClasses();
      }
      if (wasGrabCursor && !isGrabCursor) {
        swiper.unsetGrabCursor();
      } else if (!wasGrabCursor && isGrabCursor) {
        swiper.setGrabCursor();
      }

      // Toggle navigation, pagination, scrollbar
      ['navigation', 'pagination', 'scrollbar'].forEach(prop => {
        if (typeof breakpointParams[prop] === 'undefined') return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) {
          swiper[prop].disable();
        }
        if (!wasModuleEnabled && isModuleEnabled) {
          swiper[prop].enable();
        }
      });
      const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
      const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
      const wasLoop = params.loop;
      if (directionChanged && initialized) {
        swiper.changeDirection();
      }
      extend(swiper.params, breakpointParams);
      const isEnabled = swiper.params.enabled;
      const hasLoop = swiper.params.loop;
      Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
      });
      if (wasEnabled && !isEnabled) {
        swiper.disable();
      } else if (!wasEnabled && isEnabled) {
        swiper.enable();
      }
      swiper.currentBreakpoint = breakpoint;
      swiper.emit('_beforeBreakpoint', breakpointParams);
      if (initialized) {
        if (needsReLoop) {
          swiper.loopDestroy();
          swiper.loopCreate(realIndex);
          swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
          swiper.loopCreate(realIndex);
          swiper.updateSlides();
        } else if (wasLoop && !hasLoop) {
          swiper.loopDestroy();
        }
      }
      swiper.emit('breakpoint', breakpointParams);
    }
    function getBreakpoint(breakpoints, base = 'window', containerEl) {
      if (!breakpoints || base === 'container' && !containerEl) return undefined;
      let breakpoint = false;
      const window = getWindow();
      const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
      const points = Object.keys(breakpoints).map(point => {
        if (typeof point === 'string' && point.indexOf('@') === 0) {
          const minRatio = parseFloat(point.substr(1));
          const value = currentHeight * minRatio;
          return {
            value,
            point
          };
        }
        return {
          value: point,
          point
        };
      });
      points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));
      for (let i = 0; i < points.length; i += 1) {
        const {
          point,
          value
        } = points[i];
        if (base === 'window') {
          if (window.matchMedia(`(min-width: ${value}px)`).matches) {
            breakpoint = point;
          }
        } else if (value <= containerEl.clientWidth) {
          breakpoint = point;
        }
      }
      return breakpoint || 'max';
    }
    var breakpoints = {
      setBreakpoint,
      getBreakpoint
    };
    function prepareClasses(entries, prefix) {
      const resultClasses = [];
      entries.forEach(item => {
        if (typeof item === 'object') {
          Object.keys(item).forEach(classNames => {
            if (item[classNames]) {
              resultClasses.push(prefix + classNames);
            }
          });
        } else if (typeof item === 'string') {
          resultClasses.push(prefix + item);
        }
      });
      return resultClasses;
    }
    function addClasses() {
      const swiper = this;
      const {
        classNames,
        params,
        rtl,
        el,
        device
      } = swiper;
      // prettier-ignore
      const suffixes = prepareClasses(['initialized', params.direction, {
        'free-mode': swiper.params.freeMode && params.freeMode.enabled
      }, {
        'autoheight': params.autoHeight
      }, {
        'rtl': rtl
      }, {
        'grid': params.grid && params.grid.rows > 1
      }, {
        'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
      }, {
        'android': device.android
      }, {
        'ios': device.ios
      }, {
        'css-mode': params.cssMode
      }, {
        'centered': params.cssMode && params.centeredSlides
      }, {
        'watch-progress': params.watchSlidesProgress
      }], params.containerModifierClass);
      classNames.push(...suffixes);
      el.classList.add(...classNames);
      swiper.emitContainerClasses();
    }
    function removeClasses() {
      const swiper = this;
      const {
        el,
        classNames
      } = swiper;
      if (!el || typeof el === 'string') return;
      el.classList.remove(...classNames);
      swiper.emitContainerClasses();
    }
    var classes = {
      addClasses,
      removeClasses
    };
    function checkOverflow() {
      const swiper = this;
      const {
        isLocked: wasLocked,
        params
      } = swiper;
      const {
        slidesOffsetBefore
      } = params;
      if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
      } else {
        swiper.isLocked = swiper.snapGrid.length === 1;
      }
      if (params.allowSlideNext === true) {
        swiper.allowSlideNext = !swiper.isLocked;
      }
      if (params.allowSlidePrev === true) {
        swiper.allowSlidePrev = !swiper.isLocked;
      }
      if (wasLocked && wasLocked !== swiper.isLocked) {
        swiper.isEnd = false;
      }
      if (wasLocked !== swiper.isLocked) {
        swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
      }
    }
    var checkOverflow$1 = {
      checkOverflow
    };
    var defaults = {
      init: true,
      direction: 'horizontal',
      oneWayMovement: false,
      swiperElementNodeName: 'SWIPER-CONTAINER',
      touchEventsTarget: 'wrapper',
      initialSlide: 0,
      speed: 300,
      cssMode: false,
      updateOnWindowResize: true,
      resizeObserver: true,
      nested: false,
      createElements: false,
      eventsPrefix: 'swiper',
      enabled: true,
      focusableElements: 'input, select, option, textarea, button, video, label',
      // Overrides
      width: null,
      height: null,
      //
      preventInteractionOnTransition: false,
      // ssr
      userAgent: null,
      url: null,
      // To support iOS's swipe-to-go-back gesture (when being used in-app).
      edgeSwipeDetection: false,
      edgeSwipeThreshold: 20,
      // Autoheight
      autoHeight: false,
      // Set wrapper width
      setWrapperSize: false,
      // Virtual Translate
      virtualTranslate: false,
      // Effects
      effect: 'slide',
      // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

      // Breakpoints
      breakpoints: undefined,
      breakpointsBase: 'window',
      // Slides grid
      spaceBetween: 0,
      slidesPerView: 1,
      slidesPerGroup: 1,
      slidesPerGroupSkip: 0,
      slidesPerGroupAuto: false,
      centeredSlides: false,
      centeredSlidesBounds: false,
      slidesOffsetBefore: 0,
      // in px
      slidesOffsetAfter: 0,
      // in px
      normalizeSlideIndex: true,
      centerInsufficientSlides: false,
      snapToSlideEdge: false,
      // Disable swiper and hide navigation when container not overflow
      watchOverflow: true,
      // Round length
      roundLengths: false,
      // Touches
      touchRatio: 1,
      touchAngle: 45,
      simulateTouch: true,
      shortSwipes: true,
      longSwipes: true,
      longSwipesRatio: 0.5,
      longSwipesMs: 300,
      followFinger: true,
      allowTouchMove: true,
      threshold: 5,
      touchMoveStopPropagation: false,
      touchStartPreventDefault: true,
      touchStartForcePreventDefault: false,
      touchReleaseOnEdges: false,
      // Unique Navigation Elements
      uniqueNavElements: true,
      // Resistance
      resistance: true,
      resistanceRatio: 0.85,
      // Progress
      watchSlidesProgress: false,
      // Cursor
      grabCursor: false,
      // Clicks
      preventClicks: true,
      preventClicksPropagation: true,
      slideToClickedSlide: false,
      // loop
      loop: false,
      loopAddBlankSlides: true,
      loopAdditionalSlides: 0,
      loopPreventsSliding: true,
      // rewind
      rewind: false,
      // Swiping/no swiping
      allowSlidePrev: true,
      allowSlideNext: true,
      swipeHandler: null,
      // '.swipe-handler',
      noSwiping: true,
      noSwipingClass: 'swiper-no-swiping',
      noSwipingSelector: null,
      // Passive Listeners
      passiveListeners: true,
      maxBackfaceHiddenSlides: 10,
      // NS
      containerModifierClass: 'swiper-',
      // NEW
      slideClass: 'swiper-slide',
      slideBlankClass: 'swiper-slide-blank',
      slideActiveClass: 'swiper-slide-active',
      slideVisibleClass: 'swiper-slide-visible',
      slideFullyVisibleClass: 'swiper-slide-fully-visible',
      slideNextClass: 'swiper-slide-next',
      slidePrevClass: 'swiper-slide-prev',
      wrapperClass: 'swiper-wrapper',
      lazyPreloaderClass: 'swiper-lazy-preloader',
      lazyPreloadPrevNext: 0,
      // Callbacks
      runCallbacksOnInit: true,
      // Internals
      _emitClasses: false
    };
    function moduleExtendParams(params, allModulesParams) {
      return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
          extend(allModulesParams, obj);
          return;
        }
        if (params[moduleParamName] === true) {
          params[moduleParamName] = {
            enabled: true
          };
        }
        if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) {
          params[moduleParamName].auto = true;
        }
        if (['pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) {
          params[moduleParamName].auto = true;
        }
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
          extend(allModulesParams, obj);
          return;
        }
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
          params[moduleParamName].enabled = true;
        }
        if (!params[moduleParamName]) params[moduleParamName] = {
          enabled: false
        };
        extend(allModulesParams, obj);
      };
    }

    /* eslint no-param-reassign: "off" */
    const prototypes = {
      eventsEmitter,
      update,
      translate,
      transition,
      slide,
      loop,
      grabCursor,
      events: events$1,
      breakpoints,
      checkOverflow: checkOverflow$1,
      classes
    };
    const extendedDefaults = {};
    class Swiper {
      constructor(...args) {
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
          params = args[0];
        } else {
          [el, params] = args;
        }
        if (!params) params = {};
        params = extend({}, params);
        if (el && !params.el) params.el = el;
        const document = getDocument();
        if (params.el && typeof params.el === 'string' && document.querySelectorAll(params.el).length > 1) {
          const swipers = [];
          document.querySelectorAll(params.el).forEach(containerEl => {
            const newParams = extend({}, params, {
              el: containerEl
            });
            swipers.push(new Swiper(newParams));
          });
          // eslint-disable-next-line no-constructor-return
          return swipers;
        }

        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = getSupport();
        swiper.device = getDevice({
          userAgent: params.userAgent
        });
        swiper.browser = getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [...swiper.__modules__];
        if (params.modules && Array.isArray(params.modules)) {
          params.modules.forEach(mod => {
            if (typeof mod === 'function' && swiper.modules.indexOf(mod) < 0) {
              swiper.modules.push(mod);
            }
          });
        }
        const allModulesParams = {};
        swiper.modules.forEach(mod => {
          mod({
            params,
            swiper,
            extendParams: moduleExtendParams(params, allModulesParams),
            on: swiper.on.bind(swiper),
            once: swiper.once.bind(swiper),
            off: swiper.off.bind(swiper),
            emit: swiper.emit.bind(swiper)
          });
        });

        // Extend defaults with modules params
        const swiperParams = extend({}, defaults, allModulesParams);

        // Extend defaults with passed params
        swiper.params = extend({}, swiperParams, extendedDefaults, params);
        swiper.originalParams = extend({}, swiper.params);
        swiper.passedParams = extend({}, params);

        // add event listeners
        if (swiper.params && swiper.params.on) {
          Object.keys(swiper.params.on).forEach(eventName => {
            swiper.on(eventName, swiper.params.on[eventName]);
          });
        }
        if (swiper.params && swiper.params.onAny) {
          swiper.onAny(swiper.params.onAny);
        }

        // Extend Swiper
        Object.assign(swiper, {
          enabled: swiper.params.enabled,
          el,
          // Classes
          classNames: [],
          // Slides
          slides: [],
          slidesGrid: [],
          snapGrid: [],
          slidesSizesGrid: [],
          // isDirection
          isHorizontal() {
            return swiper.params.direction === 'horizontal';
          },
          isVertical() {
            return swiper.params.direction === 'vertical';
          },
          // Indexes
          activeIndex: 0,
          realIndex: 0,
          //
          isBeginning: true,
          isEnd: false,
          // Props
          translate: 0,
          previousTranslate: 0,
          progress: 0,
          velocity: 0,
          animating: false,
          cssOverflowAdjustment() {
            // Returns 0 unless `translate` is > 2**23
            // Should be subtracted from css values to prevent overflow
            return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
          },
          // Locks
          allowSlideNext: swiper.params.allowSlideNext,
          allowSlidePrev: swiper.params.allowSlidePrev,
          // Touch Events
          touchEventsData: {
            isTouched: undefined,
            isMoved: undefined,
            allowTouchCallbacks: undefined,
            touchStartTime: undefined,
            isScrolling: undefined,
            currentTranslate: undefined,
            startTranslate: undefined,
            allowThresholdMove: undefined,
            // Form elements to match
            focusableElements: swiper.params.focusableElements,
            // Last click time
            lastClickTime: 0,
            clickTimeout: undefined,
            // Velocities
            velocities: [],
            allowMomentumBounce: undefined,
            startMoving: undefined,
            pointerId: null,
            touchId: null
          },
          // Clicks
          allowClick: true,
          // Touches
          allowTouchMove: swiper.params.allowTouchMove,
          touches: {
            startX: 0,
            startY: 0,
            currentX: 0,
            currentY: 0,
            diff: 0
          },
          // Images
          imagesToLoad: [],
          imagesLoaded: 0
        });
        swiper.emit('_swiper');

        // Init
        if (swiper.params.init) {
          swiper.init();
        }

        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
      }
      getDirectionLabel(property) {
        if (this.isHorizontal()) {
          return property;
        }
        // prettier-ignore
        return {
          'width': 'height',
          'margin-top': 'margin-left',
          'margin-bottom ': 'margin-right',
          'margin-left': 'margin-top',
          'margin-right': 'margin-bottom',
          'padding-left': 'padding-top',
          'padding-right': 'padding-bottom',
          'marginRight': 'marginBottom'
        }[property];
      }
      getSlideIndex(slideEl) {
        const {
          slidesEl,
          params
        } = this;
        const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = elementIndex(slides[0]);
        return elementIndex(slideEl) - firstSlideIndex;
      }
      getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.find(slideEl => slideEl.getAttribute('data-swiper-slide-index') * 1 === index));
      }
      getSlideIndexWhenGrid(index) {
        if (this.grid && this.params.grid && this.params.grid.rows > 1) {
          if (this.params.grid.fill === 'column') {
            index = Math.floor(index / this.params.grid.rows);
          } else if (this.params.grid.fill === 'row') {
            index = index % Math.ceil(this.slides.length / this.params.grid.rows);
          }
        }
        return index;
      }
      recalcSlides() {
        const swiper = this;
        const {
          slidesEl,
          params
        } = swiper;
        swiper.slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
      }
      enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) {
          swiper.setGrabCursor();
        }
        swiper.emit('enable');
      }
      disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) {
          swiper.unsetGrabCursor();
        }
        swiper.emit('disable');
      }
      setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(' ').filter(className => {
          return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', cls.join(' '));
      }
      getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return '';
        return slideEl.className.split(' ').filter(className => {
          return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
      }
      emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach(slideEl => {
          const classNames = swiper.getSlideClasses(slideEl);
          updates.push({
            slideEl,
            classNames
          });
          swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
      }
      slidesPerViewDynamic(view = 'current', exact = false) {
        const swiper = this;
        const {
          params,
          slides,
          slidesGrid,
          slidesSizesGrid,
          size: swiperSize,
          activeIndex
        } = swiper;
        let spv = 1;
        if (typeof params.slidesPerView === 'number') return params.slidesPerView;
        if (params.centeredSlides) {
          let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
          let breakLoop;
          for (let i = activeIndex + 1; i < slides.length; i += 1) {
            if (slides[i] && !breakLoop) {
              slideSize += Math.ceil(slides[i].swiperSlideSize);
              spv += 1;
              if (slideSize > swiperSize) breakLoop = true;
            }
          }
          for (let i = activeIndex - 1; i >= 0; i -= 1) {
            if (slides[i] && !breakLoop) {
              slideSize += slides[i].swiperSlideSize;
              spv += 1;
              if (slideSize > swiperSize) breakLoop = true;
            }
          }
        } else {
          // eslint-disable-next-line
          if (view === 'current') {
            for (let i = activeIndex + 1; i < slides.length; i += 1) {
              const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
              if (slideInView) {
                spv += 1;
              }
            }
          } else {
            // previous
            for (let i = activeIndex - 1; i >= 0; i -= 1) {
              const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
              if (slideInView) {
                spv += 1;
              }
            }
          }
        }
        return spv;
      }
      update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const {
          snapGrid,
          params
        } = swiper;
        // Breakpoints
        if (params.breakpoints) {
          swiper.setBreakpoint();
        }
        [...swiper.el.querySelectorAll('[loading="lazy"]')].forEach(imageEl => {
          if (imageEl.complete) {
            processLazyPreloader(swiper, imageEl);
          }
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
          const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
          const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
          swiper.setTranslate(newTranslate);
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
          setTranslate();
          if (params.autoHeight) {
            swiper.updateAutoHeight();
          }
        } else {
          if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
            const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
            translated = swiper.slideTo(slides.length - 1, 0, false, true);
          } else {
            translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
          }
          if (!translated) {
            setTranslate();
          }
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
          swiper.checkOverflow();
        }
        swiper.emit('update');
      }
      changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) {
          // eslint-disable-next-line
          newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        }
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
          return swiper;
        }
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach(slideEl => {
          if (newDirection === 'vertical') {
            slideEl.style.width = '';
          } else {
            slideEl.style.height = '';
          }
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
      }
      changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
          swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
          swiper.el.dir = 'rtl';
        } else {
          swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
          swiper.el.dir = 'ltr';
        }
        swiper.update();
      }
      mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;

        // Find el
        let el = element || swiper.params.el;
        if (typeof el === 'string') {
          el = document.querySelector(el);
        }
        if (!el) {
          return false;
        }
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) {
          swiper.isElement = true;
        }
        const getWrapperSelector = () => {
          return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = () => {
          if (el && el.shadowRoot && el.shadowRoot.querySelector) {
            const res = el.shadowRoot.querySelector(getWrapperSelector());
            // Children needs to return slot items
            return res;
          }
          return elementChildren(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
          wrapperEl = createElement('div', swiper.params.wrapperClass);
          el.append(wrapperEl);
          elementChildren(el, `.${swiper.params.slideClass}`).forEach(slideEl => {
            wrapperEl.append(slideEl);
          });
        }
        Object.assign(swiper, {
          el,
          wrapperEl,
          slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
          hostEl: swiper.isElement ? el.parentNode.host : el,
          mounted: true,
          // RTL
          rtl: el.dir.toLowerCase() === 'rtl' || elementStyle(el, 'direction') === 'rtl',
          rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || elementStyle(el, 'direction') === 'rtl'),
          wrongRTL: elementStyle(wrapperEl, 'display') === '-webkit-box'
        });
        return true;
      }
      init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit');

        // Set breakpoint
        if (swiper.params.breakpoints) {
          swiper.setBreakpoint();
        }

        // Add Classes
        swiper.addClasses();

        // Update size
        swiper.updateSize();

        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) {
          swiper.checkOverflow();
        }

        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) {
          swiper.setGrabCursor();
        }

        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
          swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        } else {
          swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        }

        // Create loop
        if (swiper.params.loop) {
          swiper.loopCreate(undefined, true);
        }

        // Attach events
        swiper.attachEvents();
        const lazyElements = [...swiper.el.querySelectorAll('[loading="lazy"]')];
        if (swiper.isElement) {
          lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        }
        lazyElements.forEach(imageEl => {
          if (imageEl.complete) {
            processLazyPreloader(swiper, imageEl);
          } else {
            imageEl.addEventListener('load', e => {
              processLazyPreloader(swiper, e.target);
            });
          }
        });
        preload(swiper);

        // Init Flag
        swiper.initialized = true;
        preload(swiper);

        // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
      }
      destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const {
          params,
          el,
          wrapperEl,
          slides
        } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) {
          return null;
        }
        swiper.emit('beforeDestroy');

        // Init Flag
        swiper.initialized = false;

        // Detach events
        swiper.detachEvents();

        // Destroy loop
        if (params.loop) {
          swiper.loopDestroy();
        }

        // Cleanup styles
        if (cleanStyles) {
          swiper.removeClasses();
          if (el && typeof el !== 'string') {
            el.removeAttribute('style');
          }
          if (wrapperEl) {
            wrapperEl.removeAttribute('style');
          }
          if (slides && slides.length) {
            slides.forEach(slideEl => {
              slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
              slideEl.removeAttribute('style');
              slideEl.removeAttribute('data-swiper-slide-index');
            });
          }
        }
        swiper.emit('destroy');

        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach(eventName => {
          swiper.off(eventName);
        });
        if (deleteInstance !== false) {
          if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.swiper = null;
          }
          deleteProps(swiper);
        }
        swiper.destroyed = true;
        return null;
      }
      static extendDefaults(newDefaults) {
        extend(extendedDefaults, newDefaults);
      }
      static get extendedDefaults() {
        return extendedDefaults;
      }
      static get defaults() {
        return defaults;
      }
      static installModule(mod) {
        if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
        const modules = Swiper.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
          modules.push(mod);
        }
      }
      static use(module) {
        if (Array.isArray(module)) {
          module.forEach(m => Swiper.installModule(m));
          return Swiper;
        }
        Swiper.installModule(module);
        return Swiper;
      }
    }
    Object.keys(prototypes).forEach(prototypeGroup => {
      Object.keys(prototypes[prototypeGroup]).forEach(protoMethod => {
        Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
      });
    });
    Swiper.use([Resize, Observer]);

    function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
      if (swiper.params.createElements) {
        Object.keys(checkProps).forEach(key => {
          if (!params[key] && params.auto === true) {
            let element = elementChildren(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
              element = createElement('div', checkProps[key]);
              element.className = checkProps[key];
              swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
          }
        });
      }
      return params;
    }

    const arrowSvg = `<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>`;
    function Navigation({
      swiper,
      extendParams,
      on,
      emit
    }) {
      extendParams({
        navigation: {
          nextEl: null,
          prevEl: null,
          addIcons: true,
          hideOnClick: false,
          disabledClass: 'swiper-button-disabled',
          hiddenClass: 'swiper-button-hidden',
          lockClass: 'swiper-button-lock',
          navigationDisabledClass: 'swiper-navigation-disabled'
        }
      });
      swiper.navigation = {
        nextEl: null,
        prevEl: null,
        arrowSvg
      };
      function getEl(el) {
        let res;
        if (el && typeof el === 'string' && swiper.isElement) {
          res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
          if (res) return res;
        }
        if (el) {
          if (typeof el === 'string') res = [...document.querySelectorAll(el)];
          if (swiper.params.uniqueNavElements && typeof el === 'string' && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) {
            res = swiper.el.querySelector(el);
          } else if (res && res.length === 1) {
            res = res[0];
          }
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
      }
      function toggleEl(el, disabled) {
        const params = swiper.params.navigation;
        el = makeElementsArray(el);
        el.forEach(subEl => {
          if (subEl) {
            subEl.classList[disabled ? 'add' : 'remove'](...params.disabledClass.split(' '));
            if (subEl.tagName === 'BUTTON') subEl.disabled = disabled;
            if (swiper.params.watchOverflow && swiper.enabled) {
              subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
            }
          }
        });
      }
      function update() {
        // Update Navigation Buttons
        const {
          nextEl,
          prevEl
        } = swiper.navigation;
        if (swiper.params.loop) {
          toggleEl(prevEl, false);
          toggleEl(nextEl, false);
          return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
      }
      function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
      }
      function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
      }
      function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
          nextEl: 'swiper-button-next',
          prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        let nextEl = getEl(params.nextEl);
        let prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
          nextEl,
          prevEl
        });
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        const initButton = (el, dir) => {
          if (el) {
            if (params.addIcons && el.matches('.swiper-button-next,.swiper-button-prev') && !el.querySelector('svg')) {
              const tempEl = document.createElement('div');
              setInnerHTML(tempEl, arrowSvg);
              el.appendChild(tempEl.querySelector('svg'));
              tempEl.remove();
            }
            el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
          }
          if (!swiper.enabled && el) {
            el.classList.add(...params.lockClass.split(' '));
          }
        };
        nextEl.forEach(el => initButton(el, 'next'));
        prevEl.forEach(el => initButton(el, 'prev'));
      }
      function destroy() {
        let {
          nextEl,
          prevEl
        } = swiper.navigation;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        const destroyButton = (el, dir) => {
          el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
          el.classList.remove(...swiper.params.navigation.disabledClass.split(' '));
        };
        nextEl.forEach(el => destroyButton(el, 'next'));
        prevEl.forEach(el => destroyButton(el, 'prev'));
      }
      on('init', () => {
        if (swiper.params.navigation.enabled === false) {
          // eslint-disable-next-line
          disable();
        } else {
          init();
          update();
        }
      });
      on('toEdge fromEdge lock unlock', () => {
        update();
      });
      on('destroy', () => {
        destroy();
      });
      on('enable disable', () => {
        let {
          nextEl,
          prevEl
        } = swiper.navigation;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        if (swiper.enabled) {
          update();
          return;
        }
        [...nextEl, ...prevEl].filter(el => !!el).forEach(el => el.classList.add(swiper.params.navigation.lockClass));
      });
      on('click', (_s, e) => {
        let {
          nextEl,
          prevEl
        } = swiper.navigation;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        const targetEl = e.target;
        let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
          const path = e.path || e.composedPath && e.composedPath();
          if (path) {
            targetIsButton = path.find(pathEl => nextEl.includes(pathEl) || prevEl.includes(pathEl));
          }
        }
        if (swiper.params.navigation.hideOnClick && !targetIsButton) {
          if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
          let isHidden;
          if (nextEl.length) {
            isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
          } else if (prevEl.length) {
            isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
          }
          if (isHidden === true) {
            emit('navigationShow');
          } else {
            emit('navigationHide');
          }
          [...nextEl, ...prevEl].filter(el => !!el).forEach(el => el.classList.toggle(swiper.params.navigation.hiddenClass));
        }
      });
      const enable = () => {
        swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(' '));
        init();
        update();
      };
      const disable = () => {
        swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(' '));
        destroy();
      };
      Object.assign(swiper.navigation, {
        enable,
        disable,
        update,
        init,
        destroy
      });
    }

    function classesToSelector(classes = '') {
      // Escape all CSS selector special characters
      return `.${classes.trim().replace(/([\.:!+\/()[\]#>~*^$|=,'"@{}\\])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.')}`;
    }

    function Pagination({
      swiper,
      extendParams,
      on,
      emit
    }) {
      const pfx = 'swiper-pagination';
      extendParams({
        pagination: {
          el: null,
          bulletElement: 'span',
          clickable: false,
          hideOnClick: false,
          renderBullet: null,
          renderProgressbar: null,
          renderFraction: null,
          renderCustom: null,
          progressbarOpposite: false,
          type: 'bullets',
          // 'bullets' or 'progressbar' or 'fraction' or 'custom'
          dynamicBullets: false,
          dynamicMainBullets: 1,
          formatFractionCurrent: number => number,
          formatFractionTotal: number => number,
          bulletClass: `${pfx}-bullet`,
          bulletActiveClass: `${pfx}-bullet-active`,
          modifierClass: `${pfx}-`,
          currentClass: `${pfx}-current`,
          totalClass: `${pfx}-total`,
          hiddenClass: `${pfx}-hidden`,
          progressbarFillClass: `${pfx}-progressbar-fill`,
          progressbarOppositeClass: `${pfx}-progressbar-opposite`,
          clickableClass: `${pfx}-clickable`,
          lockClass: `${pfx}-lock`,
          horizontalClass: `${pfx}-horizontal`,
          verticalClass: `${pfx}-vertical`,
          paginationDisabledClass: `${pfx}-disabled`
        }
      });
      swiper.pagination = {
        el: null,
        bullets: []
      };
      let bulletSize;
      let dynamicBulletIndex = 0;
      function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
      }
      function setSideBullets(bulletEl, position) {
        const {
          bulletActiveClass
        } = swiper.params.pagination;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
        if (bulletEl) {
          bulletEl.classList.add(`${bulletActiveClass}-${position}`);
          bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
          if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
          }
        }
      }
      function getMoveDirection(prevIndex, nextIndex, length) {
        prevIndex = prevIndex % length;
        nextIndex = nextIndex % length;
        if (nextIndex === prevIndex + 1) {
          return 'next';
        } else if (nextIndex === prevIndex - 1) {
          return 'previous';
        }
        return;
      }
      function onBulletClick(e) {
        const bulletEl = e.target.closest(classesToSelector(swiper.params.pagination.bulletClass));
        if (!bulletEl) {
          return;
        }
        e.preventDefault();
        const index = elementIndex(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
          if (swiper.realIndex === index) return;
          const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
          if (moveDirection === 'next') {
            swiper.slideNext();
          } else if (moveDirection === 'previous') {
            swiper.slidePrev();
          } else {
            swiper.slideToLoop(index);
          }
        } else {
          swiper.slideTo(index);
        }
      }
      function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        el = makeElementsArray(el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
          previousIndex = swiper.previousRealIndex || 0;
          current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== 'undefined') {
          current = swiper.snapIndex;
          previousIndex = swiper.previousSnapIndex;
        } else {
          previousIndex = swiper.previousIndex || 0;
          current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
          const bullets = swiper.pagination.bullets;
          let firstIndex;
          let lastIndex;
          let midIndex;
          if (params.dynamicBullets) {
            bulletSize = elementOuterSize(bullets[0], swiper.isHorizontal() ? 'width' : 'height', true);
            el.forEach(subEl => {
              subEl.style[swiper.isHorizontal() ? 'width' : 'height'] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
            });
            if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
              dynamicBulletIndex += current - (previousIndex || 0);
              if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
                dynamicBulletIndex = params.dynamicMainBullets - 1;
              } else if (dynamicBulletIndex < 0) {
                dynamicBulletIndex = 0;
              }
            }
            firstIndex = Math.max(current - dynamicBulletIndex, 0);
            lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
            midIndex = (lastIndex + firstIndex) / 2;
          }
          bullets.forEach(bulletEl => {
            const classesToRemove = [...['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map(suffix => `${params.bulletActiveClass}${suffix}`)].map(s => typeof s === 'string' && s.includes(' ') ? s.split(' ') : s).flat();
            bulletEl.classList.remove(...classesToRemove);
          });
          if (el.length > 1) {
            bullets.forEach(bullet => {
              const bulletIndex = elementIndex(bullet);
              if (bulletIndex === current) {
                bullet.classList.add(...params.bulletActiveClass.split(' '));
              } else if (swiper.isElement) {
                bullet.setAttribute('part', 'bullet');
              }
              if (params.dynamicBullets) {
                if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                  bullet.classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                }
                if (bulletIndex === firstIndex) {
                  setSideBullets(bullet, 'prev');
                }
                if (bulletIndex === lastIndex) {
                  setSideBullets(bullet, 'next');
                }
              }
            });
          } else {
            const bullet = bullets[current];
            if (bullet) {
              bullet.classList.add(...params.bulletActiveClass.split(' '));
            }
            if (swiper.isElement) {
              bullets.forEach((bulletEl, bulletIndex) => {
                bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
              });
            }
            if (params.dynamicBullets) {
              const firstDisplayedBullet = bullets[firstIndex];
              const lastDisplayedBullet = bullets[lastIndex];
              for (let i = firstIndex; i <= lastIndex; i += 1) {
                if (bullets[i]) {
                  bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                }
              }
              setSideBullets(firstDisplayedBullet, 'prev');
              setSideBullets(lastDisplayedBullet, 'next');
            }
          }
          if (params.dynamicBullets) {
            const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
            const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
            const offsetProp = rtl ? 'right' : 'left';
            bullets.forEach(bullet => {
              bullet.style[swiper.isHorizontal() ? offsetProp : 'top'] = `${bulletsOffset}px`;
            });
          }
        }
        el.forEach((subEl, subElIndex) => {
          if (params.type === 'fraction') {
            subEl.querySelectorAll(classesToSelector(params.currentClass)).forEach(fractionEl => {
              fractionEl.textContent = params.formatFractionCurrent(current + 1);
            });
            subEl.querySelectorAll(classesToSelector(params.totalClass)).forEach(totalEl => {
              totalEl.textContent = params.formatFractionTotal(total);
            });
          }
          if (params.type === 'progressbar') {
            let progressbarDirection;
            if (params.progressbarOpposite) {
              progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
            } else {
              progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
            }
            const scale = (current + 1) / total;
            let scaleX = 1;
            let scaleY = 1;
            if (progressbarDirection === 'horizontal') {
              scaleX = scale;
            } else {
              scaleY = scale;
            }
            subEl.querySelectorAll(classesToSelector(params.progressbarFillClass)).forEach(progressEl => {
              progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
              progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
            });
          }
          if (params.type === 'custom' && params.renderCustom) {
            setInnerHTML(subEl, params.renderCustom(swiper, current + 1, total));
            if (subElIndex === 0) emit('paginationRender', subEl);
          } else {
            if (subElIndex === 0) emit('paginationRender', subEl);
            emit('paginationUpdate', subEl);
          }
          if (swiper.params.watchOverflow && swiper.enabled) {
            subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
          }
        });
      }
      function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
        let el = swiper.pagination.el;
        el = makeElementsArray(el);
        let paginationHTML = '';
        if (params.type === 'bullets') {
          let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
          if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) {
            numberOfBullets = slidesLength;
          }
          for (let i = 0; i < numberOfBullets; i += 1) {
            if (params.renderBullet) {
              paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            } else {
              // prettier-ignore
              paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
            }
          }
        }
        if (params.type === 'fraction') {
          if (params.renderFraction) {
            paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
          } else {
            paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
          }
        }
        if (params.type === 'progressbar') {
          if (params.renderProgressbar) {
            paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
          } else {
            paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
          }
        }
        swiper.pagination.bullets = [];
        el.forEach(subEl => {
          if (params.type !== 'custom') {
            setInnerHTML(subEl, paginationHTML || '');
          }
          if (params.type === 'bullets') {
            swiper.pagination.bullets.push(...subEl.querySelectorAll(classesToSelector(params.bulletClass)));
          }
        });
        if (params.type !== 'custom') {
          emit('paginationRender', el[0]);
        }
      }
      function init() {
        swiper.params.pagination = createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
          el: 'swiper-pagination'
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) {
          el = swiper.el.querySelector(params.el);
        }
        if (!el && typeof params.el === 'string') {
          el = [...document.querySelectorAll(params.el)];
        }
        if (!el) {
          el = params.el;
        }
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
          el = [...swiper.el.querySelectorAll(params.el)];
          // check if it belongs to another nested Swiper
          if (el.length > 1) {
            el = el.find(subEl => {
              if (elementParents(subEl, '.swiper')[0] !== swiper.el) return false;
              return true;
            });
          }
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
          el
        });
        el = makeElementsArray(el);
        el.forEach(subEl => {
          if (params.type === 'bullets' && params.clickable) {
            subEl.classList.add(...(params.clickableClass || '').split(' '));
          }
          subEl.classList.add(params.modifierClass + params.type);
          subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
          if (params.type === 'bullets' && params.dynamicBullets) {
            subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
            dynamicBulletIndex = 0;
            if (params.dynamicMainBullets < 1) {
              params.dynamicMainBullets = 1;
            }
          }
          if (params.type === 'progressbar' && params.progressbarOpposite) {
            subEl.classList.add(params.progressbarOppositeClass);
          }
          if (params.clickable) {
            subEl.addEventListener('click', onBulletClick);
          }
          if (!swiper.enabled) {
            subEl.classList.add(params.lockClass);
          }
        });
      }
      function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        if (el) {
          el = makeElementsArray(el);
          el.forEach(subEl => {
            subEl.classList.remove(params.hiddenClass);
            subEl.classList.remove(params.modifierClass + params.type);
            subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.clickable) {
              subEl.classList.remove(...(params.clickableClass || '').split(' '));
              subEl.removeEventListener('click', onBulletClick);
            }
          });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach(subEl => subEl.classList.remove(...params.bulletActiveClass.split(' ')));
      }
      on('changeDirection', () => {
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = swiper.params.pagination;
        let {
          el
        } = swiper.pagination;
        el = makeElementsArray(el);
        el.forEach(subEl => {
          subEl.classList.remove(params.horizontalClass, params.verticalClass);
          subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
      });
      on('init', () => {
        if (swiper.params.pagination.enabled === false) {
          // eslint-disable-next-line
          disable();
        } else {
          init();
          render();
          update();
        }
      });
      on('activeIndexChange', () => {
        if (typeof swiper.snapIndex === 'undefined') {
          update();
        }
      });
      on('snapIndexChange', () => {
        update();
      });
      on('snapGridLengthChange', () => {
        render();
        update();
      });
      on('destroy', () => {
        destroy();
      });
      on('enable disable', () => {
        let {
          el
        } = swiper.pagination;
        if (el) {
          el = makeElementsArray(el);
          el.forEach(subEl => subEl.classList[swiper.enabled ? 'remove' : 'add'](swiper.params.pagination.lockClass));
        }
      });
      on('lock unlock', () => {
        update();
      });
      on('click', (_s, e) => {
        const targetEl = e.target;
        const el = makeElementsArray(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
          if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
          const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
          if (isHidden === true) {
            emit('paginationShow');
          } else {
            emit('paginationHide');
          }
          el.forEach(subEl => subEl.classList.toggle(swiper.params.pagination.hiddenClass));
        }
      });
      const enable = () => {
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        let {
          el
        } = swiper.pagination;
        if (el) {
          el = makeElementsArray(el);
          el.forEach(subEl => subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
        }
        init();
        render();
        update();
      };
      const disable = () => {
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        let {
          el
        } = swiper.pagination;
        if (el) {
          el = makeElementsArray(el);
          el.forEach(subEl => subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
        }
        destroy();
      };
      Object.assign(swiper.pagination, {
        enable,
        disable,
        render,
        update,
        init,
        destroy
      });
    }

    /* eslint no-underscore-dangle: "off" */
    /* eslint no-use-before-define: "off" */
    function Autoplay({
      swiper,
      extendParams,
      on,
      emit,
      params
    }) {
      swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
      };
      extendParams({
        autoplay: {
          enabled: false,
          delay: 3000,
          waitForTransition: true,
          disableOnInteraction: false,
          stopOnLastSlide: false,
          reverseDirection: false,
          pauseOnMouseEnter: false
        }
      });
      let timeout;
      let raf;
      let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
      let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
      let autoplayTimeLeft;
      let autoplayStartTime = new Date().getTime();
      let wasPaused;
      let isTouched;
      let pausedByTouch;
      let touchStartTimeout;
      let pausedByInteraction;
      let pausedByPointerEnter;
      function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
        if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) {
          return;
        }
        resume();
      }
      const calcTimeLeft = () => {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) {
          wasPaused = true;
        } else if (wasPaused) {
          autoplayDelayCurrent = autoplayTimeLeft;
          wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(() => {
          calcTimeLeft();
        });
      };
      const getSlideDelay = () => {
        let activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) {
          activeSlideEl = swiper.slides.find(slideEl => slideEl.classList.contains('swiper-slide-active'));
        } else {
          activeSlideEl = swiper.slides[swiper.activeIndex];
        }
        if (!activeSlideEl) return undefined;
        const currentSlideDelay = parseInt(activeSlideEl.getAttribute('data-swiper-autoplay'), 10);
        return currentSlideDelay;
      };
      const getTotalDelay = () => {
        let totalDelay = swiper.params.autoplay.delay;
        const currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0) {
          totalDelay = currentSlideDelay;
        }
        return totalDelay;
      };
      const run = delayForce => {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = delayForce;
        if (typeof delay === 'undefined') {
          delay = getTotalDelay();
          autoplayDelayTotal = delay;
          autoplayDelayCurrent = delay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = () => {
          if (!swiper || swiper.destroyed) return;
          if (swiper.params.autoplay.reverseDirection) {
            if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
              swiper.slidePrev(speed, true, true);
              emit('autoplay');
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
              swiper.slideTo(swiper.slides.length - 1, speed, true, true);
              emit('autoplay');
            }
          } else {
            if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
              swiper.slideNext(speed, true, true);
              emit('autoplay');
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
              swiper.slideTo(0, speed, true, true);
              emit('autoplay');
            }
          }
          if (swiper.params.cssMode) {
            autoplayStartTime = new Date().getTime();
            requestAnimationFrame(() => {
              run();
            });
          }
        };
        if (delay > 0) {
          clearTimeout(timeout);
          timeout = setTimeout(() => {
            proceed();
          }, delay);
        } else {
          requestAnimationFrame(() => {
            proceed();
          });
        }

        // eslint-disable-next-line
        return delay;
      };
      const start = () => {
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit('autoplayStart');
      };
      const stop = () => {
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit('autoplayStop');
      };
      const pause = (internal, reset) => {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) {
          pausedByInteraction = true;
        }
        const proceed = () => {
          emit('autoplayPause');
          if (swiper.params.autoplay.waitForTransition) {
            swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
          } else {
            resume();
          }
        };
        swiper.autoplay.paused = true;
        if (reset) {
          proceed();
          return;
        }
        const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
      };
      const resume = () => {
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
          pausedByInteraction = false;
          run(autoplayTimeLeft);
        } else {
          run();
        }
        swiper.autoplay.paused = false;
        emit('autoplayResume');
      };
      const onVisibilityChange = () => {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        const document = getDocument();
        if (document.visibilityState === 'hidden') {
          pausedByInteraction = true;
          pause(true);
        }
        if (document.visibilityState === 'visible') {
          resume();
        }
      };
      const onPointerEnter = e => {
        if (e.pointerType !== 'mouse') return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
      };
      const onPointerLeave = e => {
        if (e.pointerType !== 'mouse') return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) {
          resume();
        }
      };
      const attachMouseEvents = () => {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
          swiper.el.addEventListener('pointerenter', onPointerEnter);
          swiper.el.addEventListener('pointerleave', onPointerLeave);
        }
      };
      const detachMouseEvents = () => {
        if (swiper.el && typeof swiper.el !== 'string') {
          swiper.el.removeEventListener('pointerenter', onPointerEnter);
          swiper.el.removeEventListener('pointerleave', onPointerLeave);
        }
      };
      const attachDocumentEvents = () => {
        const document = getDocument();
        document.addEventListener('visibilitychange', onVisibilityChange);
      };
      const detachDocumentEvents = () => {
        const document = getDocument();
        document.removeEventListener('visibilitychange', onVisibilityChange);
      };
      on('init', () => {
        if (swiper.params.autoplay.enabled) {
          attachMouseEvents();
          attachDocumentEvents();
          start();
        }
      });
      on('destroy', () => {
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) {
          stop();
        }
      });
      on('_freeModeStaticRelease', () => {
        if (pausedByTouch || pausedByInteraction) {
          resume();
        }
      });
      on('_freeModeNoMomentumRelease', () => {
        if (!swiper.params.autoplay.disableOnInteraction) {
          pause(true, true);
        } else {
          stop();
        }
      });
      on('beforeTransitionStart', (_s, speed, internal) => {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) {
          pause(true, true);
        } else {
          stop();
        }
      });
      on('sliderFirstMove', () => {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
          stop();
          return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(() => {
          pausedByInteraction = true;
          pausedByTouch = true;
          pause(true);
        }, 200);
      });
      on('touchEnd', () => {
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
          pausedByTouch = false;
          isTouched = false;
          return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
      });
      on('slideChange', () => {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) {
          autoplayTimeLeft = getTotalDelay();
          autoplayDelayTotal = getTotalDelay();
        }
      });
      Object.assign(swiper.autoplay, {
        start,
        stop,
        pause,
        resume
      });
    }

    function Thumb({
      swiper,
      extendParams,
      on
    }) {
      extendParams({
        thumbs: {
          swiper: null,
          multipleActiveThumbs: true,
          autoScrollOffset: 0,
          slideThumbActiveClass: 'swiper-slide-thumb-active',
          thumbsContainerClass: 'swiper-thumbs'
        }
      });
      let initialized = false;
      let swiperCreated = false;
      swiper.thumbs = {
        swiper: null
      };
      function isVirtualEnabled() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return false;
        return thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled;
      }
      function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) {
          slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        } else {
          slideToIndex = clickedIndex;
        }
        if (swiper.params.loop) {
          swiper.slideToLoop(slideToIndex);
        } else {
          swiper.slideTo(slideToIndex);
        }
      }
      function init() {
        const {
          thumbs: thumbsParams
        } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
          if (thumbsParams.swiper.destroyed) {
            initialized = false;
            return false;
          }
          swiper.thumbs.swiper = thumbsParams.swiper;
          Object.assign(swiper.thumbs.swiper.originalParams, {
            watchSlidesProgress: true,
            slideToClickedSlide: false
          });
          Object.assign(swiper.thumbs.swiper.params, {
            watchSlidesProgress: true,
            slideToClickedSlide: false
          });
          swiper.thumbs.swiper.update();
        } else if (isObject(thumbsParams.swiper)) {
          const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
          Object.assign(thumbsSwiperParams, {
            watchSlidesProgress: true,
            slideToClickedSlide: false
          });
          swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
          swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        if (isVirtualEnabled()) {
          swiper.thumbs.swiper.on('virtualUpdate', () => {
            update(false, {
              autoScroll: false
            });
          });
        }
        return true;
      }
      function update(initial, p) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;

        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
          thumbsToActivate = swiper.params.slidesPerView;
        }
        if (!swiper.params.thumbs.multipleActiveThumbs) {
          thumbsToActivate = 1;
        }
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach(slideEl => slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || isVirtualEnabled()) {
          for (let i = 0; i < thumbsToActivate; i += 1) {
            elementChildren(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach(slideEl => {
              slideEl.classList.add(thumbActiveClass);
            });
          }
        } else {
          for (let i = 0; i < thumbsToActivate; i += 1) {
            if (thumbsSwiper.slides[swiper.realIndex + i]) {
              thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
            }
          }
        }
        if (p?.autoScroll ?? true) {
          autoScroll(initial ? 0 : undefined);
        }
      }
      function autoScroll(slideSpeed) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
          const currentThumbsIndex = thumbsSwiper.activeIndex;
          let newThumbsIndex;
          let direction;
          if (thumbsSwiper.params.loop) {
            const newThumbsSlide = thumbsSwiper.slides.find(slideEl => slideEl.getAttribute('data-swiper-slide-index') === `${swiper.realIndex}`);
            newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
            direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
          } else {
            newThumbsIndex = swiper.realIndex;
            direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
          }
          if (useOffset) {
            newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
          }
          if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
            if (thumbsSwiper.params.centeredSlides) {
              if (newThumbsIndex > currentThumbsIndex) {
                newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
              } else {
                newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
              }
            } else if (newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup === 1) ;
            thumbsSwiper.slideTo(newThumbsIndex, slideSpeed);
          }
        }
      }
      on('beforeInit', () => {
        const {
          thumbs
        } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === 'string' || thumbs.swiper instanceof HTMLElement) {
          const document = getDocument();
          const getThumbsElementAndInit = () => {
            const thumbsElement = typeof thumbs.swiper === 'string' ? document.querySelector(thumbs.swiper) : thumbs.swiper;
            if (thumbsElement && thumbsElement.swiper) {
              thumbs.swiper = thumbsElement.swiper;
              init();
              update(true);
            } else if (thumbsElement) {
              const eventName = `${swiper.params.eventsPrefix}init`;
              const onThumbsSwiper = e => {
                thumbs.swiper = e.detail[0];
                thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                init();
                update(true);
                thumbs.swiper.update();
                swiper.update();
              };
              thumbsElement.addEventListener(eventName, onThumbsSwiper);
            }
            return thumbsElement;
          };
          const watchForThumbsToAppear = () => {
            if (swiper.destroyed) return;
            const thumbsElement = getThumbsElementAndInit();
            if (!thumbsElement) {
              requestAnimationFrame(watchForThumbsToAppear);
            }
          };
          requestAnimationFrame(watchForThumbsToAppear);
        } else {
          init();
          update(true);
        }
      });
      on('slideChange update resize observerUpdate', () => {
        update();
      });
      on('setTransition', (_s, duration) => {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
      });
      on('beforeDestroy', () => {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) {
          thumbsSwiper.destroy();
        }
      });
      Object.assign(swiper.thumbs, {
        init,
        update
      });
    }

    function freeMode({
      swiper,
      extendParams,
      emit,
      once
    }) {
      extendParams({
        freeMode: {
          enabled: false,
          momentum: true,
          momentumRatio: 1,
          momentumBounce: true,
          momentumBounceRatio: 1,
          momentumVelocityRatio: 1,
          sticky: false,
          minimumVelocity: 0.02
        }
      });
      function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
          currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
      }
      function onTouchMove() {
        if (swiper.params.cssMode) return;
        const {
          touchEventsData: data,
          touches
        } = swiper;
        // Velocity
        if (data.velocities.length === 0) {
          data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
          });
        }
        data.velocities.push({
          position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
          time: now()
        });
      }
      function onTouchEnd({
        currentPos
      }) {
        if (swiper.params.cssMode) return;
        const {
          params,
          wrapperEl,
          rtlTranslate: rtl,
          snapGrid,
          touchEventsData: data
        } = swiper;
        // Time diff
        const touchEndTime = now();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
          swiper.slideTo(swiper.activeIndex);
          return;
        }
        if (currentPos > -swiper.maxTranslate()) {
          if (swiper.slides.length < snapGrid.length) {
            swiper.slideTo(snapGrid.length - 1);
          } else {
            swiper.slideTo(swiper.slides.length - 1);
          }
          return;
        }
        if (params.freeMode.momentum) {
          if (data.velocities.length > 1) {
            const lastMoveEvent = data.velocities.pop();
            const velocityEvent = data.velocities.pop();
            const distance = lastMoveEvent.position - velocityEvent.position;
            const time = lastMoveEvent.time - velocityEvent.time;
            swiper.velocity = distance / time;
            swiper.velocity /= 2;
            if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) {
              swiper.velocity = 0;
            }
            // this implies that the user stopped moving a finger then released.
            // There would be no events with distance zero, so the last event is stale.
            if (time > 150 || now() - lastMoveEvent.time > 300) {
              swiper.velocity = 0;
            }
          } else {
            swiper.velocity = 0;
          }
          swiper.velocity *= params.freeMode.momentumVelocityRatio;
          data.velocities.length = 0;
          let momentumDuration = 1000 * params.freeMode.momentumRatio;
          const momentumDistance = swiper.velocity * momentumDuration;
          let newPosition = swiper.translate + momentumDistance;
          if (rtl) newPosition = -newPosition;
          let doBounce = false;
          let afterBouncePosition;
          const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
          let needsLoopFix;
          if (newPosition < swiper.maxTranslate()) {
            if (params.freeMode.momentumBounce) {
              if (newPosition + swiper.maxTranslate() < -bounceAmount) {
                newPosition = swiper.maxTranslate() - bounceAmount;
              }
              afterBouncePosition = swiper.maxTranslate();
              doBounce = true;
              data.allowMomentumBounce = true;
            } else {
              newPosition = swiper.maxTranslate();
            }
            if (params.loop && params.centeredSlides) needsLoopFix = true;
          } else if (newPosition > swiper.minTranslate()) {
            if (params.freeMode.momentumBounce) {
              if (newPosition - swiper.minTranslate() > bounceAmount) {
                newPosition = swiper.minTranslate() + bounceAmount;
              }
              afterBouncePosition = swiper.minTranslate();
              doBounce = true;
              data.allowMomentumBounce = true;
            } else {
              newPosition = swiper.minTranslate();
            }
            if (params.loop && params.centeredSlides) needsLoopFix = true;
          } else if (params.freeMode.sticky) {
            let nextSlide;
            for (let j = 0; j < snapGrid.length; j += 1) {
              if (snapGrid[j] > -newPosition) {
                nextSlide = j;
                break;
              }
            }
            if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
              newPosition = snapGrid[nextSlide];
            } else {
              newPosition = snapGrid[nextSlide - 1];
            }
            newPosition = -newPosition;
          }
          if (needsLoopFix) {
            once('transitionEnd', () => {
              swiper.loopFix();
            });
          }
          // Fix duration
          if (swiper.velocity !== 0) {
            if (rtl) {
              momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
            } else {
              momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
            }
            if (params.freeMode.sticky) {
              // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
              // event, then durations can be 20+ seconds to slide one (or zero!) slides.
              // It's easy to see this when simulating touch with mouse events. To fix this,
              // limit single-slide swipes to the default slide duration. This also has the
              // nice side effect of matching slide speed if the user stopped moving before
              // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
              // For faster swipes, also apply limits (albeit higher ones).
              const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
              const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
              if (moveDistance < currentSlideSize) {
                momentumDuration = params.speed;
              } else if (moveDistance < 2 * currentSlideSize) {
                momentumDuration = params.speed * 1.5;
              } else {
                momentumDuration = params.speed * 2.5;
              }
            }
          } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
          }
          if (params.freeMode.momentumBounce && doBounce) {
            swiper.updateProgress(afterBouncePosition);
            swiper.setTransition(momentumDuration);
            swiper.setTranslate(newPosition);
            swiper.transitionStart(true, swiper.swipeDirection);
            swiper.animating = true;
            elementTransitionEnd(wrapperEl, () => {
              if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
              emit('momentumBounce');
              swiper.setTransition(params.speed);
              setTimeout(() => {
                swiper.setTranslate(afterBouncePosition);
                elementTransitionEnd(wrapperEl, () => {
                  if (!swiper || swiper.destroyed) return;
                  swiper.transitionEnd();
                });
              }, 0);
            });
          } else if (swiper.velocity) {
            emit('_freeModeNoMomentumRelease');
            swiper.updateProgress(newPosition);
            swiper.setTransition(momentumDuration);
            swiper.setTranslate(newPosition);
            swiper.transitionStart(true, swiper.swipeDirection);
            if (!swiper.animating) {
              swiper.animating = true;
              elementTransitionEnd(wrapperEl, () => {
                if (!swiper || swiper.destroyed) return;
                swiper.transitionEnd();
              });
            }
          } else {
            swiper.updateProgress(newPosition);
          }
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
          swiper.slideToClosest();
          return;
        } else if (params.freeMode) {
          emit('_freeModeNoMomentumRelease');
        }
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
          emit('_freeModeStaticRelease');
          swiper.updateProgress();
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
        }
      }
      Object.assign(swiper, {
        freeMode: {
          onTouchStart,
          onTouchMove,
          onTouchEnd
        }
      });
    }

    function effectInit(params) {
      const {
        effect,
        swiper,
        on,
        setTranslate,
        setTransition,
        overwriteParams,
        perspective,
        recreateShadows,
        getEffectParams
      } = params;
      on('beforeInit', () => {
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) {
          swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        }
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
      });
      on('setTranslate _virtualUpdated', () => {
        if (swiper.params.effect !== effect) return;
        setTranslate();
      });
      on('setTransition', (_s, duration) => {
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
      });
      on('transitionEnd', () => {
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
          if (!getEffectParams || !getEffectParams().slideShadows) return;
          // remove shadows
          swiper.slides.forEach(slideEl => {
            slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(shadowEl => shadowEl.remove());
          });
          // create new one
          recreateShadows();
        }
      });
      let requireUpdateOnVirtual;
      on('virtualUpdate', () => {
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) {
          requireUpdateOnVirtual = true;
        }
        requestAnimationFrame(() => {
          if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
            setTranslate();
            requireUpdateOnVirtual = false;
          }
        });
      });
    }

    function effectTarget(effectParams, slideEl) {
      const transformEl = getSlideTransformEl(slideEl);
      if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = 'hidden';
        transformEl.style['-webkit-backface-visibility'] = 'hidden';
      }
      return transformEl;
    }

    function effectVirtualTransitionEnd({
      swiper,
      duration,
      transformElements,
      allSlides
    }) {
      const {
        activeIndex
      } = swiper;
      const getSlide = el => {
        if (!el.parentElement) {
          // assume shadow root
          const slide = swiper.slides.find(slideEl => slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode);
          return slide;
        }
        return el.parentElement;
      };
      if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) {
          transitionEndTarget = transformElements;
        } else {
          transitionEndTarget = transformElements.filter(transformEl => {
            const el = transformEl.classList.contains('swiper-slide-transform') ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
          });
        }
        transitionEndTarget.forEach(el => {
          elementTransitionEnd(el, () => {
            if (eventTriggered) return;
            if (!swiper || swiper.destroyed) return;
            eventTriggered = true;
            swiper.animating = false;
            const evt = new window.CustomEvent('transitionend', {
              bubbles: true,
              cancelable: true
            });
            swiper.wrapperEl.dispatchEvent(evt);
          });
        });
      }
    }

    function EffectFade({
      swiper,
      extendParams,
      on
    }) {
      extendParams({
        fadeEffect: {
          crossFade: false
        }
      });
      const setTranslate = () => {
        const {
          slides
        } = swiper;
        const params = swiper.params.fadeEffect;
        for (let i = 0; i < slides.length; i += 1) {
          const slideEl = swiper.slides[i];
          const offset = slideEl.swiperSlideOffset;
          let tx = -offset;
          if (!swiper.params.virtualTranslate) tx -= swiper.translate;
          let ty = 0;
          if (!swiper.isHorizontal()) {
            ty = tx;
            tx = 0;
          }
          const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
          const targetEl = effectTarget(params, slideEl);
          targetEl.style.opacity = slideOpacity;
          targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
      };
      const setTransition = duration => {
        const transformElements = swiper.slides.map(slideEl => getSlideTransformEl(slideEl));
        transformElements.forEach(el => {
          el.style.transitionDuration = `${duration}ms`;
        });
        effectVirtualTransitionEnd({
          swiper,
          duration,
          transformElements,
          allSlides: true
        });
      };
      effectInit({
        effect: 'fade',
        swiper,
        on,
        setTranslate,
        setTransition,
        overwriteParams: () => ({
          slidesPerView: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: !swiper.params.cssMode
        })
      });
    }

    // eslint-disable-next-line import/no-unresolved

    // Install modules. Swiper 9+ has no Lazy module: slide images load natively
    // (`loading="lazy"`) or through lazysizes (`data-src`); the slider init in
    // app.js takes care of the `is-loaded` class and the preloader.
    Swiper.use([Pagination, Navigation, EffectFade, Thumb, Autoplay, freeMode]);

    var lazysizes = {exports: {}};

    (function (module) {
      (function (window, factory) {
        var lazySizes = factory(window, window.document, Date);
        window.lazySizes = lazySizes;
        if (module.exports) {
          module.exports = lazySizes;
        }
      })(typeof window != 'undefined' ? window : {},
      /**
       * import("./types/global")
       * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
       */
      function l(window, document, Date) {

        /*jshint eqnull:true */
        var lazysizes,
          /**
           * @type { LazySizesConfigPartial }
           */
          lazySizesCfg;
        (function () {
          var prop;
          var lazySizesDefaults = {
            lazyClass: 'lazyload',
            loadedClass: 'lazyloaded',
            loadingClass: 'lazyloading',
            preloadClass: 'lazypreload',
            errorClass: 'lazyerror',
            //strictClass: 'lazystrict',
            autosizesClass: 'lazyautosizes',
            fastLoadedClass: 'ls-is-cached',
            iframeLoadMode: 0,
            srcAttr: 'data-src',
            srcsetAttr: 'data-srcset',
            sizesAttr: 'data-sizes',
            //preloadAfterLoad: false,
            minSize: 40,
            customMedia: {},
            init: true,
            expFactor: 1.5,
            hFac: 0.8,
            loadMode: 2,
            loadHidden: true,
            ricTimeout: 0,
            throttleDelay: 125
          };
          lazySizesCfg = window.lazySizesConfig || window.lazysizesConfig || {};
          for (prop in lazySizesDefaults) {
            if (!(prop in lazySizesCfg)) {
              lazySizesCfg[prop] = lazySizesDefaults[prop];
            }
          }
        })();
        if (!document || !document.getElementsByClassName) {
          return {
            init: function () {},
            /**
             * @type { LazySizesConfigPartial }
             */
            cfg: lazySizesCfg,
            /**
             * @type { true }
             */
            noSupport: true
          };
        }
        var docElem = document.documentElement;
        var supportPicture = window.HTMLPictureElement;
        var _addEventListener = 'addEventListener';
        var _getAttribute = 'getAttribute';

        /**
         * Update to bind to window because 'this' becomes null during SSR
         * builds.
         */
        var addEventListener = window[_addEventListener].bind(window);
        var setTimeout = window.setTimeout;
        var requestAnimationFrame = window.requestAnimationFrame || setTimeout;
        var requestIdleCallback = window.requestIdleCallback;
        var regPicture = /^picture$/i;
        var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];
        var regClassCache = {};
        var forEach = Array.prototype.forEach;

        /**
         * @param ele {Element}
         * @param cls {string}
         */
        var hasClass = function (ele, cls) {
          if (!regClassCache[cls]) {
            regClassCache[cls] = new RegExp('(\\s|^)' + cls + '(\\s|$)');
          }
          return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
        };

        /**
         * @param ele {Element}
         * @param cls {string}
         */
        var addClass = function (ele, cls) {
          if (!hasClass(ele, cls)) {
            ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
          }
        };

        /**
         * @param ele {Element}
         * @param cls {string}
         */
        var removeClass = function (ele, cls) {
          var reg;
          if (reg = hasClass(ele, cls)) {
            ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
          }
        };
        var addRemoveLoadEvents = function (dom, fn, add) {
          var action = add ? _addEventListener : 'removeEventListener';
          if (add) {
            addRemoveLoadEvents(dom, fn);
          }
          loadEvents.forEach(function (evt) {
            dom[action](evt, fn);
          });
        };

        /**
         * @param elem { Element }
         * @param name { string }
         * @param detail { any }
         * @param noBubbles { boolean }
         * @param noCancelable { boolean }
         * @returns { CustomEvent }
         */
        var triggerEvent = function (elem, name, detail, noBubbles, noCancelable) {
          var event = document.createEvent('Event');
          if (!detail) {
            detail = {};
          }
          detail.instance = lazysizes;
          event.initEvent(name, !noBubbles, !noCancelable);
          event.detail = detail;
          elem.dispatchEvent(event);
          return event;
        };
        var updatePolyfill = function (el, full) {
          var polyfill;
          if (!supportPicture && (polyfill = window.picturefill || lazySizesCfg.pf)) {
            if (full && full.src && !el[_getAttribute]('srcset')) {
              el.setAttribute('srcset', full.src);
            }
            polyfill({
              reevaluate: true,
              elements: [el]
            });
          } else if (full && full.src) {
            el.src = full.src;
          }
        };
        var getCSS = function (elem, style) {
          return (getComputedStyle(elem, null) || {})[style];
        };

        /**
         *
         * @param elem { Element }
         * @param parent { Element }
         * @param [width] {number}
         * @returns {number}
         */
        var getWidth = function (elem, parent, width) {
          width = width || elem.offsetWidth;
          while (width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth) {
            width = parent.offsetWidth;
            parent = parent.parentNode;
          }
          return width;
        };
        var rAF = function () {
          var running, waiting;
          var firstFns = [];
          var secondFns = [];
          var fns = firstFns;
          var run = function () {
            var runFns = fns;
            fns = firstFns.length ? secondFns : firstFns;
            running = true;
            waiting = false;
            while (runFns.length) {
              runFns.shift()();
            }
            running = false;
          };
          var rafBatch = function (fn, queue) {
            if (running && !queue) {
              fn.apply(this, arguments);
            } else {
              fns.push(fn);
              if (!waiting) {
                waiting = true;
                (document.hidden ? setTimeout : requestAnimationFrame)(run);
              }
            }
          };
          rafBatch._lsFlush = run;
          return rafBatch;
        }();
        var rAFIt = function (fn, simple) {
          return simple ? function () {
            rAF(fn);
          } : function () {
            var that = this;
            var args = arguments;
            rAF(function () {
              fn.apply(that, args);
            });
          };
        };
        var throttle = function (fn) {
          var running;
          var lastTime = 0;
          var gDelay = lazySizesCfg.throttleDelay;
          var rICTimeout = lazySizesCfg.ricTimeout;
          var run = function () {
            running = false;
            lastTime = Date.now();
            fn();
          };
          var idleCallback = requestIdleCallback && rICTimeout > 49 ? function () {
            requestIdleCallback(run, {
              timeout: rICTimeout
            });
            if (rICTimeout !== lazySizesCfg.ricTimeout) {
              rICTimeout = lazySizesCfg.ricTimeout;
            }
          } : rAFIt(function () {
            setTimeout(run);
          }, true);
          return function (isPriority) {
            var delay;
            if (isPriority = isPriority === true) {
              rICTimeout = 33;
            }
            if (running) {
              return;
            }
            running = true;
            delay = gDelay - (Date.now() - lastTime);
            if (delay < 0) {
              delay = 0;
            }
            if (isPriority || delay < 9) {
              idleCallback();
            } else {
              setTimeout(idleCallback, delay);
            }
          };
        };

        //based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
        var debounce = function (func) {
          var timeout, timestamp;
          var wait = 99;
          var run = function () {
            timeout = null;
            func();
          };
          var later = function () {
            var last = Date.now() - timestamp;
            if (last < wait) {
              setTimeout(later, wait - last);
            } else {
              (requestIdleCallback || run)(run);
            }
          };
          return function () {
            timestamp = Date.now();
            if (!timeout) {
              timeout = setTimeout(later, wait);
            }
          };
        };
        var loader = function () {
          var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;
          var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;
          var regImg = /^img$/i;
          var regIframe = /^iframe$/i;
          var supportScroll = 'onscroll' in window && !/(gle|ing)bot/.test(navigator.userAgent);
          var shrinkExpand = 0;
          var currentExpand = 0;
          var isLoading = 0;
          var lowRuns = -1;
          var resetPreloading = function (e) {
            isLoading--;
            if (!e || isLoading < 0 || !e.target) {
              isLoading = 0;
            }
          };
          var isVisible = function (elem) {
            if (isBodyHidden == null) {
              isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
            }
            return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
          };
          var isNestedVisible = function (elem, elemExpand) {
            var outerRect;
            var parent = elem;
            var visible = isVisible(elem);
            eLtop -= elemExpand;
            eLbottom += elemExpand;
            eLleft -= elemExpand;
            eLright += elemExpand;
            while (visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem) {
              visible = (getCSS(parent, 'opacity') || 1) > 0;
              if (visible && getCSS(parent, 'overflow') != 'visible') {
                outerRect = parent.getBoundingClientRect();
                visible = eLright > outerRect.left && eLleft < outerRect.right && eLbottom > outerRect.top - 1 && eLtop < outerRect.bottom + 1;
              }
            }
            return visible;
          };
          var checkElements = function () {
            var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal, defaultExpand, preloadExpand, hFac;
            var lazyloadElems = lazysizes.elements;
            if ((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)) {
              i = 0;
              lowRuns++;
              for (; i < eLlen; i++) {
                if (!lazyloadElems[i] || lazyloadElems[i]._lazyRace) {
                  continue;
                }
                if (!supportScroll || lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i])) {
                  unveilElement(lazyloadElems[i]);
                  continue;
                }
                if (!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)) {
                  elemExpand = currentExpand;
                }
                if (!defaultExpand) {
                  defaultExpand = !lazySizesCfg.expand || lazySizesCfg.expand < 1 ? docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 : lazySizesCfg.expand;
                  lazysizes._defEx = defaultExpand;
                  preloadExpand = defaultExpand * lazySizesCfg.expFactor;
                  hFac = lazySizesCfg.hFac;
                  isBodyHidden = null;
                  if (currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden) {
                    currentExpand = preloadExpand;
                    lowRuns = 0;
                  } else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) {
                    currentExpand = defaultExpand;
                  } else {
                    currentExpand = shrinkExpand;
                  }
                }
                if (beforeExpandVal !== elemExpand) {
                  eLvW = innerWidth + elemExpand * hFac;
                  elvH = innerHeight + elemExpand;
                  elemNegativeExpand = elemExpand * -1;
                  beforeExpandVal = elemExpand;
                }
                rect = lazyloadElems[i].getBoundingClientRect();
                if ((eLbottom = rect.bottom) >= elemNegativeExpand && (eLtop = rect.top) <= elvH && (eLright = rect.right) >= elemNegativeExpand * hFac && (eLleft = rect.left) <= eLvW && (eLbottom || eLright || eLleft || eLtop) && (lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) && (isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4) || isNestedVisible(lazyloadElems[i], elemExpand))) {
                  unveilElement(lazyloadElems[i]);
                  loadedSomething = true;
                  if (isLoading > 9) {
                    break;
                  }
                } else if (!loadedSomething && isCompleted && !autoLoadElem && isLoading < 4 && lowRuns < 4 && loadMode > 2 && (preloadElems[0] || lazySizesCfg.preloadAfterLoad) && (preloadElems[0] || !elemExpandVal && (eLbottom || eLright || eLleft || eLtop || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto'))) {
                  autoLoadElem = preloadElems[0] || lazyloadElems[i];
                }
              }
              if (autoLoadElem && !loadedSomething) {
                unveilElement(autoLoadElem);
              }
            }
          };
          var throttledCheckElements = throttle(checkElements);
          var switchLoadingClass = function (e) {
            var elem = e.target;
            if (elem._lazyCache) {
              delete elem._lazyCache;
              return;
            }
            resetPreloading(e);
            addClass(elem, lazySizesCfg.loadedClass);
            removeClass(elem, lazySizesCfg.loadingClass);
            addRemoveLoadEvents(elem, rafSwitchLoadingClass);
            triggerEvent(elem, 'lazyloaded');
          };
          var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
          var rafSwitchLoadingClass = function (e) {
            rafedSwitchLoadingClass({
              target: e.target
            });
          };
          var changeIframeSrc = function (elem, src) {
            var loadMode = elem.getAttribute('data-load-mode') || lazySizesCfg.iframeLoadMode;

            // loadMode can be also a string!
            if (loadMode == 0) {
              elem.contentWindow.location.replace(src);
            } else if (loadMode == 1) {
              elem.src = src;
            }
          };
          var handleSources = function (source) {
            var customMedia;
            var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);
            if (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) {
              source.setAttribute('media', customMedia);
            }
            if (sourceSrcset) {
              source.setAttribute('srcset', sourceSrcset);
            }
          };
          var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg) {
            var src, srcset, parent, isPicture, event, firesLoad;
            if (!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented) {
              if (sizes) {
                if (isAuto) {
                  addClass(elem, lazySizesCfg.autosizesClass);
                } else {
                  elem.setAttribute('sizes', sizes);
                }
              }
              srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
              src = elem[_getAttribute](lazySizesCfg.srcAttr);
              if (isImg) {
                parent = elem.parentNode;
                isPicture = parent && regPicture.test(parent.nodeName || '');
              }
              firesLoad = detail.firesLoad || 'src' in elem && (srcset || src || isPicture);
              event = {
                target: elem
              };
              addClass(elem, lazySizesCfg.loadingClass);
              if (firesLoad) {
                clearTimeout(resetPreloadingTimer);
                resetPreloadingTimer = setTimeout(resetPreloading, 2500);
                addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
              }
              if (isPicture) {
                forEach.call(parent.getElementsByTagName('source'), handleSources);
              }
              if (srcset) {
                elem.setAttribute('srcset', srcset);
              } else if (src && !isPicture) {
                if (regIframe.test(elem.nodeName)) {
                  changeIframeSrc(elem, src);
                } else {
                  elem.src = src;
                }
              }
              if (isImg && (srcset || isPicture)) {
                updatePolyfill(elem, {
                  src: src
                });
              }
            }
            if (elem._lazyRace) {
              delete elem._lazyRace;
            }
            removeClass(elem, lazySizesCfg.lazyClass);
            rAF(function () {
              // Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
              var isLoaded = elem.complete && elem.naturalWidth > 1;
              if (!firesLoad || isLoaded) {
                if (isLoaded) {
                  addClass(elem, lazySizesCfg.fastLoadedClass);
                }
                switchLoadingClass(event);
                elem._lazyCache = true;
                setTimeout(function () {
                  if ('_lazyCache' in elem) {
                    delete elem._lazyCache;
                  }
                }, 9);
              }
              if (elem.loading == 'lazy') {
                isLoading--;
              }
            }, true);
          });

          /**
           *
           * @param elem { Element }
           */
          var unveilElement = function (elem) {
            if (elem._lazyRace) {
              return;
            }
            var detail;
            var isImg = regImg.test(elem.nodeName);

            //allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
            var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
            var isAuto = sizes == 'auto';
            if ((isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)) {
              return;
            }
            detail = triggerEvent(elem, 'lazyunveilread').detail;
            if (isAuto) {
              autoSizer.updateElem(elem, true, elem.offsetWidth);
            }
            elem._lazyRace = true;
            isLoading++;
            lazyUnveil(elem, detail, isAuto, sizes, isImg);
          };
          var afterScroll = debounce(function () {
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
          });
          var altLoadmodeScrollListner = function () {
            if (lazySizesCfg.loadMode == 3) {
              lazySizesCfg.loadMode = 2;
            }
            afterScroll();
          };
          var onload = function () {
            if (isCompleted) {
              return;
            }
            if (Date.now() - started < 999) {
              setTimeout(onload, 999);
              return;
            }
            isCompleted = true;
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
            addEventListener('scroll', altLoadmodeScrollListner, true);
          };
          return {
            _: function () {
              started = Date.now();
              lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
              preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);
              addEventListener('scroll', throttledCheckElements, true);
              addEventListener('resize', throttledCheckElements, true);
              addEventListener('pageshow', function (e) {
                if (e.persisted) {
                  var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);
                  if (loadingElements.length && loadingElements.forEach) {
                    requestAnimationFrame(function () {
                      loadingElements.forEach(function (img) {
                        if (img.complete) {
                          unveilElement(img);
                        }
                      });
                    });
                  }
                }
              });
              if (window.MutationObserver) {
                new MutationObserver(throttledCheckElements).observe(docElem, {
                  childList: true,
                  subtree: true,
                  attributes: true
                });
              } else {
                docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
                docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
                setInterval(throttledCheckElements, 999);
              }
              addEventListener('hashchange', throttledCheckElements, true);

              //, 'fullscreenchange'
              ['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend'].forEach(function (name) {
                document[_addEventListener](name, throttledCheckElements, true);
              });
              if (/d$|^c/.test(document.readyState)) {
                onload();
              } else {
                addEventListener('load', onload);
                document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
                setTimeout(onload, 20000);
              }
              if (lazysizes.elements.length) {
                checkElements();
                rAF._lsFlush();
              } else {
                throttledCheckElements();
              }
            },
            checkElems: throttledCheckElements,
            unveil: unveilElement,
            _aLSL: altLoadmodeScrollListner
          };
        }();
        var autoSizer = function () {
          var autosizesElems;
          var sizeElement = rAFIt(function (elem, parent, event, width) {
            var sources, i, len;
            elem._lazysizesWidth = width;
            width += 'px';
            elem.setAttribute('sizes', width);
            if (regPicture.test(parent.nodeName || '')) {
              sources = parent.getElementsByTagName('source');
              for (i = 0, len = sources.length; i < len; i++) {
                sources[i].setAttribute('sizes', width);
              }
            }
            if (!event.detail.dataAttr) {
              updatePolyfill(elem, event.detail);
            }
          });
          /**
           *
           * @param elem {Element}
           * @param dataAttr
           * @param [width] { number }
           */
          var getSizeElement = function (elem, dataAttr, width) {
            var event;
            var parent = elem.parentNode;
            if (parent) {
              width = getWidth(elem, parent, width);
              event = triggerEvent(elem, 'lazybeforesizes', {
                width: width,
                dataAttr: !!dataAttr
              });
              if (!event.defaultPrevented) {
                width = event.detail.width;
                if (width && width !== elem._lazysizesWidth) {
                  sizeElement(elem, parent, event, width);
                }
              }
            }
          };
          var updateElementsSizes = function () {
            var i;
            var len = autosizesElems.length;
            if (len) {
              i = 0;
              for (; i < len; i++) {
                getSizeElement(autosizesElems[i]);
              }
            }
          };
          var debouncedUpdateElementsSizes = debounce(updateElementsSizes);
          return {
            _: function () {
              autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
              addEventListener('resize', debouncedUpdateElementsSizes);
            },
            checkElems: debouncedUpdateElementsSizes,
            updateElem: getSizeElement
          };
        }();
        var init = function () {
          if (!init.i && document.getElementsByClassName) {
            init.i = true;
            autoSizer._();
            loader._();
          }
        };
        setTimeout(function () {
          if (lazySizesCfg.init) {
            init();
          }
        });
        lazysizes = {
          /**
           * @type { LazySizesConfigPartial }
           */
          cfg: lazySizesCfg,
          autoSizer: autoSizer,
          loader: loader,
          init: init,
          uP: updatePolyfill,
          aC: addClass,
          rC: removeClass,
          hC: hasClass,
          fire: triggerEvent,
          gW: getWidth,
          rAF: rAF
        };
        return lazysizes;
      });
    })(lazysizes);
    var lazySizes = lazysizes.exports;

    var ls_bgset = {exports: {}};

    (function (module) {
      (function (window, factory) {
        var globalInstall = function () {
          factory(window.lazySizes);
          window.removeEventListener('lazyunveilread', globalInstall, true);
        };
        factory = factory.bind(null, window, window.document);
        if (module.exports) {
          factory(lazysizes.exports);
        } else if (window.lazySizes) {
          globalInstall();
        } else {
          window.addEventListener('lazyunveilread', globalInstall, true);
        }
      })(window, function (window, document, lazySizes) {

        if (!window.addEventListener) {
          return;
        }
        var lazySizesCfg = lazySizes.cfg;
        var regWhite = /\s+/g;
        var regSplitSet = /\s*\|\s+|\s+\|\s*/g;
        var regSource = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/;
        var regType = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/;
        var regBgUrlEscape = /\(|\)|'/;
        var allowedBackgroundSize = {
          contain: 1,
          cover: 1
        };
        var proxyWidth = function (elem) {
          var width = lazySizes.gW(elem, elem.parentNode);
          if (!elem._lazysizesWidth || width > elem._lazysizesWidth) {
            elem._lazysizesWidth = width;
          }
          return elem._lazysizesWidth;
        };
        var getBgSize = function (elem) {
          var bgSize;
          bgSize = (getComputedStyle(elem) || {
            getPropertyValue: function () {}
          }).getPropertyValue('background-size');
          if (!allowedBackgroundSize[bgSize] && allowedBackgroundSize[elem.style.backgroundSize]) {
            bgSize = elem.style.backgroundSize;
          }
          return bgSize;
        };
        var setTypeOrMedia = function (source, match) {
          if (match) {
            var typeMatch = match.match(regType);
            if (typeMatch && typeMatch[1]) {
              source.setAttribute('type', typeMatch[1]);
            } else {
              source.setAttribute('media', lazySizesCfg.customMedia[match] || match);
            }
          }
        };
        var createPicture = function (sets, elem, img) {
          var picture = document.createElement('picture');
          var sizes = elem.getAttribute(lazySizesCfg.sizesAttr);
          var ratio = elem.getAttribute('data-ratio');
          var optimumx = elem.getAttribute('data-optimumx');
          if (elem._lazybgset && elem._lazybgset.parentNode == elem) {
            elem.removeChild(elem._lazybgset);
          }
          Object.defineProperty(img, '_lazybgset', {
            value: elem,
            writable: true
          });
          Object.defineProperty(elem, '_lazybgset', {
            value: picture,
            writable: true
          });
          sets = sets.replace(regWhite, ' ').split(regSplitSet);
          picture.style.display = 'none';
          img.className = lazySizesCfg.lazyClass;
          if (sets.length == 1 && !sizes) {
            sizes = 'auto';
          }
          sets.forEach(function (set) {
            var match;
            var source = document.createElement('source');
            if (sizes && sizes != 'auto') {
              source.setAttribute('sizes', sizes);
            }
            if (match = set.match(regSource)) {
              source.setAttribute(lazySizesCfg.srcsetAttr, match[1]);
              setTypeOrMedia(source, match[2]);
              setTypeOrMedia(source, match[3]);
            } else {
              source.setAttribute(lazySizesCfg.srcsetAttr, set);
            }
            picture.appendChild(source);
          });
          if (sizes) {
            img.setAttribute(lazySizesCfg.sizesAttr, sizes);
            elem.removeAttribute(lazySizesCfg.sizesAttr);
            elem.removeAttribute('sizes');
          }
          if (optimumx) {
            img.setAttribute('data-optimumx', optimumx);
          }
          if (ratio) {
            img.setAttribute('data-ratio', ratio);
          }
          picture.appendChild(img);
          elem.appendChild(picture);
        };
        var proxyLoad = function (e) {
          if (!e.target._lazybgset) {
            return;
          }
          var image = e.target;
          var elem = image._lazybgset;
          var bg = image.currentSrc || image.src;
          if (bg) {
            var useSrc = regBgUrlEscape.test(bg) ? JSON.stringify(bg) : bg;
            var event = lazySizes.fire(elem, 'bgsetproxy', {
              src: bg,
              useSrc: useSrc,
              fullSrc: null
            });
            if (!event.defaultPrevented) {
              elem.style.backgroundImage = event.detail.fullSrc || 'url(' + event.detail.useSrc + ')';
            }
          }
          if (image._lazybgsetLoading) {
            lazySizes.fire(elem, '_lazyloaded', {}, false, true);
            delete image._lazybgsetLoading;
          }
        };
        addEventListener('lazybeforeunveil', function (e) {
          var set, image, elem;
          if (e.defaultPrevented || !(set = e.target.getAttribute('data-bgset'))) {
            return;
          }
          elem = e.target;
          image = document.createElement('img');
          image.alt = '';
          image._lazybgsetLoading = true;
          e.detail.firesLoad = true;
          createPicture(set, elem, image);
          setTimeout(function () {
            lazySizes.loader.unveil(image);
            lazySizes.rAF(function () {
              lazySizes.fire(image, '_lazyloaded', {}, true, true);
              if (image.complete) {
                proxyLoad({
                  target: image
                });
              }
            });
          });
        });
        document.addEventListener('load', proxyLoad, true);
        window.addEventListener('lazybeforesizes', function (e) {
          if (e.detail.instance != lazySizes) {
            return;
          }
          if (e.target._lazybgset && e.detail.dataAttr) {
            var elem = e.target._lazybgset;
            var bgSize = getBgSize(elem);
            if (allowedBackgroundSize[bgSize]) {
              e.target._lazysizesParentFit = bgSize;
              lazySizes.rAF(function () {
                e.target.setAttribute('data-parent-fit', bgSize);
                if (e.target._lazysizesParentFit) {
                  delete e.target._lazysizesParentFit;
                }
              });
            }
          }
        }, true);
        document.documentElement.addEventListener('lazybeforesizes', function (e) {
          if (e.defaultPrevented || !e.target._lazybgset || e.detail.instance != lazySizes) {
            return;
          }
          e.detail.width = proxyWidth(e.target._lazybgset);
        });
      });
    })(ls_bgset);

    lazySizes.cfg.lazyClass = 'lazyload';
    lazySizes.cfg.preloadClass = 'is-preloading';
    lazySizes.cfg.loadingClass = 'is-loading';
    lazySizes.cfg.loadedClass = 'is-loaded';
    lazySizes.cfg.customMedia = {
      '--small': '(max-width: 575px)',
      '--medium': '(max-width: 768px)',
      '--large': '(max-width: 991px)'
    };

    // add simple support for background images:
    document.addEventListener('lazybeforeunveil', e => {
      const bg = e.target.getAttribute('data-bg');
      if (bg) e.target.style.backgroundImage = 'url(' + bg + ')';
    });

    /**
     * Leaflet Map
     * @author Mert Osman Başol
     * @email mert.basol@magicport.ai
     */

    class LeafletMap {
      constructor(mapElementId, options = {}) {
        this.map = null;
        this.mapElementId = mapElementId;
        this.markers = [];
        this.currZoom = options.initialZoom || 14;
        this.iconSize = options.iconSize || [32, 32];
        this.flagPath = 'https://magicport.ai/front/flags/';
        this.markerType = mapElementId.dataset.mapMarker || 'ship';
        this.markerColor = mapElementId.dataset.mapColor || '#1e295b';
        this.markerColors = options.markerColors || {
          boat: {
            default: {
              fill: '#C8C8C8',
              stroke: '#565656'
            },
            cargo: {
              fill: '#86F793',
              stroke: '#01650C'
            },
            fishing: {
              fill: '#FFFF51',
              stroke: '#F09917'
            },
            passenger: {
              fill: '#036AEE',
              stroke: '#002B62'
            },
            'pleasure-craft': {
              fill: '#49FFFF',
              stroke: '#095F5F'
            },
            tanker: {
              fill: '#DF2329',
              stroke: '#740307'
            },
            'tugs-support-vessels': {
              fill: '#FF70FF',
              stroke: '#700C70'
            },
            container: {
              fill: '#FFBE9A',
              stroke: '#A04C1D'
            },
            'bulk-carrier': {
              fill: '#52DD62',
              stroke: '#216729'
            },
            'ro-ro': {
              fill: '#C3E972',
              stroke: '#0B5914'
            },
            'gas-carrier': {
              fill: '#FF5E63',
              stroke: '#9D0005'
            },
            bunkering: {
              fill: '#FFACA0',
              stroke: '#9D0005'
            },
            offshore: {
              fill: '#E445E4',
              stroke: '#8A008A'
            },
            'special-craft': {
              fill: '#FDC0FD',
              stroke: '#912691'
            }
          }
        };
        this.options = options;
      }
      getMarkerColor(type) {
        const markerAliases = {
          'general-cargo': 'cargo',
          'tugs-harbor-craft': 'tugs-support-vessels'
        };
        const key = markerAliases[type] || type;
        return this.markerColors.boat[key] !== undefined ? this.markerColors.boat[key] : this.markerColors.boat.default;
      }
      async init() {
        await this.loadLeaflet();
        this.addRotationSupport();
        this.initMap(this.options.locations);
        const resizeObserver = new ResizeObserver(() => {
          this.refreshUI();
        });
        resizeObserver.observe(this.mapElementId);
      }

      // eslint-disable-next-line class-methods-use-this
      loadLeaflet() {
        return new Promise(resolve => {
          if (typeof L === 'undefined') {
            const leafletCSS = document.createElement('link');
            leafletCSS.rel = 'stylesheet';
            leafletCSS.href = 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.css';
            document.head.appendChild(leafletCSS);
            const leafletScript = document.createElement('script');
            leafletScript.src = 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.js';
            leafletScript.onload = resolve;
            document.head.appendChild(leafletScript);
          } else {
            resolve();
          }
        });
      }

      // eslint-disable-next-line class-methods-use-this
      addRotationSupport() {
        // eslint-disable-next-line camelcase,no-underscore-dangle,no-undef
        const proto_initIcon = L.Marker.prototype._initIcon;
        // eslint-disable-next-line camelcase,no-underscore-dangle,no-undef
        const proto_setPos = L.Marker.prototype._setPos;

        // eslint-disable-next-line no-undef
        const oldIE = L.DomUtil.TRANSFORM === 'msTransform';

        // eslint-disable-next-line no-undef
        L.Marker.addInitHook(function () {
          const iconOptions = this.options.icon && this.options.icon.options;
          let iconAnchor = iconOptions && this.options.icon.options.iconAnchor;
          if (iconAnchor) {
            iconAnchor = `${iconAnchor[0]}px ${iconAnchor[1]}px`;
          }
          this.options.rotationOrigin = this.options.rotationOrigin || iconAnchor || 'center bottom';
          this.options.rotationAngle = this.options.rotationAngle || 0;

          // Ensure marker keeps rotated during dragging
          this.on('drag', function (e) {
            // eslint-disable-next-line no-underscore-dangle
            e.target._applyRotation();
          });
        });

        // eslint-disable-next-line no-undef
        L.Marker.include({
          // eslint-disable-next-line no-underscore-dangle
          _initIcon() {
            // eslint-disable-next-line camelcase
            proto_initIcon.call(this);
          },
          // eslint-disable-next-line no-underscore-dangle
          _setPos(pos) {
            // eslint-disable-next-line camelcase
            proto_setPos.call(this, pos);
            // eslint-disable-next-line no-underscore-dangle
            this._applyRotation();
          },
          // eslint-disable-next-line no-underscore-dangle
          _applyRotation() {
            if (this.options.rotationAngle) {
              // eslint-disable-next-line no-underscore-dangle,no-undef
              this._icon.style[`${L.DomUtil.TRANSFORM}Origin`] = this.options.rotationOrigin;
              if (oldIE) {
                // for IE 9, use the 2D rotation
                // eslint-disable-next-line no-underscore-dangle,no-undef
                this._icon.style[L.DomUtil.TRANSFORM] = `rotate(${this.options.rotationAngle}deg)`;
              } else {
                // eslint-disable-next-line no-underscore-dangle,no-undef
                this._icon.style[L.DomUtil.TRANSFORM] += ` rotateZ(${this.options.rotationAngle}deg)`;
              }
            }
          },
          setRotationAngle(angle) {
            this.options.rotationAngle = angle;
            this.update();
            return this;
          },
          setRotationOrigin(origin) {
            this.options.rotationOrigin = origin;
            this.update();
            return this;
          }
        });
      }
      initMap(locations) {
        if (this.map) {
          this.map.off();
          this.map.remove();
        }
        const isSingle = locations && locations.length === 1;
        // if (isSingle) this.currZoom = 12;

        // eslint-disable-next-line no-undef
        this.map = L.map(this.mapElementId, {
          minZoom: 2,
          maxZoom: 19
        }).setView(isSingle ? [locations[0]?.lat, locations[0]?.lng] : [0, 0], locations && locations.length > 0 ? this.currZoom : 3);

        // eslint-disable-next-line no-undef
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19,
          className: 'map-tiles',
          attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(this.map);
        if (locations && locations.length > 0) {
          this.setMarkers(locations);
          if (!isSingle) {
            this.zoomIcons(this.currZoom, this.map.getZoom());
            this.map.on('zoomend', () => {
              this.zoomIcons(this.currZoom, this.map.getZoom());
              this.currZoom = this.map.getZoom();
            });
            this.markersFitBounds(this.markers);
          }
        }
      }
      setData(locations) {
        if (this.map) {
          this.markers.forEach(marker => this.map.removeLayer(marker));
          this.markers = [];
          this.setMarkers(locations);
          this.markersFitBounds(this.markers);
        }
      }

      // eslint-disable-next-line class-methods-use-this
      cssMultiply(cssVal, multiplier) {
        const returnval = cssVal.substring(0, cssVal.match(/[A-Za-z]/).index) * multiplier;
        return returnval + cssVal.substring(cssVal.match(/[A-Za-z]/).index);
      }
      zoomIcons(oldZoom, newZoom) {
        const difference = newZoom - oldZoom ? newZoom - oldZoom : oldZoom - 12;
        const moreRatio = 1.177777772;
        const lessRatio = 0.84;
        const zoomRatio = difference > 0 ? moreRatio : lessRatio;
        const limit = 6;
        const icons = document.querySelectorAll('.shipIcon');
        icons.forEach(item => {
          if (this.map?.getZoom() < limit) {
            // eslint-disable-next-line no-param-reassign
            item.style.width = item.classList.contains('shipIcon--circle') ? `${this.iconSizeCircle[0] * 0.5}px` : `${this.iconSize[0] * 0.5}px`;
            // eslint-disable-next-line no-param-reassign
            item.style.height = item.classList.contains('shipIcon--circle') ? `${this.iconSizeCircle[1] * 0.5}px` : `${this.iconSize[1] * 0.5}px`;
            // eslint-disable-next-line no-param-reassign
            item.style.marginLeft = item.classList.contains('shipIcon--circle') ? `${this.iconSizeCircle[0] * 0.5 / 2 * -1}px` : `${this.iconSize[0] * 0.5 / 2 * -1}px`;
            // eslint-disable-next-line no-param-reassign
            item.style.marginTop = item.classList.contains('shipIcon--circle') ? `${this.iconSizeCircle[1] * 0.5 / 2 * -1}px` : `${this.iconSize[1] * 0.5 / 2 * -1}px`;
          } else if (difference < -1) {
            this.currZoom = this.map.getZoom();
            // eslint-disable-next-line no-plusplus
            for (let i = 1; i < difference * -1; i++) {
              // eslint-disable-next-line no-param-reassign
              item.style.width = this.cssMultiply(item.style.width, lessRatio);
              // eslint-disable-next-line no-param-reassign
              item.style.height = this.cssMultiply(item.style.height, lessRatio);
              // eslint-disable-next-line no-param-reassign
              item.style.marginLeft = this.cssMultiply(item.style.marginLeft, lessRatio);
              // eslint-disable-next-line no-param-reassign
              item.style.marginTop = this.cssMultiply(item.style.marginTop, lessRatio);
            }
          } else {
            // eslint-disable-next-line no-param-reassign
            item.style.width = this.cssMultiply(item.style.width, zoomRatio);
            // eslint-disable-next-line no-param-reassign
            item.style.height = this.cssMultiply(item.style.height, zoomRatio);
            // eslint-disable-next-line no-param-reassign
            item.style.marginLeft = this.cssMultiply(item.style.marginLeft, zoomRatio);
            // eslint-disable-next-line no-param-reassign
            item.style.marginTop = this.cssMultiply(item.style.marginTop, zoomRatio);
          }
        });
      }
      setMarkers(locations) {
        if (typeof locations === 'undefined') return;
        const that = this;
        locations.forEach(location => {
          if (location?.lat && location?.lng) {
            const iconSVG = this.getMarkerIcon(this.markerType, location);
            const size = this.getMarkerSize(location?.length);

            // eslint-disable-next-line no-undef
            const icon = L.divIcon({
              html: iconSVG,
              className: `shipIcon${!location?.speed || location?.speed === 0 ? ' shipIcon--circle' : ''}`,
              iconSize: size,
              iconAnchor: [size[0] / 2, size[1] / 3]
            });

            // eslint-disable-next-line no-undef,new-cap
            const marker = new L.marker([location.lat, location.lng], {
              icon,
              rotationAngle: location?.course
            }).addTo(this.map).on('mouseover', function () {
              that.customTooltip(location, this);
            });
            this.markers.push(marker);
          }
        });
      }

      /**
       * getMarkerIcon
       * @param type
       * @param data
       * @returns {string}
       */
      // eslint-disable-next-line default-param-last
      getMarkerIcon(type = 'ship', data) {
        let icon = '';

        // console.log('type', type);

        if (type === 'ship' && data) {
          const color = this.getMarkerColor(data?.type);
          // eslint-disable-next-line no-unused-expressions
          icon = !data?.speed || data?.speed === 0 ? `
          <svg width="100%" height="100%" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="16.25" y="16.25" width="25.5" height="25.5" rx="12.75" fill="${color.fill}" stroke="${color.stroke}" stroke-width="2.5"/>
          </svg>
        ` : `
        <svg width="100%" height="100%" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M29.8447 43.9119L29 43.1376L28.1553 43.9119L20.9482 50.5184C20.681 50.7634 20.25 50.5738 20.25 50.2113V24.7378C20.25 23.5695 20.539 22.4194 21.0912 21.3898L28.6328 7.32915C28.79 7.03619 29.21 7.03619 29.3672 7.32915L36.9088 21.3898C37.461 22.4194 37.75 23.5695 37.75 24.7378V50.2113C37.75 50.5738 37.319 50.7634 37.0518 50.5184L29.8447 43.9119Z" fill="${color.fill}" stroke="${color.stroke}" stroke-width="2.5"/>
            <rect x="28.1667" y="24.8333" width="1.66667" height="11.6667" rx="0.833333" fill="${color.stroke}" stroke="${color.stroke}" stroke-width="1.66667"/>
        </svg>
      `;
        }
        if (type === 'normal') {
          icon = `
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0z"/><path fill="${this.markerColor}" d="M18.364 17.364L12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0zM12 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0-2a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"/></svg>
      `;
        }
        return icon;
      }
      customTooltip(data, _) {
        if (!data?.name) return;
        _.unbindTooltip();
        if (!_.isPopupOpen()) _.bindTooltip(`
          <div class="d-flex p-025 align-items-center">
              <div style="width: 32px;" class="mr-05">
                  <img src="${this.flagPath}/${data?.flag.toLowerCase()}.svg" alt="" style="width: 100%; border-radius: 3px; height: auto;">
              </div>
              <div class="d-flex flex-column">
                  <strong class="text-style text-style--small text-style--semi text-dark text-style--lh-base">${data?.name}</strong>
                  ${data?.mmsi ? `<span class="text-style text-style--xsmall text--gray-500 text-style--lh-base">MMSI: ${data?.mmsi}</span>` : `${data?.imo ? `<span class="text-style text-style--xsmall text--gray-500 text-style--lh-base">IMO: ${data?.imo}</span>` : ''}`}
              </div>
          </div>
          `, {
          direction: 'top',
          offset: [0, -10]
        }).openTooltip();
      }
      getMarkerSize(length) {
        if (!length) return this.iconSize;
        if (!length || length <= 100) return [15, 15];
        if (length > 100 && length <= 200) return [20, 20];
        return [29, 29];
      }
      markersFitBounds(markers) {
        if (typeof markers === 'undefined' || markers.length === 0) return;

        // eslint-disable-next-line new-cap,no-undef
        const group = new L.featureGroup(markers);
        this.map.fitBounds(group.getBounds(), {
          maxZoom: 14,
          padding: markers.length > 1 ? [20, 20] : [0, 0]
        });
      }
      refreshUI() {
        if (this.map && typeof this.map.invalidateSize === 'function') {
          this.map.invalidateSize();
        }
      }
    }

    /**
     * Request
     * @author Mert Osman Başol
     * @email mert.basol@magicport.ai
     */

    // eslint-disable-next-line consistent-return
    /*export default async function request(url, options = {}) {
      if (typeof url !== 'undefined') {
        try {
          const result = await window.fetch(url, options);
          return await result.json();
        } catch (err) {
          return err;
        }
      }
      console.error('Please fetch url enter.');
    }*/

    function parseData(data) {
      let formData = new FormData();
      for (let key of Object.keys(data)) {
        formData.append(key, data[key]);
      }
      return formData;
    }
    function request(url, method = 'POST', data = null, headers = null, customData = null) {
      if (!window.fetch) {
        console.log('Fetch API not found, please upgrade your browser.');
        return;
      }
      return new Promise((resolve, reject) => {
        const options = {
          method
        };
        // if (data) options.body = JSON.stringify(data);
        if (data) options.body = customData ? parseData(data) : new FormData(data);
        if (headers) options.headers = headers;
        window.fetch(url, options).then(response => response.json()).then(response => resolve(response)).catch(error => reject(error));
      });
    }
    const get = (url, headers, customData) => request(url, 'GET', null, headers, customData);

    /**
     * MOB Autocomplete
     * @author Mert Osman Başol
     * @email mert.basol@magicport.ai
     */
    class MOBAutoComplete {
      constructor(input, options = {}) {
        this.input = input;
        this.url = input.dataset.inputAutocompleteUrl;
        this.param = input.dataset.inputAutocompleteParam || 'search';
        this.multiple = input.dataset.inputAutocomplete === 'multiple';
        this.minChars = options.minChars || 2;
        this.debounceDelay = options.debounceDelay || 300;
        this.selectedItems = [];
        this.isOpened = false;
        this.debounceTimeout = null;
        this.wrapper = null;
        this.resultsDiv = null;
        this.loadingSvg = null;
        this.previewDiv = null;
        this.filterColumn = input?.closest('.filter__column');

        // Parse initial values
        this.initialValues = input.dataset.inputAutocompleteInitialValues ? JSON.parse(input.dataset.inputAutocompleteInitialValues) : [];
        this.init();

        // eslint-disable-next-line no-underscore-dangle
        this.input._autoComplete = this;
      }

      /**
       * Init
       */
      init() {
        this.createPreviewDiv();
        this.wrapInput();
        this.createResultsDiv();
        this.loadInitialValues();
        this.addEventListeners();
      }

      /**
       * Wrap input with a wrapper
       */
      wrapInput() {
        this.wrapper = document.createElement('div');
        this.wrapper.classList.add('autocomplete');
        this.input.classList.add('autocomplete__input');
        this.input.parentNode.insertBefore(this.wrapper, this.input);
        this.wrapper.appendChild(this.input);
      }

      /**
       * Create results div
       */
      createResultsDiv() {
        this.resultsDiv = document.createElement('div');
        this.resultsDiv.classList.add('autocomplete__results');
        this.wrapper.appendChild(this.resultsDiv);
      }

      /**
       * Create preview div
       */
      createPreviewDiv() {
        this.previewDiv = document.createElement('div');
        this.previewDiv.classList.add('autocomplete__preview');
        this.input.insertAdjacentElement('afterend', this.previewDiv);
        this.updatePreviewVisibility();
      }

      /**
       * Load initial values
       */
      loadInitialValues() {
        this.initialValues.forEach(item => {
          this.selectedItems.push(item);
        });
        this.updateHiddenInputs();
        this.renderPreview();
      }

      /**
       * Show loading state
       */
      showLoading() {
        if (!this.loadingSvg) {
          this.loadingSvg = document.createElement('div');
          this.loadingSvg.classList.add('autocomplete__loading');
          this.loadingSvg.innerHTML = `
        <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M18.364 5.63604L16.9497 7.05025C15.683 5.7835 13.933 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12H21C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C14.4853 3 16.7353 4.00736 18.364 5.63604Z"></path></svg><path d="M12 3C16.9706 3 21 7.02944 21 12H19C19 8.13401 15.866 5 12 5V3Z"></path></svg>
      `;
          this.wrapper.appendChild(this.loadingSvg);
        }
        this.loadingSvg.style.display = 'block';
      }

      /**
       * Hide loading state
       */
      hideLoading() {
        if (this.loadingSvg) {
          this.loadingSvg.style.display = 'none';
        }
      }

      /**
       * Fetch data from server
       */
      async fetchResults(term) {
        this.showLoading();
        const query = `${this.url}?${this.param}=${encodeURIComponent(term)}`;
        try {
          const results = await get(query);
          this.isOpened = true;
          this.hideLoading();
          this.renderResults(results.data);
        } catch (e) {
          this.isOpened = false;
          this.hideLoading();
        }
        this.checkFilterColumnVisibility();
      }

      /**
       * Render results
       */
      /**
       * Render results
       */
      renderResults(results) {
        this.resultsDiv.innerHTML = '';
        results.forEach(result => {
          const option = document.createElement('div');
          const value = result.id || result.value;
          const text = result.value || result.name;
          option.classList.add('autocomplete__option');
          option.textContent = text;
          option.dataset.value = value;
          if (this.selectedItems.some(item => item.value.toString() === value.toString())) {
            option.classList.add('is-checked');
          }
          option.addEventListener('click', () => this.selectOption({
            text: text.toString(),
            value: value.toString()
          }));
          this.resultsDiv.appendChild(option);
        });
        this.resultsDiv.scrollTop = 0;
        this.resultsDiv.classList.add('is-active');
        this.addHoverEvents();
      }

      /**
       * Select an option
       */
      selectOption(option) {
        const matchingOption = this.resultsDiv.querySelector(`[data-value="${option.value}"]`);
        if (this.selectedItems.some(item => item.value === option.value)) {
          this.removeSelection(option.value);
          if (matchingOption) {
            matchingOption.classList.remove('is-checked');
          }
          return;
        }
        if (!this.multiple) {
          this.selectedItems = [option];
          this.resultsDiv.querySelectorAll('.is-checked').forEach(el => el.classList.remove('is-checked'));
        } else {
          this.selectedItems.push(option);
        }
        this.input.value = '';
        this.updateHiddenInputs();
        this.renderPreview();
        this.hideResults();
        this.updateFilterColumn();
        if (matchingOption) {
          matchingOption.classList.add('is-checked');
        }
        this.dispatchSelectEvent(option);
      }

      /**
       * Render preview items
       */
      renderPreview() {
        this.previewDiv.innerHTML = '';
        this.selectedItems.forEach(item => {
          const previewItem = document.createElement('div');
          previewItem.classList.add('autocomplete__preview-item');
          previewItem.dataset.value = item.value;
          previewItem.innerHTML = `
      <span class="autocomplete__preview-label">${item.text}</span>
      <button type="button" class="autocomplete__preview-remove">
        <svg class="icon"><use xlink:href="#icon-close"></use></svg>
      </button>
    `;
          previewItem.querySelector('.autocomplete__preview-remove').addEventListener('click', () => {
            this.removeSelection(item.value);
          });
          this.previewDiv.appendChild(previewItem);
        });
        this.updatePreviewVisibility();
      }

      /**
       * Remove selection
       */
      removeSelection(value) {
        this.selectedItems = this.selectedItems.filter(item => item.value !== value);
        this.updateHiddenInputs();
        this.renderPreview();
        this.dispatchUnselectEvent(value);
      }

      /**
       * Dispatch custom unselect event
       */
      dispatchUnselectEvent(value) {
        const event = new CustomEvent('autocomplete:unselect', {
          detail: {
            value
          }
        });
        this.input.dispatchEvent(event);
      }

      /**
       * Dispatch custom select event
       */
      dispatchSelectEvent(option) {
        const event = new CustomEvent('autocomplete:select', {
          detail: option
        });
        this.input.dispatchEvent(event);
      }

      /**
       * Update hidden inputs
       */
      updateHiddenInputs() {
        let hiddenInput = this.wrapper.querySelector('.autocomplete__hidden');
        if (!hiddenInput) {
          hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = `${this.input.name}_hidden`;
          hiddenInput.classList.add('autocomplete__hidden');
          this.wrapper.appendChild(hiddenInput);
        }
        hiddenInput.value = this.selectedItems.map(item => item.value).join(',');
      }

      /**
       * Update preview visibility
       */
      updatePreviewVisibility() {
        this.previewDiv.style.display = this.selectedItems.length > 0 ? 'block' : 'none';
      }

      /**
       * Add event listeners
       */
      addEventListeners() {
        this.input.addEventListener('input', e => {
          const term = e.target.value.trim();
          clearTimeout(this.debounceTimeout);
          if (term.length < this.minChars) {
            this.hideResults();
            this.hideLoading();
            return;
          }
          this.showLoading();
          this.debounceTimeout = setTimeout(async () => {
            await this.fetchResults(term);
          }, this.debounceDelay);
        });
        this.input.addEventListener('focus', e => {
          const term = e.target.value.trim();
          if (term.length >= this.minChars) {
            this.resultsDiv.classList.add('is-active');
            this.isOpened = true;
            this.checkFilterColumnVisibility();
          }
        });
        this.input.addEventListener('keydown', e => {
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            this.navigateOptions(e.key === 'ArrowDown');
          } else if (e.key === 'Enter') {
            e.preventDefault();
            this.selectFocusedOption();
          }
        });
        document.addEventListener('click', e => {
          if (!this.wrapper.contains(e.target)) {
            this.checkFilterColumnVisibility();
            this.hideResults();
          }
        });
      }

      /**
       * Hide results dropdown
       */
      hideResults() {
        this.resultsDiv.classList.remove('is-active');
        this.isOpened = false;
        this.checkFilterColumnVisibility();
      }
      checkFilterColumnVisibility() {
        if (this.filterColumn?.querySelector('.filter__column-content') && this.filterColumn.classList.contains('is-opened')) {
          this.filterColumn.querySelector('.filter__column-content').style.overflow = this.isOpened ? 'visible' : null;
        }
      }
      updateFilterColumn() {
        const filterColumnContent = this.filterColumn?.querySelector('.filter__column-content');
        if (filterColumnContent) {
          filterColumnContent.style.maxHeight = `${filterColumnContent.scrollHeight}px`;
        }
      }

      /**
       * Public API Methods
       */
      reset() {
        this.selectedItems = [];
        this.updateHiddenInputs();
        this.renderPreview();
      }
      show() {
        this.resultsDiv.scrollTop = 0;
        this.resultsDiv.classList.add('is-active');
        this.isOpened = true;
      }
      hide() {
        this.hideResults();
      }
      getSelectedItems() {
        return this.selectedItems;
      }

      /**
       * Update hover behavior
       */
      addHoverEvents() {
        const options = this.resultsDiv.querySelectorAll('.autocomplete__option');
        options.forEach(option => {
          option.addEventListener('mouseover', () => {
            [...options].map(opt => opt !== option && opt.classList.remove('is-focused'));
            if (!option.classList.contains('is-checked')) {
              this.clearHoverState();
              option.classList.add('is-hovered');
            }
          });
          option.addEventListener('mouseleave', () => {
            option.classList.remove('is-hovered');
          });
        });
      }

      /**
       * Clear hover state from all options
       */
      clearHoverState() {
        const options = this.resultsDiv.querySelectorAll('.autocomplete__option.is-hovered');
        options.forEach(option => option.classList.remove('is-hovered'));
      }

      /**
       * Navigate options with keyboard
       */
      navigateOptions(down) {
        const options = Array.from(this.resultsDiv.querySelectorAll('.autocomplete__option'));
        if (options.length === 0) return;
        const hovered = this.resultsDiv.querySelector('.is-hovered');
        const focused = this.resultsDiv.querySelector('.is-focused');
        let index = options.indexOf(hovered || focused);
        if (down) {
          if (index < options.length - 1) {
            // eslint-disable-next-line no-plusplus
            index++;
          }
        } else if (index > 0) {
          // eslint-disable-next-line no-plusplus
          index--;
        }
        options.forEach(opt => {
          opt.classList.remove('is-focused', 'is-hovered');
        });
        const selectedOption = options[index];
        if (selectedOption) {
          selectedOption.classList.add('is-focused');
          selectedOption.scrollIntoView({
            block: 'nearest'
          });
        }
      }

      /**
       * Select focused option
       */
      selectFocusedOption() {
        const focused = this.resultsDiv.querySelector('.is-focused');
        if (focused) {
          const value = {
            text: focused.textContent,
            value: focused.dataset.value.toString()
          };
          this.selectOption(value);
        }
      }
    }

    var t = function () {
        return t = Object.assign || function (t) {
          for (var i, n = 1, s = arguments.length; n < s; n++) for (var a in i = arguments[n]) Object.prototype.hasOwnProperty.call(i, a) && (t[a] = i[a]);
          return t;
        }, t.apply(this, arguments);
      },
      i = function () {
        function i(i, n, s) {
          var a = this;
          this.endVal = n, this.options = s, this.version = "2.9.0", this.defaults = {
            startVal: 0,
            decimalPlaces: 0,
            duration: 2,
            useEasing: !0,
            useGrouping: !0,
            useIndianSeparators: !1,
            smartEasingThreshold: 999,
            smartEasingAmount: 333,
            separator: ",",
            decimal: ".",
            prefix: "",
            suffix: "",
            enableScrollSpy: !1,
            scrollSpyDelay: 200,
            scrollSpyOnce: !1
          }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function (t) {
            a.startTime || (a.startTime = t);
            var i = t - a.startTime;
            a.remaining = a.duration - i, a.useEasing ? a.countDown ? a.frameVal = a.startVal - a.easingFn(i, 0, a.startVal - a.endVal, a.duration) : a.frameVal = a.easingFn(i, a.startVal, a.endVal - a.startVal, a.duration) : a.frameVal = a.startVal + (a.endVal - a.startVal) * (i / a.duration);
            var n = a.countDown ? a.frameVal < a.endVal : a.frameVal > a.endVal;
            a.frameVal = n ? a.endVal : a.frameVal, a.frameVal = Number(a.frameVal.toFixed(a.options.decimalPlaces)), a.printValue(a.frameVal), i < a.duration ? a.rAF = requestAnimationFrame(a.count) : null !== a.finalEndVal ? a.update(a.finalEndVal) : a.options.onCompleteCallback && a.options.onCompleteCallback();
          }, this.formatNumber = function (t) {
            var i,
              n,
              s,
              e,
              o = t < 0 ? "-" : "";
            i = Math.abs(t).toFixed(a.options.decimalPlaces);
            var r = (i += "").split(".");
            if (n = r[0], s = r.length > 1 ? a.options.decimal + r[1] : "", a.options.useGrouping) {
              e = "";
              for (var l = 3, h = 0, u = 0, p = n.length; u < p; ++u) a.options.useIndianSeparators && 4 === u && (l = 2, h = 1), 0 !== u && h % l == 0 && (e = a.options.separator + e), h++, e = n[p - u - 1] + e;
              n = e;
            }
            return a.options.numerals && a.options.numerals.length && (n = n.replace(/[0-9]/g, function (t) {
              return a.options.numerals[+t];
            }), s = s.replace(/[0-9]/g, function (t) {
              return a.options.numerals[+t];
            })), o + a.options.prefix + n + s + a.options.suffix;
          }, this.easeOutExpo = function (t, i, n, s) {
            return n * (1 - Math.pow(2, -10 * t / s)) * 1024 / 1023 + i;
          }, this.options = t(t({}, this.defaults), s), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.el = "string" == typeof i ? document.getElementById(i) : i, n = null == n ? this.parse(this.el.innerHTML) : n, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(n), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, "" === this.options.separator && (this.options.useGrouping = !1), this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", "undefined" != typeof window && this.options.enableScrollSpy && (this.error ? console.error(this.error, i) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function () {
            return a.handleScroll(a);
          }), window.onscroll = function () {
            window.onScrollFns.forEach(function (t) {
              return t();
            });
          }, this.handleScroll(this)));
        }
        return i.prototype.handleScroll = function (t) {
          if (t && window && !t.once) {
            var i = window.innerHeight + window.scrollY,
              n = t.el.getBoundingClientRect(),
              s = n.top + window.pageYOffset,
              a = n.top + n.height + window.pageYOffset;
            a < i && a > window.scrollY && t.paused ? (t.paused = !1, setTimeout(function () {
              return t.start();
            }, t.options.scrollSpyDelay), t.options.scrollSpyOnce && (t.once = !0)) : (window.scrollY > a || s > i) && !t.paused && t.reset();
          }
        }, i.prototype.determineDirectionAndSmartEasing = function () {
          var t = this.finalEndVal ? this.finalEndVal : this.endVal;
          this.countDown = this.startVal > t;
          var i = t - this.startVal;
          if (Math.abs(i) > this.options.smartEasingThreshold && this.options.useEasing) {
            this.finalEndVal = t;
            var n = this.countDown ? 1 : -1;
            this.endVal = t + n * this.options.smartEasingAmount, this.duration = this.duration / 2;
          } else this.endVal = t, this.finalEndVal = null;
          null !== this.finalEndVal ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
        }, i.prototype.start = function (t) {
          this.error || (this.options.onStartCallback && this.options.onStartCallback(), t && (this.options.onCompleteCallback = t), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
        }, i.prototype.pauseResume = function () {
          this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
        }, i.prototype.reset = function () {
          cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
        }, i.prototype.update = function (t) {
          cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, null == this.finalEndVal && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
        }, i.prototype.printValue = function (t) {
          var i;
          if (this.el) {
            var n = this.formattingFn(t);
            if (null === (i = this.options.plugin) || void 0 === i ? void 0 : i.render) this.options.plugin.render(this.el, n);else if ("INPUT" === this.el.tagName) this.el.value = n;else "text" === this.el.tagName || "tspan" === this.el.tagName ? this.el.textContent = n : this.el.innerHTML = n;
          }
        }, i.prototype.ensureNumber = function (t) {
          return "number" == typeof t && !isNaN(t);
        }, i.prototype.validateValue = function (t) {
          var i = Number(t);
          return this.ensureNumber(i) ? i : (this.error = "[CountUp] invalid start or end value: ".concat(t), null);
        }, i.prototype.resetDuration = function () {
          this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
        }, i.prototype.parse = function (t) {
          var i = function (t) {
              return t.replace(/([.,'  ])/g, "\\$1");
            },
            n = i(this.options.separator),
            s = i(this.options.decimal),
            a = t.replace(new RegExp(n, "g"), "").replace(new RegExp(s, "g"), ".");
          return parseFloat(a);
        }, i;
      }();

    var _ = typeof window !== 'undefined';

    const node_env = globalThis.process?.env?.NODE_ENV;
    node_env && !node_env.toLowerCase().startsWith('prod');

    const u = (n, t, e) => {
        const i = document.createElement(n),
          [s, a] = Array.isArray(t) ? [void 0, t] : [t, e];
        return s && Object.assign(i, s), a == null || a.forEach(r => i.appendChild(r)), i;
      },
      F = (n, t) => {
        var e;
        return t === "left" ? n.offsetLeft : (((e = n.offsetParent instanceof HTMLElement ? n.offsetParent : null) == null ? void 0 : e.offsetWidth) ?? 0) - n.offsetWidth - n.offsetLeft;
      },
      H = n => n.offsetWidth > 0 && n.offsetHeight > 0,
      st = (n, t) => {
        _ && !customElements.get(n) && customElements.define(n, t);
      };
    function X(n, t, {
      reverse: e = !1
    } = {}) {
      const i = n.length;
      for (let s = e ? i - 1 : 0; e ? s >= 0 : s < i; e ? s-- : s++) t(n[s], s);
    }
    function nt(n, t, e, i) {
      const s = t.formatToParts(n);
      e && s.unshift({
        type: "prefix",
        value: e
      }), i && s.push({
        type: "suffix",
        value: i
      });
      const a = [],
        r = [],
        o = [],
        c = [],
        d = {},
        p = h => `${h}:${d[h] = (d[h] ?? -1) + 1}`;
      let x = "",
        g = !1,
        y = !1;
      for (const h of s) {
        x += h.value;
        const l = h.type === "minusSign" || h.type === "plusSign" ? "sign" : h.type;
        l === "integer" ? (g = !0, r.push(...h.value.split("").map(C => ({
          type: l,
          value: parseInt(C)
        })))) : l === "group" ? r.push({
          type: l,
          value: h.value
        }) : l === "decimal" ? (y = !0, o.push({
          type: l,
          value: h.value,
          key: p(l)
        })) : l === "fraction" ? o.push(...h.value.split("").map(C => ({
          type: l,
          value: parseInt(C),
          key: p(l),
          pos: -1 - d[l]
        }))) : (g || y ? c : a).push({
          type: l,
          value: h.value,
          key: p(l)
        });
      }
      const T = [];
      for (let h = r.length - 1; h >= 0; h--) {
        const l = r[h];
        T.unshift(l.type === "integer" ? {
          ...l,
          key: p(l.type),
          pos: d[l.type]
        } : {
          ...l,
          key: p(l.type)
        });
      }
      return {
        pre: a,
        integer: T,
        fraction: o,
        post: c,
        valueAsString: x,
        value: typeof n == "string" ? parseFloat(n) : n
      };
    }
    const V = String.raw,
      O = _ && (() => {
        try {
          document.createElement("div").animate({
            opacity: 0
          }, {
            easing: "linear(0, 1)"
          });
        } catch {
          return !1;
        }
        return !0;
      })(),
      z = _ && typeof CSS < "u" && CSS.supports && CSS.supports("line-height", "mod(1,1)"),
      A = _ && typeof matchMedia < "u" ? matchMedia("(prefers-reduced-motion: reduce)") : null,
      $$1 = "--_number-flow-d-opacity",
      U = "--_number-flow-d-width",
      S = "--_number-flow-dx",
      j = "--_number-flow-d",
      Y = (() => {
        try {
          return CSS.registerProperty({
            name: $$1,
            syntax: "<number>",
            inherits: !1,
            initialValue: "0"
          }), CSS.registerProperty({
            name: S,
            syntax: "<length>",
            inherits: !0,
            initialValue: "0px"
          }), CSS.registerProperty({
            name: U,
            syntax: "<number>",
            inherits: !1,
            initialValue: "0"
          }), CSS.registerProperty({
            name: j,
            syntax: "<number>",
            inherits: !0,
            initialValue: "0"
          }), !0;
        } catch {
          return !1;
        }
      })(),
      P = "var(--number-flow-char-height, 1em)",
      f$1 = "var(--number-flow-mask-height, 0.25em)",
      k = `calc(${f$1} / 2)`,
      E = "var(--number-flow-mask-width, 0.5em)",
      m$1 = `calc(${E} / var(--scale-x))`,
      w = "#000 0, transparent 71%",
      M = V`:host{display:inline-block;direction:ltr;white-space:nowrap;isolation:isolate;line-height:${P} !important}.number,.number__inner{display:inline-block;transform-origin:left top}:host([data-will-change]) :is(.number,.number__inner,.section,.digit,.digit__num,.symbol){will-change:transform}.number{--scale-x:calc(1 + var(${U}) / var(--width));transform:translateX(var(${S})) scaleX(var(--scale-x));margin:0 calc(-1 * ${E});position:relative;-webkit-mask-image:linear-gradient(to right,transparent 0,#000 ${m$1},#000 calc(100% - ${m$1}),transparent ),linear-gradient(to bottom,transparent 0,#000 ${f$1},#000 calc(100% - ${f$1}),transparent 100% ),radial-gradient(at bottom right,${w}),radial-gradient(at bottom left,${w}),radial-gradient(at top left,${w}),radial-gradient(at top right,${w});-webkit-mask-size:100% calc(100% - ${f$1} * 2),calc(100% - ${m$1} * 2) 100%,${m$1} ${f$1},${m$1} ${f$1},${m$1} ${f$1},${m$1} ${f$1};-webkit-mask-position:center,center,top left,top right,bottom right,bottom left;-webkit-mask-repeat:no-repeat}.number__inner{padding:${k} ${E};transform:scaleX(calc(1 / var(--scale-x))) translateX(calc(-1 * var(${S})))}:host > :not(.number){z-index:5}.section,.symbol{display:inline-block;position:relative;isolation:isolate}.section::after{content:'\200b';display:inline-block}.section--justify-left{transform-origin:center left}.section--justify-right{transform-origin:center right}.section > [inert],.symbol > [inert]{margin:0 !important;position:absolute !important;z-index:-1}.digit{display:inline-block;position:relative;--c:var(--current) + var(${j})}.digit__num,.number .section::after{padding:${k} 0}.digit__num{display:inline-block;--offset-raw:mod(var(--length) + var(--n) - mod(var(--c),var(--length)),var(--length));--offset:calc( var(--offset-raw) - var(--length) * round(down,var(--offset-raw) / (var(--length) / 2),1) );--y:clamp(-100%,var(--offset) * 100%,100%);transform:translateY(var(--y))}.digit__num[inert]{position:absolute;top:0;left:50%;transform:translateX(-50%) translateY(var(--y))}.digit:not(.is-spinning) .digit__num[inert]{display:none}.symbol__value{display:inline-block;mix-blend-mode:plus-lighter;white-space:pre}.section--justify-left .symbol > [inert]{left:0}.section--justify-right .symbol > [inert]{right:0}.animate-presence{opacity:calc(1 + var(${$$1}))}`,
      G = _ ? HTMLElement : class {},
      q = z && O && Y;
    let b;
    class J extends G {
      constructor() {
        super(), this.created = !1, this.batched = !1;
        const {
          animated: t,
          ...e
        } = this.constructor.defaultProps;
        this._animated = this.computedAnimated = t, Object.assign(this, e);
      }
      get animated() {
        return this._animated;
      }
      set animated(t) {
        var e;
        this.animated !== t && (this._animated = t, (e = this.shadowRoot) == null || e.getAnimations().forEach(i => i.finish()));
      }
      /**
       * @internal
       */
      set data(t) {
        var o;
        if (t == null) return;
        const {
          pre: e,
          integer: i,
          fraction: s,
          post: a,
          value: r
        } = t;
        if (this.created) {
          const c = this._data;
          this._data = t, this.computedTrend = typeof this.trend == "function" ? this.trend(c.value, r) : this.trend, this.computedAnimated = q && this._animated && (!this.respectMotionPreference || !(A != null && A.matches)) &&
          // https://github.com/barvian/number-flow/issues/9
          H(this), (o = this.plugins) == null || o.forEach(d => {
            var p;
            return (p = d.onUpdate) == null ? void 0 : p.call(d, t, c, this);
          }), this.batched || this.willUpdate(), this._pre.update(e), this._num.update({
            integer: i,
            fraction: s
          }), this._post.update(a), this.batched || this.didUpdate();
        } else {
          this._data = t, this.attachShadow({
            mode: "open"
          });
          try {
            this._internals ?? (this._internals = this.attachInternals()), this._internals.role = "img";
          } catch {}
          if (typeof CSSStyleSheet < "u" && this.shadowRoot.adoptedStyleSheets) b || (b = new CSSStyleSheet(), b.replaceSync(M)), this.shadowRoot.adoptedStyleSheets = [b];else {
            const c = document.createElement("style");
            c.textContent = M, this.shadowRoot.appendChild(c);
          }
          this._pre = new N(this, e, {
            justify: "right",
            part: "left"
          }), this.shadowRoot.appendChild(this._pre.el), this._num = new Q(this, i, s), this.shadowRoot.appendChild(this._num.el), this._post = new N(this, a, {
            justify: "left",
            part: "right"
          }), this.shadowRoot.appendChild(this._post.el), this.created = !0;
        }
        try {
          this._internals.ariaLabel = t.valueAsString;
        } catch {}
      }
      /**
       * @internal
       */
      willUpdate() {
        this._pre.willUpdate(), this._num.willUpdate(), this._post.willUpdate();
      }
      /**
       * @internal
       */
      didUpdate() {
        if (!this.computedAnimated) return;
        this._abortAnimationsFinish ? this._abortAnimationsFinish.abort() : this.dispatchEvent(new Event("animationsstart")), this._pre.didUpdate(), this._num.didUpdate(), this._post.didUpdate();
        const t = new AbortController();
        Promise.all(this.shadowRoot.getAnimations().map(e => e.finished)).then(() => {
          t.signal.aborted || (this.dispatchEvent(new Event("animationsfinish")), this._abortAnimationsFinish = void 0);
        }), this._abortAnimationsFinish = t;
      }
    }
    J.defaultProps = {
      transformTiming: {
        duration: 900,
        // Make sure to keep this minified:
        easing: "linear(0,.005,.019,.039,.066,.096,.129,.165,.202,.24,.278,.316,.354,.39,.426,.461,.494,.526,.557,.586,.614,.64,.665,.689,.711,.731,.751,.769,.786,.802,.817,.831,.844,.856,.867,.877,.887,.896,.904,.912,.919,.925,.931,.937,.942,.947,.951,.955,.959,.962,.965,.968,.971,.973,.976,.978,.98,.981,.983,.984,.986,.987,.988,.989,.99,.991,.992,.992,.993,.994,.994,.995,.995,.996,.996,.9963,.9967,.9969,.9972,.9975,.9977,.9979,.9981,.9982,.9984,.9985,.9987,.9988,.9989,1)"
      },
      spinTiming: void 0,
      opacityTiming: {
        duration: 450,
        easing: "ease-out"
      },
      animated: !0,
      trend: (n, t) => Math.sign(t - n),
      respectMotionPreference: !0,
      plugins: void 0,
      digits: void 0
    };
    class Q {
      constructor(t, e, i, {
        className: s,
        ...a
      } = {}) {
        this.flow = t, this._integer = new L$1(t, e, {
          justify: "right",
          part: "integer"
        }), this._fraction = new L$1(t, i, {
          justify: "left",
          part: "fraction"
        }), this._inner = u("span", {
          className: "number__inner"
        }, [this._integer.el, this._fraction.el]), this.el = u("span", {
          ...a,
          part: "number",
          className: `number ${s ?? ""}`
        }, [this._inner]);
      }
      willUpdate() {
        this._prevWidth = this.el.offsetWidth, this._prevLeft = this.el.getBoundingClientRect().left, this._integer.willUpdate(), this._fraction.willUpdate();
      }
      update({
        integer: t,
        fraction: e
      }) {
        this._integer.update(t), this._fraction.update(e);
      }
      didUpdate() {
        const t = this.el.getBoundingClientRect();
        this._integer.didUpdate(), this._fraction.didUpdate();
        const e = this._prevLeft - t.left,
          i = this.el.offsetWidth,
          s = this._prevWidth - i;
        this.el.style.setProperty("--width", String(i)), this.el.animate({
          [S]: [`${e}px`, "0px"],
          [U]: [s, 0]
        }, {
          ...this.flow.transformTiming,
          composite: "accumulate"
        });
      }
    }
    class W {
      constructor(t, e, {
        justify: i,
        className: s,
        ...a
      }, r) {
        this.flow = t, this.children = /* @__PURE__ */new Map(), this.onCharRemove = c => () => {
          this.children.delete(c);
        }, this.justify = i;
        const o = e.map(c => this.addChar(c).el);
        this.el = u("span", {
          ...a,
          className: `section section--justify-${i} ${s ?? ""}`
        }, r ? r(o) : o);
      }
      addChar(t, {
        startDigitsAtZero: e = !1,
        ...i
      } = {}) {
        const s = t.type === "integer" || t.type === "fraction" ? new D(this, t.type, e ? 0 : t.value, t.pos, {
          ...i,
          onRemove: this.onCharRemove(t.key)
        }) : new tt(this, t.type, t.value, {
          ...i,
          onRemove: this.onCharRemove(t.key)
        });
        return this.children.set(t.key, s), s;
      }
      unpop(t) {
        t.el.removeAttribute("inert"), t.el.style.top = "", t.el.style[this.justify] = "";
      }
      pop(t) {
        t.forEach(e => {
          e.el.style.top = `${e.el.offsetTop}px`, e.el.style[this.justify] = `${F(e.el, this.justify)}px`;
        }), t.forEach(e => {
          e.el.setAttribute("inert", ""), e.present = !1;
        });
      }
      addNewAndUpdateExisting(t) {
        const e = /* @__PURE__ */new Map(),
          i = /* @__PURE__ */new Map(),
          s = this.justify === "left",
          a = s ? "prepend" : "append";
        if (X(t, r => {
          let o;
          this.children.has(r.key) ? (o = this.children.get(r.key), i.set(r, o), this.unpop(o), o.present = !0) : (o = this.addChar(r, {
            startDigitsAtZero: !0,
            animateIn: !0
          }), e.set(r, o)), this.el[a](o.el);
        }, {
          reverse: s
        }), this.flow.computedAnimated) {
          const r = this.el.getBoundingClientRect();
          e.forEach(o => {
            o.willUpdate(r);
          });
        }
        e.forEach((r, o) => {
          r.update(o.value);
        }), i.forEach((r, o) => {
          r.update(o.value);
        });
      }
      willUpdate() {
        const t = this.el.getBoundingClientRect();
        this._prevOffset = t[this.justify], this.children.forEach(e => e.willUpdate(t));
      }
      didUpdate() {
        const t = this.el.getBoundingClientRect();
        this.children.forEach(s => s.didUpdate(t));
        const e = t[this.justify],
          i = this._prevOffset - e;
        i && this.children.size && this.el.animate({
          transform: [`translateX(${i}px)`, "none"]
        }, {
          ...this.flow.transformTiming,
          composite: "accumulate"
        });
      }
    }
    class L$1 extends W {
      update(t) {
        const e = /* @__PURE__ */new Map();
        this.children.forEach((i, s) => {
          t.find(a => a.key === s) || e.set(s, i), this.unpop(i);
        }), this.addNewAndUpdateExisting(t), e.forEach(i => {
          i instanceof D && i.update(0);
        }), this.pop(e);
      }
    }
    class N extends W {
      update(t) {
        const e = /* @__PURE__ */new Map();
        this.children.forEach((i, s) => {
          t.find(a => a.key === s) || e.set(s, i);
        }), this.pop(e), this.addNewAndUpdateExisting(t);
      }
    }
    class R {
      constructor(t, e, {
        onRemove: i,
        animateIn: s = !1
      } = {}) {
        this.flow = t, this.el = e, this._present = !0, this._remove = () => {
          var a;
          this.el.remove(), (a = this._onRemove) == null || a.call(this);
        }, this.el.classList.add("animate-presence"), this.flow.computedAnimated && s && this.el.animate({
          [$$1]: [-0.9999, 0]
        }, {
          ...this.flow.opacityTiming,
          composite: "accumulate"
        }), this._onRemove = i;
      }
      get present() {
        return this._present;
      }
      set present(t) {
        if (this._present !== t) {
          if (this._present = t, t ? this.el.removeAttribute("inert") : this.el.setAttribute("inert", ""), !this.flow.computedAnimated) {
            t || this._remove();
            return;
          }
          this.el.style.setProperty("--_number-flow-d-opacity", t ? "0" : "-.999"), this.el.animate({
            [$$1]: t ? [-0.9999, 0] : [0.999, 0]
          }, {
            ...this.flow.opacityTiming,
            composite: "accumulate"
          }), t ? this.flow.removeEventListener("animationsfinish", this._remove) : this.flow.addEventListener("animationsfinish", this._remove, {
            once: !0
          });
        }
      }
    }
    class B extends R {
      constructor(t, e, i, s) {
        super(t.flow, i, s), this.section = t, this.value = e, this.el = i;
      }
    }
    class D extends B {
      constructor(t, e, i, s, a) {
        var d, p;
        const r = (((p = (d = t.flow.digits) == null ? void 0 : d[s]) == null ? void 0 : p.max) ?? 9) + 1,
          o = Array.from({
            length: r
          }).map((x, g) => {
            const y = u("span", {
              className: "digit__num"
            }, [document.createTextNode(String(g))]);
            return g !== i && y.setAttribute("inert", ""), y.style.setProperty("--n", String(g)), y;
          }),
          c = u("span", {
            part: `digit ${e}-digit`,
            className: "digit"
          }, o);
        c.style.setProperty("--current", String(i)), c.style.setProperty("--length", String(r)), super(t, i, c, a), this.pos = s, this._onAnimationsFinish = () => {
          this.el.classList.remove("is-spinning");
        }, this._numbers = o, this.length = r;
      }
      willUpdate(t) {
        const e = this.el.getBoundingClientRect();
        this._prevValue = this.value;
        const i = e[this.section.justify] - t[this.section.justify],
          s = e.width / 2;
        this._prevCenter = this.section.justify === "left" ? i + s : i - s;
      }
      update(t) {
        this.el.style.setProperty("--current", String(t)), this._numbers.forEach((e, i) => i === t ? e.removeAttribute("inert") : e.setAttribute("inert", "")), this.value = t;
      }
      didUpdate(t) {
        const e = this.el.getBoundingClientRect(),
          i = e[this.section.justify] - t[this.section.justify],
          s = e.width / 2,
          a = this.section.justify === "left" ? i + s : i - s,
          r = this._prevCenter - a;
        r && this.el.animate({
          transform: [`translateX(${r}px)`, "none"]
        }, {
          ...this.flow.transformTiming,
          composite: "accumulate"
        });
        const o = this.getDelta();
        o && (this.el.classList.add("is-spinning"), this.el.animate({
          [j]: [-o, 0]
        }, {
          ...(this.flow.spinTiming ?? this.flow.transformTiming),
          composite: "accumulate"
        }), this.flow.addEventListener("animationsfinish", this._onAnimationsFinish, {
          once: !0
        }));
      }
      getDelta() {
        var i;
        if (this.flow.plugins) for (const s of this.flow.plugins) {
          const a = (i = s.getDelta) == null ? void 0 : i.call(s, this.value, this._prevValue, this);
          if (a != null) return a;
        }
        const t = this.value - this._prevValue,
          e = this.flow.computedTrend || Math.sign(t);
        return e < 0 && this.value > this._prevValue ? this.value - this.length - this._prevValue : e > 0 && this.value < this._prevValue ? this.length - this._prevValue + this.value : t;
      }
    }
    class tt extends B {
      constructor(t, e, i, s) {
        const a = u("span", {
          className: "symbol__value",
          textContent: i
        });
        super(t, i, u("span", {
          part: `symbol ${e}`,
          className: "symbol"
        }, [a]), s), this.type = e, this._children = /* @__PURE__ */new Map(), this._onChildRemove = r => () => {
          this._children.delete(r);
        }, this._children.set(i, new R(this.flow, a, {
          onRemove: this._onChildRemove(i)
        }));
      }
      willUpdate(t) {
        if (this.type === "decimal") return;
        const e = this.el.getBoundingClientRect();
        this._prevOffset = e[this.section.justify] - t[this.section.justify];
      }
      update(t) {
        if (this.value !== t) {
          const e = this._children.get(this.value);
          e && (e.present = !1);
          const i = this._children.get(t);
          if (i) i.present = !0;else {
            const s = u("span", {
              className: "symbol__value",
              textContent: t
            });
            this.el.appendChild(s), this._children.set(t, new R(this.flow, s, {
              animateIn: !0,
              onRemove: this._onChildRemove(t)
            }));
          }
        }
        this.value = t;
      }
      didUpdate(t) {
        if (this.type === "decimal") return;
        const i = this.el.getBoundingClientRect()[this.section.justify] - t[this.section.justify],
          s = this._prevOffset - i;
        s && this.el.animate({
          transform: [`translateX(${s}px)`, "none"]
        }, {
          ...this.flow.transformTiming,
          composite: "accumulate"
        });
      }
    }

    const l = "number-flow-connect",
      m = "number-flow-update";
    class f extends J {
      constructor() {
        super(...arguments), this.connected = !1;
      }
      connectedCallback() {
        this.connected = !0, this.dispatchEvent(new Event(l, {
          bubbles: !0
        }));
      }
      disconnectedCallback() {
        this.connected = !1;
      }
      get value() {
        return this._value;
      }
      update(e) {
        (!this._formatter || this._prevFormat !== this.format || this._prevLocales !== this.locales) && (this._formatter = new Intl.NumberFormat(this.locales, this.format), this._prevFormat = this.format, this._prevLocales = this.locales), e != null && (this._value = e), this.dispatchEvent(new Event(m, {
          bubbles: !0
        })), this.data = nt(this._value, this._formatter, this.numberPrefix, this.numberSuffix);
      }
    }
    st("number-flow", f);

    function autoTypeInput({
      element = null,
      phrases,
      typeSpeed = 30,
      pause = 3000
    }) {
      if (!element || !phrases || phrases && phrases?.length === 0) return;
      const inputEl = element;
      if (!inputEl) return;
      let idx = 0;
      function typePhrase() {
        const text = phrases[idx];
        let i = 0;
        inputEl.setAttribute('placeholder', '');
        function typeChar() {
          if (i < text.length) {
            i++;
            inputEl.setAttribute('placeholder', text.slice(0, i));
            setTimeout(typeChar, typeSpeed);
          } else {
            setTimeout(() => {
              idx = (idx + 1) % phrases.length;
              typePhrase();
            }, pause);
          }
        }
        typeChar();
      }
      typePhrase();
    }

    // eslint-disable-next-line max-classes-per-file
    class StickyObserver {
      constructor({
        selector = '[data-sticky]',
        className = 'is-sticky'
      } = {}) {
        this.selector = selector;
        this.className = className;
        this.items = [];
        // eslint-disable-next-line no-underscore-dangle
        this._onResize = this._onResize.bind(this);
        // eslint-disable-next-line no-underscore-dangle
        this._init();
      }

      // eslint-disable-next-line no-underscore-dangle
      _init() {
        document.querySelectorAll(this.selector).forEach(el => {
          // eslint-disable-next-line no-use-before-define
          this.items.push(new StickyItem(el, this.className));
        });
        // eslint-disable-next-line no-underscore-dangle
        window.addEventListener('resize', this._onResize, {
          passive: true
        });
      }

      // eslint-disable-next-line no-underscore-dangle
      _onResize() {
        // eslint-disable-next-line no-restricted-syntax
        for (const item of this.items) item.refresh();
      }
      destroy() {
        // eslint-disable-next-line no-underscore-dangle
        window.removeEventListener('resize', this._onResize);
        // eslint-disable-next-line no-restricted-syntax
        for (const item of this.items) item.destroy();
        this.items = [];
      }
    }
    class StickyItem {
      constructor(el, className) {
        this.el = el;
        this.className = className;
        this.sentinel = document.createElement('span');
        this.sentinel.setAttribute('aria-hidden', 'true');
        this.sentinel.style.cssText = 'display:block;height:0px;padding:0;margin:0;border:0;';
        this.el.before(this.sentinel);

        // eslint-disable-next-line no-use-before-define
        this.scrollRoot = getScrollParent(this.el);
        this.io = null;
        this.ro = new ResizeObserver(() => this.refresh());
        this.ro.observe(this.el);
        this.enabled = false;
        this.refresh();
      }
      refresh() {
        const cs = getComputedStyle(this.el);
        const isSticky = cs.position === 'sticky';
        const top = parseFloat(cs.top) || 0;
        if (!isSticky) {
          // eslint-disable-next-line no-underscore-dangle
          this._disable();
          this.el.classList.remove(this.className);
          return;
        }
        const root = this.scrollRoot === document.scrollingElement ? null : this.scrollRoot;
        const rootMargin = `${-top - 1}px 0px 0px 0px`;
        if (this.io) {
          const prevRoot = this.io.root;
          const prevRootMargin = this.io.rootMargin;
          if (prevRoot === root && prevRootMargin === rootMargin) return;
          this.io.disconnect();
        }
        this.io = new IntersectionObserver(entries => {
          const e = entries[0];
          if (!e) return;
          if (!e.isIntersecting) {
            this.el.classList.add(this.className);
          } else {
            this.el.classList.remove(this.className);
          }
        }, {
          root,
          threshold: [0],
          rootMargin
        });
        this.io.observe(this.sentinel);
        this.enabled = true;
      }

      // eslint-disable-next-line no-underscore-dangle
      _disable() {
        if (this.io) {
          this.io.disconnect();
          this.io = null;
        }
        this.enabled = false;
      }
      destroy() {
        // eslint-disable-next-line no-underscore-dangle
        this._disable();
        this.ro.disconnect();
        if (this.sentinel && this.sentinel.parentNode) {
          this.sentinel.parentNode.removeChild(this.sentinel);
        }
      }
    }
    function getScrollParent(el) {
      let node = el.parentElement;
      while (node && node !== document.body) {
        const cs = getComputedStyle(node);
        const {
          overflowY
        } = cs;
        if (/(auto|scroll|overlay)/.test(overflowY)) return node;
        node = node.parentElement;
      }
      return document.scrollingElement || document.documentElement;
    }

    /**
     * Components
     */
    // eslint-disable-next-line import/order

    if (!customElements.get('number-flow')) {
      customElements.define('number-flow', f);
    }
    dayjs.extend(customParseFormat);
    dayjs.extend(dayJsDuration);

    /**
     * APP
     */
    class App {
      // Constructor
      constructor() {
        this.isLoadedClass = 'is-loaded';
        this.isPreloadingClass = 'is-preloading';
        this.activeClass = 'is-active';
        this.openedClass = 'is-opened';
        this.isMobile = window.matchMedia('(max-width: 992px)').matches;
      }

      // Initialization
      async init() {
        this.stickyNavbar();
        this.scrollAnchors();
        this.dropdown();
        this.hamburger();
        this.lightgallery();
        this.share();
        this.modal();
        this.tab();
        this.isotope();
        this.accordion();
        this.compliance();
        this.megaMenu();
        this.carousel();
        this.prices();
        this.utils();
        this.filterBox();
        this.inputs();
        this.search();
        this.appHeight();
        this.tooltip();
        this.countdown();
        this.counter();
        this.inputIntTel();
        this.collapsableEntry();
        this.blockLoader();
        this.prices();
        this.priceSwitcher();
        this.stickyObserver();
        this.dynamicAriaTags();
        this.contactDetails();
        await this.map();
        document.documentElement.classList.add(this.isLoadedClass);
      }

      /**
       * Sticky Navbar
       */
      // eslint-disable-next-line class-methods-use-this
      stickyNavbar() {
        const navbar = document.querySelector('.layout__header');
        if (navbar) {
          const sticky = new MOBStickyNavbar(navbar);
          sticky.init();
        }
      }

      /**
       * Scroll Ancors
       */
      // eslint-disable-next-line class-methods-use-this
      scrollAnchors() {
        const anchors = [...document.querySelectorAll('[data-scroll-to]')];
        if (anchors) {
          anchors.forEach(item => {
            const anchor = new MOBScrollTo(item, {
              hash: item.dataset.scrollTo === 'hash'
            });
            anchor.init();
          });
        }
      }

      /**
       * Lightgallery
       */
      // eslint-disable-next-line class-methods-use-this
      lightgallery() {
        const galleries = Array.from(document.querySelectorAll('[data-gallery]'));
        galleries.forEach(gallery => {
          const isSingle = !gallery.querySelector('[data-gallery-item]');
          let plugins = [Video];
          if (gallery.dataset.gallery !== 'video') plugins = [...plugins, Zoom, FullScreen];

          // if (gallery.dataset.galleryThumbnail === 'true') plugins.push(lgThumbnail);

          const options = {
            plugins,
            licenseKey: '0E97F16B-BB4F4207-8231D4F5-D8C5595E',
            selector: isSingle ? 'this' : '[data-gallery-item]',
            download: false,
            allowMediaOverlap: true,
            getCaptionFromTitleOrAlt: false,
            counter: !isSingle,
            videojs: true,
            videojsOptions: {
              youtube: {
                modestbranding: 1,
                showinfo: 0,
                rel: 0,
                iv_load_policy: 3
              }
            },
            iframeMaxWidth: '100%',
            youtubePlayerParams: {
              modestbranding: 1,
              showinfo: 0,
              rel: 0,
              iv_load_policy: 3
            },
            mobileSettings: {
              controls: true,
              showCloseIcon: true,
              download: false
            }
          };
          lightGallery(gallery, options);

          // Fix YouTube Error 153 by adding referrerpolicy to iframe
          gallery.addEventListener('lgAfterOpen', () => {
            setTimeout(() => {
              const youtubeIframe = document.querySelector('.lg-video-object.lg-youtube');
              if (youtubeIframe && !youtubeIframe.hasAttribute('referrerpolicy')) {
                youtubeIframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
                // Also ensure the src uses https:// instead of //
                const src = youtubeIframe.getAttribute('src');
                if (src && src.startsWith('//')) {
                  youtubeIframe.setAttribute('src', `https:${src}`);
                }
              }
            }, 100);
          });
        });
      }

      /**
       * Carousel
       */
      // eslint-disable-next-line class-methods-use-this
      carousel() {
        let thumbSlider;
        const sliders = Array.from(document.querySelectorAll(`[data-slider]:not(.${this.isLoadedClass})`));
        // eslint-disable-next-line no-shadow
        sliders.forEach(slider => {
          if (hasJSLoaded(slider, ['slide'])) return;
          const items = Array.from(slider.querySelectorAll('.slider__item'));
          const grid = slider.dataset.sliderGrid === 'auto' ? slider.dataset.sliderGrid : parseFloat(slider.dataset.sliderGrid);
          const group = slider.dataset.sliderGroup ? parseFloat(slider.dataset.sliderGroup) : 1;
          const space = parseFloat(slider.dataset.sliderGap);
          const speed = parseFloat(slider.dataset.sliderSpeed);
          const loop = items.length > 1 ? slider.dataset.sliderLoop === 'true' : false;
          const autoplay = parseFloat(slider.dataset.sliderAutoplay);
          const autoheight = slider.dataset.sliderAutoheight === 'true';
          const effect = slider.dataset.sliderEffect;
          const crossFade = slider.dataset.sliderCrossFade;
          const lazy = slider.dataset.sliderLazy;
          const parallax = slider.dataset.sliderParallax === 'true';
          const sliderLoop = parseFloat(slider.dataset.sliderSliderLoop);
          const hoverChange = slider.dataset.sliderHoverChange === 'true';
          const centered = slider.dataset.sliderCentered === 'true';
          const pagination = slider.querySelector('[data-slider-pagination]');
          const direction = slider.dataset.sliderDirection;
          const hasThumb = slider.dataset.sliderThumb === 'true';
          const sliderId = slider.id ? `#${slider.id}` : null;
          const additionalTargets = sliderId ? document.querySelectorAll(`[data-slider-additional-target="${sliderId}"]`) : [];
          let navigationPrev = slider.querySelector('[data-slider-navigation-prev]');
          let navigationNext = slider.querySelector('[data-slider-navigation-next]');
          const startLast = slider.dataset.sliderStartLast === 'true';
          const infiniteSlide = slider.dataset.sliderInfiniteSlide === 'true';
          // Swiper 9+ dropped the Lazy module in favour of native `loading="lazy"`
          // images; this only decides how many neighbouring slides get preloaded.
          let lazyPreloadAmount = 1;
          if (lazy === 'false') lazyPreloadAmount = 0;else if (loop && grid === 'auto') lazyPreloadAmount = this.isMobile ? 2 : 5;
          const breakpoints = {
            md: 768,
            lg: 991,
            xl: 1200
          };
          const options = {
            slidesPerView: effect !== 'fade' ? grid || 1 : 1,
            spaceBetween: effect !== 'fade' ? space || 0 : 0,
            centeredSlides: centered,
            direction: direction || 'horizontal',
            slidesPerGroup: group,
            loop: !!loop,
            autoHeight: autoheight,
            autoplay: autoplay ? {
              delay: autoplay,
              disableOnInteraction: false
            } : false,
            speed: speed || 400,
            // Swiper 9+ dropped the Lazy module in favour of native `loading="lazy"`
            // images; this only decides how many neighbouring slides get preloaded.
            lazyPreloadPrevNext: lazyPreloadAmount,
            watchSlidesVisibility: true,
            effect: effect || 'slide',
            fadeEffect: effect === 'fade' && crossFade !== false ? {
              crossFade: true
            } : false,
            parallax: !!parallax,
            loopedSlides: sliderLoop || (grid === 'auto' ? 10 : null),
            watchOverflow: true,
            breakpoints: {}
          };

          // Slider Per View Responsive
          Object.entries(breakpoints).forEach(([key, value]) => {
            const gridBreakpoint = slider.getAttribute(`data-slider-grid-${key}`) === 'auto' ? slider.getAttribute(`data-slider-grid-${key}`) : parseFloat(slider.getAttribute(`data-slider-grid-${key}`));
            const spaceBreakpoint = parseFloat(slider.getAttribute(`data-slider-gap-${key}`));
            const speedBreakpoint = parseFloat(slider.getAttribute(`data-slider-speed-${key}`));
            const groupBreakpoint = parseFloat(slider.getAttribute(`data-slider-group-${key}`));
            const directionBreakpoint = slider.getAttribute(`data-slider-direction-${key}`);
            const centeredBreakpoint = slider.getAttribute(`data-slider-centered-${key}`);
            if (gridBreakpoint || spaceBreakpoint || speedBreakpoint || groupBreakpoint || centeredBreakpoint) {
              options.breakpoints[value] = {};
              if (gridBreakpoint && effect !== 'fade') {
                options.breakpoints[value].slidesPerView = gridBreakpoint;
              }

              // Gap
              if (spaceBreakpoint && effect !== 'fade') options.breakpoints[value].spaceBetween = spaceBreakpoint;

              // Direction
              if (directionBreakpoint) options.breakpoints[value].direction = directionBreakpoint;

              // Speed
              if (speedBreakpoint) options.breakpoints[value].speed = speedBreakpoint;

              // Group
              if (groupBreakpoint) options.breakpoints[value].slidesPerGroup = groupBreakpoint;

              // Centered
              if (centeredBreakpoint) options.breakpoints[value].centeredSlides = centeredBreakpoint === 'true';
            }
          });

          // console.log(options.breakpoints);

          // Navigation
          if (!navigationNext && !navigationPrev) {
            let parent = null;
            if (slider.closest('[data-slider-parent]')) parent = slider.closest('[data-slider-parent]');
            if (parent) {
              navigationPrev = parent.querySelector('[data-slider-navigation-prev]');
              navigationNext = parent.querySelector('[data-slider-navigation-next]');
            }
          }
          if (navigationPrev || navigationNext) {
            options.navigation = {};
            options.navigation.disabledClass = 'slider__navigation--disabled';
            options.navigation.lockClass = 'd-none';
            if (navigationPrev) {
              options.navigation.prevEl = navigationPrev;
              navigationPrev.classList.add('is-show');
            }
            if (navigationNext) {
              options.navigation.nextEl = navigationNext;
              navigationNext.classList.add('is-show');
            }
          }

          // Pagination
          if (pagination) {
            // nested pagination bug fix
            if ([...slider.querySelectorAll('[data-slider]')].length === 0) {
              options.pagination = {};
              options.pagination.el = pagination;
              options.pagination.bulletClass = 'slider__pagination-item';
              options.pagination.bulletActiveClass = 'slider__pagination-item--active';
              options.pagination.clickable = true;
              options.pagination.lockClass = 'd-none';
              pagination.classList.add('is-show');
            }
          }

          // Scrollbar
          if (slider.querySelector('[data-slider-scrollbar]')) {
            options.scrollbar = {};
            options.scrollbar.draggable = true;
            options.scrollbar.el = slider.querySelector('[data-slider-scrollbar]');
            options.scrollbar.dragClass = 'slider__scrollbar-drag';
            options.scrollbar.lockClass = 'd-none';
          }

          // console.log(options);

          if (thumbSlider) {
            options.thumbs = {
              swiper: thumbSlider,
              slideThumbActiveClass: 'is-active'
            };
            thumbSlider = null;
          }
          if (infiniteSlide) {
            slider.classList.add('slider--infinite');
            options.loop = false;
            options.loopedSlides = 20;
            options.loopAddBlankSlides = true;
            options.autoplay = {
              delay: 1,
              disabledOnInteraction: false
            };
            options.speed = 5000;
            options.allowTouchMove = false;
            options.simulateTouch = false;
            options.pagination = false;
            options.navigation = false;
          }

          // console.log(options);

          if (isVisible(slider)) {
            const swiper = new Swiper(slider.querySelector('.swiper'), options);

            // The old Lazy module added `is-loaded` to a slide image and removed the
            // slide's `.swiper-lazy-preloader` once it was in. Images now arrive either
            // natively (`loading="lazy"`) or through lazysizes (`data-src`), so mirror it.
            const settleSlideImage = image => {
              image.classList.add('is-loaded');
              const slide = image.closest('.swiper-slide');
              if (slide) [...slide.querySelectorAll('.swiper-lazy-preloader')].forEach(el => el.remove());
            };
            [...slider.querySelectorAll('.swiper-slide img')].forEach(image => {
              if (image.complete && image.naturalWidth > 0) settleSlideImage(image);else image.addEventListener('load', () => settleSlideImage(image), {
                once: true
              });
            });
            if (startLast) {
              swiper.slideTo(items.length - 1, false);
            }
            if (hasThumb) {
              if (items.length) thumbSlider = swiper;
              if (items.length === 0) slider.remove();
            }
            if (hoverChange) {
              const hoverWrapper = document.createElement('div');
              hoverWrapper.className = 'slider__hoverable';

              // eslint-disable-next-line array-callback-return
              [...items].map(item => {
                const hoverItem = document.createElement('a');
                hoverItem.className = 'slider__hoverable-item no-transition';
                const link = item.querySelector('a[href]');
                if (link) hoverItem.href = link.getAttribute('href');
                hoverWrapper.append(hoverItem);
              });
              slider.append(hoverWrapper);
              const hoverItems = slider.querySelectorAll('.slider__hoverable-item');
              [...hoverItems].map((i, k) => i.addEventListener('mouseover', () => swiper.slideTo(k)));
            }
            if (additionalTargets.length > 0) {
              // Function to sync accordion with slider
              const syncAccordion = activeIndex => {
                const accordion = [...additionalTargets][0].closest('[data-accordion]');
                const list = accordion.querySelectorAll('[data-accordion-item]');
                [...list].map((item, key) => {
                  const content = item.querySelector('[data-accordion-content]');
                  const isActive = key === activeIndex;
                  if (content) {
                    content.style.maxHeight = isActive ? `${content.scrollHeight}px` : null;
                  }

                  // Use both is-active and is-opened for compatibility
                  item.classList.toggle('is-active', isActive);
                  item.classList.toggle('is-opened', isActive);
                  return item;
                });
              };

              // Set initial state on load
              syncAccordion(swiper.realIndex);

              // Sync accordion when clicking on it
              [...additionalTargets].forEach(target => target.addEventListener('click', () => {
                const accordion = target.closest('[data-accordion]');
                const list = accordion.querySelectorAll('[data-accordion-item]');
                const parentIndex = [...list].indexOf(target.closest('[data-accordion-item]'));
                swiper.slideToLoop(parentIndex);
              }));

              // Sync accordion when slider changes
              swiper.on('slideChangeTransitionStart', s => {
                syncAccordion(s.realIndex);
              });
            }
            setJSLoaded(slider, ['slider']);
          }
        });
      }

      /**
       * Isotope
       */
      // eslint-disable-next-line class-methods-use-this
      isotope() {
        const isotopes = Array.from(document.querySelectorAll('[data-isotope]'));
        const isotopeFilterToggle = Array.from(document.querySelectorAll('[data-isotope-filter]'));
        isotopes.forEach(item => {
          // eslint-disable-next-line no-unused-vars
          const isotopeLayout = new Isotope(item, {
            itemSelector: '[data-isotope-item]',
            percentPosition: true,
            layoutMode: 'fitRows',
            fitRows: {
              equalheight: true
            }
          });
          isotopeFilterToggle.forEach(toggle => {
            toggle.addEventListener('click', e => {
              e.preventDefault();
              const filterName = toggle.dataset.isotopeFilter;
              if (typeof filterName !== 'undefined') isotopeLayout.arrange({
                filter: filterName
              });
              // eslint-disable-next-line no-shadow
              isotopeFilterToggle.map(item => item.classList.toggle('is-active', item === toggle));
              if (window.matchMedia('(max-width: 991px)').matches) {
                scrollIntoView(toggle, {
                  inline: 'center',
                  block: 'nearest'
                });
              }
            });
          });
        });
      }

      /**
       * Map
       */
      // eslint-disable-next-line class-methods-use-this
      async map() {
        const mapsLeaflet = document.querySelector('[data-map-leaflet]');
        if (mapsLeaflet) {
          const location = mapsLeaflet.dataset.mapLocation;
          const lat = location.split(',')[0];
          const lng = location.split(',')[1];

          // eslint-disable-next-line no-undef
          const map = new LeafletMap(mapsLeaflet, {
            locations: [{
              lat,
              lng,
              speed: mapsLeaflet.dataset?.mapSpeed,
              course: mapsLeaflet.dataset?.mapRotate,
              type: mapsLeaflet.dataset?.mapType,
              name: mapsLeaflet.dataset?.mapTitle
            }]
          });
          await map.init();
        }
      }

      /**
       * Dropdowns
       */
      // eslint-disable-next-line class-methods-use-this
      dropdown() {
        const dropdownToggles = Array.from(document.querySelectorAll('[data-toggle="dropdown"]'));
        dropdownToggles.forEach(toggle => {
          if (hasJSLoaded(toggle, ['dropdown'])) return;
          const dropdown = new MOBDropdown(toggle, {
            bodyHidden: toggle.dataset.bodyHidden,
            bodyActiveClass: toggle?.parentNode.classList.contains('dropdown--toolbar') ? 'is-body-front' : null
          });
          dropdown.init();
          setJSLoaded(toggle, ['dropdown']);
        });
      }

      /**
       * Hamburger
       */
      // eslint-disable-next-line class-methods-use-this
      hamburger() {
        const hamburgerToggle = document.querySelector('[data-toggle="menu"]');
        if (hamburgerToggle) {
          const menu = new MOBDropdown(hamburgerToggle, {
            bodyHidden: true,
            headerStickyStop: true,
            activeClass: 'is-opened',
            toggleActiveClass: 'has-toggle',
            animationClass: 'is-show',
            animationDuration: 300,
            menu: true
          });
          menu.init();
        }
      }

      /**
       * Modals
       */
      // eslint-disable-next-line class-methods-use-this
      modal() {
        const modals = Array.from(document.querySelectorAll('[data-toggle="modal"]'));
        modals.forEach(item => {
          if (hasJSLoaded(item, ['modal'])) return;
          const modal = new MOBModal(item);
          modal.init();
          item.addEventListener('click', () => {
            setTimeout(this.carousel, 150);
          });
          setJSLoaded(item, ['modal']);
        });

        // Service modals
        /* const modalService = document.querySelector('[data-modal="service"]');
        if (modalService) {
          const services = Array.from(document.querySelectorAll('[data-service-modal]'));
          const image = modalService.querySelector('[data-modal-image]');
          const title = modalService.querySelector('[data-modal-title]');
          const caption = modalService.querySelector('[data-modal-caption]');
          services.forEach((item) => {
            if (!item.dataset.serviceModal) return;
            const data = item.dataset.serviceModal ? JSON.parse(item.dataset.serviceModal) : {};
            if (Object.keys(data).length === 0) return;
             item.addEventListener('click', () => {
              if (image && data.image) {
                image.removeAttribute('src');
                image.classList.remove('is-loaded');
                image.classList.remove('d-none');
                image.classList.add('lazyload');
                image.setAttribute('data-src', data.image);
              } else if (image) {
                image.classList.add('d-none');
              }
               if (title && data.title) {
                title.textContent = data.title;
              }
               if (caption && data.caption) {
                caption.textContent = data.caption;
              }
            });
          });
        } */

        // Service modals
        const modalServiceNew = document.querySelector('[data-modal="service-new"]');
        if (modalServiceNew) {
          const services = Array.from(document.querySelectorAll('[data-service-modal-new]'));
          const icon = modalServiceNew.querySelector('[data-modal-icon]');
          const title = modalServiceNew.querySelector('[data-modal-title]');
          const description = modalServiceNew.querySelector('[data-modal-description]');
          const content = modalServiceNew.querySelector('[data-modal-content]');
          services.forEach(item => {
            if (!item.dataset.serviceModalNew) return;
            const data = item.dataset.serviceModalNew ? JSON.parse(item.dataset.serviceModalNew) : {};
            const modalType = item.dataset.serviceModalType || 'tab';
            if (Object.keys(data).length === 0) return;
            item.addEventListener('click', () => {
              if (icon && data.icon) {
                const iconXlink = icon?.querySelector('use');
                iconXlink.setAttribute('xlink:href', `#icon-${data.icon}`);
              }
              if (title && data.title) {
                title.textContent = data.title;
              }
              if (content && data?.data && data?.data.length > 0) {
                if (description) {
                  description.classList.toggle('d-none', !data?.data || data?.data.length === 0);
                  description.textContent = `${data?.data.length} service${data?.data.length > 1 ? 's' : ''}`;
                }
                content.innerHTML = '';
                switch (modalType) {
                  case 'accordion':
                    {
                      // accordion tab mode
                      const div = document.createElement('div');
                      div.className = 'accordion accordion--small';
                      div.setAttribute('data-accordion', '');
                      div.setAttribute('data-accordion-close-others', 'true');
                      div.innerHTML = data?.data.map(
                      // eslint-disable-next-line no-shadow
                      (item, key) => `
                  <div class="accordion__item${key === 0 ? ' is-active' : ''}" data-accordion-item="">
                    <h3 class="accordion__item-toggle text-style text-style--normal text-style--semi " type="button" data-accordion-toggle="">
                      <span class="accordion__item-toggle-label">${item.title}</span>
                    </h3>
                    <div class="accordion__item-content" data-accordion-content="">
                      <p class="text-style text-style--small mb-05">${item.description}</p>
                    </div>
                  </div>
                `).join('');
                      content.appendChild(div);

                      // re init accordion
                      this.accordion();
                      break;
                    }
                  default:
                    {
                      // default tab mode
                      const div = document.createElement('div');
                      div.setAttribute('data-tab', '');
                      div.className = 'box box--service';
                      div.innerHTML = `
                  <div class="box__tab box__tab--bordered box__tab--scrollable" data-tab-buttons data-tab-buttons-scroll="true">
                    ${data?.data.map(
                  // eslint-disable-next-line no-shadow
                  (item, key) => `
                      <button type="button" data-target="#modal-service-${key}" data-tab-button class="box__tab-item${key === 0 ? '  is-active' : ''}">${item.title}</button>
                    `).join('')}
                  </div>
                  <div class="box__content">
                    <div class="d-flex flex-column" data-tab-content>
                    ${data?.data.map(
                  // eslint-disable-next-line no-shadow
                  (item, key) => `
                      <div id="modal-service-${key}" data-tab-item>
                        <p class="text-style">${item.description}</p>
                      </div>
                    `).join('')}
                    </div>
                  </div>
                `;
                      content.appendChild(div);

                      // re init tabs
                      this.tab();
                      break;
                    }
                }
              }
            });
          });
        }
      }

      /**
       * Tab
       */
      // eslint-disable-next-line class-methods-use-this
      tab() {
        const tabs = Array.from(document.querySelectorAll('[data-tab]'));
        const toggle = '[data-tab-button]';
        const item = '[data-tab-item]';
        tabs.forEach(tab => {
          if (hasJSLoaded(tab, ['tab'])) return;
          const options = {
            toggle,
            item,
            hash: !!tab.dataset.tabHash
          };
          const tabElement = new MOBTab(tab, options);
          tabElement.init();

          // eslint-disable-next-line no-shadow
          Array.from(tab.querySelectorAll(toggle)).forEach(toggle => toggle.addEventListener('click', () => {
            this.carousel();

            // eslint-disable-next-line no-undef
            if (typeof initSelect2 !== 'undefined' && initSelect2 === 'function') {
              // eslint-disable-next-line no-undef
              initSelect2();
            }
          }));
          setJSLoaded(tab, ['tab']);
        });
      }

      /**
       * Compliance & Risk Check — port-call period filter.
       * The rows are hidden by CSS; this only flips the selected period on the wrapper.
       */
      // eslint-disable-next-line class-methods-use-this
      compliance() {
        Array.from(document.querySelectorAll('[data-compliance-table]')).forEach(table => {
          if (hasJSLoaded(table, ['compliance'])) return;
          const buttons = Array.from(table.querySelectorAll('[data-compliance-period]'));
          const content = table.closest('[data-accordion-content]');
          buttons.forEach(button => button.addEventListener('click', () => {
            table.dataset.period = button.dataset.compliancePeriod;
            buttons.forEach(item => item.classList.toggle('button--bordered', item !== button));

            // Fewer or more rows changes the panel height the accordion pinned on open.
            if (content && content.style.maxHeight) {
              content.style.maxHeight = 'none';
              const {
                scrollHeight
              } = content;
              content.style.maxHeight = `${scrollHeight}px`;
            }
          }));
          setJSLoaded(table, ['compliance']);
        });
      }

      /**
       * Accordion
       */
      accordion() {
        const accordions = Array.from(document.querySelectorAll('[data-accordion]'));

        // Init a single accordion element if it isn't already, and its viewport allows it.
        const initAccordion = item => {
          if (hasJSLoaded(item, ['accordion'])) return;
          const accordion = new MOBAccordion(item);
          if (!accordion.shouldBeActive()) return;
          accordion.init();
          // Keep the instance on the element so resize can destroy it later.
          item._mobAccordion = accordion;
          setJSLoaded(item, ['accordion']);
        };

        // Tear down an initialized accordion (e.g. resized from mobile to desktop).
        const destroyAccordion = item => {
          if (!hasJSLoaded(item, ['accordion'])) return;
          if (item._mobAccordion) {
            item._mobAccordion.destroy();
            item._mobAccordion = null;
          }
          removeJSLoaded(item, ['accordion']);
        };
        accordions.forEach(item => initAccordion(item));

        // Bind the responsive sync once (not per element / per accordion() call).
        if (!this._accordionResizeBound) {
          this._accordionResizeBound = true;
          const syncAccordions = () => {
            Array.from(document.querySelectorAll('[data-accordion]')).forEach(item => {
              const mode = item.dataset.accordion;
              // Only size-gated accordions need to react to resize.
              if (mode !== 'mobile' && mode !== 'mobile-sm') return;

              // Mirror the thresholds used by the Accordion component (768 / 575).
              const query = mode === 'mobile-sm' ? '(max-width: 575px)' : '(max-width: 768px)';
              const active = window.matchMedia(query).matches;
              const inited = hasJSLoaded(item, ['accordion']);
              if (active && !inited) initAccordion(item);else if (!active && inited) destroyAccordion(item);
            });
          };
          window.addEventListener('resize', this.debounce(syncAccordions, 200));
        }
      }

      /**
       * Mega Menu (desktop)
       * Tracks whether any mega dropdown is open on the navbar. While one is open,
       * switching to another shows it in place (CSS skips the translateY slide) and
       * the shared backdrop stays visible — only the first open animates.
       */
      // eslint-disable-next-line class-methods-use-this
      megaMenu() {
        const items = Array.from(document.querySelectorAll('.navbar__menu-item--mega'));
        if (!items.length) return;
        const isLarge = () => window.matchMedia('(min-width: 992px)').matches;
        items.forEach(item => {
          if (hasJSLoaded(item, ['mega'])) return;
          const navbar = item.closest('.navbar');
          if (!navbar) return;
          const openMega = () => {
            if (!isLarge()) return;
            // Timer is stored on the navbar (shared across items) so moving from one
            // mega to another doesn't let the first item's close timer fire.
            // eslint-disable-next-line no-underscore-dangle
            clearTimeout(navbar._megaCloseTimer);
            // A mega is already open → this is a switch → make it instant.
            if (navbar.classList.contains('is-mega-open')) {
              navbar.classList.add('is-mega-instant');
            }
            navbar.classList.add('is-mega-open');
          };
          item.addEventListener('mouseenter', openMega);

          // mouseenter never fires for an element the cursor is ALREADY over when
          // the listener binds (e.g. page load with the pointer resting on the
          // trigger). Detect that case and open immediately so it isn't stuck
          // until the user moves out and back in.
          if (item.matches(':hover')) openMega();
          item.addEventListener('mouseleave', () => {
            // Restore transitions on the way out so the exit fades (a re-enter on
            // another trigger re-adds is-mega-instant before it matters).
            navbar.classList.remove('is-mega-instant');
            // eslint-disable-next-line no-underscore-dangle
            clearTimeout(navbar._megaCloseTimer);
            // Small delay bridges the gap when moving between two mega triggers so
            // the shared backdrop (is-mega-open) doesn't flicker off and back on.
            // eslint-disable-next-line no-underscore-dangle
            navbar._megaCloseTimer = setTimeout(() => {
              navbar.classList.remove('is-mega-open');
            }, 200);
          });
          setJSLoaded(item, ['mega']);
        });
      }

      /**
       * Prices
       */
      // eslint-disable-next-line class-methods-use-this
      prices() {
        // for Package Modal
        const packages = document.querySelector('[data-packages]');
        if (packages) {
          const toggles = packages.querySelectorAll('[data-packages-toggle]');
          const items = packages.querySelectorAll('[data-packages-item]');
          const setPrice = period => {
            if (typeof period === 'undefined') return;
            [...items].map(item => {
              const price = item.getAttribute(`data-packages-item-price-${period}`);
              if (price) {
                const priceLabel = item.querySelector('[data-packages-item-value]');
                const periodLabel = item.querySelector('[data-packages-item-period]');
                if (priceLabel) priceLabel.textContent = price;
                if (periodLabel) periodLabel.textContent = period !== 'yearly' ? 'Monthly' : 'Yearly';
              }
              return item;
            });
          };
          if (toggles.length > 0 && items.length > 0) {
            [...toggles].forEach(toggle => toggle.addEventListener('click', () => {
              const periodType = toggle.dataset.packagesToggle;
              if (periodType) {
                [...toggles].map(t => t.classList.toggle('is-active', toggle === t));
                setPrice(periodType);
              }
            }));
          }
        }
      }

      /**
       * priceSwitcher
       */
      // eslint-disable-next-line class-methods-use-this
      priceSwitcher() {
        const pricingContainer = document.querySelector('[data-pricing]');
        if (!pricingContainer) return;
        const periodToggle = pricingContainer.querySelector('[data-pricing-period-switch]');
        const monthlyLabel = pricingContainer.querySelector('[data-pricing-period-label="monthly"]');
        const annuallyLabel = pricingContainer.querySelector('[data-pricing-period-label="annually"]');
        const priceFlows = pricingContainer.querySelectorAll('number-flow');
        const allPriceCards = pricingContainer.querySelectorAll('.card--price');
        if (!periodToggle || !monthlyLabel || !annuallyLabel || allPriceCards.length === 0) {
          return;
        }
        const handlePriceChange = () => {
          const isAnnually = periodToggle.checked;
          monthlyLabel.classList.toggle('is-active', !isAnnually);
          annuallyLabel.classList.toggle('is-active', isAnnually);
          allPriceCards.forEach(card => {
            card.classList.toggle('is-annually', isAnnually);
          });
          priceFlows.forEach(flow => {
            const monthlyPrice = flow.dataset.pricingPriceMonthly;
            const yearlyPrice = flow.dataset.pricingPriceYearly;
            const currencyCode = flow.dataset.pricingPriceCurrency || 'USD';
            const targetValue = isAnnually ? yearlyPrice : monthlyPrice;

            // eslint-disable-next-line no-param-reassign
            flow.format = {
              style: 'currency',
              currency: currencyCode,
              trailingZeroDisplay: 'stripIfInteger'
            };
            if (typeof flow.update === 'function') {
              flow.update(targetValue);
            } else {
              flow.setAttribute('value', targetValue);
            }
          });
        };
        periodToggle.addEventListener('change', handlePriceChange);
        handlePriceChange();
      }

      /**
       * Utils
       */
      // eslint-disable-next-line class-methods-use-this
      utils() {
        // Filter read more
        const filterReadMore = [...document.querySelectorAll('[data-filter-column-button-more]')];
        filterReadMore.forEach(button => {
          const parent = button?.parentElement;
          const wrapper = parent ? parent?.querySelector('[data-filter-column-limit]') : null;
          const label = button?.querySelector('[data-filter-column-button-label]');
          const accordionContent = button?.closest('[data-accordion-content]');
          if (wrapper) {
            const defaultHeight = wrapper.clientHeight;
            const textMore = button.dataset.filterColumnButtonMore;
            const textLess = button.dataset.filterColumnButtonLess;
            let isExpandable = false;
            button.addEventListener('click', e => {
              e.preventDefault();
              if (!isExpandable) {
                wrapper.style.maxHeight = `${wrapper.scrollHeight}px`;
                isExpandable = true;
                if (label && textLess) label.textContent = textLess;
              } else {
                wrapper.style.maxHeight = `${defaultHeight}px`;
                isExpandable = false;
                if (label && textMore) label.textContent = textMore;
              }
              button.classList.toggle('is-active', isExpandable);
              if (accordionContent) {
                accordionContent.style.maxHeight = `inherit`;
                setTimeout(() => {
                  accordionContent.style.maxHeight = `${accordionContent.scrollHeight}px`;
                }, 400);
              }
            });
          }
        });

        // Table read more
        const tableCollapsable = [...document.querySelectorAll('[data-table-collapsable]')];
        tableCollapsable.forEach(table => {
          const count = parseInt(table.dataset.tableCollapsable, 10) || 3;
          const isPagination = table.dataset.tableCollapsablePagination === 'true';
          const toggle = table?.querySelector('[data-table-collapsable-toggle]');
          const items = [...table.querySelectorAll('tr')];
          const wrapper = table?.querySelector('[data-table-collapsable-wrapper]');
          const label = toggle ? toggle.querySelector('[data-table-collapsable-toggle-more]') : null;
          const labelMoreText = label?.dataset?.tableCollapsableToggleMore;
          const labelLessText = label?.dataset?.tableCollapsableToggleLess;
          const bottomContainer = toggle?.closest('.table-collapsable__bottom');
          let currentCount = count;
          let isOpened = false;
          const calculateHeight = visibleItems => {
            return visibleItems.reduce((total, item) => total + item.clientHeight, 0);
          };
          const setInitialView = () => {
            if (isPagination) {
              items.forEach((item, index) => {
                // eslint-disable-next-line no-param-reassign
                item.style.display = index < currentCount ? '' : 'none';
              });
              if (wrapper) {
                const initialHeight = calculateHeight(items.slice(0, currentCount));
                wrapper.style.maxHeight = `${initialHeight}px`;
              }
              if (currentCount >= items.length) {
                toggle.style.display = 'none';
              }
            }
          };
          const handleSeeMore = () => {
            currentCount += count;
            setInitialView();
          };
          const setCollapse = () => {
            if (isOpened) {
              isOpened = false;
              toggle.classList.remove('is-active');
              const initialHeight = calculateHeight(items.slice(0, count));
              wrapper.style.maxHeight = `${initialHeight}px`;
            } else {
              isOpened = true;
              toggle.classList.add('is-active');
              wrapper.style.maxHeight = `${wrapper.scrollHeight}px`;
            }
            if (label && labelMoreText && labelLessText) {
              label.textContent = isOpened ? labelLessText : labelMoreText;
            }
            setTimeout(() => toggle.blur(), 10);
          };

          // Hide toggle button container if item count is less than or equal to limit
          if (bottomContainer && items.length <= count) {
            bottomContainer.classList.add('d-none');
          }
          if (isPagination && toggle) {
            setInitialView();
            toggle.addEventListener('click', handleSeeMore);
          } else if (toggle && wrapper) {
            const initialHeight = calculateHeight(items.slice(0, count));
            wrapper.style.maxHeight = `${initialHeight}px`;
            toggle.addEventListener('click', setCollapse);
          }
        });

        // Collapsable
        const collapsable = [...document.querySelectorAll('[data-collapsable]')];
        collapsable.forEach(item => {
          const count = item.dataset.collapsable || 3;
          const items = item?.querySelectorAll('[data-collapsable-item]');
          const toggle = item?.querySelector('[data-collapsable-toggle]');
          const customMargin = item.hasAttribute('data-collapsable-margin') ? item.getAttribute('data-collapsable-margin') : null;
          const hasParentGridClass = (element, colClass) => {
            const parent = element?.parentElement;
            if (!parent) return false;
            const parentClasses = Array.from(parent.classList);
            return parentClasses.some(cls => cls.startsWith(colClass));
          };
          const style = items && items.length > 0 && items[1] ? getComputedStyle(items[1]) : null;
          const grid = !!(items && items.length > 0 && hasParentGridClass(items[1], 'col-'));
          // eslint-disable-next-line no-unused-vars,no-nested-ternary
          customMargin ? parseInt(customMargin, 10) : grid ? 16 : parseInt(style?.marginTop, 10);
          // eslint-disable-next-line no-unused-vars
          item.querySelector('[data-collapsable-item]') ? item.querySelector('[data-collapsable-item]').clientHeight : 50;
          const wrapper = item?.querySelector('[data-collapsable-wrapper]');
          const label = toggle?.querySelector('[data-collapsable-toggle-more]');
          const labelMoreText = label?.dataset?.collapsableToggleMore;
          const labelLessText = label?.dataset?.collapsableToggleLess;
          const parentAccordion = item?.closest('[data-accordion-content]');
          const accordionDefaultHeight = parentAccordion ? parentAccordion.scrollHeight : 0;
          let isOpened = false;
          const heightIsPixel = count?.includes('px');

          // Function to calculate current height limit dynamically
          const calculateHeightLimit = () => {
            if (heightIsPixel) {
              return parseFloat(count);
            }

            // Recalculate current item dimensions
            const currentStyle = items && items.length > 0 && items[1] ? getComputedStyle(items[1]) : null;
            const currentGrid = !!(items && items.length > 0 && hasParentGridClass(items[1], 'col-'));
            // eslint-disable-next-line no-nested-ternary
            const currentItemTopmargin = customMargin ? parseInt(customMargin, 10) : currentGrid ? 16 : parseInt(currentStyle?.marginTop, 10);
            const currentItemHeight = item.querySelector('[data-collapsable-item]') ? item.querySelector('[data-collapsable-item]').clientHeight : 50;
            return count * currentItemHeight + (currentItemTopmargin ? (count - 1) * currentItemTopmargin : 0);
          };

          // Initial height limit calculation
          const heightLimit = calculateHeightLimit();

          // Set initial max-height for both pixel and count-based limits
          if (wrapper) {
            if (heightIsPixel) {
              wrapper.style.maxHeight = count;
            } else {
              // Set initial collapsed height based on calculated heightLimit
              wrapper.style.maxHeight = `${heightLimit}px`;
            }
          }
          if (wrapper && toggle) {
            toggle.classList.toggle('d-none', wrapper.scrollHeight <= wrapper.clientHeight);
            item.classList.toggle('is-active', wrapper.scrollHeight <= wrapper.clientHeight);
          }

          // const parentGrid =
          //   items &&
          //   items.length > 0 &&
          //   items[0] &&
          //   items[0].parentNode &&
          //   hasParentGridClass(items[0], 'col-')
          //     ? items[0].parentNode
          //     : null;

          const breakpoints = {
            xs: 0,
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1200
          };
          const getBreakpoint = () => {
            const width = window.innerWidth;
            return Object.keys(breakpoints).reduce((acc, breakpoint) => {
              return width >= breakpoints[breakpoint] ? breakpoint : acc;
            }, 'xs');
          };
          const parseClassName = className => {
            const classes = className.split(' ');
            const result = {
              default: 1
            };

            // eslint-disable-next-line no-restricted-syntax
            for (const cls of classes) {
              if (cls.startsWith('col-')) {
                const [key, value] = cls.slice(4).split('-');
                if (value === undefined) {
                  result.default = 12 / parseInt(cls.slice(4), 10);
                } else {
                  result[key] = 12 / parseInt(value, 10);
                }
              }
            }
            const breakpointOrder = ['xs', 'sm', 'md', 'lg', 'xl'];
            let lastValue = result.default;
            // eslint-disable-next-line no-restricted-syntax
            for (const bp of breakpointOrder) {
              result[bp] = result[bp] || lastValue;
              lastValue = result[bp];
            }
            return result;
          };

          // Debounce function for resize events
          const debounce = (func, wait) => {
            let timeout;
            return function executedFunction(...args) {
              const later = () => {
                clearTimeout(timeout);
                func(...args);
              };
              clearTimeout(timeout);
              timeout = setTimeout(later, wait);
            };
          };
          const updateToggleVisibility = () => {
            const currentBreakpoint = getBreakpoint();

            // eslint-disable-next-line no-shadow
            collapsable.forEach(item => {
              const rowCount = parseInt(item.dataset.collapsable || 3, 10);
              // eslint-disable-next-line no-shadow
              const items = item.querySelectorAll('[data-collapsable-item]');
              // eslint-disable-next-line no-shadow
              const parentGrid = items.length > 0 ? items[0].parentNode : null;
              if (parentGrid) {
                const gridBreakpoints = parseClassName(parentGrid.className);
                const colCount = gridBreakpoints[currentBreakpoint];
                const visibleItemsCount = rowCount * colCount;

                // eslint-disable-next-line no-shadow
                const toggle = item.querySelector('[data-collapsable-toggle]');
                if (toggle) {
                  toggle.classList.toggle('d-none', visibleItemsCount >= items.length);
                }
              }
            });
          };
          const recalculateHeights = () => {
            // Recalculate heights for collapsed items on resize
            if (!isOpened && wrapper) {
              // Use the dynamic height limit calculation
              const newHeightLimit = calculateHeightLimit();

              // Update max-height if collapsed
              if (heightIsPixel) {
                wrapper.style.maxHeight = count;
              } else {
                wrapper.style.maxHeight = `${newHeightLimit}px`;
              }
            }
          };
          const handleResize = debounce(() => {
            updateToggleVisibility();
            recalculateHeights();
          }, 250);
          // console.log(parentGrid);

          /* if (parentGrid && toggle) {
            const gridBreakpoints = parseClassName(parentGrid.className);
            Object.keys(gridBreakpoints).forEach((k) => {
              if (breakpoints[k] && window.matchMedia(`(min-width: ${breakpoints[k]}px)`).matches) {
                toggle.classList.toggle(
                  'd-none',
                  Math.round([...items].length / gridBreakpoints[k]) <= count
                );
              }
            });
          } else if ([...items].length < count) {
            if (toggle) toggle.classList.add('d-none');
            return;
          } */

          // if (toggle) toggle.classList.toggle('d-none', [...items].length <= parseInt(count, 10));

          const setCollapse = () => {
            if (isOpened) {
              isOpened = false;
              item.classList.remove('is-active');
              toggle.classList.remove('is-active');

              // Calculate current height limit for accurate collapse
              const currentHeightLimit = calculateHeightLimit();
              wrapper.style.maxHeight = currentHeightLimit ? `${currentHeightLimit}px` : null;
              if (parentAccordion) {
                parentAccordion.style.maxHeight = `${accordionDefaultHeight}px`;
              }
            } else {
              isOpened = true;
              item.classList.add('is-active');
              toggle.classList.add('is-active');
              wrapper.style.maxHeight = `${wrapper.scrollHeight}px`;
              if (parentAccordion) {
                parentAccordion.style.maxHeight = `${accordionDefaultHeight + wrapper.scrollHeight}px`;
              }
            }
            toggle.blur();
            if (label && labelMoreText && labelLessText) {
              label.textContent = isOpened ? labelLessText : labelMoreText;
            }
          };
          if (toggle && wrapper) {
            toggle.addEventListener('click', setCollapse);
          }
          window.addEventListener('resize', handleResize);
          updateToggleVisibility();
        });

        // Current time
        const currentTimes = document.querySelectorAll('[data-current-time]');
        if ([...currentTimes].length > 0) {
          const today = new Date();
          const time = `${String(today.getHours()).padStart(0, '2')}:${String(today.getMinutes()).padStart(2, '0')}`;
          [...currentTimes].forEach(item => {
            // eslint-disable-next-line no-param-reassign
            item.textContent = time;
          });
        }

        // Confirm
        if (typeof jQuery !== 'undefined' && jQuery.isFunction(jQuery.fn.confirm)) {
          // eslint-disable-next-line no-underscore-dangle
          window._confirmOptions = {
            title: 'Are you sure?',
            content: "Once you do this, you can't go back.",
            buttons: {
              close: {
                text: 'Cancel',
                btnClass: 'button button--small button--gray'
              },
              ok: {
                text: 'Proceed',
                btnClass: 'button button--small button--red',
                action: () => {}
              }
            }
          };
        }

        // Circular Progress
        const circularProgress = document.querySelectorAll('[data-circular-progress]');
        if ([...circularProgress].length > 0 && typeof ProgressBar !== 'undefined') {
          [...circularProgress].forEach(item => {
            const maxValue = parseInt(item.dataset.circularProgress, 10);
            const isStatic = item.dataset.circularProgressStatic === 'true';
            let currentValue = 0;

            // eslint-disable-next-line no-undef
            const bar = new ProgressBar.Circle(item, {
              color: item.dataset.circularProgressColor || '#2bace2',
              strokeWidth: 4,
              trailWidth: 2,
              trailColor: item.closest('.card--background-gray') ? '#ddd' : '#eee',
              easing: 'easeInOut',
              duration: 1400,
              text: {
                autoStyleContainer: false
              },
              from: {
                color: item.dataset.circularProgressColor || '#2bace2',
                width: 4
              },
              to: {
                color: item.dataset.circularProgressColor || '#2bace2',
                width: 4
              },
              step(state, circle) {
                circle.path.setAttribute('stroke', state.color);
                circle.path.setAttribute('stroke-width', state.width);
                if (isStatic) {
                  currentValue = Math.round(circle.value() * maxValue);
                } else {
                  currentValue = Math.round(circle.value() * 100);
                }
                if (currentValue === 0) {
                  circle.setText('');
                } else {
                  circle.setText(item.dataset.circularProgressLabel ? `<strong>${currentValue}${item.dataset.circularProgressSubfix === 'false' ? '' : item.dataset.circularProgressSubfix || '%'}</strong><span>${item.dataset.circularProgressLabel}</span>` : `<strong>${currentValue}${item.dataset.circularProgressSubfix === 'false' ? '' : item.dataset.circularProgressSubfix || '%'}</strong>`);
                }
              }
            });
            if (isStatic) {
              bar.animate(1);
            } else {
              bar.animate(maxValue / 100);
            }
          });
        }

        // Notifications Wrapper
        let notificationWrapperDesktop = document.querySelector('[data-notifications-wrapper="desktop"]');
        let notificationWrapperMobile = document.querySelector('[data-notifications-wrapper="mobile"]');
        if (notificationWrapperDesktop && notificationWrapperMobile) {
          const mq = window.matchMedia('(max-width: 1200px)');
          const mobileClass = 'navbar__buttons-dropdown--notifications-mobile';
          const handleMediaChange = mediaQuery => {
            const dropdown = document.querySelector('[data-notifications-dropdown]');
            notificationWrapperDesktop = document.querySelector('[data-notifications-wrapper="desktop"]');
            notificationWrapperMobile = document.querySelector('[data-notifications-wrapper="mobile"]');
            if (!dropdown || !notificationWrapperMobile || !notificationWrapperDesktop) return;
            if (mediaQuery.matches) {
              notificationWrapperMobile.appendChild(dropdown);
              dropdown.classList.add(mobileClass);
            } else {
              notificationWrapperDesktop.appendChild(dropdown);
              dropdown.classList.remove(mobileClass);
            }
          };
          handleMediaChange(mq);
          mq.addEventListener('change', handleMediaChange);
        }

        // Filter List Search
        const filterLists = document.querySelectorAll('[data-filter-list]');
        if ([...filterLists].length > 0) {
          [...filterLists].forEach(list => {
            const search = list?.querySelector('[data-filter-list-search]');
            const reset = list?.querySelector('[data-filter-list-reset]');
            const inputs = list?.querySelectorAll('[data-filter-list-input]');
            if (!search || [...inputs]?.length === 0) return;
            const handleSearch = e => {
              let term = e?.target?.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
              if (term === 'turkey') {
                term = 'turkiye';
              }
              if (reset) reset.classList.toggle('d-none', !term || term.length === 0);
              [...inputs].forEach(input => {
                const normalizedValue = input.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
                if (normalizedValue.includes(term)) {
                  input.parentElement.classList.remove('d-none');
                } else {
                  input.parentElement.classList.add('d-none');
                }
              });
            };
            const updateAccordion = () => {
              if (search?.closest('[data-accordion-content]')) {
                search.closest('[data-accordion-content]').style.maxHeight = `${search.closest('[data-accordion-content]').scrollHeight}px`;
              }
            };
            search.addEventListener('input', handleSearch);
            if (search?.value?.length > 0) {
              search.dispatchEvent(new Event('input'));
              updateAccordion();
            }
            if (reset && search) {
              reset.addEventListener('click', () => {
                search.value = '';
                search.dispatchEvent(new Event('input'));
                updateAccordion();
              });
            }
          });
        }

        // Dynamic color image detector - Detects if the logo needs dark background
        // Compares edge brightness vs. center brightness to detect low-contrast logos
        const dynamicColorImages = [...document.querySelectorAll('[data-dynamic-color-image]')];
        dynamicColorImages.forEach(img => {
          const wrapper = img?.closest('.image-ratio');
          if (!wrapper) return;
          const detectNeedsDarkBackground = () => {
            try {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d', {
                willReadFrequently: true
              });
              const size = 100;
              canvas.width = size;
              canvas.height = size;
              ctx.drawImage(img, 0, 0, size, size);
              const fullData = ctx.getImageData(0, 0, size, size);

              // Helper function to calculate the brightness of a pixel at (x, y)
              const getBrightness = (x, y) => {
                const idx = (y * size + x) * 4;
                const r = fullData.data[idx];
                const g = fullData.data[idx + 1];
                const b = fullData.data[idx + 2];
                const a = fullData.data[idx + 3];
                if (a < 50) return null; // Transparent pixel
                return 0.299 * r + 0.587 * g + 0.114 * b;
              };

              // Sample EDGE pixels (top, bottom, left, right edges - 10px border)
              const edgeBrightness = [];
              const edgeWidth = 10;
              for (let x = 0; x < size; x += 1) {
                for (let y = 0; y < size; y += 1) {
                  const isEdge = x < edgeWidth || x >= size - edgeWidth || y < edgeWidth || y >= size - edgeWidth;
                  if (isEdge) {
                    const b = getBrightness(x, y);
                    if (b !== null) edgeBrightness.push(b);
                  }
                }
              }

              // Sample CENTER pixels (middle 50%)
              const centerBrightness = [];
              const centerStart = Math.floor(size * 0.25);
              const centerEnd = Math.floor(size * 0.75);
              for (let x = centerStart; x < centerEnd; x += 1) {
                for (let y = centerStart; y < centerEnd; y += 1) {
                  const b = getBrightness(x, y);
                  if (b !== null) centerBrightness.push(b);
                }
              }
              if (edgeBrightness.length === 0 || centerBrightness.length === 0) return;

              // Calculate averages
              const avgEdge = edgeBrightness.reduce((a, b) => a + b, 0) / edgeBrightness.length;
              const avgCenter = centerBrightness.reduce((a, b) => a + b, 0) / centerBrightness.length;

              // Calculate how much of center is very light (>230)
              const veryLightCenterCount = centerBrightness.filter(b => b > 230).length;
              const veryLightCenterRatio = veryLightCenterCount / centerBrightness.length;

              // Calculate contrast in center (standard deviation)
              const centerVariance = centerBrightness.reduce((sum, b) => sum + (b - avgCenter) ** 2, 0) / centerBrightness.length;
              const centerStdDev = Math.sqrt(centerVariance);

              // Check if the center has any dark elements (<100)
              const darkCenterCount = centerBrightness.filter(b => b < 100).length;
              const darkCenterRatio = darkCenterCount / centerBrightness.length;

              // DECISION LOGIC:
              // Logo needs dark background ONLY if:
              // 1. Edge is very light (white background) AND
              // 2. Center is also very light (logo blends with a background) AND
              // 3. Center has LOW contrast (no distinct dark elements)

              const edgeIsLight = avgEdge > 240; // Edge/background is white
              const centerIsVeryLight = veryLightCenterRatio > 0.85; // Most of the center is very light
              const centerHasLowContrast = centerStdDev < 30; // No significant variation
              const centerHasNoDarkElements = darkCenterRatio < 0.05; // Almost no dark pixels

              // Only apply dark background if logo will disappear on white
              const needsDarkBg = edgeIsLight && centerIsVeryLight && centerHasLowContrast && centerHasNoDarkElements;
              if (wrapper && needsDarkBg) {
                wrapper.classList.add('image-ratio--dark');
                if (wrapper?.parentNode) wrapper?.parentNode.classList.add('is-dark');
              }
            } catch (error) {
              console.warn('Logo analysis error:', error);
            }
          };
          if (img.complete && img.naturalHeight !== 0) {
            detectNeedsDarkBackground();
          } else {
            img.addEventListener('load', detectNeedsDarkBackground, {
              once: true
            });
            if (img.dataset.src && !img.src) {
              // eslint-disable-next-line no-param-reassign
              img.src = img.dataset.src;
            }
          }
        });
      }

      /**
       * Filter Box
       */
      // eslint-disable-next-line class-methods-use-this
      filterBox() {
        const filter = document.querySelector('[data-filter-box]');
        if (filter) {
          const inputs = document.querySelectorAll('[data-filter-box-input]');
          const badges = document.querySelectorAll('[data-filter-box-badges]');

          // eslint-disable-next-line no-inner-declarations
          function resetFilter() {
            const resetButtons = document.querySelectorAll('[data-filter-box-reset]');
            [...resetButtons].forEach(button => button.addEventListener('click', () => {
              // eslint-disable-next-line no-param-reassign,no-return-assign
              [...inputs].map(input => input.checked = false);
              // eslint-disable-next-line no-param-reassign,no-return-assign
              [...badges].map(badge => badge.innerHTML = '');
            }));
          }
          resetFilter();
        }
      }

      /**
       * Inputs
       */
      // eslint-disable-next-line class-methods-use-this
      inputs() {
        class InputInstance {
          constructor(input) {
            this.input = input;
          }

          // eslint-disable-next-line class-methods-use-this
          update() {
            // Input file default remove button event
            if (this.input.getAttribute('type') === 'file' && this.input.closest('.file')) {
              const file = this.input.closest('.file');
              const removedInitialValues = [];
              let items = file?.querySelectorAll('.file__preview-item:not(.file__preview-item--add)');
              [...items].forEach(item => {
                const buttonRemove = item.querySelector('.file__preview-item-remove');
                if (!buttonRemove) return;
                buttonRemove.addEventListener('click', () => {
                  const initialId = buttonRemove.dataset?.inputInitialRemove;
                  const initialTarget = buttonRemove.dataset?.inputInitialTarget ? document.querySelector(buttonRemove.dataset.inputInitialTarget) : null;
                  if (initialId && initialTarget && initialTarget.getAttribute('type') === 'hidden') {
                    removedInitialValues.push(initialId);
                    if (removedInitialValues.length > 0) initialTarget.value = removedInitialValues.join(',').toString();
                  }
                  item.remove();
                  items = file?.querySelectorAll('.file__preview-item:not(.file__preview-item--add)');
                  this.input.classList.toggle('is-checked', items && [...items].length > 0);
                });
              });
            }
          }
        }

        // Input File
        const inputFiles = document.querySelectorAll('.file input[type="file"]');
        [...inputFiles].forEach(input => {
          let previewDIV;
          const initialRemoveToggles = input?.parentNode?.querySelectorAll('[data-input-initial-remove]');
          const removedInitialValues = [];
          const isAvatar = input?.parentNode.classList.contains('file--avatar') || input?.parentNode.classList.contains('file--cover');
          const inputPreviewWrapper = `
          ${!isAvatar ? `
            <svg class="icon file__preview-item-icon"><use xlink:href="#icon-check-circle"></use></svg>
            <span class="file__preview-item-label"></span>
          ` : `
            <img class="file__preview-item-image" alt="">
          `}
          <button type="button" class="file__preview-item-remove"${isAvatar ? ` data-tippy="right" title="Remove"` : ''}><svg class="icon file__preview-item-remove-icon"><use xlink:href="#icon-close"></use></svg></button>`;
          if (!input.parentNode.querySelector('.file__preview')) {
            previewDIV = document.createElement('div');
            previewDIV.className = 'file__preview';
            input.parentNode.insertBefore(previewDIV, input.nextSibling);
          } else {
            previewDIV = input.parentNode.querySelector('.file__preview');
          }

          // previewDIV.innerHTML = inputPreviewWrapper;

          const handleFileInput = async () => {
            const files = input?.files;
            previewDIV.innerHTML = '';
            input.classList.toggle('is-checked', files && files.length > 0);
            const removeFile = idx => {
              const attachments = files;
              const fileBuffer = new DataTransfer();

              // eslint-disable-next-line no-plusplus
              for (let i = 0; i < attachments.length; i++) {
                // Exclude file in specified index
                if (idx !== i) fileBuffer.items.add(attachments[i]);
              }

              // eslint-disable-next-line no-param-reassign
              input.files = fileBuffer.files;
              input.dispatchEvent(new Event('change', {
                bubbles: true
              }));
            };
            if (files && files.length > 0) {
              // eslint-disable-next-line no-plusplus
              for (let i = 0; i < files.length; i++) {
                const file = files[i]?.name;
                const preview = document.createElement('div');
                preview.className = 'file__preview-item';
                preview.innerHTML = inputPreviewWrapper;
                previewDIV.append(preview);
                const previewLabel = preview.querySelector('.file__preview-item-label');
                if (previewLabel) previewLabel.textContent = file;
                if (isAvatar && files[0]) {
                  // eslint-disable-next-line no-use-before-define,no-await-in-loop
                  const imageUrl = await convertBase64(files[i]);
                  const previewImage = preview.querySelector('.file__preview-item-image');
                  if (previewImage) previewImage.setAttribute('src', imageUrl.toString());
                  this.tooltip();
                }
                const previewRemoveButton = preview.querySelector('.file__preview-item-remove');
                previewRemoveButton.addEventListener('click', () => {
                  removeFile(i);
                  [...previewDIV.querySelectorAll('.file__preview-item:not(.file__preview-item--add)')];
                });
              }
            } else {
              previewDIV.innerHTML = '';
            }
          };
          const checkInputVisibility = () => {
            if (previewDIV) {
              input.classList.toggle('is-checked', [...previewDIV.querySelectorAll('.file__preview-item')].length > 0);
              if ([...previewDIV.querySelectorAll('.file__preview-item')].length === 0) previewDIV.innerHTML = '';
            }
          };
          const convertBase64 = file => {
            return new Promise((resolve, reject) => {
              const fileReader = new FileReader();
              fileReader.readAsDataURL(file);
              fileReader.onload = () => {
                resolve(fileReader.result);
              };
              fileReader.onerror = error => {
                reject(error);
              };
            });
          };
          input.addEventListener('change', handleFileInput);
          checkInputVisibility();

          // Initial Remove
          [...initialRemoveToggles].forEach(toggle => {
            toggle.addEventListener('click', () => {
              const id = toggle.dataset.inputInitialRemove;
              const target = toggle.dataset.inputInitialTarget ? document.querySelector(toggle.dataset.inputInitialTarget) : null;
              if (id && target && target.getAttribute('type') === 'hidden') {
                // console.log(target);
                removedInitialValues.push(id);
                if (removedInitialValues.length > 0) {
                  target.value = removedInitialValues.join(',').toString();
                  toggle.parentNode.remove();
                  checkInputVisibility();
                }
              }
            });
          });

          // Instance
          // eslint-disable-next-line no-underscore-dangle
          if (!input?._input) {
            // eslint-disable-next-line no-param-reassign,no-underscore-dangle
            input._input = new InputInstance(input);
            // eslint-disable-next-line no-underscore-dangle
            input._input.update();
          }
        });

        // Editor
        const editors = [...document.querySelectorAll('[data-editor]')];
        if (editors.length > 0 && typeof Quill !== 'undefined') {
          editors.forEach(editor => {
            const target = document.getElementById(editor.dataset.editor);

            // eslint-disable-next-line no-unused-vars,no-undef
            const quill = new Quill(editor, {
              theme: 'snow',
              modules: {
                toolbar: [['bold', 'italic', 'underline', 'strike', 'blockquote'], [{
                  list: 'ordered'
                }, {
                  list: 'bullet'
                }], ['clean']]
              },
              formats: ['bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet']
            });
            if (target) {
              quill.enable(!target.disabled);
              if (target.value.length > 0) {
                const initialContent = quill.clipboard.convert(target.value);
                quill.setContents(initialContent, 'silent');
              }

              // eslint-disable-next-line no-return-assign
              quill.on('text-change', () => {
                let editorContent = quill.root.innerHTML;
                if (/^<p>(\s|&nbsp;|<br>)*<\/p>$/.test(editorContent)) editorContent = '';
                target.value = editorContent;
              });
            }
          });
        }

        // Datepickers
        const datepickers = [...document.querySelectorAll('[data-input-datepicker]')];
        if (datepickers.length > 0) {
          datepickers.forEach(input => {
            const options = {
              locale: default_1,
              dateFormat: 'dd-MM-yyyy',
              autoClose: true,
              timepicker: input.dataset.inputDatepickerTimepicker === 'true',
              timeFormat: 'HH:mm',
              onSelect: () => {
                input.dispatchEvent(new Event('change'));
                // eslint-disable-next-line no-use-before-define
                updateDatepickerRange();
              }
            };

            // Başlangıç ve bitiş tarihleri arasında bağlantı kurmak için ekstra mantık
            const updateDatepickerRange = () => {
              const wrapper = input.closest('[data-input-datepicker-wrapper]');
              if (wrapper) {
                const startDateInput = wrapper.querySelector('[data-input-datepicker="start"]');
                const endDateInput = wrapper.querySelector('[data-input-datepicker="end"]');
                // eslint-disable-next-line no-underscore-dangle
                const startDatepicker = startDateInput?._datepicker;
                // eslint-disable-next-line no-underscore-dangle
                const endDatepicker = endDateInput?._datepicker;
                if (startDatepicker && endDatepicker) {
                  if (input === startDateInput) {
                    endDatepicker.update({
                      minDate: startDatepicker.selectedDates[0]
                    });
                  } else if (input === endDateInput) {
                    startDatepicker.update({
                      maxDate: endDatepicker.selectedDates[0]
                    });
                  }
                }
              }
            };
            if (input.dataset.inputDatepicker === 'today') {
              options.minDate = new Date();
            }
            const datepicker = new AirDatepicker(input, options);
            if (input.value.length > 0) {
              if (dayjs(input.value, 'DD-MM-YYYY').isValid()) {
                const date = dayjs(input.value, 'DD-MM-YYYY').format('YYYY-MM-DD');
                datepicker.selectDate(new Date(date));
              }
            }

            // eslint-disable-next-line no-param-reassign,no-underscore-dangle
            if (!input._datepicker) input._datepicker = datepicker;
          });
        }

        // Clipboard Text
        const inputCopies = [...document.querySelectorAll('[data-input-copy]')];
        if (inputCopies.length > 0) {
          inputCopies.forEach(button => {
            const target = document.querySelector(button.dataset.inputCopy);
            if (target) {
              const setClipboardText = () => {
                target.select();
                target.setSelectionRange(0, 99999); /* For mobile devices */

                navigator.clipboard.writeText(target.value).then(() => button.classList.add('is-copied'));
              };
              button.addEventListener('click', setClipboardText);
            }
          });
        }

        // Dynamic Inputs
        const dynamicInputs = document.querySelectorAll('[data-input-dynamic]');
        if ([...dynamicInputs].length > 0) {
          const checkDynamicInputModalToggle = () => {
            const toggleMap = document.querySelectorAll('[data-toggle="modal"][data-modal-target="map-location"]');
            if ([...toggleMap].length > 0) {
              [...toggleMap].forEach(toggle => {
                const inputs = toggle?.parentNode?.querySelectorAll('input');
                if ([...inputs].length > 0) {
                  toggle.addEventListener('click', () => {
                    const preview = document.querySelector('[data-map-location-preview]');
                    if (preview) preview.innerHTML = '';
                    const inputAddress = [...inputs].find(i => i?.id && i.id.includes('address'));
                    if (inputAddress) {
                      const inputsAddress = document.querySelectorAll('[data-map-location-address]');
                      [...inputsAddress].map(i => i.removeAttribute('data-map-location-address'));
                      inputAddress.setAttribute('data-map-location-address', '');
                    }
                    const inputLocation = [...inputs].find(i => i?.id && i.id.includes('location'));
                    if (inputLocation) {
                      const inputLocations = document.querySelectorAll('[data-map-location-lat-lng]');
                      [...inputLocations].map(i => i.removeAttribute('data-map-location-lat-lng'));
                      inputLocation.setAttribute('data-map-location-lat-lng', '');
                    }
                  });
                }
              });
            }
          };
          const updateInputNames = group => {
            const items = group.querySelectorAll('[data-input-dynamic-item]');
            items.forEach((item, index) => {
              const inputs = item.querySelectorAll('input');
              inputs.forEach(input => {
                // eslint-disable-next-line no-param-reassign
                input.name = input.name.replace(/\[\d*\]/g, (match, offset, string) => {
                  // İlk bulunan indeksi değiştirme
                  if (string.indexOf(match) === offset) {
                    return `[${index + 1}]`;
                  }
                  return match;
                });
              });
            });
          };
          [...dynamicInputs].forEach(group => {
            const small = group.dataset.inputDynamic === 'small';
            const buttonAdd = group.querySelector('[data-input-dynamic-add]');
            const buttonRemoves = group.querySelectorAll('[data-input-dynamic-item-remove]');
            const currentClone = group.dataset.inputDynamicCurrent === 'true';
            const limit = group.dataset.inputDynamicLimit !== 'false' ? group.dataset.inputDynamicLimit || 5 : null;
            let items = group.querySelectorAll('[data-input-dynamic-item]');
            let idx = items && [...items].length > 0 ? [...items].length + 1 : 1;
            if (buttonAdd) {
              if (limit && [...items].length + 1 >= limit) buttonAdd.classList.add('is-disabled');
              buttonAdd.addEventListener('click', () => {
                const name = buttonAdd.dataset.inputDynamicAdd;
                const placeholder = buttonAdd.dataset.inputDynamicPlaceholder;
                let item;
                if (!currentClone) {
                  item = document.createElement('div');
                  item.setAttribute('data-input-dynamic-item', '');
                  item.className = 'col';
                  item.innerHTML = `
                <div class="row cs-x-${small ? '4' : '8'}">
                  <div class="col">
                    <input id="${name}-${idx}" name="${name}[]" type="text" class="input${small ? ' input--small' : ''}" placeholder="${placeholder}">
                  </div>
                  <div class="col-auto"${group.closest('[data-form-editable]') ? ' data-form-editable-item-visibility="show"' : ''}>
                    <button class="button button--red button--icon${small ? ' button--small' : ''}" type="button" data-tippy title="Remove" data-input-dynamic-item-remove>
                      <svg class="icon button__icon">
                          <use xlink:href="#icon-trash"></use>
                      </svg>
                    </button>
                  </div>
                </div>
              `;
                } else {
                  const layout = group.querySelector('[data-input-dynamic-layout]');
                  if (!layout) return;
                  item = layout.cloneNode(true);
                  item.removeAttribute('data-input-dynamic-layout');
                  item.setAttribute('data-input-dynamic-item', '');
                  const inputs = item.querySelectorAll(`input`);
                  if ([...inputs].length > 0) {
                    [...inputs].forEach(input => {
                      // eslint-disable-next-line no-param-reassign
                      input.value = null;
                      input.removeAttribute('value');
                      input.setAttribute('id', `${input.id}-${idx}`);
                      if (input.hasAttribute('data-input-tel') && input.parentNode.classList.contains('iti')) {
                        const parent = input.parentNode.parentNode;
                        if (parent) {
                          parent.appendChild(input);
                          input.removeAttribute('data-intl-tel-input-id');
                          input.removeAttribute('placeholder');
                          input.classList.remove('is-loaded');
                          if (parent.querySelector('.iti')) parent.querySelector('.iti').remove();
                        }
                      }
                    });
                  }
                  const buttonWrapper = item.querySelector('.col-auto');
                  if (buttonWrapper) {
                    buttonWrapper.innerHTML = `
                  <button class="button button--red button--icon${small ? ' button--small' : ''}" type="button" data-tippy title="Remove" data-input-dynamic-item-remove>
                      <svg class="icon button__icon">
                          <use xlink:href="#icon-trash"></use>
                      </svg>
                    </button>
                `;
                  }
                }
                const removeButton = item.querySelector('[data-input-dynamic-item-remove]');
                if (removeButton) {
                  removeButton.addEventListener('click', () => {
                    if (item.hasAttribute('data-input-dynamic-item')) {
                      item.remove();
                      items = group.querySelectorAll('[data-input-dynamic-item]');
                      if (limit) {
                        buttonAdd.disabled = [...items].length + 1 >= limit;
                        buttonAdd.classList.toggle('is-disabled', [...items].length + 1 >= limit);
                      }
                    }
                  });
                }
                group.appendChild(item);
                this.tooltip();
                this.modal();
                this.inputIntTel();
                setTimeout(() => {
                  checkDynamicInputModalToggle();
                }, 100);

                // eslint-disable-next-line no-plusplus
                idx++;
                items = group.querySelectorAll('[data-input-dynamic-item]');
                if (limit) {
                  buttonAdd.disabled = [...items].length + 1 >= limit;
                  buttonAdd.classList.toggle('is-disabled', [...items].length + 1 >= limit);
                }
                updateInputNames(group);
              });
            }
            if ([...buttonRemoves].length) {
              [...buttonRemoves].forEach(button => {
                button.addEventListener('click', () => {
                  if (button.closest('[data-input-dynamic-item]')) {
                    button.closest('[data-input-dynamic-item]').remove();
                    items = group.querySelectorAll('[data-input-dynamic-item]');
                    if (limit) {
                      buttonAdd.disabled = [...items].length + 1 >= limit;
                      buttonAdd.classList.toggle('is-disabled', [...items].length + 1 >= limit);
                    }
                    updateInputNames(group);
                  }
                });
              });
            }
          });
        }

        // Additional Inputs
        const additionalInputs = document.querySelectorAll('input[data-additional-input], select[data-additional-input]');
        if ([...additionalInputs].length > 0) {
          [...additionalInputs].forEach(input => {
            const additionalGroups = document.querySelectorAll(`[data-additional-group="${input.dataset.additionalInput}"]`);
            if ([...additionalGroups].length <= 0) return;
            [...additionalGroups].forEach(group => {
              [...group.querySelectorAll('input[required]')].map(
              // eslint-disable-next-line no-param-reassign,no-return-assign
              item => item.dataset.additionalGroupInputRequired = 'true');
            });

            // const groupRequiredInputs =
            const setAdditional = target => {
              if (typeof target === 'undefined') return;
              [...additionalGroups].forEach(group => {
                const item = group.dataset.additionalItem ? group.dataset.additionalItem.split(',') : [];
                const condition = item.some(i => i === target);
                group.classList.toggle('d-none', !condition);
                group.classList.toggle('d-flex', condition);
                [...group.querySelectorAll('input[data-additional-group-input-required="true"]')].map(
                // eslint-disable-next-line no-param-reassign,no-return-assign,no-shadow
                item => item.disabled = !condition);
                [...group.querySelectorAll('input[data-additional-group-input-required="true"]')].map(
                // eslint-disable-next-line no-param-reassign,no-return-assign,no-shadow
                item => item.required = condition);

                // eslint-disable-next-line no-undef
                if (typeof initSelect2 !== 'undefined') initSelect2();
              });
            };
            if (input.tagName === 'SELECT' && typeof jQuery !== 'undefined') {
              $(input).on('change', () => {
                setAdditional($(input).val());
              });
            } else {
              input.addEventListener('change', e => {
                const target = e.target.dataset.additionalInputValue || (input.getAttribute('type') === 'checkbox' ? !!e.target.checked : e.target.value);
                const label = e.target.getAttribute('id') && (e.target.getAttribute('type') === 'checkbox' || e.target.getAttribute('type') === 'radio') ? document.querySelector(`label[for="${e.target.getAttribute('id')}"]`) : null;
                if (label) label.classList.toggle('is-active', e.target.checked);
                setAdditional(target.toString());
              });
            }

            // Default checked value show/hide
            if (input.checked || input.tagName === 'SELECT' && input.value.length > 0) {
              const target = input.dataset.additionalInputValue || (input.getAttribute('type') === 'checkbox' ? !!input.checked : input.value);
              const label = input.getAttribute('id') && (input.getAttribute('type') === 'checkbox' || input.getAttribute('type') === 'radio') ? document.querySelector(`label[for="${input.getAttribute('id')}"]`) : null;
              if (label) label.classList.toggle('is-active', input.checked);
              setAdditional(target.toString());
            }
          });

          // Triggers
          const triggers = document.querySelectorAll('[data-additional-trigger]');
          if ([...triggers].length > 0) {
            triggers.forEach(trigger => {
              trigger.addEventListener('click', e => {
                e.preventDefault();
                const value = trigger.dataset.additionalTriggerValue;
                const input = document.querySelector(`input[data-additional-input][value="${value}"]`);
                if (input) {
                  input.checked = true;
                  input.dispatchEvent(new Event('input'));
                }
              });
            });
          }
        }

        // Editable Forms
        const editableForms = document.querySelectorAll('[data-form-editable]');
        if ([...editableForms].length > 0) {
          [...editableForms].forEach(form => {
            const editable = new MOBEditableForm(form);
            editable.init();
          });

          /* // Checkbox visibility inputs
          const inputVisibilities = document.querySelectorAll(
            'input[type="checkbox"][data-input-checkbox-visibility]'
          );
          if ([...inputVisibilities].lengrh > 0) {
            [...inputVisibilities].forEach((input) => {
              input.addEventListener('input', () => {});
            });
          } */
        }

        // Input Masks
        const inputMasks = Array.from(document.querySelectorAll('[data-input-mask]'));
        inputMasks.forEach(item => {
          const pattern = item.dataset.inputMask;
          if (pattern) VMasker(item).maskPattern(pattern);
        });

        // Input Card Type
        const inputCardType = document.querySelectorAll('[data-input-card-type]');
        const inputCardTypeWrapper = document.querySelectorAll('[data-input-card-type-wrapper]');
        if ([...inputCardType].length > 0 && [...inputCardTypeWrapper].length > 0) {
          [...inputCardType].forEach(input => {
            const items = input?.parentNode?.querySelectorAll('[data-input-card-type-value]');
            if ([...items].length > 0) {
              if (input.value.length > 0) {
                const cardType = dist(input.value.replace(/\s/g, ''));
                if (cardType.length > 0) {
                  input.classList.add('has-card');
                  [...items].map(item => item.classList.toggle('is-active', item.dataset.inputCardTypeValue === cardType[0].type));
                }
              }
              input.addEventListener('input', e => {
                if (e.target.value.length > 0) {
                  const cardType = dist(e.target.value.replace(/\s/g, ''));
                  if (cardType.length > 0) {
                    input.classList.add('has-card');
                    [...items].map(item => item.classList.toggle('is-active', item.dataset.inputCardTypeValue === cardType[0].type));
                  } else {
                    [...items].map(item => item.classList.remove('is-active'));
                    input.classList.remove('has-card');
                  }
                } else {
                  [...items].map(item => item.classList.remove('is-active'));
                  input.classList.remove('has-card');
                }
              });
            }
          });
        }

        /**
         * Filter additional reset
         */
        const filterAdditionalResets = document.querySelectorAll('[data-filter-additional-reset]');
        if ([...filterAdditionalResets].length > 0) {
          const resetButton = document.querySelector('[data-filter-additional-reset-button]');
          const resetButtonWrapper = resetButton?.closest('[data-filter-additional-reset-button-wrapper]');
          if (!resetButton || typeof jQuery === 'undefined' || typeof initSelect2 === 'undefined') return;
          [...filterAdditionalResets].forEach(input => {
            $(input).on('change', () => {
              if (resetButtonWrapper) {
                resetButtonWrapper.classList.toggle('d-none', !$(input).val().length > 0);
                resetButtonWrapper.classList.toggle('d-flex', $(input).val().length > 0);
              } else {
                resetButton.classList.toggle('d-none', !$(input).val().length > 0);
              }
            });
          });
          resetButton.addEventListener('click', () => {
            [...filterAdditionalResets].forEach(input => {
              $(input).val('').trigger('change');
              if (resetButtonWrapper) {
                resetButtonWrapper.classList.add('d-none');
                resetButtonWrapper.classList.remove('d-flex');
              } else {
                resetButton.classList.add('d-none');
              }
            });
          });
        }

        /**
         * Input Check All
         */
        const inputCheckAlls = document.querySelectorAll('[data-input-check-all]');
        if ([...inputCheckAlls].length > 0) {
          [...inputCheckAlls].forEach(inputCheckAll => {
            const wrapper = document.querySelector(inputCheckAll.dataset.inputCheckAll);
            if (!wrapper) return;
            const inputs = wrapper?.querySelectorAll(`input[type="checkbox"]:not([data-input-check-all])`);
            if ([...inputs].length === 0) return;
            inputCheckAll.addEventListener('change', () => {
              [...inputs].forEach(i => {
                // eslint-disable-next-line no-param-reassign,no-undef
                i.checked = inputCheckAll.checked;
              });
            });
            const updateCheckAllStatus = () => {
              // eslint-disable-next-line no-param-reassign
              inputCheckAll.checked = Array.from(inputs).every(input => input.checked);
            };
            inputs.forEach(input => {
              input.addEventListener('change', updateCheckAllStatus);
            });

            // Sayfa yüklenirken durumu kontrol et
            if (inputCheckAll.checked) {
              inputCheckAll.dispatchEvent(new Event('change'));
            }
          });
        }

        /**
         * Reset Buttons
         */
        const buttonResets = document.querySelectorAll('button[type="reset"]');
        if ([...buttonResets].length > 0) {
          if (typeof jQuery === 'undefined' || typeof initSelect2 === 'undefined') return;
          [...buttonResets].forEach(button => {
            const form = button?.closest('form');
            if (!form) return;
            const selects = form?.querySelectorAll('select');
            if (selects?.length === 0) return;
            button.addEventListener('click', () => {
              [...selects].forEach(select => {
                $(select).val('').trigger('change');
              });
            });
          });
        }

        // Input validator
        const inputValidators = document.querySelectorAll('[data-input-validator]');
        if ([...inputValidators].length > 0) {
          const validateInput = (input, isBlurEvent = false) => {
            const numericValue = parseInt(input.value, 10);
            // eslint-disable-next-line no-restricted-globals
            if (input.value?.length === 0 || input.value === '' || isNaN(numericValue)) return;
            const min = input.getAttribute('data-input-validator-min');
            const max = input.getAttribute('data-input-validator-max');
            const relatedInputSelector = input.getAttribute('data-input-validator-end') || input.getAttribute('data-input-validator-start');
            const relatedInput = relatedInputSelector ? document.querySelector(relatedInputSelector) : null;
            if (input.hasAttribute('data-input-validator-min') && numericValue < parseFloat(min)) {
              // eslint-disable-next-line no-param-reassign
              if (isBlurEvent) input.value = parseFloat(min);
            }
            if (input.hasAttribute('data-input-validator-max') && numericValue > parseFloat(max)) {
              // eslint-disable-next-line no-param-reassign
              if (isBlurEvent) input.value = parseFloat(max);
            }

            // eslint-disable-next-line no-restricted-globals
            if (relatedInput) {
              const relatedNumericValue = parseInt(relatedInput.value, 10);
              if (input.hasAttribute('data-input-validator-end') && numericValue > relatedNumericValue) {
                if (isBlurEvent) {
                  // eslint-disable-next-line no-param-reassign
                  input.value = relatedNumericValue;
                }
              } else if (input.hasAttribute('data-input-validator-start') && numericValue < relatedNumericValue) {
                if (isBlurEvent) {
                  // eslint-disable-next-line no-param-reassign
                  input.value = relatedNumericValue;
                }
              }
            }
          };
          inputValidators.forEach(input => {
            input.addEventListener('input', () => {
              const validatorType = input.getAttribute('data-input-validator');
              const min = input.getAttribute('data-input-validator-min');
              const max = input.getAttribute('data-input-validator-max');
              if (validatorType === 'number') {
                // eslint-disable-next-line no-param-reassign
                input.value = input.value.replace(/[^\d]+/g, '');
              }
              let numericValue = parseInt(input.value, 10);
              // eslint-disable-next-line no-restricted-globals
              if (!isNaN(numericValue)) {
                if (min !== null && numericValue < parseInt(min, 10)) {
                  numericValue = min;
                } else if (max !== null && numericValue > parseInt(max, 10)) {
                  numericValue = max;
                }
                if (numericValue > parseFloat(min) && numericValue < parseFloat(max)) {
                  // eslint-disable-next-line no-param-reassign
                  input.value = numericValue;
                }
              }
              validateInput(input);
            });
            input.addEventListener('blur', () => {
              validateInput(input, true);
            });
          });
        }

        // Input Autocomplete
        const inputAutocompletes = document.querySelectorAll('[data-input-autocomplete]');
        if (inputAutocompletes.length > 0) {
          inputAutocompletes.forEach(input => {
            // eslint-disable-next-line no-unused-vars
            new MOBAutoComplete(input);
          });
        }
      }

      /**
       * Search
       */
      search() {
        const {
          body
        } = document;
        let isOpened = false;

        // Hero Search
        const form = document.querySelector('[data-search]');
        if (!form) return;
        const formInline = document.querySelector('[data-search-inline]');
        const modal = document.querySelector('[data-search-modal]');
        const inputCategory = document.querySelector('[data-search-input-category]');
        const isAIChat = form.dataset?.search && form.dataset.search === 'ai';
        if (form) {
          const input = form.querySelector('[data-search-input]');
          const closeSelectors = [...document.querySelectorAll('[data-search-close]')];
          const submitButton = form.querySelector('button[type="submit"]');
          const aiButton = form?.querySelector('.btn-ai[data-toggle]');
          const open = () => {
            form.classList.add(this.openedClass);
            body.classList.add('search-opened');
          };
          const close = () => {
            form.classList.remove(this.openedClass);
            body.classList.remove('search-opened');
            if (modal) modal.classList.remove(this.openedClass);
            if (inputCategory) inputCategory.value = null;
          };

          // Input click event
          input.addEventListener('click', () => {
            if (isAIChat) {
              if (aiButton) aiButton.dispatchEvent(new Event('click'));
              return;
            }
            if (!isOpened) {
              isOpened = true;
              open();
            }
          });
          input.addEventListener('input', () => {
            if (isAIChat) return;
            if (submitButton) submitButton.disabled = input.value.length < 3;
            if (input.value.length >= 3 && !isOpened) {
              isOpened = true;
              open();
            }
          });

          // Close selector events
          closeSelectors.forEach(selector => selector.addEventListener('click', () => {
            if (isOpened) {
              isOpened = false;
              close();
            }
          }));

          // Escape close event
          document.addEventListener('keyup', e => {
            if (e.key === 'Escape') {
              if (isOpened) {
                isOpened = false;
                close();
              }
            }
          });
          if (isAIChat) {
            autoTypeInput({
              element: input,
              phrases: ['Vessel search IMO 9384071!', 'Who is the manager of vessel Maunawili?', 'Give me class society of Muradiye', 'Where has the vessel Canakkale been in the last 12 months?', 'Where is Bow Cedar going to?', 'Where is Ap Sveti Vlaho right now?', 'Tell me about Imabari Queen', 'Is vessel Zangazur sanctioned?', 'What is the last port of call of vessel Maunawili?', 'Give me details on company Asco Shipmanagement', 'Give me details of vessel Kobe Express', 'Who owns vessel MSC CLARA?', 'Fleet of company Neptune Lines Shipping', 'Show me vessels owned or operated by company Eagle Bulk Ultraco LLC', 'Vessel search mmsi 538002634', 'Show me details of Champion Road']
            });
          }
        }

        // Search Modal
        if (modal) {
          const toggles = [...document.querySelectorAll('[data-search-modal-toggle]')];
          const input = modal.querySelector('[data-search-input]');
          const submitButton = modal.querySelector('button[type="submit"]');
          if (toggles.length > 0) {
            const open = () => {
              isOpened = true;
              modal.classList.add(this.openedClass);
              body.classList.add('search-opened');
              setTimeout(() => {
                if (input) input.focus();
              }, 200);
            };
            if (submitButton && input) {
              input.addEventListener('input', () => {
                submitButton.disabled = input.value.length < 3;
              });
            }
            toggles.forEach(toggle => toggle.addEventListener('click', () => {
              const category = toggle.dataset.searchModalToggle;
              if (category && inputCategory) {
                inputCategory.value = category;
                open();
              }
            }));
          }
        }

        // Inline form
        if (formInline) {
          const input = formInline?.querySelector('[data-search-input]');
          const submitButton = formInline?.querySelector('button[type="submit"]');
          if (input && submitButton) {
            input.addEventListener('input', () => {
              if (submitButton) submitButton.disabled = input.value.length < 3;
            });
          }
        }
      }

      /**
       * appHeight
       */
      // eslint-disable-next-line class-methods-use-this
      appHeight() {
        const doc = document.documentElement;
        doc.style.setProperty('--vh', `${window.innerHeight}px`);
      }

      /**
       * Debounce utility function
       */
      // eslint-disable-next-line class-methods-use-this
      debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
          const later = () => {
            clearTimeout(timeout);
            func(...args);
          };
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
        };
      }

      /**
       * Tooltip
       */
      // eslint-disable-next-line class-methods-use-this
      tooltip() {
        const tooltips = document.querySelectorAll('[data-tippy]');
        [...tooltips].forEach(item => {
          if (hasJSLoaded(item, ['tooltip'])) return;
          const hasInitialShow = item.dataset.tippyInitialShow;
          const initialDelay = parseInt(item.dataset.tippyInitialDelay, 10) || 1000;
          let isInitialMode = false;
          let autoShowTimeout = null;

          // Device-based initial show logic
          const shouldShowInitially = () => {
            // Get current mobile state dynamically
            const currentIsMobile = window.matchMedia('(max-width: 992px)').matches;

            // If no initial show parameter, don't use initial mode
            if (!hasInitialShow) return false;

            // If empty string or unspecified value, show on both devices
            if (hasInitialShow === '' || hasInitialShow === 'true' || hasInitialShow === 'both') return true;

            // Device specific
            if (hasInitialShow === 'desktop') return !currentIsMobile;
            if (hasInitialShow === 'mobile') return currentIsMobile;
            return false;
          };
          isInitialMode = shouldShowInitially();

          // eslint-disable-next-line new-cap,no-unused-vars
          const tooltip = new tippy(item, {
            content: item.getAttribute('title'),
            animation: 'shift-away-subtle',
            placement: item.dataset.tippy || 'top',
            theme: item.dataset.tippyLight === 'true' ? 'light' : item.dataset.tippyClass || false,
            allowHTML: item.dataset.tippyHtml === 'true',
            interactive: item.dataset.tippyHtml === 'true',
            interactiveBorder: 10,
            maxWidth: item.dataset.tippyMax ? parseFloat(item.dataset.tippyMax) : 220,
            // Disable hover triggers initially if has initial show parameter
            trigger: hasInitialShow ? 'manual' : 'mouseenter focus',
            hideOnClick: hasInitialShow ? false : 'toggle'
          });
          item.removeAttribute('title');
          item.removeAttribute('data-tippy');
          setJSLoaded(item, ['tooltip']);

          // Auto show functionality
          const startAutoShow = () => {
            if (isInitialMode && hasInitialShow) {
              autoShowTimeout = setTimeout(() => {
                if (isInitialMode) {
                  tooltip.show();
                }
              }, initialDelay);
            }
          };

          // Start initial auto show
          startAutoShow();

          // Click handler to switch to normal mode
          const clickHandler = () => {
            if (isInitialMode) {
              isInitialMode = false;
              tooltip.hide();
              if (autoShowTimeout) {
                clearTimeout(autoShowTimeout);
                autoShowTimeout = null;
              }

              // Enable normal hover behavior after first click
              tooltip.setProps({
                trigger: 'mouseenter focus',
                hideOnClick: 'toggle'
              });

              // Remove the click handler after first click
              item.removeEventListener('click', clickHandler);
            }
          };
          if (hasInitialShow) {
            item.addEventListener('click', clickHandler);
          }

          // Resize handler for responsive behavior
          const resizeHandler = () => {
            const newShouldShow = shouldShowInitially();

            // If device type changed and we're still in initial mode
            if (isInitialMode && newShouldShow !== isInitialMode) {
              // Clear existing timeout
              if (autoShowTimeout) {
                clearTimeout(autoShowTimeout);
                autoShowTimeout = null;
              }

              // Hide current tooltip
              tooltip.hide();

              // Update mode and restart if needed
              isInitialMode = newShouldShow;
              if (isInitialMode) {
                startAutoShow();
              }
            }
          };

          // Add debounced resize listener only if has initial show parameter
          if (hasInitialShow) {
            const debouncedResizeHandler = this.debounce(resizeHandler, 250);
            window.addEventListener('resize', debouncedResizeHandler);

            // Store cleanup function for potential future use
            // eslint-disable-next-line no-underscore-dangle,no-param-reassign
            item._tooltipCleanup = () => {
              window.removeEventListener('resize', debouncedResizeHandler);
              if (autoShowTimeout) {
                clearTimeout(autoShowTimeout);
              }
            };
          }
          if (this.isMobile && item.dataset.toggle) {
            item.addEventListener('click', () => {
              tooltip.hide();
            });
          }
        });
      }

      /**
       * Share
       */
      // eslint-disable-next-line class-methods-use-this
      share() {
        const shareButton = [...document.querySelectorAll('[data-share]')];
        if (shareButton.length > 0) {
          const socialWindow = (url, width, height) => {
            // eslint-disable-next-line no-restricted-globals
            const left = (screen.width - width) / 2;
            // eslint-disable-next-line no-restricted-globals
            const top = (screen.height - height) / 2;
            const params = `menubar=no,toolbar=no,status=no,width=${width},height=${height},top=${top},left=${left}`;
            window.open(url, '', params);
          };
          const setShare = e => {
            e.preventDefault();
            const self = e.currentTarget;
            const shareType = self.dataset.share;
            const link = self.dataset.shareLink || encodeURIComponent(document.URL);
            const title = self.dataset.shareTitle || encodeURIComponent(document.title);
            const postType = self.dataset.shareType;
            const shareContents = {
              twitter: {
                content: {
                  vessel: {
                    text: `Discover this vessel on #MagicPort! Get the details on specs, history & more! Explore now: `,
                    hashƒ: ['Maritime', 'Vessels']
                  },
                  port: {
                    text: `Uncover this port on #MagicPort! Learn about facilities, capacity & location! Check it out: `,
                    hashtags: ['Maritime', 'Ports']
                  },
                  event: {
                    text: `Can't wait for this #maritime event on #MagicPort! Join for industry insights & networking opportunities: `,
                    hashtags: ['MaritimeEvent']
                  },
                  blog: {
                    text: `Engaging blog post on #MagicPort! Learn about the latest trends in the maritime world: `,
                    hashtags: ['MaritimeBlog']
                  },
                  news: {
                    text: `Stay ahead with the latest maritime news on #MagicPort! Get informed: `,
                    hashtags: ['MaritimeNews']
                  },
                  jobs: {
                    text: `Exciting job opportunity in the maritime industry! 🌊 Check out this position posted on #MagicPort and apply now to advance your career: `,
                    hashtags: ['MaritimeJob', 'ShippingIndustry']
                  },
                  company: {
                    text: `Explore this outstanding company on #MagicPort! 🌊Catering to a variety of needs in the shipping industry. Highly recommended for maritime solutions: `,
                    hashtags: ['MaritimeCompany', 'ShippingIndustry']
                  }
                }
              },
              email: {
                content: {
                  default: {
                    text: `Hi, %0D%0A%0D%0ACheck out the link below! %0D%0A%0D%0A${link}`
                  },
                  vessel: {
                    title: `Discover this vessel on MagicPort!`,
                    text: `Hi, %0D%0A%0D%0AI recently found this vessel on MagicPort and thought you might like to explore it too. Learn about its specs, history, and more: ${link}`
                  },
                  port: {
                    title: `Check out this port on MagicPort!`,
                    text: `Hi, %0D%0A%0D%0AI came across this port on MagicPort and thought you'd appreciate the details on its facilities, capacity, and location. Find out more: ${link}`
                  },
                  event: {
                    title: `Exciting maritime event on MagicPort!`,
                    text: `Hi, %0D%0A%0D%0ADon't miss this upcoming maritime event on MagicPort! Join for industry insights, networking opportunities, and more: ${link}`
                  },
                  blog: {
                    title: `Insightful blog post on MagicPort - A must-read!`,
                    text: `Hi, %0D%0A%0D%0AI just read this engaging blog post on MagicPort discussing the latest trends in the maritime industry. I think you'll find it informative and thought-provoking. Give it a read: ${link}`
                  },
                  news: {
                    title: `Stay updated with the latest maritime news on MagicPort!`,
                    text: `Hi, %0D%0A%0D%0AI wanted to share this news page on MagicPort with you, where you can stay informed on the latest developments, breakthroughs, and more in the maritime industry. Keep up with the news here: ${link}`
                  },
                  jobs: {
                    title: `Unlock Your Maritime Career Potential - Exciting Job Opportunity on MagicPort!`,
                    text: `Hey, %0D%0A%0D%0AI came across this exciting job opportunity in the maritime industry on MagicPort and thought you might be interested in applying. It could be an excellent chance to further your career in the shipping sector. %0D%0AFind more details about the position here: ${link} %0D%0A%0D%0ABest of luck if you decide to apply! %0D%0A%0D%0ABest regards`
                  },
                  company: {
                    title: `Discover a Trusted Maritime Partner - Featured Company on MagicPort!`,
                    text: `Hey, %0D%0A%0D%0AI recently discovered a fantastic company on MagicPort that offers a wide range of services to cater to various needs within the shipping industry. I thought you might be interested in checking them out for your requirements. %0D%0A%0D%0ATake a look at their profile and learn more about their offerings: ${link} %0D%0A%0D%0ABest regards`
                  }
                }
              }
            };
            if (typeof shareType === 'undefined') return;
            if (shareType === 'facebook') {
              const url = `https://www.facebook.com/sharer.php?u=${link}`;
              socialWindow(url, 570, 570);
            }
            if (shareType === 'twitter') {
              const url = `https://twitter.com/intent/tweet?url=${link}&text=${shareContents?.twitter?.content[postType]?.text ? encodeURIComponent(shareContents?.twitter?.content[postType]?.text) : title}${shareContents?.twitter?.content[postType]?.hashtags?.length > 0 ? `&hashtags=${shareContents?.twitter?.content[postType]?.hashtags.map(i => i).join(',')}` : ''}`;
              socialWindow(url, 570, 300);
            }
            if (shareType === 'linkedin') {
              const url = `https://www.linkedin.com/shareArticle?mini=true&url=${link}`;
              socialWindow(url, 570, 570);
            }
            if (shareType === 'whatsapp') {
              const url = `whatsapp://send?text=${link}%20${title}`;
              socialWindow(url, 570, 450);
            }
            if (shareType === 'mail') {
              const url = `mailto:?subject=${shareContents?.email?.content[postType]?.title ? encodeURIComponent(shareContents?.email?.content[postType]?.title) : title}&body=${shareContents?.email?.content[postType]?.text ? shareContents?.email?.content[postType]?.text : shareContents?.email?.content.default?.text}`;
              socialWindow(url, 570, 450);
            }
          };
          shareButton.forEach(button => button.addEventListener('click', setShare));
        }
        const nativeShareButton = [...document.querySelectorAll('[data-native-share="true"]')];
        if (nativeShareButton.length > 0) {
          // eslint-disable-next-line consistent-return
          nativeShareButton.forEach(button => {
            const {
              title,
              URL: link
            } = document;
            button.addEventListener('click', e => {
              if (link && title && navigator?.share && window.matchMedia('(max-width: 991px)').matches) {
                e.preventDefault();
                navigator.share({
                  title,
                  url: link
                }).then(() => {
                  console.log('Thanks for sharing!');
                }).catch(console.error);
              }
            });
          });
        }
        const currentUrlInput = document.querySelector('[data-input-current-url]');
        if (currentUrlInput) currentUrlInput.value = document.URL;
      }

      /**
       * Countdown
       */
      // eslint-disable-next-line class-methods-use-this
      countdown() {
        const countdowns = [...document.querySelectorAll('[data-countdown]')];
        countdowns.forEach(countdown => {
          const debug = countdown.dataset.countdownDebug === 'true';
          const finishText = countdown.dataset.countdownFinishText;
          // const onlyDay = countdown.dataset.countdownDay === 'true';
          // const inline = countdown.dataset.coutdownInline === 'true';
          // const subfix = countdown.dataset.countdownSubfix;
          let interval;
          let date = countdown.dataset.countdown;

          // tester
          if (debug) {
            const today = new Date();
            const tomorrow = new Date(today);
            tomorrow.setHours(today.getHours() + 12, today.getMinutes() + 34, today.getSeconds() + 56);
            date = tomorrow;
          }
          const countdownMarkup = (num, label) => {
            const value = num < 10 ? `0${num}` : `${Math.round(num)}`;
            if (value.length > 1) {
              const arr = value.split('');
              return `
            <div class="countdown__group"${label ? ` data-label="${label}"` : ''}>
                ${arr.map(c => `<div class="countdown__item">${c}</div>`).join('')}
            </div>
          `;
            }
            return `<div class="countdown__item">${num < 10 ? `0${num}` : num}</div>`;
          };
          const init = () => {
            const endDate = dayjs(new Date(date));
            const difference = endDate.diff(new Date(), 'second');
            const duration = dayjs.duration(difference, 'seconds')?.$d;

            // const difference = +new Date(date) - +new Date();
            let remaining = null;
            if (difference > 0 && duration) {
              const labels = {
                years: 'Year',
                months: 'Month',
                days: 'Day',
                hours: 'Hour',
                minutes: 'Minute',
                seconds: 'Second'
              };
              remaining = Object.keys(duration).map(part => {
                if (part === 'milliseconds') return;
                if (duration?.years === 0 && part === 'years') return;
                if (duration?.years === 0 && duration?.months === 0 && part === 'months') return;
                if (duration?.years === 0 && duration?.months === 0 && duration?.days === 0 && part === 'days') return;
                if (duration?.years > 0) {
                  if (part === 'hours' || part === 'minutes' || part === 'seconds') return;
                } else if (duration?.years === 0 && duration?.months >= 1) {
                  if (part === 'minutes' || part === 'seconds') return;
                } else if (duration?.years === 0 && duration?.months === 0 && duration?.days >= 1) {
                  if (part === 'seconds') return;
                }
                const num = duration[part];
                const label = `${labels[part]}${num > 1 ? 's' : ''}`;

                // eslint-disable-next-line consistent-return
                return countdownMarkup(num, label);
              }).filter(n => n).join(`<div class="countdown__item countdown__item--seperator">:</div>`);
              // eslint-disable-next-line no-param-reassign
              countdown.innerHTML = remaining;
            } else {
              clearInterval(interval);
              // eslint-disable-next-line no-param-reassign
              countdown.innerHTML = `<div class="countdown__fallback">${finishText || 'The event has started'}</div>`;
              countdown.classList.add('pb-0');
            }
          };
          init();

          // eslint-disable-next-line no-unused-vars,prefer-const
          interval = setInterval(init, 1000);
        });
      }

      /**
       * BlockLoader
       */
      // eslint-disable-next-line class-methods-use-this
      blockLoader() {
        const blockLoaders = document.querySelectorAll('[data-block-loader]');
        if ([...blockLoaders].length > 0) {
          [...blockLoaders].forEach(item => {
            // eslint-disable-next-line no-unused-vars
            new MOBBLockLoader(item);
          });
        }
      }

      /**
       * inputIntTel
       */
      inputIntTel() {
        const inputTels = document.querySelectorAll('[data-input-tel]');
        if ([...inputTels].length > 0 && typeof window?.intlTelInput !== 'undefined') {
          [...inputTels].forEach(input => {
            if (!input.classList.contains(this.isLoadedClass)) {
              const iti = window.intlTelInput(input, {
                utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js',
                separateDialCode: false,
                formatOnDisplay: false,
                dropdownContainer: input.closest('.modal') || null
              });
              input.addEventListener('countrychange', e => {
                const countryData = iti?.getSelectedCountryData();
                if (countryData?.dialCode) {
                  const inputValue = e.target.value;
                  if (!inputValue) e.target.value = `+${countryData?.dialCode}`;
                }
              });
              input.classList.add(this.isLoadedClass);
            }
          });
        }
      }

      /**
       * createGlobalInstance
       */
      // eslint-disable-next-line class-methods-use-this
      createGlobalInstance() {
        return {
          reInitPlugins: () => {
            this.dropdown();
            this.accordion();
            this.modal();
            this.tooltip();
          }
        };
      }

      /**
       * Tour Guides
       */
      // eslint-disable-next-line class-methods-use-this
      /* tourGuides() {
        const tg = new tourguide.TourGuideClient({
          completeOnFinish: true,
        });
        tg.onFinish(async () => {
          localStorage.setItem('tg_tours_complete', '1');
        });
         if (!localStorage.getItem('tg_tours_complete')) {
          tg.start();
        }
      } */

      /**
       * Collapsable Entry
       */
      collapsableEntry() {
        const collapsableEntries = document.querySelectorAll('[data-collapsable-entry]');
        if ([...collapsableEntries].length === 0) return;
        collapsableEntries.forEach(item => {
          const wrapper = item?.querySelector('[data-collapsable-entry-wrapper]');
          const toggle = item?.querySelector('[data-collapsable-entry-toggle]');
          if (!wrapper || !toggle) return;
          const label = toggle?.querySelector('[data-collapsable-entry-toggle-label]');
          const initialHeight = wrapper.clientHeight;
          const textMore = toggle?.dataset.collapsableEntryToggleMore;
          const textLess = toggle?.dataset.collapsableEntryToggleLess;
          const handleToggleContent = () => {
            if (item.classList.contains(this.activeClass)) {
              item.classList.remove(this.activeClass);
              wrapper.style.maxHeight = `${initialHeight}px`;
              if (label && textMore) label.textContent = textMore;
            } else {
              item.classList.add(this.activeClass);
              wrapper.style.maxHeight = `${wrapper.scrollHeight}px`;
              if (label && textLess) label.textContent = textLess;
            }
          };
          toggle.addEventListener('click', () => handleToggleContent());
        });
      }

      /**
       * Counter
       */
      // eslint-disable-next-line class-methods-use-this
      counter() {
        const counters = [...document.querySelectorAll('[data-counter]')];
        if (counters.length > 0) {
          counters.forEach(item => {
            const value = item.dataset.counter;
            const decimals = (value.split('.')[1] || '').length;
            const c = new i(item, value, {
              duration: 2,
              decimalPlaces: decimals,
              // separator: '',
              prefix: item.dataset.counterPrefix || '',
              suffix: item.dataset.counterSuffix || '',
              enableScrollSpy: true,
              scrollSpyOnce: true,
              scrollSpyDelay: 500
            });
            if (!c?.error) {
              c?.start();
            }
          });
        }
      }

      /**
       * Sticky Observer
       */
      // eslint-disable-next-line class-methods-use-this
      stickyObserver() {
        // eslint-disable-next-line no-unused-vars
        new StickyObserver({
          selector: '[data-sticky]',
          className: 'is-sticky'
        });
      }

      /*
       * Dynamic Aria Tags
       */
      // eslint-disable-next-line class-methods-use-this
      dynamicAriaTags() {
        const menu = document.querySelector('[data-toggle="menu"]');

        // Debounce function for resize events
        const debounce = (func, wait) => {
          let timeout;
          return function executedFunction(...args) {
            const later = () => {
              clearTimeout(timeout);
              func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
          };
        };
        const checkAriaTags = () => {
          const isMobile = window.matchMedia('(max-width: 992px)').matches;
          if (menu) {
            menu.setAttribute('aria-hidden', isMobile ? 'false' : 'true');
          }
        };
        const handleResize = debounce(() => {
          checkAriaTags();
        }, 250);
        window.addEventListener('resize', handleResize);
        checkAriaTags();
      }

      /**
       * Contact Details modal
       * Populates the contact details modal (phones / emails / addresses / websites)
       * from data attributes on the trigger button. Wires up per-tab search,
       * dynamic placeholder, and clear button.
       */
      // eslint-disable-next-line class-methods-use-this
      contactDetails() {
        const triggers = Array.from(document.querySelectorAll('[data-contact-details-trigger]'));
        if (triggers.length === 0) return;
        const modal = document.querySelector('[data-contact-details]');
        if (!modal) return;
        if (modal.dataset.contactDetailsBound === 'true') return;
        modal.dataset.contactDetailsBound = 'true';
        const searchInput = modal.querySelector('[data-contact-details-search]');
        const searchClear = modal.querySelector('[data-contact-details-search-clear]');
        const tabButtons = Array.from(modal.querySelectorAll('[data-contact-details-tab]'));
        if (!searchInput || tabButtons.length === 0) return;
        const dataByType = {
          phones: [],
          emails: [],
          addresses: [],
          websites: []
        };
        const escapeHtml = str => String(str ?? '').replace(/[&<>"']/g, s => ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        })[s]);
        const getLinkAttrs = (type, value) => {
          switch (type) {
            case 'phones':
              return {
                href: `tel:${value}`,
                target: '_self',
                rel: ''
              };
            case 'emails':
              return {
                href: `mailto:${value}`,
                target: '_self',
                rel: ''
              };
            case 'websites':
              return {
                href: /^https?:\/\//i.test(value) ? value : `https://${value}`,
                target: '_blank',
                rel: 'noopener nofollow'
              };
            case 'addresses':
              return {
                href: `https://www.google.com/maps/search/${encodeURIComponent(value)}`,
                target: '_blank',
                rel: 'noopener nofollow'
              };
            default:
              return {
                href: '#',
                target: '_self',
                rel: ''
              };
          }
        };
        const buildItem = (item, type) => {
          const {
            href,
            target,
            rel
          } = getLinkAttrs(type, item.value);
          const value = escapeHtml(item.value);
          const relAttr = rel ? ` rel="${rel}"` : '';
          const category = item.category ? `<span class="button__badge badge badge--gray badge--rounded badge--xsmall ml-05">${escapeHtml(item.category)}</span>` : '';
          const rawIcon = type === 'phones' && item.is_raw ? `<span class="d-inline-flex ml-025" data-tippy title="Displayed as entered due to an unrecognized format. You may want to double-check this."><svg class="icon"><use xlink:href="#icon-info"></use></svg></span>` : '';
          return `
        <div class="col d-flex flex-column">
          <a href="${href}" target="${target}"${relAttr} class="button button--contact button--small button--bordered button--square">
            <span class="d-flex flex-grow-1 align-items-center flex-wrap min-w-0">
              <span class="button__label button__label--truncate">${value}</span>
              ${rawIcon}
              ${category}
            </span>
            <svg class="icon button__icon"><use xlink:href="#icon-chevron-right"></use></svg>
          </a>
        </div>
      `;
        };
        const renderTab = (type, term = '') => {
          const content = modal.querySelector(`[data-contact-details-content="${type}"]`);
          if (!content) return;
          const listEl = content.querySelector('[data-contact-details-list]');
          const emptyEl = content.querySelector('[data-contact-details-empty]');
          const list = dataByType[type] || [];
          const lower = term.trim().toLowerCase();
          const filtered = lower ? list.filter(item => String(item.value || '').toLowerCase().includes(lower) || String(item.category || '').toLowerCase().includes(lower)) : list;
          if (filtered.length === 0) {
            listEl.innerHTML = '';
            listEl.classList.add('d-none');
            emptyEl.classList.remove('d-none');
          } else {
            listEl.innerHTML = filtered.map(item => buildItem(item, type)).join('');
            listEl.classList.remove('d-none');
            emptyEl.classList.add('d-none');
          }
        };
        const parseAttr = (el, name) => {
          try {
            return JSON.parse(el.getAttribute(name) || '[]');
          } catch (e) {
            return [];
          }
        };
        const getActiveType = () => {
          const active = tabButtons.find(btn => btn.classList.contains('is-active'));
          return (active || tabButtons[0]).dataset.contactDetailsTab;
        };
        const updatePlaceholder = button => {
          searchInput.placeholder = button.dataset.searchPlaceholder || 'Search';
        };
        const resetSearch = () => {
          searchInput.value = '';
          if (searchClear) searchClear.classList.remove('is-active');
        };
        const populateAll = trigger => {
          dataByType.phones = parseAttr(trigger, 'data-phones');
          dataByType.emails = parseAttr(trigger, 'data-emails');
          dataByType.addresses = parseAttr(trigger, 'data-addresses');
          dataByType.websites = parseAttr(trigger, 'data-websites');
          Object.keys(dataByType).forEach(type => renderTab(type));
          resetSearch();
          updatePlaceholder(tabButtons.find(btn => btn.classList.contains('is-active')) || tabButtons[0]);
        };

        // Search input
        searchInput.addEventListener('input', () => {
          const term = searchInput.value;
          if (searchClear) searchClear.classList.toggle('is-active', term.trim().length > 0);
          renderTab(getActiveType(), term);
        });

        // Clear button
        if (searchClear) {
          searchClear.addEventListener('click', () => {
            resetSearch();
            renderTab(getActiveType(), '');
          });
        }

        // Tab change — update placeholder, reset search, re-render unfiltered
        tabButtons.forEach(btn => {
          btn.addEventListener('click', () => {
            updatePlaceholder(btn);
            resetSearch();
            renderTab(btn.dataset.contactDetailsTab, '');
          });
        });

        // Trigger click — populate from data attributes
        triggers.forEach(trigger => {
          trigger.addEventListener('click', () => populateAll(trigger));
        });

        // Auto-populate from first trigger if modal is initially opened (prototype/dev)
        if (modal.classList.contains('is-opened') && triggers[0]) {
          populateAll(triggers[0]);
        }
      }
    }

    // APP Calling
    const app = new App();
    (() => {
      document.addEventListener('DOMContentLoaded', () => {
        app.init();
        window.app = app.createGlobalInstance();
        window.addEventListener('resize', app.appHeight);
      });
    })();

})();
